import {
  Unit_instance104q5opgivhr8 as Unit_instance,
  Enum3alwj03lh1n41 as Enum,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  toString30pk9tzaqopn as toString,
  hashCodeq5arwsb9dgti as hashCode,
  THROW_CCE2g6jy02ryeudk as THROW_CCE,
  equals2au1ep9vhcato as equals,
  toList3jhuyej2anx2q as toList,
  VOID7hggqo3abtya as VOID,
  IllegalStateExceptionkoljg5n0nrlr as IllegalStateException,
  toString1pkumu07cwy4m as toString_0,
  noWhenBranchMatchedException2a6r7ubxgky5j as noWhenBranchMatchedException,
  createThis2j2avj17cvnv2 as createThis,
  arrayListOf1fz8nib0ncbow as arrayListOf,
  ArrayList3it5z8td81qkl as ArrayList,
  LinkedHashMap1zhqxkxv3xnkl as LinkedHashMap,
  numberToInt1ygmcfwhs2fkq as numberToInt,
  ensureNotNull1e947j3ixpazm as ensureNotNull,
  KtMutableMap1kqeifoi36kpz as KtMutableMap,
  isInterface3d6p8outrmvmk as isInterface,
  lazy2hsh8ze7j6ikd as lazy,
  NotImplementedErrorfzlkpv14xxr8 as NotImplementedError,
  isIntArrayeijsubfngq38 as isIntArray,
  UnsupportedOperationException2tkumpmhredt3 as UnsupportedOperationException,
  KMutableProperty11e8g1gb0ecb9j as KMutableProperty1,
  getPropertyCallableRef1ajb9in178r5r as getPropertyCallableRef,
  KProperty1ca4yb4wlo496 as KProperty1,
  get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED,
  fill2542d4m9l93pn as fill,
  toByte4i43936u611k as toByte,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  suspendOrReturn39deou0cu44h3 as suspendOrReturn,
  SequenceScope1coiso86pqzq2 as SequenceScope,
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  RuntimeException1r3t0zl97011n as RuntimeException,
  StringBuildermazzzhj6kkai as StringBuilder,
  iterator3f5i676wpaa3g as iterator,
  Iterable1y3qizuf89iou as Iterable,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForInterface1egvbzx539z91 as initMetadataForInterface,
  collectionSizeOrDefault36dulx8yinfqm as collectionSizeOrDefault,
  until1jbpn0z3f8lbg as until,
  to2cs3ny02qtbcb as to,
  listOf1jh22dvmctj1r as listOf,
  coerceAtMost322komnqp70ag as coerceAtMost,
  round2mrvepag8eey0 as round,
  getNumberHashCode2l4nbdcihl25f as getNumberHashCode,
  isFloatArrayjjscnqphw92j as isFloatArray,
  IllegalArgumentException2asla15b5jaob as IllegalArgumentException,
  mapOf1xd03cq9cnmy8 as mapOf,
  removePrefix279df90bhrqqg as removePrefix,
  removeSuffix3d61x5lsuvuho as removeSuffix,
  split2bvyvnrlcifjv as split,
  toIntOrNull3w2d066r9pvwm as toIntOrNull,
  toDoubleOrNullkxwozihadygj as toDoubleOrNull,
  startsWith26w8qjqapeeq6 as startsWith,
  setOf45ia9pnfhe90 as setOf,
  toInt5qdj874w69jh as toInt,
  printStackTrace18lnx7a39cni as printStackTrace,
  contains3u8qpdzrl9an as contains,
  Collection1k04j3hzsbod0 as Collection,
  KtList3hktaavzmj137 as KtList,
  _Char___init__impl__6a9atx35f3p1971c8nj as _Char___init__impl__6a9atx,
  compareTo3ankvs086tmwq as compareTo,
  Comparable198qfk8pnblz0 as Comparable,
  numberToDouble210hrknaofnhf as numberToDouble,
  protoOf180f3jzyo7rfj as protoOf,
  isCharSequence1ju9jr1w86plq as isCharSequence,
  trim11nh7r46at6sx as trim,
  HashMap1a0ld5kgwhmhv as HashMap,
  startsWith1bgirhbedtv2y as startsWith_0,
  firstOrNullf6vlo6vdgu1e as firstOrNull,
  first28gmhyvs4kf06 as first,
  toMap1vec9topfei08 as toMap,
  lines3g90sq0zeq43v as lines,
  charArrayOf27f4r3dozbrk1 as charArrayOf,
  split3d3yeauc4rm2n as split_0,
  plus310ted5e4i90h as plus,
  numberToChar93r9buh19yek as numberToChar,
  toString26mv3gzfo7fn as toString_1,
  toInt2q8uldh7sc951 as toInt_0,
  toDouble1kn912gjoizjp as toDouble,
  mapCapacity1h45rc3eh9p2l as mapCapacity,
  coerceAtLeast2bkz8m9ik7hep as coerceAtLeast,
  Monotonic_instance19wu6xfdyzm85 as Monotonic_instance,
  ValueTimeMark__elapsedNow_impl_eonqvs2ntz2k8jdtq63 as ValueTimeMark__elapsedNow_impl_eonqvs,
  TimedValuew9j01dao9jci as TimedValue,
  listOfvhqybd2zx248 as listOf_0,
  println2shhhgwwt4c61 as println,
  emptyList1g2z5xcrvp2zy as emptyList,
  Char__toInt_impl_vasixd1g1ubcha2b2yr as Char__toInt_impl_vasixd,
  numberRangeToNumber25vse2rgp6rs8 as numberRangeToNumber,
  first58ocm7j58k3q as first_0,
  roundToInt1ue8x8yshtznx as roundToInt,
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  firstOrNull1982767dljvdy as firstOrNull_0,
  copyOfRange3alro60z4hhf8 as copyOfRange,
  toList2z3tifmtru5ra as toList_0,
  emptyMapr06gerzljqtm as emptyMap,
  last1vo29oleiqj36 as last,
  THROW_IAE23kobfj9wdoxr as THROW_IAE,
  getProgressionLastElement2w30kdy2w5nkt as getProgressionLastElement,
  isNumberiramasdbon0i as isNumber,
  toShort36kaw0zjdq3ex as toShort,
  Char__plus_impl_qi7pgjue8oeapgr66d as Char__plus_impl_qi7pgj,
  Default_getInstance324kkay623mzd as Default_getInstance,
  step18s9qzr5xwxat as step,
  fillArrayVali8eppxapiek4 as fillArrayVal,
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  getStringHashCode26igk1bx568vk as getStringHashCode,
  toList383f556t1dixk as toList_1,
  boxApply1qmzdb3dh90hg as boxApply,
  throwUninitializedPropertyAccessExceptionyynx7gkm73wd as throwUninitializedPropertyAccessException,
  Long2qws0ah9gnpki as Long,
  copyOfRange1v9olvyjr7c0r as copyOfRange_0,
  repeat2w4c6j8zoq09o as repeat,
  getOrNull1d60i0672n7ns as getOrNull,
  joinToString1cxrrlmo0chqs as joinToString,
  NoSuchElementException679xzhnp5bpj as NoSuchElementException,
  primitiveArrayConcatwxgknw08pmlb as primitiveArrayConcat,
  toIntArray27j90pvfixv10 as toIntArray,
  first34dru09vyikub as first_1,
  getOrNullef5jbxih7r4f as getOrNull_0,
  lastOrNullxgbdyo3mdsps as lastOrNull,
  Comparator2b3maoeh98xtg as Comparator,
  compareValues1n2ayl87ihzfk as compareValues,
  sortWith4fnm6b3vw03s as sortWith,
  contains3ue2qo8xhmpf1 as contains_0,
  toLongw1zpgk99d84b as toLong,
  Companion_getInstance2b73c6hwbaiuw as Companion_getInstance,
  DurationUnit_MILLISECONDS_getInstance15owevua4zjxe as DurationUnit_MILLISECONDS_getInstance,
  toDuration28gf6ughsr3vf as toDuration,
  slice2g43wio9c6zdv as slice,
  checkIndexOverflow3frtmheghr0th as checkIndexOverflow,
  addAll1k27qatfgp3k5 as addAll,
  distinct10qe1scfdvu5k as distinct,
  sortedWith2csnbbb21k0lg as sortedWith,
  toSet2orjxp16sotqu as toSet,
  Exceptiondt2hlxn7j7vw as Exception,
  minus27abgkurcn6u0 as minus,
  CancellationException3b36o9qz53rgr as CancellationException,
  toMutableSetjdpdbr9jsqq8 as toMutableSet,
  setOf1u3mizs95ngxo as setOf_0,
  plus1nh85pok677ot as plus_0,
  DurationUnit_SECONDS_getInstance3jias9ne5z4er as DurationUnit_SECONDS_getInstance,
  Duration5ynfiptaqcrg as Duration,
  Duration__toString_impl_8d916b1f2vqqjkgwgjr as Duration__toString_impl_8d916b,
  toMapcf6xfku344cz as toMap_0,
  toIntArray2d4xwvtjb01mq as toIntArray_0,
  abs1kdzbjes1idip as abs,
  getOrNull1go7ef9ldk0df as getOrNull_1,
  Companion_getInstance1pxg306pnafvz as Companion_getInstance_0,
  maxOrNull2e5ok5wkly1cp as maxOrNull,
  fill34ox8qmmmh3u3 as fill_0,
  coerceIn10f36k81le1mm as coerceIn,
  KProperty02ce7r476m8633 as KProperty0,
  ValueTimeMark__minus_impl_f87sko1pcxed03k2z1m as ValueTimeMark__minus_impl_f87sko,
  Duration__compareTo_impl_pchp0f1z7ae3ty3s6c1 as Duration__compareTo_impl_pchp0f,
  Companion_instance3fplhgf4ipvld as Companion_instance,
  _Result___init__impl__xyqfz831xktsyjq1qrq as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
  intercepted2ogpsikxxj4u0 as intercepted,
  copyToArray2j022khrow2yi as copyToArray,
} from './kotlin-kotlin-stdlib.mjs';
import {
  Companion_instance3s1b22cepz6i7 as Companion_instance_0,
  RectSlicec5msorw5q4el as RectSlice,
  ImageDoNotFitException2gm4q4wt4lh58 as ImageDoNotFitException,
  _SliceOrientation___get_flipX__impl__lgb7bxjxyk0h8ndav as _SliceOrientation___get_flipX__impl__lgb7bx,
  _SliceOrientation___get_rotation__impl__m65r0o1742ytu7rgu88 as _SliceOrientation___get_rotation__impl__m65r0o,
  Companion_getInstance2cvx1jnjzsvrw as Companion_getInstance_1,
  _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq2xqbs5alo5x1q as _SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq,
  VectorPath1chx1oqdw6sb9 as VectorPath,
  applyTransform1vhqlmleb4dce as applyTransform,
  getCurves2yjahbp68cxj3 as getCurves,
  toBezier1cphbqwqpx0d3 as toBezier,
  plus1r33v70e4ipd7 as plus_1,
  get_immutablepxpdoj6e54ll as get_immutable,
  arc$default2o4ca59st3p6v as arc$default,
  VectorBuilder2g8a28qau4ty9 as VectorBuilder,
  splitInRows1cyiez6sz0yy1 as splitInRows,
  SliceOrientation5szkqzxt7oev as SliceOrientation,
  _SliceOrientation___get_raw__impl__tj3u8w3gfaax2oun1df as _SliceOrientation___get_raw__impl__tj3u8w,
  SliceOrientation__flippedX_impl_m25zo9238kxt6n8vuqd as SliceOrientation__flippedX_impl_m25zo9,
  SliceOrientation__flippedY_impl_mj7m2g3ohocif0hlnub as SliceOrientation__flippedY_impl_mj7m2g,
  SliceOrientation__rotatedRight_impl_m8di3ghw918f3d536q as SliceOrientation__rotatedRight_impl_m8di3g,
  Winding_EVEN_ODD_getInstance2nlckv54zgzhj as Winding_EVEN_ODD_getInstance,
  StrokeToFill127v8ehrppf9e as StrokeToFill,
  strokeToFill2j5wye7yyxd99 as strokeToFill,
  Companion_getInstance2yrgpxwoeu923 as Companion_getInstance_2,
  LineScaleMode_NORMAL_getInstance349p0dssy4fun as LineScaleMode_NORMAL_getInstance,
  LineCap_BUTT_getInstanceb57ygh36gdst as LineCap_BUTT_getInstance,
  LineJoin_MITER_getInstance3doesgezxmixn as LineJoin_MITER_getInstance,
  Winding_NON_ZERO_getInstance2zsru2lm79i6x as Winding_NON_ZERO_getInstance,
  line3u2mk0n2uhnlh as line,
  isEmpty3b7xkdp0by4c8 as isEmpty,
  rect1tyihxx4629c2 as rect,
  rect31bppuugx2wch as rect_0,
  rect3nqbmqh4a4l2a as rect_1,
  arc1vjl2w7wqv39k as arc,
  circle1t8rrxfrm1ku9 as circle,
  rMoveTo38ittbd8h3wn5 as rMoveTo,
  rLineTo1671hm1vy9pme as rLineTo,
  transformed2t6vo3srmaaf9 as transformed,
  toCurvesList2ibv2opnrpohn as toCurvesList,
  ProjectedPoint37gr1oedqap6n as ProjectedPoint,
  Companion_getInstance2iuza9dwssjbj as Companion_getInstance_3,
  write11msa0gyjblqp as write,
  get_isConvex3nm4n5empqw0n as get_isConvex,
  strokeToFill34bvxzbc34djp as strokeToFill_0,
  get_mutableqzgwrema46rx as get_mutable,
  StrokeInfo1cunqczl43ffk as StrokeInfo,
  RastScale3rcmuinujik1d as RastScale,
  PolygonScanline1ccjpk6mqxyxd as PolygonScanline,
  IntSegmentSet3br6yjcm9q2bd as IntSegmentSet,
} from './korlibs-korlibs-math.mjs';
import {
  MarginInt3jiec8xsxkfd as MarginInt,
  RectangleInt3lmu13ytuf5lk as RectangleInt,
  SizeInte6w85oa6mz6v as SizeInt,
  Companion_instance3cau272s9vxbi as Companion_instance_1,
  Companion_getInstance9hqru60m2833 as Companion_getInstance_4,
  Companion_getInstancewvzae8n0fprj as Companion_getInstance_5,
  Vector2D378fe5rov8fgw as Vector2D,
  Size2Dum5ayuyhhau7 as Size2D,
  Companion_getInstance3jdtpl42k8kus as Companion_getInstance_6,
  Line2D2pf35pcx71ncp as Line2D,
  Companion_getInstanceuv1p1c5gwy11 as Companion_getInstance_7,
  Companion_getInstance3om7tc9mg7edv as Companion_getInstance_8,
  _BoundsBuilder___get_bounds__impl__s1l1gx3cti8ahdxq1b5 as _BoundsBuilder___get_bounds__impl__s1l1gx,
  BoundsBuilder__plus_impl_cz7f7x3c46o898gf5al as BoundsBuilder__plus_impl_cz7f7x,
  Rectangle3q03woyn9k8x1 as Rectangle,
  BoundsBuilder__plus_impl_cz7f7x3pz0lxdivao0o as BoundsBuilder__plus_impl_cz7f7x_0,
  Scale2cm697xlulcp5 as Scale,
  toFloat3b315y36g90cd as toFloat,
  Matrix1p940sdz227jj as Matrix,
  Companion_getInstance1ygiwm9bgjia3 as Companion_getInstance_9,
  Angle_between72970e1vlen9 as Angle_between,
  Angle__unaryMinus_impl_7901frdiuz4dirxfxh as Angle__unaryMinus_impl_7901fr,
  get_degrees3czcd4ojw4i as get_degrees,
  Angle__div_impl_ut2btd1uvzni4k9abn0 as Angle__div_impl_ut2btd,
  Angle2itorpob18n08 as Angle,
  Angle__hashCode_impl_szcndt1v9it5377zvl as Angle__hashCode_impl_szcndt,
  Anchor2D3ucppq7m9n3z8 as Anchor2D,
  BoundsBuilder__xminOr_impl_k3l1m23vaitgwxe5y8m as BoundsBuilder__xminOr_impl_k3l1m2,
  BoundsBuilder__toString_impl_fmvxh71jc5bjlliwupe as BoundsBuilder__toString_impl_fmvxh7,
  BoundsBuilder__hashCode_impl_649zbouv25pt0ki4b7 as BoundsBuilder__hashCode_impl_649zbo,
  BoundsBuilder__plus_impl_cz7f7x1gtmpkit3llyq as BoundsBuilder__plus_impl_cz7f7x_1,
  get_radians391vbqqjsolq6 as get_radians,
  _Angle___get_degrees__impl__qg56vw1zqnfrqkp8did as _Angle___get_degrees__impl__qg56vw,
  MatrixTransform1wlsrhxt7473v as MatrixTransform,
  _Angle___init__impl__g23q1m1vusxs8sthxgw as _Angle___init__impl__g23q1m,
  _Angle___get_ratio__impl__ap3on42zzwqtrc65vpb as _Angle___get_ratio__impl__ap3on4,
  BoundsBuilder__boundsOrNull_impl_se9lyg2y0izha8gzbzd as BoundsBuilder__boundsOrNull_impl_se9lyg,
  scaled2eehd42i2trq9 as scaled,
  MatrixType_IDENTITY_getInstancevamvzsx28k56 as MatrixType_IDENTITY_getInstance,
  _Angle___get_radians__impl__n00yt523wqxa1jdhpa1 as _Angle___get_radians__impl__n00yt5,
} from './korlibs-korlibs-math-vector.mjs';
import {
  setExtra314k0z6q35eku as setExtra,
  hasExtra1969mplo13qgb as hasExtra,
  Mixin3lmkm5hum2vdj as Mixin,
  Property1m5vulkepgwzd as Property,
  toFastList32ukjb68l6wd7 as toFastList,
  FastArrayListw5fr1wlp4slq as FastArrayList,
  getExtraTyped8zexqxz5xxli as getExtraTyped,
  PropertyThis2r0hbk1cs09wj as PropertyThis,
  getExtra307y0o9pd6mp3 as getExtra,
  fastArrayListOf1rdodhrpn0q8y as fastArrayListOf,
} from './korlibs-korlibs-datastructure-core.mjs';
import {
  toIntFloor3t307m2tavlm8 as toIntFloor,
  toIntCeiltm5lvaa6k4k9 as toIntCeil,
  toRatiolga1a9coidva as toRatio,
  clamp31lhm66c28ic8 as clamp,
  ilog23dbvpk38jf7rc as ilog2,
  extract2vhru1ihy4ogl as extract,
  insertm9bp9ll4cml3 as insert,
  clamp011ml7wx1d2b7sp as clamp01,
  min2wcdwdef93gdl as min,
  maxfuu7ju0dv4mx as max,
  convertRange378kqy75r4gq5 as convertRange,
  clampdicp8njiht45 as clamp_0,
  toIntFloor2i5mxseifeud5 as toIntFloor_0,
  toIntRoundjnzmk86x1qp5 as toIntRound,
  divCeil2r4o5lbvnv4lh as divCeil,
  Ratio__toFloat_impl_1ftup5294anfb3s41c1 as Ratio__toFloat_impl_1ftup5,
  clampUByte16elok6pzd6c5 as clampUByte,
  get_niceStr1tlwtz2l2j4my as get_niceStr,
  interpolatexm8yaf0iv9q9 as interpolate,
  clamp012a0sd8pj80ati as clamp01_0,
  toIntCeil3h286vm49zgwd as toIntCeil_0,
  niceStr1mw27wr6fq0ek as niceStr,
  get_niceStr3crhxydmlnaoj as get_niceStr_0,
  extractSignedx6cuhlj55jv4 as extractSigned,
  insert163hf9bvod0wg0m as insert16,
  hasBitSet141smdymg86x0 as hasBitSet,
  toIntRound1mv0y8x9hh1p4 as toIntRound_0,
  _Ratio___init__impl__9mwvn2cg32u2k0cnlg as _Ratio___init__impl__9mwvn2,
  clamp1qclpmpfxm7xb as clamp_1,
  toRatio1hooqit5gulhr as toRatio_0,
  interpolate35pbs3ac913y4 as interpolate_0,
  Ratio__times_impl_ucdh7y1eb1bj32n3p46 as Ratio__times_impl_ucdh7y,
  Ratio__toDouble_impl_o7epze3e3zsci3ipwe7 as Ratio__toDouble_impl_o7epze,
  get_low2kdkn3173rx8r as get_low,
  get_high3vl4k4kkorqlu as get_high,
  extract16Signed1oywtbmsx4vcm as extract16Signed,
  fromLowHigh12fm8h1tmjclj as fromLowHigh,
  insert2fz5125p2hdyd as insert_0,
  Companion_instance1hng7e117o7dr as Companion_instance_2,
  IntMaskRange__extractSigned_impl_s8qphq2famz7h8sv4u4 as IntMaskRange__extractSigned_impl_s8qphq,
  maskkmj9g5rvi2pr as mask,
  umod164hvijxhfi8p as umod,
  get_nextPowerOfTwoselx3fye7kjp as get_nextPowerOfTwo,
  Companion_getInstance1kb6pmvl5oz92 as Companion_getInstance_10,
  _Ratio___init__impl__9mwvn21qo8ztog8o9ep as _Ratio___init__impl__9mwvn2_0,
  umodgae5ifx362au as umod_0,
  insert8f3zk23r8x9da as insert8,
  toStringDecimalw23mr08es1e2 as toStringDecimal,
} from './korlibs-korlibs-math-core.mjs';
import {
  IntArray23680o40e0fgt8 as IntArray2,
  Companion_instance1nrsidgsshcc7 as Companion_instance_3,
  Companion_instance1pvn6c7thxh4 as Companion_instance_4,
  FloatArray2beehiaucxmzd as FloatArray2,
  GenericSubList2rec7qqyf06nw as GenericSubList,
  GenericListIterator397gjg9p2xwl5 as GenericListIterator,
  toIntMapp1jij98esrcm as toIntMap,
  associateByInt3vmv30txx5avl as associateByInt,
  IntMap2d9g6f5pyaoc2 as IntMap,
  IntArrayList3liuagbdnwmna as IntArrayList,
  reverse22fe0u1pwl2c6 as reverse,
  DoubleArrayList3by0we6lhx26x as DoubleArrayList,
  IntIntMap3mvg5iqgd5t3z as IntIntMap,
  getCyclic28wvgqye98jqx as getCyclic,
  toIntArrayList3jlt4o6tyleu as toIntArrayList,
  FastIntMapl0pzyavg6uw5 as FastIntMap,
  toLinkedMap37vdtde5j2z8d as toLinkedMap,
  doubleArrayListOfkj3z9zq4pobs as doubleArrayListOf,
  DoubleVectorArrayListq54dfthnqi2t as DoubleVectorArrayList,
  BaseDelegatedStackedArray2i6xcy52y4r2o as BaseDelegatedStackedArray2,
  StackedLongArray2rhxzonenq3dr as StackedLongArray2,
  IStackedArray2Baseutd8qm80cz0q as IStackedArray2Base,
  intArrayListOf18h0hna7wb0zr as intArrayListOf,
  _TGenStack___init__impl__yynjgtbdasgrb15naj as _TGenStack___init__impl__yynjgt,
  TGenStack__push_impl_9yh33t3meiyro65i033 as TGenStack__push_impl_9yh33t,
  TGenStack__pop_impl_qisxa03row6p4nvthsp as TGenStack__pop_impl_qisxa0,
} from './korlibs-korlibs-datastructure.mjs';
import {
  invalidOp1stebxh2m3n07 as invalidOp,
  reserved38luap2kxmc9d as reserved,
  get_unreachable2fi7msfg0vgzd as get_unreachable,
  get_reserved2d9gxjta2y60d as get_reserved,
  get_invalidOp31x7cztl0dv9m as get_invalidOp,
  Endian_BIG_ENDIAN_getInstancel551vnoq34sw as Endian_BIG_ENDIAN_getInstance,
  Endian_LITTLE_ENDIAN_getInstancelbfxpgu7xewo as Endian_LITTLE_ENDIAN_getInstance,
  FileNotFoundException2tz8ve019qipn as FileNotFoundException,
  ByteArrayBuilderyrflhqjz64ju as ByteArrayBuilder,
  Companion_getInstance4j5fpzk5rb8p as Companion_getInstance_11,
} from './korlibs-korlibs-platform.mjs';
import {
  arraycopy14jict0dth60o as arraycopy,
  UByteArrayInt__get_impl_px6q8a12ofefwxigfcv as UByteArrayInt__get_impl_px6q8a,
  UByteArrayInt__set_impl_gn45322e8gdcoopwt46 as UByteArrayInt__set_impl_gn4532,
  arraycopy3czrd9re36wzt as arraycopy_0,
  _UByteArrayInt___init__impl__xif7bu3pdjaoxauimyc as _UByteArrayInt___init__impl__xif7bu,
  getU83agrw8yj0shar as getU8,
  _UShortArrayInt___init__impl__kdofb82ugyoyyu34uy3 as _UShortArrayInt___init__impl__kdofb8,
  UShortArrayInt__set_impl_38wgvc2x2oeh0jr5fvg as UShortArrayInt__set_impl_38wgvc,
  UShortArrayInt__get_impl_ciz20k1fu51oh2yw4qc as UShortArrayInt__get_impl_ciz20k,
  getU16LE2cizldw8qp53x as getU16LE,
  getU16BE2rszf3doox5o as getU16BE,
  getU24LEi3x1z5ajbdbv as getU24LE,
  getU24BE36pml41y2814b as getU24BE,
  getS32LE1pxm9wohin3g8 as getS32LE,
  getS32BE5aphh7sm8f2q as getS32BE,
  getS32Array39c2ui7l3wxdu as getS32Array,
  getS32ArrayLE2u84ix7qnexrb as getS32ArrayLE,
  getU1616fejrhhqwfv2 as getU16,
  getS3225c4j90s7n16a as getS32,
  _UByteArrayInt___init__impl__xif7bu2cberlddfaqn1 as _UByteArrayInt___init__impl__xif7bu_0,
  asByteArray1mw554k0vpuh5 as asByteArray,
  _UByteArrayInt___get_size__impl__bcjnte3rwa3i1eytgix as _UByteArrayInt___get_size__impl__bcjnte,
  UByteArrayInt247ue4nx0pkns as UByteArrayInt,
  asInt32Arrayf0ml2lp92o3m as asInt32Array,
} from './korlibs-korlibs-memory.mjs';
import {
  substr2jonrcqd8qwvx as substr,
  substr1q77u5lo4evr6 as substr_0,
  unquote1kjyk5vajgaow as unquote,
  get_UTF82geyfhi1l22xl as get_UTF8,
  get_UTF16_BE3rxrt7v8707y4 as get_UTF16_BE,
  Companion_getInstanceyicqcjxy8shz as Companion_getInstance_12,
  Charsets_instancenv17fp98ne59 as Charsets_instance,
  ASCII_getInstance1x38t72vrtpyt as ASCII_getInstance,
  toString2x583ovdqfjci as toString_2,
  WStringReader2bukzqxb5clbi as WStringReader,
  _WChar___get_codePoint__impl__c8brwu291ypbecez861 as _WChar___get_codePoint__impl__c8brwu,
  WStringambx64bqrrmq as WString,
} from './korlibs-korlibs-string.mjs';
import {
  appendHexByte1xtb46j7ij290 as appendHexByte,
  fromBase6434uveajlhn2ar as fromBase64,
  get_hex32p4ssq0y1xxx as get_hex,
  get_hex3lw8e6gsph9rg as get_hex_0,
} from './korlibs-korlibs-encoding.mjs';
import {
  Xmlepssdknidwxh as Xml,
  get12f8xnsftqcwn as get,
  Companion_getInstance1ijxhf2kvgag6 as Companion_getInstance_13,
} from './korlibs-korlibs-serialization.mjs';
import {
  get_dynw5edstkdie96 as get_dyn,
  Dyn__get_impl_6l2p806an9lmzdx97q as Dyn__get_impl_6l2p80,
  Dyn__toDoubleDefault_impl_fspogf18eiqqlf0n9f2 as Dyn__toDoubleDefault_impl_fspogf,
  Dyn__toStringOrNull_impl_7e6cgy1o7rt6j433mfo as Dyn__toStringOrNull_impl_7e6cgy,
  Dyn__toList_impl_pxssgr1ih96kqmm5wba as Dyn__toList_impl_pxssgr,
  Dyn__toString_impl_9l0v3s1r5ef9jhsnww1 as Dyn__toString_impl_9l0v3s,
  _Dyn___get_int__impl__sh8lhm1cuta1m3oa6bm as _Dyn___get_int__impl__sh8lhm,
} from './korlibs-korlibs-dyn.mjs';
import {
  Companion_getInstance27y7ak0p8xjnv as Companion_getInstance_14,
  uncompress3ofkd276wd0zn as uncompress,
} from './korlibs-korlibs-compression.mjs';
import {
  openFastStream2r4uuohoj0wpo as openFastStream,
  toSyncStream3g0dpktigjx33 as toSyncStream,
  FastByteArrayInputStream1jjm4ufd0tkh5 as FastByteArrayInputStream,
  readBytesExact2w7t0p09xkbt6 as readBytesExact,
  readU16LE24dnvocwt4zgx as readU16LE,
  readS32LE3aqh95gxznf4n as readS32LE,
  readU32LE336f0p4nkvbi as readU32LE,
  readU82o15i0epsnmc5 as readU8,
  readS16LE375f28fer5dhk as readS16LE,
  readStreamp6bgvjd275ek as readStream,
  readAvailablecuh5du6kum51 as readAvailable,
  readString20u8kjncp0xlx as readString,
  sliceHere36xxn3efrum43 as sliceHere,
  readString2uttbyypy7i6f as readString_0,
  readU163oe0yrg3omvh6 as readU16,
  readS32hadcfcfqfot3 as readS32,
  readBytesExactclsk6o5m4pur as readBytesExact_0,
  sliceStart2elugg4aq9q3w as sliceStart,
  readStringztu0bw928vdf2 as readStringz,
  skipToAlignusebk6ndjvs1 as skipToAlign,
  openSync2m3qn99fqytu0 as openSync,
  sliceStart237tx6t7cytus as sliceStart_0,
  readString3106ot9qwcir2 as readString_1,
  readBytes3l26albs0coyl as readBytes,
  readAllc0x1zv8qqb58 as readAll,
  readS32BE1vkzsiuy9pof1 as readS32BE,
  get_eofaukbsoaf5jcj as get_eof,
  readStringz3jxaogr49n5ys as readStringz_0,
  readStream3s64ivrsklqly as readStream_0,
  readAll3m5rixujsbctr as readAll_0,
  openAsync37anb1e84urmo as openAsync,
} from './korlibs-korlibs-io-stream.mjs';
import {
  Level_DEBUG_getInstance2cjwrm9110zsz as Level_DEBUG_getInstance,
  Companion_getInstance1lqql7kjbk545 as Companion_getInstance_15,
  Level_INFO_getInstance2ziz2o3m3loni as Level_INFO_getInstance,
  Level_ERROR_getInstance3sgixyayx9gy9 as Level_ERROR_getInstance,
} from './korlibs-korlibs-logger.mjs';
import {
  get_baseName2yf63efofm8te as get_baseName,
  readAsSyncStream1fxi8ije69l8f as readAsSyncStream,
  get_extensionLC3gx4qkgbywkav as get_extensionLC,
  getUnderlyingUnscapedFile1x96alth7xqs as getUnderlyingUnscapedFile,
  UrlVfs292f1sja450ff as UrlVfs,
  LocalVfs18bzski76hhpp as LocalVfs,
} from './korlibs-korlibs-io-vfs.mjs';
import { atomic$ref$130aurmcwdfdf1 as atomic$ref$1 } from './kotlinx-atomicfu.mjs';
import {
  NonRecursiveLock2vf7fkhp857q as NonRecursiveLock,
  runBlockingNoSuspensions25hsuevf2mle as runBlockingNoSuspensions,
} from './korlibs-korlibs-concurrent.mjs';
import {
  get_fastSecondsxsf72e0ltu4j as get_fastSeconds,
  toDuration15w5sljvx2ut2 as toDuration_0,
  get_fast37cu8s8qwnuyi as get_fast,
} from './korlibs-korlibs-time-core.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from './kotlinx-coroutines-core.mjs';
//region block: imports
var imul = Math.imul;
var hypot = Math.hypot;
var log2 = Math.log2;
//endregion
//region block: pre-declaration
class GrowMethod extends Enum {}
class Entry {
  constructor(slice, data) {
    this.w3k_1 = slice;
    this.x3k_1 = data;
  }
  toString() {
    return 'Entry(slice=' + this.w3k_1.toString() + ', data=' + toString(this.x3k_1) + ')';
  }
  hashCode() {
    var result = this.w3k_1.hashCode();
    result = imul(result, 31) + (this.x3k_1 == null ? 0 : hashCode(this.x3k_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry))
      return false;
    var tmp0_other_with_cast = other instanceof Entry ? other : THROW_CCE();
    if (!this.w3k_1.equals(tmp0_other_with_cast.w3k_1))
      return false;
    if (!equals(this.x3k_1, tmp0_other_with_cast.x3k_1))
      return false;
    return true;
  }
}
class MutableAtlas {
  static b3m(binPacker, border, premultiplied, allowToGrow, growMethod) {
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    var $this = createThis(this);
    $this.y3k_1 = binPacker;
    $this.z3k_1 = border;
    $this.a3l_1 = premultiplied;
    $this.b3l_1 = allowToGrow;
    $this.c3l_1 = growMethod;
    $this.d3l_1 = MarginInt.w24($this.z3k_1);
    $this.e3l_1 = Bitmap32.z3l($this.n2d(), $this.o2d(), VOID, $this.a3l_1);
    $this.f3l_1 = arrayListOf([$this.e3l_1]);
    var tmp = $this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.g3l_1 = ArrayList.p1();
    $this.h3l_1 = LinkedHashMap.ac();
    $this.i3l_1 = null;
    return $this;
  }
  static c3m(width, height, border, premultiplied, allowToGrow, growMethod) {
    width = width === VOID ? 2048 : width;
    height = height === VOID ? width : height;
    border = border === VOID ? 2 : border;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    allowToGrow = allowToGrow === VOID ? true : allowToGrow;
    growMethod = growMethod === VOID ? GrowMethod_NEW_IMAGES_getInstance() : growMethod;
    return this.b3m(Companion_instance_0.f37(width, height), border, premultiplied, allowToGrow, growMethod);
  }
  n2d() {
    return numberToInt(this.y3k_1.n2d());
  }
  o2d() {
    return numberToInt(this.y3k_1.o2d());
  }
  d1() {
    return this.g3l_1.d1();
  }
  d3m(bmp, data, name) {
    return this.a3m(slice_0(bmp, VOID, name), data, name);
  }
  e3m(bmp, data, name, $super) {
    name = name === VOID ? 'Slice' + this.d1() : name;
    return $super === VOID ? this.d3m(bmp, data, name) : $super.d3m.call(this, bmp, data, name);
  }
  a3m(bmp, data, name) {
    var tmp = get_bmp(bmp);
    if (!(tmp instanceof Bitmap32)) {
      return this.d3m(extract_0(bmp).s3m(), data, name);
    }
    if (!(bmp instanceof RectSlice))
      THROW_CCE();
    try {
      var rname = name == null ? 'Slice' + this.d1() : name;
      var isEmpty = isFullyTransparent(bmp);
      var entry = null;
      if (isEmpty && !(this.i3l_1 == null)) {
        var bigEmptySlice = ensureNotNull(this.i3l_1).w3k_1;
        if (bigEmptySlice.w38_1 >= bmp.w38_1 && bigEmptySlice.x38_1 >= bmp.x38_1) {
          entry = new Entry(bigEmptySlice.f3a(RectangleInt.j2a(0, 0, bmp.w38_1, bmp.x38_1)), data);
        }
      }
      if (entry == null) {
        var rect = this.y3k_1.k2o(bmp.w38_1 + imul(this.z3k_1, 2), bmp.x38_1 + imul(this.z3k_1, 2));
        var slice = sliceWithSize(this.e3l_1, numberToInt(rect.k22() + this.z3k_1), numberToInt(rect.m22() + this.z3k_1), bmp.w38_1, bmp.x38_1, rname);
        var dstX = slice.k22();
        var dstY = slice.m22();
        var boundsWithBorder = get_bounds_0(slice).k2a(this.d3l_1);
        // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
        var this_0 = this.e3l_1;
        if (true) {
          this_0.l1o();
        }
        var result;
        try {
          // Inline function 'korlibs.image.atlas.MutableAtlas.add.<anonymous>' call
          this.e3l_1.t3m(bmp, dstX, dstY);
          expandBorder(this.e3l_1, slice.o38_1, this.z3k_1);
        }finally {
          result = true ? this_0.u3m(boundsWithBorder) : 0;
        }
        entry = new Entry(slice, data);
        if (this.i3l_1 == null || bmp.b2b() > ensureNotNull(this.i3l_1).w3k_1.b2b()) {
          this.i3l_1 = entry;
        }
      }
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.g3l_1;
      var element = entry;
      this_1.f(element);
      // Inline function 'kotlin.collections.set' call
      var this_2 = this.h3l_1;
      var value = entry;
      this_2.g3(rname, value);
      return entry;
    } catch ($p) {
      if ($p instanceof ImageDoNotFitException) {
        var e = $p;
        if (!this.b3l_1)
          throw e;
        growAtlas(this, bmp);
        return this.a3m(bmp, data, name);
      } else {
        throw $p;
      }
    }
  }
  v3m(bmp, data, name, $super) {
    name = name === VOID ? bmp.r38_1 : name;
    return $super === VOID ? this.a3m(bmp, data, name) : $super.a3m.call(this, bmp, data, name);
  }
}
class Bitmap {
  static w3m(width, height, bpp, premultiplied, backingArray) {
    var $this = createThis(this);
    $this.f3m_1 = new Mixin();
    $this.g3m_1 = width;
    $this.h3m_1 = height;
    $this.i3m_1 = bpp;
    $this.j3m_1 = backingArray;
    $this.k3m_1 = RectangleInt.j2a(0, 0, $this.n2d(), $this.o2d());
    $this.l3m_1 = null;
    $this.m3m_1 = premultiplied;
    $this.n3m_1 = false;
    var tmp = $this;
    tmp.o3m_1 = lazy(Bitmap$tempInts$delegate$lambda($this));
    $this.p3m_1 = 0;
    $this.q3m_1 = null;
    $this.r3m_1 = false;
    return $this;
  }
  tw(_set____db54di) {
    this.f3m_1.tw(_set____db54di);
  }
  uw() {
    return this.f3m_1.uw();
  }
  n2d() {
    return this.g3m_1;
  }
  o2d() {
    return this.h3m_1;
  }
  x3m() {
    return this.i3m_1;
  }
  d1() {
    return SizeInt.z2b(this.n2d(), this.o2d());
  }
  y3m(value) {
    this.m3m_1 = value;
  }
  z3m() {
    return this.m3m_1;
  }
  a3n() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o3m_1;
    tempInts$factory();
    return this_0.t1();
  }
  b3n() {
    return _RgbaArray___init__impl__oib4y4(this.a3n());
  }
  c3n() {
    return imul(this.n2d(), this.x3m()) / 8 | 0;
  }
  b2b() {
    return imul(this.n2d(), this.o2d());
  }
  d3n(x, y) {
    return imul(y, this.n2d()) + x | 0;
  }
  e3n() {
    if (!(this.q3m_1 == null)) {
      this.q3m_1 = null;
    }
  }
  l1o() {
    return Unit_instance;
  }
  u3m(rect) {
    if (this.q3m_1 == null)
      this.q3m_1 = rect;
    else
      this.q3m_1 = Companion_instance_1.u2a(ensureNotNull(this.q3m_1), rect);
    this.p3m_1 = this.p3m_1 + 1 | 0;
    return this.p3m_1;
  }
  f3n(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            out[_unary__edvuaz] = _RGBA___get_value__impl__hhco8v(this.g3n(x0 + x | 0, y0 + y | 0));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  h3n(x, y, width, height, out, offset) {
    var n = offset;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y0 = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < width)
          do {
            var x0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var tmp = x0 + x | 0;
            var tmp_0 = y0 + y | 0;
            var _unary__edvuaz = n;
            n = _unary__edvuaz + 1 | 0;
            this.i3n(tmp, tmp_0, _RGBA___init__impl__lqpay5(out[_unary__edvuaz]));
          }
           while (inductionVariable_0 < width);
      }
       while (inductionVariable < height);
  }
  j3n(x, y, width, height, out, offset, $super) {
    offset = offset === VOID ? 0 : offset;
    var tmp;
    if ($super === VOID) {
      this.h3n(x, y, width, height, out, offset);
      tmp = Unit_instance;
    } else {
      tmp = $super.h3n.call(this, x, y, width, height, out, offset);
    }
    return tmp;
  }
  i3n(x, y, v) {
    // Inline function 'kotlin.TODO' call
    throw NotImplementedError.nd();
  }
  g3n(x, y) {
    return Colors_getInstance().p3n_1;
  }
  c3t(x, y, color) {
    return Unit_instance;
  }
  d3t(x, y) {
    return 0;
  }
  e3t(x, y) {
    var x0 = toIntFloor(x);
    var y0 = toIntFloor(y);
    if (x0 < 0 || y0 < 0 || x0 >= this.n2d() || y0 >= this.o2d())
      return Colors_getInstance().p3n_1;
    var x1 = toIntCeil(x);
    var y1 = toIntCeil(y);
    var x1Inside = x1 < (this.n2d() - 1 | 0);
    var y1Inside = y1 < (this.o2d() - 1 | 0);
    // Inline function 'korlibs.math.fract' call
    var xratio = x - toIntFloor(x);
    // Inline function 'korlibs.math.fract' call
    var yratio = y - toIntFloor(y);
    var c00 = this.g3n(x0, y0);
    var c10 = x1Inside ? this.g3n(x1, y0) : c00;
    var c01 = y1Inside ? this.g3n(x0, y1) : c00;
    var c11 = x1Inside && y1Inside ? this.g3n(x1, y1) : c01;
    return Companion_getInstance_23().k3t(c00, c10, c01, c11, toRatio(xratio), toRatio(yratio));
  }
  l3t(srcX, srcY, dst, dstX, dstY, width, height) {
    var src = this;
    var srcX0 = src.m3t(srcX);
    var srcX1 = src.m3t(srcX + width | 0);
    var srcY0 = src.n3t(srcY);
    var srcY1 = src.n3t(srcY + height | 0);
    var dstX0 = dst.m3t(dstX);
    var dstX1 = dst.m3t(dstX + width | 0);
    var dstY0 = dst.n3t(dstY);
    var dstY1 = dst.n3t(dstY + height | 0);
    var srcX_0 = srcX0;
    var srcY_0 = srcY0;
    var dstX_0 = dstX0;
    var dstY_0 = dstY0;
    // Inline function 'kotlin.math.min' call
    var a = srcX1 - srcX0 | 0;
    var b = dstX1 - dstX0 | 0;
    var width_0 = Math.min(a, b);
    // Inline function 'kotlin.math.min' call
    var a_0 = srcY1 - srcY0 | 0;
    var b_0 = dstY1 - dstY0 | 0;
    var height_0 = Math.min(a_0, b_0);
    this.o3t(srcX_0, srcY_0, dst, dstX_0, dstY_0, width_0, height_0);
  }
  o3t(srcX, srcY, dst, dstX, dstY, width, height) {
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.f3n(srcX, srcY + y | 0, width, 1, this.a3n(), 0);
        dst.h3n(dstX, dstY + y | 0, width, 1, this.a3n(), 0);
      }
       while (inductionVariable < height);
  }
  p3t(x) {
    return x >= 0 && x < this.n2d();
  }
  q3t(y) {
    return y >= 0 && y < this.o2d();
  }
  r3t(x, y) {
    return this.p3t(x) && this.q3t(y);
  }
  s3t(x) {
    return clamp(x, 0, this.n2d() - 1 | 0);
  }
  t3t(y) {
    return clamp(y, 0, this.o2d() - 1 | 0);
  }
  m3t(x) {
    return clamp(x, 0, this.n2d());
  }
  n3t(y) {
    return clamp(y, 0, this.o2d());
  }
  u3t() {
    var inductionVariable = 0;
    var last = this.o2d() / 2 | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.v3t(y, (this.o2d() - y | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  w3t() {
    var inductionVariable = 0;
    var last = this.n2d() / 2 | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.x3t(x, (this.n2d() - x | 0) - 1 | 0);
      }
       while (inductionVariable < last);
    return this;
  }
  y3t(rotation) {
    var tmp;
    switch (rotation.m3_1) {
      case 0:
        tmp = this.qw();
        break;
      case 1:
        tmp = this.z3t().w3t();
        break;
      case 2:
        tmp = this.z3t().w3t().z3t().w3t();
        break;
      case 3:
        tmp = this.z3t().u3t();
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  a3u(orientation) {
    var out = this.qw();
    if (_SliceOrientation___get_flipX__impl__lgb7bx(orientation)) {
      out.w3t();
    }
    return out.y3t(_SliceOrientation___get_rotation__impl__m65r0o(orientation));
  }
  z3t() {
    var temp = new IntArray2(this.n2d(), this.o2d(), readPixelsUnsafe(this, 0, 0, this.n2d(), this.o2d()));
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = this.o2d();
    var height = this.n2d();
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Int32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 0;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var out = new IntArray2(width, height, isIntArray(tmp_2) ? tmp_2 : THROW_CCE());
    var inductionVariable = 0;
    var last = this.o2d();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.n2d();
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            out.t2d(y, x, temp.a24(x, y));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = this.b3u(this.o2d(), this.n2d());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.transposed.<anonymous>' call
    this_0.j3n(0, 0, this.o2d(), this.n2d(), out.m2d_1);
    return this_0;
  }
  v3t(y0, y1) {
    var inductionVariable = 0;
    var last = this.n2d();
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.d3t(x, y0);
        var c1 = this.d3t(x, y1);
        this.c3t(x, y0, c1);
        this.c3t(x, y1, c0);
      }
       while (inductionVariable < last);
  }
  x3t(x0, x1) {
    var inductionVariable = 0;
    var last = this.o2d();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c0 = this.d3t(x0, y);
        var c1 = this.d3t(x1, y);
        this.c3t(x0, y, c1);
        this.c3t(x1, y, c0);
      }
       while (inductionVariable < last);
  }
  c3u(antialiasing) {
    throw UnsupportedOperationException.x9('Not implemented context2d on Bitmap, please use NativeImage or Bitmap32 instead');
  }
  b3u(width, height) {
    invalidOp('Unsupported createWithThisFormat (' + toString_0(this) + ')');
  }
  s3m() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.z3l(this.n2d(), this.o2d(), VOID, this.z3m());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap.toBMP32.<anonymous>' call
    this.f3n(0, 0, this.n2d(), this.o2d(), this_0.w3l_1, 0);
    return this_0;
  }
  d3u() {
    var tmp;
    if (this instanceof Bitmap32) {
      tmp = this;
    } else {
      tmp = this.s3m();
    }
    return tmp;
  }
  qw() {
    var out = this.b3u(this.n2d(), this.o2d());
    this.o3t(0, 0, out, 0, 0, this.n2d(), this.o2d());
    return out;
  }
}
class Companion {
  constructor() {
    Companion_instance_5 = this;
    this.n3u_1 = Bitmap32.z3l(0, 0, VOID, true);
  }
  o3u(width, height, value) {
    // Inline function 'kotlin.apply' call
    var this_0 = Bitmap32.z3l(width, height, VOID, true);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Companion.invoke.<anonymous>' call
    fill(this_0.w3l_1, _RGBAPremultiplied___get_value__impl__bqfhud(value));
    return this_0;
  }
  p3u(width, height, premultiplied) {
    return Bitmap32.z3l(width, height, new Int32Array(imul(width, height)), premultiplied);
  }
  q3u(src, srcChannel, dst, dstChannel) {
    var srcShift = srcChannel.u3u_1;
    var dstShift = dstChannel.u3u_1;
    var dstClear = dstChannel.w3u_1;
    var dstData = dst.w3l_1;
    var srcData = src.w3l_1;
    var inductionVariable = 0;
    var last = dst.b2b();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = (srcData[n] >>> srcShift | 0) & 255;
        dstData[n] = dstData[n] & dstClear | c << dstShift;
      }
       while (inductionVariable < last);
  }
  x3u(src, dst, dstChannel) {
    var destShift = imul(dstChannel.t3u_1, 8);
    var destClear = ~(255 << destShift);
    var inductionVariable = 0;
    var last = dst.b2b();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = src.s3v()[n] & 255;
        dst.w3l_1[n] = dst.w3l_1[n] & destClear | c << destShift;
      }
       while (inductionVariable < last);
  }
  t3v(src, srcChannel, dst) {
    var shift = srcChannel.u3u_1;
    var inductionVariable = 0;
    var last = src.b2b();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        dst.s3v()[n] = toByte((src.w3l_1[n] >>> shift | 0) & 255);
      }
       while (inductionVariable < last);
  }
  u3v(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.l3t(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class Bitmap32$iterator$slambda {
  constructor(this$0) {
    this.l3u_1 = this$0;
  }
  v3v($this$iterator, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8(this, $this$iterator, $completion), $completion);
  }
  pd(p1, $completion) {
    return this.v3v(p1 instanceof SequenceScope ? p1 : THROW_CCE(), $completion);
  }
}
class Bitmap32 extends Bitmap {
  static z3l(width, height, ints, premultiplied) {
    Companion_getInstance_16();
    ints = ints === VOID ? new Int32Array(imul(width, height)) : ints;
    premultiplied = premultiplied === VOID ? true : premultiplied;
    var $this = this.w3m(width, height, 32, premultiplied, ints);
    $this.w3l_1 = ints;
    if ($this.w3l_1.length < imul(width, height))
      throw RuntimeException.ia('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.w3l_1.length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.x3l_1 = new Int32Array(tmp$ret$0);
    $this.y3l_1 = RectangleInt.j2a(0, 0, width, height);
    return $this;
  }
  static w3v(width, height, value) {
    Companion_getInstance_16();
    return this.z3l(width, height, _RgbaArray___get_ints__impl__u2kps1(value), false);
  }
  b3u(width, height) {
    return Bitmap32.z3l(width, height, VOID, this.z3m());
  }
  o3t(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap32))
      return super.o3t(srcX, srcY, dst, dstX, dstY, width, height);
    var src = this;
    var srcArray = src.w3l_1;
    var dstArray = dst.w3l_1;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        arraycopy(srcArray, src.d3n(srcX, srcY + y | 0), dstArray, dst.d3n(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  x3v(x, y, color) {
    this.y3v(x, y, color);
  }
  z3v(x, y) {
    return this.a3w(x, y);
  }
  c3t(x, y, color) {
    this.w3l_1[this.d3n(x, y)] = color;
  }
  d3t(x, y) {
    return this.w3l_1[this.d3n(x, y)];
  }
  g3n(x, y) {
    return _RGBA___init__impl__lqpay5(this.d3t(x, y));
  }
  i3n(x, y, v) {
    return this.c3t(x, y, _RGBA___get_value__impl__hhco8v(v));
  }
  y3v(x, y, v) {
    return this.b3w(this.d3n(x, y), v);
  }
  a3w(x, y) {
    return this.m3u(this.d3n(x, y));
  }
  b3w(n, color) {
    this.w3l_1[n] = this.z3m() ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(color)) : _RGBA___get_value__impl__hhco8v(color);
  }
  c3w(n, color) {
    var tmp;
    if (this.z3m()) {
      tmp = _RGBAPremultiplied___get_value__impl__bqfhud(color);
    } else {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(color);
      tmp = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
    }
    this.w3l_1[n] = tmp;
  }
  m3u(n) {
    var tmp;
    if (this.z3m()) {
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.w3l_1[n]);
      tmp = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
    } else {
      tmp = _RGBA___init__impl__lqpay5(this.w3l_1[n]);
    }
    return tmp;
  }
  d3w(n) {
    return this.z3m() ? _RGBAPremultiplied___init__impl__uos02x(this.w3l_1[n]) : _RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.w3l_1[n]));
  }
  e3w(src, dx, dy, sleft, stop, sright, sbottom, mix_0) {
    var dst = this;
    var width = sright - sleft | 0;
    var height = sbottom - stop | 0;
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var dstOffset = dst.d3n(dx, dy + y | 0);
        var srcOffset = src.d3n(sleft, stop + y | 0);
        if (mix_0) {
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < width)
            do {
              var x = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              dst.c3w(dstOffset + x | 0, mix(dst.d3w(dstOffset + x | 0), src.d3w(srcOffset + x | 0)));
            }
             while (inductionVariable_0 < width);
        } else {
          if (dst.z3m() === src.z3m()) {
            arraycopy(src.w3l_1, srcOffset, dst.w3l_1, dstOffset, width);
          } else if (!dst.z3m()) {
            var inductionVariable_1 = 0;
            if (inductionVariable_1 < width)
              do {
                var x_0 = inductionVariable_1;
                inductionVariable_1 = inductionVariable_1 + 1 | 0;
                dst.b3w(dstOffset + x_0 | 0, src.m3u(srcOffset + x_0 | 0));
              }
               while (inductionVariable_1 < width);
          } else {
            var inductionVariable_2 = 0;
            if (inductionVariable_2 < width)
              do {
                var x_1 = inductionVariable_2;
                inductionVariable_2 = inductionVariable_2 + 1 | 0;
                dst.c3w(dstOffset + x_1 | 0, src.d3w(srcOffset + x_1 | 0));
              }
               while (inductionVariable_2 < width);
          }
        }
      }
       while (inductionVariable < height);
  }
  f3w(src, dx, dy, sleft, stop, sright, sbottom, mix) {
    var sleft_0 = sleft;
    var stop_0 = stop;
    var dx_0 = dx;
    var dy_0 = dy;
    if (dx_0 < 0) {
      sleft_0 = sleft_0 - dx_0 | 0;
      dx_0 = 0;
    }
    if (dy_0 < 0) {
      stop_0 = stop_0 - dy_0 | 0;
      dy_0 = 0;
    }
    var availableWidth = this.n2d() - dx_0 | 0;
    var availableHeight = this.o2d() - dy_0 | 0;
    // Inline function 'kotlin.math.min' call
    var b = sright - sleft_0 | 0;
    var awidth = Math.min(availableWidth, b);
    // Inline function 'kotlin.math.min' call
    var b_0 = sbottom - stop_0 | 0;
    var aheight = Math.min(availableHeight, b_0);
    this.e3w(src, dx_0, dy_0, sleft_0, stop_0, sleft_0 + awidth | 0, stop_0 + aheight | 0, mix);
  }
  g3w(mix, other, _dx, _dy) {
    this.f3w(other, _dx, _dy, 0, 0, other.n2d(), other.o2d(), mix);
  }
  h3w(color, x, y, width, height) {
    var x1 = this.s3t(x);
    var x2 = this.s3t((x + width | 0) - 1 | 0);
    var y1 = this.t3t(y);
    var y2 = this.t3t((y + height | 0) - 1 | 0);
    var colorInt = RGBA__premultipliedValue_impl_oja55q(color, this.z3m());
    var inductionVariable = y1;
    if (inductionVariable <= y2)
      do {
        var cy = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        fill(this.w3l_1, colorInt, this.d3n(x1, cy), this.d3n(x2, cy) + 1 | 0);
      }
       while (!(cy === y2));
  }
  i3w(color, x, y, width, height, $super) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    width = width === VOID ? this.n2d() - x | 0 : width;
    height = height === VOID ? this.o2d() - y | 0 : height;
    var tmp;
    if ($super === VOID) {
      this.h3w(color, x, y, width, height);
      tmp = Unit_instance;
    } else {
      tmp = $super.h3w.call(this, new RGBA(color), x, y, width, height);
    }
    return tmp;
  }
  j3w(src, dx, dy, mix) {
    var b = get_bounds_0(src);
    this.f3w(get_bmp(src), dx, dy, b.k22(), b.m22(), b.l22(), b.n22(), mix);
  }
  k3w(src, dx, dy) {
    return this.g3w(false, src, dx, dy);
  }
  l3w(src, dx, dy) {
    return this.g3w(true, src, dx, dy);
  }
  m3w(src, dx, dy) {
    return this.j3w(src, dx, dy, false);
  }
  t3m(src, dx, dy) {
    return this.j3w(src, dx, dy, true);
  }
  n3w(destination, input, source) {
    return Companion_getInstance_16().q3u(input, source, this, destination);
  }
  o3w(destination, input) {
    return Companion_getInstance_16().x3u(input, this, destination);
  }
  p3w(channel, out) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.extractChannel.<anonymous>' call
    Companion_getInstance_16().t3v(this, channel, out);
    return out;
  }
  q3w(channel, out, $super) {
    out = out === VOID ? Bitmap8.l3x(this.n2d(), this.o2d()) : out;
    return $super === VOID ? this.p3w(channel, out) : $super.p3w.call(this, channel, out);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.toString.<anonymous>' call
    this_0.nb('Bitmap32(');
    this_0.ig(this.n2d());
    this_0.nb(', ');
    this_0.ig(this.o2d());
    if (!(this.l3m_1 == null)) {
      this_0.nb(', name=');
      this_0.nb(this.l3m_1);
    }
    this_0.nb(')');
    return this_0.toString();
  }
  v3t(y0, y1) {
    var s0 = this.d3n(0, y0);
    var s1 = this.d3n(0, y1);
    arraycopy(this.w3l_1, s0, this.x3l_1, 0, this.n2d());
    arraycopy(this.w3l_1, s1, this.w3l_1, s0, this.n2d());
    arraycopy(this.x3l_1, 0, this.w3l_1, s1, this.n2d());
  }
  qw() {
    var tmp = this.n2d();
    var tmp_0 = this.o2d();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$1 = this.w3l_1.slice();
    return Bitmap32.z3l(tmp, tmp_0, tmp$ret$1, this.z3m());
  }
  c3u(antialiasing) {
    return new Context2d(new Bitmap32Context2d(this, antialiasing));
  }
  m3x() {
    return this.z3m() ? this : this.copyPremultiplied();
  }
  n3x() {
    return !this.z3m() ? this : this.o3x();
  }
  copyPremultiplied() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.qw();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.premultiplied.<anonymous>' call
    this_0.p3x();
    return this_0;
  }
  o3x() {
    // Inline function 'kotlin.apply' call
    var this_0 = this.qw();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Bitmap32.depremultiplied.<anonymous>' call
    this_0.q3x();
    return this_0;
  }
  p3x() {
    if (this.z3m())
      return Unit_instance;
    this.y3m(true);
    var inductionVariable = 0;
    var last = this.b2b();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.w3l_1[n] = _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_RGBA___init__impl__lqpay5(this.w3l_1[n])));
      }
       while (inductionVariable < last);
  }
  q3x() {
    if (!this.z3m())
      return Unit_instance;
    this.y3m(false);
    var inductionVariable = 0;
    var last = this.b2b();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
        var this_0 = _RGBAPremultiplied___init__impl__uos02x(this.w3l_1[n]);
        var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
        this.w3l_1[n] = _RGBA___get_value__impl__hhco8v(tmp$ret$0);
      }
       while (inductionVariable < last);
  }
  z() {
    return iterator(Bitmap32$iterator$slambda_0(this));
  }
  r3x(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy(_RgbaArray___get_ints__impl__u2kps1(data), 0, this.w3l_1, this.d3n(x, y), width);
    } else {
      var m = this.d3n(x, y);
      var inductionVariable = 0;
      if (inductionVariable < width)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.w3l_1[m] = _RgbaArray___get_ints__impl__u2kps1(data)[n];
          m = m + increment | 0;
        }
         while (inductionVariable < width);
    }
  }
  s3m() {
    return this;
  }
}
class Companion_0 {
  s3x(src, srcX, srcY, dst, dstX, dstY, width, height) {
    return src.l3t(srcX, srcY, dst, dstX, dstY, width, height);
  }
}
class BitmapIndexed extends Bitmap {
  static u3x(bpp, width, height, bytes, palette) {
    bytes = bytes === VOID ? new Int8Array(imul(width, height) / (8 / bpp | 0) | 0) : bytes;
    palette = palette === VOID ? Companion_instance_11.t3x(1 << bpp) : palette;
    var $this = this.w3m(width, height, bpp, false, bytes);
    $this.l3v_1 = bytes;
    $this.m3v_1 = palette;
    if ($this.x3x().length < (imul(width, height) / (8 / bpp | 0) | 0))
      throw RuntimeException.ia('Bitmap data is too short: width=' + width + ', height=' + height + ', data=ByteArray(' + $this.s3v().length + '), area=' + imul(width, height));
    var tmp = $this;
    // Inline function 'kotlin.math.max' call
    var tmp$ret$0 = Math.max(width, height);
    tmp.n3v_1 = new Int8Array(tmp$ret$0);
    $this.o3v_1 = _UByteArrayInt___init__impl__xif7bu($this.s3v());
    $this.p3v_1 = 8 / bpp | 0;
    $this.q3v_1 = ilog2($this.p3v_1);
    $this.r3v_1 = $this.p3v_1 - 1 | 0;
    return $this;
  }
  x3x() {
    return this.l3v_1;
  }
  s3v() {
    return this.x3x();
  }
  toString() {
    return 'BitmapIndexed(bpp=' + this.x3m() + ', width=' + this.n2d() + ', height=' + this.o2d() + ', clut=' + _RgbaArray___get_size__impl__imxef8(this.m3v_1) + ')';
  }
  d3t(x, y) {
    return this.w3x(this.d3n(x, y));
  }
  c3t(x, y, color) {
    return this.v3x(this.d3n(x, y), color);
  }
  w3x(n) {
    var iD = this.z3x(n);
    var iM = this.a3y(n);
    return extract(UByteArrayInt__get_impl_px6q8a(this.o3v_1, iD), imul(this.x3m(), iM), this.x3m());
  }
  v3x(n, color) {
    var iD = this.z3x(n);
    var iM = this.a3y(n);
    UByteArrayInt__set_impl_gn4532(this.o3v_1, iD, insert(UByteArrayInt__get_impl_px6q8a(this.o3v_1, iD), color, imul(this.x3m(), iM), this.x3m()));
  }
  g3n(x, y) {
    var tmp = this.m3v_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.d3t(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  y3x(x, y) {
    return this.z3x(this.d3n(x, y));
  }
  z3x(n) {
    return n >>> this.q3v_1 | 0;
  }
  a3y(n) {
    return n & this.r3v_1;
  }
  v3t(y0, y1) {
    var s0 = this.y3x(0, y0);
    var s1 = this.y3x(0, y1);
    arraycopy_0(this.s3v(), s0, this.n3v_1, 0, this.c3n());
    arraycopy_0(this.s3v(), s1, this.s3v(), s0, this.c3n());
    arraycopy_0(this.n3v_1, 0, this.s3v(), s1, this.c3n());
  }
  b3y(x, y, data, width, increment) {
    if (increment === 1) {
      arraycopy_0(data, 0, this.s3v(), this.d3n(x, y), width / this.p3v_1 | 0);
    } else {
      var m = this.d3n(x, y);
      var inductionVariable = 0;
      var last = width / this.p3v_1 | 0;
      if (inductionVariable < last)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.s3v()[m] = data[n];
          m = m + increment | 0;
        }
         while (inductionVariable < last);
    }
  }
  s3m() {
    // Inline function 'kotlin.also' call
    var this_0 = Bitmap32.z3l(this.n2d(), this.o2d(), VOID, this.z3m());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.toBMP32.<anonymous>' call
    var out = this_0.w3l_1;
    var pal = _RgbaArray___get_ints__impl__u2kps1(this.m3v_1);
    var inductionVariable = 0;
    var last = this.b2b();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        out[n] = pal[this.w3x(n)];
      }
       while (inductionVariable < last);
    return this_0;
  }
}
class Bitmap8 extends BitmapIndexed {
  static l3x(width, height, data, palette) {
    data = data === VOID ? new Int8Array(imul(width, height)) : data;
    palette = palette === VOID ? Companion_instance_11.t3x(256) : palette;
    return this.u3x(8, width, height, data, palette);
  }
  b3u(width, height) {
    return Bitmap8.l3x(width, height, VOID, this.m3v_1);
  }
  c3t(x, y, color) {
    return this.v3x(this.d3n(x, y), color);
  }
  d3t(x, y) {
    return UByteArrayInt__get_impl_px6q8a(this.o3v_1, this.d3n(x, y));
  }
  g3n(x, y) {
    var tmp = this.m3v_1;
    // Inline function 'korlibs.image.bitmap.BitmapIndexed.get' call
    var tmp$ret$0 = this.d3t(x, y);
    return RgbaArray__get_impl_nzyo1o(tmp, tmp$ret$0);
  }
  w3x(n) {
    return UByteArrayInt__get_impl_px6q8a(this.o3v_1, n);
  }
  v3x(n, color) {
    UByteArrayInt__set_impl_gn4532(this.o3v_1, n, color);
  }
  o3t(srcX, srcY, dst, dstX, dstY, width, height) {
    if (!(dst instanceof Bitmap8))
      return super.o3t(srcX, srcY, dst, dstX, dstY, width, height);
    var inductionVariable = 0;
    if (inductionVariable < height)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var tmp = this.s3v();
        var tmp_0 = this.d3n(srcX, srcY + y | 0);
        arraycopy_0(tmp, tmp_0, (dst instanceof Bitmap8 ? dst : THROW_CCE()).s3v(), dst.d3n(dstX, dstY + y | 0), width);
      }
       while (inductionVariable < height);
  }
  qw() {
    var tmp = this.n2d();
    var tmp_0 = this.o2d();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp_1 = this.s3v().slice();
    // Inline function 'kotlin.collections.copyOf' call
    // Inline function 'kotlin.js.asDynamic' call
    var tmp$ret$3 = _RgbaArray___get_ints__impl__u2kps1(this.m3v_1).slice();
    return Bitmap8.l3x(tmp, tmp_0, tmp_1, _RgbaArray___init__impl__oib4y4(tmp$ret$3));
  }
  toString() {
    return 'Bitmap8(' + this.n2d() + ', ' + this.o2d() + ', palette=' + _RgbaArray___get_size__impl__imxef8(this.m3v_1) + ')';
  }
}
class Companion_1 {
  constructor() {
    Companion_instance_7 = this;
    this.c3y_1 = values();
  }
  c1(index) {
    return this.c3y_1[index];
  }
}
class BitmapChannel extends Enum {
  constructor(name, ordinal, index) {
    super(name, ordinal);
    this.t3u_1 = index;
    this.u3u_1 = imul(this.t3u_1, 8);
    this.v3u_1 = 255 << this.u3u_1;
    this.w3u_1 = ~this.v3u_1;
  }
}
class Bitmaps {}
class Companion_2 {
  constructor() {
    this.d3y_1 = 1.0;
    this.e3y_1 = 1.4142135;
  }
}
class DistanceBitmap {
  constructor(width, height, d, px, py) {
    d = d === VOID ? new Float32Array(imul(width, height)) : d;
    px = px === VOID ? new Int32Array(imul(width, height)) : px;
    py = py === VOID ? new Int32Array(imul(width, height)) : py;
    this.f3y_1 = width;
    this.g3y_1 = height;
    this.h3y_1 = d;
    this.i3y_1 = px;
    this.j3y_1 = py;
    this.k3y_1 = imul(this.f3y_1, this.g3y_1);
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.h3y_1.length >= this.k3y_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.i3y_1.length >= this.k3y_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message_0));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.j3y_1.length >= this.k3y_1)) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_1 = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message_1));
    }
  }
  p3t(x) {
    return x >= 0 && x < this.f3y_1;
  }
  q3t(y) {
    return y >= 0 && y < this.g3y_1;
  }
  r3t(x, y) {
    return this.p3t(x) && this.q3t(y);
  }
  d3n(x, y) {
    return imul(y, this.f3y_1) + x | 0;
  }
  p3y(x, y) {
    return this.r3t(x, y) ? this.h3y_1[this.d3n(x, y)] : Infinity;
  }
  m3y(x, y) {
    return this.r3t(x, y) ? this.i3y_1[this.d3n(x, y)] : -1;
  }
  n3y(x, y) {
    return this.r3t(x, y) ? this.j3y_1[this.d3n(x, y)] : -1;
  }
  o3y(x, y, d) {
    if (!this.r3t(x, y))
      return Unit_instance;
    this.h3y_1[this.d3n(x, y)] = d;
  }
  q3y(x, y, px, py) {
    if (!this.r3t(x, y))
      return Unit_instance;
    var index = this.d3n(x, y);
    this.i3y_1[index] = px;
    this.j3y_1[index] = py;
  }
  l3y(x, y, px, py) {
    return this.q3y(x, y, this.m3y(px, py), this.n3y(px, py));
  }
  r3y(bmp, thresold) {
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.f3y_1 === bmp.n2d())) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!(this.g3y_1 === bmp.o2d())) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message_0 = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message_0));
    }
    var thresoldInt = numberToInt(clamp01(thresold) * 255);
    var inductionVariable = 0;
    var last = this.g3y_1;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = this.f3y_1;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            this.o3y(x, y, Infinity);
            this.q3y(x, y, -1, -1);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    var inductionVariable_1 = 0;
    var last_1 = this.g3y_1;
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = this.f3y_1;
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var cur = setFromBitmap$getAlpha(bmp, x_0, y_0, thresoldInt);
            var left = setFromBitmap$getAlpha(bmp, x_0 - 1 | 0, y_0, thresoldInt);
            var right = setFromBitmap$getAlpha(bmp, x_0 + 1 | 0, y_0, thresoldInt);
            var up = setFromBitmap$getAlpha(bmp, x_0, y_0 - 1 | 0, thresoldInt);
            var down = setFromBitmap$getAlpha(bmp, x_0, y_0 + 1 | 0, thresoldInt);
            if (!(left === cur) || !(right === cur) || !(up === cur) || !(down === cur)) {
              this.o3y(x_0, y_0, 0.0);
              this.q3y(x_0, y_0, x_0, y_0);
            }
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    var inductionVariable_3 = 0;
    var last_3 = this.g3y_1;
    if (inductionVariable_3 < last_3)
      do {
        var y_1 = inductionVariable_3;
        inductionVariable_3 = inductionVariable_3 + 1 | 0;
        var inductionVariable_4 = 0;
        var last_4 = this.f3y_1;
        if (inductionVariable_4 < last_4)
          do {
            var x_1 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            setFromBitmap$pass(this, x_1, y_1, -1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, 0, -1, 1.0);
            setFromBitmap$pass(this, x_1, y_1, 1, -1, 1.4142135);
            setFromBitmap$pass(this, x_1, y_1, -1, 0, 1.0);
          }
           while (inductionVariable_4 < last_4);
      }
       while (inductionVariable_3 < last_3);
    var inductionVariable_5 = this.g3y_1 - 1 | 0;
    if (0 <= inductionVariable_5)
      do {
        var y_2 = inductionVariable_5;
        inductionVariable_5 = inductionVariable_5 + -1 | 0;
        var inductionVariable_6 = this.f3y_1 - 1 | 0;
        if (0 <= inductionVariable_6)
          do {
            var x_2 = inductionVariable_6;
            inductionVariable_6 = inductionVariable_6 + -1 | 0;
            setFromBitmap$pass(this, x_2, y_2, 1, 0, 1.0);
            setFromBitmap$pass(this, x_2, y_2, -1, 1, 1.4142135);
            setFromBitmap$pass(this, x_2, y_2, 0, 1, 1.0);
            setFromBitmap$pass(this, x_2, y_2, 1, 1, 1.4142135);
          }
           while (0 <= inductionVariable_6);
      }
       while (0 <= inductionVariable_5);
    var inductionVariable_7 = this.g3y_1 - 1 | 0;
    if (0 <= inductionVariable_7)
      do {
        var y_3 = inductionVariable_7;
        inductionVariable_7 = inductionVariable_7 + -1 | 0;
        var inductionVariable_8 = this.f3y_1 - 1 | 0;
        if (0 <= inductionVariable_8)
          do {
            var x_3 = inductionVariable_8;
            inductionVariable_8 = inductionVariable_8 + -1 | 0;
            if (setFromBitmap$getAlpha(bmp, x_3, y_3, thresoldInt)) {
              this.o3y(x_3, y_3, -this.p3y(x_3, y_3));
            }
          }
           while (0 <= inductionVariable_8);
      }
       while (0 <= inductionVariable_7);
  }
}
class FloatBitmap32 extends Bitmap {
  static g3z(width, height, data, premultiplied) {
    data = data === VOID ? new Float32Array(imul(imul(width, height), 4)) : data;
    premultiplied = premultiplied === VOID ? false : premultiplied;
    var $this = this.w3m(width, height, 32, premultiplied, data);
    $this.f3z_1 = data;
    return $this;
  }
  i3n(x, y, v) {
    var rindex = index4(this, x, y);
    this.f3z_1[rindex + 0 | 0] = _RGBA___get_rf__impl__kvz75k(v);
    this.f3z_1[rindex + 1 | 0] = _RGBA___get_gf__impl__5gcu1f(v);
    this.f3z_1[rindex + 2 | 0] = _RGBA___get_bf__impl__1xz5yg(v);
    this.f3z_1[rindex + 3 | 0] = _RGBA___get_af__impl__vu36qv(v);
  }
  g3n(x, y) {
    var rindex = index4(this, x, y);
    return Companion_getInstance_23().h3z(this.f3z_1[rindex + 0 | 0], this.f3z_1[rindex + 1 | 0], this.f3z_1[rindex + 2 | 0], this.f3z_1[rindex + 3 | 0]);
  }
  i3z(x, y) {
    return this.f3z_1[index4(this, x, y) + 0 | 0];
  }
  j3z(x, y) {
    return this.f3z_1[index4(this, x, y) + 1 | 0];
  }
  k3z(x, y) {
    return this.f3z_1[index4(this, x, y) + 2 | 0];
  }
  l3z(x, y) {
    return this.f3z_1[index4(this, x, y) + 3 | 0];
  }
  m3z(x, y, r, g, b, a) {
    var rindex = index4(this, x, y);
    this.f3z_1[rindex + 0 | 0] = r;
    this.f3z_1[rindex + 1 | 0] = g;
    this.f3z_1[rindex + 2 | 0] = b;
    this.f3z_1[rindex + 3 | 0] = a;
  }
  n3z(x, y, out) {
    var rindex = index4(this, x, y);
    _RGBAf___set_r__impl__pz5j5e(out, this.f3z_1[rindex + 0 | 0]);
    _RGBAf___set_g__impl__c4jj21(out, this.f3z_1[rindex + 1 | 0]);
    _RGBAf___set_b__impl__a2n9pa(out, this.f3z_1[rindex + 2 | 0]);
    _RGBAf___set_a__impl__iqz7cx(out, this.f3z_1[rindex + 3 | 0]);
    return out;
  }
  o3z(out) {
    var min_0 = Infinity;
    var max_0 = -Infinity;
    var temp = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.n2d() - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.o2d() - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.d3n(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.getMinMax.<anonymous>' call
            n = n + 1 | 0;
            var c = this.n3z(x, y, temp);
            min_0 = min(min_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
            max_0 = max(max_0, _RGBAf___get_r__impl__jfq8gq(c), _RGBAf___get_g__impl__dhoraz(c), _RGBAf___get_b__impl__fjl0nq(c), _RGBAf___get_a__impl__qnwk97(c));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    out[0] = min_0;
    out[1] = max_0;
    return out;
  }
  p3z(out, $super) {
    out = out === VOID ? new Float32Array(2) : out;
    return $super === VOID ? this.o3z(out) : $super.o3z.call(this, out);
  }
  q3z(minSrc, maxSrc, minDst, maxDst) {
    var out = _RGBAf___init__impl__idjpgn_0();
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.n2d() - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.o2d() - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.d3n(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.convertRange.<anonymous>' call
            n = n + 1 | 0;
            var rgbaf = this.n3z(x, y, out);
            this.m3z(x, y, convertRange(_RGBAf___get_r__impl__jfq8gq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_g__impl__dhoraz(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_b__impl__fjl0nq(rgbaf), minSrc, maxSrc, minDst, maxDst), convertRange(_RGBAf___get_a__impl__qnwk97(rgbaf), minSrc, maxSrc, minDst, maxDst));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  r3z(minSrc, maxSrc, minDst, maxDst, $super) {
    minDst = minDst === VOID ? 0.0 : minDst;
    maxDst = maxDst === VOID ? 1.0 : maxDst;
    var tmp;
    if ($super === VOID) {
      this.q3z(minSrc, maxSrc, minDst, maxDst);
      tmp = Unit_instance;
    } else {
      tmp = $super.q3z.call(this, minSrc, maxSrc, minDst, maxDst);
    }
    return tmp;
  }
  s3z() {
    var _destruct__k2r9zo = this.p3z();
    // Inline function 'kotlin.collections.component1' call
    var min = _destruct__k2r9zo[0];
    // Inline function 'kotlin.collections.component2' call
    var max = _destruct__k2r9zo[1];
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.math.absoluteValue' call
    var a = Math.abs(min);
    // Inline function 'kotlin.math.absoluteValue' call
    var b = Math.abs(max);
    var range = Math.max(a, b);
    this.r3z(-range, +range);
  }
  t3z(scale) {
    return this.u3z(scale, scale, scale, scale);
  }
  u3z(scaleRed, scaleGreen, scaleBlue, scaleAlpha) {
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.n2d() - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.o2d() - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.d3n(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.scale.<anonymous>' call
            n = n + 1 | 0;
            this.m3z(x, y, this.i3z(x, y) * scaleRed, this.j3z(x, y) * scaleGreen, this.k3z(x, y) * scaleBlue, this.l3z(x, y) * scaleAlpha);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
  v3z(min, max) {
    // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
    // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
    var width = this.n2d() - 0 | 0;
    var inductionVariable = 0;
    var last = 0 + (this.o2d() - 0 | 0) | 0;
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var n = this.d3n(0, 0 + y | 0);
        var inductionVariable_0 = 0;
        var last_0 = 0 + width | 0;
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
            n = n + 1 | 0;
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value = this.i3z(x, y);
            var tmp = clamp_0(value, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_0 = this.j3z(x, y);
            var tmp_0 = clamp_0(value_0, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_1 = this.k3z(x, y);
            var tmp_1 = clamp_0(value_1, min, max);
            // Inline function 'korlibs.image.bitmap.FloatBitmap32.clamp.<anonymous>' call
            var value_2 = this.l3z(x, y);
            var tmp$ret$3 = clamp_0(value_2, min, max);
            this.m3z(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
  }
}
class MultiBitmap extends Bitmap {}
class NativeImage extends Bitmap {
  static k40(width, height, data, premultiplied) {
    var $this = this.w3m(width, height, 32, premultiplied, null);
    $this.j40_1 = data;
    return $this;
  }
  s3m() {
    // Inline function 'kotlin.also' call
    var this_0 = Companion_getInstance_16().p3u(this.n2d(), this.o2d(), this.z3m());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.NativeImage.toBMP32.<anonymous>' call
    this.f3n(0, 0, this.n2d(), this.o2d(), this_0.w3l_1, 0);
    return this_0;
  }
  i3n(x, y, v) {
    RgbaArray__set_impl_epw2wg(this.b3n(), 0, v);
    this.h3n(x, y, 1, 1, this.a3n(), 0);
  }
  g3n(x, y) {
    this.f3n(x, y, 1, 1, this.a3n(), 0);
    return RgbaArray__get_impl_nzyo1o(this.b3n(), 0);
  }
  c3t(x, y, color) {
    return this.i3n(x, y, _RGBA___init__impl__lqpay5(color));
  }
  d3t(x, y) {
    return _RGBA___get_value__impl__hhco8v(this.g3n(x, y));
  }
  u3t() {
    var tmp = this.n2d();
    var tmp_0 = this.o2d();
    var tmp_1 = this.s3m().u3t();
    this.j3n(0, 0, tmp, tmp_0, (tmp_1 instanceof Bitmap32 ? tmp_1 : THROW_CCE()).w3l_1);
    return this;
  }
  w3t() {
    var tmp = this.n2d();
    var tmp_0 = this.o2d();
    var tmp_1 = this.s3m().w3t();
    this.j3n(0, 0, tmp, tmp_0, (tmp_1 instanceof Bitmap32 ? tmp_1 : THROW_CCE()).w3l_1);
    return this;
  }
  v3t(y0, y1) {
    this.f3n(0, y0, this.n2d(), 1, this.a3n(), 0);
    this.f3n(0, y1, this.n2d(), 1, this.a3n(), this.n2d());
    this.h3n(0, y1, this.n2d(), 1, this.a3n(), 0);
    this.h3n(0, y0, this.n2d(), 1, this.a3n(), this.n2d());
  }
  x3t(x0, x1) {
    this.f3n(x0, 0, 1, this.o2d(), this.a3n(), 0);
    this.f3n(x1, 0, 1, this.o2d(), this.a3n(), this.n2d());
    this.h3n(x1, 0, 1, this.o2d(), this.a3n(), 0);
    this.h3n(x0, 0, 1, this.o2d(), this.a3n(), this.n2d());
  }
  b3u(width, height) {
    return NativeImage_0(width, height);
  }
  toString() {
    return this.n3() + '(' + this.n2d() + ', ' + this.o2d() + ')';
  }
}
class ForcedTexId {}
function get_forcedTexTarget() {
  return 3553;
}
class Companion_3 {
  o40(bmp, left, top, right, bottom) {
    return new NinePatchBmpSlice(bmp, NinePatchInfo.f41(bmp.w38_1, bmp.x38_1, left, top, right, bottom, bmp));
  }
}
class NinePatchBmpSlice {
  constructor(content, info, bmpSlice) {
    bmpSlice = bmpSlice === VOID ? content : bmpSlice;
    this.g41_1 = content;
    this.h41_1 = info;
    this.i41_1 = bmpSlice;
  }
}
class AxisSegment {
  constructor(scaled, range) {
    this.s41_1 = scaled;
    this.t41_1 = range;
  }
  u41() {
    return !this.s41_1;
  }
  a() {
    return get_length(this.t41_1);
  }
}
class AxisInfo {
  constructor(ranges, totalLen) {
    this.v41_1 = ranges;
    this.w41_1 = totalLen;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.v41_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.bitmap.AxisInfo.segments.<anonymous>' call
      var tmp$ret$0 = new AxisSegment(item.pk_1, item.qk_1);
      destination.f(tmp$ret$0);
    }
    tmp.x41_1 = toFastList(destination);
    var tmp_0 = this;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.collections.sumOf' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_1 = this.x41_1;
    var destination_0 = ArrayList.p1();
    var tmp0_iterator_0 = this_1.z();
    while (tmp0_iterator_0.a1()) {
      var element = tmp0_iterator_0.b1();
      // Inline function 'korlibs.image.bitmap.AxisInfo.fixedLen.<anonymous>' call
      if (element.u41()) {
        destination_0.f(element);
      }
    }
    var sum = 0;
    var tmp0_iterator_1 = destination_0.z();
    while (tmp0_iterator_1.a1()) {
      var element_0 = tmp0_iterator_1.b1();
      var tmp_1 = sum;
      // Inline function 'korlibs.image.bitmap.AxisInfo.fixedLen.<anonymous>' call
      sum = tmp_1 + element_0.a() | 0;
    }
    var b = sum;
    tmp_0.y41_1 = Math.max(1, b);
    var tmp_2 = this;
    // Inline function 'kotlin.math.max' call
    // Inline function 'kotlin.collections.sumOf' call
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_2 = this.x41_1;
    var destination_1 = ArrayList.p1();
    var tmp0_iterator_2 = this_2.z();
    while (tmp0_iterator_2.a1()) {
      var element_1 = tmp0_iterator_2.b1();
      // Inline function 'korlibs.image.bitmap.AxisInfo.scaledLen.<anonymous>' call
      if (element_1.s41_1) {
        destination_1.f(element_1);
      }
    }
    var sum_0 = 0;
    var tmp0_iterator_3 = destination_1.z();
    while (tmp0_iterator_3.a1()) {
      var element_2 = tmp0_iterator_3.b1();
      var tmp_3 = sum_0;
      // Inline function 'korlibs.image.bitmap.AxisInfo.scaledLen.<anonymous>' call
      sum_0 = tmp_3 + element_2.a() | 0;
    }
    var b_0 = sum_0;
    tmp_2.z41_1 = Math.max(1, b_0);
  }
  toString() {
    return 'AxisInfo(ranges=' + toString_0(this.v41_1) + ', totalLen=' + this.w41_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.v41_1);
    result = imul(result, 31) + this.w41_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AxisInfo))
      return false;
    var tmp0_other_with_cast = other instanceof AxisInfo ? other : THROW_CCE();
    if (!equals(this.v41_1, tmp0_other_with_cast.v41_1))
      return false;
    if (!(this.w41_1 === tmp0_other_with_cast.w41_1))
      return false;
    return true;
  }
}
class Segment {
  constructor(info, rect, x, y) {
    this.j41_1 = new Mixin();
    this.k41_1 = info;
    this.l41_1 = rect;
    this.m41_1 = x;
    this.n41_1 = y;
    this.o41_1 = this.m41_1.s41_1;
    this.p41_1 = this.n41_1.s41_1;
    var tmp = this;
    var tmp20_safe_receiver = this.k41_1.t40_1;
    tmp.q41_1 = tmp20_safe_receiver == null ? null : tmp20_safe_receiver.f3a(this.l41_1);
    var tmp_0 = this;
    tmp_0.r41_1 = lazy(NinePatchInfo$Segment$bmp$delegate$lambda(this));
  }
  tw(_set____db54di) {
    this.j41_1.tw(_set____db54di);
  }
  uw() {
    return this.j41_1.uw();
  }
}
class NinePatchInfo {
  static a42(xranges, yranges, width, height, content) {
    content = content === VOID ? null : content;
    var $this = createThis(this);
    $this.p40_1 = xranges;
    $this.q40_1 = yranges;
    $this.r40_1 = width;
    $this.s40_1 = height;
    $this.t40_1 = content;
    $this.u40_1 = new AxisInfo($this.p40_1, $this.r40_1);
    $this.v40_1 = new AxisInfo($this.q40_1, $this.s40_1);
    $this.w40_1 = $this.u40_1.x41_1;
    $this.x40_1 = $this.v40_1.x41_1;
    $this.y40_1 = $this.u40_1.y41_1;
    $this.z40_1 = $this.v40_1.y41_1;
    $this.a41_1 = $this.u40_1.z41_1;
    $this.b41_1 = $this.v40_1.z41_1;
    var tmp = $this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = $this.x40_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.bitmap.NinePatchInfo.segments.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_1 = $this.w40_1;
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.z();
      while (tmp0_iterator_0.a1()) {
        var item_0 = tmp0_iterator_0.b1();
        // Inline function 'korlibs.image.bitmap.NinePatchInfo.segments.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new Segment($this, Companion_instance_1.r29(item_0.t41_1.c2_1, item.t41_1.c2_1, item_0.t41_1.d2_1 + 1 | 0, item.t41_1.d2_1 + 1 | 0), item_0, item);
        destination_0.f(tmp$ret$0);
      }
      var tmp$ret$3 = toFastList(destination_0);
      destination.f(tmp$ret$3);
    }
    tmp.c41_1 = toFastList(destination);
    $this.d41_1 = new Int32Array(64);
    $this.e41_1 = new Int32Array(64);
    return $this;
  }
  static f41(width, height, left, top, right, bottom, content) {
    content = content === VOID ? null : content;
    return this.a42(listOf([to(false, until(0, left)), to(true, until(left, right)), to(false, until(right, width))]), listOf([to(false, until(0, top)), to(true, until(top, bottom)), to(false, until(bottom, height))]), width, height, content);
  }
  toString() {
    return 'NinePatchInfo(xranges=' + toString_0(this.p40_1) + ', yranges=' + toString_0(this.q40_1) + ', width=' + this.r40_1 + ', height=' + this.s40_1 + ', content=' + toString(this.t40_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.p40_1);
    result = imul(result, 31) + hashCode(this.q40_1) | 0;
    result = imul(result, 31) + this.r40_1 | 0;
    result = imul(result, 31) + this.s40_1 | 0;
    result = imul(result, 31) + (this.t40_1 == null ? 0 : this.t40_1.hashCode()) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NinePatchInfo))
      return false;
    var tmp0_other_with_cast = other instanceof NinePatchInfo ? other : THROW_CCE();
    if (!equals(this.p40_1, tmp0_other_with_cast.p40_1))
      return false;
    if (!equals(this.q40_1, tmp0_other_with_cast.q40_1))
      return false;
    if (!(this.r40_1 === tmp0_other_with_cast.r40_1))
      return false;
    if (!(this.s40_1 === tmp0_other_with_cast.s40_1))
      return false;
    if (!equals(this.t40_1, tmp0_other_with_cast.t40_1))
      return false;
    return true;
  }
}
class NullBitmap extends Bitmap {
  static o42(width, height, premultiplied) {
    premultiplied = premultiplied === VOID ? true : premultiplied;
    return this.w3m(width, height, 32, premultiplied, null);
  }
}
class Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    this.p42_1 = colors;
    this.q42_1 = names;
    this.r42_1 = changeStart;
    this.s42_1 = changeEnd;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.bitmap.Palette.toString.<anonymous>' call
    this_0.nb('Palette(');
    var inductionVariable = 0;
    var last = _RgbaArray___get_size__impl__imxef8(this.p42_1);
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var color = RgbaArray__get_impl_nzyo1o(this.p42_1, n);
        var tmp22_safe_receiver = this.q42_1;
        var name = tmp22_safe_receiver == null ? null : tmp22_safe_receiver[n];
        if (n > 0) {
          this_0.nb(', ');
        }
        if (!(name == null)) {
          this_0.nb(name);
          this_0.nb(': ');
        }
        this_0.nb(RGBA__toString_impl_4lw6dp(color));
      }
       while (inductionVariable < last);
    this_0.nb(')');
    return this_0.toString();
  }
}
class Result {
  constructor(bmp, buffer, radius, cutoff) {
    this.d43_1 = bmp;
    this.e43_1 = buffer;
    this.f43_1 = radius;
    this.g43_1 = cutoff;
  }
  toString() {
    return 'Result(bmp=' + this.d43_1.toString() + ', buffer=' + this.e43_1 + ', radius=' + this.f43_1 + ', cutoff=' + this.g43_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.d43_1);
    result = imul(result, 31) + this.e43_1 | 0;
    result = imul(result, 31) + this.f43_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.g43_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Result))
      return false;
    var tmp0_other_with_cast = other instanceof Result ? other : THROW_CCE();
    if (!equals(this.d43_1, tmp0_other_with_cast.d43_1))
      return false;
    if (!(this.e43_1 === tmp0_other_with_cast.e43_1))
      return false;
    if (!(this.f43_1 === tmp0_other_with_cast.f43_1))
      return false;
    if (!equals(this.g43_1, tmp0_other_with_cast.g43_1))
      return false;
    return true;
  }
}
class NewSDF {
  constructor() {
    this.h43_1 = 1.0E10;
  }
  i43(bmp, maxSide, buffer, radius, cutoff) {
    var size = maxSide + imul(buffer, 4) | 0;
    var out = Bitmap32.z3l(bmp.n2d() + imul(buffer, 2) | 0, bmp.o2d() + imul(buffer, 2) | 0);
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width = out.n2d();
    var height = out.o2d();
    var tmp = 0;
    var tmp_0 = imul(width, height);
    var tmp_1 = new Float32Array(tmp_0);
    while (tmp < tmp_0) {
      tmp_1[tmp] = 1.0E10;
      tmp = tmp + 1 | 0;
    }
    var tmp_2 = tmp_1;
    var gridOuter = new FloatArray2(width, height, isFloatArray(tmp_2) ? tmp_2 : THROW_CCE());
    // Inline function 'korlibs.datastructure.Companion.invoke' call
    var width_0 = out.n2d();
    var height_0 = out.o2d();
    var tmp_3 = 0;
    var tmp_4 = imul(width_0, height_0);
    var tmp_5 = new Float32Array(tmp_4);
    while (tmp_3 < tmp_4) {
      tmp_5[tmp_3] = 0.0;
      tmp_3 = tmp_3 + 1 | 0;
    }
    var tmp_6 = tmp_5;
    var gridInner = new FloatArray2(width_0, height_0, isFloatArray(tmp_6) ? tmp_6 : THROW_CCE());
    var f = new Float32Array(size);
    var z = new Float32Array(size + 1 | 0);
    var v = _UShortArrayInt___init__impl__kdofb8(size);
    var inductionVariable = 0;
    var last = bmp.o2d();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = bmp.n2d();
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var a = _RGBA___get_af__impl__vu36qv(bmp.z3v(x, y));
            var x0 = x + buffer | 0;
            var y0 = y + buffer | 0;
            switch (a) {
              case 0.0:
                gridOuter.c2e(x0, y0, 1.0E10);
                gridInner.c2e(x0, y0, 0.0);
                break;
              case 1.0:
                gridOuter.c2e(x0, y0, 0.0);
                gridInner.c2e(x0, y0, 1.0E10);
                break;
              default:
                var d = 0.5 - a;
                gridOuter.c2e(x0, y0, d > 0.0 ? d * d : 0.0);
                gridInner.c2e(x0, y0, d < 0.0 ? d * d : 0.0);
                break;
            }
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    this.j43(gridOuter.a2e_1, 0, 0, out.n2d(), out.o2d(), gridOuter.n2d(), f, v, z);
    this.j43(gridInner.a2e_1, buffer, buffer, bmp.n2d(), bmp.o2d(), gridInner.n2d(), f, v, z);
    var inductionVariable_1 = 0;
    var last_1 = out.o2d();
    if (inductionVariable_1 < last_1)
      do {
        var y_0 = inductionVariable_1;
        inductionVariable_1 = inductionVariable_1 + 1 | 0;
        var inductionVariable_2 = 0;
        var last_2 = out.n2d();
        if (inductionVariable_2 < last_2)
          do {
            var x_0 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            var gout = gridOuter.a24(x_0, y_0);
            var gin = gridInner.a24(x_0, y_0);
            // Inline function 'kotlin.math.sqrt' call
            var tmp_7 = Math.sqrt(gout);
            // Inline function 'kotlin.math.sqrt' call
            var d_0 = tmp_7 - Math.sqrt(gin);
            var a_0 = toIntRound(255 - 255 * (d_0 / radius + cutoff));
            out.x3v(x_0, y_0, Companion_getInstance_23().c43(255, 255, 255, clamp(a_0, 0, 255)));
          }
           while (inductionVariable_2 < last_2);
      }
       while (inductionVariable_1 < last_1);
    return new Result(out, buffer, radius, cutoff);
  }
  k43(bmp, maxSide, buffer, radius, cutoff, $super) {
    var tmp;
    if (maxSide === VOID) {
      // Inline function 'kotlin.math.max' call
      var a = bmp.n2d();
      var b = bmp.o2d();
      tmp = Math.max(a, b);
    } else {
      tmp = maxSide;
    }
    maxSide = tmp;
    buffer = buffer === VOID ? divCeil(maxSide, 8) : buffer;
    radius = radius === VOID ? divCeil(maxSide, 3) : radius;
    cutoff = cutoff === VOID ? 0.5 : cutoff;
    return $super === VOID ? this.i43(bmp, maxSide, buffer, radius, cutoff) : $super.i43.call(this, bmp, maxSide, buffer, radius, cutoff);
  }
  j43(data, x0, y0, width, height, gridSize, f, v, z) {
    var inductionVariable = x0;
    var last = x0 + width | 0;
    if (inductionVariable < last)
      do {
        var x = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        this.l43(data, imul(y0, gridSize) + x | 0, gridSize, height, f, v, z);
      }
       while (inductionVariable < last);
    var inductionVariable_0 = y0;
    var last_0 = y0 + height | 0;
    if (inductionVariable_0 < last_0)
      do {
        var y = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        this.l43(data, imul(y, gridSize) + x0 | 0, 1, width, f, v, z);
      }
       while (inductionVariable_0 < last_0);
  }
  l43(grid, offset, stride, length, f, v, z) {
    UShortArrayInt__set_impl_38wgvc(v, 0, 0);
    z[0] = -1.0E10;
    z[1] = 1.0E10;
    f[0] = grid[offset];
    var k = 0;
    var s = 0.0;
    var inductionVariable = 1;
    if (inductionVariable < length)
      do {
        var q = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        f[q] = grid[offset + imul(q, stride) | 0];
        var q2 = imul(q, q);
        $l$1: do {
          $l$0: do {
            var r = UShortArrayInt__get_impl_ciz20k(v, k);
            s = (f[q] - f[r] + q2 - imul(r, r)) / (q - r | 0) / 2.0;
          }
           while (false);
          var tmp;
          if (s <= z[k]) {
            k = k - 1 | 0;
            tmp = k > -1;
          } else {
            tmp = false;
          }
        }
         while (tmp);
        k = k + 1 | 0;
        UShortArrayInt__set_impl_38wgvc(v, k, q);
        z[k] = s;
        z[k + 1 | 0] = 1.0E10;
      }
       while (inductionVariable < length);
    k = 0;
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < length)
      do {
        var q_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        while (z[k + 1 | 0] < q_0) {
          k = k + 1 | 0;
        }
        var r_0 = UShortArrayInt__get_impl_ciz20k(v, k);
        var qr = q_0 - r_0 | 0;
        grid[offset + imul(q_0, stride) | 0] = f[r_0] + imul(qr, qr);
      }
       while (inductionVariable_0 < length);
  }
}
class ColorFormat32 {
  constructor() {
    this.q43_1 = 32;
  }
  x3m() {
    return this.q43_1;
  }
}
class ColorFormat24 {
  constructor() {
    this.r43_1 = 24;
  }
  x3m() {
    return this.r43_1;
  }
}
class ColorTransformMul {
  constructor(_r, _g, _b, _a) {
    _r = _r === VOID ? 1.0 : _r;
    _g = _g === VOID ? 1.0 : _g;
    _b = _b === VOID ? 1.0 : _b;
    _a = _a === VOID ? 1.0 : _a;
    this.s43_1 = _r;
    this.t43_1 = _g;
    this.u43_1 = _b;
    this.v43_1 = _a;
    this.w43_1 = true;
    this.x43_1 = Colors_getInstance().k3n_1;
  }
  y43() {
    return this.s43_1;
  }
  z43() {
    return this.t43_1;
  }
  a44() {
    return this.u43_1;
  }
  b44(value) {
    this.v43_1 = value;
    this.w43_1 = true;
  }
  c44() {
    return this.v43_1;
  }
  d44(v) {
    this.e44(_RGBA___get_rf__impl__kvz75k(v), _RGBA___get_gf__impl__5gcu1f(v), _RGBA___get_bf__impl__1xz5yg(v), _RGBA___get_af__impl__vu36qv(v));
    this.x43_1 = v;
    this.w43_1 = false;
  }
  f44() {
    if (this.w43_1) {
      this.w43_1 = false;
      this.x43_1 = Companion_getInstance_23().h3z(this.s43_1, this.t43_1, this.u43_1, this.v43_1);
    }
    return this.x43_1;
  }
  e44(r, g, b, a) {
    this.s43_1 = r;
    this.t43_1 = g;
    this.u43_1 = b;
    this.v43_1 = a;
    this.w43_1 = true;
  }
  g44(other) {
    return this.e44(other.s43_1, other.t43_1, other.u43_1, other.v43_1);
  }
  h44(a, b) {
    return this.e44(a.y43() * b.y43(), a.z43() * b.z43(), a.a44() * b.a44(), a.c44() * b.c44());
  }
  toString() {
    return 'ColorTransformMul(_r=' + this.s43_1 + ', _g=' + this.t43_1 + ', _b=' + this.u43_1 + ', _a=' + this.v43_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.s43_1);
    result = imul(result, 31) + getNumberHashCode(this.t43_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u43_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v43_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorTransformMul))
      return false;
    var tmp0_other_with_cast = other instanceof ColorTransformMul ? other : THROW_CCE();
    if (!equals(this.s43_1, tmp0_other_with_cast.s43_1))
      return false;
    if (!equals(this.t43_1, tmp0_other_with_cast.t43_1))
      return false;
    if (!equals(this.u43_1, tmp0_other_with_cast.u43_1))
      return false;
    if (!equals(this.v43_1, tmp0_other_with_cast.v43_1))
      return false;
    return true;
  }
}
class Colors {
  constructor() {
    Colors_instance = this;
    this.k3n_1 = Companion_getInstance_23().c43(255, 255, 255, 255);
    this.l3n_1 = Companion_getInstance_23().c43(0, 0, 0, 255);
    this.m3n_1 = Companion_getInstance_23().c43(255, 0, 0, 255);
    this.n3n_1 = Companion_getInstance_23().c43(0, 255, 0, 255);
    this.o3n_1 = Companion_getInstance_23().c43(0, 0, 255, 255);
    this.p3n_1 = Companion_getInstance_23().c43(0, 0, 0, 0);
    this.q3n_1 = Companion_getInstance_23().c43(255, 255, 255, 0);
    this.r3n_1 = Companion_getInstance_23().i44(240, 248, 255);
    this.s3n_1 = Companion_getInstance_23().i44(250, 235, 215);
    this.t3n_1 = Companion_getInstance_23().i44(0, 255, 255);
    this.u3n_1 = Companion_getInstance_23().i44(127, 255, 212);
    this.v3n_1 = Companion_getInstance_23().i44(240, 255, 255);
    this.w3n_1 = Companion_getInstance_23().i44(245, 245, 220);
    this.x3n_1 = Companion_getInstance_23().i44(255, 228, 196);
    this.y3n_1 = Companion_getInstance_23().i44(255, 235, 205);
    this.z3n_1 = Companion_getInstance_23().i44(138, 43, 226);
    this.a3o_1 = Companion_getInstance_23().i44(165, 42, 42);
    this.b3o_1 = Companion_getInstance_23().i44(222, 184, 135);
    this.c3o_1 = Companion_getInstance_23().i44(95, 158, 160);
    this.d3o_1 = Companion_getInstance_23().i44(127, 255, 0);
    this.e3o_1 = Companion_getInstance_23().i44(210, 105, 30);
    this.f3o_1 = Companion_getInstance_23().i44(255, 127, 80);
    this.g3o_1 = Companion_getInstance_23().i44(100, 149, 237);
    this.h3o_1 = Companion_getInstance_23().i44(255, 248, 220);
    this.i3o_1 = Companion_getInstance_23().i44(220, 20, 60);
    this.j3o_1 = Companion_getInstance_23().i44(0, 0, 139);
    this.k3o_1 = Companion_getInstance_23().i44(0, 255, 255);
    this.l3o_1 = Companion_getInstance_23().i44(0, 139, 139);
    this.m3o_1 = Companion_getInstance_23().i44(184, 134, 11);
    this.n3o_1 = Companion_getInstance_23().i44(169, 169, 169);
    this.o3o_1 = Companion_getInstance_23().i44(0, 100, 0);
    this.p3o_1 = Companion_getInstance_23().i44(169, 169, 169);
    this.q3o_1 = Companion_getInstance_23().i44(189, 183, 107);
    this.r3o_1 = Companion_getInstance_23().i44(255, 0, 255);
    this.s3o_1 = Companion_getInstance_23().i44(139, 0, 139);
    this.t3o_1 = Companion_getInstance_23().i44(85, 107, 47);
    this.u3o_1 = Companion_getInstance_23().i44(255, 140, 0);
    this.v3o_1 = Companion_getInstance_23().i44(153, 50, 204);
    this.w3o_1 = Companion_getInstance_23().i44(139, 0, 0);
    this.x3o_1 = Companion_getInstance_23().i44(233, 150, 122);
    this.y3o_1 = Companion_getInstance_23().i44(143, 188, 143);
    this.z3o_1 = Companion_getInstance_23().i44(72, 61, 139);
    this.a3p_1 = Companion_getInstance_23().i44(47, 79, 79);
    this.b3p_1 = Companion_getInstance_23().i44(47, 79, 79);
    this.c3p_1 = Companion_getInstance_23().i44(0, 206, 209);
    this.d3p_1 = Companion_getInstance_23().i44(148, 0, 211);
    this.e3p_1 = Companion_getInstance_23().i44(255, 20, 147);
    this.f3p_1 = Companion_getInstance_23().i44(0, 191, 255);
    this.g3p_1 = Companion_getInstance_23().i44(105, 105, 105);
    this.h3p_1 = Companion_getInstance_23().i44(105, 105, 105);
    this.i3p_1 = Companion_getInstance_23().i44(30, 144, 255);
    this.j3p_1 = Companion_getInstance_23().i44(178, 34, 34);
    this.k3p_1 = Companion_getInstance_23().i44(255, 250, 240);
    this.l3p_1 = Companion_getInstance_23().i44(34, 139, 34);
    this.m3p_1 = Companion_getInstance_23().i44(255, 0, 255);
    this.n3p_1 = Companion_getInstance_23().i44(220, 220, 220);
    this.o3p_1 = Companion_getInstance_23().i44(248, 248, 255);
    this.p3p_1 = Companion_getInstance_23().i44(255, 215, 0);
    this.q3p_1 = Companion_getInstance_23().i44(218, 165, 32);
    this.r3p_1 = Companion_getInstance_23().i44(173, 255, 47);
    this.s3p_1 = Companion_getInstance_23().i44(240, 255, 240);
    this.t3p_1 = Companion_getInstance_23().i44(255, 105, 180);
    this.u3p_1 = Companion_getInstance_23().i44(205, 92, 92);
    this.v3p_1 = Companion_getInstance_23().i44(75, 0, 130);
    this.w3p_1 = Companion_getInstance_23().i44(255, 255, 240);
    this.x3p_1 = Companion_getInstance_23().i44(240, 230, 140);
    this.y3p_1 = Companion_getInstance_23().i44(230, 230, 250);
    this.z3p_1 = Companion_getInstance_23().i44(255, 240, 245);
    this.a3q_1 = Companion_getInstance_23().i44(124, 252, 0);
    this.b3q_1 = Companion_getInstance_23().i44(255, 250, 205);
    this.c3q_1 = Companion_getInstance_23().i44(173, 216, 230);
    this.d3q_1 = Companion_getInstance_23().i44(240, 128, 128);
    this.e3q_1 = Companion_getInstance_23().i44(224, 255, 255);
    this.f3q_1 = Companion_getInstance_23().i44(250, 250, 210);
    this.g3q_1 = Companion_getInstance_23().i44(211, 211, 211);
    this.h3q_1 = Companion_getInstance_23().i44(144, 238, 144);
    this.i3q_1 = Companion_getInstance_23().i44(211, 211, 211);
    this.j3q_1 = Companion_getInstance_23().i44(255, 182, 193);
    this.k3q_1 = Companion_getInstance_23().i44(255, 160, 122);
    this.l3q_1 = Companion_getInstance_23().i44(32, 178, 170);
    this.m3q_1 = Companion_getInstance_23().i44(135, 206, 250);
    this.n3q_1 = Companion_getInstance_23().i44(119, 136, 153);
    this.o3q_1 = Companion_getInstance_23().i44(119, 136, 153);
    this.p3q_1 = Companion_getInstance_23().i44(176, 196, 222);
    this.q3q_1 = Companion_getInstance_23().i44(255, 255, 224);
    this.r3q_1 = Companion_getInstance_23().i44(0, 255, 0);
    this.s3q_1 = Companion_getInstance_23().i44(50, 205, 50);
    this.t3q_1 = Companion_getInstance_23().i44(250, 240, 230);
    this.u3q_1 = Companion_getInstance_23().i44(128, 0, 0);
    this.v3q_1 = Companion_getInstance_23().i44(102, 205, 170);
    this.w3q_1 = Companion_getInstance_23().i44(0, 0, 205);
    this.x3q_1 = Companion_getInstance_23().i44(186, 85, 211);
    this.y3q_1 = Companion_getInstance_23().i44(147, 112, 219);
    this.z3q_1 = Companion_getInstance_23().i44(60, 179, 113);
    this.a3r_1 = Companion_getInstance_23().i44(123, 104, 238);
    this.b3r_1 = Companion_getInstance_23().i44(0, 250, 154);
    this.c3r_1 = Companion_getInstance_23().i44(72, 209, 204);
    this.d3r_1 = Companion_getInstance_23().i44(199, 21, 133);
    this.e3r_1 = Companion_getInstance_23().i44(25, 25, 112);
    this.f3r_1 = Companion_getInstance_23().i44(245, 255, 250);
    this.g3r_1 = Companion_getInstance_23().i44(255, 228, 225);
    this.h3r_1 = Companion_getInstance_23().i44(255, 228, 181);
    this.i3r_1 = Companion_getInstance_23().i44(255, 222, 173);
    this.j3r_1 = Companion_getInstance_23().i44(0, 0, 128);
    this.k3r_1 = Companion_getInstance_23().i44(253, 245, 230);
    this.l3r_1 = Companion_getInstance_23().i44(128, 128, 0);
    this.m3r_1 = Companion_getInstance_23().i44(107, 142, 35);
    this.n3r_1 = Companion_getInstance_23().i44(255, 165, 0);
    this.o3r_1 = Companion_getInstance_23().i44(255, 69, 0);
    this.p3r_1 = Companion_getInstance_23().i44(218, 112, 214);
    this.q3r_1 = Companion_getInstance_23().i44(238, 232, 170);
    this.r3r_1 = Companion_getInstance_23().i44(152, 251, 152);
    this.s3r_1 = Companion_getInstance_23().i44(175, 238, 238);
    this.t3r_1 = Companion_getInstance_23().i44(219, 112, 147);
    this.u3r_1 = Companion_getInstance_23().i44(255, 239, 213);
    this.v3r_1 = Companion_getInstance_23().i44(255, 218, 185);
    this.w3r_1 = Companion_getInstance_23().i44(205, 133, 63);
    this.x3r_1 = Companion_getInstance_23().i44(255, 192, 203);
    this.y3r_1 = Companion_getInstance_23().i44(221, 160, 221);
    this.z3r_1 = Companion_getInstance_23().i44(176, 224, 230);
    this.a3s_1 = Companion_getInstance_23().i44(128, 0, 128);
    this.b3s_1 = Companion_getInstance_23().i44(188, 143, 143);
    this.c3s_1 = Companion_getInstance_23().i44(65, 105, 225);
    this.d3s_1 = Companion_getInstance_23().i44(139, 69, 19);
    this.e3s_1 = Companion_getInstance_23().i44(250, 128, 114);
    this.f3s_1 = Companion_getInstance_23().i44(244, 164, 96);
    this.g3s_1 = Companion_getInstance_23().i44(46, 139, 87);
    this.h3s_1 = Companion_getInstance_23().i44(255, 245, 238);
    this.i3s_1 = Companion_getInstance_23().i44(160, 82, 45);
    this.j3s_1 = Companion_getInstance_23().i44(192, 192, 192);
    this.k3s_1 = Companion_getInstance_23().i44(135, 206, 235);
    this.l3s_1 = Companion_getInstance_23().i44(106, 90, 205);
    this.m3s_1 = Companion_getInstance_23().i44(112, 128, 144);
    this.n3s_1 = Companion_getInstance_23().i44(112, 128, 144);
    this.o3s_1 = Companion_getInstance_23().i44(255, 250, 250);
    this.p3s_1 = Companion_getInstance_23().i44(0, 255, 127);
    this.q3s_1 = Companion_getInstance_23().i44(70, 130, 180);
    this.r3s_1 = Companion_getInstance_23().i44(210, 180, 140);
    this.s3s_1 = Companion_getInstance_23().i44(0, 128, 128);
    this.t3s_1 = Companion_getInstance_23().i44(216, 191, 216);
    this.u3s_1 = Companion_getInstance_23().i44(255, 99, 71);
    this.v3s_1 = Companion_getInstance_23().i44(64, 224, 208);
    this.w3s_1 = Companion_getInstance_23().i44(238, 130, 238);
    this.x3s_1 = Companion_getInstance_23().i44(245, 222, 179);
    this.y3s_1 = Companion_getInstance_23().i44(245, 245, 245);
    this.z3s_1 = Companion_getInstance_23().i44(154, 205, 50);
    this.a3t_1 = Companion_getInstance_23().i44(255, 255, 0);
    this.b3t_1 = mapOf([to('black', new RGBA(this.l3n_1)), to('white', new RGBA(this.k3n_1)), to('red', new RGBA(this.m3n_1)), to('green', new RGBA(this.n3n_1)), to('blue', new RGBA(this.o3n_1)), to('aliceblue', new RGBA(this.r3n_1)), to('antiquewhite', new RGBA(this.s3n_1)), to('aqua', new RGBA(this.t3n_1)), to('aquamarine', new RGBA(this.u3n_1)), to('azure', new RGBA(this.v3n_1)), to('beige', new RGBA(this.w3n_1)), to('bisque', new RGBA(this.x3n_1)), to('blanchedalmond', new RGBA(this.y3n_1)), to('blueviolet', new RGBA(this.z3n_1)), to('brown', new RGBA(this.a3o_1)), to('burlywood', new RGBA(this.b3o_1)), to('cadetblue', new RGBA(this.c3o_1)), to('chartreuse', new RGBA(this.d3o_1)), to('chocolate', new RGBA(this.e3o_1)), to('coral', new RGBA(this.f3o_1)), to('cornflowerblue', new RGBA(this.g3o_1)), to('cornsilk', new RGBA(this.h3o_1)), to('crimson', new RGBA(this.i3o_1)), to('cyan', new RGBA(this.k3o_1)), to('darkblue', new RGBA(this.j3o_1)), to('darkcyan', new RGBA(this.l3o_1)), to('darkgoldenrod', new RGBA(this.m3o_1)), to('darkgray', new RGBA(this.n3o_1)), to('darkgreen', new RGBA(this.o3o_1)), to('darkgrey', new RGBA(this.p3o_1)), to('darkkhaki', new RGBA(this.q3o_1)), to('darkmagenta', new RGBA(this.s3o_1)), to('darkolivegreen', new RGBA(this.t3o_1)), to('darkorange', new RGBA(this.u3o_1)), to('darkorchid', new RGBA(this.v3o_1)), to('darkred', new RGBA(this.w3o_1)), to('darksalmon', new RGBA(this.x3o_1)), to('darkseagreen', new RGBA(this.y3o_1)), to('darkslateblue', new RGBA(this.z3o_1)), to('darkslategray', new RGBA(this.a3p_1)), to('darkslategrey', new RGBA(this.b3p_1)), to('darkturquoise', new RGBA(this.c3p_1)), to('darkviolet', new RGBA(this.d3p_1)), to('deeppink', new RGBA(this.e3p_1)), to('deepskyblue', new RGBA(this.f3p_1)), to('dimgray', new RGBA(this.g3p_1)), to('dimgrey', new RGBA(this.h3p_1)), to('dodgerblue', new RGBA(this.i3p_1)), to('firebrick', new RGBA(this.j3p_1)), to('floralwhite', new RGBA(this.k3p_1)), to('forestgreen', new RGBA(this.l3p_1)), to('fuchsia', new RGBA(this.m3p_1)), to('gainsboro', new RGBA(this.n3p_1)), to('ghostwhite', new RGBA(this.o3p_1)), to('gold', new RGBA(this.p3p_1)), to('goldenrod', new RGBA(this.q3p_1)), to('greenyellow', new RGBA(this.r3p_1)), to('honeydew', new RGBA(this.s3p_1)), to('hotpink', new RGBA(this.t3p_1)), to('indianred', new RGBA(this.u3p_1)), to('indigo', new RGBA(this.v3p_1)), to('ivory', new RGBA(this.w3p_1)), to('khaki', new RGBA(this.x3p_1)), to('lavender', new RGBA(this.y3p_1)), to('lavenderblush', new RGBA(this.z3p_1)), to('lawngreen', new RGBA(this.a3q_1)), to('lemonchiffon', new RGBA(this.b3q_1)), to('lightblue', new RGBA(this.c3q_1)), to('lightcoral', new RGBA(this.d3q_1)), to('lightcyan', new RGBA(this.e3q_1)), to('lightgoldenrodyellow', new RGBA(this.f3q_1)), to('lightgray', new RGBA(this.g3q_1)), to('lightgreen', new RGBA(this.h3q_1)), to('lightgrey', new RGBA(this.i3q_1)), to('lightpink', new RGBA(this.j3q_1)), to('lightsalmon', new RGBA(this.k3q_1)), to('lightseagreen', new RGBA(this.l3q_1)), to('lightskyblue', new RGBA(this.m3q_1)), to('lightslategray', new RGBA(this.n3q_1)), to('lightslategrey', new RGBA(this.o3q_1)), to('lightsteelblue', new RGBA(this.p3q_1)), to('lightyellow', new RGBA(this.q3q_1)), to('lime', new RGBA(this.r3q_1)), to('limegreen', new RGBA(this.s3q_1)), to('linen', new RGBA(this.t3q_1)), to('magenta', new RGBA(this.r3o_1)), to('maroon', new RGBA(this.u3q_1)), to('mediumaquamarine', new RGBA(this.v3q_1)), to('mediumblue', new RGBA(this.w3q_1)), to('mediumorchid', new RGBA(this.x3q_1)), to('mediumpurple', new RGBA(this.y3q_1)), to('mediumseagreen', new RGBA(this.z3q_1)), to('mediumslateblue', new RGBA(this.a3r_1)), to('mediumspringgreen', new RGBA(this.b3r_1)), to('mediumturquoise', new RGBA(this.c3r_1)), to('mediumvioletred', new RGBA(this.d3r_1)), to('midnightblue', new RGBA(this.e3r_1)), to('mintcream', new RGBA(this.f3r_1)), to('mistyrose', new RGBA(this.g3r_1)), to('moccasin', new RGBA(this.h3r_1)), to('navajowhite', new RGBA(this.i3r_1)), to('navy', new RGBA(this.j3r_1)), to('oldlace', new RGBA(this.k3r_1)), to('olive', new RGBA(this.l3r_1)), to('olivedrab', new RGBA(this.m3r_1)), to('orange', new RGBA(this.n3r_1)), to('orangered', new RGBA(this.o3r_1)), to('orchid', new RGBA(this.p3r_1)), to('palegoldenrod', new RGBA(this.q3r_1)), to('palegreen', new RGBA(this.r3r_1)), to('paleturquoise', new RGBA(this.s3r_1)), to('palevioletred', new RGBA(this.t3r_1)), to('papayawhip', new RGBA(this.u3r_1)), to('peachpuff', new RGBA(this.v3r_1)), to('peru', new RGBA(this.w3r_1)), to('pink', new RGBA(this.x3r_1)), to('plum', new RGBA(this.y3r_1)), to('powderblue', new RGBA(this.z3r_1)), to('purple', new RGBA(this.a3s_1)), to('rosybrown', new RGBA(this.b3s_1)), to('royalblue', new RGBA(this.c3s_1)), to('saddlebrown', new RGBA(this.d3s_1)), to('salmon', new RGBA(this.e3s_1)), to('sandybrown', new RGBA(this.f3s_1)), to('seagreen', new RGBA(this.g3s_1)), to('seashell', new RGBA(this.h3s_1)), to('sienna', new RGBA(this.i3s_1)), to('silver', new RGBA(this.j3s_1)), to('skyblue', new RGBA(this.k3s_1)), to('slateblue', new RGBA(this.l3s_1)), to('slategray', new RGBA(this.m3s_1)), to('slategrey', new RGBA(this.n3s_1)), to('snow', new RGBA(this.o3s_1)), to('springgreen', new RGBA(this.p3s_1)), to('steelblue', new RGBA(this.q3s_1)), to('tan', new RGBA(this.r3s_1)), to('teal', new RGBA(this.s3s_1)), to('thistle', new RGBA(this.t3s_1)), to('tomato', new RGBA(this.u3s_1)), to('turquoise', new RGBA(this.v3s_1)), to('violet', new RGBA(this.w3s_1)), to('wheat', new RGBA(this.x3s_1)), to('whitesmoke', new RGBA(this.y3s_1)), to('yellowgreen', new RGBA(this.z3s_1)), to('yellow', new RGBA(this.a3t_1))]);
  }
  j44(str) {
    return this.k44(str, this.p3n_1, true);
  }
  k44(str, default_0, errorOnDefault) {
    try {
      if (startsWith(str, '#')) {
        var hex = substr(str, 1);
        if (!setOf([3, 4, 6, 8]).w2(hex.length))
          return this.l3n_1;
        var chars = hex.length < 6 ? 1 : 2;
        var scale = hex.length < 6 ? 255.0 / 15.0 : 1.0;
        var hasAlpha = (hex.length / chars | 0) >= 4;
        var r = numberToInt(toInt(substr_0(hex, imul(0, chars), chars), 16) * scale);
        var g = numberToInt(toInt(substr_0(hex, imul(1, chars), chars), 16) * scale);
        var b = numberToInt(toInt(substr_0(hex, imul(2, chars), chars), 16) * scale);
        var a = hasAlpha ? numberToInt(toInt(substr_0(hex, imul(3, chars), chars), 16) * scale) : 255;
        return Companion_getInstance_23().c43(r, g, b, a);
      } else if (startsWith(str, 'RGBA(', true)) {
        // Inline function 'kotlin.text.toUpperCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$1 = str.toUpperCase();
        var parts = split(removeSuffix(removePrefix(tmp$ret$1, 'RGBA('), ')'), [',']);
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp;
        if (0 <= 0 ? 0 < parts.d1() : false) {
          tmp = parts.c1(0);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp = '0';
        }
        var tmp$ret$3 = tmp;
        var tmp0_elvis_lhs = toIntOrNull(tmp$ret$3);
        var r_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_0;
        if (0 <= 1 ? 1 < parts.d1() : false) {
          tmp_0 = parts.c1(1);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_0 = '0';
        }
        var tmp$ret$5 = tmp_0;
        var tmp1_elvis_lhs = toIntOrNull(tmp$ret$5);
        var g_0 = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_1;
        if (0 <= 2 ? 2 < parts.d1() : false) {
          tmp_1 = parts.c1(2);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_1 = '0';
        }
        var tmp$ret$7 = tmp_1;
        var tmp2_elvis_lhs = toIntOrNull(tmp$ret$7);
        var b_0 = tmp2_elvis_lhs == null ? 0 : tmp2_elvis_lhs;
        // Inline function 'kotlin.collections.getOrElse' call
        // Inline function 'kotlin.contracts.contract' call
        var tmp_2;
        if (0 <= 3 ? 3 < parts.d1() : false) {
          tmp_2 = parts.c1(3);
        } else {
          // Inline function 'korlibs.image.color.Colors.get.<anonymous>' call
          tmp_2 = '1.0';
        }
        var tmp$ret$9 = tmp_2;
        var tmp3_elvis_lhs = toDoubleOrNull(tmp$ret$9);
        var af = tmp3_elvis_lhs == null ? 1.0 : tmp3_elvis_lhs;
        return Companion_getInstance_23().c43(r_0, g_0, b_0, numberToInt(af * 255));
      } else {
        // Inline function 'kotlin.text.toLowerCase' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = str.toLowerCase();
        var tmp_3 = this.b3t_1.b3(tmp$ret$11);
        var col = tmp_3 == null ? null : tmp_3.l44_1;
        var tmp_4;
        var tmp_5 = col;
        if ((tmp_5 == null ? null : new RGBA(tmp_5)) == null) {
          tmp_4 = errorOnDefault;
        } else {
          tmp_4 = false;
        }
        if (tmp_4)
          return this.m44('#' + str, default_0);
        var tmp_6;
        var tmp_7 = col;
        if ((tmp_7 == null ? null : new RGBA(tmp_7)) == null) {
          tmp_6 = default_0;
        } else {
          tmp_6 = col;
        }
        return tmp_6;
      }
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
        return Colors_getInstance().m3n_1;
      } else {
        throw $p;
      }
    }
  }
  m44(str, default_0, errorOnDefault, $super) {
    errorOnDefault = errorOnDefault === VOID ? false : errorOnDefault;
    return $super === VOID ? this.k44(str, default_0, errorOnDefault) : $super.k44.call(this, str, new RGBA(default_0), errorOnDefault).l44_1;
  }
}
class RGB extends ColorFormat24 {
  constructor(rOffset, gOffset, bOffset) {
    Companion_getInstance_21();
    super();
    this.o44_1 = rOffset;
    this.p44_1 = gOffset;
    this.q44_1 = bOffset;
  }
  m43(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.o44_1 | 0) & 255;
  }
  n43(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.p44_1 | 0) & 255;
  }
  o43(v) {
    // Inline function 'korlibs.memory.extract8' call
    return (v >>> this.q44_1 | 0) & 255;
  }
  p43(v) {
    return 255;
  }
}
class Companion_4 extends RGB {
  constructor() {
    Companion_instance_10 = null;
    super(0, 8, 16);
    Companion_instance_10 = this;
  }
}
class Companion_5 {
  t3x(size) {
    return _RgbaArray___init__impl__oib4y4(new Int32Array(size));
  }
}
class RgbaArray {
  constructor(ints) {
    this.r44_1 = ints;
  }
  m1(fromIndex, toIndex) {
    return RgbaArray__subList_impl_rbyi98(this.r44_1, fromIndex, toIndex);
  }
  s44(elements) {
    return RgbaArray__containsAll_impl_l6gz5c(this.r44_1, elements);
  }
  x2(elements) {
    return RgbaArray__containsAll_impl_l6gz5c_0(this, elements);
  }
  f1() {
    return RgbaArray__isEmpty_impl_nch3ip(this.r44_1);
  }
  z() {
    return RgbaArray__iterator_impl_5wfwsm(this.r44_1);
  }
  y2() {
    return RgbaArray__listIterator_impl_m4kjt0(this.r44_1);
  }
  o1(index) {
    return RgbaArray__listIterator_impl_m4kjt0_0(this.r44_1, index);
  }
  d1() {
    return _RgbaArray___get_size__impl__imxef8(this.r44_1);
  }
  t44(index) {
    return RgbaArray__get_impl_nzyo1o(this.r44_1, index);
  }
  c1(index) {
    return RgbaArray__get_impl_nzyo1o_0(this, index);
  }
  toString() {
    return RgbaArray__toString_impl_vgvk04(this.r44_1);
  }
  hashCode() {
    return RgbaArray__hashCode_impl_ht2l65(this.r44_1);
  }
  equals(other) {
    return RgbaArray__equals_impl_6qvuf(this.r44_1, other);
  }
}
class Companion_6 extends ColorFormat32 {
  constructor() {
    Companion_instance_12 = null;
    super();
    Companion_instance_12 = this;
    this.g3t_1 = 0;
    this.h3t_1 = 8;
    this.i3t_1 = 16;
    this.j3t_1 = 24;
  }
  h3z(r, g, b, a) {
    return this.u44(f2i(r), f2i(g), f2i(b), f2i(a));
  }
  u44(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntUnchecked(r, g, b, a));
  }
  c43(r, g, b, a) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, a));
  }
  i44(r, g, b) {
    return _RGBA___init__impl__lqpay5(packIntClamped(r, g, b, 255));
  }
  v44(rgb, a) {
    return _RGBA___init__impl__lqpay5(rgb & 16777215 | a << 24);
  }
  m43(v) {
    return _RGBA___get_r__impl__duz7mo(_RGBA___init__impl__lqpay5(v));
  }
  n43(v) {
    return _RGBA___get_g__impl__o8pukr(_RGBA___init__impl__lqpay5(v));
  }
  o43(v) {
    return _RGBA___get_b__impl__m6tl80(_RGBA___init__impl__lqpay5(v));
  }
  p43(v) {
    return _RGBA___get_a__impl__6msvu7(_RGBA___init__impl__lqpay5(v));
  }
  w44(c1, c2, factor256) {
    return _RGBA___init__impl__lqpay5(this.x44(_RGBA___get_value__impl__hhco8v(c1), _RGBA___get_value__impl__hhco8v(c2), factor256));
  }
  x44(c1, c2, factor256) {
    var ifactor256 = 256 - factor256 | 0;
    return ((imul(c1 & 16711935, ifactor256) + imul(c2 & 16711935, factor256) | 0) & -16711936 | (imul(c1 & 65280, ifactor256) + imul(c2 & 65280, factor256) | 0) & 16711680) >>> 8 | 0;
  }
  y44(c1, c2, factor) {
    return this.w44(c1, c2, numberToInt(Ratio__toFloat_impl_1ftup5(factor) * 256));
  }
  z44(c1, c2, factor) {
    return Companion_getInstance_23().v44(_RGBA___get_rgb__impl__tijaqt(this.y44(c1, c2, factor)), blendComponent(this, _RGBA___get_a__impl__6msvu7(c1), _RGBA___get_a__impl__6msvu7(c2), factor));
  }
  k3t(c00, c10, c01, c11, factorX, factorY) {
    var c1 = this.z44(c00, c10, factorX);
    var c2 = this.z44(c01, c11, factorX);
    return this.z44(c1, c2, factorY);
  }
  b43(dst, src) {
    var srcA = _RGBA___get_a__impl__6msvu7(src);
    var iSrcA = 255 - srcA | 0;
    switch (srcA) {
      case 0:
        return dst;
      case 255:
        return src;
      default:
        return Companion_getInstance_23().v44(_RGBA___get_rgb__impl__tijaqt(this.w44(dst, src, srcA + 1 | 0)), clampUByte(srcA + (imul(_RGBA___get_a__impl__6msvu7(dst), iSrcA) / 255 | 0) | 0));
    }
  }
  a45(src, dst, ratio) {
    return Companion_getInstance_23().c43(interpolate(ratio, _RGBA___get_r__impl__duz7mo(src), _RGBA___get_r__impl__duz7mo(dst)), interpolate(ratio, _RGBA___get_g__impl__o8pukr(src), _RGBA___get_g__impl__o8pukr(dst)), interpolate(ratio, _RGBA___get_b__impl__m6tl80(src), _RGBA___get_b__impl__m6tl80(dst)), interpolate(ratio, _RGBA___get_a__impl__6msvu7(src), _RGBA___get_a__impl__6msvu7(dst)));
  }
}
class RGBA {
  constructor(value) {
    Companion_getInstance_23();
    this.l44_1 = value;
  }
  qw() {
    return RGBA__clone_impl_w007z0(this.l44_1);
  }
  toString() {
    return RGBA__toString_impl_4lw6dp(this.l44_1);
  }
  b45(other) {
    return RGBA__compareTo_impl_lrfjc1(this.l44_1, other);
  }
  d(other) {
    return RGBA__compareTo_impl_lrfjc1_0(this, other);
  }
  hashCode() {
    return RGBA__hashCode_impl_h59qf6(this.l44_1);
  }
  equals(other) {
    return RGBA__equals_impl_4vjmca(this.l44_1, other);
  }
}
class Companion_7 {
  constructor() {
    this.c45_1 = 16711935;
    this.d45_1 = -16711936;
  }
  e45(dst, src) {
    return _RGBAPremultiplied___init__impl__uos02x(sumPacked4MulR(_RGBAPremultiplied___get_value__impl__bqfhud(src), _RGBAPremultiplied___get_value__impl__bqfhud(dst), 256 - _RGBAPremultiplied___get_a__impl__f0hnd1(src) | 0));
  }
}
class Companion_8 {
  f45(size) {
    return _RgbaPremultipliedArray___init__impl__lx83hy(new Int32Array(size));
  }
}
class RgbaPremultipliedArray {
  constructor(ints) {
    this.g45_1 = ints;
  }
  toString() {
    return RgbaPremultipliedArray__toString_impl_seal6e(this.g45_1);
  }
  hashCode() {
    return RgbaPremultipliedArray__hashCode_impl_kvnjzv(this.g45_1);
  }
  equals(other) {
    return RgbaPremultipliedArray__equals_impl_vav5d5(this.g45_1, other);
  }
}
class Companion_9 {
  h45(f, s) {
    return insert(insert(0, f, 0, 16), s, 16, 16);
  }
}
class Companion_10 {}
class Kerning {
  constructor(first, second, amount) {
    this.q45_1 = first;
    this.r45_1 = second;
    this.s45_1 = amount;
  }
}
class Glyph {
  constructor(fontSize, id, texture, xoffset, yoffset, xadvance) {
    this.i45_1 = fontSize;
    this.j45_1 = id;
    this.k45_1 = texture;
    this.l45_1 = xoffset;
    this.m45_1 = yoffset;
    this.n45_1 = xadvance;
    var tmp = this;
    tmp.o45_1 = lazy(BitmapFont$Glyph$bmp$delegate$lambda(this));
    this.p45_1 = new GlyphMetrics(this.i45_1, true, -1, Companion_getInstance_5().n29(this.l45_1, this.m45_1, this.k45_1.w38_1, this.k45_1.x38_1), this.n45_1);
  }
  t45() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o45_1;
    bmp$factory();
    return this_0.t1();
  }
  toString() {
    return 'Glyph(fontSize=' + this.i45_1 + ', id=' + this.j45_1 + ', texture=' + this.k45_1.toString() + ', xoffset=' + this.l45_1 + ', yoffset=' + this.m45_1 + ', xadvance=' + this.n45_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.i45_1);
    result = imul(result, 31) + this.j45_1 | 0;
    result = imul(result, 31) + this.k45_1.hashCode() | 0;
    result = imul(result, 31) + this.l45_1 | 0;
    result = imul(result, 31) + this.m45_1 | 0;
    result = imul(result, 31) + this.n45_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Glyph))
      return false;
    var tmp0_other_with_cast = other instanceof Glyph ? other : THROW_CCE();
    if (!equals(this.i45_1, tmp0_other_with_cast.i45_1))
      return false;
    if (!(this.j45_1 === tmp0_other_with_cast.j45_1))
      return false;
    if (!this.k45_1.equals(tmp0_other_with_cast.k45_1))
      return false;
    if (!(this.l45_1 === tmp0_other_with_cast.l45_1))
      return false;
    if (!(this.m45_1 === tmp0_other_with_cast.m45_1))
      return false;
    if (!(this.n45_1 === tmp0_other_with_cast.n45_1))
      return false;
    return true;
  }
}
class Font {}
function getOrNull_2() {
  return this;
}
function getFontMetrics$default(size, metrics, $super) {
  metrics = metrics === VOID ? new FontMetrics() : metrics;
  return $super === VOID ? this.d46(size, metrics) : $super.d46.call(this, size, metrics);
}
function getGlyphMetrics$default(size, codePoint, metrics, reader, $super) {
  metrics = metrics === VOID ? new GlyphMetrics() : metrics;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.p46(size, codePoint, metrics, reader) : $super.p46.call(this, size, codePoint, metrics, reader);
}
function renderGlyph$default(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw, $super) {
  reader = reader === VOID ? null : reader;
  beforeDraw = beforeDraw === VOID ? null : beforeDraw;
  return $super === VOID ? this.a47(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) : $super.a47.call(this, ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw);
}
class BitmapFont {}
function get_baseBmp() {
  return get_bmp(this.a46().k45_1);
}
function getFontMetrics(size, metrics) {
  return metrics.n46(this.b46(), size);
}
function getGlyphMetrics(size, codePoint, metrics, reader) {
  var tmp38_safe_receiver = this.q46(codePoint);
  var tmp0_elvis_lhs = tmp38_safe_receiver == null ? null : tmp38_safe_receiver.p45_1;
  return metrics.w46(tmp0_elvis_lhs == null ? this.c46() : tmp0_elvis_lhs, size, codePoint);
}
function getTextScale(size) {
  return size / this.u45();
}
function get_0(charCode) {
  var tmp0_elvis_lhs = this.q46(charCode);
  var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.q46(32) : tmp0_elvis_lhs;
  return tmp1_elvis_lhs == null ? this.a46() : tmp1_elvis_lhs;
}
function renderGlyph(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  var scale = this.z46(size);
  var tmp0_elvis_lhs = this.x45().c1(codePoint);
  var tmp;
  if (tmp0_elvis_lhs == null) {
    return false;
  } else {
    tmp = tmp0_elvis_lhs;
  }
  var g = tmp;
  // Inline function 'kotlin.takeIf' call
  var this_0 = this.p46(size, codePoint, metrics, reader);
  // Inline function 'kotlin.contracts.contract' call
  var tmp_0;
  // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
  if (this_0.s46_1) {
    tmp_0 = this_0;
  } else {
    tmp_0 = null;
  }
  if (tmp_0 == null)
    return false;
  if (metrics.n2d() === 0.0 && metrics.o2d() === 0.0)
    return false;
  var texX = pos.h21_1 + metrics.k22();
  var texY = pos.i21_1 + metrics.m22();
  var swidth = metrics.n2d();
  var sheight = metrics.o2d();
  var tmp_1;
  if (equals(ctx.x47(), new RGBA(get_DefaultPaint()))) {
    tmp_1 = g.t45();
  } else {
    // Inline function 'korlibs.image.bitmap.context2d' call
    var this_1 = Bitmap32.z3l(g.t45().n2d(), g.t45().o2d(), VOID, true);
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_1.k3m_1;
    if (true) {
      this_1.l1o();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx_0 = this_1.c3u(true);
      try {
        // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>' call
        // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
        var t = ctx_0.h3u_1.b47_1;
        try {
          // Inline function 'korlibs.image.font.BitmapFont.renderGlyph.<anonymous>.<anonymous>' call
          ctx_0.w47(1.0 / scale);
          ctx_0.y47(ctx.x47());
          // Inline function 'korlibs.image.vector.Context2d.fillRect' call
          var width = ctx_0.n2d() * scale;
          var height = ctx_0.o2d() * scale;
          ctx_0.z47(numberToDouble(0), numberToDouble(0), numberToDouble(width), numberToDouble(height));
        }finally {
          ctx_0.h3u_1.b47_1 = t;
        }
      }finally {
        ctx_0.p11();
      }
    }finally {
      result = true ? this_1.u3m(rect) : 0;
    }
    var bmpFill = this_1;
    bmpFill.n3w(BitmapChannel_ALPHA_getInstance(), g.t45(), BitmapChannel_ALPHA_getInstance());
    tmp_1 = bmpFill;
  }
  var bmp = tmp_1;
  if (beforeDraw == null)
    null;
  else
    beforeDraw();
  ctx.a48(bmp, Vector2D.j21(texX, texY - metrics.n22()), Size2D.t29(swidth, sheight));
  return true;
}
function getKerning(size, leftCodePoint, rightCodePoint) {
  var tmp = this.z46(size);
  var tmp40_safe_receiver = this.y46(leftCodePoint, rightCodePoint);
  var tmp41_safe_receiver = tmp40_safe_receiver == null ? null : tmp40_safe_receiver.s45_1;
  var tmp0_elvis_lhs = tmp41_safe_receiver == null ? null : tmp41_safe_receiver;
  return tmp * (tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs);
}
class BitmapFontImpl {
  constructor(fontSize, lineHeight, base, glyphs, kernings, name, distanceField) {
    name = name === VOID ? 'BitmapFont' : name;
    distanceField = distanceField === VOID ? null : distanceField;
    this.d48_1 = new Mixin();
    this.e48_1 = fontSize;
    this.f48_1 = lineHeight;
    this.g48_1 = base;
    this.h48_1 = glyphs;
    this.i48_1 = kernings;
    this.j48_1 = name;
    this.k48_1 = distanceField;
    this.l48_1 = this.f48_1 - this.g48_1;
    var tmp = this;
    tmp.m48_1 = lazy(BitmapFontImpl$naturalFontMetrics$delegate$lambda(this));
    this.n48_1 = new GlyphMetrics(this.e48_1, false, 0, Companion_getInstance_5().d25(), 0.0);
    var tmp_0 = this;
    tmp_0.o48_1 = lazy(BitmapFontImpl$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.p48_1 = lazy(BitmapFontImpl$invalidGlyph$delegate$lambda(this));
  }
  tw(_set____db54di) {
    this.d48_1.tw(_set____db54di);
  }
  uw() {
    return this.d48_1.uw();
  }
  u45() {
    return this.e48_1;
  }
  v45() {
    return this.f48_1;
  }
  t2g() {
    return this.g48_1;
  }
  x45() {
    return this.h48_1;
  }
  y45() {
    return this.i48_1;
  }
  n3() {
    return this.j48_1;
  }
  w45() {
    return this.k48_1;
  }
  xx() {
    return this;
  }
  b46() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.m48_1;
    naturalFontMetrics$factory();
    return this_0.t1();
  }
  c46() {
    return this.n48_1;
  }
  y46(first, second) {
    return this.i48_1.c1(Companion_instance_15.h45(first, second));
  }
  q46(codePoint) {
    return this.h48_1.c1(codePoint);
  }
  a46() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.o48_1;
    anyGlyph$factory();
    return this_0.t1();
  }
  q48() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.p48_1;
    invalidGlyph$factory();
    return this_0.t1();
  }
}
class TextToBitmapResult {
  constructor(bmp, fmetrics, metrics, glyphs, glyphsPerLine, shape) {
    shape = shape === VOID ? null : shape;
    this.g4b_1 = bmp;
    this.h4b_1 = fmetrics;
    this.i4b_1 = metrics;
    this.j4b_1 = glyphs;
    this.k4b_1 = glyphsPerLine;
    this.l4b_1 = shape;
  }
  toString() {
    return 'TextToBitmapResult(bmp=' + toString_0(this.g4b_1) + ', fmetrics=' + this.h4b_1.toString() + ', metrics=' + this.i4b_1.toString() + ', glyphs=' + toString_0(this.j4b_1) + ', glyphsPerLine=' + toString_0(this.k4b_1) + ', shape=' + toString(this.l4b_1) + ')';
  }
  hashCode() {
    var result = hashCode(this.g4b_1);
    result = imul(result, 31) + this.h4b_1.hashCode() | 0;
    result = imul(result, 31) + this.i4b_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.j4b_1) | 0;
    result = imul(result, 31) + hashCode(this.k4b_1) | 0;
    result = imul(result, 31) + (this.l4b_1 == null ? 0 : hashCode(this.l4b_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextToBitmapResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextToBitmapResult ? other : THROW_CCE();
    if (!equals(this.g4b_1, tmp0_other_with_cast.g4b_1))
      return false;
    if (!this.h4b_1.equals(tmp0_other_with_cast.h4b_1))
      return false;
    if (!this.i4b_1.equals(tmp0_other_with_cast.i4b_1))
      return false;
    if (!equals(this.j4b_1, tmp0_other_with_cast.j4b_1))
      return false;
    if (!equals(this.k4b_1, tmp0_other_with_cast.k4b_1))
      return false;
    if (!equals(this.l4b_1, tmp0_other_with_cast.l4b_1))
      return false;
    return true;
  }
}
class PlacedGlyphMetrics {
  constructor(codePoint, pos, metrics, fontMetrics, transform, index, nline) {
    this.x4b_1 = codePoint;
    this.y4b_1 = pos;
    this.z4b_1 = metrics;
    this.a4c_1 = fontMetrics;
    this.b4c_1 = transform;
    this.c4c_1 = index;
    this.d4c_1 = nline;
    var tmp = this;
    tmp.e4c_1 = lazy(PlacedGlyphMetrics$boundsPath$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.f4c_1 = lazy(PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.g4c_1 = lazy(PlacedGlyphMetrics$caretStart$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.h4c_1 = lazy(PlacedGlyphMetrics$caretEnd$delegate$lambda(this));
  }
  i4c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.e4c_1;
    boundsPath$factory();
    return this_0.t1();
  }
  j4c() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f4c_1;
    boundsPathCurves$factory();
    return this_0.t1();
  }
  toString() {
    return 'PlacedGlyphMetrics(codePoint=' + this.x4b_1 + ', pos=' + this.y4b_1.toString() + ', metrics=' + this.z4b_1.toString() + ', fontMetrics=' + this.a4c_1.toString() + ', transform=' + this.b4c_1.toString() + ', index=' + this.c4c_1 + ', nline=' + this.d4c_1 + ')';
  }
  hashCode() {
    var result = this.x4b_1;
    result = imul(result, 31) + this.y4b_1.hashCode() | 0;
    result = imul(result, 31) + this.z4b_1.hashCode() | 0;
    result = imul(result, 31) + this.a4c_1.hashCode() | 0;
    result = imul(result, 31) + this.b4c_1.hashCode() | 0;
    result = imul(result, 31) + this.c4c_1 | 0;
    result = imul(result, 31) + this.d4c_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PlacedGlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof PlacedGlyphMetrics ? other : THROW_CCE();
    if (!(this.x4b_1 === tmp0_other_with_cast.x4b_1))
      return false;
    if (!this.y4b_1.equals(tmp0_other_with_cast.y4b_1))
      return false;
    if (!this.z4b_1.equals(tmp0_other_with_cast.z4b_1))
      return false;
    if (!this.a4c_1.equals(tmp0_other_with_cast.a4c_1))
      return false;
    if (!this.b4c_1.equals(tmp0_other_with_cast.b4c_1))
      return false;
    if (!(this.c4c_1 === tmp0_other_with_cast.c4c_1))
      return false;
    if (!(this.d4c_1 === tmp0_other_with_cast.d4c_1))
      return false;
    return true;
  }
}
class TextMetricsResult {
  constructor(fmetrics, metrics, glyphs, glyphsPerLine) {
    fmetrics = fmetrics === VOID ? new FontMetrics() : fmetrics;
    metrics = metrics === VOID ? new TextMetrics() : metrics;
    glyphs = glyphs === VOID ? emptyList() : glyphs;
    glyphsPerLine = glyphsPerLine === VOID ? emptyList() : glyphsPerLine;
    this.k4c_1 = fmetrics;
    this.l4c_1 = metrics;
    this.m4c_1 = glyphs;
    this.n4c_1 = glyphsPerLine;
  }
  toString() {
    return 'TextMetricsResult(fmetrics=' + this.k4c_1.toString() + ', metrics=' + this.l4c_1.toString() + ', glyphs=' + toString_0(this.m4c_1) + ', glyphsPerLine=' + toString_0(this.n4c_1) + ')';
  }
  hashCode() {
    var result = this.k4c_1.hashCode();
    result = imul(result, 31) + this.l4c_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.m4c_1) | 0;
    result = imul(result, 31) + hashCode(this.n4c_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetricsResult))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetricsResult ? other : THROW_CCE();
    if (!this.k4c_1.equals(tmp0_other_with_cast.k4c_1))
      return false;
    if (!this.l4c_1.equals(tmp0_other_with_cast.l4c_1))
      return false;
    if (!equals(this.m4c_1, tmp0_other_with_cast.m4c_1))
      return false;
    if (!equals(this.n4c_1, tmp0_other_with_cast.n4c_1))
      return false;
    return true;
  }
}
class MultiplePlacedGlyphMetrics {
  constructor() {
    this.p4d_1 = FastArrayList.lx();
    this.q4d_1 = FastArrayList.lx();
  }
  d1() {
    return this.p4d_1.d1();
  }
  v4e(glyph) {
    // Inline function 'kotlin.collections.plusAssign' call
    this.p4d_1.f(glyph);
    while (this.q4d_1.d1() <= glyph.d4c_1) {
      this.q4d_1.f(FastArrayList.lx());
    }
    this.q4d_1.c1(glyph.d4c_1).f(glyph);
  }
}
class ITextRendererActions {}
function reset() {
  this.f4h(Companion_getInstance_7().v21_1);
}
function advance(x) {
  // Inline function 'korlibs.math.geom.Vector2D.plus' call
  var this_0 = this.bt();
  var that = Vector2D.j21(x, 0.0);
  var tmp$ret$0 = Vector2D.j21(this_0.h21_1 + that.h21_1, this_0.i21_1 + that.i21_1);
  this.f4h(tmp$ret$0);
}
function newLine(y, end) {
  this.f4h(Vector2D.j21(0.0, this.bt().i21_1 + y));
  var _unary__edvuaz = this.x4g();
  this.d4h(_unary__edvuaz + 1 | 0);
}
class TextRendererActions {
  constructor($box) {
    boxApply(this, $box);
    this.n4g_1 = new GlyphPath();
    this.o4g_1 = new GlyphMetrics();
    this.p4g_1 = new FontMetrics();
    this.q4g_1 = 0;
    this.s4g_1 = 0.0;
    this.t4g_1 = Companion_getInstance_7().v21_1;
    this.u4g_1 = Companion_getInstance_6().a25_1;
    this.v4g_1 = null;
    this.w4g_1 = Colors_getInstance().k3n_1;
  }
  v45() {
    return this.p4g_1.v45();
  }
  d4h(_set____db54di) {
    this.q4g_1 = _set____db54di;
  }
  x4g() {
    return this.q4g_1;
  }
  c4h() {
    var tmp = this.r4g_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('font');
    }
  }
  e4h(font, size) {
    this.r4g_1 = font;
    this.s4g_1 = size;
    font.d46(size, this.p4g_1);
  }
  f4h(_set____db54di) {
    this.t4g_1 = _set____db54di;
  }
  bt() {
    return this.t4g_1;
  }
  g4h(reader, codePoint) {
    return this.c4h().p46(this.s4g_1, codePoint, this.o4g_1, reader);
  }
  h4h(_set____db54di) {
    this.u4g_1 = _set____db54di;
  }
  a4h() {
    return this.u4g_1;
  }
  y46(leftCodePoint, rightCodePoint) {
    return this.c4h().c48(this.s4g_1, leftCodePoint, rightCodePoint);
  }
}
class drawText$actions$1 extends TextRendererActions {
  constructor($renderer, $text, $size, $fnt, $align, $pos, $ctx, $paint, $textRangeStart, $textRangeEnd, $doRender, $glyphs, $placed, $box) {
    if ($box === VOID)
      $box = {};
    $box.c4g_1 = $size;
    $box.d4g_1 = $align;
    $box.e4g_1 = $pos;
    $box.f4g_1 = $ctx;
    $box.g4g_1 = $paint;
    $box.h4g_1 = $textRangeStart;
    $box.i4g_1 = $textRangeEnd;
    $box.j4g_1 = $doRender;
    $box.k4g_1 = $glyphs;
    $box.l4g_1 = $placed;
    super($box);
    this.a4g_1 = measure($renderer, $text, $size, $fnt);
    this.b4g_1 = 0;
  }
  m4g(reader, codePoint) {
    var nline = this.x4g();
    var dx = this.a4g_1.y4g(this.d4g_1.m4e_1, nline);
    var dy = this.a4g_1.p4e(this.d4g_1.n4e_1, this.p4g_1);
    var px = this.bt().h21_1 + this.e4g_1.h21_1 - dx;
    var py = this.bt().i21_1 + this.e4g_1.i21_1 + dy;
    var tmp71_safe_receiver = this.f4g_1;
    if (tmp71_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
      var t = tmp71_safe_receiver.h3u_1.b47_1;
      try {
        // Inline function 'korlibs.image.font.<no name provided>.put.<anonymous>' call
        this.f4g_1.z4g(px, py);
        this.f4g_1.b4h(get_immutable(this.a4h()));
        var tmp0_elvis_lhs = this.v4g_1;
        var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.g4g_1 : tmp0_elvis_lhs;
        this.f4g_1.y47(tmp1_elvis_lhs == null ? NonePaint_instance : tmp1_elvis_lhs);
        var containsLower = this.h4g_1;
        var containsUpper = this.i4g_1;
        var containsArg = this.b4g_1;
        if (containsLower <= containsArg ? containsArg < containsUpper : false) {
          this.c4h().a47(this.f4g_1, this.c4g_1, codePoint, Companion_getInstance_7().v21_1, null, this.o4g_1, reader, this.j4g_1);
        }
        this.b4g_1 = this.b4g_1 + 1 | 0;
      }finally {
        tmp71_safe_receiver.h3u_1.b47_1 = t;
      }
    }
    if (!(this.k4g_1 == null)) {
      var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.j21(px, py), this.o4g_1.qw(), this.p4g_1.qw(), this.a4h(), this.k4g_1.d1(), nline);
      this.k4g_1.v4e(glyph);
    }
    var tmp72_safe_receiver = this.l4g_1;
    if (tmp72_safe_receiver == null)
      null;
    else
      tmp72_safe_receiver(this, codePoint, Vector2D.j21(px, py), this.c4g_1, this.o4g_1, this.p4g_1, this.a4h());
    return this.o4g_1;
  }
}
class GlyphPath {
  constructor(path, colorShape, bitmap, bitmapOffset, bitmapScale, transform, scale) {
    path = path === VOID ? new VectorPath() : path;
    colorShape = colorShape === VOID ? null : colorShape;
    bitmap = bitmap === VOID ? null : bitmap;
    bitmapOffset = bitmapOffset === VOID ? Vector2D.l24(0, 0) : bitmapOffset;
    bitmapScale = bitmapScale === VOID ? Scale.j2b(1, 1) : bitmapScale;
    transform = transform === VOID ? Companion_getInstance_6().d25() : transform;
    scale = scale === VOID ? 1.0 : scale;
    this.k4h_1 = path;
    this.l4h_1 = colorShape;
    this.m4h_1 = bitmap;
    this.n4h_1 = bitmapOffset;
    this.o4h_1 = bitmapScale;
    this.p4h_1 = transform;
    this.q4h_1 = scale;
  }
  r4h() {
    return this.m4h_1 == null && this.l4h_1 == null;
  }
  s4h(c) {
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = c.h3u_1.b47_1;
    try {
      // Inline function 'korlibs.image.font.GlyphPath.draw.<anonymous>' call
      c.b4h(this.p4h_1);
      if (!(this.m4h_1 == null)) {
        c.a48(ensureNotNull(this.m4h_1), this.n4h_1, toFloat(ensureNotNull(this.m4h_1).d1()).v2b(this.o4h_1));
      } else if (!(this.l4h_1 == null)) {
        c.t4h(ensureNotNull(this.l4h_1));
        c.o4d();
      } else {
        draw_1(c, this.k4h_1);
      }
    }finally {
      c.h3u_1.b47_1 = t;
    }
  }
  toString() {
    return 'GlyphPath(path=' + this.k4h_1.toString() + ', colorShape=' + toString(this.l4h_1) + ', bitmap=' + toString(this.m4h_1) + ', bitmapOffset=' + this.n4h_1.toString() + ', bitmapScale=' + this.o4h_1.toString() + ', transform=' + this.p4h_1.toString() + ', scale=' + this.q4h_1 + ')';
  }
  hashCode() {
    var result = this.k4h_1.hashCode();
    result = imul(result, 31) + (this.l4h_1 == null ? 0 : hashCode(this.l4h_1)) | 0;
    result = imul(result, 31) + (this.m4h_1 == null ? 0 : hashCode(this.m4h_1)) | 0;
    result = imul(result, 31) + this.n4h_1.hashCode() | 0;
    result = imul(result, 31) + this.o4h_1.hashCode() | 0;
    result = imul(result, 31) + this.p4h_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.q4h_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath ? other : THROW_CCE();
    if (!this.k4h_1.equals(tmp0_other_with_cast.k4h_1))
      return false;
    if (!equals(this.l4h_1, tmp0_other_with_cast.l4h_1))
      return false;
    if (!equals(this.m4h_1, tmp0_other_with_cast.m4h_1))
      return false;
    if (!this.n4h_1.equals(tmp0_other_with_cast.n4h_1))
      return false;
    if (!this.o4h_1.equals(tmp0_other_with_cast.o4h_1))
      return false;
    if (!this.p4h_1.equals(tmp0_other_with_cast.p4h_1))
      return false;
    if (!equals(this.q4h_1, tmp0_other_with_cast.q4h_1))
      return false;
    return true;
  }
}
class Companion_11 {
  constructor() {
    Companion_instance_17 = this;
    var tmp = this;
    // Inline function 'kotlin.intArrayOf' call
    // Inline function 'kotlin.code' call
    var this_0 = _Char___init__impl__6a9atx(32);
    var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
    tmp.u4h_1 = new Int32Array([tmp$ret$0]);
  }
}
class LazyBitmapFont {
  constructor(font, fontSize, distanceField) {
    Companion_getInstance_28();
    distanceField = distanceField === VOID ? null : distanceField;
    this.v4h_1 = new Mixin();
    this.w4h_1 = font;
    this.x4h_1 = fontSize;
    this.y4h_1 = distanceField;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = MutableAtlas.c3m(1024, 1024, 2);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.LazyBitmapFont.atlas.<anonymous>' call
    if (!(this.y4h_1 == null))
      this_0.e3l_1;
    else
      mipmaps(this_0.e3l_1);
    tmp.z4h_1 = this_0;
    this.a4i_1 = this.w4h_1.o46(this.x4h_1);
    this.b4i_1 = this.a4i_1.v45();
    this.c4i_1 = this.a4i_1.h46_1;
    this.d4i_1 = IntMap.i2k();
    this.e4i_1 = IntMap.i2k();
    var tmp_0 = this;
    tmp_0.f4i_1 = lazy(LazyBitmapFont$anyGlyph$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.g4i_1 = lazy(LazyBitmapFont$invalidGlyph$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.h4i_1 = lazy(LazyBitmapFont$naturalFontMetrics$delegate$lambda(this));
    this.i4i_1 = new GlyphMetrics(this.x4h_1, false, 0, Companion_getInstance_5().d25(), 0.0);
  }
  tw(_set____db54di) {
    this.v4h_1.tw(_set____db54di);
  }
  uw() {
    return this.v4h_1.uw();
  }
  u45() {
    return this.x4h_1;
  }
  w45() {
    return this.y4h_1;
  }
  v45() {
    return this.b4i_1;
  }
  t2g() {
    return this.c4i_1;
  }
  x45() {
    return this.d4i_1;
  }
  y45() {
    return this.e4i_1;
  }
  a46() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.f4i_1;
    anyGlyph$factory_0();
    return this_0.t1();
  }
  q48() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.g4i_1;
    invalidGlyph$factory_0();
    return this_0.t1();
  }
  n3() {
    return this.w4h_1.n3();
  }
  b46() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.h4i_1;
    naturalFontMetrics$factory_0();
    return this_0.t1();
  }
  c46() {
    return this.i4i_1;
  }
  y46(first, second) {
    var kerning = this.w4h_1.c48(this.x4h_1, first, second);
    var tmp;
    if (kerning === 0.0) {
      tmp = null;
    } else {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.e4i_1;
      var key = Companion_instance_15.h45(first, second);
      var res = this_0.c1(key);
      if (res == null) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.getKerning.<anonymous>' call
        var tmp$ret$0 = new Kerning(first, second, numberToInt(kerning));
        this_0.c2k(key, tmp$ret$0);
      }
      tmp = ensureNotNull(this_0.c1(key));
    }
    return tmp;
  }
  q46(codePoint) {
    if (this.d4i_1.c1(codePoint) == null) {
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(97);
      var tmp = Char__toInt_impl_vasixd(this_0);
      // Inline function 'kotlin.code' call
      var this_1 = _Char___init__impl__6a9atx(122);
      var tmp$ret$1 = Char__toInt_impl_vasixd(this_1);
      this.j4i(codePoint, numberRangeToNumber(tmp, tmp$ret$1));
      // Inline function 'kotlin.code' call
      var this_2 = _Char___init__impl__6a9atx(65);
      var tmp_0 = Char__toInt_impl_vasixd(this_2);
      // Inline function 'kotlin.code' call
      var this_3 = _Char___init__impl__6a9atx(90);
      var tmp$ret$3 = Char__toInt_impl_vasixd(this_3);
      this.j4i(codePoint, numberRangeToNumber(tmp_0, tmp$ret$3));
      // Inline function 'kotlin.code' call
      var this_4 = _Char___init__impl__6a9atx(48);
      var tmp_1 = Char__toInt_impl_vasixd(this_4);
      // Inline function 'kotlin.code' call
      var this_5 = _Char___init__impl__6a9atx(57);
      var tmp$ret$5 = Char__toInt_impl_vasixd(this_5);
      this.j4i(codePoint, numberRangeToNumber(tmp_1, tmp$ret$5));
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$6 = new Int32Array([codePoint]);
      this.k4i(tmp$ret$6);
    }
    return this.d4i_1.c1(codePoint);
  }
  j4i(codePoint, range) {
    var containsLower = range.c2_1;
    if (codePoint <= range.d2_1 ? containsLower <= codePoint : false) {
      // Inline function 'korlibs.datastructure.toIntList' call
      // Inline function 'kotlin.also' call
      var this_0 = IntArrayList.w2e(coerceAtLeast(range.l1() - range.k1() | 0, 0));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.toIntList.<anonymous>' call
      var inductionVariable = range.k1();
      var last = range.l1();
      if (inductionVariable <= last)
        do {
          var v = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this_0.c2f(v);
        }
         while (!(v === last));
      this.k4i(this_0.n2f());
    }
  }
  k4i(codePoints) {
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var this_0 = this.z4h_1.e3l_1;
    var rect = this_0.k3m_1;
    if (true) {
      this_0.l1o();
    }
    var result;
    try {
      // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>' call
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var n = 0;
      while (n < codePoints.length) {
        // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>' call
        var _unary__edvuaz = n;
        n = _unary__edvuaz + 1 | 0;
        var codePoint = codePoints[_unary__edvuaz];
        // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
        var this_1 = this.d4i_1;
        var res = this_1.c1(codePoint);
        if (res == null) {
          // Inline function 'korlibs.image.font.LazyBitmapFont.ensureCodePoints.<anonymous>.<anonymous>.<anonymous>' call
          var tmp;
          if (!(this.y4h_1 == null)) {
            // Inline function 'kotlin.math.max' call
            var b = toIntCeil_0(this.x4h_1 / 8.0);
            tmp = Math.max(4, b);
          } else {
            tmp = 1;
          }
          var border = tmp;
          var tmp83_$receiver = this.w4h_1;
          var tmp84_size = this.x4h_1;
          var tmp85_paint = Colors_getInstance().k3n_1;
          var result_0 = renderGlyphToBitmap(tmp83_$receiver, tmp84_size, codePoint, new RGBA(tmp85_paint), true, null, border);
          var bmp = result_0.g4b_1.s3m();
          var rbmp;
          switch (this.y4h_1) {
            case 'msdf':
              rbmp = msdfBmp(ensureNotNull(result_0.l4b_1).l4i(), bmp.n2d(), bmp.o2d());
              break;
            case 'sdf':
              rbmp = sdfBmp(ensureNotNull(result_0.l4b_1).l4i(), bmp.n2d(), bmp.o2d());
              break;
            default:
              rbmp = bmp;
              break;
          }
          var entry = this.z4h_1.e3m(rbmp, Unit_instance);
          var slice = entry.w3k_1.b3a(border, border, entry.w3k_1.w38_1 - border | 0, entry.w3k_1.x38_1 - border | 0);
          var g = first_0(result_0.j4b_1);
          var m = g.z4b_1;
          var xadvance = m.v46_1;
          var tmp$ret$1 = new Glyph(this.x4h_1, codePoint, slice, -toIntRound(g.y4b_1.h21_1) | 0, -toIntRound(g.y4b_1.i21_1) | 0, toIntRound(xadvance));
          this_1.c2k(codePoint, tmp$ret$1);
        }
        ensureNotNull(this_1.c1(codePoint));
      }
    }finally {
      result = true ? this_0.u3m(rect) : 0;
    }
  }
}
class FontMetrics {
  constructor(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    size = size === VOID ? 0.0 : size;
    top = top === VOID ? 0.0 : top;
    ascent = ascent === VOID ? 0.0 : ascent;
    baseline = baseline === VOID ? 0.0 : baseline;
    descent = descent === VOID ? 0.0 : descent;
    bottom = bottom === VOID ? 0.0 : bottom;
    lineGap = lineGap === VOID ? 0.0 : lineGap;
    maxWidth = maxWidth === VOID ? 0.0 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? 0.0 : unitsPerEm;
    this.e46_1 = size;
    this.f46_1 = top;
    this.g46_1 = ascent;
    this.h46_1 = baseline;
    this.i46_1 = descent;
    this.j46_1 = bottom;
    this.k46_1 = lineGap;
    this.l46_1 = maxWidth;
    this.m46_1 = unitsPerEm;
  }
  m4i() {
    // Inline function 'kotlin.math.max' call
    var a = this.g46_1;
    var b = this.f46_1;
    return Math.max(a, b);
  }
  n4i() {
    // Inline function 'kotlin.math.min' call
    var a = this.i46_1;
    var b = this.j46_1;
    return Math.min(a, b);
  }
  o4i() {
    return this.m4i() - this.n4i();
  }
  v45() {
    return this.o4i() + this.k46_1;
  }
  v4d(other) {
    return this.p4i(other, 1.0);
  }
  n46(other, size) {
    return this.p4i(other, size / other.e46_1);
  }
  p4i(other, scale) {
    this.e46_1 = other.e46_1 * scale;
    this.f46_1 = other.f46_1 * scale;
    this.g46_1 = other.g46_1 * scale;
    this.h46_1 = other.h46_1 * scale;
    this.i46_1 = other.i46_1 * scale;
    this.j46_1 = other.j46_1 * scale;
    this.k46_1 = other.k46_1 * scale;
    this.m46_1 = other.m46_1 * scale;
    this.l46_1 = other.l46_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.FontMetrics.toString.<anonymous>' call
    this_0.nb('FontMetrics(');
    this_0.nb('size=' + niceStr(this.e46_1, 1) + ', ');
    this_0.nb('top=' + niceStr(this.f46_1, 1) + ', ');
    this_0.nb('ascent=' + niceStr(this.g46_1, 1) + ', ');
    this_0.nb('baseline=' + niceStr(this.h46_1, 1) + ', ');
    this_0.nb('descent=' + niceStr(this.i46_1, 1) + ', ');
    this_0.nb('bottom=' + niceStr(this.j46_1, 1) + ', ');
    this_0.nb('lineGap=' + niceStr(this.k46_1, 1) + ', ');
    this_0.nb('unitsPerEm=' + niceStr(this.m46_1, 1) + ', ');
    this_0.nb('maxWidth=' + niceStr(this.l46_1, 1) + ', ');
    this_0.nb('lineHeight=' + niceStr(this.v45(), 1));
    this_0.nb(')');
    return this_0.toString();
  }
  qw() {
    return this.q4i();
  }
  r4i(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) {
    return new FontMetrics(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  q4i(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm, $super) {
    size = size === VOID ? this.e46_1 : size;
    top = top === VOID ? this.f46_1 : top;
    ascent = ascent === VOID ? this.g46_1 : ascent;
    baseline = baseline === VOID ? this.h46_1 : baseline;
    descent = descent === VOID ? this.i46_1 : descent;
    bottom = bottom === VOID ? this.j46_1 : bottom;
    lineGap = lineGap === VOID ? this.k46_1 : lineGap;
    maxWidth = maxWidth === VOID ? this.l46_1 : maxWidth;
    unitsPerEm = unitsPerEm === VOID ? this.m46_1 : unitsPerEm;
    return $super === VOID ? this.r4i(size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm) : $super.r4i.call(this, size, top, ascent, baseline, descent, bottom, lineGap, maxWidth, unitsPerEm);
  }
  hashCode() {
    var result = getNumberHashCode(this.e46_1);
    result = imul(result, 31) + getNumberHashCode(this.f46_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.g46_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.h46_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i46_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j46_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k46_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l46_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m46_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FontMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof FontMetrics ? other : THROW_CCE();
    if (!equals(this.e46_1, tmp0_other_with_cast.e46_1))
      return false;
    if (!equals(this.f46_1, tmp0_other_with_cast.f46_1))
      return false;
    if (!equals(this.g46_1, tmp0_other_with_cast.g46_1))
      return false;
    if (!equals(this.h46_1, tmp0_other_with_cast.h46_1))
      return false;
    if (!equals(this.i46_1, tmp0_other_with_cast.i46_1))
      return false;
    if (!equals(this.j46_1, tmp0_other_with_cast.j46_1))
      return false;
    if (!equals(this.k46_1, tmp0_other_with_cast.k46_1))
      return false;
    if (!equals(this.l46_1, tmp0_other_with_cast.l46_1))
      return false;
    if (!equals(this.m46_1, tmp0_other_with_cast.m46_1))
      return false;
    return true;
  }
}
class GlyphMetrics {
  constructor(size, existing, codePoint, bounds, xadvance) {
    size = size === VOID ? 0.0 : size;
    existing = existing === VOID ? false : existing;
    codePoint = codePoint === VOID ? 0 : codePoint;
    bounds = bounds === VOID ? Companion_getInstance_5().d25() : bounds;
    xadvance = xadvance === VOID ? 0.0 : xadvance;
    this.r46_1 = size;
    this.s46_1 = existing;
    this.t46_1 = codePoint;
    this.u46_1 = bounds;
    this.v46_1 = xadvance;
  }
  n22() {
    return this.u46_1.n22();
  }
  k22() {
    return this.u46_1.k22();
  }
  m22() {
    return this.u46_1.m22();
  }
  n2d() {
    return this.u46_1.f22_1;
  }
  o2d() {
    return this.u46_1.g22_1;
  }
  qw() {
    return this.s4i(VOID, VOID, VOID, this.u46_1.qw());
  }
  w46(other, size, codePoint) {
    return this.t4i(other, size / other.r46_1, codePoint);
  }
  t4i(other, scale, codePoint) {
    this.r46_1 = other.r46_1;
    this.s46_1 = other.s46_1;
    this.t46_1 = codePoint;
    this.u46_1 = other.u46_1.w29(scale);
    this.v46_1 = other.v46_1 * scale;
    return this;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.GlyphMetrics.toString.<anonymous>' call
    this_0.nb('GlyphMetrics(');
    this_0.nb('codePoint=' + this.t46_1 + " ('" + toString_1(numberToChar(this.t46_1)) + "'), ");
    this_0.nb('existing=' + this.s46_1 + ', ');
    this_0.nb('xadvance=' + roundToInt(this.v46_1) + ', ');
    this_0.nb('bounds=' + this.u46_1.i2().toString());
    this_0.nb(')');
    return this_0.toString();
  }
  u4i(size, existing, codePoint, bounds, xadvance) {
    return new GlyphMetrics(size, existing, codePoint, bounds, xadvance);
  }
  s4i(size, existing, codePoint, bounds, xadvance, $super) {
    size = size === VOID ? this.r46_1 : size;
    existing = existing === VOID ? this.s46_1 : existing;
    codePoint = codePoint === VOID ? this.t46_1 : codePoint;
    bounds = bounds === VOID ? this.u46_1 : bounds;
    xadvance = xadvance === VOID ? this.v46_1 : xadvance;
    return $super === VOID ? this.u4i(size, existing, codePoint, bounds, xadvance) : $super.u4i.call(this, size, existing, codePoint, bounds, xadvance);
  }
  hashCode() {
    var result = getNumberHashCode(this.r46_1);
    result = imul(result, 31) + getBooleanHashCode(this.s46_1) | 0;
    result = imul(result, 31) + this.t46_1 | 0;
    result = imul(result, 31) + this.u46_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.v46_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphMetrics ? other : THROW_CCE();
    if (!equals(this.r46_1, tmp0_other_with_cast.r46_1))
      return false;
    if (!(this.s46_1 === tmp0_other_with_cast.s46_1))
      return false;
    if (!(this.t46_1 === tmp0_other_with_cast.t46_1))
      return false;
    if (!this.u46_1.equals(tmp0_other_with_cast.u46_1))
      return false;
    if (!equals(this.v46_1, tmp0_other_with_cast.v46_1))
      return false;
    return true;
  }
}
class TextMetrics {
  constructor(bounds, lineBounds, fontMetrics, nlines) {
    bounds = bounds === VOID ? Companion_getInstance_5().d25() : bounds;
    lineBounds = lineBounds === VOID ? emptyList() : lineBounds;
    fontMetrics = fontMetrics === VOID ? new FontMetrics() : fontMetrics;
    nlines = nlines === VOID ? 0 : nlines;
    this.r4d_1 = bounds;
    this.s4d_1 = lineBounds;
    this.t4d_1 = fontMetrics;
    this.u4d_1 = nlines;
  }
  v4i() {
    var tmp0_elvis_lhs = firstOrNull_0(this.s4d_1);
    return tmp0_elvis_lhs == null ? Companion_getInstance_5().p22_1 : tmp0_elvis_lhs;
  }
  k22() {
    return this.r4d_1.k22();
  }
  m22() {
    return this.r4d_1.m22();
  }
  n2d() {
    return this.r4d_1.f22_1;
  }
  o2d() {
    return this.r4d_1.g22_1;
  }
  w4i() {
    return -this.k22();
  }
  x4i() {
    return this.v4i().g22_1 + this.v4i().m22();
  }
  u4e() {
    return this.t4d_1.g46_1;
  }
  toString() {
    return 'TextMetrics[' + get_niceStr_0(this.k22()) + ', ' + get_niceStr_0(this.m22()) + ', ' + get_niceStr_0(this.n2d()) + ', ' + get_niceStr_0(this.o2d()) + '][' + get_niceStr_0(this.w4i()) + ', ' + get_niceStr_0(this.x4i()) + ']';
  }
  hashCode() {
    var result = this.r4d_1.hashCode();
    result = imul(result, 31) + hashCode(this.s4d_1) | 0;
    result = imul(result, 31) + this.t4d_1.hashCode() | 0;
    result = imul(result, 31) + this.u4d_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof TextMetrics ? other : THROW_CCE();
    if (!this.r4d_1.equals(tmp0_other_with_cast.r4d_1))
      return false;
    if (!equals(this.s4d_1, tmp0_other_with_cast.s4d_1))
      return false;
    if (!this.t4d_1.equals(tmp0_other_with_cast.t4d_1))
      return false;
    if (!(this.u4d_1 === tmp0_other_with_cast.u4d_1))
      return false;
    return true;
  }
}
class Companion_12 {
  constructor() {
    Companion_instance_18 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_0();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.VALUES_BY_ID.<anonymous>' call
      var tmp$ret$0 = element.a4j_1;
      destination.g3(tmp$ret$0, element);
    }
    tmp.b4j_1 = toIntMap(destination);
  }
  c1(id) {
    return this.b4j_1.c1(id);
  }
}
class GlyphPath_0 {
  constructor(path, advanceWidth) {
    this.c4j_1 = path;
    this.d4j_1 = advanceWidth;
  }
  toString() {
    return 'GlyphPath(path=' + this.c4j_1.toString() + ', advanceWidth=' + this.d4j_1 + ')';
  }
  hashCode() {
    var result = this.c4j_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.d4j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphPath_0))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphPath_0 ? other : THROW_CCE();
    if (!this.c4j_1.equals(tmp0_other_with_cast.c4j_1))
      return false;
    if (!equals(this.d4j_1, tmp0_other_with_cast.d4j_1))
      return false;
    return true;
  }
}
class CFFResult {
  constructor(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict) {
    this.e4j_1 = charstringsIndex;
    this.f4j_1 = globalSubrIndex;
    this.g4j_1 = localSubrsIndex;
    this.h4j_1 = privateDict;
    var tmp = this;
    var tmp90_safe_receiver = this.h4j_1.b3(Op_defaultWidthX_getInstance());
    var tmp91_safe_receiver = tmp90_safe_receiver == null ? null : firstOrNull_0(tmp90_safe_receiver);
    var tmp0_elvis_lhs = tmp91_safe_receiver == null ? null : numberToDouble(tmp91_safe_receiver);
    tmp.i4j_1 = tmp0_elvis_lhs == null ? 0.0 : tmp0_elvis_lhs;
    var tmp_0 = this;
    var tmp92_safe_receiver = this.h4j_1.b3(Op_nominalWidthX_getInstance());
    var tmp93_safe_receiver = tmp92_safe_receiver == null ? null : firstOrNull_0(tmp92_safe_receiver);
    var tmp0_elvis_lhs_0 = tmp93_safe_receiver == null ? null : numberToDouble(tmp93_safe_receiver);
    tmp_0.j4j_1 = tmp0_elvis_lhs_0 == null ? 0.0 : tmp0_elvis_lhs_0;
  }
  k4j(index, flipY) {
    var evalCtx = new EvalContext(this.f4j_1, this.g4j_1, this.i4j_1, this.j4j_1, index);
    var vp = new VectorPath();
    var bytes = this.e4j_1.c1(index);
    CharStringType2_instance.n4j(vp, openFastStream(bytes), evalCtx);
    if (flipY) {
      vp.i3g(1.0, -1.0);
    }
    return new GlyphPath_0(vp, evalCtx.x4j_1);
  }
  z4j(index, flipY, $super) {
    flipY = flipY === VOID ? true : flipY;
    return $super === VOID ? this.k4j(index, flipY) : $super.k4j.call(this, index, flipY);
  }
}
class DataIndex {
  static a4k(offsets, bytes) {
    var $this = createThis(this);
    $this.l4j_1 = offsets;
    $this.m4j_1 = bytes;
    return $this;
  }
  static b4k() {
    // Inline function 'kotlin.intArrayOf' call
    var tmp = new Int32Array([0]);
    // Inline function 'kotlin.byteArrayOf' call
    var tmp$ret$1 = new Int8Array([]);
    return this.a4k(tmp, tmp$ret$1);
  }
  d1() {
    return this.l4j_1.length - 1 | 0;
  }
  c4k(index) {
    return this.l4j_1[index + 1 | 0] - this.l4j_1[index] | 0;
  }
  c1(index) {
    return copyOfRange(this.m4j_1, this.l4j_1[index], this.l4j_1[index + 1 | 0]);
  }
  d4k() {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.d1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.font.DataIndex.toList.<anonymous>' call
      var tmp$ret$0 = this.c1(item);
      destination.f(tmp$ret$0);
    }
    return destination;
  }
  z() {
    return this.d4k().z();
  }
  toString() {
    var tmp = this.d1();
    var tmp_0 = toString_0(toList_0(this.l4j_1));
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, this.d1());
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.font.DataIndex.toString.<anonymous>' call
      var tmp$ret$0 = this.c4k(item);
      destination.f(tmp$ret$0);
    }
    return 'DataIndex[' + tmp + '](' + tmp_0 + ')(' + toString_0(destination) + ')';
  }
}
class Op extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.a4j_1 = id;
  }
}
class Companion_13 {
  constructor() {
    Companion_instance_19 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_1();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.Companion.MAP.<anonymous>' call
      var tmp$ret$0 = element.g4k_1;
      destination.g3(tmp$ret$0, element);
    }
    tmp.h4k_1 = toIntMap(destination);
  }
  c1(id) {
    var tmp0_elvis_lhs = this.h4k_1.c1(id);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'Unknown CFF CS2 operator ' + id;
      throw IllegalStateException.w4(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class EvalContext {
  constructor(globalSubrIndex, localSubrsIndex, defaultWidthX, nominalWidthX, index, heap) {
    globalSubrIndex = globalSubrIndex === VOID ? DataIndex.b4k() : globalSubrIndex;
    localSubrsIndex = localSubrsIndex === VOID ? DataIndex.b4k() : localSubrsIndex;
    defaultWidthX = defaultWidthX === VOID ? 0.0 : defaultWidthX;
    nominalWidthX = nominalWidthX === VOID ? 0.0 : nominalWidthX;
    index = index === VOID ? -1 : index;
    heap = heap === VOID ? new Float64Array(32) : heap;
    this.o4j_1 = globalSubrIndex;
    this.p4j_1 = localSubrsIndex;
    this.q4j_1 = defaultWidthX;
    this.r4j_1 = nominalWidthX;
    this.s4j_1 = index;
    this.t4j_1 = heap;
    this.u4j_1 = computeSubrBias(CharStringType2_instance, this.o4j_1.d1());
    this.v4j_1 = computeSubrBias(CharStringType2_instance, this.p4j_1.d1());
    this.w4j_1 = 0;
    this.x4j_1 = this.q4j_1;
    this.y4j_1 = false;
  }
}
class Op_0 extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.g4k_1 = id;
  }
}
class CFF {
  i4k(_this__u8e3s4) {
    this.j4k(_this__u8e3s4);
    var nameIndex = this.k4k(_this__u8e3s4);
    var topDictIndex = this.k4k(_this__u8e3s4);
    var topDictByte = topDictIndex.c1(0)[1];
    var topDict = this.l4k(openFastStream(topDictIndex.c1(0)));
    var stringIndex = this.k4k(_this__u8e3s4);
    var globalSubrIndex = this.k4k(_this__u8e3s4);
    var privateSizeOffset = topDict.b3(Op_Private_getInstance());
    var localSubrsIndex = DataIndex.b4k();
    var privateDict = emptyMap();
    if (!(privateSizeOffset == null)) {
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(privateSizeOffset, 10));
      var tmp0_iterator = privateSizeOffset.z();
      while (tmp0_iterator.a1()) {
        var item = tmp0_iterator.b1();
        // Inline function 'korlibs.image.font.CFF.readCFF.<anonymous>' call
        var tmp$ret$0 = numberToInt(item);
        destination.f(tmp$ret$0);
      }
      // Inline function 'kotlin.collections.component1' call
      var privateSize = destination.c1(0);
      // Inline function 'kotlin.collections.component2' call
      var privateOffset = destination.c1(1);
      privateDict = this.l4k(_this__u8e3s4.e1j(privateOffset, privateSize));
      var localSubrs = privateDict.b3(Op_Subrs_getInstance());
      if (!(localSubrs == null)) {
        var subrsOffset = privateOffset + numberToInt(last(localSubrs)) | 0;
        localSubrsIndex = this.k4k(_this__u8e3s4.f1j(subrsOffset));
      }
    }
    var charstringsOffsets = topDict.b3(Op_CharStrings_getInstance());
    var charstringsOffset = numberToInt(first_0(ensureNotNull(charstringsOffsets)));
    var charstringsIndex = this.k4k(_this__u8e3s4.f1j(charstringsOffset));
    return new CFFResult(charstringsIndex, globalSubrIndex, localSubrsIndex, privateDict);
  }
  j4k(_this__u8e3s4) {
    var versionMajor = _this__u8e3s4.k1j();
    var versionMinor = _this__u8e3s4.k1j();
    var headerSize = _this__u8e3s4.k1j();
    var offsetSize = _this__u8e3s4.k1j();
    if (versionMajor > 1) {
      // Inline function 'kotlin.error' call
      var message = 'Only supported CFF version 1';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'korlibs.logger.Logger.debug' call
    var this_0 = TtfCIDFont_getInstance().m4k_1;
    var level = Level_DEBUG_getInstance();
    var tmp;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.image.font.CFF.readHeader.<anonymous>' call
      var tmp$ret$0 = 'CFF.versionMajor/Minor: ' + versionMajor + '.' + versionMinor + ' : headerSize=' + headerSize + ', offsetSize=' + offsetSize;
      this_0.n2q(level, tmp$ret$0);
      tmp = Unit_instance;
    }
  }
  n4k(_this__u8e3s4) {
    return _this__u8e3s4.k1j();
  }
  o4k(_this__u8e3s4, offSize) {
    var roffSize = offSize < 0 ? this.n4k(_this__u8e3s4) : offSize;
    var tmp;
    switch (roffSize) {
      case 1:
        tmp = _this__u8e3s4.k1j();
        break;
      case 2:
        tmp = _this__u8e3s4.m1j();
        break;
      case 3:
        tmp = _this__u8e3s4.n1j();
        break;
      case 4:
        tmp = _this__u8e3s4.o1j();
        break;
      default:
        reserved('' + roffSize);
        break;
    }
    return tmp;
  }
  k4k(_this__u8e3s4) {
    var count = _this__u8e3s4.m1j();
    if (count === 0)
      return DataIndex.b4k();
    var offSize = this.n4k(_this__u8e3s4);
    // Inline function 'korlibs.datastructure.mapInt' call
    var this_0 = until(0, count + 1 | 0);
    // Inline function 'kotlin.also' call
    var this_1 = IntArrayList.w2e((coerceAtLeast(this_0.l1() - this_0.k1() | 0, 0) / this_0.e2_1 | 0) + 1 | 0);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
    var nestedFirst = this_0.k1();
    var nestedLast = this_0.l1();
    var stepArg = this_0.e2_1;
    if (stepArg <= 0)
      THROW_IAE('Step must be positive, was: ' + stepArg + '.');
    var inductionVariable = nestedFirst;
    var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
    if (inductionVariable <= last)
      do {
        var v = inductionVariable;
        inductionVariable = inductionVariable + stepArg | 0;
        // Inline function 'korlibs.image.font.CFF.readIndex.<anonymous>' call
        var tmp$ret$0 = CFF_instance.o4k(_this__u8e3s4, offSize) - 1 | 0;
        this_1.c2f(tmp$ret$0);
      }
       while (!(v === last));
    var offsets = this_1;
    var bytes = _this__u8e3s4.i1j(offsets.j2f());
    return DataIndex.a4k(offsets.n2f(), bytes);
  }
  l4k(_this__u8e3s4) {
    var map = LinkedHashMap.ac();
    // Inline function 'kotlin.collections.arrayListOf' call
    var values = ArrayList.p1();
    while (_this__u8e3s4.ks()) {
      var item = this.p4k(_this__u8e3s4);
      if (item instanceof Op) {
        // Inline function 'kotlin.collections.set' call
        var value = toList(values);
        map.g3(item, value);
        values.j3();
      } else {
        if (isNumber(item)) {
          values.f(item);
        }
      }
    }
    return map;
  }
  p4k(_this__u8e3s4) {
    var b0 = _this__u8e3s4.k1j();
    var tmp;
    if (0 <= b0 ? b0 <= 21 : false) {
      var tmp_0 = Companion_getInstance_29();
      tmp = tmp_0.c1(b0 === 12 ? b0 << 8 | _this__u8e3s4.k1j() : b0);
    } else if (22 <= b0 ? b0 <= 27 : false) {
      get_reserved();
    } else if (b0 === 28) {
      tmp = toShort(_this__u8e3s4.k1j() << 8 | _this__u8e3s4.k1j());
    } else if (b0 === 29) {
      tmp = _this__u8e3s4.k1j() << 24 | _this__u8e3s4.k1j() << 16 | _this__u8e3s4.k1j() << 8 | _this__u8e3s4.k1j();
    } else if (b0 === 30) {
      tmp = this.q4k(_this__u8e3s4, false);
    } else if (b0 === 31) {
      get_reserved();
    } else if (32 <= b0 ? b0 <= 246 : false) {
      tmp = b0 - 139 | 0;
    } else if (247 <= b0 ? b0 <= 250 : false) {
      tmp = (imul(b0 - 247 | 0, 256) + _this__u8e3s4.k1j() | 0) + 108 | 0;
    } else if (251 <= b0 ? b0 <= 254 : false) {
      tmp = ((-imul(b0 - 251 | 0, 256) | 0) - _this__u8e3s4.k1j() | 0) - 108 | 0;
    } else if (b0 === 255) {
      get_reserved();
    } else {
      get_unreachable();
    }
    return tmp;
  }
  r4k(_this__u8e3s4, readHeader) {
    if (readHeader) {
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(_this__u8e3s4.k1j() === 30)) {
        // Inline function 'kotlin.check.<anonymous>' call
        var message = 'Check failed.';
        throw IllegalStateException.w4(toString_0(message));
      }
    }
    var str = StringBuilder.h();
    end: while (true) {
      var byte = _this__u8e3s4.k1j();
      var inductionVariable = 0;
      if (inductionVariable <= 1)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var nibble = (byte >>> imul(1 - n | 0, 4) | 0) & 15;
          if (nibble === 15)
            break end;
          switch (nibble) {
            case 15:
              break end;
            case 12:
              str.nb('E-');
              break;
            default:
              str.ob((0 <= nibble ? nibble <= 9 : false) ? Char__plus_impl_qi7pgj(_Char___init__impl__6a9atx(48), nibble) : nibble === 10 ? _Char___init__impl__6a9atx(46) : nibble === 11 ? _Char___init__impl__6a9atx(69) : nibble === 14 ? _Char___init__impl__6a9atx(45) : _Char___init__impl__6a9atx(48));
              break;
          }
        }
         while (inductionVariable <= 1);
    }
    return str.toString();
  }
  q4k(_this__u8e3s4, readHeader) {
    return toDouble(this.r4k(_this__u8e3s4, readHeader));
  }
}
class CharStringType2 {
  s4k(_this__u8e3s4, value) {
    _this__u8e3s4.c2g(_this__u8e3s4.d1() - 1 | 0, value);
  }
  t4k(_this__u8e3s4) {
    return _this__u8e3s4.c1(_this__u8e3s4.d1() - 1 | 0);
  }
  u4k(_this__u8e3s4) {
    return _this__u8e3s4.f3(_this__u8e3s4.d1() - 1 | 0);
  }
  v4k(_this__u8e3s4, value) {
    _this__u8e3s4.g1y(value);
  }
  w4k(_this__u8e3s4, value) {
    _this__u8e3s4.g1y(value);
  }
  x4k(_this__u8e3s4) {
    var lastPoint = _this__u8e3s4.q3f();
    _this__u8e3s4.z5();
    _this__u8e3s4.n36(lastPoint);
  }
  y4k(_this__u8e3s4, x, y) {
    _this__u8e3s4.y3f(Vector2D.j21(x, y));
  }
  z4k(_this__u8e3s4, x, y) {
    _this__u8e3s4.z3f(Vector2D.j21(x, y));
  }
  a4l(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay) {
    _this__u8e3s4.o36(Vector2D.j21(fcx1, fcy1), Vector2D.j21(fcx2, fcy2), Vector2D.j21(fax, fay));
  }
  b4l(_this__u8e3s4, cx1, cy1, cx2, cy2, ax, ay) {
    var fcx1 = _this__u8e3s4.q3f().h21_1 + cx1;
    var fcy1 = _this__u8e3s4.q3f().i21_1 + cy1;
    var fcx2 = fcx1 + cx2;
    var fcy2 = fcy1 + cy2;
    var fax = fcx2 + ax;
    var fay = fcy2 + ay;
    this.a4l(_this__u8e3s4, fcx1, fcy1, fcx2, fcy2, fax, fay);
  }
  c4l(_this__u8e3s4, v, horizontal) {
    return this.y4k(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  d4l(_this__u8e3s4, v, horizontal) {
    return this.z4k(_this__u8e3s4, horizontal ? v : 0.0, !horizontal ? v : 0.0);
  }
  e4l(_this__u8e3s4) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CharStringType2.u8.<anonymous>' call
    return _this__u8e3s4.k1j();
  }
  f4l(ctx, s, evalCtx, stack, stackLevel) {
    while (s.ks()) {
      var v0 = this.e4l(s);
      if ((0 <= v0 ? v0 <= 27 : false) || (29 <= v0 ? v0 <= 31 : false)) {
        var tmp = Companion_getInstance_30();
        var op = tmp.c1(v0 === 12 ? v0 << 8 | this.e4l(s) : v0);
        switch (op.m3_1) {
          case 13:
            return Unit_instance;
          case 16:
            var tmp_0;
            // Inline function 'kotlin.collections.isNotEmpty' call

            if (!stack.f1()) {
              tmp_0 = !evalCtx.y4j_1;
            } else {
              tmp_0 = false;
            }

            if (tmp_0) {
              evalCtx.x4j_1 = stack.c1(0) + evalCtx.r4j_1;
              evalCtx.y4j_1 = true;
            }

            if (!(ctx.p3f() === 0)) {
              this.x4k(ctx);
            }

            return Unit_instance;
          case 11:
          case 40:
            var global = op.equals(Op_callgsubr_getInstance());
            var funcOffset = numberToInt(this.u4k(stack));
            var bytes = global ? evalCtx.o4j_1.c1(evalCtx.u4j_1 + funcOffset | 0) : evalCtx.p4j_1.c1(evalCtx.v4j_1 + funcOffset | 0);
            this.f4l(ctx, openFastStream(bytes), evalCtx, stack, stackLevel + 1 | 0);
            break;
          case 22:
            this.u4k(stack);
            break;
          case 38:
            // Inline function 'kotlin.also' call

            var this_0 = this.u4k(stack);
            // Inline function 'kotlin.contracts.contract' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            stack.v2f(this_0, this_0);
            break;
          case 39:
            stack.l2f(stack.d1() - 2 | 0, stack.d1() - 1 | 0);
            break;
          case 43:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          case 41:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          case 25:
            var index = this.u4k(stack);
            var value = this.u4k(stack);
            evalCtx.t4j_1[numberToInt(index)] = value;
            break;
          case 27:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var it = this.t4k(stack);
            var tmp$ret$3 = evalCtx.t4j_1[numberToInt(it)];
            this.s4k(stack, tmp$ret$3);
            break;
          case 2:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r = this.u4k(stack);
            var l = this.u4k(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$5 = !(l === 0.0) && !(r === 0.0) ? 1 : 0;
            this.v4k(stack, tmp$ret$5);
            break;
          case 4:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_0 = this.u4k(stack);
            var l_0 = this.u4k(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$7 = !(l_0 === 0.0) || !(r_0 === 0.0) ? 1 : 0;
            this.v4k(stack, tmp$ret$7);
            break;
          case 6:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$9 = this.t4k(stack) === 0.0 ? 1 : 0;
            this.s4k(stack, tmp$ret$9);
            break;
          case 19:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_1 = this.u4k(stack);
            var l_1 = this.u4k(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'korlibs.math.toInt' call

            var tmp$ret$11 = l_1 === r_1 ? 1 : 0;
            this.v4k(stack, tmp$ret$11);
            break;
          case 29:
            var v2 = this.u4k(stack);
            var v1 = this.u4k(stack);
            var s2 = this.u4k(stack);
            var s1 = this.u4k(stack);
            this.v4k(stack, v1 <= v2 ? s1 : s2);
            break;
          case 31:
            stack.g1y(Default_getInstance().im());
            break;
          case 36:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.sqrt' call

            var x = this.t4k(stack);
            var tmp$ret$13 = Math.sqrt(x);
            this.s4k(stack, tmp$ret$13);
            break;
          case 10:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            // Inline function 'kotlin.math.abs' call

            var x_0 = this.t4k(stack);
            var tmp$ret$15 = Math.abs(x_0);
            this.s4k(stack, tmp$ret$15);
            break;
          case 17:
            // Inline function 'korlibs.image.font.CharStringType2.unop' call

            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$16 = -this.t4k(stack);
            this.s4k(stack, tmp$ret$16);
            break;
          case 12:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_2 = this.u4k(stack);
            var l_2 = this.u4k(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$17 = l_2 + r_2;
            this.v4k(stack, tmp$ret$17);
            break;
          case 14:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_3 = this.u4k(stack);
            var l_3 = this.u4k(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$18 = l_3 - r_3;
            this.v4k(stack, tmp$ret$18);
            break;
          case 15:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_4 = this.u4k(stack);
            var l_4 = this.u4k(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$19 = l_4 / r_4;
            this.v4k(stack, tmp$ret$19);
            break;
          case 33:
            // Inline function 'korlibs.image.font.CharStringType2.binop' call

            var r_5 = this.u4k(stack);
            var l_5 = this.u4k(stack);
            // Inline function 'korlibs.image.font.CharStringType2.eval.<anonymous>' call

            var tmp$ret$20 = l_5 * r_5;
            this.v4k(stack, tmp$ret$20);
            break;
          case 26:
            if (stack.d1() > 2) {
              evalCtx.x4j_1 = stack.c1(0) + evalCtx.r4j_1;
              evalCtx.y4j_1 = true;
            }

            if (!(ctx.p3f() === 0)) {
              this.x4k(ctx);
            }

            this.y4k(ctx, stack.c1(stack.d1() - 2 | 0), stack.c1(stack.d1() - 1 | 0));
            stack.j3();
            break;
          case 3:
          case 28:
            if (stack.d1() > 1) {
              evalCtx.x4j_1 = stack.c1(0) + evalCtx.r4j_1;
              evalCtx.y4j_1 = true;
            }

            this.c4l(ctx, this.u4k(stack), op.equals(Op_hmoveto_getInstance()));
            stack.j3();
            break;
          case 5:
            var progression = step(until(0, stack.d1()), 2);
            var inductionVariable = progression.c2_1;
            var last = progression.d2_1;
            var step_0 = progression.e2_1;
            if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
              do {
                var n = inductionVariable;
                inductionVariable = inductionVariable + step_0 | 0;
                this.z4k(ctx, stack.c1(n), stack.c1(n + 1 | 0));
              }
               while (!(n === last));
            stack.j3();
            break;
          case 7:
          case 8:
            var toggle = op.equals(Op_hlineto_getInstance());
            var inductionVariable_0 = 0;
            var last_0 = stack.d1();
            if (inductionVariable_0 < last_0)
              do {
                var n_0 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                this.d4l(ctx, stack.c1(n_0), toggle);
                toggle = !toggle;
              }
               while (inductionVariable_0 < last_0);
            stack.j3();
            break;
          case 9:
          case 32:
          case 34:
            var n_1 = 0;
            if (op.equals(Op_rlinecurve_getInstance())) {
              while ((stack.d1() - n_1 | 0) < 6) {
                var _unary__edvuaz = n_1;
                n_1 = _unary__edvuaz + 1 | 0;
                var tmp_1 = stack.c1(_unary__edvuaz);
                var _unary__edvuaz_0 = n_1;
                n_1 = _unary__edvuaz_0 + 1 | 0;
                this.z4k(ctx, tmp_1, stack.c1(_unary__edvuaz_0));
              }
            }

            while ((stack.d1() - n_1 | 0) >= 6) {
              var _unary__edvuaz_1 = n_1;
              n_1 = _unary__edvuaz_1 + 1 | 0;
              var tmp_2 = stack.c1(_unary__edvuaz_1);
              var _unary__edvuaz_2 = n_1;
              n_1 = _unary__edvuaz_2 + 1 | 0;
              var tmp_3 = stack.c1(_unary__edvuaz_2);
              var _unary__edvuaz_3 = n_1;
              n_1 = _unary__edvuaz_3 + 1 | 0;
              var tmp_4 = stack.c1(_unary__edvuaz_3);
              var _unary__edvuaz_4 = n_1;
              n_1 = _unary__edvuaz_4 + 1 | 0;
              var tmp_5 = stack.c1(_unary__edvuaz_4);
              var _unary__edvuaz_5 = n_1;
              n_1 = _unary__edvuaz_5 + 1 | 0;
              var tmp_6 = stack.c1(_unary__edvuaz_5);
              var _unary__edvuaz_6 = n_1;
              n_1 = _unary__edvuaz_6 + 1 | 0;
              this.b4l(ctx, tmp_2, tmp_3, tmp_4, tmp_5, tmp_6, stack.c1(_unary__edvuaz_6));
            }

            if (op.equals(Op_rcurveline_getInstance())) {
              while (n_1 < stack.d1()) {
                var _unary__edvuaz_7 = n_1;
                n_1 = _unary__edvuaz_7 + 1 | 0;
                var tmp_7 = stack.c1(_unary__edvuaz_7);
                var _unary__edvuaz_8 = n_1;
                n_1 = _unary__edvuaz_8 + 1 | 0;
                this.z4k(ctx, tmp_7, stack.c1(_unary__edvuaz_8));
              }
            }

            stack.j3();
            break;
          case 35:
          case 37:
            var horizontal = op.equals(Op_hhcurveto_getInstance());
            var n_2 = 0;
            var tmp_8;
            if ((stack.d1() % 2 | 0) === 1) {
              var _unary__edvuaz_9 = n_2;
              n_2 = _unary__edvuaz_9 + 1 | 0;
              tmp_8 = stack.c1(_unary__edvuaz_9);
            } else {
              tmp_8 = 0.0;
            }

            var v = tmp_8;
            var initialY = horizontal ? v : 0.0;
            var initialX = horizontal ? 0.0 : v;
            if (!(((stack.d1() - n_2 | 0) % 4 | 0) === 0)) {
              // Inline function 'kotlin.error' call
              var message = 'Invalid number of operands';
              throw IllegalStateException.w4(toString_0(message));
            }

            while (n_2 < stack.d1()) {
              var _unary__edvuaz_10 = n_2;
              n_2 = _unary__edvuaz_10 + 1 | 0;
              var vv = stack.c1(_unary__edvuaz_10);
              var x1 = initialX + (horizontal ? vv : 0.0);
              var y1 = initialY + (horizontal ? 0.0 : vv);
              var _unary__edvuaz_11 = n_2;
              n_2 = _unary__edvuaz_11 + 1 | 0;
              var x2 = stack.c1(_unary__edvuaz_11);
              var _unary__edvuaz_12 = n_2;
              n_2 = _unary__edvuaz_12 + 1 | 0;
              var y2 = stack.c1(_unary__edvuaz_12);
              var _unary__edvuaz_13 = n_2;
              n_2 = _unary__edvuaz_13 + 1 | 0;
              var v1_0 = stack.c1(_unary__edvuaz_13);
              var lastX = horizontal ? v1_0 : 0.0;
              var lastY = horizontal ? 0.0 : v1_0;
              this.b4l(ctx, x1, y1, x2, y2, lastX, lastY);
              initialX = 0.0;
              initialY = 0.0;
            }

            stack.j3();
            break;
          case 42:
          case 44:
            reverse(stack);
            var toggle_0 = op.equals(Op_hvcurveto_getInstance());
            $l$loop: while (true) {
              // Inline function 'kotlin.collections.isNotEmpty' call
              if (!!stack.f1()) {
                break $l$loop;
              }
              var vv_0 = this.u4k(stack);
              var x1_0 = toggle_0 ? vv_0 : 0.0;
              var y1_0 = toggle_0 ? 0.0 : vv_0;
              var x2_0 = this.u4k(stack);
              var y2_0 = this.u4k(stack);
              var v1_1 = this.u4k(stack);
              var v2_0 = stack.d1() === 1 ? this.u4k(stack) : 0.0;
              var ax = toggle_0 ? v2_0 : v1_1;
              var ay = toggle_0 ? v1_1 : v2_0;
              this.b4l(ctx, x1_0, y1_0, x2_0, y2_0, ax, ay);
              toggle_0 = !toggle_0;
            }

            stack.j3();
            break;
          case 45:
          case 46:
          case 47:
          case 48:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          case 0:
          case 1:
          case 21:
          case 30:
          case 23:
          case 24:
            if (!((stack.d1() % 2 | 0) === 0) && !evalCtx.y4j_1) {
              var value_0 = stack.c1(0);
              evalCtx.x4j_1 = value_0 + evalCtx.r4j_1;
            }

            evalCtx.w4j_1 = evalCtx.w4j_1 + (stack.d1() >>> 1 | 0) | 0;
            evalCtx.y4j_1 = true;
            stack.j3();
            if (op.equals(Op_hintmask_getInstance()) || op.equals(Op_cntrmask_getInstance())) {
              var skipCount = (evalCtx.w4j_1 + 7 | 0) >>> 3 | 0;
              s.ps(skipCount);
            }

            break;
          case 18:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          case 20:
            // Inline function 'kotlin.TODO' call

            throw NotImplementedError.nd();
          default:
            noWhenBranchMatchedException();
            break;
        }
      } else if (v0 === 255) {
        var integerPart = this.e4l(s) << 8 | this.e4l(s);
        var fractionPart = this.e4l(s) << 8 | this.e4l(s);
        var value_1 = integerPart + fractionPart / 65536.0;
        this.v4k(stack, value_1);
      } else {
        var tmp_9;
        if (v0 === 28) {
          tmp_9 = toShort(this.e4l(s) << 8 | this.e4l(s));
        } else if (32 <= v0 ? v0 <= 246 : false) {
          tmp_9 = v0 - 139 | 0;
        } else if (247 <= v0 ? v0 <= 250 : false) {
          tmp_9 = (imul(v0 - 247 | 0, 256) + this.e4l(s) | 0) + 108 | 0;
        } else if (251 <= v0 ? v0 <= 254 : false) {
          tmp_9 = ((-imul(v0 - 251 | 0, 256) | 0) - this.e4l(s) | 0) - 108 | 0;
        } else {
          get_unreachable();
        }
        var value_2 = tmp_9;
        this.w4k(stack, value_2);
      }
    }
  }
  n4j(ctx, s, evalCtx, stack, stackLevel, $super) {
    stack = stack === VOID ? DoubleArrayList.q2f(32) : stack;
    stackLevel = stackLevel === VOID ? 0 : stackLevel;
    var tmp;
    if ($super === VOID) {
      this.f4l(ctx, s, evalCtx, stack, stackLevel);
      tmp = Unit_instance;
    } else {
      tmp = $super.f4l.call(this, ctx, s, evalCtx, stack, stackLevel);
    }
    return tmp;
  }
}
class TtfCIDFont {
  constructor() {
    TtfCIDFont_instance = this;
    this.m4k_1 = Companion_getInstance_15().us('TtfCIDFont');
  }
}
class Companion_14 {
  constructor() {
    Companion_instance_20 = this;
    this.g4l_1 = Companion_getInstance_15().us('TTF');
  }
}
class VectorFont {}
function getGlyphPath$default(size, codePoint, path, reader, $super) {
  path = path === VOID ? new GlyphPath() : path;
  reader = reader === VOID ? null : reader;
  return $super === VOID ? this.w4n(size, codePoint, path, reader) : $super.w4n.call(this, size, codePoint, path, reader);
}
function renderGlyph_0(ctx, size, codePoint, pos, fill, metrics, reader, beforeDraw) {
  $l$block: {
    // Inline function 'korlibs.io.lang.keep' call
    var tmp0_elvis_lhs = reader == null ? null : reader.ds_1;
    var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      this.p46(size, codePoint, metrics, reader);
      break $l$block;
    }finally {
      if (reader == null)
        null;
      else {
        reader.ds_1 = old;
      }
    }
  }
  var g = this.x4n(size, codePoint, VOID, reader);
  if (!(g == null)) {
    if (!(fill == null)) {
      ctx.o4d();
    }
    if (!g.r4h()) {
      if (beforeDraw == null)
        null;
      else
        beforeDraw();
    }
    // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
    var t = ctx.h3u_1.b47_1;
    try {
      // Inline function 'korlibs.image.font.VectorFont.renderGlyph.<anonymous>' call
      // Inline function 'korlibs.image.vector.Context2d.translate' call
      ctx.z4g(pos.h21_1, pos.i21_1);
      g.s4h(ctx);
    }finally {
      ctx.h3u_1.b47_1 = t;
    }
    switch (fill) {
      case true:
        ctx.x4e();
        break;
      case false:
        ctx.w4e();
        break;
      case null:
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return !g.r4h();
  }
  return false;
}
class BaseTtfFont {
  static r4x(s, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = createThis(this);
    $this.h4l_1 = new Mixin();
    $this.i4l_1 = s;
    $this.j4l_1 = extName;
    $this.k4l_1 = onlyReadMetadata;
    $this.l4l_1 = enableLigatures;
    $this.m4l_1 = new NamesInfo();
    var tmp = $this;
    var tmp_0 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(3), null);
    while (tmp_0 < 3) {
      tmp_1[tmp_0] = new Contour();
      tmp_0 = tmp_0 + 1 | 0;
    }
    tmp.n4l_1 = tmp_1;
    $this.o4l_1 = 0;
    $this.p4l_1 = 0;
    $this.q4l_1 = 0;
    $this.r4l_1 = 0;
    $this.s4l_1 = 0;
    $this.t4l_1 = 0;
    $this.u4l_1 = 0;
    $this.v4l_1 = 0;
    $this.w4l_1 = 0;
    $this.x4l_1 = 0;
    $this.y4l_1 = 0;
    $this.z4l_1 = 0;
    $this.a4m_1 = 0;
    $this.b4m_1 = 0;
    $this.c4m_1 = Companion_instance_24.s4x(0, 0);
    $this.d4m_1 = 0;
    $this.e4m_1 = 0;
    $this.f4m_1 = 0;
    $this.g4m_1 = 0;
    $this.h4m_1 = 0;
    $this.i4m_1 = 0;
    $this.j4m_1 = 0;
    $this.k4m_1 = 0;
    $this.l4m_1 = 0;
    $this.m4m_1 = 0;
    $this.n4m_1 = 0;
    $this.o4m_1 = 0;
    $this.p4m_1 = new Int32Array(0);
    $this.q4m_1 = Companion_instance_24.s4x(0, 0);
    $this.r4m_1 = 128;
    $this.s4m_1 = 0;
    $this.t4m_1 = 0;
    $this.u4m_1 = 0;
    $this.v4m_1 = 0;
    $this.w4m_1 = 0;
    $this.x4m_1 = 0;
    $this.y4m_1 = 0;
    $this.z4m_1 = 0;
    $this.a4n_1 = 0;
    var tmp_2 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_2.b4n_1 = emptyList();
    $this.c4n_1 = LinkedHashMap.ac();
    $this.d4n_1 = LinkedHashMap.ac();
    $this.e4n_1 = IntMap.i2k(512);
    $this.f4n_1 = LinkedHashMap.ac();
    var tmp_3 = $this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp_3.g4n_1 = [];
    $this.h4n_1 = IntMap.i2k();
    var tmp_4 = $this;
    // Inline function 'kotlin.collections.listOf' call
    tmp_4.i4n_1 = emptyList();
    $this.j4n_1 = new COLRv1();
    $this.k4n_1 = false;
    $this.l4n_1 = IntIntMap.b2l();
    $this.m4n_1 = IntMap.i2k();
    $this.o4n_1 = new GlyphMetrics(1.0, false, 0, Companion_getInstance_5().d25(), 0.0);
    $this.p4n_1 = false;
    $this.q4n_1 = null;
    return $this;
  }
  tw(_set____db54di) {
    this.h4l_1.tw(_set____db54di);
  }
  uw() {
    return this.h4l_1.uw();
  }
  static r4n(d, extName, onlyReadMetadata, enableLigatures) {
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    return this.r4x(openFastStream(d), extName, onlyReadMetadata, enableLigatures);
  }
  d46(size, metrics) {
    return metrics.n46(this.b4o(), size);
  }
  p46(size, codePoint, metrics, reader) {
    var tmp104_safe_receiver = this.m4p(reader, codePoint);
    var tmp0_elvis_lhs = tmp104_safe_receiver == null ? null : tmp104_safe_receiver.x4u_1;
    return metrics.w46(tmp0_elvis_lhs == null ? this.o4n_1 : tmp0_elvis_lhs, size, codePoint);
  }
  c48(size, leftCodePoint, rightCodePoint) {
    return 0.0;
  }
  w4n(size, codePoint, path, reader) {
    var spos = reader == null ? null : reader.ds_1;
    var codePointPeek = reader == null ? null : reader.ls(0);
    var tmp0_elvis_lhs = this.l4p(reader, codePoint, true);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return null;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var g = tmp;
    var scale = this.z46(size);
    path.k4h_1 = g.l1q().a4v_1;
    var tmp_0 = path;
    var tmp107_safe_receiver = g.k4v();
    tmp_0.l4h_1 = tmp107_safe_receiver == null ? null : tmp107_safe_receiver.c4v();
    var bitmapEntry = g.m4v();
    var bitmap = bitmapEntry == null ? null : bitmapEntry.m4s();
    path.m4h_1 = bitmap;
    if (!(bitmapEntry == null)) {
      var scaleX = this.r4m_1 / bitmapEntry.w4r_1.c4r_1;
      var scaleY = this.r4m_1 / bitmapEntry.w4r_1.d4r_1;
      path.n4h_1 = Vector2D.j21(0.0, ((-bitmapEntry.x4r_1 | 0) - bitmapEntry.h4s() | 0) * scaleY);
      path.o4h_1 = Scale.j29(scaleX, scaleY);
    }
    path.p4h_1 = Companion_getInstance_6().a25_1.a26(scale, scale);
    path.q4h_1 = scale;
    return path;
  }
  z46(size) {
    return size / this.r4m_1;
  }
  y4n(key) {
    return this.c4n_1.b3(key);
  }
  z4n(codePoint, glyphID) {
    // Inline function 'kotlin.collections.set' call
    this.c4n_1.g3(codePoint, glyphID);
    // Inline function 'kotlin.collections.set' call
    this.d4n_1.g3(glyphID, codePoint);
  }
  a4o(codePoint, glyphID) {
  }
  b4o() {
    var tmp = this.n4n_1;
    if (!(tmp == null))
      return tmp;
    else {
      throwUninitializedPropertyAccessException('fontMetrics1px');
    }
  }
  c4o() {
    return this.m4l_1.c4o();
  }
  n3() {
    var tmp0_elvis_lhs = this.j4l_1;
    return tmp0_elvis_lhs == null ? this.c4o() : tmp0_elvis_lhs;
  }
  s4n() {
    this.t4n();
    this.i4o();
    this.j4o();
    this.k4o();
    this.g4o();
    if (!this.k4l_1) {
      if (!(this.v4n('CFF ') == null) && this.v4n('glyf') == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.runTableUnit' call
        var tmp111_safe_receiver = this.f4o('CFF ');
        if (tmp111_safe_receiver == null)
          null;
        else {
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
          // Inline function 'kotlin.apply' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>.<anonymous>' call
          this.q4n_1 = CFF_instance.i4k(tmp111_safe_receiver);
        }
      }
      this.h4o();
      this.i4p();
      this.l4o();
      this.m4o();
      this.h4p();
      this.g4p();
      this.o4o();
      this.p4o();
      this.q4o();
    }
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = new FontMetrics();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.doInit.<anonymous>' call
    var scale = this.z46(1.0);
    this_0.e46_1 = 1.0;
    this_0.f46_1 = this.v4m_1 * scale;
    this_0.g46_1 = this.d4m_1 * scale;
    this_0.h46_1 = 0.0 * scale;
    this_0.i46_1 = this.e4m_1 * scale;
    this_0.j46_1 = this.t4m_1 * scale;
    this_0.k46_1 = this.f4m_1 * scale;
    this_0.l46_1 = this.g4m_1 * scale;
    this_0.m46_1 = this.r4m_1 * scale;
    tmp.n4n_1 = this_0;
  }
  toString() {
    return 'TtfFont(name=' + this.n3() + ')';
  }
  d4o(_this__u8e3s4) {
    return _FWord___init__impl__2rjyqf(_this__u8e3s4.m1j());
  }
  e4o(_this__u8e3s4) {
    return Companion_instance_24.s4x(_this__u8e3s4.l1j(), _this__u8e3s4.l1j());
  }
  f4o(name) {
    var tmp109_safe_receiver = this.v4n(name);
    return tmp109_safe_receiver == null ? null : tmp109_safe_receiver.q4q();
  }
  g4o() {
    var tmp111_safe_receiver = this.f4o('name');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readNames.<anonymous>' call
      Companion_instance_23.t4q(tmp111_safe_receiver, this.m4l_1);
    }
    return Unit_instance;
  }
  h4o() {
    var tmp111_safe_receiver = this.f4o('loca');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>' call
      var tmp;
      switch (this.z4m_1) {
        case 0:
          tmp = 2;
          break;
        case 1:
          tmp = 4;
          break;
        default:
          get_invalidOp();
          break;
      }
      var bytesPerEntry = tmp;
      var data = tmp111_safe_receiver.i1j(imul(bytesPerEntry, this.o4l_1 + 1 | 0));
      var tmp_0 = this;
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>' call
      var $this$run = new FastByteArrayInputStream(data);
      var tmp_1;
      switch (this.z4m_1) {
        case 0:
          // Inline function 'korlibs.datastructure.mapInt' call

          var this_0 = $this$run.s1j(this.o4l_1 + 1 | 0);
          // Inline function 'kotlin.also' call

          var this_1 = new Int32Array(this_0.length);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

          var inductionVariable = 0;
          var last = this_0.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              // Inline function 'korlibs.image.font.BaseTtfFont.readLoca.<anonymous>.<anonymous>.<anonymous>' call
              // Inline function 'kotlin.code' call
              var this_2 = this_0[n];
              var tmp$ret$0 = Char__toInt_impl_vasixd(this_2);
              this_1[n] = imul(tmp$ret$0, 2);
            }
             while (inductionVariable < last);
          tmp_1 = this_1;
          break;
        case 1:
          tmp_1 = $this$run.u1j(this.o4l_1 + 1 | 0);
          break;
        default:
          get_invalidOp();
          break;
      }
      tmp_0.p4m_1 = tmp_1;
    }
    return Unit_instance;
  }
  i4o() {
    var tmp111_safe_receiver = this.f4o('head');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>' call
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.m1j() === 1)) {
        invalidOp('Invalid TTF');
      }
      // Inline function 'kotlin.apply' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(tmp111_safe_receiver.m1j() === 0)) {
        invalidOp('Invalid TTF');
      }
      this.q4m_1 = this.e4o(tmp111_safe_receiver);
      var checkSumAdjustment = tmp111_safe_receiver.o1j();
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.o1j();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readHead.<anonymous>.<anonymous>' call
      if (!(this_0 === 1594834165)) {
        invalidOp('Invalid magic ' + get_hex(this_0));
      }
      var flags = tmp111_safe_receiver.m1j();
      this.r4m_1 = tmp111_safe_receiver.m1j();
      var created = tmp111_safe_receiver.p1j().u3(new Long(1000, 0));
      var modified = tmp111_safe_receiver.p1j().u3(new Long(1000, 0));
      this.s4m_1 = tmp111_safe_receiver.l1j();
      this.t4m_1 = tmp111_safe_receiver.l1j();
      this.u4m_1 = tmp111_safe_receiver.l1j();
      this.v4m_1 = tmp111_safe_receiver.l1j();
      this.w4m_1 = tmp111_safe_receiver.m1j();
      this.x4m_1 = tmp111_safe_receiver.m1j();
      this.y4m_1 = tmp111_safe_receiver.l1j();
      this.z4m_1 = tmp111_safe_receiver.l1j();
      this.a4n_1 = tmp111_safe_receiver.l1j();
    }
    return Unit_instance;
  }
  j4o() {
    var tmp111_safe_receiver = this.f4o('maxp');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readMaxp.<anonymous>' call
      var version = this.e4o(tmp111_safe_receiver);
      this.o4l_1 = tmp111_safe_receiver.m1j();
      this.p4l_1 = tmp111_safe_receiver.m1j();
      this.q4l_1 = tmp111_safe_receiver.m1j();
      this.r4l_1 = tmp111_safe_receiver.m1j();
      this.s4l_1 = tmp111_safe_receiver.m1j();
      this.t4l_1 = tmp111_safe_receiver.m1j();
      this.u4l_1 = tmp111_safe_receiver.m1j();
      this.v4l_1 = tmp111_safe_receiver.m1j();
      this.w4l_1 = tmp111_safe_receiver.m1j();
      this.x4l_1 = tmp111_safe_receiver.m1j();
      this.y4l_1 = tmp111_safe_receiver.m1j();
      this.z4l_1 = tmp111_safe_receiver.m1j();
      this.a4m_1 = tmp111_safe_receiver.m1j();
      this.b4m_1 = tmp111_safe_receiver.m1j();
    }
    return Unit_instance;
  }
  k4o() {
    var tmp111_safe_receiver = this.f4o('hhea');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHhea.<anonymous>' call
      this.c4m_1 = this.e4o(tmp111_safe_receiver);
      this.d4m_1 = tmp111_safe_receiver.l1j();
      this.e4m_1 = tmp111_safe_receiver.l1j();
      this.f4m_1 = tmp111_safe_receiver.l1j();
      this.g4m_1 = tmp111_safe_receiver.m1j();
      this.h4m_1 = tmp111_safe_receiver.l1j();
      this.i4m_1 = tmp111_safe_receiver.l1j();
      this.j4m_1 = tmp111_safe_receiver.l1j();
      this.k4m_1 = tmp111_safe_receiver.l1j();
      this.l4m_1 = tmp111_safe_receiver.l1j();
      this.m4m_1 = tmp111_safe_receiver.l1j();
      tmp111_safe_receiver.l1j();
      tmp111_safe_receiver.l1j();
      tmp111_safe_receiver.l1j();
      tmp111_safe_receiver.l1j();
      this.n4m_1 = tmp111_safe_receiver.l1j();
      this.o4m_1 = tmp111_safe_receiver.m1j();
    }
    return Unit_instance;
  }
  l4o() {
    var tmp111_safe_receiver = this.f4o('hmtx');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>' call
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, this.o4m_1);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.z();
      while (tmp0_iterator.a1()) {
        var item = tmp0_iterator.b1();
        // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new HorMetric(tmp111_safe_receiver.m1j(), tmp111_safe_receiver.l1j());
        destination.f(tmp$ret$0);
      }
      var firstMetrics = destination;
      var lastAdvanceWidth = last(firstMetrics).r4q_1;
      // Inline function 'kotlin.collections.map' call
      var this_1 = until(0, this.o4l_1 - this.o4m_1 | 0);
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
      var tmp0_iterator_0 = this_1.z();
      while (tmp0_iterator_0.a1()) {
        var item_0 = tmp0_iterator_0.b1();
        // Inline function 'korlibs.image.font.BaseTtfFont.readHmtx.<anonymous>.<anonymous>' call
        var tmp$ret$3 = new HorMetric(lastAdvanceWidth, tmp111_safe_receiver.l1j());
        destination_0.f(tmp$ret$3);
      }
      var compressedMetrics = destination_0;
      this.b4n_1 = plus(firstMetrics, compressedMetrics);
    }
    return Unit_instance;
  }
  m4o() {
    var tmp111_safe_receiver = this.f4o('CPAL');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>' call
      var version = tmp111_safe_receiver.m1j();
      switch (version) {
        case 0:
        case 1:
          var numPaletteEntries = tmp111_safe_receiver.m1j();
          var numPalettes = tmp111_safe_receiver.m1j();
          var numColorRecords = tmp111_safe_receiver.m1j();
          var colorRecordsArrayOffset = tmp111_safe_receiver.o1j();
          var colorRecordIndices = tmp111_safe_receiver.r1j(numPalettes);
          var paletteTypesArrayOffset = version === 1 ? tmp111_safe_receiver.o1j() : -1;
          var paletteLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.o1j() : -1;
          var paletteEntryLabelsArrayOffset = version === 1 ? tmp111_safe_receiver.o1j() : -1;
          tmp111_safe_receiver.a1j(colorRecordsArrayOffset);
          var colorInts = tmp111_safe_receiver.t1j(numColorRecords);
          var inductionVariable = 0;
          var last = colorInts.length;
          if (inductionVariable < last)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var c = _RGBA___init__impl__lqpay5(colorInts[n]);
              colorInts[n] = _RGBA___get_value__impl__hhco8v(Companion_getInstance_23().c43(_RGBA___get_b__impl__m6tl80(c), _RGBA___get_g__impl__o8pukr(c), _RGBA___get_r__impl__duz7mo(c), _RGBA___get_a__impl__6msvu7(c)));
            }
             while (inductionVariable < last);
          var tmp = this;
          // Inline function 'kotlin.collections.map' call

          // Inline function 'kotlin.collections.mapTo' call

          var destination = ArrayList.w(colorRecordIndices.length);
          var inductionVariable_0 = 0;
          var last_0 = colorRecordIndices.length;
          while (inductionVariable_0 < last_0) {
            var item = colorRecordIndices[inductionVariable_0];
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCpal.<anonymous>.<anonymous>' call
            var tmp$ret$0 = new Palette(_RgbaArray___init__impl__oib4y4(copyOfRange_0(colorInts, item, item + numPaletteEntries | 0)));
            destination.f(tmp$ret$0);
          }

          tmp.i4n_1 = destination;
          break;
        default:
          println('TTF WARNING CPAL version != 0,1');
          break;
      }
    }
    return Unit_instance;
  }
  n4o(_this__u8e3s4) {
    return new SbitLineMetrics(_this__u8e3s4.j1j(), _this__u8e3s4.j1j(), _this__u8e3s4.k1j(), _this__u8e3s4.j1j(), _this__u8e3s4.j1j(), _this__u8e3s4.j1j(), _this__u8e3s4.j1j(), _this__u8e3s4.j1j(), _this__u8e3s4.j1j(), _this__u8e3s4.j1j(), _this__u8e3s4.j1j(), _this__u8e3s4.j1j());
  }
  o4o() {
    var tmp111_safe_receiver = this.f4o('CBLC');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCblc.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.m1j();
      var minorVersion = tmp111_safe_receiver.m1j();
      if (majorVersion === 3) {
        var numSizes = tmp111_safe_receiver.o1j();
        var tmp = 0;
        // Inline function 'kotlin.arrayOfNulls' call
        var tmp_0 = fillArrayVal(Array(numSizes), null);
        while (tmp < numSizes) {
          tmp_0[tmp] = new ColorBitmapInfo(tmp111_safe_receiver.o1j(), tmp111_safe_receiver.o1j(), tmp111_safe_receiver.o1j(), tmp111_safe_receiver.o1j(), this.n4o(tmp111_safe_receiver), this.n4o(tmp111_safe_receiver), tmp111_safe_receiver.m1j(), tmp111_safe_receiver.m1j(), tmp111_safe_receiver.k1j(), tmp111_safe_receiver.k1j(), tmp111_safe_receiver.k1j(), tmp111_safe_receiver.j1j());
          tmp = tmp + 1 | 0;
        }
        var colorBitmapInfos = toList_1(tmp_0);
        var _iterator__ex2g4s = colorBitmapInfos.z();
        while (_iterator__ex2g4s.a1()) {
          var cbi = _iterator__ex2g4s.b1();
          var glyphCount = cbi.b4r_1 - cbi.a4r_1 | 0;
          tmp111_safe_receiver.a1j(cbi.u4q_1);
          var tmp_1 = 0;
          var tmp_2 = cbi.w4q_1;
          // Inline function 'kotlin.arrayOfNulls' call
          var tmp_3 = fillArrayVal(Array(tmp_2), null);
          while (tmp_1 < tmp_2) {
            tmp_3[tmp_1] = new BaseTtfFont$readCblc$1$Subtable(tmp111_safe_receiver.m1j(), tmp111_safe_receiver.m1j(), tmp111_safe_receiver.o1j());
            tmp_1 = tmp_1 + 1 | 0;
          }
          var subtables = tmp_3;
          var inductionVariable = 0;
          var last = subtables.length;
          while (inductionVariable < last) {
            var subtable = subtables[inductionVariable];
            inductionVariable = inductionVariable + 1 | 0;
            tmp111_safe_receiver.a1j(cbi.u4q_1 + subtable.e4x_1 | 0);
            var indexFormat = tmp111_safe_receiver.m1j();
            var imageFormat = tmp111_safe_receiver.m1j();
            var imageDataOffset = tmp111_safe_receiver.o1j();
            var tmp_4;
            if (indexFormat === 1) {
              var tmp_5 = 0;
              var tmp_6 = subtable.f4x() + 1 | 0;
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_7 = fillArrayVal(Array(tmp_6), null);
              while (tmp_5 < tmp_6) {
                tmp_7[tmp_5] = imageDataOffset + tmp111_safe_receiver.o1j() | 0;
                tmp_5 = tmp_5 + 1 | 0;
              }
              tmp_4 = tmp_7;
            } else {
              // Inline function 'kotlin.emptyArray' call
              tmp_4 = [];
            }
            var offsets = tmp_4;
            var inductionVariable_0 = 0;
            var last_0 = offsets.length - 1 | 0;
            if (inductionVariable_0 < last_0)
              do {
                var n = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var offset = offsets[n];
                var size = offsets[n + 1 | 0] - offset | 0;
                var glyphID = (subtable.c4x_1 + n | 0) - 1 | 0;
                // Inline function 'kotlin.collections.set' call
                var this_0 = this.f4n_1;
                var value = new BitmapGlyphInfo(glyphID, imageFormat, offset, size, cbi);
                this_0.g3(glyphID, value);
              }
               while (inductionVariable_0 < last_0);
          }
        }
      } else {
        println('Unsupported CBLC ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  p4o() {
    var tmp111_safe_receiver = this.f4o('CBDT');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCbdt.<anonymous>' call
      var majorVersion = tmp111_safe_receiver.m1j();
      var minorVersion = tmp111_safe_receiver.m1j();
      if (majorVersion === 3) {
        var _iterator__ex2g4s = this.f4n_1.k3().z();
        while (_iterator__ex2g4s.a1()) {
          var i = _iterator__ex2g4s.b1();
          var format = i.t4r_1;
          if (format === 17 || format === 18) {
            i.x4r_1 = tmp111_safe_receiver.k1j();
            i.y4r_1 = tmp111_safe_receiver.k1j();
            i.z4r_1 = tmp111_safe_receiver.j1j();
            i.a4s_1 = tmp111_safe_receiver.j1j();
            i.b4s_1 = tmp111_safe_receiver.k1j();
            i.c4s_1 = format === 18 ? tmp111_safe_receiver.j1j() : i.z4r_1;
            i.d4s_1 = format === 18 ? tmp111_safe_receiver.j1j() : i.a4s_1;
            i.e4s_1 = format === 18 ? tmp111_safe_receiver.j1j() : i.b4s_1;
          }
          var dataLen = tmp111_safe_receiver.o1j();
          i.f4s_1 = tmp111_safe_receiver.d1j(dataLen);
        }
      } else {
        println('Unsupported CBDT ' + majorVersion + '.' + minorVersion);
      }
    }
    return Unit_instance;
  }
  q4o() {
    var tmp111_safe_receiver = this.f4o('sbix');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>' call
      var version = tmp111_safe_receiver.m1j();
      var flags = tmp111_safe_receiver.m1j();
      var numStrikes = tmp111_safe_receiver.o1j();
      var strikeOffsets = tmp111_safe_receiver.u1j(numStrikes);
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(strikeOffsets.length);
      var inductionVariable = 0;
      var last = strikeOffsets.length;
      while (inductionVariable < last) {
        var item = strikeOffsets[inductionVariable];
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        tmp111_safe_receiver.a1j(item);
        var tmp$ret$0 = new BaseTtfFont$readSbix$1$StrikeInfo(tmp111_safe_receiver.m1j(), tmp111_safe_receiver.m1j(), item, toIntArrayList(tmp111_safe_receiver.u1j(this.o4l_1 + 1 | 0)));
        destination.f(tmp$ret$0);
      }
      var strikes = destination;
      var tmp$ret$3;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxByOrNull' call
        var iterator = strikes.z();
        if (!iterator.a1()) {
          tmp$ret$3 = null;
          break $l$block_0;
        }
        var maxElem = iterator.b1();
        if (!iterator.a1()) {
          tmp$ret$3 = maxElem;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
        var maxValue = maxElem.g4x_1;
        do {
          var e = iterator.b1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          var v = e.g4x_1;
          if (compareTo(maxValue, v) < 0) {
            maxElem = e;
            maxValue = v;
          }
        }
         while (iterator.a1());
        tmp$ret$3 = maxElem;
      }
      var strike = ensureNotNull(tmp$ret$3);
      var inductionVariable_0 = 0;
      var last_0 = this.o4l_1;
      if (inductionVariable_0 < last_0)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var glyphID = n;
          var offset = strike.j4x_1.c1(n);
          var len = strike.j4x_1.c1(n + 1 | 0) - offset | 0;
          var start = strike.i4x_1 + offset | 0;
          var end = start + len | 0;
          tmp111_safe_receiver.a1j(start);
          var originOffsetX = tmp111_safe_receiver.l1j();
          var originOffsetY = tmp111_safe_receiver.l1j();
          var graphicType = tmp111_safe_receiver.x1j(4);
          var bytes = tmp111_safe_receiver.d1j(len - 8 | 0);
          // Inline function 'kotlin.collections.set' call
          var this_0 = this.f4n_1;
          // Inline function 'kotlin.also' call
          var this_1 = new BitmapGlyphInfo(glyphID, VOID, VOID, VOID, new ColorBitmapInfo(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, strike.g4x_1, strike.g4x_1));
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readSbix.<anonymous>.<anonymous>' call
          this_1.f4s_1 = bytes;
          this_0.g3(glyphID, this_1);
        }
         while (inductionVariable_0 < last_0);
    }
    return Unit_instance;
  }
  r4o(_this__u8e3s4) {
    return _this__u8e3s4.o1j();
  }
  s4o(_this__u8e3s4) {
    return _this__u8e3s4.m1j();
  }
  t4o(_this__u8e3s4) {
    return _this__u8e3s4.l1j();
  }
  u4o(_this__u8e3s4) {
    return _this__u8e3s4.m1j();
  }
  v4o(_this__u8e3s4) {
    return _this__u8e3s4.n1j();
  }
  w4o(_this__u8e3s4) {
    return _this__u8e3s4.o1j();
  }
  x4o(_this__u8e3s4, isVar) {
    var xx = this.s4p(_this__u8e3s4);
    var yx = this.s4p(_this__u8e3s4);
    var xy = this.s4p(_this__u8e3s4);
    var yy = this.s4p(_this__u8e3s4);
    var dx = this.s4p(_this__u8e3s4);
    var dy = this.s4p(_this__u8e3s4);
    return new Matrix(xx, yx, xy, yy, dx, -dy);
  }
  y4o(_this__u8e3s4, out) {
    out.q4s_1 = this.r4p(_this__u8e3s4);
    out.r4s_1 = _this__u8e3s4.m1j();
    out.s4s_1 = this.r4p(_this__u8e3s4);
    return out;
  }
  z4o(_this__u8e3s4, out, $super) {
    out = out === VOID ? new ColorStop(0.0, 0, 0.0) : out;
    return $super === VOID ? this.y4o(_this__u8e3s4, out) : $super.y4o.call(this, _this__u8e3s4, out);
  }
  a4p(_this__u8e3s4, doVar) {
    var format = _this__u8e3s4.k1j();
    var xMin = this.t4o(_this__u8e3s4);
    var yMin = this.t4o(_this__u8e3s4);
    var xMax = this.t4o(_this__u8e3s4);
    var yMax = this.t4o(_this__u8e3s4);
    if (format === 2) {
      var varIndexBase = this.r4o(_this__u8e3s4);
    }
    return Companion_getInstance_5().r29(xMin, yMin, xMax, yMax);
  }
  b4p(_this__u8e3s4, doVar, $super) {
    doVar = doVar === VOID ? false : doVar;
    return $super === VOID ? this.a4p(_this__u8e3s4, doVar) : $super.a4p.call(this, _this__u8e3s4, doVar);
  }
  c4p(_this__u8e3s4) {
    var cycle;
    switch (_this__u8e3s4.k1j()) {
      case 0:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
      case 1:
        cycle = CycleMethod_REPEAT_getInstance();
        break;
      case 2:
        cycle = CycleMethod_REFLECT_getInstance();
        break;
      default:
        cycle = CycleMethod_NO_CYCLE_getInstance();
        break;
    }
    // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf16' call
    var tmp = 0;
    var tmp_0 = _this__u8e3s4.m1j();
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColorLine.<anonymous>' call
      tmp_1[tmp] = this.z4o(_this__u8e3s4);
      tmp = tmp + 1 | 0;
    }
    return new ColorLine(cycle, toList_1(tmp_1));
  }
  d4p(glyphID, s, c, pal, level) {
    var nodeFormat = s.k1j();
    var isVar = (nodeFormat % 2 | 0) === 1;
    var indent = repeat('  ', level);
    var debug = false;
    var debugShape = false;
    if (debug) {
      println(indent + 'interpretColrv1[glyphID=' + glyphID + ']: ' + nodeFormat + ' - ' + toString(getOrNull(Companion_getInstance_33().c4q_1, nodeFormat)));
    }
    switch (nodeFormat) {
      case 1:
        var numLayers = s.k1j();
        var firstLayerIndex = s.o1j();
        var inductionVariable = 0;
        if (inductionVariable < numLayers)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            var paint = this.j4n_1.v4t_1[firstLayerIndex + n | 0];
            this.d4p(glyphID, this.j4n_1.y4t_1.f1j(paint), c, pal, level + 1 | 0);
          }
           while (inductionVariable < numLayers);
        break;
      case 2:
      case 3:
        var paletteIndex = s.m1j();
        var alpha = this.r4p(s);
        if (isVar) {
          var varIndexBase = this.r4o(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.nd();
        }

        var color = RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(this.i4n_1.c1(pal).p42_1, paletteIndex), alpha);
        if (debugShape) {
          println("ctx.fillStyle = '" + _RGBA___get_htmlStringSimple__impl__l4nu0u(color) + "';");
          println('ctx.fill();');
        }

        if (debug) {
          println(indent + RGBA__toString_impl_4lw6dp(color));
        }

        c.a4f(new RGBA(color));
        break;
      case 4:
      case 5:
        var colorLineOffset = this.v4o(s);
        var x0 = this.t4o(s);
        var y0 = this.t4o(s);
        var x1 = this.t4o(s);
        var y1 = this.t4o(s);
        var x2 = this.t4o(s);
        var y2 = this.t4o(s);
        var colorLine = this.c4p(s.f1j(colorLineOffset));
        if (isVar) {
          var varIndexBase_0 = this.r4o(s);
        }

        // Inline function 'korlibs.image.paint.LinearGradientPaint' call

        var y0_0 = -y0;
        var y1_0 = -y1;
        var cycle = colorLine.n4s_1;
        var transform = Companion_getInstance_6().a25_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.LinearGradientPaint.<anonymous>' call

        var paint_0 = new GradientPaint(GradientKind_LINEAR_getInstance(), numberToDouble(x0), numberToDouble(y0_0), 0.0, numberToDouble(x1), numberToDouble(y1_0), 0.0, VOID, VOID, cycle, transform);
        colorLine.p4s(paint_0, this.i4n_1.c1(pal));
        if (debug) {
          println(indent + paint_0.toString());
        }

        c.a4f(paint_0);
        break;
      case 6:
      case 7:
        var colorLineOffset_0 = this.v4o(s);
        var x0_0 = this.t4o(s);
        var y0_1 = this.t4o(s);
        var radius0 = this.s4o(s);
        var x1_0 = this.t4o(s);
        var y1_1 = this.t4o(s);
        var radius1 = this.s4o(s);
        var colorLine_0 = this.c4p(s.f1j(colorLineOffset_0));
        if (isVar) {
          var varIndexBase_1 = this.r4o(s);
        }

        if (debugShape) {
          println('ctx.fillStyle = ctx.createRadialGradient(' + x0_0 + ', -' + y0_1 + ', ' + radius0 + ', ' + x1_0 + ', -' + y1_1 + ', ' + radius1 + ');');
          println('ctx.fill();');
        }

        // Inline function 'korlibs.image.paint.RadialGradientPaint' call

        var y0_2 = -y0_1;
        var y1_2 = -y1_1;
        var cycle_0 = colorLine_0.n4s_1;
        var transform_0 = Companion_getInstance_6().a25_1;
        // Inline function 'kotlin.also' call

        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.image.paint.RadialGradientPaint.<anonymous>' call

        var paint_1 = new GradientPaint(GradientKind_RADIAL_getInstance(), numberToDouble(x0_0), numberToDouble(y0_2), numberToDouble(radius0), numberToDouble(x1_0), numberToDouble(y1_2), numberToDouble(radius1), VOID, VOID, cycle_0, transform_0);
        colorLine_0.p4s(paint_1, this.i4n_1.c1(pal));
        if (debug) {
          println(indent + paint_1.toString());
        }

        c.a4f(paint_1);
        break;
      case 8:
      case 9:
        var colorLine_1 = this.v4o(s);
        var centerX = this.t4o(s);
        var centerY = this.t4o(s);
        var startAngle = this.r4p(s);
        var endAngle = this.r4p(s);
        if (isVar) {
          var varIndexBase_2 = this.r4o(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 10:
        var paint_2 = this.v4o(s);
        var glyphID_0 = s.m1j();
        var colr = this.h4n_1.c1(glyphID_0);
        var glyph = this.q4p(glyphID_0);
        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.h4f();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (!(glyph == null)) {
            if (debugShape) {
              println(joinToString(toContext2dCommands(glyph.l1q().a4v_1), '\n'));
            }
            c.t4x(glyph.l1q().a4v_1);
            this.d4p(glyphID_0, s.f1j(paint_2), c, pal, level + 1 | 0);
          }
        }finally {
          c.p4f();
        }

        break;
      case 11:
        var glyphID_1 = s.m1j();
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 12:
      case 13:
        var paint_3 = this.v4o(s);
        var transform_1 = this.v4o(s);
        var affine = this.x4o(s.f1j(transform_1), isVar);
        if (debug) {
          println(indent + 'affine=' + affine.toString());
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.h4f();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          c.b4h(affine);
          this.d4p(glyphID, s.f1j(paint_3), c, pal, level + 1 | 0);
        }finally {
          c.p4f();
        }

        break;
      case 14:
      case 15:
        var paint_4 = this.v4o(s);
        var dx = FWord__toDouble_impl_53j5qp(this.d4o(s));
        var dy = FWord__toDouble_impl_53j5qp(this.d4o(s));
        if (isVar) {
          var varIndexBase_3 = this.r4o(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.h4f();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          if (debug) {
            println('translate: ' + dx + ', ' + dy);
          }
          c.z4g(dx, -dy);
          this.d4p(glyphID, s.f1j(paint_4), c, pal, level + 1 | 0);
        }finally {
          c.p4f();
        }

        break;
      case 16:
      case 17:
      case 18:
      case 19:
        var paint_5 = this.v4o(s);
        var scaleX = this.r4p(s);
        var scaleY = this.r4p(s);
        var aroundCenter = nodeFormat >= 18;
        if (aroundCenter) {
          var centerX_0 = this.t4o(s);
          var centerY_0 = this.t4o(s);
          // Inline function 'kotlin.TODO' call
          throw NotImplementedError.nd();
        }

        if (isVar) {
          var varIndexBase_4 = this.r4o(s);
        }

        // Inline function 'korlibs.image.vector.Context2d.keep' call

        c.h4f();
        try {
          // Inline function 'korlibs.image.font.BaseTtfFont.interpretColrv1.<anonymous>' call
          // Inline function 'korlibs.image.vector.Context2d.scale' call
          c.u4x(numberToDouble(scaleX), numberToDouble(scaleY));
          this.d4p(glyphID, s.f1j(paint_5), c, pal, level + 1 | 0);
        }finally {
          c.p4f();
        }

        break;
      case 20:
      case 21:
      case 22:
      case 23:
        var paint_6 = this.v4o(s);
        var scale = this.r4p(s);
        if (nodeFormat >= 22) {
          var centerX_1 = this.t4o(s);
          var centerY_1 = this.t4o(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_5 = this.r4o(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 24:
      case 25:
      case 26:
      case 27:
        var paint_7 = this.v4o(s);
        var angle = this.r4p(s);
        if (nodeFormat >= 26) {
          var centerX_2 = this.t4o(s);
          var centerY_2 = this.t4o(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_6 = this.r4o(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 28:
      case 29:
      case 30:
      case 31:
        var paint_8 = this.v4o(s);
        var xSkewAngle = this.r4p(s);
        var ySkewAngle = this.r4p(s);
        if (nodeFormat >= 30) {
          var centerX_3 = this.t4o(s);
          var centerY_3 = this.t4o(s);
        }

        if ((nodeFormat % 2 | 0) === 1) {
          var varIndexBase_7 = this.r4o(s);
        }

        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      case 32:
        var sourcePaint = this.v4o(s);
        var compositeMode = s.k1j();
        var backdropPaint = this.v4o(s);
        // Inline function 'kotlin.TODO' call

        throw NotImplementedError.nd();
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Unknown colorv1 format=' + nodeFormat;
        throw NotImplementedError.nd('An operation is not implemented: ' + reason);
    }
  }
  e4p(_this__u8e3s4, hintedCount) {
    var coverageFormat = _this__u8e3s4.m1j();
    switch (coverageFormat) {
      case 1:
        var glyphCount = _this__u8e3s4.m1j();
        // Inline function 'korlibs.datastructure.mapInt' call

        var this_0 = _this__u8e3s4.s1j(glyphCount);
        // Inline function 'kotlin.also' call

        var this_1 = new Int32Array(this_0.length);
        // Inline function 'kotlin.contracts.contract' call

        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

        var inductionVariable = 0;
        var last = this_0.length;
        if (inductionVariable < last)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
            // Inline function 'kotlin.code' call
            var this_2 = this_0[n];
            this_1[n] = Char__toInt_impl_vasixd(this_2);
          }
           while (inductionVariable < last);
        return this_1;
      case 2:
        var rangeCount = _this__u8e3s4.m1j();
        // Inline function 'kotlin.collections.map' call

        var this_3 = until(0, rangeCount);
        // Inline function 'kotlin.collections.mapTo' call

        var destination = ArrayList.w(collectionSizeOrDefault(this_3, 10));
        var tmp0_iterator = this_3.z();
        while (tmp0_iterator.a1()) {
          var item = tmp0_iterator.b1();
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var tmp$ret$4 = new BaseTtfFont$readCoverage$RangeInfo(_this__u8e3s4.m1j(), _this__u8e3s4.m1j(), _this__u8e3s4.m1j());
          destination.f(tmp$ret$4);
        }

        var ranges = destination;
        // Inline function 'kotlin.collections.maxOf' call

        var iterator = ranges.z();
        if (!iterator.a1())
          throw NoSuchElementException.h6();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call

        var it = iterator.b1();
        var maxValue = it.m4x_1 + it.n4x_1 | 0;
        while (iterator.a1()) {
          // Inline function 'korlibs.image.font.BaseTtfFont.readCoverage.<anonymous>' call
          var it_0 = iterator.b1();
          var v = it_0.m4x_1 + it_0.n4x_1 | 0;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }

        var glyphCount_0 = maxValue;
        var glyphArray = new Int32Array(glyphCount_0);
        var _iterator__ex2g4s = ranges.z();
        while (_iterator__ex2g4s.a1()) {
          var range = _iterator__ex2g4s.b1();
          var inductionVariable_0 = range.k4x_1;
          var last_0 = range.l4x_1;
          if (inductionVariable_0 <= last_0)
            do {
              var glyphID = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              var offset = glyphID - range.k4x_1 | 0;
              glyphArray[range.m4x_1 + offset | 0] = glyphID;
            }
             while (!(glyphID === last_0));
        }

        return glyphArray;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'coverageFormat=' + coverageFormat;
        throw NotImplementedError.nd('An operation is not implemented: ' + reason);
    }
  }
  f4p(_this__u8e3s4, hintedCount, $super) {
    hintedCount = hintedCount === VOID ? -1 : hintedCount;
    return $super === VOID ? this.e4p(_this__u8e3s4, hintedCount) : $super.e4p.call(this, _this__u8e3s4, hintedCount);
  }
  g4p() {
    var tmp111_safe_receiver = this.f4o('GSUB');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>' call
      var totalLength = tmp111_safe_receiver.a();
      var majorVersion = tmp111_safe_receiver.m1j();
      var minorVersion = tmp111_safe_receiver.m1j();
      if (!(majorVersion === 1)) {
        // Inline function 'kotlin.error' call
        var message = 'Unknown GSUB majorVerrsion=' + majorVersion;
        throw IllegalStateException.w4(toString_0(message));
      }
      var scriptListOffset = this.u4o(tmp111_safe_receiver);
      var featureListOffset = this.u4o(tmp111_safe_receiver);
      var lookupListOffset = this.u4o(tmp111_safe_receiver);
      if (minorVersion >= 1) {
        var featureVariationsOffset = this.w4o(tmp111_safe_receiver);
      }
      // Inline function 'kotlin.apply' call
      var this_0 = tmp111_safe_receiver.f1j(scriptListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var scriptCount = this_0.m1j();
      var inductionVariable = 0;
      if (inductionVariable < scriptCount)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          var scriptTag = this_0.x1j(4);
          var scriptOffset = this.u4o(this_0);
        }
         while (inductionVariable < scriptCount);
      // Inline function 'kotlin.apply' call
      var this_1 = tmp111_safe_receiver.f1j(featureListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var featureCount = this_1.m1j();
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < featureCount)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var featureTag = this_1.x1j(4);
          var featureOffset = this.u4o(this_1);
        }
         while (inductionVariable_0 < featureCount);
      // Inline function 'kotlin.apply' call
      var this_2 = tmp111_safe_receiver.f1j(lookupListOffset);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>' call
      var lookupCount = this_2.m1j();
      // Inline function 'korlibs.datastructure.mapInt' call
      var this_3 = until(0, lookupCount);
      // Inline function 'kotlin.also' call
      var this_4 = IntArrayList.w2e((coerceAtLeast(this_3.l1() - this_3.k1() | 0, 0) / this_3.e2_1 | 0) + 1 | 0);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
      var nestedFirst = this_3.k1();
      var nestedLast = this_3.l1();
      var stepArg = this_3.e2_1;
      if (stepArg <= 0)
        THROW_IAE('Step must be positive, was: ' + stepArg + '.');
      var inductionVariable_1 = nestedFirst;
      var last = getProgressionLastElement(nestedFirst, nestedLast, stepArg);
      if (inductionVariable_1 <= last)
        do {
          var v = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + stepArg | 0;
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
          var tmp$ret$2 = this.u4o(this_2);
          this_4.c2f(tmp$ret$2);
        }
         while (!(v === last));
      var lookups = this_4;
      var _iterator__ex2g4s = lookups.z();
      while (_iterator__ex2g4s.a1()) {
        var lookupOffset = _iterator__ex2g4s.b1();
        // Inline function 'kotlin.apply' call
        var this_5 = this_2.f1j(lookupOffset);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>' call
        var lookupType = this_5.m1j();
        var lookupFlag = this_5.m1j();
        var subTableCount = this_5.m1j();
        // Inline function 'korlibs.datastructure.mapInt' call
        var this_6 = this_5.r1j(subTableCount);
        // Inline function 'kotlin.also' call
        var this_7 = new Int32Array(this_6.length);
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
        var inductionVariable_2 = 0;
        var last_0 = this_6.length;
        if (inductionVariable_2 < last_0)
          do {
            var n_1 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
            this_7[n_1] = this_6[n_1] & 65535;
          }
           while (inductionVariable_2 < last_0);
        var subtableOffsets = this_7;
        var markFilteringSet = this_5.m1j();
        var inductionVariable_3 = 0;
        var last_1 = subtableOffsets.length;
        while (inductionVariable_3 < last_1) {
          var offset = subtableOffsets[inductionVariable_3];
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          // Inline function 'kotlin.apply' call
          var this_8 = this_5.f1j(offset);
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
          var subsTable = this_8;
          switch (lookupType) {
            case 1:
              var substFormat = this_8.m1j();
              var coverageOffset = this.u4o(this_8);
              switch (substFormat) {
                case 1:
                  var deltaGlyphID = this_8.l1j();
                  var coverageTable = this.f4p(this_8.f1j(coverageOffset));
                  var inductionVariable_4 = 0;
                  var last_2 = coverageTable.length;
                  while (inductionVariable_4 < last_2) {
                    var glyphID = coverageTable[inductionVariable_4];
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    this.l4n_1.a2l(glyphID, glyphID + deltaGlyphID | 0);
                  }

                  break;
                case 2:
                  var glyphCount = this_8.m1j();
                  var coverageTable_0 = this.f4p(this_8.f1j(coverageOffset));
                  // Inline function 'korlibs.datastructure.mapInt' call

                  var this_9 = this_8.s1j(glyphCount);
                  // Inline function 'kotlin.also' call

                  var this_10 = new Int32Array(this_9.length);
                  // Inline function 'kotlin.contracts.contract' call

                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

                  var inductionVariable_5 = 0;
                  var last_3 = this_9.length;
                  if (inductionVariable_5 < last_3)
                    do {
                      var n_2 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_11 = this_9[n_2];
                      this_10[n_2] = Char__toInt_impl_vasixd(this_11);
                    }
                     while (inductionVariable_5 < last_3);
                  var substituteGlyphIDs = this_10;
                  // Inline function 'kotlin.repeat' call

                  // Inline function 'kotlin.contracts.contract' call

                  var inductionVariable_6 = 0;
                  if (inductionVariable_6 < glyphCount)
                    do {
                      var index = inductionVariable_6;
                      inductionVariable_6 = inductionVariable_6 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      this.l4n_1.a2l(coverageTable_0[index], substituteGlyphIDs[index]);
                    }
                     while (inductionVariable_6 < glyphCount);
                  break;
                default:
                  // Inline function 'kotlin.error' call

                  var message_0 = 'Unsupported lookupType=1, substFormat=' + substFormat;
                  throw IllegalStateException.w4(toString_0(message_0));
              }

              break;
            case 4:
              var substFormat_0 = this_8.m1j();
              if (!(substFormat_0 === 1)) {
                // Inline function 'kotlin.error' call
                var message_1 = 'For lookType=4 only substFormat=1 is supported';
                throw IllegalStateException.w4(toString_0(message_1));
              }

              var coverageOffset_0 = this.u4o(this_8);
              var ligatureSetCount = this_8.m1j();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_12 = this_8.s1j(ligatureSetCount);
              // Inline function 'kotlin.also' call

              var this_13 = new Int32Array(this_12.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable_7 = 0;
              var last_4 = this_12.length;
              if (inductionVariable_7 < last_4)
                do {
                  var n_3 = inductionVariable_7;
                  inductionVariable_7 = inductionVariable_7 + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  // Inline function 'kotlin.code' call
                  var this_14 = this_12[n_3];
                  this_13[n_3] = Char__toInt_impl_vasixd(this_14);
                }
                 while (inductionVariable_7 < last_4);
              var ligatureSetOffsets = this_13;
              var glyphArray = this.e4p(this_8.f1j(coverageOffset_0), ligatureSetCount);
              var inductionVariable_8 = 0;
              var last_5 = ligatureSetOffsets.length - 1 | 0;
              if (inductionVariable_8 <= last_5)
                do {
                  var n_4 = inductionVariable_8;
                  inductionVariable_8 = inductionVariable_8 + 1 | 0;
                  var glyphID_0 = glyphArray[n_4];
                  var asetoffset = ligatureSetOffsets[n_4];
                  var map = LinkedHashMap.ac();
                  var codePoint = this.k4p(glyphID_0);
                  // Inline function 'kotlin.intArrayOf' call
                  var codePointIntArray = new Int32Array([codePoint]);
                  var maxComponentCount = 1;
                  // Inline function 'kotlin.apply' call
                  var this_15 = subsTable.f1j(asetoffset);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                  var ligatureCount = this_15.m1j();
                  // Inline function 'korlibs.datastructure.mapInt' call
                  var this_16 = this_15.s1j(ligatureCount);
                  // Inline function 'kotlin.also' call
                  var this_17 = new Int32Array(this_16.length);
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                  var inductionVariable_9 = 0;
                  var last_6 = this_16.length;
                  if (inductionVariable_9 < last_6)
                    do {
                      var n_5 = inductionVariable_9;
                      inductionVariable_9 = inductionVariable_9 + 1 | 0;
                      // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                      // Inline function 'kotlin.code' call
                      var this_18 = this_16[n_5];
                      this_17[n_5] = Char__toInt_impl_vasixd(this_18);
                    }
                     while (inductionVariable_9 < last_6);
                  var ligatureOffsets = this_17;
                  var inductionVariable_10 = 0;
                  var last_7 = ligatureOffsets.length;
                  while (inductionVariable_10 < last_7) {
                    var offset_0 = ligatureOffsets[inductionVariable_10];
                    inductionVariable_10 = inductionVariable_10 + 1 | 0;
                    // Inline function 'kotlin.apply' call
                    var this_19 = this_15.f1j(offset_0);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                    var ligatureGlyph = this_19.m1j();
                    var componentCount = this_19.m1j();
                    // Inline function 'kotlin.math.max' call
                    var a = maxComponentCount;
                    var b = componentCount + 1 | 0;
                    maxComponentCount = Math.max(a, b);
                    // Inline function 'korlibs.datastructure.mapInt' call
                    var this_20 = this_19.s1j(componentCount - 1 | 0);
                    // Inline function 'kotlin.also' call
                    var this_21 = new Int32Array(this_20.length);
                    // Inline function 'kotlin.contracts.contract' call
                    // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call
                    var inductionVariable_11 = 0;
                    var last_8 = this_20.length;
                    if (inductionVariable_11 < last_8)
                      do {
                        var n_6 = inductionVariable_11;
                        inductionVariable_11 = inductionVariable_11 + 1 | 0;
                        // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                        // Inline function 'kotlin.code' call
                        var this_22 = this_20[n_6];
                        var tmp$ret$22 = Char__toInt_impl_vasixd(this_22);
                        this_21[n_6] = this.k4p(tmp$ret$22);
                      }
                       while (inductionVariable_11 < last_8);
                    var componentCodePoints = this_21;
                    var tmp = Companion_getInstance_12();
                    // Inline function 'kotlin.collections.plus' call
                    var tmp$ret$26 = primitiveArrayConcat([codePointIntArray, componentCodePoints]);
                    var ligature = tmp.ss(tmp$ret$26);
                    // Inline function 'kotlin.collections.set' call
                    // Inline function 'kotlin.intArrayOf' call
                    var value = new Int32Array([ligatureGlyph]);
                    map.g3(ligature, value);
                  }
                  this.m4n_1.c2k(codePoint, new SubstitutionInfo(maxComponentCount, map));
                }
                 while (inductionVariable_8 <= last_5);
              break;
            default:
              // Inline function 'korlibs.logger.Logger.info' call

              var this_23 = Companion_getInstance_31().g4l_1;
              var level = Level_INFO_getInstance();
              var tmp_0;
              if (this_23.m2q(level)) {
                // Inline function 'korlibs.image.font.BaseTtfFont.readGsub.<anonymous>.<anonymous>.<anonymous>.<anonymous>.<anonymous>' call
                var tmp$ret$30 = 'TTF.GSUB: Unsupported lookupType=' + lookupType;
                this_23.n2q(level, tmp$ret$30);
                tmp_0 = Unit_instance;
              }

              break;
          }
        }
      }
    }
    return Unit_instance;
  }
  h4p() {
    var tmp111_safe_receiver = this.f4o('COLR');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>' call
      var version = tmp111_safe_receiver.m1j();
      switch (version) {
        case 0:
        case 1:
          var numBaseGlyphRecords = tmp111_safe_receiver.m1j();
          var baseGlyphRecordsOffset = tmp111_safe_receiver.o1j();
          var layerRecordsOffset = tmp111_safe_receiver.o1j();
          var numLayerRecords = tmp111_safe_receiver.m1j();
          // Inline function 'kotlin.apply' call

          var this_0 = tmp111_safe_receiver.f1j(layerRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var tmp = this;
          var tmp_0 = 0;
          // Inline function 'kotlin.arrayOfNulls' call

          var tmp_1 = fillArrayVal(Array(numLayerRecords), null);
          while (tmp_0 < numLayerRecords) {
            tmp_1[tmp_0] = new ColrLayerInfo(this, this_0.m1j(), this_0.m1j());
            tmp_0 = tmp_0 + 1 | 0;
          }

          tmp.g4n_1 = tmp_1;
          // Inline function 'kotlin.apply' call

          var this_1 = tmp111_safe_receiver.f1j(baseGlyphRecordsOffset);
          // Inline function 'kotlin.contracts.contract' call

          // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call

          var inductionVariable = 0;
          if (inductionVariable < numBaseGlyphRecords)
            do {
              var n = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var info = new ColrGlyphInfoV0(this, this_1.m1j(), this_1.m1j(), this_1.m1j());
              this.h4n_1.c2k(info.g4v_1, info);
            }
             while (inductionVariable < numBaseGlyphRecords);
          if (version === 1) {
            var baseGlyphListOffset = this.w4o(tmp111_safe_receiver);
            var layerListOffset = this.w4o(tmp111_safe_receiver);
            var clipListOffset = this.w4o(tmp111_safe_receiver);
            var varIdxMapOffset = this.w4o(tmp111_safe_receiver);
            var varStoreOffset = this.w4o(tmp111_safe_receiver);
            this.j4n_1.a4u_1.j3();
            var tmp_2 = this;
            var tmp126_s = tmp111_safe_receiver.f1j(0);
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_2 = tmp111_safe_receiver.f1j(layerListOffset);
            var tmp_3 = 0;
            var tmp_4 = this_2.o1j();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_5 = fillArrayVal(Array(tmp_4), null);
            while (tmp_3 < tmp_4) {
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_5[tmp_3] = this.w4o(this_2);
              tmp_3 = tmp_3 + 1 | 0;
            }
            var tmp127_layerList = toIntArray(tmp_5);
            var tmp128_sBaseOffset = tmp111_safe_receiver.f1j(baseGlyphListOffset);
            var tmp129_sLayerOffset = tmp111_safe_receiver.f1j(layerListOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_6;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_6 = clipListOffset;
            } else {
              tmp_6 = null;
            }
            var tmp125_safe_receiver = tmp_6;
            var tmp_7;
            if (tmp125_safe_receiver == null) {
              tmp_7 = null;
            } else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              tmp_7 = tmp111_safe_receiver.f1j(tmp125_safe_receiver);
            }
            var tmp130_sClipOffset = tmp_7;
            tmp_2.j4n_1 = new COLRv1(tmp127_layerList, tmp126_s, tmp128_sBaseOffset, tmp129_sLayerOffset, tmp130_sClipOffset);
            // Inline function 'kotlin.takeIf' call
            // Inline function 'kotlin.contracts.contract' call
            var tmp_8;
            // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
            if (!(clipListOffset === 0)) {
              tmp_8 = clipListOffset;
            } else {
              tmp_8 = null;
            }
            if (tmp_8 == null)
              null;
            else {
              // Inline function 'kotlin.let' call
              // Inline function 'kotlin.contracts.contract' call
              // Inline function 'korlibs.image.font.BaseTtfFont.readColr.<anonymous>.<anonymous>' call
              var s = tmp111_safe_receiver.f1j(clipListOffset);
              var format = s.k1j();
              // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
              var tmp_9 = 0;
              var tmp_10 = s.o1j();
              // Inline function 'kotlin.arrayOfNulls' call
              var tmp_11 = fillArrayVal(Array(tmp_10), null);
              while (tmp_9 < tmp_10) {
                var tmp_12 = tmp_9;
                var startGlyphID = s.m1j();
                var endGlyphID = s.m1j();
                var clipBoxOffset = this.v4o(s);
                var inductionVariable_0 = startGlyphID;
                if (inductionVariable_0 <= endGlyphID)
                  do {
                    var glyphID = inductionVariable_0;
                    inductionVariable_0 = inductionVariable_0 + 1 | 0;
                    this.j4n_1.a4u_1.a2l(glyphID, clipBoxOffset);
                  }
                   while (!(glyphID === endGlyphID));
                tmp_11[tmp_12] = Unit_instance;
                tmp_9 = tmp_9 + 1 | 0;
              }
            }
            // Inline function 'korlibs.image.font.BaseTtfFont.readArrayOf32' call
            var this_3 = tmp111_safe_receiver.f1j(baseGlyphListOffset);
            var tmp_13 = 0;
            var tmp_14 = this_3.o1j();
            // Inline function 'kotlin.arrayOfNulls' call
            var tmp_15 = fillArrayVal(Array(tmp_14), null);
            while (tmp_13 < tmp_14) {
              var tmp_16 = tmp_13;
              var glyphID_0 = this_3.m1j();
              var paint = this.w4o(this_3);
              this.h4n_1.c2k(glyphID_0, new ColrGlyphInfoV1(this, glyphID_0, paint));
              tmp_15[tmp_16] = Unit_instance;
              tmp_13 = tmp_13 + 1 | 0;
            }
          }

          break;
        default:
          println('TTF WARNING CCOLv' + version + ' not supported');
          break;
      }
    }
    return Unit_instance;
  }
  i4p() {
    var tmp111_safe_receiver = this.f4o('cmap');
    if (tmp111_safe_receiver == null)
      null;
    else {
      // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>' call
      var version = tmp111_safe_receiver.m1j();
      var numTables = tmp111_safe_receiver.m1j();
      // Inline function 'kotlin.collections.map' call
      var this_0 = until(0, numTables);
      // Inline function 'kotlin.collections.mapTo' call
      var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
      var tmp0_iterator = this_0.z();
      while (tmp0_iterator.a1()) {
        var item = tmp0_iterator.b1();
        // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>' call
        var tmp$ret$0 = new BaseTtfFont$readCmap$1$EncodingRecord(tmp111_safe_receiver.m1j(), tmp111_safe_receiver.m1j(), tmp111_safe_receiver.o1j());
        destination.f(tmp$ret$0);
      }
      var tables = destination;
      var index = 0;
      var _iterator__ex2g4s = tables.z();
      while (_iterator__ex2g4s.a1()) {
        var table = _iterator__ex2g4s.b1();
        // Inline function 'kotlin.run' call
        // Inline function 'kotlin.contracts.contract' call
        var $this$run = tmp111_safe_receiver.f1j(table.q4x_1);
        var format = $this$run.m1j();
        try {
          switch (format) {
            case 0:
              var length = $this$run.m1j();
              var language = $this$run.m1j();
              // Inline function 'korlibs.datastructure.mapInt' call

              var this_1 = $this$run.i1j(256);
              // Inline function 'kotlin.also' call

              var this_2 = new Int32Array(this_1.length);
              // Inline function 'kotlin.contracts.contract' call

              // Inline function 'korlibs.datastructure.mapInt.<anonymous>' call

              var inductionVariable = 0;
              var last = this_1.length;
              if (inductionVariable < last)
                do {
                  var n = inductionVariable;
                  inductionVariable = inductionVariable + 1 | 0;
                  // Inline function 'korlibs.image.font.BaseTtfFont.readCmap.<anonymous>.<anonymous>.<anonymous>' call
                  this_2[n] = this_1[n] & 255;
                }
                 while (inductionVariable < last);
              var glyphIdArray = this_2;
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < 256)
                do {
                  var n_0 = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  this.a4o(n_0, glyphIdArray[n_0]);
                }
                 while (inductionVariable_0 < 256);
              break;
            case 2:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 4:
              var length_0 = $this$run.m1j();
              var language_0 = $this$run.m1j();
              var segCount = $this$run.m1j() / 2 | 0;
              var searchRangeS = $this$run.m1j();
              var entrySelector = $this$run.m1j();
              var rangeShift = $this$run.m1j();
              var endCount = $this$run.s1j(segCount);
              $this$run.m1j();
              var startCount = $this$run.s1j(segCount);
              var idDelta = $this$run.r1j(segCount);
              var rangeOffsetPos = $this$run.b1j();
              var idRangeOffset = $this$run.s1j(segCount);
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < segCount)
                do {
                  var n_1 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  var ec = Char__toInt_impl_vasixd(endCount[n_1]);
                  var sc = Char__toInt_impl_vasixd(startCount[n_1]);
                  var delta = idDelta[n_1];
                  var iro = Char__toInt_impl_vasixd(idRangeOffset[n_1]);
                  var inductionVariable_2 = sc;
                  if (inductionVariable_2 <= ec)
                    do {
                      var c = inductionVariable_2;
                      inductionVariable_2 = inductionVariable_2 + 1 | 0;
                      if (!(iro === 0)) {
                        var glyphIndexOffset = rangeOffsetPos + imul(n_1, 2) | 0;
                        glyphIndexOffset = glyphIndexOffset + iro | 0;
                        glyphIndexOffset = glyphIndexOffset + imul(c - sc | 0, 2) | 0;
                        index = $this$run.f1j(glyphIndexOffset).m1j();
                        if (!(index === 0)) {
                          index = index + delta | 0;
                        }
                      } else {
                        index = c + delta | 0;
                      }
                      this.z4n(c, index & 65535);
                    }
                     while (!(c === ec));
                }
                 while (inductionVariable_1 < segCount);
              break;
            case 6:
              var length_1 = $this$run.m1j();
              var language_1 = $this$run.m1j();
              var firstCode = $this$run.m1j();
              var entryCount = $this$run.m1j();
              var inductionVariable_3 = 0;
              if (inductionVariable_3 < entryCount)
                do {
                  var n_2 = inductionVariable_3;
                  inductionVariable_3 = inductionVariable_3 + 1 | 0;
                  var codePoint = firstCode + n_2 | 0;
                  this.z4n(codePoint, $this$run.m1j());
                }
                 while (inductionVariable_3 < entryCount);
              break;
            case 8:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 10:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            case 12:
              $this$run.m1j();
              var length_2 = $this$run.o1j();
              var language_2 = $this$run.o1j();
              var numGroups = $this$run.o1j();
              var inductionVariable_4 = 0;
              if (inductionVariable_4 < numGroups)
                do {
                  var n_3 = inductionVariable_4;
                  inductionVariable_4 = inductionVariable_4 + 1 | 0;
                  var startCharCode = $this$run.o1j();
                  var endCharCode = $this$run.o1j();
                  var startGlyphId = $this$run.o1j();
                  var inductionVariable_5 = startCharCode;
                  if (inductionVariable_5 <= endCharCode)
                    do {
                      var c_0 = inductionVariable_5;
                      inductionVariable_5 = inductionVariable_5 + 1 | 0;
                      var m = c_0 - startCharCode | 0;
                      this.z4n(c_0, startGlyphId + m | 0);
                    }
                     while (!(c_0 === endCharCode));
                }
                 while (inductionVariable_4 < numGroups);
              break;
            case 13:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
            default:
              println('UNSUPPORTED CMAP format = ' + format);
              break;
          }
        } catch ($p) {
          if ($p instanceof Error) {
            var e = $p;
            printStackTrace(e);
          } else {
            throw $p;
          }
        }
      }
    }
    return Unit_instance;
  }
  j4p(charIndex, default_0) {
    // Inline function 'kotlin.collections.getOrElse' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp0_elvis_lhs = this.d4n_1.b3(charIndex);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.font.BaseTtfFont.getCodePointFromCharIndexOrElse.<anonymous>' call
      tmp = default_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  k4p(charIndex, default_0, $super) {
    default_0 = default_0 === VOID ? -1 : default_0;
    return $super === VOID ? this.j4p(charIndex, default_0) : $super.j4p.call(this, charIndex, default_0);
  }
  l4p(reader, codePoint, cache) {
    var g = this.o4p(codePoint);
    var skipCount = 1;
    if (this.l4l_1 && !(g == null)) {
      var subs = this.m4n_1.c1(codePoint);
      if (!(reader == null) && !(subs == null)) {
        // Inline function 'kotlin.math.min' call
        var a = reader.es();
        var b = subs.o4q_1;
        var inductionVariable = Math.min(a, b);
        if (2 <= inductionVariable)
          $l$loop_0: do {
            var count = inductionVariable;
            inductionVariable = inductionVariable + -1 | 0;
            var sub = reader.qs(0, count);
            var replacement = subs.p4q_1.b3(sub);
            if (!(replacement == null)) {
              skipCount = sub.a();
              var tmp0_elvis_lhs = this.q4p(first_1(replacement));
              var tmp;
              if (tmp0_elvis_lhs == null) {
                break $l$loop_0;
              } else {
                tmp = tmp0_elvis_lhs;
              }
              g = tmp;
              break $l$loop_0;
            }
          }
           while (2 <= inductionVariable);
      }
    }
    if (reader == null)
      null;
    else {
      reader.ps(skipCount);
    }
    return g;
  }
  m4p(reader, codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.l4p(reader, codePoint, cache) : $super.l4p.call(this, reader, codePoint, cache);
  }
  n4p(codePoint, cache) {
    var tmp134_safe_receiver = this.y4n(codePoint);
    var tmp;
    if (tmp134_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByCodePoint.<anonymous>' call
      tmp = this.p4p(tmp134_safe_receiver, cache, codePoint);
    }
    return tmp;
  }
  o4p(codePoint, cache, $super) {
    cache = cache === VOID ? true : cache;
    return $super === VOID ? this.n4p(codePoint, cache) : $super.n4p.call(this, codePoint, cache);
  }
  p4p(index, cache, codePoint) {
    var cff = this.q4n_1;
    if (!(cff == null)) {
      // Inline function 'korlibs.datastructure.IntMap.getOrPut' call
      var this_0 = this.e4n_1;
      var res = this_0.c1(index);
      if (res == null) {
        // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
        var gvector = cff.z4j(index);
        var tmp$ret$0 = new CFFGlyph(this, index, 0, 0, 0, 0, numberToInt(gvector.d4j_1), new GlyphGraphicsPath(index, gvector.c4j_1));
        this_0.c2k(index, tmp$ret$0);
      }
      return ensureNotNull(this_0.c1(index));
    }
    var tmp0_elvis_lhs = getOrNull_0(this.p4m_1, index);
    var start = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    var tmp1_elvis_lhs = getOrNull_0(this.p4m_1, index + 1 | 0);
    var end = tmp1_elvis_lhs == null ? start : tmp1_elvis_lhs;
    var size = end - start | 0;
    var tmp;
    if (!(size === 0)) {
      var tmp2_elvis_lhs = this.e4n_1.c1(index);
      var tmp_0;
      if (tmp2_elvis_lhs == null) {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.image.font.BaseTtfFont.runTable' call
          var tmp0_elvis_lhs_0 = this.v4n('glyf');
          var tmp_1;
          if (tmp0_elvis_lhs_0 == null) {
            tmp$ret$2 = null;
            break $l$block;
          } else {
            tmp_1 = tmp0_elvis_lhs_0;
          }
          var table = tmp_1;
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
          var $this$runTable = table.q4q();
          // Inline function 'kotlin.also' call
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>.<anonymous>' call
          tmp$ret$2 = this.u4p($this$runTable.f1j(start), index);
        }
        tmp_0 = tmp$ret$2;
      } else {
        tmp_0 = tmp2_elvis_lhs;
      }
      tmp = tmp_0;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.intArrayOf' call
      var tmp_2 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_3 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp_4 = new Int32Array([]);
      // Inline function 'kotlin.intArrayOf' call
      var tmp$ret$9 = new Int32Array([]);
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.BaseTtfFont.getGlyphByIndex.<anonymous>' call
      tmp = new SimpleGlyph(this, index, 0, 0, 0, 0, tmp_2, tmp_3, tmp_4, tmp$ret$9, this.b4n_1.c1(index).r4q_1, true);
    }
    var glyph = tmp;
    if (cache && !this.k4n_1) {
      this.e4n_1.c2k(index, glyph);
    }
    return glyph;
  }
  q4p(index, cache, codePoint, $super) {
    cache = cache === VOID ? true : cache;
    codePoint = codePoint === VOID ? -1 : codePoint;
    return $super === VOID ? this.p4p(index, cache, codePoint) : $super.p4p.call(this, index, cache, codePoint);
  }
  r4p(_this__u8e3s4) {
    var v = _this__u8e3s4.l1j();
    var i = extractSigned(v, 14, 2);
    var f = extract(v, 0, 14);
    return i + f / 16384.0;
  }
  s4p(_this__u8e3s4) {
    var v = _this__u8e3s4.o1j();
    var i = extractSigned(v, 16, 16);
    var f = extract(v, 0, 16);
    return i + f / 65536.0;
  }
  t4p(_this__u8e3s4, signed, word) {
    var tmp;
    if (!word && signed) {
      tmp = _this__u8e3s4.j1j();
    } else if (!word && !signed) {
      tmp = _this__u8e3s4.k1j();
    } else if (word && signed) {
      tmp = _this__u8e3s4.l1j();
    } else if (word && !signed) {
      tmp = _this__u8e3s4.m1j();
    } else {
      get_invalidOp();
    }
    return tmp;
  }
  u4p(_this__u8e3s4, index) {
    var ncontours = _this__u8e3s4.l1j();
    var xMin = _this__u8e3s4.l1j();
    var yMin = _this__u8e3s4.l1j();
    var xMax = _this__u8e3s4.l1j();
    var yMax = _this__u8e3s4.l1j();
    var advanceWidth = this.b4n_1.c1(index).r4q_1;
    // Inline function 'kotlin.also' call
    var tmp;
    if (ncontours < 0) {
      var ARG_1_AND_2_ARE_WORDS = 1;
      var ARGS_ARE_XY_VALUES = 2;
      var ROUND_XY_TO_GRID = 4;
      var WE_HAVE_A_SCALE = 8;
      var MORE_COMPONENTS = 32;
      var WE_HAVE_AN_X_AND_Y_SCALE = 64;
      var WE_HAVE_A_TWO_BY_TWO = 128;
      var WE_HAVE_INSTRUCTIONS = 256;
      var USE_MY_METRICS = 512;
      var OVERLAP_COMPOUND = 1024;
      var SCALED_COMPONENT_OFFSET = 2048;
      var UNSCALED_COMPONENT_OFFSET = 4096;
      // Inline function 'kotlin.collections.arrayListOf' call
      var references = ArrayList.p1();
      do {
        var flags = _this__u8e3s4.m1j();
        var glyphIndex = _this__u8e3s4.m1j();
        var signed = !((flags & ARGS_ARE_XY_VALUES) === 0);
        var words = !((flags & ARG_1_AND_2_ARE_WORDS) === 0);
        var x = this.t4p(_this__u8e3s4, signed, words);
        var y = this.t4p(_this__u8e3s4, signed, words);
        var scaleX = 1.0;
        var scaleY = 1.0;
        var scale01 = 0.0;
        var scale10 = 0.0;
        if (!((flags & WE_HAVE_A_SCALE) === 0)) {
          scaleX = this.r4p(_this__u8e3s4);
          scaleY = scaleX;
        } else if (!((flags & WE_HAVE_AN_X_AND_Y_SCALE) === 0)) {
          scaleX = this.r4p(_this__u8e3s4);
          scaleY = this.r4p(_this__u8e3s4);
        } else if (!((flags & WE_HAVE_A_TWO_BY_TWO) === 0)) {
          scaleX = this.r4p(_this__u8e3s4);
          scale01 = this.r4p(_this__u8e3s4);
          scale10 = this.r4p(_this__u8e3s4);
          scaleY = this.r4p(_this__u8e3s4);
        }
        var ref = new GlyphReference(ensureNotNull(this.q4p(glyphIndex)), x, y, scaleX, scale01, scale10, scaleY);
        // Inline function 'kotlin.collections.plusAssign' call
        references.f(ref);
      }
       while (!((flags & MORE_COMPONENTS) === 0));
      tmp = new CompositeGlyph(this, index, xMin, yMin, xMax, yMax, references, advanceWidth);
    } else {
      var contoursIndices = new Int32Array(ncontours + 1 | 0);
      contoursIndices[0] = -1;
      var inductionVariable = 1;
      if (inductionVariable <= ncontours)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          contoursIndices[n] = _this__u8e3s4.m1j();
        }
         while (!(n === ncontours));
      var instructionLength = _this__u8e3s4.m1j();
      var instructions = _this__u8e3s4.i1j(instructionLength);
      var tmp139_safe_receiver = lastOrNull(contoursIndices);
      var tmp0_elvis_lhs = tmp139_safe_receiver == null ? null : tmp139_safe_receiver + 1 | 0;
      var numPoints = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var flags_0 = IntArrayList.w2e();
      var npos = 0;
      while (npos < numPoints) {
        var cf = _this__u8e3s4.k1j();
        flags_0.c2f(cf);
        if (!((cf & 8) === 0)) {
          var count = _this__u8e3s4.k1j();
          var inductionVariable_0 = 0;
          if (inductionVariable_0 < count)
            do {
              var n_0 = inductionVariable_0;
              inductionVariable_0 = inductionVariable_0 + 1 | 0;
              flags_0.c2f(cf);
            }
             while (inductionVariable_0 < count);
          npos = npos + (count + 1 | 0) | 0;
        } else {
          npos = npos + 1 | 0;
        }
      }
      var xPos = new Int32Array(numPoints);
      var yPos = new Int32Array(numPoints);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= 1)
        do {
          var xy = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var pos = xy === 0 ? xPos : yPos;
          var p = 0;
          var inductionVariable_2 = 0;
          if (inductionVariable_2 < numPoints)
            do {
              var n_1 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var flag = flags_0.ow(n_1);
              var b1 = !(((flag >>> (1 + xy | 0) | 0) & 1) === 0);
              var b2 = !(((flag >>> (4 + xy | 0) | 0) & 1) === 0);
              if (b1) {
                var magnitude = _this__u8e3s4.k1j();
                if (b2)
                  p = p + magnitude | 0;
                else
                  p = p - magnitude | 0;
              } else if (!b2) {
                p = p + _this__u8e3s4.l1j() | 0;
              }
              pos[n_1] = p;
            }
             while (inductionVariable_2 < numPoints);
        }
         while (inductionVariable_1 <= 1);
      tmp = new SimpleGlyph(this, index, xMin, yMin, xMax, yMax, contoursIndices, flags_0.n2f(), xPos, yPos, advanceWidth);
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BaseTtfFont.readGlyph.<anonymous>' call
    return tmp;
  }
}
class TtfFont extends BaseTtfFont {
  static f4b(d, extName, onlyReadMetadata, enableLigatures) {
    Companion_getInstance_31();
    extName = extName === VOID ? null : extName;
    onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
    enableLigatures = enableLigatures === VOID ? true : enableLigatures;
    var $this = this.r4n(d, extName, onlyReadMetadata, enableLigatures);
    $this.e4b_1 = LinkedHashMap.ac();
    $this.s4n();
    return $this;
  }
  t4n() {
    this.e4b_1.i3(Companion_instance_23.u4n(this.i4l_1.g1j()));
  }
  v4n(name) {
    return this.e4b_1.b3(name);
  }
}
class Companion_15 {
  constructor() {
    this.b4q_1 = 26;
  }
}
class Companion_16 {
  constructor() {
    Companion_instance_22 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.plus' call
    // Inline function 'kotlin.arrayOfNulls' call
    var this_0 = fillArrayVal(Array(1), null);
    var elements = values_3();
    // Inline function 'kotlin.js.asDynamic' call
    tmp.c4q_1 = this_0.concat(elements);
  }
}
class NamesInfo {
  constructor() {
    var tmp = this;
    // Inline function 'kotlin.arrayOfNulls' call
    tmp.d4q_1 = fillArrayVal(Array(26), null);
    this.e4q_1 = new Int32Array(26);
    var tmp_0 = this;
    var tmp_1 = 0;
    var tmp_2 = new Int32Array(26);
    while (tmp_1 < 26) {
      tmp_2[tmp_1] = -1;
      tmp_1 = tmp_1 + 1 | 0;
    }
    tmp_0.f4q_1 = tmp_2;
    var tmp_3 = this;
    var tmp_4 = 0;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_5 = fillArrayVal(Array(26), null);
    while (tmp_4 < 26) {
      tmp_5[tmp_4] = get_UTF8();
      tmp_4 = tmp_4 + 1 | 0;
    }
    tmp_3.g4q_1 = tmp_5;
    this.h4q_1 = null;
  }
  c4o() {
    var tmp0_elvis_lhs = this.i4q(NameId_NAME_getInstance());
    var tmp1_elvis_lhs = tmp0_elvis_lhs == null ? this.i4q(NameId_COMPLETE_NAME_getInstance()) : tmp0_elvis_lhs;
    return tmp1_elvis_lhs == null ? 'TtfFont' : tmp1_elvis_lhs;
  }
  j4q(nameId) {
    if (this.d4q_1[nameId] == null) {
      var nameLength = this.f4q_1[nameId];
      if (nameLength < 0)
        return null;
      var string = ensureNotNull(this.h4q_1).v1j(this.e4q_1[nameId], nameLength, this.g4q_1[nameId]);
      var tmp;
      // Inline function 'kotlin.text.isEmpty' call
      if (charSequenceLength(string) === 0) {
        tmp = string;
      } else {
        if (charSequenceGet(string, 0) === _Char___init__impl__6a9atx(0)) {
          // Inline function 'kotlin.text.filter' call
          // Inline function 'kotlin.text.filterTo' call
          var destination = StringBuilder.h();
          var inductionVariable = 0;
          var last = charSequenceLength(string);
          if (inductionVariable < last)
            do {
              var index = inductionVariable;
              inductionVariable = inductionVariable + 1 | 0;
              var element = charSequenceGet(string, index);
              // Inline function 'korlibs.image.font.NamesInfo.getName.<anonymous>' call
              if (!(element === _Char___init__impl__6a9atx(0))) {
                destination.ob(element);
              }
            }
             while (inductionVariable < last);
          tmp = destination.toString();
        } else {
          tmp = string;
        }
      }
      this.d4q_1[nameId] = tmp;
    }
    return this.d4q_1[nameId];
  }
  i4q(nameId) {
    return this.j4q(nameId.m4q_1);
  }
  n4q() {
    // Inline function 'kotlin.collections.associateWith' call
    var this_0 = values_2();
    var result = LinkedHashMap.bc(coerceAtLeast(mapCapacity(this_0.length), 16));
    // Inline function 'kotlin.collections.associateWithTo' call
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.font.NamesInfo.toMap.<anonymous>' call
      var tmp$ret$0 = this.i4q(element);
      result.g3(element, tmp$ret$0);
    }
    return result;
  }
  toString() {
    return 'NamesInfo(' + toString_0(this.n4q()) + ')';
  }
}
class SubstitutionInfo {
  constructor(maxSequence, map) {
    this.o4q_1 = maxSequence;
    this.p4q_1 = map;
  }
}
class Table {
  constructor(id, checksum, offset, length) {
    this.v4p_1 = id;
    this.w4p_1 = checksum;
    this.x4p_1 = offset;
    this.y4p_1 = length;
    this.z4p_1 = null;
    var tmp = this;
    tmp.a4q_1 = lazy(BaseTtfFont$Table$ss$delegate$lambda(this));
  }
  q4q() {
    return _get_ss__ndcawb(this).qw();
  }
  toString() {
    return 'Table(id=' + this.v4p_1 + ', checksum=' + this.w4p_1 + ', offset=' + this.x4p_1 + ', length=' + this.y4p_1 + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.v4p_1);
    result = imul(result, 31) + this.w4p_1 | 0;
    result = imul(result, 31) + this.x4p_1 | 0;
    result = imul(result, 31) + this.y4p_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Table))
      return false;
    var tmp0_other_with_cast = other instanceof Table ? other : THROW_CCE();
    if (!(this.v4p_1 === tmp0_other_with_cast.v4p_1))
      return false;
    if (!(this.w4p_1 === tmp0_other_with_cast.w4p_1))
      return false;
    if (!(this.x4p_1 === tmp0_other_with_cast.x4p_1))
      return false;
    if (!(this.y4p_1 === tmp0_other_with_cast.y4p_1))
      return false;
    return true;
  }
}
class HorMetric {
  constructor(advanceWidth, lsb) {
    this.r4q_1 = advanceWidth;
    this.s4q_1 = lsb;
  }
  toString() {
    return 'HorMetric(advanceWidth=' + this.r4q_1 + ', lsb=' + this.s4q_1 + ')';
  }
  hashCode() {
    var result = this.r4q_1;
    result = imul(result, 31) + this.s4q_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof HorMetric))
      return false;
    var tmp0_other_with_cast = other instanceof HorMetric ? other : THROW_CCE();
    if (!(this.r4q_1 === tmp0_other_with_cast.r4q_1))
      return false;
    if (!(this.s4q_1 === tmp0_other_with_cast.s4q_1))
      return false;
    return true;
  }
}
class Companion_17 {
  t4q(s, info) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    var format = s.m1j();
    var count = s.m1j();
    var stringOffset = s.m1j();
    var inductionVariable = 0;
    if (inductionVariable < count)
      $l$loop: do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var platformId = s.m1j();
        var encodingId = s.m1j();
        var languageId = s.m1j();
        var nameId = s.m1j();
        var length = s.m1j();
        var offset = s.m1j();
        if (nameId < 0 || nameId >= 26)
          continue $l$loop;
        var charset;
        switch (encodingId) {
          case 0:
            charset = get_UTF8();
            break;
          case 1:
            charset = get_UTF16_BE();
            break;
          default:
            charset = get_UTF16_BE();
            break;
        }
        if (platformId === 0 && languageId === 0 || info.f4q_1[nameId] === -1) {
          info.e4q_1[nameId] = stringOffset + offset | 0;
          info.f4q_1[nameId] = length;
          info.g4q_1[nameId] = charset;
          info.h4q_1 = s;
        }
      }
       while (inductionVariable < count);
    return Unit_instance;
  }
  u4n(s) {
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    if (s.o1j() === 1953784678) {
      var majorVersion = s.m1j();
      var minorVersion = s.m1j();
      var numFonts = s.o1j();
      var tableDirectoryOffsets = s.u1j(numFonts);
      if (majorVersion >= 2) {
        var dsigTag = s.o1j();
        var dsigLength = s.o1j();
        var dsigOffset = s.o1j();
      }
      s.a1j(tableDirectoryOffsets[0]);
    } else {
      s.h1j(4);
    }
    // Inline function 'kotlin.apply' call
    var this_0 = s.m1j();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_0 === 1) && !(this_0 === 20308)) {
      invalidOp('Not a TTF/OTF file');
    }
    var majorVersion_0 = this_0;
    // Inline function 'kotlin.apply' call
    var this_1 = s.m1j();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
    if (!(this_1 === 0) && !(this_1 === 21583)) {
      invalidOp('Not a TTF/OTF file');
    }
    var minorVersion_0 = this_1;
    var numTables = s.m1j();
    var searchRange = s.m1j();
    var entrySelector = s.m1j();
    var rangeShift = s.m1j();
    // Inline function 'kotlin.collections.map' call
    var this_2 = until(0, numTables);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator = this_2.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.font.Companion.readHeaderTables.<anonymous>.<anonymous>' call
      var tmp$ret$2 = new Table(s.x1j(4), s.o1j(), s.o1j(), s.o1j());
      destination.f(tmp$ret$2);
    }
    var tables = destination;
    var tablesByName = LinkedHashMap.ac();
    var _iterator__ex2g4s = tables.z();
    while (_iterator__ex2g4s.a1()) {
      var table = _iterator__ex2g4s.b1();
      var tmp = table;
      tmp.z4p_1 = BaseTtfFont$Companion$readHeaderTables$lambda(s, table);
      // Inline function 'kotlin.collections.set' call
      var key = table.v4p_1;
      tablesByName.g3(key, table);
    }
    return tablesByName;
  }
}
class NameId extends Enum {
  constructor(name, ordinal, id) {
    super(name, ordinal);
    this.m4q_1 = id;
  }
}
class ColorBitmapInfo {
  constructor(indexSubTableArrayOffset, indexTablesSize, numberofIndexSubTables, colorRef, hori, vert, startGlyphIndex, endGlyphIndex, ppemX, ppemY, bitDepth, flags) {
    indexSubTableArrayOffset = indexSubTableArrayOffset === VOID ? 0 : indexSubTableArrayOffset;
    indexTablesSize = indexTablesSize === VOID ? 0 : indexTablesSize;
    numberofIndexSubTables = numberofIndexSubTables === VOID ? 0 : numberofIndexSubTables;
    colorRef = colorRef === VOID ? 0 : colorRef;
    hori = hori === VOID ? new SbitLineMetrics() : hori;
    vert = vert === VOID ? new SbitLineMetrics() : vert;
    startGlyphIndex = startGlyphIndex === VOID ? 0 : startGlyphIndex;
    endGlyphIndex = endGlyphIndex === VOID ? 0 : endGlyphIndex;
    ppemX = ppemX === VOID ? 0 : ppemX;
    ppemY = ppemY === VOID ? 0 : ppemY;
    bitDepth = bitDepth === VOID ? 0 : bitDepth;
    flags = flags === VOID ? 0 : flags;
    this.u4q_1 = indexSubTableArrayOffset;
    this.v4q_1 = indexTablesSize;
    this.w4q_1 = numberofIndexSubTables;
    this.x4q_1 = colorRef;
    this.y4q_1 = hori;
    this.z4q_1 = vert;
    this.a4r_1 = startGlyphIndex;
    this.b4r_1 = endGlyphIndex;
    this.c4r_1 = ppemX;
    this.d4r_1 = ppemY;
    this.e4r_1 = bitDepth;
    this.f4r_1 = flags;
  }
  toString() {
    return 'ColorBitmapInfo(indexSubTableArrayOffset=' + this.u4q_1 + ', indexTablesSize=' + this.v4q_1 + ', numberofIndexSubTables=' + this.w4q_1 + ', colorRef=' + this.x4q_1 + ', hori=' + this.y4q_1.toString() + ', vert=' + this.z4q_1.toString() + ', startGlyphIndex=' + this.a4r_1 + ', endGlyphIndex=' + this.b4r_1 + ', ppemX=' + this.c4r_1 + ', ppemY=' + this.d4r_1 + ', bitDepth=' + this.e4r_1 + ', flags=' + this.f4r_1 + ')';
  }
  hashCode() {
    var result = this.u4q_1;
    result = imul(result, 31) + this.v4q_1 | 0;
    result = imul(result, 31) + this.w4q_1 | 0;
    result = imul(result, 31) + this.x4q_1 | 0;
    result = imul(result, 31) + this.y4q_1.hashCode() | 0;
    result = imul(result, 31) + this.z4q_1.hashCode() | 0;
    result = imul(result, 31) + this.a4r_1 | 0;
    result = imul(result, 31) + this.b4r_1 | 0;
    result = imul(result, 31) + this.c4r_1 | 0;
    result = imul(result, 31) + this.d4r_1 | 0;
    result = imul(result, 31) + this.e4r_1 | 0;
    result = imul(result, 31) + this.f4r_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorBitmapInfo))
      return false;
    var tmp0_other_with_cast = other instanceof ColorBitmapInfo ? other : THROW_CCE();
    if (!(this.u4q_1 === tmp0_other_with_cast.u4q_1))
      return false;
    if (!(this.v4q_1 === tmp0_other_with_cast.v4q_1))
      return false;
    if (!(this.w4q_1 === tmp0_other_with_cast.w4q_1))
      return false;
    if (!(this.x4q_1 === tmp0_other_with_cast.x4q_1))
      return false;
    if (!this.y4q_1.equals(tmp0_other_with_cast.y4q_1))
      return false;
    if (!this.z4q_1.equals(tmp0_other_with_cast.z4q_1))
      return false;
    if (!(this.a4r_1 === tmp0_other_with_cast.a4r_1))
      return false;
    if (!(this.b4r_1 === tmp0_other_with_cast.b4r_1))
      return false;
    if (!(this.c4r_1 === tmp0_other_with_cast.c4r_1))
      return false;
    if (!(this.d4r_1 === tmp0_other_with_cast.d4r_1))
      return false;
    if (!(this.e4r_1 === tmp0_other_with_cast.e4r_1))
      return false;
    if (!(this.f4r_1 === tmp0_other_with_cast.f4r_1))
      return false;
    return true;
  }
}
class SbitLineMetrics {
  constructor(ascender, descender, widthMax, caretSlopeNumerator, caretSlopeDenominator, caretOffset, minOriginSB, minAdvanceSB, maxBeforeBL, minAfterBL, pad1, pad2) {
    ascender = ascender === VOID ? 0 : ascender;
    descender = descender === VOID ? 0 : descender;
    widthMax = widthMax === VOID ? 0 : widthMax;
    caretSlopeNumerator = caretSlopeNumerator === VOID ? 0 : caretSlopeNumerator;
    caretSlopeDenominator = caretSlopeDenominator === VOID ? 0 : caretSlopeDenominator;
    caretOffset = caretOffset === VOID ? 0 : caretOffset;
    minOriginSB = minOriginSB === VOID ? 0 : minOriginSB;
    minAdvanceSB = minAdvanceSB === VOID ? 0 : minAdvanceSB;
    maxBeforeBL = maxBeforeBL === VOID ? 0 : maxBeforeBL;
    minAfterBL = minAfterBL === VOID ? 0 : minAfterBL;
    pad1 = pad1 === VOID ? 0 : pad1;
    pad2 = pad2 === VOID ? 0 : pad2;
    this.g4r_1 = ascender;
    this.h4r_1 = descender;
    this.i4r_1 = widthMax;
    this.j4r_1 = caretSlopeNumerator;
    this.k4r_1 = caretSlopeDenominator;
    this.l4r_1 = caretOffset;
    this.m4r_1 = minOriginSB;
    this.n4r_1 = minAdvanceSB;
    this.o4r_1 = maxBeforeBL;
    this.p4r_1 = minAfterBL;
    this.q4r_1 = pad1;
    this.r4r_1 = pad2;
  }
  toString() {
    return 'SbitLineMetrics(ascender=' + this.g4r_1 + ', descender=' + this.h4r_1 + ', widthMax=' + this.i4r_1 + ', caretSlopeNumerator=' + this.j4r_1 + ', caretSlopeDenominator=' + this.k4r_1 + ', caretOffset=' + this.l4r_1 + ', minOriginSB=' + this.m4r_1 + ', minAdvanceSB=' + this.n4r_1 + ', maxBeforeBL=' + this.o4r_1 + ', minAfterBL=' + this.p4r_1 + ', pad1=' + this.q4r_1 + ', pad2=' + this.r4r_1 + ')';
  }
  hashCode() {
    var result = this.g4r_1;
    result = imul(result, 31) + this.h4r_1 | 0;
    result = imul(result, 31) + this.i4r_1 | 0;
    result = imul(result, 31) + this.j4r_1 | 0;
    result = imul(result, 31) + this.k4r_1 | 0;
    result = imul(result, 31) + this.l4r_1 | 0;
    result = imul(result, 31) + this.m4r_1 | 0;
    result = imul(result, 31) + this.n4r_1 | 0;
    result = imul(result, 31) + this.o4r_1 | 0;
    result = imul(result, 31) + this.p4r_1 | 0;
    result = imul(result, 31) + this.q4r_1 | 0;
    result = imul(result, 31) + this.r4r_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof SbitLineMetrics))
      return false;
    var tmp0_other_with_cast = other instanceof SbitLineMetrics ? other : THROW_CCE();
    if (!(this.g4r_1 === tmp0_other_with_cast.g4r_1))
      return false;
    if (!(this.h4r_1 === tmp0_other_with_cast.h4r_1))
      return false;
    if (!(this.i4r_1 === tmp0_other_with_cast.i4r_1))
      return false;
    if (!(this.j4r_1 === tmp0_other_with_cast.j4r_1))
      return false;
    if (!(this.k4r_1 === tmp0_other_with_cast.k4r_1))
      return false;
    if (!(this.l4r_1 === tmp0_other_with_cast.l4r_1))
      return false;
    if (!(this.m4r_1 === tmp0_other_with_cast.m4r_1))
      return false;
    if (!(this.n4r_1 === tmp0_other_with_cast.n4r_1))
      return false;
    if (!(this.o4r_1 === tmp0_other_with_cast.o4r_1))
      return false;
    if (!(this.p4r_1 === tmp0_other_with_cast.p4r_1))
      return false;
    if (!(this.q4r_1 === tmp0_other_with_cast.q4r_1))
      return false;
    if (!(this.r4r_1 === tmp0_other_with_cast.r4r_1))
      return false;
    return true;
  }
}
class BitmapGlyphInfo {
  constructor(glyphID, imageFormat, offset, size, info, height, width, horiBearingX, horiBearingY, horiAdvance, vertBearingX, vertBearingY, vertAdvance) {
    imageFormat = imageFormat === VOID ? 0 : imageFormat;
    offset = offset === VOID ? 0 : offset;
    size = size === VOID ? 0 : size;
    height = height === VOID ? 0 : height;
    width = width === VOID ? 0 : width;
    horiBearingX = horiBearingX === VOID ? 0 : horiBearingX;
    horiBearingY = horiBearingY === VOID ? 0 : horiBearingY;
    horiAdvance = horiAdvance === VOID ? 0 : horiAdvance;
    vertBearingX = vertBearingX === VOID ? 0 : vertBearingX;
    vertBearingY = vertBearingY === VOID ? 0 : vertBearingY;
    vertAdvance = vertAdvance === VOID ? 0 : vertAdvance;
    this.s4r_1 = glyphID;
    this.t4r_1 = imageFormat;
    this.u4r_1 = offset;
    this.v4r_1 = size;
    this.w4r_1 = info;
    this.x4r_1 = height;
    this.y4r_1 = width;
    this.z4r_1 = horiBearingX;
    this.a4s_1 = horiBearingY;
    this.b4s_1 = horiAdvance;
    this.c4s_1 = vertBearingX;
    this.d4s_1 = vertBearingY;
    this.e4s_1 = vertAdvance;
    this.f4s_1 = null;
    this.g4s_1 = null;
  }
  h4s() {
    return this.w4r_1.y4q_1.h4r_1;
  }
  i4s(cache) {
    var tmp0_elvis_lhs = this.g4s_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var tmp_0;
      try {
        tmp_0 = PNG_getInstance().l4s(toSyncStream(ensureNotNull(this.f4s_1)));
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          println('Error in TtfFont.BitmapGlyphInfo: ' + e.message);
          // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
          var tmp$ret$0 = get_Bitmaps_transparent();
          tmp_1 = get_bmp(tmp$ret$0);
        } else {
          throw $p;
        }
        tmp_0 = tmp_1;
      }
      tmp = tmp_0;
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var bmp = tmp;
    if (cache)
      this.g4s_1 = bmp;
    return bmp;
  }
  m4s(cache, $super) {
    cache = cache === VOID ? false : cache;
    return $super === VOID ? this.i4s(cache) : $super.i4s.call(this, cache);
  }
  toString() {
    return 'BitmapGlyphInfo(glyphID=' + this.s4r_1 + ', imageFormat=' + this.t4r_1 + ', offset=' + this.u4r_1 + ', size=' + this.v4r_1 + ', info=' + this.w4r_1.toString() + ', height=' + this.x4r_1 + ', width=' + this.y4r_1 + ', horiBearingX=' + this.z4r_1 + ', horiBearingY=' + this.a4s_1 + ', horiAdvance=' + this.b4s_1 + ', vertBearingX=' + this.c4s_1 + ', vertBearingY=' + this.d4s_1 + ', vertAdvance=' + this.e4s_1 + ')';
  }
  hashCode() {
    var result = this.s4r_1;
    result = imul(result, 31) + this.t4r_1 | 0;
    result = imul(result, 31) + this.u4r_1 | 0;
    result = imul(result, 31) + this.v4r_1 | 0;
    result = imul(result, 31) + this.w4r_1.hashCode() | 0;
    result = imul(result, 31) + this.x4r_1 | 0;
    result = imul(result, 31) + this.y4r_1 | 0;
    result = imul(result, 31) + this.z4r_1 | 0;
    result = imul(result, 31) + this.a4s_1 | 0;
    result = imul(result, 31) + this.b4s_1 | 0;
    result = imul(result, 31) + this.c4s_1 | 0;
    result = imul(result, 31) + this.d4s_1 | 0;
    result = imul(result, 31) + this.e4s_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapGlyphInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapGlyphInfo ? other : THROW_CCE();
    if (!(this.s4r_1 === tmp0_other_with_cast.s4r_1))
      return false;
    if (!(this.t4r_1 === tmp0_other_with_cast.t4r_1))
      return false;
    if (!(this.u4r_1 === tmp0_other_with_cast.u4r_1))
      return false;
    if (!(this.v4r_1 === tmp0_other_with_cast.v4r_1))
      return false;
    if (!this.w4r_1.equals(tmp0_other_with_cast.w4r_1))
      return false;
    if (!(this.x4r_1 === tmp0_other_with_cast.x4r_1))
      return false;
    if (!(this.y4r_1 === tmp0_other_with_cast.y4r_1))
      return false;
    if (!(this.z4r_1 === tmp0_other_with_cast.z4r_1))
      return false;
    if (!(this.a4s_1 === tmp0_other_with_cast.a4s_1))
      return false;
    if (!(this.b4s_1 === tmp0_other_with_cast.b4s_1))
      return false;
    if (!(this.c4s_1 === tmp0_other_with_cast.c4s_1))
      return false;
    if (!(this.d4s_1 === tmp0_other_with_cast.d4s_1))
      return false;
    if (!(this.e4s_1 === tmp0_other_with_cast.e4s_1))
      return false;
    return true;
  }
}
class ColorLine {
  constructor(cycle, stops) {
    this.n4s_1 = cycle;
    this.o4s_1 = stops;
  }
  p4s(paint, palette) {
    var _iterator__ex2g4s = this.o4s_1.z();
    while (_iterator__ex2g4s.a1()) {
      var stop = _iterator__ex2g4s.b1();
      paint.r4t(stop.q4s_1, RGBA__concatAd_impl_gwhfm(RgbaArray__get_impl_nzyo1o(palette.p42_1, stop.r4s_1), stop.s4s_1));
    }
  }
  toString() {
    return 'ColorLine(cycle=' + this.n4s_1.toString() + ', stops=' + toString_0(this.o4s_1) + ')';
  }
  hashCode() {
    var result = this.n4s_1.hashCode();
    result = imul(result, 31) + hashCode(this.o4s_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColorLine))
      return false;
    var tmp0_other_with_cast = other instanceof ColorLine ? other : THROW_CCE();
    if (!this.n4s_1.equals(tmp0_other_with_cast.n4s_1))
      return false;
    if (!equals(this.o4s_1, tmp0_other_with_cast.o4s_1))
      return false;
    return true;
  }
}
class ColorStop {
  constructor(stopOffset, paletteIndex, alpha) {
    this.q4s_1 = stopOffset;
    this.r4s_1 = paletteIndex;
    this.s4s_1 = alpha;
  }
}
class Colrv1Paint extends Enum {
  constructor(name, ordinal) {
    super(name, ordinal);
    this.u4t_1 = this.m3_1 + 1 | 0;
  }
}
class COLRv1 {
  constructor(layerList, s, sBaseOffset, sLayerOffset, sClipOffset) {
    var tmp;
    if (layerList === VOID) {
      // Inline function 'kotlin.intArrayOf' call
      tmp = new Int32Array([]);
    } else {
      tmp = layerList;
    }
    layerList = tmp;
    var tmp_0;
    if (s === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0 = new Int8Array([]);
      tmp_0 = new FastByteArrayInputStream(tmp$ret$0);
    } else {
      tmp_0 = s;
    }
    s = tmp_0;
    var tmp_1;
    if (sBaseOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_0 = new Int8Array([]);
      tmp_1 = new FastByteArrayInputStream(tmp$ret$0_0);
    } else {
      tmp_1 = sBaseOffset;
    }
    sBaseOffset = tmp_1;
    var tmp_2;
    if (sLayerOffset === VOID) {
      // Inline function 'kotlin.byteArrayOf' call
      var tmp$ret$0_1 = new Int8Array([]);
      tmp_2 = new FastByteArrayInputStream(tmp$ret$0_1);
    } else {
      tmp_2 = sLayerOffset;
    }
    sLayerOffset = tmp_2;
    sClipOffset = sClipOffset === VOID ? null : sClipOffset;
    this.v4t_1 = layerList;
    this.w4t_1 = s;
    this.x4t_1 = sBaseOffset;
    this.y4t_1 = sLayerOffset;
    this.z4t_1 = sClipOffset;
    this.a4u_1 = IntIntMap.b2l();
  }
}
class Contour {
  constructor(x, y, onCurve) {
    x = x === VOID ? 0 : x;
    y = y === VOID ? 0 : y;
    onCurve = onCurve === VOID ? false : onCurve;
    this.b4u_1 = x;
    this.c4u_1 = y;
    this.d4u_1 = onCurve;
  }
  toString() {
    return 'Contour(x=' + this.b4u_1 + ', y=' + this.c4u_1 + ', onCurve=' + this.d4u_1 + ')';
  }
  hashCode() {
    var result = this.b4u_1;
    result = imul(result, 31) + this.c4u_1 | 0;
    result = imul(result, 31) + getBooleanHashCode(this.d4u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Contour))
      return false;
    var tmp0_other_with_cast = other instanceof Contour ? other : THROW_CCE();
    if (!(this.b4u_1 === tmp0_other_with_cast.b4u_1))
      return false;
    if (!(this.c4u_1 === tmp0_other_with_cast.c4u_1))
      return false;
    if (!(this.d4u_1 === tmp0_other_with_cast.d4u_1))
      return false;
    return true;
  }
}
class GlyphReference {
  constructor(glyph, x, y, scaleX, scale01, scale10, scaleY) {
    this.e4u_1 = glyph;
    this.f4u_1 = x;
    this.g4u_1 = y;
    this.h4u_1 = scaleX;
    this.i4u_1 = scale01;
    this.j4u_1 = scale10;
    this.k4u_1 = scaleY;
  }
  toString() {
    return 'GlyphReference(glyph=' + toString_0(this.e4u_1) + ', x=' + this.f4u_1 + ', y=' + this.g4u_1 + ', scaleX=' + this.h4u_1 + ', scale01=' + this.i4u_1 + ', scale10=' + this.j4u_1 + ', scaleY=' + this.k4u_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.e4u_1);
    result = imul(result, 31) + this.f4u_1 | 0;
    result = imul(result, 31) + this.g4u_1 | 0;
    result = imul(result, 31) + getNumberHashCode(this.h4u_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i4u_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.j4u_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.k4u_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphReference))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphReference ? other : THROW_CCE();
    if (!equals(this.e4u_1, tmp0_other_with_cast.e4u_1))
      return false;
    if (!(this.f4u_1 === tmp0_other_with_cast.f4u_1))
      return false;
    if (!(this.g4u_1 === tmp0_other_with_cast.g4u_1))
      return false;
    if (!equals(this.h4u_1, tmp0_other_with_cast.h4u_1))
      return false;
    if (!equals(this.i4u_1, tmp0_other_with_cast.i4u_1))
      return false;
    if (!equals(this.j4u_1, tmp0_other_with_cast.j4u_1))
      return false;
    if (!equals(this.k4u_1, tmp0_other_with_cast.k4u_1))
      return false;
    return true;
  }
}
class ColrLayerInfo {
  constructor($outer, glyphID, paletteIndex) {
    this.n4u_1 = $outer;
    this.l4u_1 = glyphID;
    this.m4u_1 = paletteIndex;
  }
  o4u(pal) {
    // Inline function 'kotlin.collections.getOrElse' call
    var this_0 = new RgbaArray(getCyclic(this.n4u_1.i4n_1, pal).p42_1);
    var index = this.m4u_1;
    // Inline function 'kotlin.contracts.contract' call
    var tmp;
    if (0 <= index ? index < this_0.d1() : false) {
      tmp = this_0.c1(index);
    } else {
      // Inline function 'korlibs.image.font.ColrLayerInfo.color.<anonymous>' call
      tmp = new RGBA(Colors_getInstance().m3p_1);
    }
    return tmp.l44_1;
  }
  p4u() {
    return this.o4u(0);
  }
  q4u(pal) {
    var tmp135_safe_receiver = this.n4u_1.q4p(this.l4u_1);
    var tmp136_safe_receiver = tmp135_safe_receiver == null ? null : tmp135_safe_receiver.l1q();
    var tmp;
    if (tmp136_safe_receiver == null) {
      tmp = null;
    } else {
      // Inline function 'kotlin.let' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.ColrLayerInfo.getShape.<anonymous>' call
      tmp = new FillShape(tmp136_safe_receiver.a4v_1, null, new RGBA(this.o4u(pal)));
    }
    return tmp;
  }
  toString() {
    return 'ColrLayerInfo(' + this.l4u_1 + ', ' + this.m4u_1 + ', ' + RGBA__toString_impl_4lw6dp(this.p4u()) + ')';
  }
}
class ColrGlyphInfo {}
function getColorShape$default(pal, $super) {
  pal = pal === VOID ? 0 : pal;
  return $super === VOID ? this.b4v(pal) : $super.b4v.call(this, pal);
}
class ColrGlyphInfoV1 {
  constructor($outer, glyphID, paint) {
    this.f4v_1 = $outer;
    this.d4v_1 = glyphID;
    this.e4v_1 = paint;
  }
  b4v(pal) {
    // Inline function 'kotlin.also' call
    // Inline function 'korlibs.image.vector.buildShape' call
    // Inline function 'kotlin.apply' call
    var this_0 = new ShapeBuilder(null, null);
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    var paintS = this.f4v_1.j4n_1.x4t_1.f1j(this.e4v_1);
    try {
      this.f4v_1.d4p(this.d4v_1, paintS, this_0, pal, 0);
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        printStackTrace(e);
      } else {
        throw $p;
      }
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.ColrGlyphInfoV1.getColorShape.<anonymous>' call
    return this_0.w4b();
  }
  toString() {
    return 'ColrGlyphInfoV1[' + this.d4v_1 + '][' + this.e4v_1 + ']';
  }
}
class ColrGlyphInfoV0 {
  constructor($outer, glyphID, firstLayerIndex, numLayers) {
    this.j4v_1 = $outer;
    this.g4v_1 = glyphID;
    this.h4v_1 = firstLayerIndex;
    this.i4v_1 = numLayers;
  }
  c1(index) {
    return this.j4v_1.g4n_1[this.h4v_1 + index | 0];
  }
  d4k() {
    var tmp = 0;
    var tmp_0 = this.i4v_1;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this.c1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return toList_1(tmp_1);
  }
  b4v(pal) {
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_0 = this.d4k();
    var destination = ArrayList.p1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var element = tmp0_iterator.b1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.font.ColrGlyphInfoV0.getColorShape.<anonymous>' call
      var tmp0_safe_receiver = element.q4u(pal);
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination.f(tmp0_safe_receiver);
      }
    }
    return new CompoundShape(destination);
  }
  toString() {
    return 'ColrGlyphInfoV0[' + this.g4v_1 + '][' + this.i4v_1 + '](' + toString_0(this.d4k()) + ')';
  }
}
class GlyphGraphicsPath {
  constructor(glpyhIndex, path) {
    this.z4u_1 = glpyhIndex;
    this.a4v_1 = path;
  }
  n36(p) {
    this.a4v_1.n36(p);
  }
  a37(p) {
    this.a4v_1.a37(p);
  }
  b37(c, a) {
    this.a4v_1.b37(c, a);
  }
  o36(c1, c2, a) {
    this.a4v_1.o36(c1, c2, a);
  }
  z5() {
    this.a4v_1.z5();
  }
  r3f(p0, p1) {
    this.a4v_1.r3f(p0, p1);
  }
  s3f(rect) {
    this.a4v_1.s3f(rect);
  }
  t3f(pos, size) {
    this.a4v_1.t3f(pos, size);
  }
  u3f(x, y, width, height) {
    this.a4v_1.u3f(x, y, width, height);
  }
  v3f(center, r, start, end, counterclockwise) {
    this.a4v_1.v3f(center, r, start, end, counterclockwise);
  }
  x3f(center, radius) {
    this.a4v_1.x3f(center, radius);
  }
  y3f(delta) {
    this.a4v_1.y3f(delta);
  }
  z3f(delta) {
    this.a4v_1.z3f(delta);
  }
  m2a(m) {
    return this.a4v_1.m2a(m);
  }
  p3f() {
    return this.a4v_1.p3f();
  }
  q3f() {
    return this.a4v_1.w36_1;
  }
  toString() {
    return 'GlyphGraphicsPath(glpyhIndex=' + this.z4u_1 + ', "' + toSvgPathString(this.a4v_1) + '")';
  }
  hashCode() {
    var result = this.z4u_1;
    result = imul(result, 31) + this.a4v_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GlyphGraphicsPath))
      return false;
    var tmp0_other_with_cast = other instanceof GlyphGraphicsPath ? other : THROW_CCE();
    if (!(this.z4u_1 === tmp0_other_with_cast.z4u_1))
      return false;
    if (!this.a4v_1.equals(tmp0_other_with_cast.a4v_1))
      return false;
    return true;
  }
}
class Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box) {
    boxApply(this, $box);
    this.y4u_1 = $outer;
    this.r4u_1 = index;
    this.s4u_1 = xMin;
    this.t4u_1 = yMin;
    this.u4u_1 = xMax;
    this.v4u_1 = yMax;
    this.w4u_1 = advanceWidth;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.Glyph.metrics1px.<anonymous>' call
    var xMin_0 = this.s4u_1;
    var yMin_0 = this.t4u_1;
    var xMax_0 = this.u4u_1;
    var yMax_0 = this.v4u_1;
    if (xMin_0 === 0 && yMin_0 === 0 && xMax_0 === 0 && yMax_0 === 0) {
      var sClipOffset = this.y4u_1.j4n_1.z4t_1;
      var glyphIDToClipOffset = this.y4u_1.j4n_1.a4u_1;
      var tmp_0;
      if (!(sClipOffset == null) && glyphIDToClipOffset.sm(this.r4u_1)) {
        var clipOffset = glyphIDToClipOffset.c1(this.r4u_1);
        tmp_0 = this.y4u_1.b4p(sClipOffset.f1j(clipOffset));
      } else {
        var tmp137_safe_receiver = this.k4v();
        var tmp138_safe_receiver = tmp137_safe_receiver == null ? null : tmp137_safe_receiver.c4v();
        tmp_0 = tmp138_safe_receiver == null ? null : tmp138_safe_receiver.l4v();
      }
      var bounds = tmp_0;
      if (!(bounds == null)) {
        xMin_0 = numberToInt(bounds.k22());
        xMax_0 = numberToInt(bounds.l22());
        yMin_0 = numberToInt(bounds.m22());
        yMax_0 = numberToInt(bounds.n22());
      }
    }
    var size = this.y4u_1.r4m_1;
    var scale = this.y4u_1.z46(size);
    tmp.x4u_1 = new GlyphMetrics(size, true, -1, Companion_getInstance_5().q29(xMin_0 * scale, yMin_0 * scale, xMax_0 * scale, yMax_0 * scale), this.w4u_1 * scale);
  }
  k4v() {
    return this.y4u_1.h4n_1.c1(this.r4u_1);
  }
  m4v() {
    return this.y4u_1.f4n_1.b3(this.r4u_1);
  }
}
class CompositeGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, refs, advanceWidth, $box) {
    if ($box === VOID)
      $box = {};
    $box.y4v_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.v4v_1 = refs;
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.v4v_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>' call
      var gpath = item.e4u_1.l1q().a4v_1;
      // Inline function 'kotlin.also' call
      var this_1 = new GlyphGraphicsPath(item.e4u_1.r4u_1, new VectorPath(IntArrayList.w2e(gpath.q36_1.d1()), DoubleArrayList.q2f(gpath.r36_1.d1())));
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.font.CompositeGlyph.paths.<anonymous>.<anonymous>' call
      var m = Companion_getInstance_6().d25().z25(item.h4u_1, item.k4u_1).f26(item.f4u_1, -item.g4u_1 | 0);
      this_1.a4v_1.f3g(item.e4u_1.l1q().a4v_1, m);
      destination.f(this_1);
    }
    tmp.w4v_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>' call
    var commandsSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = this.w4v_1;
    var n = 0;
    while (n < this_2.d1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var gpath_0 = this_2.c1(_unary__edvuaz);
      commandsSize = commandsSize + gpath_0.a4v_1.q36_1.d1() | 0;
      dataSize = dataSize + gpath_0.a4v_1.r36_1.d1() | 0;
    }
    // Inline function 'kotlin.also' call
    var this_3 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.w2e(commandsSize), DoubleArrayList.q2f(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_4 = this.w4v_1;
    var n_0 = 0;
    while (n_0 < this_4.d1()) {
      // Inline function 'korlibs.image.font.CompositeGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
      var _unary__edvuaz_0 = n_0;
      n_0 = _unary__edvuaz_0 + 1 | 0;
      var it = this_4.c1(_unary__edvuaz_0);
      this_3.a4v_1.g3g(it.a4v_1);
    }
    tmp_0.x4v_1 = this_3;
  }
  toString() {
    return 'CompositeGlyph[' + this.w4u_1 + '](' + toString_0(this.v4v_1) + ')';
  }
  l1q() {
    return this.x4v_1;
  }
}
class CFFGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, advanceWidth, path, $box) {
    if ($box === VOID)
      $box = {};
    $box.j4w_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.h4w_1 = path;
    this.i4w_1 = listOf_0(this.h4w_1);
  }
  l1q() {
    return this.h4w_1;
  }
}
class SimpleGlyph extends Glyph_0 {
  constructor($outer, index, xMin, yMin, xMax, yMax, contoursIndices, flags, xPos, yPos, advanceWidth, dummy, $box) {
    if ($box === VOID)
      $box = {};
    dummy = dummy === VOID ? false : dummy;
    $box.z4w_1 = $outer;
    super($outer, index, xMin, yMin, xMax, yMax, advanceWidth, $box);
    this.s4w_1 = contoursIndices;
    this.t4w_1 = flags;
    this.u4w_1 = xPos;
    this.v4w_1 = yPos;
    this.w4w_1 = dummy;
    var tmp = this;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>' call
    var commandSize = 0;
    var dataSize = 0;
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    this.z4w_1;
    var inductionVariable = 0;
    var last = this.s4w_1.length - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var cstart = this.s4w_1[n] + 1 | 0;
        var cend = this.s4w_1[n + 1 | 0];
        var csize = (cend - cstart | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
        commandSize = commandSize + (1 + imul(csize, 2) | 0) | 0;
        dataSize = dataSize + (2 + imul(csize, 8) | 0) | 0;
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.also' call
    var this_0 = new GlyphGraphicsPath(index, new VectorPath(IntArrayList.w2e(commandSize), DoubleArrayList.q2f(dataSize)));
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>' call
    // Inline function 'korlibs.image.font.SimpleGlyph.forEachContour' call
    var this_1 = this.z4w_1;
    var inductionVariable_0 = 0;
    var last_0 = this.s4w_1.length - 1 | 0;
    if (inductionVariable_0 < last_0)
      do {
        var n_0 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var cstart_0 = this.s4w_1[n_0] + 1 | 0;
        var cend_0 = this.s4w_1[n_0 + 1 | 0];
        var csize_0 = (cend_0 - cstart_0 | 0) + 1 | 0;
        // Inline function 'korlibs.image.font.SimpleGlyph.path.<anonymous>.<anonymous>.<anonymous>' call
        var curr = this.a4x(cend_0, this_1.n4l_1[0]);
        var next = this.a4x(cstart_0, this_1.n4l_1[1]);
        if (curr.d4u_1) {
          this_0.n36(Vector2D.l24(curr.b4u_1, -curr.c4u_1 | 0));
        } else if (next.d4u_1) {
          this_0.n36(Vector2D.l24(next.b4u_1, -next.c4u_1 | 0));
        } else {
          this_0.n36(Vector2D.l24(imul(curr.b4u_1 + next.b4u_1 | 0, numberToInt(0.5)), -numberToInt((curr.c4u_1 + next.c4u_1 | 0) * 0.5) | 0));
        }
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < csize_0)
          do {
            var cpos = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            var prev = curr;
            curr = next;
            next = this.a4x(cstart_0 + ((cpos + 1 | 0) % csize_0 | 0) | 0, this_1.n4l_1[(cpos + 2 | 0) % 3 | 0]);
            if (curr.d4u_1) {
              this_0.a37(Vector2D.l24(curr.b4u_1, -curr.c4u_1 | 0));
            } else {
              var prev2X = prev.b4u_1;
              var prev2Y = prev.c4u_1;
              var next2X = next.b4u_1;
              var next2Y = next.c4u_1;
              if (!prev.d4u_1) {
                prev2X = numberToInt((curr.b4u_1 + prev.b4u_1 | 0) * 0.5);
                prev2Y = numberToInt((curr.c4u_1 + prev.c4u_1 | 0) * 0.5);
                this_0.a37(Vector2D.l24(prev2X, -prev2Y | 0));
              }
              if (!next.d4u_1) {
                next2X = numberToInt((curr.b4u_1 + next.b4u_1 | 0) * 0.5);
                next2Y = numberToInt((curr.c4u_1 + next.c4u_1 | 0) * 0.5);
              }
              this_0.a37(Vector2D.l24(prev2X, -prev2Y | 0));
              this_0.b37(Vector2D.l24(curr.b4u_1, -curr.c4u_1 | 0), Vector2D.l24(next2X, -next2Y | 0));
            }
          }
           while (inductionVariable_1 < csize_0);
        this_0.z5();
      }
       while (inductionVariable_0 < last_0);
    tmp.x4w_1 = this_0;
    this.y4w_1 = listOf_0(this.x4w_1);
  }
  toString() {
    return 'SimpleGlyph' + (this.w4w_1 ? 'Dummy' : '') + '[' + this.r4u_1 + '](advance=' + this.w4u_1 + ') : ' + this.x4w_1.toString();
  }
  b4x(n) {
    return !((this.t4w_1[n] & 1) === 0);
  }
  a4x(n, out) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.SimpleGlyph.contour.<anonymous>' call
    out.b4u_1 = this.u4w_1[n];
    out.c4u_1 = this.v4w_1[n];
    out.d4u_1 = this.b4x(n);
    return out;
  }
  l1q() {
    return this.x4w_1;
  }
}
class BaseTtfFont$readCblc$1$Subtable {
  constructor(firstGlyphIndex, lastGlyphIndex, additionalOffsetToIndexSubtable) {
    this.c4x_1 = firstGlyphIndex;
    this.d4x_1 = lastGlyphIndex;
    this.e4x_1 = additionalOffsetToIndexSubtable;
  }
  f4x() {
    return this.d4x_1 - this.c4x_1 | 0;
  }
  toString() {
    return 'Subtable(firstGlyphIndex=' + this.c4x_1 + ', lastGlyphIndex=' + this.d4x_1 + ', additionalOffsetToIndexSubtable=' + this.e4x_1 + ')';
  }
  hashCode() {
    var result = this.c4x_1;
    result = imul(result, 31) + this.d4x_1 | 0;
    result = imul(result, 31) + this.e4x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCblc$1$Subtable))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCblc$1$Subtable ? other : THROW_CCE();
    if (!(this.c4x_1 === tmp0_other_with_cast.c4x_1))
      return false;
    if (!(this.d4x_1 === tmp0_other_with_cast.d4x_1))
      return false;
    if (!(this.e4x_1 === tmp0_other_with_cast.e4x_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readSbix$1$StrikeInfo {
  constructor(ppem, ppi, strikeOffset, offsets) {
    this.g4x_1 = ppem;
    this.h4x_1 = ppi;
    this.i4x_1 = strikeOffset;
    this.j4x_1 = offsets;
  }
  toString() {
    return 'StrikeInfo(ppem=' + this.g4x_1 + ', ppi=' + this.h4x_1 + ', strikeOffset=' + this.i4x_1 + ', offsets=' + this.j4x_1.toString() + ')';
  }
  hashCode() {
    var result = this.g4x_1;
    result = imul(result, 31) + this.h4x_1 | 0;
    result = imul(result, 31) + this.i4x_1 | 0;
    result = imul(result, 31) + this.j4x_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readSbix$1$StrikeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readSbix$1$StrikeInfo ? other : THROW_CCE();
    if (!(this.g4x_1 === tmp0_other_with_cast.g4x_1))
      return false;
    if (!(this.h4x_1 === tmp0_other_with_cast.h4x_1))
      return false;
    if (!(this.i4x_1 === tmp0_other_with_cast.i4x_1))
      return false;
    if (!this.j4x_1.equals(tmp0_other_with_cast.j4x_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCoverage$RangeInfo {
  constructor(start, endInclusive, index) {
    this.k4x_1 = start;
    this.l4x_1 = endInclusive;
    this.m4x_1 = index;
    this.n4x_1 = (this.l4x_1 - this.k4x_1 | 0) + 1 | 0;
  }
  toString() {
    return 'RangeInfo(start=' + this.k4x_1 + ', endInclusive=' + this.l4x_1 + ', index=' + this.m4x_1 + ')';
  }
  hashCode() {
    var result = this.k4x_1;
    result = imul(result, 31) + this.l4x_1 | 0;
    result = imul(result, 31) + this.m4x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCoverage$RangeInfo))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCoverage$RangeInfo ? other : THROW_CCE();
    if (!(this.k4x_1 === tmp0_other_with_cast.k4x_1))
      return false;
    if (!(this.l4x_1 === tmp0_other_with_cast.l4x_1))
      return false;
    if (!(this.m4x_1 === tmp0_other_with_cast.m4x_1))
      return false;
    return true;
  }
}
class BaseTtfFont$readCmap$1$EncodingRecord {
  constructor(platformId, encodingId, offset) {
    this.o4x_1 = platformId;
    this.p4x_1 = encodingId;
    this.q4x_1 = offset;
  }
  toString() {
    return 'EncodingRecord(platformId=' + this.o4x_1 + ', encodingId=' + this.p4x_1 + ', offset=' + this.q4x_1 + ')';
  }
  hashCode() {
    var result = this.o4x_1;
    result = imul(result, 31) + this.p4x_1 | 0;
    result = imul(result, 31) + this.q4x_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BaseTtfFont$readCmap$1$EncodingRecord))
      return false;
    var tmp0_other_with_cast = other instanceof BaseTtfFont$readCmap$1$EncodingRecord ? other : THROW_CCE();
    if (!(this.o4x_1 === tmp0_other_with_cast.o4x_1))
      return false;
    if (!(this.p4x_1 === tmp0_other_with_cast.p4x_1))
      return false;
    if (!(this.q4x_1 === tmp0_other_with_cast.q4x_1))
      return false;
    return true;
  }
}
class Companion_18 {
  s4x(num, den) {
    return insert16(insert16(0, num, 0), den, 16);
  }
}
class Companion_19 {
  d25() {
    return new Mixin_0();
  }
}
class Mixin_0 {
  constructor() {
    this.v4x_1 = null;
    this.w4x_1 = Colors_getInstance().p3n_1;
  }
  x4x(_set____db54di) {
    this.v4x_1 = _set____db54di;
  }
  y4x(_set____db54di) {
    this.w4x_1 = _set____db54di;
  }
}
class sam$kotlin_Comparator$0 {
  constructor(function_0) {
    this.z4x_1 = function_0;
  }
  ei(a, b) {
    return this.z4x_1(a, b);
  }
  compare(a, b) {
    return this.ei(a, b);
  }
}
class AseCell {}
function resolve() {
  return this;
}
class AseBitmapCell {
  constructor(bmp, x, y, opacity) {
    this.p4y_1 = Companion_instance_25.d25();
    this.q4y_1 = bmp;
    this.r4y_1 = x;
    this.s4y_1 = y;
    this.t4y_1 = opacity;
  }
  x4x(_set____db54di) {
    this.p4y_1.x4x(_set____db54di);
  }
  y4x(_set____db54di) {
    this.p4y_1.y4x(_set____db54di);
  }
  t45() {
    return this.q4y_1;
  }
  m4y() {
    return this.r4y_1;
  }
  n4y() {
    return this.s4y_1;
  }
}
class AseLinkedCell {
  constructor(linkedCell, x, y, opacity) {
    this.u4y_1 = Companion_instance_25.d25();
    this.v4y_1 = linkedCell;
    this.w4y_1 = x;
    this.x4y_1 = y;
    this.y4y_1 = opacity;
  }
  x4x(_set____db54di) {
    this.u4y_1.x4x(_set____db54di);
  }
  y4x(_set____db54di) {
    this.u4y_1.y4x(_set____db54di);
  }
  m4y() {
    return this.w4y_1;
  }
  n4y() {
    return this.x4y_1;
  }
  t45() {
    return this.v4y_1.t45();
  }
  o4y() {
    return this.v4y_1.o4y();
  }
}
class AseTilemapCell {
  constructor(data, tileBitmask, bitmaskXFlip, bitmaskYFlip, bitmask90CWFlip, x, y, opacity) {
    this.z4y_1 = Companion_instance_25.d25();
    this.a4z_1 = data;
    this.b4z_1 = tileBitmask;
    this.c4z_1 = bitmaskXFlip;
    this.d4z_1 = bitmaskYFlip;
    this.e4z_1 = bitmask90CWFlip;
    this.f4z_1 = x;
    this.g4z_1 = y;
    this.h4z_1 = opacity;
    this.i4z_1 = Bitmap32.z3l(1, 1, VOID, true);
  }
  x4x(_set____db54di) {
    this.z4y_1.x4x(_set____db54di);
  }
  y4x(_set____db54di) {
    this.z4y_1.y4x(_set____db54di);
  }
  m4y() {
    return this.f4z_1;
  }
  n4y() {
    return this.g4z_1;
  }
  t45() {
    return this.i4z_1;
  }
}
class ImageLayer {
  constructor(index, name, type) {
    type = type === VOID ? Type_NORMAL_getInstance() : type;
    this.v52_1 = index;
    this.w52_1 = name;
    this.x52_1 = type;
  }
}
class AseLayer extends ImageLayer {
  constructor(originalAseIndex, index, name, flags, type, childLevel, blendModeInt, opacity, tilesetIndex) {
    super(index, name, type);
    this.m4z_1 = Companion_instance_25.d25();
    this.n4z_1 = originalAseIndex;
    this.o4z_1 = flags;
    this.p4z_1 = childLevel;
    this.q4z_1 = blendModeInt;
    this.r4z_1 = opacity;
    this.s4z_1 = tilesetIndex;
    this.t4z_1 = hasBitSet(this.o4z_1, 0);
    this.u4z_1 = hasBitSet(this.o4z_1, 1);
    this.v4z_1 = hasBitSet(this.o4z_1, 2);
    this.w4z_1 = hasBitSet(this.o4z_1, 3);
    this.x4z_1 = hasBitSet(this.o4z_1, 4);
    this.y4z_1 = hasBitSet(this.o4z_1, 5);
    this.z4z_1 = hasBitSet(this.o4z_1, 6);
    var tmp = this;
    switch (this.q4z_1) {
      case 0:
        tmp.a50_1 = BlendMode_NORMAL_getInstance();
        break;
      case 1:
        tmp.a50_1 = BlendMode_MULTIPLY_getInstance();
        break;
      case 2:
        tmp.a50_1 = BlendMode_SCREEN_getInstance();
        break;
      case 3:
        tmp.a50_1 = BlendMode_OVERLAY_getInstance();
        break;
      case 4:
        tmp.a50_1 = BlendMode_DARKEN_getInstance();
        break;
      case 5:
        tmp.a50_1 = BlendMode_LIGHTEN_getInstance();
        break;
      case 6:
        tmp.a50_1 = BlendMode_COLOR_DODGE_getInstance();
        break;
      case 7:
        tmp.a50_1 = BlendMode_COLOR_BURN_getInstance();
        break;
      case 8:
        tmp.a50_1 = BlendMode_HARD_LIGHT_getInstance();
        break;
      case 9:
        tmp.a50_1 = BlendMode_SOFT_LIGHT_getInstance();
        break;
      case 10:
        tmp.a50_1 = BlendMode_DIFFERENCE_getInstance();
        break;
      case 11:
        tmp.a50_1 = BlendMode_EXCLUSION_getInstance();
        break;
      case 12:
        tmp.a50_1 = BlendMode_HUE_getInstance();
        break;
      case 13:
        tmp.a50_1 = BlendMode_SATURATION_getInstance();
        break;
      case 14:
        tmp.a50_1 = BlendMode_COLOR_getInstance();
        break;
      case 15:
        tmp.a50_1 = BlendMode_LUMINOSITY_getInstance();
        break;
      case 16:
        tmp.a50_1 = BlendMode_ADDITION_getInstance();
        break;
      case 17:
        tmp.a50_1 = BlendMode_SUBTRACT_getInstance();
        break;
      case 18:
        tmp.a50_1 = BlendMode_DIVIDE_getInstance();
        break;
      default:
        tmp.a50_1 = BlendMode_NORMAL_getInstance();
        break;
    }
  }
  x4x(_set____db54di) {
    this.m4z_1.x4x(_set____db54di);
  }
  y4x(_set____db54di) {
    this.m4z_1.y4x(_set____db54di);
  }
}
class AseFrame {
  constructor(index) {
    this.b50_1 = Companion_instance_25.d25();
    this.c50_1 = index;
    this.d50_1 = 0;
    this.e50_1 = FastIntMap();
  }
  x4x(_set____db54di) {
    this.b50_1.x4x(_set____db54di);
  }
  y4x(_set____db54di) {
    this.b50_1.y4x(_set____db54di);
  }
}
class AsePalette extends Palette {
  constructor(colors, names, changeStart, changeEnd) {
    names = names === VOID ? null : names;
    changeStart = changeStart === VOID ? 0 : changeStart;
    changeEnd = changeEnd === VOID ? 0 : changeEnd;
    super(colors, names, changeStart, changeEnd);
    this.j50_1 = Companion_instance_25.d25();
  }
  x4x(_set____db54di) {
    this.j50_1.x4x(_set____db54di);
  }
  y4x(_set____db54di) {
    this.j50_1.y4x(_set____db54di);
  }
}
class AseTileset {
  constructor(tilesetId, ntiles, tileWidth, tileHeight, baseIndex, tilesetName, tiles) {
    this.k50_1 = tilesetId;
    this.l50_1 = ntiles;
    this.m50_1 = tileWidth;
    this.n50_1 = tileHeight;
    this.o50_1 = baseIndex;
    this.p50_1 = tilesetName;
    this.q50_1 = tiles;
    var tmp = this;
    // Inline function 'kotlin.also' call
    var this_0 = IntMap.i2k();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.AseTileset.tileSet.<anonymous>' call
    var inductionVariable = 0;
    var last = this.q50_1.d1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var id = n;
        this_0.c2k(id, new TileSetTileInfo(id, this.q50_1.c1(n)));
      }
       while (inductionVariable <= last);
    tmp.r50_1 = new TileSet(this_0);
  }
  toString() {
    return 'AseTileset(tilesetId=' + this.k50_1 + ', ntiles=' + this.l50_1 + ', tileWidth=' + this.m50_1 + ', tileHeight=' + this.n50_1 + ', baseIndex=' + this.o50_1 + ', tilesetName=' + this.p50_1 + ', tiles=' + toString_0(this.q50_1) + ')';
  }
  hashCode() {
    var result = this.k50_1;
    result = imul(result, 31) + this.l50_1 | 0;
    result = imul(result, 31) + this.m50_1 | 0;
    result = imul(result, 31) + this.n50_1 | 0;
    result = imul(result, 31) + this.o50_1 | 0;
    result = imul(result, 31) + getStringHashCode(this.p50_1) | 0;
    result = imul(result, 31) + hashCode(this.q50_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof AseTileset))
      return false;
    var tmp0_other_with_cast = other instanceof AseTileset ? other : THROW_CCE();
    if (!(this.k50_1 === tmp0_other_with_cast.k50_1))
      return false;
    if (!(this.l50_1 === tmp0_other_with_cast.l50_1))
      return false;
    if (!(this.m50_1 === tmp0_other_with_cast.m50_1))
      return false;
    if (!(this.n50_1 === tmp0_other_with_cast.n50_1))
      return false;
    if (!(this.o50_1 === tmp0_other_with_cast.o50_1))
      return false;
    if (!(this.p50_1 === tmp0_other_with_cast.p50_1))
      return false;
    if (!equals(this.q50_1, tmp0_other_with_cast.q50_1))
      return false;
    return true;
  }
}
class AseSliceKey {
  constructor(frameIndex, sliceXOrigin, sliceYOrigin, sliceWidth, sliceHeight, centerXPos, centerYPos, centerWidth, centerHeight, pivotX, pivotY) {
    this.a4y_1 = frameIndex;
    this.b4y_1 = sliceXOrigin;
    this.c4y_1 = sliceYOrigin;
    this.d4y_1 = sliceWidth;
    this.e4y_1 = sliceHeight;
    this.f4y_1 = centerXPos;
    this.g4y_1 = centerYPos;
    this.h4y_1 = centerWidth;
    this.i4y_1 = centerHeight;
    this.j4y_1 = pivotX;
    this.k4y_1 = pivotY;
    this.l4y_1 = RectangleInt.j2a(this.b4y_1, this.c4y_1, this.d4y_1, this.e4y_1);
  }
}
class AseSlice {
  constructor(name, hasNinePatch, hasPivotInfo) {
    this.s50_1 = Companion_instance_25.d25();
    this.t50_1 = name;
    this.u50_1 = hasNinePatch;
    this.v50_1 = hasPivotInfo;
    this.w50_1 = FastArrayList.lx();
  }
  x4x(_set____db54di) {
    this.s50_1.x4x(_set____db54di);
  }
  y4x(_set____db54di) {
    this.s50_1.y4x(_set____db54di);
  }
  x50() {
    // Inline function 'kotlin.collections.sortBy' call
    var this_0 = this.w50_1;
    if (this_0.d1() > 1) {
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp = ASE$AseSlice$sortKeys$lambda;
      var tmp$ret$0 = new sam$kotlin_Comparator$0(tmp);
      sortWith(this_0, tmp$ret$0);
    }
  }
  y50(index) {
    // Inline function 'korlibs.datastructure.FastArrayList.fastForEachReverse' call
    var this_0 = this.w50_1;
    // Inline function 'korlibs.datastructure.FastArrayList.jsArray' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var array = this_0.jx_1;
    var n = 0;
    while (n < array.length) {
      // Inline function 'korlibs.image.format.AseSlice.getSliceForFrame.<anonymous>' call
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'korlibs.datastructure.get' call
      // Inline function 'kotlin.js.asDynamic' call
      // Inline function 'kotlin.js.asDynamic' call
      var it = array[(this_0.d1() - n | 0) - 1 | 0];
      if (index >= it.a4y_1)
        return it;
      n = n + 1 | 0;
    }
    var tmp0_elvis_lhs = firstOrNull_0(this.w50_1);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      var message = 'No frames key frames for slice!';
      throw IllegalStateException.w4(toString_0(message));
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
}
class AseTag {
  constructor(fromFrame, toFrame, directionByte, tagColor, tagName) {
    this.z50_1 = Companion_instance_25.d25();
    this.a51_1 = fromFrame;
    this.b51_1 = toFrame;
    this.c51_1 = directionByte;
    this.d51_1 = tagColor;
    this.e51_1 = tagName;
    var tmp = this;
    switch (this.c51_1) {
      case 0:
        tmp.f51_1 = Direction_FORWARD_getInstance();
        break;
      case 1:
        tmp.f51_1 = Direction_REVERSE_getInstance();
        break;
      case 2:
        tmp.f51_1 = Direction_PING_PONG_getInstance();
        break;
      default:
        tmp.f51_1 = Direction_FORWARD_getInstance();
        break;
    }
  }
  x4x(_set____db54di) {
    this.z50_1.x4x(_set____db54di);
  }
  y4x(_set____db54di) {
    this.z50_1.y4x(_set____db54di);
  }
}
class AseImage {
  constructor() {
    this.g51_1 = Companion_instance_25.d25();
    this.h51_1 = null;
    this.i51_1 = FastArrayList.lx();
    this.j51_1 = FastArrayList.lx();
    this.k51_1 = FastArrayList.lx();
    this.l51_1 = FastArrayList.lx();
    this.m51_1 = IntMap.i2k();
    this.n51_1 = IntMap.i2k();
  }
  x4x(_set____db54di) {
    this.g51_1.x4x(_set____db54di);
  }
  y4x(_set____db54di) {
    this.g51_1.y4x(_set____db54di);
  }
}
class ImageFormat {
  static l55(exts) {
    var $this = createThis(this);
    var tmp = $this;
    tmp.j4s_1 = lazy(ImageFormat$decodingProps$delegate$lambda($this));
    var tmp_0 = $this;
    // Inline function 'kotlin.collections.map' call
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(exts.length);
    var inductionVariable = 0;
    var last = exts.length;
    while (inductionVariable < last) {
      var item = exts[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.ImageFormat.extensions.<anonymous>' call
      // Inline function 'kotlin.text.trim' call
      // Inline function 'kotlin.text.toLowerCase' call
      // Inline function 'kotlin.js.asDynamic' call
      var this_0 = item.toLowerCase();
      var tmp$ret$3 = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
      destination.f(tmp$ret$3);
    }
    tmp_0.k4s_1 = toSet(destination);
    return $this;
  }
  r53() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.j4s_1;
    decodingProps$factory();
    return this_0.t1();
  }
  q53(s, props) {
    throw NotImplementedError.nd();
  }
  v51(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>' call
      var bmp = this.s53(s, props);
      // Inline function 'kotlin.apply' call
      var this_0 = new ImageInfo();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format.ImageFormat.decodeHeader.<anonymous>.<anonymous>' call
      this_0.x51_1 = bmp.n2d();
      this_0.y51_1 = bmp.o2d();
      this_0.z51_1 = bmp.x3m();
      tmp = this_0;
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    return tmp;
  }
  s53(s, props) {
    return this.q53(s, props).d55();
  }
  t53(s, props) {
    // Inline function 'korlibs.io.lang.runIgnoringExceptions' call
    var tmp;
    try {
      // Inline function 'korlibs.image.format.ImageFormat.check.<anonymous>' call
      tmp = !(this.v51(s, props) == null);
    } catch ($p) {
      var tmp_0;
      if ($p instanceof Error) {
        var e = $p;
        if (true) {
          printStackTrace(e);
        }
        tmp_0 = null;
      } else {
        throw $p;
      }
      tmp = tmp_0;
    }
    var tmp0_elvis_lhs = tmp;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  u53(s, props) {
    return this.s53(s, props);
  }
  l4s(s, props, $super) {
    props = props === VOID ? Companion_getInstance_40().r48_1 : props;
    return $super === VOID ? this.u53(s, props) : $super.u53.call(this, s, props);
  }
  v53(data, props) {
    return this.s53(openSync(data), props);
  }
  x53(data, props, $completion) {
    return this.v53(data, props);
  }
  w53(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq(this, file, props, $completion), $completion);
  }
  toString() {
    return 'ImageFormat(' + toString_0(this.k4s_1) + ')';
  }
}
class ImageFormatWithContainer extends ImageFormat {
  static u51(exts) {
    return this.l55(exts.slice());
  }
  a52(s, props) {
    throw NotImplementedError.nd();
  }
  q53(s, props) {
    return first_0(this.a52(s, props).e55_1);
  }
}
class ASE extends ImageFormatWithContainer {
  static r51() {
    ASE_instance = null;
    var $this = this.u51(['ase']);
    ASE_instance = $this;
    return $this;
  }
  v51(s, props) {
    var ss = s.qw();
    readBytesExact(ss, 4);
    if (!(readU16LE(ss) === 42464))
      return null;
    var frames = readU16LE(ss);
    var width = readU16LE(ss);
    var height = readU16LE(ss);
    var bitsPerPixel = readU16LE(ss);
    // Inline function 'kotlin.also' call
    var this_0 = new ImageInfo();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.ASE.decodeHeader.<anonymous>' call
    this_0.z51_1 = bitsPerPixel;
    this_0.x51_1 = width;
    this_0.y51_1 = height;
    return this_0;
  }
  a52(s, props) {
    var fileSize = readS32LE(s);
    if (s.a().y1(toLong(fileSize)) < 0) {
      // Inline function 'kotlin.error' call
      var message = 'File too short';
      throw IllegalStateException.w4(toString_0(message));
    }
    if (!(readU16LE(s) === 42464)) {
      // Inline function 'kotlin.error' call
      var message_0 = 'Not an Aseprite file';
      throw IllegalStateException.w4(toString_0(message_0));
    }
    var numFrames = readU16LE(s);
    var imageWidth = readU16LE(s);
    var imageHeight = readU16LE(s);
    var bitsPerPixel = readU16LE(s);
    var bytesPerPixel = bitsPerPixel / 8 | 0;
    var flags = readU32LE(s);
    var speed = readU16LE(s);
    s.ps(4);
    s.ps(4);
    var transparentIndex = readU8(s);
    s.ps(3);
    var numColors = readU16LE(s);
    var pixelWidth = readU8(s);
    var pixelHeight = readU8(s);
    var gridX = readS16LE(s);
    var gridY = readS16LE(s);
    var gridWidth = readU16LE(s);
    var gridHeight = readU16LE(s);
    s.ps(84);
    var image = new AseImage();
    var inductionVariable = 0;
    if (inductionVariable < numFrames)
      do {
        var frameIndex = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var bytesInFrame = readS32LE(s);
        var fs = readStream(s, bytesInFrame - 4 | 0);
        if (!(readU16LE(fs) === 61946)) {
          // Inline function 'kotlin.error' call
          var message_1 = 'Invalid ASE sprite file or error parsing';
          throw IllegalStateException.w4(toString_0(message_1));
        }
        readU16LE(fs);
        var frameDuration = readU16LE(fs);
        fs.ps(2);
        var numChunks = readS32LE(fs);
        var currentFrame = new AseFrame(frameIndex);
        image.j51_1.f(currentFrame);
        currentFrame.d50_1 = frameDuration;
        var lastEntity = null;
        var lastCell = null;
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < numChunks)
          do {
            var nc = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var chunkSize = readS32LE(fs);
            var chunkType = readU16LE(fs);
            var cs = readStream(fs, chunkSize - 6 | 0);
            switch (chunkType) {
              case 4:
                image.h51_1;
                break;
              case 17:
                image.h51_1;
                break;
              case 8196:
                var flags_0 = readU16LE(cs);
                var type = Companion_getInstance_42().b52_1[readU16LE(cs)];
                var childLevel = readU16LE(cs);
                var defaultLayerWidth = readU16LE(cs);
                var defaultLayerHeight = readU16LE(cs);
                var blendModeInt = readU16LE(cs);
                var opacity = readU8(cs);
                cs.ps(3);
                var name = this.c52(cs);
                var tilesetIndex = type.f52() ? readS32LE(cs) : 0;
                var layer = new AseLayer(image.i51_1.d1(), image.i51_1.d1(), name, flags_0, type, childLevel, blendModeInt, opacity, tilesetIndex);
                image.i51_1.f(layer);
                lastEntity = layer;
                break;
              case 8197:
                var layerIndex = readU16LE(cs);
                var x = readS16LE(cs);
                var y = readS16LE(cs);
                var opacity_0 = readU8(cs);
                var celType = readU16LE(cs);
                cs.ps(7);
                var tmp;
                switch (celType) {
                  case 0:
                  case 2:
                    var width = readU16LE(cs);
                    var height = readU16LE(cs);
                    var data = readAvailable(cs);
                    var udata = celType === 2 ? uncompress(data, Companion_getInstance_14(), imul(imul(width, height), bytesPerPixel)) : data;
                    var tmp_0;
                    switch (bitsPerPixel) {
                      case 32:
                        // Inline function 'kotlin.also' call

                        var this_0 = Bitmap32.w3v(width, height, _RgbaArray___init__impl__oib4y4(getS32Array(udata, 0, imul(width, height), true)));
                        // Inline function 'kotlin.contracts.contract' call

                        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call

                        if (props.s52()) {
                          this_0.p3x();
                        }

                        tmp_0 = this_0;
                        break;
                      case 8:
                        tmp_0 = Bitmap8.l3x(width, height, udata, ensureNotNull(image.h51_1).p42_1);
                        break;
                      default:
                        var message_2 = 'Unsupported ASE mode';
                        throw IllegalStateException.w4(toString_0(message_2));
                    }

                    var bmp = tmp_0;
                    tmp = new AseBitmapCell(bmp, x, y, opacity_0);
                    break;
                  case 1:
                    var linkFrame = readU16LE(cs);
                    // Inline function 'korlibs.datastructure.get' call

                    // Inline function 'kotlin.js.asDynamic' call

                    var tmp$ret$2 = image.j51_1.c1(linkFrame).e50_1.get(layerIndex);
                    var aseCell = ensureNotNull(tmp$ret$2);
                    tmp = new AseLinkedCell(aseCell, x, y, opacity_0);
                    break;
                  case 3:
                    var tilesWidth = readU16LE(cs);
                    var tilesHeight = readU16LE(cs);
                    var bitsPerTile = readU16LE(cs);
                    var tileBitmask = readS32LE(cs);
                    var bitmaskXFlip = readS32LE(cs);
                    var bitmaskYFlip = readS32LE(cs);
                    var bitmask90CWFlip = readS32LE(cs);
                    var bytesPerTile = bitsPerTile / 8 | 0;
                    cs.ps(10);
                    var compressedData = uncompress(readAvailable(cs), Companion_getInstance_14(), imul(imul(tilesWidth, tilesHeight), bytesPerTile));
                    var tmp_1;
                    if (bitsPerTile === 32) {
                      tmp_1 = getS32ArrayLE(compressedData, 0, imul(tilesWidth, tilesHeight));
                    } else {
                      var reason = 'Only supported 32-bits per tile';
                      throw NotImplementedError.nd('An operation is not implemented: ' + reason);
                    }

                    var data_0 = tmp_1;
                    tmp = new AseTilemapCell(new IntArray2(tilesWidth, tilesHeight, data_0), tileBitmask, bitmaskXFlip, bitmaskYFlip, bitmask90CWFlip, x, y, opacity_0);
                    break;
                  default:
                    var message_3 = 'Aseprite: Unknown celType=' + celType;
                    throw IllegalStateException.w4(toString_0(message_3));
                }

                var cel = tmp;
                lastEntity = cel;
                lastCell = cel;
                if (!(cel == null)) {
                  // Inline function 'korlibs.datastructure.set' call
                  // Inline function 'kotlin.js.asDynamic' call
                  currentFrame.e50_1.set(layerIndex, cel);
                }

                break;
              case 8198:
                var flags_1 = readS32LE(cs);
                var x_0 = _Fixed32___get_double__impl__wjoyf6(this.t52(cs));
                var y_0 = _Fixed32___get_double__impl__wjoyf6(this.t52(cs));
                var width_0 = _Fixed32___get_double__impl__wjoyf6(this.t52(cs));
                var height_0 = _Fixed32___get_double__impl__wjoyf6(this.t52(cs));
                cs.ps(16);
                break;
              case 8199:
                var type_0 = readU16LE(cs);
                var flags_2 = readU16LE(cs);
                var gamma = this.t52(cs);
                cs.ps(8);
                break;
              case 8200:
                var nentries = readS32LE(cs);
                cs.ps(8);
                var inductionVariable_1 = 0;
                if (inductionVariable_1 < nentries)
                  do {
                    var n = inductionVariable_1;
                    inductionVariable_1 = inductionVariable_1 + 1 | 0;
                    var entryId = readS32LE(cs);
                    cs.ps(8);
                    var externalFileName = this.c52(cs);
                    image.m51_1.c2k(entryId, externalFileName);
                  }
                   while (inductionVariable_1 < nentries);
                break;
              case 8214:
                break;
              case 8215:
                break;
              case 8216:
                var numTags = readU16LE(cs);
                cs.ps(8);
                var inductionVariable_2 = 0;
                if (inductionVariable_2 < numTags)
                  do {
                    var tag = inductionVariable_2;
                    inductionVariable_2 = inductionVariable_2 + 1 | 0;
                    var fromFrame = readU16LE(cs);
                    var toFrame = readU16LE(cs);
                    var direction = readU8(cs);
                    cs.ps(8);
                    var tagColor = RGBA__withA_impl_vogscm(this.u52(cs), 255);
                    var tagName = this.c52(cs);
                    var tag_0 = new AseTag(fromFrame, toFrame, direction, tagColor, tagName);
                    image.k51_1.f(tag_0);
                  }
                   while (inductionVariable_2 < numTags);
                break;
              case 8217:
                var numEntries = readS32LE(cs);
                var changeStart = readS32LE(cs);
                var changeEnd = readS32LE(cs);
                var colors = Companion_instance_11.t3x(numEntries);
                // Inline function 'kotlin.arrayOfNulls' call

                var colorNames = fillArrayVal(Array(numEntries), null);
                cs.ps(8);
                var inductionVariable_3 = 0;
                if (inductionVariable_3 < numEntries)
                  do {
                    var ncol = inductionVariable_3;
                    inductionVariable_3 = inductionVariable_3 + 1 | 0;
                    var flags_3 = readU16LE(cs);
                    var rgba = this.u52(cs);
                    var name_0 = hasBitSet(flags_3, 0) ? this.c52(cs) : null;
                    RgbaArray__set_impl_epw2wg(colors, ncol, rgba);
                    colorNames[ncol] = name_0;
                  }
                   while (inductionVariable_3 < numEntries);
                image.h51_1 = new AsePalette(colors, colorNames, changeStart, changeEnd);
                lastEntity = image.h51_1;
                break;
              case 8224:
                var flags_4 = readS32LE(cs);
                if (hasBitSet(flags_4, 0)) {
                  var tmp149_safe_receiver = lastEntity;
                  if (tmp149_safe_receiver == null)
                    null;
                  else {
                    tmp149_safe_receiver.x4x(this.c52(cs));
                  }
                }

                if (hasBitSet(flags_4, 1)) {
                  var tmp150_safe_receiver = lastEntity;
                  if (tmp150_safe_receiver == null)
                    null;
                  else {
                    tmp150_safe_receiver.y4x(this.u52(cs));
                  }
                }

                break;
              case 8226:
                var numSliceKeys = readS32LE(cs);
                var sliceFlags = readS32LE(cs);
                cs.ps(4);
                var sliceName = this.c52(cs);
                var hasNinePatch = hasBitSet(sliceFlags, 0);
                var hasPivotInfo = hasBitSet(sliceFlags, 1);
                var slice_1 = new AseSlice(sliceName, hasNinePatch, hasPivotInfo);
                image.l51_1.f(slice_1);
                lastEntity = slice_1;
                var inductionVariable_4 = 0;
                if (inductionVariable_4 < numSliceKeys)
                  do {
                    var nsk = inductionVariable_4;
                    inductionVariable_4 = inductionVariable_4 + 1 | 0;
                    var sliceFrameIndex = readS32LE(cs);
                    var sliceXOrigin = readS32LE(cs);
                    var sliceYOrigin = readS32LE(cs);
                    var sliceWidth = readS32LE(cs);
                    var sliceHeight = readS32LE(cs);
                    var centerXPos = hasNinePatch ? readS32LE(cs) : 0;
                    var centerYPos = hasNinePatch ? readS32LE(cs) : 0;
                    var centerWidth = hasNinePatch ? readS32LE(cs) : sliceWidth;
                    var centerHeight = hasNinePatch ? readS32LE(cs) : sliceHeight;
                    var pivotX = hasPivotInfo ? readS32LE(cs) : 0;
                    var pivotY = hasPivotInfo ? readS32LE(cs) : 0;
                    slice_1.w50_1.f(new AseSliceKey(sliceFrameIndex, sliceXOrigin, sliceYOrigin, sliceWidth, sliceHeight, centerXPos, centerYPos, centerWidth, centerHeight, pivotX, pivotY));
                  }
                   while (inductionVariable_4 < numSliceKeys);
                break;
              case 8227:
                var tilesetId = readS32LE(cs);
                var tilesetFlags = readS32LE(cs);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var includeLinkToExternalFile = !(((tilesetFlags >>> 0 | 0) & 1) === 0);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var includeTilesInsideThisFile = !(((tilesetFlags >>> 1 | 0) & 1) === 0);
                // Inline function 'korlibs.memory.extract' call

                // Inline function 'korlibs.memory.extract1' call

                var tile0IsEmpty = !(((tilesetFlags >>> 2 | 0) & 1) === 0);
                var ntiles = readS32LE(cs);
                var tileWidth = readU16LE(cs);
                var tileHeight = readU16LE(cs);
                var baseIndex = readS16LE(cs);
                cs.ps(14);
                var tilesetName = this.c52(cs);
                // Inline function 'kotlin.collections.listOf' call

                var tiles = emptyList();
                if (includeLinkToExternalFile) {
                  var externalFileId = readS32LE(cs);
                  var externalTilesetId = readS32LE(cs);
                }

                if (includeTilesInsideThisFile) {
                  var compressedDataLength = readS32LE(cs);
                  var compressedData_0 = readBytesExact(cs, compressedDataLength);
                  var data_1 = uncompress(compressedData_0, Companion_getInstance_14());
                  var ints = getS32ArrayLE(data_1, 0, imul(imul(tileWidth, tileHeight), ntiles));
                  // Inline function 'kotlin.also' call
                  var this_1 = Bitmap32.w3v(tileWidth, imul(tileHeight, ntiles), _RgbaArray___init__impl__oib4y4(ints));
                  // Inline function 'kotlin.contracts.contract' call
                  // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
                  if (props.s52()) {
                    this_1.p3x();
                  }
                  var bitmap = this_1;
                  tiles = splitInRows(slice_0(bitmap), tileWidth, tileHeight);
                }

                image.n51_1.c2k(tilesetId, new AseTileset(tilesetId, ntiles, tileWidth, tileHeight, baseIndex, tilesetName, tiles));
                break;
              default:
                println('WARNING: Aseprite: Not implemented chunkType=' + get_hex(chunkType));
                break;
            }
          }
           while (inductionVariable_0 < numChunks);
      }
       while (inductionVariable < numFrames);
    var imageLayers = image.i51_1;
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var destination = ArrayList.p1();
    var tmp0_iterator = imageLayers.z();
    while (tmp0_iterator.a1()) {
      var element = tmp0_iterator.b1();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var shouldProcess = get_onlyReadVisibleLayers(props) ? element.t4z_1 : true;
      var tmp_2;
      if (shouldProcess) {
        var tmp_3 = ASE_getInstance();
        var tmp_4 = element.w52_1;
        tmp_2 = takeLayersByName(props, tmp_3, (!(tmp_4 == null) ? typeof tmp_4 === 'string' : false) ? tmp_4 : THROW_CCE());
      } else {
        tmp_2 = false;
      }
      if (tmp_2) {
        destination.f(element);
      }
    }
    var imageLayersToProcess = destination;
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_2 = image.j51_1;
    var destination_0 = ArrayList.p1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_0 = this_2.z();
    while (tmp0_iterator_0.a1()) {
      var element_0 = tmp0_iterator_0.b1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      // Inline function 'kotlin.collections.filter' call
      // Inline function 'kotlin.collections.filterTo' call
      var this_3 = toLinkedMap(element_0.e50_1);
      var destination_1 = LinkedHashMap.ac();
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_1 = this_3.r1().z();
      while (tmp0_iterator_1.a1()) {
        var element_1 = tmp0_iterator_1.b1();
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var shouldProcess_0 = get_onlyReadVisibleLayers(props) ? imageLayers.c1(element_1.s1()).t4z_1 : true;
        var tmp_5;
        if (shouldProcess_0) {
          var tmp_6 = ASE_getInstance();
          var tmp_7 = imageLayers.c1(element_1.s1()).w52_1;
          tmp_5 = takeLayersByName(props, tmp_6, (!(tmp_7 == null) ? typeof tmp_7 === 'string' : false) ? tmp_7 : THROW_CCE());
        } else {
          tmp_5 = false;
        }
        if (tmp_5) {
          destination_1.g3(element_1.s1(), element_1.t1());
        }
      }
      var cells = destination_1;
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.mapTo' call
      var destination_2 = ArrayList.w(cells.d1());
      // Inline function 'kotlin.collections.iterator' call
      var tmp0_iterator_2 = cells.r1().z();
      while (tmp0_iterator_2.a1()) {
        var item = tmp0_iterator_2.b1();
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        // Inline function 'kotlin.collections.component1' call
        var key = item.s1();
        // Inline function 'kotlin.collections.component2' call
        var value = item.t1();
        var tmp$ret$23 = readImageContainer$createImageFrameLayer(imageLayers, image, key, value);
        destination_2.f(tmp$ret$23);
      }
      var layerData = destination_2;
      var tmp_8;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!layerData.f1()) {
        // Inline function 'korlibs.time.milliseconds' call
        var this_4 = element_0.d50_1;
        // Inline function 'kotlin.time.Companion.milliseconds' call
        Companion_getInstance();
        var tmp$ret$28 = toDuration(this_4, DurationUnit_MILLISECONDS_getInstance());
        tmp_8 = ImageFrame.e53(element_0.c50_1, tmp$ret$28, layerData);
      } else {
        tmp_8 = ImageFrame.d53(element_0.c50_1);
      }
      var tmp0_safe_receiver = tmp_8;
      if (tmp0_safe_receiver == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_0.f(tmp0_safe_receiver);
      }
    }
    var frames = destination_0;
    // Inline function 'kotlin.collections.map' call
    var this_5 = image.k51_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_3 = ArrayList.w(collectionSizeOrDefault(this_5, 10));
    var tmp0_iterator_3 = this_5.z();
    while (tmp0_iterator_3.a1()) {
      var item_0 = tmp0_iterator_3.b1();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var framesRange = slice(frames, numberRangeToNumber(clamp(item_0.a51_1, 0, frames.d1()), clamp(item_0.b51_1, 0, frames.d1() - 1 | 0)));
      var tmp$ret$33 = new ImageAnimation(framesRange, item_0.f51_1, item_0.e51_1);
      destination_3.f(tmp$ret$33);
    }
    var animations = destination_3;
    var defaultData = new ImageData(frames, VOID, imageWidth, imageHeight, imageLayersToProcess, animations);
    // Inline function 'kotlin.collections.mapNotNull' call
    // Inline function 'kotlin.collections.mapNotNullTo' call
    var this_6 = image.l51_1;
    var destination_4 = ArrayList.p1();
    // Inline function 'kotlin.collections.forEach' call
    var tmp0_iterator_4 = this_6.z();
    while (tmp0_iterator_4.a1()) {
      var element_2 = tmp0_iterator_4.b1();
      // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      element_2.x50();
      var tmp$ret$36;
      $l$block: {
        // Inline function 'kotlin.collections.maxOfOrNull' call
        var iterator = element_2.w50_1.z();
        if (!iterator.a1()) {
          tmp$ret$36 = null;
          break $l$block;
        }
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var maxValue = iterator.b1().d4y_1;
        while (iterator.a1()) {
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var v = iterator.b1().d4y_1;
          if (compareTo(maxValue, v) < 0) {
            maxValue = v;
          }
        }
        tmp$ret$36 = maxValue;
      }
      var tmp0_elvis_lhs = tmp$ret$36;
      var maxWidth = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      var tmp$ret$39;
      $l$block_0: {
        // Inline function 'kotlin.collections.maxOfOrNull' call
        var iterator_0 = element_2.w50_1.z();
        if (!iterator_0.a1()) {
          tmp$ret$39 = null;
          break $l$block_0;
        }
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var maxValue_0 = iterator_0.b1().e4y_1;
        while (iterator_0.a1()) {
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var v_0 = iterator_0.b1().e4y_1;
          if (compareTo(maxValue_0, v_0) < 0) {
            maxValue_0 = v_0;
          }
        }
        tmp$ret$39 = maxValue_0;
      }
      var tmp1_elvis_lhs = tmp$ret$39;
      var maxHeight = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      // Inline function 'kotlin.collections.mapNotNull' call
      // Inline function 'kotlin.collections.mapNotNullTo' call
      var this_7 = image.j51_1;
      var destination_5 = ArrayList.p1();
      // Inline function 'kotlin.collections.forEach' call
      var tmp0_iterator_5 = this_7.z();
      while (tmp0_iterator_5.a1()) {
        var element_3 = tmp0_iterator_5.b1();
        // Inline function 'kotlin.collections.mapNotNullTo.<anonymous>' call
        // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
        var sliceKey = element_2.y50(element_3.c50_1);
        // Inline function 'kotlin.collections.filter' call
        // Inline function 'kotlin.collections.filterTo' call
        var this_8 = toLinkedMap(element_3.e50_1);
        var destination_6 = LinkedHashMap.ac();
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_6 = this_8.r1().z();
        while (tmp0_iterator_6.a1()) {
          var element_4 = tmp0_iterator_6.b1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          var shouldProcess_1 = get_onlyReadVisibleLayers(props) ? imageLayers.c1(element_4.s1()).t4z_1 : true;
          var tmp_9;
          if (shouldProcess_1) {
            var tmp_10 = ASE_getInstance();
            var tmp_11 = imageLayers.c1(element_4.s1()).w52_1;
            tmp_9 = takeLayersByName(props, tmp_10, (!(tmp_11 == null) ? typeof tmp_11 === 'string' : false) ? tmp_11 : THROW_CCE());
          } else {
            tmp_9 = false;
          }
          if (tmp_9) {
            destination_6.g3(element_4.s1(), element_4.t1());
          }
        }
        var cells_0 = destination_6;
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.map' call
        // Inline function 'kotlin.collections.mapTo' call
        var destination_7 = ArrayList.w(cells_0.d1());
        // Inline function 'kotlin.collections.iterator' call
        var tmp0_iterator_7 = cells_0.r1().z();
        while (tmp0_iterator_7.a1()) {
          var item_1 = tmp0_iterator_7.b1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          // Inline function 'kotlin.collections.component1' call
          var key_0 = item_1.s1();
          // Inline function 'kotlin.collections.component2' call
          var value_0 = item_1.t1();
          var tmp$ret$49 = readImageContainer$createImageFrameLayer(imageLayers, image, key_0, value_0);
          destination_7.f(tmp$ret$49);
        }
        // Inline function 'kotlin.collections.mapTo' call
        var destination_8 = ArrayList.w(collectionSizeOrDefault(destination_7, 10));
        var tmp0_iterator_8 = destination_7.z();
        while (tmp0_iterator_8.a1()) {
          var item_2 = tmp0_iterator_8.b1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>.<anonymous>' call
          var sliceKeyFrame = sliceKey.l4y_1;
          var sliceFrame = RectangleInt.j2a(sliceKeyFrame.f2a_1 - item_2.g53_1 | 0, sliceKeyFrame.g2a_1 - item_2.h53_1 | 0, sliceKeyFrame.h2a_1, sliceKeyFrame.i2a_1);
          var sslice = item_2.o53_1.f3a(sliceFrame, item_2.o53_1.r38_1);
          var ninePatchSlice = element_2.u50_1 ? asNinePatchSimple(sslice, sliceKey.f4y_1, sliceKey.g4y_1, sliceKey.f4y_1 + sliceKey.h4y_1 | 0, sliceKey.g4y_1 + sliceKey.i4y_1 | 0) : null;
          var tmp$ret$52 = new ImageFrameLayer(item_2.f53_1, sslice, (useSlicePosition(props, ASE_getInstance()) ? sliceKeyFrame.f2a_1 : item_2.g53_1) - sliceKey.j4y_1 | 0, (useSlicePosition(props, ASE_getInstance()) ? sliceKeyFrame.g2a_1 : item_2.h53_1) - sliceKey.k4y_1 | 0, item_2.i53_1, item_2.j53_1, VOID, ninePatchSlice);
          destination_8.f(tmp$ret$52);
        }
        var layerData_0 = destination_8;
        var tmp_12;
        // Inline function 'kotlin.collections.isNotEmpty' call
        if (!layerData_0.f1()) {
          // Inline function 'korlibs.time.milliseconds' call
          var this_9 = element_3.d50_1;
          // Inline function 'kotlin.time.Companion.milliseconds' call
          Companion_getInstance();
          var tmp$ret$57 = toDuration(this_9, DurationUnit_MILLISECONDS_getInstance());
          tmp_12 = ImageFrame.e53(element_3.c50_1, tmp$ret$57, layerData_0);
        } else {
          tmp_12 = null;
        }
        var tmp0_safe_receiver_0 = tmp_12;
        if (tmp0_safe_receiver_0 == null)
          null;
        else {
          // Inline function 'kotlin.let' call
          // Inline function 'kotlin.contracts.contract' call
          destination_5.f(tmp0_safe_receiver_0);
        }
      }
      var frames_0 = destination_5;
      var tmp_13;
      var tmp_14;
      // Inline function 'kotlin.collections.isNotEmpty' call
      if (!frames_0.f1()) {
        tmp_14 = slicingEnabled(props, ASE_getInstance());
      } else {
        tmp_14 = false;
      }
      if (tmp_14) {
        // Inline function 'kotlin.collections.map' call
        var this_10 = image.k51_1;
        // Inline function 'kotlin.collections.mapTo' call
        var destination_9 = ArrayList.w(collectionSizeOrDefault(this_10, 10));
        var tmp0_iterator_9 = this_10.z();
        while (tmp0_iterator_9.a1()) {
          var item_3 = tmp0_iterator_9.b1();
          // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>.<anonymous>' call
          var framesRange_0 = slice(frames_0, numberRangeToNumber(clamp(item_3.a51_1, 0, frames_0.d1()), clamp(item_3.b51_1, 0, frames_0.d1() - 1 | 0)));
          var tmp$ret$63 = new ImageAnimation(framesRange_0, item_3.f51_1, item_3.e51_1);
          destination_9.f(tmp$ret$63);
        }
        var animations_0 = destination_9;
        tmp_13 = new ImageData(frames_0, VOID, maxWidth, maxHeight, imageLayersToProcess, animations_0, element_2.t50_1);
      } else {
        tmp_13 = null;
      }
      var tmp0_safe_receiver_1 = tmp_13;
      if (tmp0_safe_receiver_1 == null)
        null;
      else {
        // Inline function 'kotlin.let' call
        // Inline function 'kotlin.contracts.contract' call
        destination_4.f(tmp0_safe_receiver_1);
      }
    }
    var datas = destination_4;
    // Inline function 'kotlin.collections.forEachIndexed' call
    var index = 0;
    var tmp0_iterator_10 = imageLayersToProcess.z();
    while (tmp0_iterator_10.a1()) {
      var item_4 = tmp0_iterator_10.b1();
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      var tmp1 = index;
      index = tmp1 + 1 | 0;
      item_4.v52_1 = checkIndexOverflow(tmp1);
    }
    // Inline function 'kotlin.collections.ifEmpty' call
    // Inline function 'kotlin.contracts.contract' call
    var tmp_15;
    if (datas.f1()) {
      // Inline function 'korlibs.image.format.ASE.readImageContainer.<anonymous>' call
      tmp_15 = listOf_0(defaultData);
    } else {
      tmp_15 = datas;
    }
    var tmp$ret$71 = tmp_15;
    return new ImageDataContainer(tmp$ret$71);
  }
  u52(_this__u8e3s4) {
    return _RGBA___init__impl__lqpay5(readS32LE(_this__u8e3s4));
  }
  t52(_this__u8e3s4) {
    return Companion_instance_26.p53(readS32LE(_this__u8e3s4));
  }
  c52(_this__u8e3s4) {
    return readString(_this__u8e3s4, readU16LE(_this__u8e3s4));
  }
}
class Companion_20 {
  p53(raw) {
    return _Fixed32___init__impl__8jizkq(raw);
  }
}
class Companion_21 {
  constructor() {
    Companion_instance_27 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_4();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.a54_1;
      destination.g3(tmp$ret$0, element);
    }
    tmp.c54_1 = destination;
  }
  c1(index) {
    var tmp0_elvis_lhs = this.c54_1.b3(index);
    return tmp0_elvis_lhs == null ? DataFormat_UNKNOWN_getInstance() : tmp0_elvis_lhs;
  }
}
class DataFormat extends Enum {
  constructor(name, ordinal, id, indexBytes) {
    super(name, ordinal);
    this.a54_1 = id;
    this.b54_1 = indexBytes;
  }
}
class EXIF {
  constructor() {
    EXIF_instance = this;
    this.d54_1 = Companion_getInstance_15().us('EXIF');
  }
  e54(ss, info, debug, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_readExifBase__4npesx(this, ss, info, debug, $completion), $completion);
  }
  f54(ss, info, debug, $completion, $super) {
    info = info === VOID ? new ImageInfo() : info;
    debug = debug === VOID ? false : debug;
    return $super === VOID ? this.e54(ss, info, debug, $completion) : $super.e54.call(this, ss, info, debug, $completion);
  }
}
class Direction extends Enum {}
class sam$kotlin_Comparator$0_0 {
  constructor(function_0) {
    this.g54_1 = function_0;
  }
  ei(a, b) {
    return this.g54_1(a, b);
  }
  compare(a, b) {
    return this.ei(a, b);
  }
}
class ImageAnimation {
  constructor(frames, direction, name, layers) {
    var tmp;
    if (layers === VOID) {
      // Inline function 'kotlin.collections.sortedBy' call
      // Inline function 'kotlin.collections.map' call
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var destination = ArrayList.p1();
      var tmp0_iterator = frames.z();
      while (tmp0_iterator.a1()) {
        var element = tmp0_iterator.b1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var list = element.b53_1;
        addAll(destination, list);
      }
      // Inline function 'kotlin.collections.mapTo' call
      var destination_0 = ArrayList.w(collectionSizeOrDefault(destination, 10));
      var tmp0_iterator_0 = destination.z();
      while (tmp0_iterator_0.a1()) {
        var item = tmp0_iterator_0.b1();
        // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
        var tmp$ret$3 = item.f53_1;
        destination_0.f(tmp$ret$3);
      }
      var this_0 = distinct(destination_0);
      // Inline function 'kotlin.comparisons.compareBy' call
      var tmp_0 = ImageAnimation$_init_$lambda_bxp50i;
      var tmp$ret$6 = new sam$kotlin_Comparator$0_0(tmp_0);
      tmp = sortedWith(this_0, tmp$ret$6);
    } else {
      tmp = layers;
    }
    layers = tmp;
    this.h54_1 = frames;
    this.i54_1 = direction;
    this.j54_1 = name;
    this.k54_1 = layers;
    var tmp_1 = this;
    var tmp0_elvis_lhs = firstOrNull_0(this.h54_1);
    tmp_1.l54_1 = tmp0_elvis_lhs == null ? ImageFrame.d53(0) : tmp0_elvis_lhs;
  }
}
class Companion_22 {
  m54(simple) {
    return new ImageData(listOf_0(Companion_instance_30.n54(simple)));
  }
}
class sam$kotlin_Comparator$0_1 {
  constructor(function_0) {
    this.o54_1 = function_0;
  }
  ei(a, b) {
    return this.o54_1(a, b);
  }
  compare(a, b) {
    return this.ei(a, b);
  }
}
class ImageData {
  constructor(frames, loopCount, width, height, layers, animations, name) {
    loopCount = loopCount === VOID ? 0 : loopCount;
    var tmp;
    if (width === VOID) {
      var tmp170_safe_receiver = firstOrNull_0(frames);
      var tmp0_elvis_lhs = tmp170_safe_receiver == null ? null : tmp170_safe_receiver.n2d();
      tmp = tmp0_elvis_lhs == null ? 1 : tmp0_elvis_lhs;
    } else {
      tmp = width;
    }
    width = tmp;
    var tmp_0;
    if (height === VOID) {
      var tmp171_safe_receiver = firstOrNull_0(frames);
      var tmp1_elvis_lhs = tmp171_safe_receiver == null ? null : tmp171_safe_receiver.o2d();
      tmp_0 = tmp1_elvis_lhs == null ? 1 : tmp1_elvis_lhs;
    } else {
      tmp_0 = height;
    }
    height = tmp_0;
    layers = layers === VOID ? fastArrayListOf([]) : layers;
    animations = animations === VOID ? fastArrayListOf([]) : animations;
    name = name === VOID ? null : name;
    this.r54_1 = new Mixin();
    this.s54_1 = frames;
    this.t54_1 = loopCount;
    this.u54_1 = width;
    this.v54_1 = height;
    this.w54_1 = layers;
    this.x54_1 = animations;
    this.y54_1 = name;
    this.z54_1 = new ImageAnimation(this.s54_1, Direction_FORWARD_getInstance(), 'default');
    var tmp_1 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.x54_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var element = tmp0_iterator.b1();
      // Inline function 'korlibs.image.format.ImageData.animationsByName.<anonymous>' call
      var tmp$ret$0 = element.j54_1;
      destination.g3(tmp$ret$0, element);
    }
    tmp_1.a55_1 = destination;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_1 = this.s54_1;
    var capacity_0 = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_1, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination_0 = LinkedHashMap.bc(capacity_0);
    var tmp0_iterator_0 = this_1.z();
    while (tmp0_iterator_0.a1()) {
      var element_0 = tmp0_iterator_0.b1();
      // Inline function 'korlibs.image.format.ImageData.framesByName.<anonymous>' call
      var tmp$ret$3 = element_0.n3();
      destination_0.g3(tmp$ret$3, element_0);
    }
    tmp_2.b55_1 = destination_0;
    var tmp_3 = this;
    // Inline function 'kotlin.collections.sortedByDescending' call
    var this_2 = this.s54_1;
    // Inline function 'kotlin.comparisons.compareByDescending' call
    var tmp_4 = ImageData$framesSortedByPriority$lambda;
    var tmp$ret$6 = new sam$kotlin_Comparator$0_1(tmp_4);
    tmp_3.c55_1 = sortedWith(this_2, tmp$ret$6);
  }
  tw(_set____db54di) {
    this.r54_1.tw(_set____db54di);
  }
  uw() {
    return this.r54_1.uw();
  }
  d55() {
    var tmp172_safe_receiver = firstOrNull_0(this.c55_1);
    var tmp0_elvis_lhs = tmp172_safe_receiver == null ? null : tmp172_safe_receiver.p54();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      throw IllegalArgumentException.l('No bitmap found');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageData(' + toString_0(this.s54_1) + ')';
  }
}
class ImageDataContainer {
  constructor(imageDatas) {
    this.e55_1 = imageDatas;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = this.e55_1;
    var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(this_0, 10)), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var element = tmp0_iterator.b1();
      // Inline function 'korlibs.image.format.ImageDataContainer.imageDatasByName.<anonymous>' call
      var tmp$ret$0 = element.y54_1;
      destination.g3(tmp$ret$0, element);
    }
    tmp.f55_1 = destination;
    var tmp_0 = this;
    var tmp0_elvis_lhs = this.f55_1.b3(null);
    tmp_0.g55_1 = tmp0_elvis_lhs == null ? first_0(this.e55_1) : tmp0_elvis_lhs;
  }
}
class Companion_23 {
  constructor() {
    Companion_instance_29 = this;
    this.r48_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.s48_1 = new ImageDecodingProps(VOID, VOID, VOID, true);
    this.t48_1 = new ImageDecodingProps(VOID, VOID, VOID, false);
  }
}
class ImageDecodingProps {
  constructor(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    Companion_getInstance_40();
    filename = filename === VOID ? 'unknown' : filename;
    width = width === VOID ? null : width;
    height = height === VOID ? null : height;
    premultiplied = premultiplied === VOID ? null : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? false : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? null : requestedMaxSize;
    debug = debug === VOID ? false : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? false : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? true : tryNativeDecode;
    format = format === VOID ? get_RegisteredImageFormats() : format;
    out = out === VOID ? null : out;
    extra = extra === VOID ? null : extra;
    this.g52_1 = filename;
    this.h52_1 = width;
    this.i52_1 = height;
    this.j52_1 = premultiplied;
    this.k52_1 = asumePremultiplied;
    this.l52_1 = requestedMaxSize;
    this.m52_1 = debug;
    this.n52_1 = preferKotlinDecoder;
    this.o52_1 = tryNativeDecode;
    this.p52_1 = format;
    this.q52_1 = out;
    this.r52_1 = extra;
  }
  tw(_set____db54di) {
    this.r52_1 = _set____db54di;
  }
  uw() {
    return this.r52_1;
  }
  r53() {
    return this;
  }
  s52() {
    var tmp0_elvis_lhs = this.j52_1;
    return tmp0_elvis_lhs == null ? true : tmp0_elvis_lhs;
  }
  h55(filename) {
    return this.i55(filename);
  }
  j55(file) {
    return this.h55(get_baseName(file));
  }
  k55(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) {
    return new ImageDecodingProps(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  i55(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra, $super) {
    filename = filename === VOID ? this.g52_1 : filename;
    width = width === VOID ? this.h52_1 : width;
    height = height === VOID ? this.i52_1 : height;
    premultiplied = premultiplied === VOID ? this.j52_1 : premultiplied;
    asumePremultiplied = asumePremultiplied === VOID ? this.k52_1 : asumePremultiplied;
    requestedMaxSize = requestedMaxSize === VOID ? this.l52_1 : requestedMaxSize;
    debug = debug === VOID ? this.m52_1 : debug;
    preferKotlinDecoder = preferKotlinDecoder === VOID ? this.n52_1 : preferKotlinDecoder;
    tryNativeDecode = tryNativeDecode === VOID ? this.o52_1 : tryNativeDecode;
    format = format === VOID ? this.p52_1 : format;
    out = out === VOID ? this.q52_1 : out;
    extra = extra === VOID ? this.r52_1 : extra;
    return $super === VOID ? this.k55(filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra) : $super.k55.call(this, filename, width, height, premultiplied, asumePremultiplied, requestedMaxSize, debug, preferKotlinDecoder, tryNativeDecode, format, out, extra);
  }
  toString() {
    return 'ImageDecodingProps(filename=' + this.g52_1 + ', width=' + this.h52_1 + ', height=' + this.i52_1 + ', premultiplied=' + this.j52_1 + ', asumePremultiplied=' + this.k52_1 + ', requestedMaxSize=' + this.l52_1 + ', debug=' + this.m52_1 + ', preferKotlinDecoder=' + this.n52_1 + ', tryNativeDecode=' + this.o52_1 + ', format=' + toString(this.p52_1) + ', out=' + toString(this.q52_1) + ', extra=' + toString(this.r52_1) + ')';
  }
  hashCode() {
    var result = getStringHashCode(this.g52_1);
    result = imul(result, 31) + (this.h52_1 == null ? 0 : this.h52_1) | 0;
    result = imul(result, 31) + (this.i52_1 == null ? 0 : this.i52_1) | 0;
    result = imul(result, 31) + (this.j52_1 == null ? 0 : getBooleanHashCode(this.j52_1)) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.k52_1) | 0;
    result = imul(result, 31) + (this.l52_1 == null ? 0 : this.l52_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.m52_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.n52_1) | 0;
    result = imul(result, 31) + getBooleanHashCode(this.o52_1) | 0;
    result = imul(result, 31) + (this.p52_1 == null ? 0 : hashCode(this.p52_1)) | 0;
    result = imul(result, 31) + (this.q52_1 == null ? 0 : hashCode(this.q52_1)) | 0;
    result = imul(result, 31) + (this.r52_1 == null ? 0 : hashCode(this.r52_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ImageDecodingProps))
      return false;
    var tmp0_other_with_cast = other instanceof ImageDecodingProps ? other : THROW_CCE();
    if (!(this.g52_1 === tmp0_other_with_cast.g52_1))
      return false;
    if (!(this.h52_1 == tmp0_other_with_cast.h52_1))
      return false;
    if (!(this.i52_1 == tmp0_other_with_cast.i52_1))
      return false;
    if (!(this.j52_1 == tmp0_other_with_cast.j52_1))
      return false;
    if (!(this.k52_1 === tmp0_other_with_cast.k52_1))
      return false;
    if (!(this.l52_1 == tmp0_other_with_cast.l52_1))
      return false;
    if (!(this.m52_1 === tmp0_other_with_cast.m52_1))
      return false;
    if (!(this.n52_1 === tmp0_other_with_cast.n52_1))
      return false;
    if (!(this.o52_1 === tmp0_other_with_cast.o52_1))
      return false;
    if (!equals(this.p52_1, tmp0_other_with_cast.p52_1))
      return false;
    if (!equals(this.q52_1, tmp0_other_with_cast.q52_1))
      return false;
    if (!equals(this.r52_1, tmp0_other_with_cast.r52_1))
      return false;
    return true;
  }
}
class ImageDecoderNotFoundException extends Exception {}
class ImageFormats extends ImageFormat {
  static q55(formats) {
    var $this = this.l55(['']);
    $this.o55_1 = atomic$ref$1(minus(listFormats(formats), $this));
    return $this;
  }
  static r55(formats) {
    return this.q55(toList_1(formats));
  }
  s55(_set____db54di) {
    var this_0 = this.o55_1;
    _formats$factory();
    this_0.kotlinx$atomicfu$value = _set____db54di;
    return Unit_instance;
  }
  t55() {
    // Inline function 'kotlinx.atomicfu.AtomicRef.getValue' call
    var this_0 = this.o55_1;
    _formats$factory_0();
    return this_0.kotlinx$atomicfu$value;
  }
  p55() {
    return this.t55();
  }
  u55(ext) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'kotlin.collections.firstOrNull' call
      var tmp0_iterator = this.p55().z();
      while (tmp0_iterator.a1()) {
        var element = tmp0_iterator.b1();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExtOrNull.<anonymous>' call
        if (element.k4s_1.w2(ext)) {
          tmp$ret$1 = element;
          break $l$block;
        }
      }
      tmp$ret$1 = null;
    }
    return tmp$ret$1;
  }
  v55(ext) {
    var tmp0_elvis_lhs = this.u55(ext);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'kotlin.collections.flatMap' call
      // Inline function 'kotlin.collections.flatMapTo' call
      var this_0 = this.p55();
      var destination = ArrayList.p1();
      var tmp0_iterator = this_0.z();
      while (tmp0_iterator.a1()) {
        var element = tmp0_iterator.b1();
        // Inline function 'korlibs.image.format.ImageFormats.formatByExt.<anonymous>' call
        var list = element.k4s_1;
        addAll(destination, list);
      }
      throw UnsupportedOperationException.x9("Don't know how to generate file for extension '" + ext + "' (supported extensions " + toString_0(destination) + ')');
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  toString() {
    return 'ImageFormats(' + this.p55().d1() + ')' + toString_0(this.p55());
  }
  v51(s, props) {
    if (this.p55().f1())
      return null;
    var _iterator__ex2g4s = this.p55().z();
    $l$loop_0: while (_iterator__ex2g4s.a1()) {
      var format = _iterator__ex2g4s.b1();
      var tmp;
      try {
        var tmp0_elvis_lhs = format.v51(sliceStart_0(s), props);
        var tmp_0;
        if (tmp0_elvis_lhs == null) {
          continue $l$loop_0;
        } else {
          tmp_0 = tmp0_elvis_lhs;
        }
        tmp = tmp_0;
      } catch ($p) {
        var tmp_1;
        if ($p instanceof Error) {
          var e = $p;
          if (e instanceof CancellationException)
            throw e;
          continue $l$loop_0;
        } else {
          throw $p;
        }
      }
      return tmp;
    }
    return null;
  }
  q53(s, props) {
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
      var _iterator__ex2g4s = this.p55().z();
      while (_iterator__ex2g4s.a1()) {
        var format = _iterator__ex2g4s.b1();
        if (format.t53(sliceStart_0(s), props)) {
          // Inline function 'korlibs.image.format.ImageFormats.readImage.<anonymous>' call
          var s_0 = sliceStart_0(s);
          tmp$ret$1 = format.q53(sliceStart_0(s_0), props);
          break $l$block;
        }
      }
      throw UnsupportedOperationException.x9('No suitable image format : MAGIC:' + readString_1(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
    }
    return tmp$ret$1;
  }
  x53(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme(this, data, props, $completion), $completion);
  }
  w53(file, props, $completion) {
    return this.v55(get_extensionLC(file)).w53(file, props, $completion);
  }
}
class ImageFormatsMutable extends ImageFormats {
  static a56() {
    var $this = this.r55([]);
    $this.z55_1 = new NonRecursiveLock();
    return $this;
  }
  b56(formats) {
    $l$block: {
      // Inline function 'korlibs.concurrent.lock.BaseLock.invoke' call
      var this_0 = this.z55_1;
      this_0.l1o();
      try {
        this.s55(minus(plus_0(this.t55(), formats), this));
        break $l$block;
      }finally {
        this_0.o1o();
      }
    }
  }
}
class Companion_24 {
  c56(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) {
    return ImageFrame.e53(index, time, fastArrayListOf([new ImageFrameLayer(new ImageLayer(0, null, Type_NORMAL_getInstance()), slice_0(bitmap, VOID, name), targetX, targetY, main, includeInAtlas)]));
  }
  n54(bitmap, time, targetX, targetY, main, includeInAtlas, name, index, $super) {
    var tmp;
    if (time === VOID) {
      // Inline function 'korlibs.time.seconds' call
      // Inline function 'korlibs.time.seconds' call
      tmp = toDuration(0, DurationUnit_SECONDS_getInstance());
    } else {
      tmp = time;
    }
    time = tmp;
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    name = name === VOID ? null : name;
    index = index === VOID ? 0 : index;
    return $super === VOID ? this.c56(bitmap, time, targetX, targetY, main, includeInAtlas, name, index) : $super.c56.call(this, bitmap, new Duration(time), targetX, targetY, main, includeInAtlas, name, index);
  }
}
class ImageFrame {
  static d53(index, fastTime, layerData) {
    fastTime = fastTime === VOID ? get_fastSeconds(0) : fastTime;
    layerData = layerData === VOID ? emptyList() : layerData;
    var $this = createThis(this);
    $this.y52_1 = new Mixin();
    $this.z52_1 = index;
    $this.a53_1 = fastTime;
    $this.b53_1 = layerData;
    $this.c53_1 = firstOrNull_0($this.b53_1);
    return $this;
  }
  tw(_set____db54di) {
    this.y52_1.tw(_set____db54di);
  }
  uw() {
    return this.y52_1.uw();
  }
  d56() {
    return toDuration_0(this.a53_1);
  }
  static e53(index, time, layerData) {
    layerData = layerData === VOID ? emptyList() : layerData;
    return this.d53(index, get_fast(time), layerData);
  }
  e56() {
    var tmp176_safe_receiver = this.c53_1;
    var tmp0_elvis_lhs = tmp176_safe_receiver == null ? null : tmp176_safe_receiver.o53_1;
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  f56() {
    var tmp177_safe_receiver = this.c53_1;
    var tmp0_elvis_lhs = tmp177_safe_receiver == null ? null : tmp177_safe_receiver.g53_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  g56() {
    var tmp178_safe_receiver = this.c53_1;
    var tmp0_elvis_lhs = tmp178_safe_receiver == null ? null : tmp178_safe_receiver.h53_1;
    return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
  }
  q54() {
    var tmp179_safe_receiver = this.c53_1;
    var tmp0_elvis_lhs = tmp179_safe_receiver == null ? null : tmp179_safe_receiver.i53_1;
    return tmp0_elvis_lhs == null ? false : tmp0_elvis_lhs;
  }
  n2d() {
    return this.e56().w38_1;
  }
  o2d() {
    return this.e56().x38_1;
  }
  p54() {
    var tmp181_safe_receiver = this.c53_1;
    var tmp0_elvis_lhs = tmp181_safe_receiver == null ? null : tmp181_safe_receiver.p54();
    var tmp;
    if (tmp0_elvis_lhs == null) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    return tmp;
  }
  n3() {
    return this.e56().r38_1;
  }
  toString() {
    return 'ImageFrame(' + this.e56().toString() + ', time=' + Duration__toString_impl_8d916b(this.d56()) + ', targetX=' + this.f56() + ', targetY=' + this.g56() + ', main=' + this.q54() + ')';
  }
}
class ImageFrameLayer {
  constructor(layer, slice, targetX, targetY, main, includeInAtlas, tilemap, ninePatchSlice) {
    targetX = targetX === VOID ? 0 : targetX;
    targetY = targetY === VOID ? 0 : targetY;
    main = main === VOID ? true : main;
    includeInAtlas = includeInAtlas === VOID ? true : includeInAtlas;
    tilemap = tilemap === VOID ? null : tilemap;
    ninePatchSlice = ninePatchSlice === VOID ? null : ninePatchSlice;
    this.f53_1 = layer;
    this.g53_1 = targetX;
    this.h53_1 = targetY;
    this.i53_1 = main;
    this.j53_1 = includeInAtlas;
    this.k53_1 = tilemap;
    this.l53_1 = ninePatchSlice;
    this.m53_1 = null;
    this.n53_1 = null;
    this.o53_1 = slice;
  }
  n2d() {
    return this.o53_1.w38_1;
  }
  o2d() {
    return this.o53_1.x38_1;
  }
  p54() {
    if (get_bmp(this.o53_1).n2d() === this.n2d() && get_bmp(this.o53_1).o2d() === this.o2d())
      return get_bmp(this.o53_1);
    if (this.m53_1 == null)
      this.m53_1 = extract_0(this.o53_1);
    return ensureNotNull(this.m53_1);
  }
}
class ImageInfo {
  constructor() {
    this.w51_1 = new Mixin();
    this.x51_1 = 0;
    this.y51_1 = 0;
    this.z51_1 = 8;
  }
  tw(_set____db54di) {
    this.w51_1.tw(_set____db54di);
  }
  uw() {
    return this.w51_1.uw();
  }
  toString() {
    var tmp = this.x51_1;
    var tmp_0 = this.y51_1;
    var tmp_1 = this.z51_1;
    var tmp182_safe_receiver = this.uw();
    return 'ImageInfo(width=' + tmp + ', height=' + tmp_0 + ', bpp=' + tmp_1 + ', extra=' + toString(tmp182_safe_receiver == null ? null : toMap_0(tmp182_safe_receiver)) + ')';
  }
}
class Companion_25 {
  constructor() {
    Companion_instance_31 = this;
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.b52_1 = [Type_NORMAL_getInstance(), Type_GROUP_getInstance(), Type_TILEMAP_getInstance()];
  }
}
class Type extends Enum {
  f52() {
    return this.equals(Type_TILEMAP_getInstance());
  }
}
class NativeImageFormatProvider {
  b57(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt(this, vfs, path, props, $completion), $completion);
  }
  x53(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeSuspend__fioeme_0(this, data, props, $completion), $completion);
  }
  c57(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_0(this, file, props, $completion), $completion);
  }
  w53(file, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decode__skqvkq_1(this, file, props, $completion), $completion);
  }
  l40(bmp) {
    // Inline function 'kotlin.apply' call
    var this_0 = this.m40(bmp.n2d(), bmp.o2d(), bmp.z3m());
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>' call
    // Inline function 'korlibs.image.bitmap.context2d' call
    // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
    var rect = this_0.k3m_1;
    if (true) {
      this_0.l1o();
    }
    var result;
    try {
      // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
      var ctx = this_0.c3u(true);
      try {
        // Inline function 'korlibs.image.format.NativeImageFormatProvider.copy.<anonymous>.<anonymous>' call
        ctx.h57(bmp, Companion_getInstance_7().v21_1);
      }finally {
        ctx.p11();
      }
    }finally {
      result = true ? this_0.u3m(rect) : 0;
    }
    return this_0;
  }
}
class BaseNativeImageFormatProvider extends NativeImageFormatProvider {
  p55() {
    return get_RegisteredImageFormats();
  }
  h56(data, props, $completion) {
    return this.i56(this.p55().v53(data, props), props);
  }
  j56(bmp) {
    return BitmapNativeImage.a57(bmp);
  }
  i56(bmp, props) {
    var bmp32 = bmp.d3u();
    return new NativeImageResult(this.j56(props.k52_1 ? asumePremultiplied(bmp32) : props.s52() ? bmp32.m3x() : bmp32.n3x()));
  }
  m40(width, height, premultiplied) {
    return this.j56(Bitmap32.z3l(width, height, VOID, premultiplied == null ? true : premultiplied));
  }
  l40(bmp) {
    return this.j56(bmp);
  }
}
class NativeImageResult {
  constructor(image, originalWidth, originalHeight) {
    originalWidth = originalWidth === VOID ? image.n2d() : originalWidth;
    originalHeight = originalHeight === VOID ? image.o2d() : originalHeight;
    this.d57_1 = image;
    this.e57_1 = originalWidth;
    this.f57_1 = originalHeight;
  }
  toString() {
    return 'NativeImageResult(image=' + this.d57_1.toString() + ', originalWidth=' + this.e57_1 + ', originalHeight=' + this.f57_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.d57_1);
    result = imul(result, 31) + this.e57_1 | 0;
    result = imul(result, 31) + this.f57_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof NativeImageResult))
      return false;
    var tmp0_other_with_cast = other instanceof NativeImageResult ? other : THROW_CCE();
    if (!equals(this.d57_1, tmp0_other_with_cast.d57_1))
      return false;
    if (!(this.e57_1 === tmp0_other_with_cast.e57_1))
      return false;
    if (!(this.f57_1 === tmp0_other_with_cast.f57_1))
      return false;
    return true;
  }
}
class BitmapNativeImage extends NativeImage {
  static g57(bitmap) {
    var $this = this.k40(bitmap.n2d(), bitmap.o2d(), bitmap, bitmap.z3m());
    $this.y56_1 = bitmap;
    $this.z56_1 = $this.y56_1.w3l_1;
    return $this;
  }
  n3() {
    return 'BitmapNativeImage';
  }
  static a57(bitmap) {
    return this.g57(bitmap.d3u());
  }
  c3u(antialiasing) {
    return this.y56_1.c3u(antialiasing);
  }
  s3m() {
    return this.y56_1;
  }
  f3n(x, y, width, height, out, offset) {
    return this.y56_1.f3n(x, y, width, height, out, offset);
  }
  h3n(x, y, width, height, out, offset) {
    return this.y56_1.h3n(x, y, width, height, out, offset);
  }
  i3n(x, y, v) {
    return this.y56_1.i3n(x, y, v);
  }
  g3n(x, y) {
    return this.y56_1.g3n(x, y);
  }
}
class Companion_26 {
  constructor() {
    Companion_instance_32 = this;
    var tmp = this;
    // Inline function 'kotlin.collections.associateBy' call
    var this_0 = values_5();
    var capacity = coerceAtLeast(mapCapacity(this_0.length), 16);
    // Inline function 'kotlin.collections.associateByTo' call
    var destination = LinkedHashMap.bc(capacity);
    var inductionVariable = 0;
    var last = this_0.length;
    while (inductionVariable < last) {
      var element = this_0[inductionVariable];
      inductionVariable = inductionVariable + 1 | 0;
      // Inline function 'korlibs.image.format.Companion.BY_ID.<anonymous>' call
      var tmp$ret$0 = element.k57_1;
      destination.g3(tmp$ret$0, element);
    }
    tmp.m57_1 = destination;
  }
}
class InterlacedPass {
  constructor(startingRow, startingCol, rowIncrement, colIncrement, blockHeight, blockWidth) {
    this.n57_1 = startingRow;
    this.o57_1 = startingCol;
    this.p57_1 = rowIncrement;
    this.q57_1 = colIncrement;
    this.r57_1 = blockHeight;
    this.s57_1 = blockWidth;
    var tmp = this;
    // Inline function 'kotlin.math.log2' call
    var x = this.q57_1;
    var tmp$ret$0 = log2(x);
    tmp.t57_1 = numberToInt(tmp$ret$0);
  }
  toString() {
    return 'InterlacedPass(startingRow=' + this.n57_1 + ', startingCol=' + this.o57_1 + ', rowIncrement=' + this.p57_1 + ', colIncrement=' + this.q57_1 + ', blockHeight=' + this.r57_1 + ', blockWidth=' + this.s57_1 + ')';
  }
  hashCode() {
    var result = this.n57_1;
    result = imul(result, 31) + this.o57_1 | 0;
    result = imul(result, 31) + this.p57_1 | 0;
    result = imul(result, 31) + this.q57_1 | 0;
    result = imul(result, 31) + this.r57_1 | 0;
    result = imul(result, 31) + this.s57_1 | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof InterlacedPass))
      return false;
    var tmp0_other_with_cast = other instanceof InterlacedPass ? other : THROW_CCE();
    if (!(this.n57_1 === tmp0_other_with_cast.n57_1))
      return false;
    if (!(this.o57_1 === tmp0_other_with_cast.o57_1))
      return false;
    if (!(this.p57_1 === tmp0_other_with_cast.p57_1))
      return false;
    if (!(this.q57_1 === tmp0_other_with_cast.q57_1))
      return false;
    if (!(this.r57_1 === tmp0_other_with_cast.r57_1))
      return false;
    if (!(this.s57_1 === tmp0_other_with_cast.s57_1))
      return false;
    return true;
  }
}
class Colorspace extends Enum {
  constructor(name, ordinal, id, nchannels) {
    super(name, ordinal);
    this.k57_1 = id;
    this.l57_1 = nchannels;
  }
}
class Header {
  constructor(width, height, bitsPerChannel, colorspace, compressionmethod, filtermethod, interlacemethod) {
    this.u57_1 = width;
    this.v57_1 = height;
    this.w57_1 = bitsPerChannel;
    this.x57_1 = colorspace;
    this.y57_1 = compressionmethod;
    this.z57_1 = filtermethod;
    this.a58_1 = interlacemethod;
    var tmp = this;
    var tmp_0;
    switch (this.x57_1.m3_1) {
      case 0:
        tmp_0 = 1;
        break;
      case 2:
        tmp_0 = 1;
        break;
      case 3:
        tmp_0 = 2;
        break;
      case 1:
        tmp_0 = 3;
        break;
      case 4:
        tmp_0 = 4;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    tmp.b58_1 = tmp_0;
    this.c58_1 = imul(imul(this.u57_1, this.b58_1), this.w57_1) / 8 | 0;
  }
}
class DecodingContext {
  constructor(header) {
    this.d58_1 = header;
    this.e58_1 = _UByteArrayInt___init__impl__xif7bu_0(this.d58_1.c58_1);
    this.f58_1 = _UByteArrayInt___init__impl__xif7bu_0(this.d58_1.c58_1);
    this.g58_1 = Companion_instance_11.t3x(this.d58_1.u57_1);
  }
  p58() {
    var temp = this.f58_1;
    this.f58_1 = this.e58_1;
    this.e58_1 = temp;
  }
}
class PNG$readCommon$readChunk$slambda {
  constructor($data, $info) {
    this.q58_1 = $data;
    this.r58_1 = $info;
  }
  od($completion) {
    return EXIF_getInstance().f54(openAsync(readAll_0(this.q58_1)), this.r58_1, VOID, $completion);
  }
}
class PNG extends ImageFormat {
  static s58() {
    PNG_instance = null;
    var $this = this.l55(['png']);
    PNG_instance = $this;
    $this.j58_1 = -1991225785;
    $this.k58_1 = 218765834;
    $this.l58_1 = listOf([new InterlacedPass(0, 0, 8, 8, 8, 8), new InterlacedPass(0, 4, 8, 8, 8, 4), new InterlacedPass(4, 0, 8, 4, 4, 4), new InterlacedPass(0, 2, 4, 4, 4, 2), new InterlacedPass(2, 0, 4, 2, 2, 2), new InterlacedPass(0, 1, 2, 2, 2, 1), new InterlacedPass(1, 0, 2, 1, 1, 1)]);
    $this.m58_1 = listOf_0(new InterlacedPass(0, 0, 1, 1, 1, 1));
    return $this;
  }
  v51(s, props) {
    var tmp;
    try {
      var info = new ImageInfo();
      var tmp_0 = readCommon(this, s, true, info);
      var header = tmp_0 instanceof Header ? tmp_0 : THROW_CCE();
      tmp = info;
    } catch ($p) {
      var tmp_1;
      if ($p instanceof Error) {
        var t = $p;
        tmp_1 = null;
      } else {
        throw $p;
      }
      tmp = tmp_1;
    }
    return tmp;
  }
  q53(s, props) {
    var tmp = Companion_instance_28;
    var tmp_0 = readCommon$default(this, s, false);
    return tmp.m54(tmp_0 instanceof Bitmap ? tmp_0 : THROW_CCE());
  }
  t58(a, b, c) {
    var p = (a + b | 0) - c | 0;
    var pa = abs(p - a | 0);
    var pb = abs(p - b | 0);
    var pc = abs(p - c | 0);
    return pa <= pb && pa <= pc ? a : pb <= pc ? b : c;
  }
  n58(filter, p, c, bpp, size) {
    switch (filter) {
      case 0:
        break;
      case 1:
        var inductionVariable = bpp;
        if (inductionVariable < size)
          do {
            var n = inductionVariable;
            inductionVariable = inductionVariable + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n, UByteArrayInt__get_impl_px6q8a(c, n) + UByteArrayInt__get_impl_px6q8a(c, n - bpp | 0) | 0);
          }
           while (inductionVariable < size);
        break;
      case 2:
        var inductionVariable_0 = 0;
        if (inductionVariable_0 < size)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_0, UByteArrayInt__get_impl_px6q8a(c, n_0) + UByteArrayInt__get_impl_px6q8a(p, n_0) | 0);
          }
           while (inductionVariable_0 < size);
        break;
      case 3:
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < bpp)
          do {
            var n_1 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_1, UByteArrayInt__get_impl_px6q8a(c, n_1) + (UByteArrayInt__get_impl_px6q8a(p, n_1) / 2 | 0) | 0);
          }
           while (inductionVariable_1 < bpp);
        var inductionVariable_2 = bpp;
        if (inductionVariable_2 < size)
          do {
            var n_2 = inductionVariable_2;
            inductionVariable_2 = inductionVariable_2 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_2, UByteArrayInt__get_impl_px6q8a(c, n_2) + ((UByteArrayInt__get_impl_px6q8a(c, n_2 - bpp | 0) + UByteArrayInt__get_impl_px6q8a(p, n_2) | 0) / 2 | 0) | 0);
          }
           while (inductionVariable_2 < size);
        break;
      case 4:
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < bpp)
          do {
            var n_3 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_3, UByteArrayInt__get_impl_px6q8a(c, n_3) + UByteArrayInt__get_impl_px6q8a(p, n_3) | 0);
          }
           while (inductionVariable_3 < bpp);
        var inductionVariable_4 = bpp;
        if (inductionVariable_4 < size)
          do {
            var n_4 = inductionVariable_4;
            inductionVariable_4 = inductionVariable_4 + 1 | 0;
            UByteArrayInt__set_impl_gn4532(c, n_4, UByteArrayInt__get_impl_px6q8a(c, n_4) + this.t58(UByteArrayInt__get_impl_px6q8a(c, n_4 - bpp | 0), UByteArrayInt__get_impl_px6q8a(p, n_4), UByteArrayInt__get_impl_px6q8a(p, n_4 - bpp | 0)) | 0);
          }
           while (inductionVariable_4 < size);
        break;
      default:
        // Inline function 'kotlin.TODO' call

        var reason = 'Filter: ' + filter;
        throw NotImplementedError.nd('An operation is not implemented: ' + reason);
    }
  }
  o58(filter, p, c, bpp, size, $super) {
    size = size === VOID ? _UByteArrayInt___get_size__impl__bcjnte(c) : size;
    var tmp;
    if ($super === VOID) {
      this.n58(filter, p, c, bpp, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.n58.call(this, filter, new UByteArrayInt(p), new UByteArrayInt(c), bpp, size);
    }
    return tmp;
  }
}
class BaseFiller {
  x58(data, offset, x0, x1, y) {
    var yFloat = y;
    var inductionVariable = x0;
    if (inductionVariable <= x1)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        RgbaPremultipliedArray__set_impl_7fwbby(data, offset + n | 0, this.w58(n, yFloat));
      }
       while (!(n === x1));
  }
  y58(bmp, rect) {
    var cols = _RgbaPremultipliedArray___init__impl__lx83hy(bmp.w3l_1);
    var inductionVariable = rect.m22();
    var last = rect.n22();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var offset = imul(y, bmp.n2d());
        this.x58(cols, offset, rect.k22(), rect.l22() - 1 | 0, y);
      }
       while (inductionVariable < last);
  }
  z58(bmp, rect, $super) {
    rect = rect === VOID ? bmp.y3l_1 : rect;
    var tmp;
    if ($super === VOID) {
      this.y58(bmp, rect);
      tmp = Unit_instance;
    } else {
      tmp = $super.y58.call(this, bmp, rect);
    }
    return tmp;
  }
}
class ColorFiller extends BaseFiller {
  constructor() {
    super();
    this.u58_1 = _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().m3n_1);
  }
  v58(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.ColorFiller.set.<anonymous>' call
    this.u58_1 = _RGBA___get_premultiplied__impl__3bulqc(_RGBA___get_color__impl__8x3sb3(fill));
    return this;
  }
  w58(x, y) {
    return this.u58_1;
  }
  x58(data, offset, x0, x1, y) {
    RgbaPremultipliedArray__fill_impl_sem38t(data, this.u58_1, offset + x0 | 0, (offset + x1 | 0) + 1 | 0);
  }
}
class Companion_27 {
  constructor() {
    this.a59_1 = 256;
  }
}
class GradientFiller extends BaseFiller {
  constructor() {
    super();
    this.b59_1 = Companion_instance_14.f45(256);
  }
  d59(fill, state) {
    fill.e59(this.b59_1);
    this.c59_1 = fill.f59(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, Companion_getInstance_6().a25_1.s26(fill.d4t_1).s26(state.b47_1));
    return this;
  }
  g59(x, y) {
    return _get_fill__d6ivc8(this).h59(Vector2D.j26(x, y));
  }
  w58(x, y) {
    return color(this, this.g59(x, y));
  }
}
class BitmapFiller extends BaseFiller {
  constructor() {
    super();
    this.i59_1 = _CycleMethodPair___init__impl__y6jlco_0(CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_getInstance());
    this.j59_1 = 0.0;
    this.k59_1 = 0.0;
    this.l59_1 = 0.0;
    this.m59_1 = 0.0;
    var tmp = this;
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    tmp.n59_1 = get_bmp(tmp$ret$0);
    this.o59_1 = Companion_getInstance_6().a25_1;
    this.p59_1 = true;
    this.q59_1 = Companion_getInstance_6().a25_1;
  }
  r59(fill, state) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.BitmapFiller.set.<anonymous>' call
    this.i59_1 = _CycleMethodPair___init__impl__y6jlco_0(fill.u59_1, fill.v59_1);
    _set_texture__qu271y(this, fill.y59_1);
    this.o59_1 = fill.t59_1;
    this.p59_1 = fill.w59_1;
    this.q59_1 = Companion_getInstance_6().a25_1.l26(state.b47_1).l26(fill.t59_1).m26();
    return this;
  }
  z59(x, y) {
    return this.n59_1.e3t(x, y);
  }
  a5a(x, y) {
    return this.n59_1.z3v(numberToInt(x), numberToInt(y));
  }
  w58(x, y) {
    var mat = this.q59_1;
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var tmp$ret$0;
    $l$block: {
      // Inline function 'korlibs.math.geom.Matrix.transform' call
      var p = Vector2D.j26(x, y);
      if (mat.i22()) {
        tmp$ret$0 = p;
        break $l$block;
      }
      tmp$ret$0 = Vector2D.j21(mat.s25(p.h21_1, p.i21_1), mat.v25(p.h21_1, p.i21_1));
    }
    var this_0 = tmp$ret$0;
    var that = Vector2D.j26(this.l59_1, this.m59_1);
    var p_0 = Vector2D.j21(this_0.h21_1 * that.h21_1, this_0.i21_1 * that.i21_1);
    // Inline function 'korlibs.math.geom.Vector2D.times' call
    var this_1 = CycleMethodPair__apply_impl_g3sekg(this.i59_1, p_0);
    var that_0 = Vector2D.j26(this.j59_1, this.k59_1);
    var t = Vector2D.j21(this_1.h21_1 * that_0.h21_1, this_1.i21_1 * that_0.i21_1);
    return this.p59_1 ? _RGBA___get_premultiplied__impl__3bulqc(this.z59(t.h21_1, t.i21_1)) : _RGBA___get_premultiplied__impl__3bulqc(this.a5a(t.h21_1, t.i21_1));
  }
}
class NoneFiller extends BaseFiller {
  constructor() {
    NoneFiller_instance = null;
    super();
    NoneFiller_instance = this;
  }
  w58(x, y) {
    return _RGBAPremultiplied___init__impl__uos02x(0);
  }
  x58(data, offset, x0, x1, y) {
    return Unit_instance;
  }
}
class Companion_28 {}
class TransformedPaint {}
class GradientPaint {
  constructor(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    stops = stops === VOID ? DoubleArrayList.q2f() : stops;
    colors = colors === VOID ? IntArrayList.w2e() : colors;
    cycle = cycle === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycle;
    transform = transform === VOID ? Companion_getInstance_6().a25_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? GradientInterpolationMethod_NORMAL_getInstance() : interpolationMethod;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    startAngle = startAngle === VOID ? Companion_getInstance_9().m21_1 : startAngle;
    this.t4s_1 = kind;
    this.u4s_1 = x0;
    this.v4s_1 = y0;
    this.w4s_1 = r0;
    this.x4s_1 = x1;
    this.y4s_1 = y1;
    this.z4s_1 = r1;
    this.a4t_1 = stops;
    this.b4t_1 = colors;
    this.c4t_1 = cycle;
    this.d4t_1 = transform;
    this.e4t_1 = interpolationMethod;
    this.f4t_1 = units;
    this.g4t_1 = startAngle;
    var tmp = this;
    var tmp_0 = Companion_getInstance_6().a25_1.g26(-this.u4s_1, -this.v4s_1).b26(1.0 / clamp_1(Companion_getInstance_7().p2a(this.u4s_1, this.v4s_1, this.x4s_1, this.y4s_1), 1.0, 16000.0));
    // Inline function 'korlibs.math.geom.Companion.between' call
    Companion_getInstance_9();
    var x0_0 = this.u4s_1;
    var y0_0 = this.v4s_1;
    var x1_0 = this.x4s_1;
    var y1_0 = this.y4s_1;
    var up = Companion_getInstance_7().z21_1;
    var tmp$ret$0 = Angle_between(x0_0, y0_0, x1_0, y1_0, up);
    tmp.h4t_1 = tmp_0.y25(Angle__unaryMinus_impl_7901fr(tmp$ret$0));
    this.i4t_1 = this.d4t_1.m26();
    this.j4t_1 = Companion_getInstance_6().a25_1.l26(this.h4t_1).l26(this.i4t_1);
    this.k4t_1 = 2 * this.w4s_1 * this.z4s_1;
    this.l4t_1 = this.b5a(this.w4s_1);
    this.m4t_1 = this.b5a(this.z4s_1);
    this.n4t_1 = this.v4s_1 - this.y4s_1;
    this.o4t_1 = this.w4s_1 - this.z4s_1;
    this.p4t_1 = this.u4s_1 - this.x4s_1;
    this.q4t_1 = 1.0 / (this.b5a(this.w4s_1 - this.z4s_1) - this.b5a(this.u4s_1 - this.x4s_1) - this.b5a(this.v4s_1 - this.y4s_1));
  }
  a4h() {
    return this.d4t_1;
  }
  e59(out) {
    return _fillColors(Companion_instance_34, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(out), this.a4t_1, this.b4t_1, true);
  }
  r4t(stop, color) {
    return this.c5a(stop, color);
  }
  c5a(stop, color) {
    this.a4t_1.y2f(stop);
    this.b4t_1.d2f(_RGBA___get_value__impl__hhco8v(color));
    return this;
  }
  h59(p) {
    var tmp;
    switch (this.t4s_1.m3_1) {
      case 2:
        var tmp$ret$0;
        $l$block: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_0 = this.i4t_1;
          if (this_0.i22()) {
            tmp$ret$0 = p;
            break $l$block;
          }
          tmp$ret$0 = Vector2D.j21(this_0.s25(p.h21_1, p.i21_1), this_0.v25(p.h21_1, p.i21_1));
        }

        var p_0 = tmp$ret$0;
        tmp = Angle__div_impl_ut2btd(Companion_getInstance_7().c2c(Vector2D.j21(this.u4s_1, this.v4s_1), p_0), get_degrees(360));
        break;
      case 1:
        var tmp$ret$1;
        $l$block_0: {
          // Inline function 'korlibs.math.geom.Matrix.transform' call
          var this_1 = this.i4t_1;
          if (this_1.i22()) {
            tmp$ret$1 = p;
            break $l$block_0;
          }
          tmp$ret$1 = Vector2D.j21(this_1.s25(p.h21_1, p.i21_1), this_1.v25(p.h21_1, p.i21_1));
        }

        var _destruct__k2r9zo = tmp$ret$1;
        var x = _destruct__k2r9zo.rk();
        var y = _destruct__k2r9zo.sk();
        var tmp_0 = -this.z4s_1 * this.o4t_1 + this.p4t_1 * (this.x4s_1 - x) + this.n4t_1 * (this.y4s_1 - y);
        // Inline function 'kotlin.math.sqrt' call

        var x_0 = this.m4t_1 * (this.b5a(this.u4s_1 - x) + this.b5a(this.v4s_1 - y)) - this.k4t_1 * ((this.u4s_1 - x) * (this.x4s_1 - x) + (this.v4s_1 - y) * (this.y4s_1 - y)) + this.l4t_1 * (this.b5a(this.x4s_1 - x) + this.b5a(this.y4s_1 - y)) - this.b5a(this.x4s_1 * this.v4s_1 - x * this.v4s_1 - this.u4s_1 * this.y4s_1 + x * this.y4s_1 + this.u4s_1 * y - this.x4s_1 * y);
        tmp = 1.0 - (tmp_0 - Math.sqrt(x_0)) * this.q4t_1;
        break;
      default:
        tmp = this.j4t_1.r25(p);
        break;
    }
    return this.c4t_1.f5a(tmp);
  }
  b5a(_this__u8e3s4) {
    return _this__u8e3s4 * _this__u8e3s4;
  }
  qw() {
    return this.f59(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.d4t_1);
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.paint.GradientPaint.toString.<anonymous>' call
    var tmp;
    switch (this.t4s_1.m3_1) {
      case 0:
        tmp = 'LinearGradient([' + this.u4s_1 + ', ' + this.v4s_1 + '], [' + this.x4s_1 + ', ' + this.y4s_1 + ']';
        break;
      case 1:
        tmp = 'RadialGradient([' + this.u4s_1 + ', ' + this.v4s_1 + ', ' + this.w4s_1 + '], [' + this.x4s_1 + ', ' + this.y4s_1 + ', ' + this.z4s_1 + ']';
        break;
      case 2:
        tmp = 'ConicGradient([' + this.u4s_1 + ', ' + this.v4s_1 + ']';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    this_0.nb(tmp);
    this_0.nb(', stops=' + this.a4t_1.toString() + ', colors=' + colorsToString_0(this, this.b4t_1) + ', cycle=' + this.c4t_1.toString() + ', transform=' + this.d4t_1.toString() + ', interpolationMethod=' + this.e4t_1.toString() + ', units=' + this.f4t_1.toString() + ')');
    return this_0.toString();
  }
  g5a(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) {
    return new GradientPaint(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle);
  }
  f59(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle, $super) {
    kind = kind === VOID ? this.t4s_1 : kind;
    x0 = x0 === VOID ? this.u4s_1 : x0;
    y0 = y0 === VOID ? this.v4s_1 : y0;
    r0 = r0 === VOID ? this.w4s_1 : r0;
    x1 = x1 === VOID ? this.x4s_1 : x1;
    y1 = y1 === VOID ? this.y4s_1 : y1;
    r1 = r1 === VOID ? this.z4s_1 : r1;
    stops = stops === VOID ? this.a4t_1 : stops;
    colors = colors === VOID ? this.b4t_1 : colors;
    cycle = cycle === VOID ? this.c4t_1 : cycle;
    transform = transform === VOID ? this.d4t_1 : transform;
    interpolationMethod = interpolationMethod === VOID ? this.e4t_1 : interpolationMethod;
    units = units === VOID ? this.f4t_1 : units;
    startAngle = startAngle === VOID ? this.g4t_1 : startAngle;
    return $super === VOID ? this.g5a(kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, startAngle) : $super.g5a.call(this, kind, x0, y0, r0, x1, y1, r1, stops, colors, cycle, transform, interpolationMethod, units, new Angle(startAngle));
  }
  hashCode() {
    var result = this.t4s_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.u4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.v4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.w4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.x4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.y4s_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.z4s_1) | 0;
    result = imul(result, 31) + this.a4t_1.hashCode() | 0;
    result = imul(result, 31) + this.b4t_1.hashCode() | 0;
    result = imul(result, 31) + this.c4t_1.hashCode() | 0;
    result = imul(result, 31) + this.d4t_1.hashCode() | 0;
    result = imul(result, 31) + this.e4t_1.hashCode() | 0;
    result = imul(result, 31) + this.f4t_1.hashCode() | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.g4t_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof GradientPaint))
      return false;
    var tmp0_other_with_cast = other instanceof GradientPaint ? other : THROW_CCE();
    if (!this.t4s_1.equals(tmp0_other_with_cast.t4s_1))
      return false;
    if (!equals(this.u4s_1, tmp0_other_with_cast.u4s_1))
      return false;
    if (!equals(this.v4s_1, tmp0_other_with_cast.v4s_1))
      return false;
    if (!equals(this.w4s_1, tmp0_other_with_cast.w4s_1))
      return false;
    if (!equals(this.x4s_1, tmp0_other_with_cast.x4s_1))
      return false;
    if (!equals(this.y4s_1, tmp0_other_with_cast.y4s_1))
      return false;
    if (!equals(this.z4s_1, tmp0_other_with_cast.z4s_1))
      return false;
    if (!this.a4t_1.equals(tmp0_other_with_cast.a4t_1))
      return false;
    if (!this.b4t_1.equals(tmp0_other_with_cast.b4t_1))
      return false;
    if (!this.c4t_1.equals(tmp0_other_with_cast.c4t_1))
      return false;
    if (!this.d4t_1.equals(tmp0_other_with_cast.d4t_1))
      return false;
    if (!this.e4t_1.equals(tmp0_other_with_cast.e4t_1))
      return false;
    if (!this.f4t_1.equals(tmp0_other_with_cast.f4t_1))
      return false;
    if (!equals(this.g4t_1, tmp0_other_with_cast.g4t_1))
      return false;
    return true;
  }
}
class GradientKind extends Enum {}
class GradientInterpolationMethod extends Enum {}
class GradientUnits extends Enum {}
class NonePaint {
  qw() {
    return this;
  }
}
class BitmapPaint {
  constructor(bitmap, transform, cycleX, cycleY, smooth, units) {
    transform = transform === VOID ? Companion_getInstance_6().a25_1 : transform;
    cycleX = cycleX === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleX;
    cycleY = cycleY === VOID ? CycleMethod_NO_CYCLE_getInstance() : cycleY;
    smooth = smooth === VOID ? true : smooth;
    units = units === VOID ? GradientUnits_OBJECT_BOUNDING_BOX_getInstance() : units;
    this.s59_1 = bitmap;
    this.t59_1 = transform;
    this.u59_1 = cycleX;
    this.v59_1 = cycleY;
    this.w59_1 = smooth;
    this.x59_1 = units;
    this.y59_1 = this.s59_1.s3m();
  }
  a4h() {
    return this.t59_1;
  }
  h5a() {
    return this.u59_1.i5a();
  }
  j5a() {
    return this.v59_1.i5a();
  }
  qw() {
    return this.k5a(VOID, this.t59_1);
  }
  toString() {
    return 'BitmapPaint(' + toString_0(this.s59_1) + ', cycle=(' + this.u59_1.toString() + ', ' + this.v59_1.toString() + '), smooth=' + this.w59_1 + ', transform=' + this.t59_1.toString() + ')';
  }
  l5a(bitmap, transform, cycleX, cycleY, smooth, units) {
    return new BitmapPaint(bitmap, transform, cycleX, cycleY, smooth, units);
  }
  k5a(bitmap, transform, cycleX, cycleY, smooth, units, $super) {
    bitmap = bitmap === VOID ? this.s59_1 : bitmap;
    transform = transform === VOID ? this.t59_1 : transform;
    cycleX = cycleX === VOID ? this.u59_1 : cycleX;
    cycleY = cycleY === VOID ? this.v59_1 : cycleY;
    smooth = smooth === VOID ? this.w59_1 : smooth;
    units = units === VOID ? this.x59_1 : units;
    return $super === VOID ? this.l5a(bitmap, transform, cycleX, cycleY, smooth, units) : $super.l5a.call(this, bitmap, transform, cycleX, cycleY, smooth, units);
  }
  hashCode() {
    var result = hashCode(this.s59_1);
    result = imul(result, 31) + this.t59_1.hashCode() | 0;
    result = imul(result, 31) + this.u59_1.hashCode() | 0;
    result = imul(result, 31) + this.v59_1.hashCode() | 0;
    result = imul(result, 31) + getBooleanHashCode(this.w59_1) | 0;
    result = imul(result, 31) + this.x59_1.hashCode() | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof BitmapPaint))
      return false;
    var tmp0_other_with_cast = other instanceof BitmapPaint ? other : THROW_CCE();
    if (!equals(this.s59_1, tmp0_other_with_cast.s59_1))
      return false;
    if (!this.t59_1.equals(tmp0_other_with_cast.t59_1))
      return false;
    if (!this.u59_1.equals(tmp0_other_with_cast.u59_1))
      return false;
    if (!this.v59_1.equals(tmp0_other_with_cast.v59_1))
      return false;
    if (!(this.w59_1 === tmp0_other_with_cast.w59_1))
      return false;
    if (!this.x59_1.equals(tmp0_other_with_cast.x59_1))
      return false;
    return true;
  }
}
class Companion_29 {
  constructor() {
    Companion_instance_35 = this;
    this.m5a_1 = _VerticalAlign___init__impl__f42kfq(0.0);
    this.n5a_1 = _VerticalAlign___init__impl__f42kfq(0.5);
    this.o5a_1 = _VerticalAlign___init__impl__f42kfq(1.0);
    this.p5a_1 = _VerticalAlign___init__impl__f42kfq(Infinity);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.q5a_1 = [new VerticalAlign(this.m5a_1), new VerticalAlign(this.n5a_1), new VerticalAlign(this.p5a_1), new VerticalAlign(this.o5a_1)];
    this.r5a_1 = toList_1(this.q5a_1);
  }
}
class VerticalAlign {
  constructor(ratio) {
    Companion_getInstance_46();
    this.s5a_1 = ratio;
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.s5a_1);
  }
  hashCode() {
    return VerticalAlign__hashCode_impl_vx8hj7(this.s5a_1);
  }
  equals(other) {
    return VerticalAlign__equals_impl_xp13z(this.s5a_1, other);
  }
}
class Companion_30 {
  constructor() {
    Companion_instance_36 = this;
    this.t5a_1 = _HorizontalAlign___init__impl__ad654o(-1.0 / 2048.0);
    this.u5a_1 = _HorizontalAlign___init__impl__ad654o(0.0);
    this.v5a_1 = _HorizontalAlign___init__impl__ad654o(0.5);
    this.w5a_1 = _HorizontalAlign___init__impl__ad654o(1.0);
    var tmp = this;
    // Inline function 'kotlin.arrayOf' call
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.x5a_1 = [new HorizontalAlign(this.u5a_1), new HorizontalAlign(this.v5a_1), new HorizontalAlign(this.w5a_1), new HorizontalAlign(this.t5a_1)];
    this.y5a_1 = toList_1(this.x5a_1);
  }
}
class HorizontalAlign {
  constructor(ratio) {
    Companion_getInstance_47();
    this.z5a_1 = ratio;
  }
  toString() {
    return HorizontalAlign__toString_impl_toflc0(this.z5a_1);
  }
  hashCode() {
    return HorizontalAlign__hashCode_impl_7x9oj5(this.z5a_1);
  }
  equals(other) {
    return HorizontalAlign__equals_impl_hkfbhv(this.z5a_1, other);
  }
}
class Companion_31 {
  constructor() {
    Companion_instance_37 = this;
    this.o4c_1 = listOf([new HorizontalAlign(Companion_getInstance_47().u5a_1), new HorizontalAlign(Companion_getInstance_47().v5a_1), new HorizontalAlign(Companion_getInstance_47().w5a_1), new HorizontalAlign(Companion_getInstance_47().t5a_1)]);
    var tmp = this;
    // Inline function 'kotlin.collections.map' call
    var this_0 = this.o4c_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.text.Companion.TOP.<anonymous>' call
      var it = item.z5a_1;
      var tmp$ret$0 = new TextAlignment(it, Companion_getInstance_46().m5a_1);
      destination.f(tmp$ret$0);
    }
    tmp.p4c_1 = destination;
    var tmp_0 = this;
    // Inline function 'kotlin.collections.map' call
    var this_1 = this.o4c_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
    var tmp0_iterator_0 = this_1.z();
    while (tmp0_iterator_0.a1()) {
      var item_0 = tmp0_iterator_0.b1();
      // Inline function 'korlibs.image.text.Companion.BASELINE.<anonymous>' call
      var it_0 = item_0.z5a_1;
      var tmp$ret$3 = new TextAlignment(it_0, Companion_getInstance_46().p5a_1);
      destination_0.f(tmp$ret$3);
    }
    tmp_0.q4c_1 = destination_0;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.map' call
    var this_2 = this.o4c_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_1 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
    var tmp0_iterator_1 = this_2.z();
    while (tmp0_iterator_1.a1()) {
      var item_1 = tmp0_iterator_1.b1();
      // Inline function 'korlibs.image.text.Companion.MIDDLE.<anonymous>' call
      var it_1 = item_1.z5a_1;
      var tmp$ret$6 = new TextAlignment(it_1, Companion_getInstance_46().n5a_1);
      destination_1.f(tmp$ret$6);
    }
    tmp_1.r4c_1 = destination_1;
    var tmp_2 = this;
    // Inline function 'kotlin.collections.map' call
    var this_3 = this.o4c_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination_2 = ArrayList.w(collectionSizeOrDefault(this_3, 10));
    var tmp0_iterator_2 = this_3.z();
    while (tmp0_iterator_2.a1()) {
      var item_2 = tmp0_iterator_2.b1();
      // Inline function 'korlibs.image.text.Companion.BOTTOM.<anonymous>' call
      var it_2 = item_2.z5a_1;
      var tmp$ret$9 = new TextAlignment(it_2, Companion_getInstance_46().o5a_1);
      destination_2.f(tmp$ret$9);
    }
    tmp_2.s4c_1 = destination_2;
    this.t4c_1 = plus(plus(plus(this.p4c_1, this.q4c_1), this.r4c_1), this.s4c_1);
    this.u4c_1 = this.p4c_1.c1(0);
    this.v4c_1 = this.p4c_1.c1(1);
    this.w4c_1 = this.p4c_1.c1(2);
    this.x4c_1 = this.p4c_1.c1(3);
    this.y4c_1 = this.q4c_1.c1(0);
    this.z4c_1 = this.q4c_1.c1(1);
    this.a4d_1 = this.q4c_1.c1(2);
    this.b4d_1 = this.q4c_1.c1(3);
    this.c4d_1 = this.p4c_1.c1(0);
    this.d4d_1 = this.p4c_1.c1(1);
    this.e4d_1 = this.p4c_1.c1(2);
    this.f4d_1 = this.p4c_1.c1(3);
    this.g4d_1 = this.r4c_1.c1(0);
    this.h4d_1 = this.r4c_1.c1(1);
    this.i4d_1 = this.r4c_1.c1(2);
    this.j4d_1 = this.r4c_1.c1(3);
    this.k4d_1 = this.s4c_1.c1(0);
    this.l4d_1 = this.s4c_1.c1(1);
    this.m4d_1 = this.s4c_1.c1(2);
    this.n4d_1 = this.s4c_1.c1(3);
  }
  a5b(horizontal, vertical) {
    var tmp;
    if (equals(horizontal, Companion_getInstance_47().u5a_1)) {
      tmp = 0;
    } else if (equals(horizontal, Companion_getInstance_47().v5a_1)) {
      tmp = 1;
    } else if (equals(horizontal, Companion_getInstance_47().w5a_1)) {
      tmp = 2;
    } else if (equals(horizontal, Companion_getInstance_47().t5a_1)) {
      tmp = 3;
    } else {
      return new TextAlignment(horizontal, vertical);
    }
    var horizontalIndex = tmp;
    return equals(vertical, Companion_getInstance_46().m5a_1) ? this.p4c_1.c1(horizontalIndex) : equals(vertical, Companion_getInstance_46().p5a_1) ? this.q4c_1.c1(horizontalIndex) : equals(vertical, Companion_getInstance_46().n5a_1) ? this.r4c_1.c1(horizontalIndex) : equals(vertical, Companion_getInstance_46().o5a_1) ? this.s4c_1.c1(horizontalIndex) : new TextAlignment(horizontal, vertical);
  }
}
class TextAlignment {
  constructor(horizontal, vertical) {
    Companion_getInstance_48();
    this.m4e_1 = horizontal;
    this.n4e_1 = vertical;
    this.o4e_1 = Anchor2D.f21(_HorizontalAlign___get_ratioFake__impl__h46z0d(this.m4e_1), _VerticalAlign___get_ratioFake__impl__1h2fwv(this.n4e_1));
  }
  toString() {
    return VerticalAlign__toString_impl_hcpnn2(this.n4e_1) + '_' + HorizontalAlign__toString_impl_toflc0(this.m4e_1);
  }
  hashCode() {
    var result = HorizontalAlign__hashCode_impl_7x9oj5(this.m4e_1);
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.n4e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TextAlignment))
      return false;
    var tmp0_other_with_cast = other instanceof TextAlignment ? other : THROW_CCE();
    if (!equals(this.m4e_1, tmp0_other_with_cast.m4e_1))
      return false;
    if (!equals(this.n4e_1, tmp0_other_with_cast.n4e_1))
      return false;
    return true;
  }
}
class TextRenderer {}
function get_version() {
  return 0;
}
class LineStats {
  constructor(maxLineHeight, maxX, bounds) {
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    maxX = maxX === VOID ? 0.0 : maxX;
    bounds = bounds === VOID ? Companion_getInstance_8().t22() : bounds;
    this.q4e_1 = maxLineHeight;
    this.r4e_1 = maxX;
    this.s4e_1 = bounds;
  }
  t4e(align) {
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, this.r4e_1) + BoundsBuilder__xminOr_impl_k3l1m2(this.s4e_1, 0.0);
  }
  i4h(dx) {
    this.r4e_1 = this.r4e_1 + dx;
  }
  d5b(fontMetrics) {
    var tmp = this;
    // Inline function 'kotlin.math.max' call
    var a = this.q4e_1;
    var b = fontMetrics.v45();
    tmp.q4e_1 = Math.max(a, b);
  }
  e5b() {
  }
  e2h() {
    this.r4e_1 = 0.0;
    this.s4e_1 = Companion_getInstance_8().o22_1;
    this.q4e_1 = 0.0;
  }
  toString() {
    return 'LineStats(maxLineHeight=' + this.q4e_1 + ', maxX=' + this.r4e_1 + ', bounds=' + BoundsBuilder__toString_impl_fmvxh7(this.s4e_1) + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.q4e_1);
    result = imul(result, 31) + getNumberHashCode(this.r4e_1) | 0;
    result = imul(result, 31) + BoundsBuilder__hashCode_impl_649zbo(this.s4e_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineStats))
      return false;
    var tmp0_other_with_cast = other instanceof LineStats ? other : THROW_CCE();
    if (!equals(this.q4e_1, tmp0_other_with_cast.q4e_1))
      return false;
    if (!equals(this.r4e_1, tmp0_other_with_cast.r4e_1))
      return false;
    if (!equals(this.s4e_1, tmp0_other_with_cast.s4e_1))
      return false;
    return true;
  }
}
class BoundBuilderTextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.g4e_1 = Companion_getInstance_8().t22();
    this.h4e_1 = Companion_getInstance_8().t22();
    this.i4e_1 = 0;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.j4e_1 = ArrayList.p1();
    this.k4e_1 = new LineStats();
  }
  l4e() {
    return this.i4e_1;
  }
  f5b() {
    // Inline function 'kotlin.collections.sumOf' call
    var sum = 0;
    var tmp0_iterator = this.j4e_1.z();
    while (tmp0_iterator.a1()) {
      var element = tmp0_iterator.b1();
      var tmp = sum;
      // Inline function 'korlibs.image.text.BoundBuilderTextRendererActions.<get-totalMaxLineHeight>.<anonymous>' call
      sum = tmp + element.q4e_1;
    }
    return sum;
  }
  y4g(align, line) {
    var tmp0_elvis_lhs = getOrNull_1(this.j4e_1, line);
    var tmp;
    if (tmp0_elvis_lhs == null) {
      return HorizontalAlign__getOffsetX_impl_urzzxf(align, 0.0);
    } else {
      tmp = tmp0_elvis_lhs;
    }
    var line_0 = tmp;
    return HorizontalAlign__getOffsetX_impl_urzzxf(align, line_0.r4e_1);
  }
  p4e(align, fontMetrics) {
    return VerticalAlign__getOffsetYRespectBaseline_impl_62po5b(align, fontMetrics, this.f5b());
  }
  e2h() {
    super.e2h();
    this.i4e_1 = 0;
    this.h4e_1 = Companion_getInstance_8().o22_1;
    this.g4e_1 = Companion_getInstance_8().o22_1;
    this.k4e_1.e2h();
    this.j4e_1.j3();
  }
  m4g(reader, codePoint) {
    var g = this.g4h(reader, codePoint);
    add_0(this, g.u46_1);
    this.k4e_1.d5b(this.p4g_1);
    return g;
  }
  i4h(x) {
    super.i4h(x);
    this.k4e_1.i4h(x);
  }
  j4h(y, end) {
    super.j4h(y, end);
    this.i4e_1 = this.i4e_1 + 1 | 0;
    this.k4e_1.d5b(this.p4g_1);
    this.k4e_1.e5b();
    this.j4e_1.f(this.k4e_1);
    this.k4e_1 = new LineStats();
  }
}
class LineInfo {
  constructor(maxTop, minBottom, maxLineHeight) {
    maxTop = maxTop === VOID ? 0.0 : maxTop;
    minBottom = minBottom === VOID ? 0.0 : minBottom;
    maxLineHeight = maxLineHeight === VOID ? 0.0 : maxLineHeight;
    this.g5b_1 = maxTop;
    this.h5b_1 = minBottom;
    this.i5b_1 = maxLineHeight;
  }
  toString() {
    return 'LineInfo(maxTop=' + this.g5b_1 + ', minBottom=' + this.h5b_1 + ', maxLineHeight=' + this.i5b_1 + ')';
  }
  hashCode() {
    var result = getNumberHashCode(this.g5b_1);
    result = imul(result, 31) + getNumberHashCode(this.h5b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.i5b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof LineInfo))
      return false;
    var tmp0_other_with_cast = other instanceof LineInfo ? other : THROW_CCE();
    if (!equals(this.g5b_1, tmp0_other_with_cast.g5b_1))
      return false;
    if (!equals(this.h5b_1, tmp0_other_with_cast.h5b_1))
      return false;
    if (!equals(this.i5b_1, tmp0_other_with_cast.i5b_1))
      return false;
    return true;
  }
}
class Entry_0 {
  constructor(tex, x, y, sx, sy, rot) {
    var tmp;
    if (tex === VOID) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      tmp = get_Bitmaps_transparent();
    } else {
      tmp = tex;
    }
    tex = tmp;
    x = x === VOID ? 0.0 : x;
    y = y === VOID ? 0.0 : y;
    sx = sx === VOID ? 1.0 : sx;
    sy = sy === VOID ? 1.0 : sy;
    rot = rot === VOID ? get_radians(0) : rot;
    this.j5b_1 = tex;
    this.k5b_1 = x;
    this.l5b_1 = y;
    this.m5b_1 = sx;
    this.n5b_1 = sy;
    this.o5b_1 = rot;
  }
  toString() {
    // Inline function 'kotlin.text.buildString' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.apply' call
    var this_0 = StringBuilder.h();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.Entry.toString.<anonymous>' call
    this_0.nb('Entry(');
    this_0.nb("'" + this.j5b_1.r38_1 + "', " + numberToInt(this.k5b_1) + ', ' + numberToInt(this.l5b_1) + ', ' + this.j5b_1.w38_1 + ', ' + this.j5b_1.x38_1);
    if (!(this.m5b_1 === 1.0)) {
      this_0.nb(', sx=' + get_niceStr_0(this.m5b_1));
    }
    if (!(this.n5b_1 === 1.0)) {
      this_0.nb(', sy=' + get_niceStr_0(this.n5b_1));
    }
    if (!equals(this.o5b_1, get_radians(0))) {
      this_0.nb(', rot=' + get_niceStr_0(_Angle___get_degrees__impl__qg56vw(this.o5b_1)));
    }
    this_0.nb(')');
    return this_0.toString();
  }
  hashCode() {
    var result = this.j5b_1.hashCode();
    result = imul(result, 31) + getNumberHashCode(this.k5b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.l5b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.m5b_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.n5b_1) | 0;
    result = imul(result, 31) + Angle__hashCode_impl_szcndt(this.o5b_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof Entry_0))
      return false;
    var tmp0_other_with_cast = other instanceof Entry_0 ? other : THROW_CCE();
    if (!this.j5b_1.equals(tmp0_other_with_cast.j5b_1))
      return false;
    if (!equals(this.k5b_1, tmp0_other_with_cast.k5b_1))
      return false;
    if (!equals(this.l5b_1, tmp0_other_with_cast.l5b_1))
      return false;
    if (!equals(this.m5b_1, tmp0_other_with_cast.m5b_1))
      return false;
    if (!equals(this.n5b_1, tmp0_other_with_cast.n5b_1))
      return false;
    if (!equals(this.o5b_1, tmp0_other_with_cast.o5b_1))
      return false;
    return true;
  }
}
class Text2TextRendererActions extends TextRendererActions {
  constructor() {
    super();
    this.z5b_1 = Companion_getInstance_48().u4c_1;
    var tmp = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp.a5c_1 = ArrayList.p1();
    this.b5c_1 = doubleArrayListOf(new Float64Array([]));
    this.c5c_1 = doubleArrayListOf(new Float64Array([]));
    this.d5c_1 = doubleArrayListOf(new Float64Array([]));
    this.e5c_1 = doubleArrayListOf(new Float64Array([]));
    this.f5c_1 = doubleArrayListOf(new Float64Array([]));
    this.g5c_1 = new DoubleVectorArrayList(4);
    this.h5c_1 = MatrixTransform.j27();
  }
  i5c() {
    return this.z5b_1.n4e_1;
  }
  d1() {
    return this.b5c_1.d1();
  }
  j5c() {
    var out = arrayListOf([new LineInfo()]);
    // Inline function 'korlibs.math.geom.fastForEachGeneric' call
    var this_0 = this.g5c_1;
    var inductionVariable = 0;
    var last = this_0.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.text.Text2TextRendererActions.getLineInfos.<anonymous>' call
        var line = numberToInt(this_0.a24(n, 0));
        while (out.d1() <= line) {
          out.f(new LineInfo());
        }
        var lineInfo = out.c1(line);
        var top = this_0.a24(n, 1);
        var bottom = this_0.a24(n, 2);
        var lineHeight = this_0.a24(n, 3);
        var tmp = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a = lineInfo.g5b_1;
        tmp.g5b_1 = Math.max(a, top);
        var tmp_0 = lineInfo;
        // Inline function 'kotlin.math.min' call
        var a_0 = lineInfo.h5b_1;
        tmp_0.h5b_1 = Math.min(a_0, bottom);
        var tmp_1 = lineInfo;
        // Inline function 'kotlin.math.max' call
        var a_1 = lineInfo.i5b_1;
        tmp_1.i5b_1 = Math.max(a_1, lineHeight);
      }
       while (inductionVariable < last);
    return out;
  }
  k5c(n) {
    return n >= this.d1() ? Companion_getInstance_5().p22_1 : Companion_getInstance_5().q29(this.b5c_1.c1(n), this.c5c_1.c1(n), this.b5c_1.c1(n) + this.a5c_1.c1(n).w38_1 * this.d5c_1.c1(n), this.c5c_1.c1(n) + this.a5c_1.c1(n).x38_1 * this.e5c_1.c1(n));
  }
  e33() {
    if (this.d1() === 0) {
      return Companion_getInstance_5().p22_1;
    }
    var bb = Companion_getInstance_8().t22();
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, this.k5c(n));
      }
       while (inductionVariable < last);
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  l5c(n, out) {
    out.j5b_1 = this.a5c_1.c1(n);
    out.k5b_1 = this.b5c_1.c1(n);
    out.l5b_1 = this.c5c_1.c1(n);
    out.m5b_1 = this.d5c_1.c1(n);
    out.n5b_1 = this.e5c_1.c1(n);
    var tmp = out;
    // Inline function 'korlibs.math.geom.Companion.fromRatio' call
    Companion_getInstance_9();
    var ratio = this.f5c_1.c1(n);
    // Inline function 'korlibs.math.geom.Companion.ratioToRadians' call
    var ratio_0 = toRatio_0(ratio);
    var tmp$ret$0 = Ratio__times_impl_ucdh7y(ratio_0, 6.283185307179586);
    tmp.o5b_1 = _Angle___init__impl__g23q1m(tmp$ret$0);
    return out;
  }
  m5c() {
    this.f4h(Companion_getInstance_7().v21_1);
    this.a5c_1.j3();
    this.b5c_1.j3();
    this.c5c_1.j3();
    this.d5c_1.j3();
    this.e5c_1.j3();
    this.f5c_1.j3();
    this.g5c_1.j3();
    this.d4h(0);
  }
  m4g(reader, codePoint) {
    var tmp = this.c4h();
    var bf = isInterface(tmp, BitmapFont) ? tmp : THROW_CCE();
    var tmp$ret$1;
    $l$block: {
      // Inline function 'korlibs.io.lang.keep' call
      var tmp0_elvis_lhs = reader == null ? null : reader.ds_1;
      var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
      try {
        // Inline function 'korlibs.image.text.Text2TextRendererActions.put.<anonymous>' call
        tmp$ret$1 = this.g4h(reader, codePoint);
        break $l$block;
      }finally {
        if (reader == null)
          null;
        else {
          reader.ds_1 = old;
        }
      }
    }
    var m = tmp$ret$1;
    var g = bf.c1(codePoint);
    var x = g.l45_1;
    var tmp_0 = g.m45_1;
    var tmp294_subject = this.i5c();
    var y = tmp_0 - (equals(tmp294_subject, Companion_getInstance_46().p5a_1) ? bf.t2g() : bf.v45() * _VerticalAlign___get_ratio__impl__b3ilr8(this.i5c()));
    var fontScale = this.s4g_1 / bf.u45();
    this.h5c_1 = get_immutable(this.a4h()).n26();
    this.a5c_1.f(g.k45_1);
    this.b5c_1.g1y(this.bt().h21_1 + this.a4h().s25(x, y) * fontScale);
    this.c5c_1.g1y(this.bt().i21_1 + this.a4h().v25(x, y) * fontScale);
    this.d5c_1.g1y(this.h5c_1.b27_1 * fontScale);
    this.e5c_1.g1y(this.h5c_1.c27_1 * fontScale);
    this.f5c_1.g1y(Ratio__toDouble_impl_o7epze(_Angle___get_ratio__impl__ap3on4(this.h5c_1.f27_1)));
    this.g5c_1.w2f(this.x4g(), this.p4g_1.f46_1, this.p4g_1.j46_1, this.p4g_1.v45());
    return m;
  }
}
class CreateWStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    this.n5c_1 = $getVersion;
    this.o5c_1 = $handler;
  }
  b5b() {
    return this.n5c_1();
  }
  p5c(_this__u8e3s4, text, size, defaultFont) {
    _this__u8e3s4.e2h();
    _this__u8e3s4.e4h(defaultFont, size);
    var reader = new WStringReader(text);
    while (reader.ks()) {
      var c = _WChar___get_codePoint__impl__c8brwu(reader.ns());
      var c1 = _WChar___get_codePoint__impl__c8brwu(reader.ls(1));
      var startPos = reader.ds_1;
      // Inline function 'kotlin.code' call
      var this_0 = _Char___init__impl__6a9atx(10);
      if (c === Char__toInt_impl_vasixd(this_0)) {
        _this__u8e3s4.j4h(_this__u8e3s4.v45(), false);
      } else {
        var tmp$ret$2;
        $l$block: {
          // Inline function 'korlibs.io.lang.keep' call
          var tmp0_elvis_lhs = reader == null ? null : reader.ds_1;
          var old = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
          try {
            // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
            tmp$ret$2 = _this__u8e3s4.g4h(reader, c);
            break $l$block;
          }finally {
            if (reader == null)
              null;
            else {
              reader.ds_1 = old;
            }
          }
        }
        var g = tmp$ret$2;
        _this__u8e3s4.h4h(Companion_getInstance_6().a25_1);
        this.o5c_1(_this__u8e3s4, reader, c, g, g.v46_1 + _this__u8e3s4.y46(c, c1));
      }
      if (reader.ds_1 <= startPos) {
        reader.ps(1);
      }
    }
    _this__u8e3s4.j4h(_this__u8e3s4.v45(), true);
  }
  c5b(_this__u8e3s4, text, size, defaultFont) {
    return this.p5c(_this__u8e3s4, text instanceof WString ? text : THROW_CCE(), size, defaultFont);
  }
}
class CreateStringTextRenderer$2 {
  constructor($getVersion, $handler) {
    var tmp = this;
    tmp.q5c_1 = CreateWStringTextRenderer($getVersion, CreateStringTextRenderer$o$wstring$lambda($handler));
  }
  b5b() {
    return this.q5c_1.b5b();
  }
  r5c(_this__u8e3s4, text, size, defaultFont) {
    // Inline function 'kotlin.apply' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.text.<no name provided>.run.<anonymous>' call
    this.q5c_1.c5b(_this__u8e3s4, Companion_getInstance_12().us(text), size, defaultFont);
  }
  c5b(_this__u8e3s4, text, size, defaultFont) {
    return this.r5c(_this__u8e3s4, (!(text == null) ? typeof text === 'string' : false) ? text : THROW_CCE(), size, defaultFont);
  }
}
class Companion_32 {
  constructor() {
    Companion_instance_38 = this;
    this.s5c_1 = new Long(-1, -1);
    this.t5c_1 = _Tile___init__impl__tdix77(new Long(0, 0));
    this.u5c_1 = _Tile___init__impl__tdix77(new Long(-1, -1));
  }
  v5c(raw) {
    return _Tile___init__impl__tdix77(raw);
  }
  w5c(low, high) {
    return _Tile___init__impl__tdix77(fromLowHigh(Companion_getInstance_0(), low, high));
  }
  x5c(tile, offsetX, offsetY, flipX, flipY, rotate) {
    return this.w5c(insert_0(insert_0(insert_0(insert(0, tile, 0, 26), rotate, 29), flipY, 30), flipX, 31), insert16(insert16(0, offsetX, 0), offsetY, 16));
  }
}
class Companion_33 {
  y5c(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale) {
    var tmp297_width = data.n2d();
    var tmp298_height = data.o2d();
    var tmp299_tileSet = tileSet == null ? Companion_getInstance_51().z5c_1 : tileSet;
    var map = TileMapData.g5d(tmp297_width, tmp298_height, tmp299_tileSet, VOID, repeatX, repeatY, offsetScale);
    var offsetXRange = Companion_instance_2.zt(maskOffsetX);
    var offsetYRange = Companion_instance_2.zt(maskOffsetY);
    // Inline function 'korlibs.datastructure.each' call
    var inductionVariable = 0;
    var last = data.o2d();
    if (inductionVariable < last)
      do {
        var y = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var inductionVariable_0 = 0;
        var last_0 = data.n2d();
        if (inductionVariable_0 < last_0)
          do {
            var x = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            // Inline function 'korlibs.image.tiles.Companion.invoke.<anonymous>' call
            var v = data.w2d(x, y);
            var offsetX = IntMaskRange__extractSigned_impl_s8qphq(offsetXRange, v, offsetSigned);
            var offsetY = IntMaskRange__extractSigned_impl_s8qphq(offsetYRange, v, offsetSigned);
            map.h5d(x, y, Companion_getInstance_49().x5c(v & maskData, offsetX, offsetY, !((v & maskFlipX) === 0), !((v & maskFlipY) === 0), !((v & maskRotate) === 0)));
          }
           while (inductionVariable_0 < last_0);
      }
       while (inductionVariable < last);
    return map;
  }
  o51(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale, $super) {
    tileSet = tileSet === VOID ? null : tileSet;
    maskData = maskData === VOID ? 268435455 : maskData;
    maskFlipX = maskFlipX === VOID ? mask(1, 31) : maskFlipX;
    maskFlipY = maskFlipY === VOID ? mask(1, 30) : maskFlipY;
    maskRotate = maskRotate === VOID ? mask(1, 29) : maskRotate;
    maskOffsetX = maskOffsetX === VOID ? 0 : maskOffsetX;
    maskOffsetY = maskOffsetY === VOID ? 0 : maskOffsetY;
    offsetSigned = offsetSigned === VOID ? true : offsetSigned;
    repeatX = repeatX === VOID ? TileMapRepeat_NONE_getInstance() : repeatX;
    repeatY = repeatY === VOID ? TileMapRepeat_NONE_getInstance() : repeatY;
    offsetScale = offsetScale === VOID ? 1.0 : offsetScale;
    return $super === VOID ? this.y5c(data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale) : $super.y5c.call(this, data, tileSet, maskData, maskFlipX, maskFlipY, maskRotate, maskOffsetX, maskOffsetY, offsetSigned, repeatX, repeatY, offsetScale);
  }
}
class TileMapData extends BaseDelegatedStackedArray2 {
  static i5d(data, tileSet, repeatX, repeatY, offsetScale) {
    tileSet = tileSet === VOID ? Companion_getInstance_51().z5c_1 : tileSet;
    repeatX = repeatX === VOID ? TileMapRepeat_NONE_getInstance() : repeatX;
    repeatY = repeatY === VOID ? TileMapRepeat_NONE_getInstance() : repeatY;
    offsetScale = offsetScale === VOID ? 1.0 : offsetScale;
    var $this = this.f2n(data);
    $this.b5d_1 = data;
    $this.c5d_1 = tileSet;
    $this.d5d_1 = repeatX;
    $this.e5d_1 = repeatY;
    $this.f5d_1 = offsetScale;
    return $this;
  }
  static g5d(width, height, tileSet, empty, repeatX, repeatY, offsetScale) {
    tileSet = tileSet === VOID ? Companion_getInstance_51().z5c_1 : tileSet;
    empty = empty === VOID ? Tile(0) : empty;
    repeatX = repeatX === VOID ? TileMapRepeat_NONE_getInstance() : repeatX;
    repeatY = repeatY === VOID ? TileMapRepeat_NONE_getInstance() : repeatY;
    offsetScale = offsetScale === VOID ? 1.0 : offsetScale;
    return this.i5d(new StackedLongArray2(width, height, _Tile___get_raw__impl__kp6cq8(empty)), tileSet, repeatX, repeatY, offsetScale);
  }
  h5d(x, y, data) {
    return this.j5d(x, y, data);
  }
  k5d(x, y, level, data) {
    if (this.x2d(x, y)) {
      this.b5d_1.g2n(x, y, level, _Tile___get_raw__impl__kp6cq8(data));
    }
  }
  l5d(x, y, level) {
    return Companion_getInstance_49().v5c(this.b5d_1.h2n(x, y, level));
  }
  c2n(x, y) {
    return this.b5d_1.c2n(x, y);
  }
  m5d(x, y, value) {
    this.b5d_1.i2n(x, y, _Tile___get_raw__impl__kp6cq8(value));
  }
  j5d(x, y, value) {
    if (!this.x2d(x, y))
      return Unit_instance;
    var level = coerceAtLeast(this.c2n(x, y) - 1 | 0, 0);
    this.k5d(x, y, level, value);
  }
  toString() {
    return 'TileMapData(data=' + toString_0(this.b5d_1) + ', tileSet=' + this.c5d_1.toString() + ', repeatX=' + this.d5d_1.toString() + ', repeatY=' + this.e5d_1.toString() + ', offsetScale=' + this.f5d_1 + ')';
  }
  hashCode() {
    var result = hashCode(this.b5d_1);
    result = imul(result, 31) + hashCode(this.c5d_1) | 0;
    result = imul(result, 31) + this.d5d_1.hashCode() | 0;
    result = imul(result, 31) + this.e5d_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.f5d_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TileMapData))
      return false;
    var tmp0_other_with_cast = other instanceof TileMapData ? other : THROW_CCE();
    if (!equals(this.b5d_1, tmp0_other_with_cast.b5d_1))
      return false;
    if (!equals(this.c5d_1, tmp0_other_with_cast.c5d_1))
      return false;
    if (!this.d5d_1.equals(tmp0_other_with_cast.d5d_1))
      return false;
    if (!this.e5d_1.equals(tmp0_other_with_cast.e5d_1))
      return false;
    if (!equals(this.f5d_1, tmp0_other_with_cast.f5d_1))
      return false;
    return true;
  }
}
class TileMapRepeat extends Enum {
  constructor(name, ordinal, get) {
    super(name, ordinal);
    this.p5d_1 = get;
  }
}
class Companion_34 {
  constructor() {
    Companion_instance_40 = this;
    this.z5c_1 = new TileSet(IntMap.i2k());
  }
  q5d(tilewidth, tileheight, bmpSlices, border, mipmaps_0) {
    // Inline function 'kotlin.check' call
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.all' call
      var tmp;
      if (isInterface(bmpSlices, Collection)) {
        tmp = bmpSlices.f1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = true;
        break $l$block_0;
      }
      var tmp0_iterator = bmpSlices.z();
      while (tmp0_iterator.a1()) {
        var element = tmp0_iterator.b1();
        // Inline function 'korlibs.image.tiles.Companion.fromBitmapSlices.<anonymous>' call
        if (!(element.w38_1 === tilewidth && element.x38_1 === tileheight)) {
          tmp$ret$0 = false;
          break $l$block_0;
        }
      }
      tmp$ret$0 = true;
    }
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.check' call
    // Inline function 'kotlin.contracts.contract' call
    if (!tmp$ret$0) {
      // Inline function 'kotlin.check.<anonymous>' call
      var message = 'Check failed.';
      throw IllegalStateException.w4(toString_0(message));
    }
    if (bmpSlices.f1())
      return new TileSet(IntMap.i2k(), tilewidth, tileheight);
    var border2 = imul(border, 2);
    var btilewidth = tilewidth + border2 | 0;
    var btileheight = tileheight + border2 | 0;
    // Inline function 'kotlin.math.sqrt' call
    var x = bmpSlices.d1();
    var tmp$ret$3 = Math.sqrt(x);
    var columns = toIntCeil_0(tmp$ret$3);
    var rows = toIntCeil_0(bmpSlices.d1() / columns);
    var minWidth = imul(columns, tilewidth + border | 0) + border | 0;
    var minHeight = imul(rows, tileheight + border | 0) + border | 0;
    // Inline function 'kotlin.comparisons.maxOf' call
    var a = get_nextPowerOfTwo(minWidth);
    var b = get_nextPowerOfTwo(minHeight);
    var potSize = Math.max(a, b);
    var tmp$ret$5;
    $l$block_2: {
      // Inline function 'kotlin.collections.any' call
      var tmp_0;
      if (isInterface(bmpSlices, Collection)) {
        tmp_0 = bmpSlices.f1();
      } else {
        tmp_0 = false;
      }
      if (tmp_0) {
        tmp$ret$5 = false;
        break $l$block_2;
      }
      var tmp0_iterator_0 = bmpSlices.z();
      while (tmp0_iterator_0.a1()) {
        var element_0 = tmp0_iterator_0.b1();
        // Inline function 'korlibs.image.tiles.Companion.fromBitmapSlices.<anonymous>' call
        if (element_0.n38_1.z3m()) {
          tmp$ret$5 = true;
          break $l$block_2;
        }
      }
      tmp$ret$5 = false;
    }
    var premultiplied = tmp$ret$5;
    var out = mipmaps(Bitmap32.z3l(potSize, potSize, VOID, premultiplied), mipmaps_0);
    var texs = IntMap.i2k();
    var inductionVariable = 0;
    var last = bmpSlices.d1() - 1 | 0;
    if (inductionVariable <= last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = n / columns | 0;
        var x_0 = n % columns | 0;
        var px = imul(x_0, btilewidth) + border | 0;
        var py = imul(y, btileheight) + border | 0;
        out.m3w(bmpSlices.c1(n), px, py);
        var tileInfo = new TileSetTileInfo(n, sliceWithSize(out, px, py, tilewidth, tileheight, bmpSlices.c1(n).r38_1));
        texs.c2k(n, tileInfo);
      }
       while (inductionVariable <= last);
    var inductionVariable_0 = 0;
    if (inductionVariable_0 < columns)
      do {
        var x_1 = inductionVariable_0;
        inductionVariable_0 = inductionVariable_0 + 1 | 0;
        var px_0 = imul(x_1, btilewidth) + border | 0;
        var inductionVariable_1 = 0;
        if (inductionVariable_1 < border)
          do {
            var b_0 = inductionVariable_1;
            inductionVariable_1 = inductionVariable_1 + 1 | 0;
            Companion_getInstance_16().u3v(out, px_0, 0, out, (px_0 - 1 | 0) - b_0 | 0, 0, 1, out.o2d());
            Companion_getInstance_16().u3v(out, (px_0 + tilewidth | 0) - 1 | 0, 0, out, (px_0 + tilewidth | 0) + b_0 | 0, 0, 1, out.o2d());
          }
           while (inductionVariable_1 < border);
      }
       while (inductionVariable_0 < columns);
    var inductionVariable_2 = 0;
    if (inductionVariable_2 < rows)
      do {
        var y_0 = inductionVariable_2;
        inductionVariable_2 = inductionVariable_2 + 1 | 0;
        var py_0 = imul(y_0, btileheight) + border | 0;
        var inductionVariable_3 = 0;
        if (inductionVariable_3 < border)
          do {
            var b_1 = inductionVariable_3;
            inductionVariable_3 = inductionVariable_3 + 1 | 0;
            Companion_getInstance_16().u3v(out, 0, py_0, out, 0, (py_0 - 1 | 0) - b_1 | 0, out.n2d(), 1);
            Companion_getInstance_16().u3v(out, 0, (py_0 + tileheight | 0) - 1 | 0, out, 0, (py_0 + tileheight | 0) + b_1 | 0, out.n2d(), 1);
          }
           while (inductionVariable_3 < border);
      }
       while (inductionVariable_2 < rows);
    return new TileSet(texs, tilewidth, tileheight);
  }
  r5d(tilewidth, tileheight, bmpSlices, border, mipmaps, $super) {
    border = border === VOID ? 1 : border;
    mipmaps = mipmaps === VOID ? false : mipmaps;
    return $super === VOID ? this.q5d(tilewidth, tileheight, bmpSlices, border, mipmaps) : $super.q5d.call(this, tilewidth, tileheight, bmpSlices, border, mipmaps);
  }
}
class TileSet {
  constructor(tilesMap, width, height) {
    Companion_getInstance_51();
    width = width === VOID ? tilesMap.v2j_1 === 0 ? 0 : tilesMap.k2k().u5d_1.w38_1 : width;
    height = height === VOID ? tilesMap.v2j_1 === 0 ? 0 : tilesMap.k2k().u5d_1.x38_1 : height;
    this.x5d_1 = tilesMap;
    this.y5d_1 = width;
    this.z5d_1 = height;
    var tmp = this;
    tmp.a5e_1 = lazy(TileSet$base$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.b5e_1 = lazy(TileSet$hasMultipleBaseBitmaps$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.c5e_1 = lazy(TileSet$infos$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.d5e_1 = lazy(TileSet$textures$delegate$lambda(this));
  }
  e5e() {
    return SizeInt.z2b(this.y5d_1, this.z5d_1);
  }
  toString() {
    return 'TileSet(size=' + this.y5d_1 + 'x' + this.z5d_1 + ', tiles=' + toString_0(toList(this.x5d_1.c3())) + ')';
  }
  t2g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.a5e_1;
    base$factory();
    return this_0.t1();
  }
  f33() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.c5e_1;
    infos$factory();
    return this_0.t1();
  }
  f5e() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.d5e_1;
    textures$factory();
    return this_0.t1();
  }
}
class TileSetTileInfo {
  constructor(id, slice, frames, collision) {
    frames = frames === VOID ? emptyList() : frames;
    collision = collision === VOID ? null : collision;
    this.s5d_1 = new Mixin();
    this.t5d_1 = id;
    this.u5d_1 = slice;
    this.v5d_1 = frames;
    this.w5d_1 = collision;
  }
  tw(_set____db54di) {
    this.s5d_1.tw(_set____db54di);
  }
  uw() {
    return this.s5d_1.uw();
  }
  toString() {
    return 'TileSetTileInfo(id=' + this.t5d_1 + ', slice=' + this.u5d_1.toString() + ', frames=' + toString_0(this.v5d_1) + ', collision=' + toString(this.w5d_1) + ')';
  }
  hashCode() {
    var result = this.t5d_1;
    result = imul(result, 31) + this.u5d_1.hashCode() | 0;
    result = imul(result, 31) + hashCode(this.v5d_1) | 0;
    result = imul(result, 31) + (this.w5d_1 == null ? 0 : hashCode(this.w5d_1)) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof TileSetTileInfo))
      return false;
    var tmp0_other_with_cast = other instanceof TileSetTileInfo ? other : THROW_CCE();
    if (!(this.t5d_1 === tmp0_other_with_cast.t5d_1))
      return false;
    if (!this.u5d_1.equals(tmp0_other_with_cast.u5d_1))
      return false;
    if (!equals(this.v5d_1, tmp0_other_with_cast.v5d_1))
      return false;
    if (!equals(this.w5d_1, tmp0_other_with_cast.w5d_1))
      return false;
    return true;
  }
}
class SegmentHandler {
  constructor() {
    this.g5e_1 = intArrayListOf(new Int32Array([]));
    this.h5e_1 = intArrayListOf(new Int32Array([]));
    this.e2h();
  }
  d1() {
    return this.g5e_1.d1();
  }
  e2h() {
    this.g5e_1.j3();
    this.h5e_1.j3();
  }
  b3d(x0, x1) {
    var inductionVariable = 0;
    var last = this.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var xmin = this.g5e_1.ow(n);
        var xmax = this.h5e_1.ow(n);
        if (overlaps(this, xmin, xmax, x0, x1)) {
          // Inline function 'kotlin.math.min' call
          var tmp$ret$0 = Math.min(x0, xmin);
          this.g5e_1.h2f(n, tmp$ret$0);
          // Inline function 'kotlin.math.max' call
          var tmp$ret$1 = Math.max(x1, xmax);
          this.h5e_1.h2f(n, tmp$ret$1);
          return Unit_instance;
        }
      }
       while (inductionVariable < last);
    this.g5e_1.c2f(x0);
    this.h5e_1.c2f(x1);
  }
}
class ScanlineWriter {
  constructor($outer) {
    this.t5e_1 = $outer;
    this.i5e_1 = get_DEFAULT(Companion_getInstance_52());
    this.j5e_1 = NoneFiller_getInstance();
    this.k5e_1 = -1;
    this.l5e_1 = -1;
    this.m5e_1 = new Float32Array(this.d1());
    this.n5e_1 = new Int32Array(this.d1());
    this.o5e_1 = Companion_instance_14.f45(this.d1());
    this.p5e_1 = Companion_instance_14.f45(this.d1());
    this.q5e_1 = new SegmentHandler();
    this.r5e_1 = 0;
    this.s5e_1 = 1.0;
  }
  d1() {
    return this.t5e_1.w5e_1.n2d();
  }
  g5f() {
    return this.t5e_1.w5e_1.n2d() - 1 | 0;
  }
  e2h() {
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.q5e_1;
    var inductionVariable = 0;
    var last = this_0.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.reset.<anonymous>' call
        var xmin = this_0.g5e_1.ow(n);
        var xmax = this_0.h5e_1.ow(n);
        fill_0(this.m5e_1, 0.0, xmin, xmax + 1 | 0);
        fill(this.n5e_1, 0, xmin, xmax + 1 | 0);
      }
       while (inductionVariable < last);
    this.r5e_1 = 0;
    this.q5e_1.e2h();
  }
  h5f(x0, x1, y0) {
    if (this.g5f() < 1)
      return Unit_instance;
    var x0_0 = coerceIn(x0, 0, imul(this.g5f(), 20));
    var x1_0 = coerceIn(x1, 0, imul(this.g5f(), 20));
    var a = x0_0 / 20 | 0;
    var b = x1_0 / 20 | 0;
    var y = y0 / 20 | 0;
    var i0 = coerceIn(a, 0, this.g5f());
    var i1 = coerceIn(b, 0, this.g5f());
    var i0m = x0_0 % 20 | 0;
    var i1m = x1_0 % 20 | 0;
    if (!(this.l5e_1 === y)) {
      if (y >= 0) {
        this.kc();
      }
      this.l5e_1 = y;
      this.e2h();
    }
    if (!(this.k5e_1 === y0)) {
      this.k5e_1 = y0;
      this.r5e_1 = this.r5e_1 + 1 | 0;
    }
    if (i1 > i0) {
      this.q5e_1.b3d(i0, i1);
      this.i5f(i0, 1.0 - i0m / 20);
      var inductionVariable = i0 + 1 | 0;
      if (inductionVariable < i1)
        do {
          var x = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          this.i5f(x, 1.0);
        }
         while (inductionVariable < i1);
      if (!(i1m === 0)) {
        this.i5f(i1, i1m / 20);
      }
    }
  }
  i5f(x, ratio) {
    var mask = 1 << this.r5e_1;
    if ((this.n5e_1[x] & mask) === 0) {
      this.n5e_1[x] = this.n5e_1[x] | mask;
      var _array__4zh2yp = this.m5e_1;
      _array__4zh2yp[x] = _array__4zh2yp[x] + ratio;
    }
  }
  kc() {
    var containsUpper = this.t5e_1.w5e_1.o2d();
    var containsArg = this.l5e_1;
    if (!(0 <= containsArg ? containsArg < containsUpper : false))
      return Unit_instance;
    var galpha = clamp01_0(this.s5e_1);
    var scale_0 = 1.0 / this.r5e_1 * galpha;
    // Inline function 'korlibs.image.vector.SegmentHandler.forEachFast' call
    var this_0 = this.q5e_1;
    var inductionVariable = 0;
    var last = this_0.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        // Inline function 'korlibs.image.vector.ScanlineWriter.flush.<anonymous>' call
        var xmin = this_0.g5e_1.ow(n);
        var xmax = this_0.h5e_1.ow(n);
        var x = xmin;
        var count = (xmax - xmin | 0) + 1 | 0;
        this.j5e_1.x58(this.p5e_1, 0, xmin, xmax, this.l5e_1);
        var inductionVariable_0 = xmin;
        if (inductionVariable_0 <= xmax)
          do {
            var n_0 = inductionVariable_0;
            inductionVariable_0 = inductionVariable_0 + 1 | 0;
            var _array__4zh2yp = this.m5e_1;
            var _index_0__fvwizt = n_0;
            _array__4zh2yp[_index_0__fvwizt] = _array__4zh2yp[_index_0__fvwizt] * scale_0;
          }
           while (!(n_0 === xmax));
        scale(this.p5e_1, xmin, this.m5e_1, xmin, count);
        var index = this.t5e_1.w5e_1.d3n(0, this.l5e_1) + x | 0;
        if (this.t5e_1.w5e_1.z3m()) {
          arraycopy(this.t5e_1.w5e_1.w3l_1, index, _RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.o5e_1), x, count);
        } else {
          premultiply(_RgbaArray___init__impl__oib4y4(this.t5e_1.w5e_1.w3l_1), index, this.o5e_1, x, count);
        }
        this.i5e_1.j5f(this.o5e_1, x, this.p5e_1, x, count);
        if (this.t5e_1.w5e_1.z3m()) {
          arraycopy(_RgbaPremultipliedArray___get_ints__impl__i1gpd7(this.o5e_1), x, this.t5e_1.w5e_1.w3l_1, index, count);
        } else {
          depremultiply(this.o5e_1, x, _RgbaArray___init__impl__oib4y4(this.t5e_1.w5e_1.w3l_1), index, count);
        }
      }
       while (inductionVariable < last);
  }
}
class Renderer {
  constructor() {
    this.v5f_1 = false;
    this.w5f_1 = 0;
  }
  kc() {
    return Unit_instance;
  }
  y5f() {
    var _unary__edvuaz = this.w5f_1;
    this.w5f_1 = _unary__edvuaz + 1 | 0;
    return _unary__edvuaz;
  }
  z5f() {
    this.w5f_1 = this.w5f_1 - 1 | 0;
    if (this.w5f_1 === 0) {
      this.kc();
    }
  }
  a5g(state, fill, winding) {
    var rstate = state;
    if (fill && !this.c5g(state.l47_1)) {
      rstate = state.qw();
      rstate.l47_1 = toBitmapPaint(rstate.l47_1, state);
    }
    this.u5f(rstate, fill, winding);
  }
  b5g(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.a5g(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.a5g.call(this, state, fill, winding);
    }
    return tmp;
  }
  u5f(state, fill, winding) {
    return Unit_instance;
  }
  c5g(_this__u8e3s4) {
    return true;
  }
  d5g(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.renderer.Renderer.drawImage.<anonymous>' call
    if (transform.q25().equals(MatrixType_IDENTITY_getInstance())) {
      this_0.t3f(pos, size);
    } else {
      this_0.a3g(transform, Renderer$drawImage$lambda(pos, size));
    }
    this.b5g(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_6().a25_1, size.k2b(toFloat(image.d1()))).e26(pos))), true);
  }
  p11() {
    this.kc();
  }
}
class Bitmap32Context2d extends Renderer {
  constructor(bmp, antialiasing) {
    super();
    this.w5e_1 = bmp;
    this.x5e_1 = antialiasing;
    this.y5e_1 = this.w5e_1.y3l_1.d2b();
    this.z5e_1 = new Rasterizer();
    this.a5f_1 = new ColorFiller();
    this.b5f_1 = new GradientFiller();
    this.c5f_1 = new BitmapFiller();
    this.d5f_1 = new ScanlineWriter(this);
    this.e5f_1 = new VectorPath(VOID, VOID, Winding_EVEN_ODD_getInstance());
    this.f5f_1 = new StrokeToFill();
  }
  n2d() {
    return this.w5e_1.n2d();
  }
  o2d() {
    return this.w5e_1.o2d();
  }
  u5f(state, fill, winding) {
    var style = fill ? state.l47_1 : state.k47_1;
    var tmp;
    if (style instanceof NonePaint) {
      tmp = NoneFiller_getInstance();
    } else {
      if (style instanceof RGBA) {
        tmp = this.a5f_1.v58(style.l44_1, state);
      } else {
        if (style instanceof GradientPaint) {
          tmp = this.b5f_1.d59(style, state);
        } else {
          if (style instanceof BitmapPaint) {
            tmp = this.c5f_1.r59(style, state);
          } else {
            throw NotImplementedError.nd();
          }
        }
      }
    }
    var filler = tmp;
    this.d5f_1.i5e_1 = state.s47_1;
    this.z5e_1.e2h();
    this.z5e_1.k5f_1 = this.v5f_1;
    var doingStroke = !fill;
    var tmp_0;
    if (fill) {
      tmp_0 = state.d47_1;
    } else {
      this.e5f_1.j3();
      var tmp305_$receiver = state.d47_1;
      var tmp306_lineWidth = state.x5f();
      var tmp307_joins = state.i47_1;
      var tmp308_startCap = state.g47_1;
      var tmp309_endCap = state.h47_1;
      var tmp310_miterLimit = state.j47_1;
      var tmp311_temp = this.f5f_1;
      var tmp312_outFill = this.e5f_1;
      var tmp313_lineDash = state.t47_1;
      var tmp314_lineDashOffset = state.u47_1;
      tmp_0 = strokeToFill(tmp305_$receiver, tmp306_lineWidth, tmp307_joins, tmp308_startCap, tmp309_endCap, tmp310_miterLimit, tmp313_lineDash, tmp314_lineDashOffset, tmp311_temp, tmp312_outFill);
    }
    var fillPath = tmp_0;
    if (!(state.c47_1 == null)) {
      this.z5e_1.o5f_1.g3c_1 = ensureNotNull(state.c47_1).s36_1;
      // Inline function 'korlibs.math.geom.shape.emitPoints2' call
      var this_0 = ensureNotNull(state.c47_1);
      var i = Vector2D.j24();
      var l = Vector2D.j24();
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.z5e_1.o5f_1.z5();
      }
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
      var n = 0;
      // Inline function 'korlibs.datastructure.iterators.fastForEach' call
      var this_1 = this_0.q36_1;
      var n_0 = 0;
      while (n_0 < this_1.d1()) {
        // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
        var _unary__edvuaz = n_0;
        n_0 = _unary__edvuaz + 1 | 0;
        switch (this_1.ow(_unary__edvuaz)) {
          case 0:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_0 = n;
            n = _unary__edvuaz_0 + 1 | 0;
            var tmp_1 = this_0.r36_1.c1(_unary__edvuaz_0);
            var _unary__edvuaz_1 = n;
            n = _unary__edvuaz_1 + 1 | 0;
            var it = Vector2D.j21(tmp_1, this_0.r36_1.c1(_unary__edvuaz_1));
            i = it;
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x = it.rk();
            var y = it.sk();
            this.z5e_1.o5f_1.j3d(x, y, true);
            l = it;
            break;
          case 1:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_2 = n;
            n = _unary__edvuaz_2 + 1 | 0;
            var tmp_2 = this_0.r36_1.c1(_unary__edvuaz_2);
            var _unary__edvuaz_3 = n;
            n = _unary__edvuaz_3 + 1 | 0;
            var it_0 = Vector2D.j21(tmp_2, this_0.r36_1.c1(_unary__edvuaz_3));
            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var x_0 = it_0.rk();
            var y_0 = it_0.sk();
            this.z5e_1.o5f_1.j3d(x_0, y_0, false);
            l = it_0;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 2:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_4 = n;
            n = _unary__edvuaz_4 + 1 | 0;
            var tmp_3 = this_0.r36_1.c1(_unary__edvuaz_4);
            var _unary__edvuaz_5 = n;
            n = _unary__edvuaz_5 + 1 | 0;
            var c = Vector2D.j21(tmp_3, this_0.r36_1.c1(_unary__edvuaz_5));
            var _unary__edvuaz_6 = n;
            n = _unary__edvuaz_6 + 1 | 0;
            var tmp_4 = this_0.r36_1.c1(_unary__edvuaz_6);
            var _unary__edvuaz_7 = n;
            n = _unary__edvuaz_7 + 1 | 0;
            var a = Vector2D.j21(tmp_4, this_0.r36_1.c1(_unary__edvuaz_7));
            var sum = Companion_getInstance_7().f2c(l, c) + Companion_getInstance_7().f2c(c, a);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_0 = numberToInt(sum);
            var rcurveSteps = Math.max(a_0, 20);
            var dt = 1.0 / rcurveSteps;
            var lastPos = {_v: Vector2D.j24()};
            var prevPos = {_v: Vector2D.j24()};
            var emittedCount = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio = Companion_getInstance_10().st_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos._v = Companion_getInstance_2().n34(l, c, a, ratio);
            var nStart = false ? 0 : 1;
            var nEnd = true ? rcurveSteps : rcurveSteps - 1 | 0;
            var inductionVariable = nStart;
            if (inductionVariable <= nEnd)
              do {
                var n_1 = inductionVariable;
                inductionVariable = inductionVariable + 1 | 0;
                var ratio_0 = _Ratio___init__impl__9mwvn2_0(n_1 * dt);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_1 = Companion_getInstance_2().n34(l, c, a, ratio_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_1 = it_1.rk();
                var y_1 = it_1.sk();
                this.z5e_1.o5f_1.j3d(x_1, y_1, false);
                emittedCount._v = emittedCount._v + 1 | 0;
                lastPos._v = prevPos._v;
                prevPos._v = it_1;
              }
               while (!(n_1 === nEnd));
            l = a;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 3:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            var _unary__edvuaz_8 = n;
            n = _unary__edvuaz_8 + 1 | 0;
            var tmp_5 = this_0.r36_1.c1(_unary__edvuaz_8);
            var _unary__edvuaz_9 = n;
            n = _unary__edvuaz_9 + 1 | 0;
            var c0 = Vector2D.j21(tmp_5, this_0.r36_1.c1(_unary__edvuaz_9));
            var _unary__edvuaz_10 = n;
            n = _unary__edvuaz_10 + 1 | 0;
            var tmp_6 = this_0.r36_1.c1(_unary__edvuaz_10);
            var _unary__edvuaz_11 = n;
            n = _unary__edvuaz_11 + 1 | 0;
            var c1 = Vector2D.j21(tmp_6, this_0.r36_1.c1(_unary__edvuaz_11));
            var _unary__edvuaz_12 = n;
            n = _unary__edvuaz_12 + 1 | 0;
            var tmp_7 = this_0.r36_1.c1(_unary__edvuaz_12);
            var _unary__edvuaz_13 = n;
            n = _unary__edvuaz_13 + 1 | 0;
            var a_1 = Vector2D.j21(tmp_7, this_0.r36_1.c1(_unary__edvuaz_13));
            var sum_0 = Companion_getInstance_7().f2c(l, c0) + Companion_getInstance_7().f2c(c0, c1) + Companion_getInstance_7().f2c(c1, a_1);
            // Inline function 'korlibs.math.geom.shape.approximateCurve' call

            // Inline function 'kotlin.math.max' call

            var a_2 = numberToInt(sum_0);
            var rcurveSteps_0 = Math.max(a_2, 20);
            var dt_0 = 1.0 / rcurveSteps_0;
            var lastPos_0 = {_v: Vector2D.j24()};
            var prevPos_0 = {_v: Vector2D.j24()};
            var emittedCount_0 = {_v: 0};
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

            var ratio_1 = Companion_getInstance_10().st_1;
            // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

            lastPos_0._v = Companion_getInstance_2().m34(l, c0, c1, a_1, ratio_1);
            var nStart_0 = false ? 0 : 1;
            var nEnd_0 = true ? rcurveSteps_0 : rcurveSteps_0 - 1 | 0;
            var inductionVariable_0 = nStart_0;
            if (inductionVariable_0 <= nEnd_0)
              do {
                var n_2 = inductionVariable_0;
                inductionVariable_0 = inductionVariable_0 + 1 | 0;
                var ratio_2 = _Ratio___init__impl__9mwvn2_0(n_2 * dt_0);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
                var it_2 = Companion_getInstance_2().m34(l, c0, c1, a_1, ratio_2);
                // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
                // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
                var x_2 = it_2.rk();
                var y_2 = it_2.sk();
                this.z5e_1.o5f_1.j3d(x_2, y_2, false);
                emittedCount_0._v = emittedCount_0._v + 1 | 0;
                lastPos_0._v = prevPos_0._v;
                prevPos_0._v = it_2;
              }
               while (!(n_2 === nEnd_0));
            l = a_1;
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            break;
          case 4:
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            var destruct = i;
            var x_3 = destruct.rk();
            var y_3 = destruct.sk();
            this.z5e_1.o5f_1.j3d(x_3, y_3, false);
            // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

            // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

            if (true) {
              this.z5e_1.o5f_1.z5();
            }

            break;
        }
      }
      // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
      if (false) {
        this.z5e_1.o5f_1.z5();
      }
    }
    var tmp_8 = this.z5e_1.n5f_1;
    tmp_8.g3c_1 = winding == null ? ensureNotNull(state.d47_1).s36_1 : winding;
    // Inline function 'korlibs.math.geom.shape.emitPoints2' call
    var i_0 = Vector2D.j24();
    var l_0 = Vector2D.j24();
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.z5e_1.n5f_1.z5();
    }
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n_3 = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_2 = fillPath.q36_1;
    var n_4 = 0;
    while (n_4 < this_2.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz_14 = n_4;
      n_4 = _unary__edvuaz_14 + 1 | 0;
      switch (this_2.ow(_unary__edvuaz_14)) {
        case 0:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_15 = n_3;
          n_3 = _unary__edvuaz_15 + 1 | 0;
          var tmp_9 = fillPath.r36_1.c1(_unary__edvuaz_15);
          var _unary__edvuaz_16 = n_3;
          n_3 = _unary__edvuaz_16 + 1 | 0;
          var it_3 = Vector2D.j21(tmp_9, fillPath.r36_1.c1(_unary__edvuaz_16));
          i_0 = it_3;
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_4 = it_3.rk();
          var y_4 = it_3.sk();
          if (doingStroke) {
            if (true) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.z5e_1.n5f_1.j3d(x_4, y_4, true);
          l_0 = it_3;
          break;
        case 1:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_17 = n_3;
          n_3 = _unary__edvuaz_17 + 1 | 0;
          var tmp_10 = fillPath.r36_1.c1(_unary__edvuaz_17);
          var _unary__edvuaz_18 = n_3;
          n_3 = _unary__edvuaz_18 + 1 | 0;
          var it_4 = Vector2D.j21(tmp_10, fillPath.r36_1.c1(_unary__edvuaz_18));
          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var x_5 = it_4.rk();
          var y_5 = it_4.sk();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.z5e_1.n5f_1.j3d(x_5, y_5, false);
          l_0 = it_4;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 2:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_19 = n_3;
          n_3 = _unary__edvuaz_19 + 1 | 0;
          var tmp_11 = fillPath.r36_1.c1(_unary__edvuaz_19);
          var _unary__edvuaz_20 = n_3;
          n_3 = _unary__edvuaz_20 + 1 | 0;
          var c_0 = Vector2D.j21(tmp_11, fillPath.r36_1.c1(_unary__edvuaz_20));
          var _unary__edvuaz_21 = n_3;
          n_3 = _unary__edvuaz_21 + 1 | 0;
          var tmp_12 = fillPath.r36_1.c1(_unary__edvuaz_21);
          var _unary__edvuaz_22 = n_3;
          n_3 = _unary__edvuaz_22 + 1 | 0;
          var a_3 = Vector2D.j21(tmp_12, fillPath.r36_1.c1(_unary__edvuaz_22));
          var sum_1 = Companion_getInstance_7().f2c(l_0, c_0) + Companion_getInstance_7().f2c(c_0, a_3);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_4 = numberToInt(sum_1);
          var rcurveSteps_1 = Math.max(a_4, 20);
          var dt_1 = 1.0 / rcurveSteps_1;
          var lastPos_1 = {_v: Vector2D.j24()};
          var prevPos_1 = {_v: Vector2D.j24()};
          var emittedCount_1 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_3 = Companion_getInstance_10().st_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_1._v = Companion_getInstance_2().n34(l_0, c_0, a_3, ratio_3);
          var nStart_1 = false ? 0 : 1;
          var nEnd_1 = true ? rcurveSteps_1 : rcurveSteps_1 - 1 | 0;
          var inductionVariable_1 = nStart_1;
          if (inductionVariable_1 <= nEnd_1)
            do {
              var n_5 = inductionVariable_1;
              inductionVariable_1 = inductionVariable_1 + 1 | 0;
              var ratio_4 = _Ratio___init__impl__9mwvn2_0(n_5 * dt_1);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_5 = Companion_getInstance_2().n34(l_0, c_0, a_3, ratio_4);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_6 = it_5.rk();
              var y_6 = it_5.sk();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.z5e_1.n5f_1.j3d(x_6, y_6, false);
              emittedCount_1._v = emittedCount_1._v + 1 | 0;
              lastPos_1._v = prevPos_1._v;
              prevPos_1._v = it_5;
            }
             while (!(n_5 === nEnd_1));
          l_0 = a_3;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 3:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          var _unary__edvuaz_23 = n_3;
          n_3 = _unary__edvuaz_23 + 1 | 0;
          var tmp_13 = fillPath.r36_1.c1(_unary__edvuaz_23);
          var _unary__edvuaz_24 = n_3;
          n_3 = _unary__edvuaz_24 + 1 | 0;
          var c0_0 = Vector2D.j21(tmp_13, fillPath.r36_1.c1(_unary__edvuaz_24));
          var _unary__edvuaz_25 = n_3;
          n_3 = _unary__edvuaz_25 + 1 | 0;
          var tmp_14 = fillPath.r36_1.c1(_unary__edvuaz_25);
          var _unary__edvuaz_26 = n_3;
          n_3 = _unary__edvuaz_26 + 1 | 0;
          var c1_0 = Vector2D.j21(tmp_14, fillPath.r36_1.c1(_unary__edvuaz_26));
          var _unary__edvuaz_27 = n_3;
          n_3 = _unary__edvuaz_27 + 1 | 0;
          var tmp_15 = fillPath.r36_1.c1(_unary__edvuaz_27);
          var _unary__edvuaz_28 = n_3;
          n_3 = _unary__edvuaz_28 + 1 | 0;
          var a_5 = Vector2D.j21(tmp_15, fillPath.r36_1.c1(_unary__edvuaz_28));
          var sum_2 = Companion_getInstance_7().f2c(l_0, c0_0) + Companion_getInstance_7().f2c(c0_0, c1_0) + Companion_getInstance_7().f2c(c1_0, a_5);
          // Inline function 'korlibs.math.geom.shape.approximateCurve' call

          // Inline function 'kotlin.math.max' call

          var a_6 = numberToInt(sum_2);
          var rcurveSteps_2 = Math.max(a_6, 20);
          var dt_2 = 1.0 / rcurveSteps_2;
          var lastPos_2 = {_v: Vector2D.j24()};
          var prevPos_2 = {_v: Vector2D.j24()};
          var emittedCount_2 = {_v: 0};
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call

          var ratio_5 = Companion_getInstance_10().st_1;
          // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call

          lastPos_2._v = Companion_getInstance_2().m34(l_0, c0_0, c1_0, a_5, ratio_5);
          var nStart_2 = false ? 0 : 1;
          var nEnd_2 = true ? rcurveSteps_2 : rcurveSteps_2 - 1 | 0;
          var inductionVariable_2 = nStart_2;
          if (inductionVariable_2 <= nEnd_2)
            do {
              var n_6 = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio_6 = _Ratio___init__impl__9mwvn2_0(n_6 * dt_2);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.math.geom.shape.approximateCurve.<anonymous>' call
              var it_6 = Companion_getInstance_2().m34(l_0, c0_0, c1_0, a_5, ratio_6);
              // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>.<anonymous>' call
              // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
              var x_7 = it_6.rk();
              var y_7 = it_6.sk();
              if (doingStroke) {
                if (false) {
                  renderFinal$flush(this, filler, state, winding, fillPath);
                }
              }
              this.z5e_1.n5f_1.j3d(x_7, y_7, false);
              emittedCount_2._v = emittedCount_2._v + 1 | 0;
              lastPos_2._v = prevPos_2._v;
              prevPos_2._v = it_6;
            }
             while (!(n_6 === nEnd_2));
          l_0 = a_5;
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          break;
        case 4:
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          var destruct_0 = i_0;
          var x_8 = destruct_0.rk();
          var y_8 = destruct_0.sk();
          if (doingStroke) {
            if (false) {
              renderFinal$flush(this, filler, state, winding, fillPath);
            }
          }

          this.z5e_1.n5f_1.j3d(x_8, y_8, false);
          // Inline function 'korlibs.math.geom.shape.emitPoints2.<anonymous>' call

          // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call

          if (true) {
            this.z5e_1.n5f_1.z5();
          }

          break;
      }
    }
    // Inline function 'korlibs.image.vector.Bitmap32Context2d.renderFinal.<anonymous>' call
    if (false) {
      this.z5e_1.n5f_1.z5();
    }
    renderFinal$flush(this, filler, state, winding, fillPath);
  }
}
class CompositeOperation$Companion$invoke$1 {
  constructor($func) {
    this.e5g_1 = $func;
  }
  j5f(dst, dstN, src, srcN, count) {
    return this.e5g_1(new RgbaPremultipliedArray(dst), dstN, new RgbaPremultipliedArray(src), srcN, count);
  }
}
class Companion_35 {
  constructor() {
    Companion_instance_41 = this;
    var tmp = this;
    var tmp_0 = Companion_getInstance_52();
    tmp.f5g_1 = tmp_0.g5g(CompositeOperation$Companion$UNIMPLEMENTED$lambda);
  }
  g5g(func) {
    return new CompositeOperation$Companion$invoke$1(func);
  }
}
class Companion_36 {
  b3g() {
    return CompositeMode_SOURCE_OVER_getInstance();
  }
}
class CompositeMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.j5g_1 = op;
  }
  j5f(dst, dstN, src, srcN, count) {
    this.j5g_1.j5f(dst, dstN, src, srcN, count);
  }
}
class BlendMode extends Enum {
  constructor(name, ordinal, op) {
    super(name, ordinal);
    this.m5g_1 = op;
  }
  j5f(dst, dstN, src, srcN, count) {
    this.m5g_1.j5f(dst, dstN, src, srcN, count);
  }
}
class State {
  constructor(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    transform = transform === VOID ? Companion_getInstance_6().a25_1 : transform;
    clip = clip === VOID ? null : clip;
    path = path === VOID ? new VectorPath() : path;
    lineScaleMode = lineScaleMode === VOID ? LineScaleMode_NORMAL_getInstance() : lineScaleMode;
    lineWidth = lineWidth === VOID ? 1.0 : lineWidth;
    startLineCap = startLineCap === VOID ? LineCap_BUTT_getInstance() : startLineCap;
    endLineCap = endLineCap === VOID ? LineCap_BUTT_getInstance() : endLineCap;
    lineJoin = lineJoin === VOID ? LineJoin_MITER_getInstance() : lineJoin;
    miterLimit = miterLimit === VOID ? 10.0 : miterLimit;
    strokeStyle = strokeStyle === VOID ? new RGBA(get_DefaultPaint()) : strokeStyle;
    fillStyle = fillStyle === VOID ? new RGBA(get_DefaultPaint()) : fillStyle;
    fontRegistry = fontRegistry === VOID ? null : fontRegistry;
    font = font === VOID ? null : font;
    fontSize = fontSize === VOID ? 24.0 : fontSize;
    verticalAlign = verticalAlign === VOID ? Companion_getInstance_46().p5a_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? Companion_getInstance_47().u5a_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? CompositeMode_SOURCE_OVER_getInstance() : globalCompositeOperation;
    lineDash = lineDash === VOID ? null : lineDash;
    lineDashOffset = lineDashOffset === VOID ? 0.0 : lineDashOffset;
    this.b47_1 = transform;
    this.c47_1 = clip;
    this.d47_1 = path;
    this.e47_1 = lineScaleMode;
    this.f47_1 = lineWidth;
    this.g47_1 = startLineCap;
    this.h47_1 = endLineCap;
    this.i47_1 = lineJoin;
    this.j47_1 = miterLimit;
    this.k47_1 = strokeStyle;
    this.l47_1 = fillStyle;
    this.m47_1 = fontRegistry;
    this.n47_1 = font;
    this.o47_1 = fontSize;
    this.p47_1 = verticalAlign;
    this.q47_1 = horizontalAlign;
    this.r47_1 = globalAlpha;
    this.s47_1 = globalCompositeOperation;
    this.t47_1 = lineDash;
    this.u47_1 = lineDashOffset;
    var tmp = this;
    tmp.v47_1 = lazy(Context2d$State$transformTransform$delegate$lambda(this));
  }
  n5g() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v47_1;
    transformTransform$factory();
    return this_0.t1();
  }
  x5f() {
    var tmp = this.f47_1;
    // Inline function 'kotlin.math.absoluteValue' call
    var this_0 = this.n5g().l27();
    return tmp * Math.abs(this_0);
  }
  j4f(value) {
    this.g47_1 = value;
    this.h47_1 = value;
  }
  c4f() {
    return this.g47_1;
  }
  qw() {
    var tmp = this.b47_1;
    var tmp318_safe_receiver = this.c47_1;
    var tmp_0 = tmp318_safe_receiver == null ? null : tmp318_safe_receiver.qw();
    var tmp_1 = this.d47_1.qw();
    var tmp319_safe_receiver = this.t47_1;
    return this.o5g(tmp, tmp_0, tmp_1, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, tmp319_safe_receiver == null ? null : tmp319_safe_receiver.qw());
  }
  p5g(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) {
    return new State(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  o5g(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset, $super) {
    transform = transform === VOID ? this.b47_1 : transform;
    clip = clip === VOID ? this.c47_1 : clip;
    path = path === VOID ? this.d47_1 : path;
    lineScaleMode = lineScaleMode === VOID ? this.e47_1 : lineScaleMode;
    lineWidth = lineWidth === VOID ? this.f47_1 : lineWidth;
    startLineCap = startLineCap === VOID ? this.g47_1 : startLineCap;
    endLineCap = endLineCap === VOID ? this.h47_1 : endLineCap;
    lineJoin = lineJoin === VOID ? this.i47_1 : lineJoin;
    miterLimit = miterLimit === VOID ? this.j47_1 : miterLimit;
    strokeStyle = strokeStyle === VOID ? this.k47_1 : strokeStyle;
    fillStyle = fillStyle === VOID ? this.l47_1 : fillStyle;
    fontRegistry = fontRegistry === VOID ? this.m47_1 : fontRegistry;
    font = font === VOID ? this.n47_1 : font;
    fontSize = fontSize === VOID ? this.o47_1 : fontSize;
    verticalAlign = verticalAlign === VOID ? this.p47_1 : verticalAlign;
    horizontalAlign = horizontalAlign === VOID ? this.q47_1 : horizontalAlign;
    globalAlpha = globalAlpha === VOID ? this.r47_1 : globalAlpha;
    globalCompositeOperation = globalCompositeOperation === VOID ? this.s47_1 : globalCompositeOperation;
    lineDash = lineDash === VOID ? this.t47_1 : lineDash;
    lineDashOffset = lineDashOffset === VOID ? this.u47_1 : lineDashOffset;
    return $super === VOID ? this.p5g(transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, verticalAlign, horizontalAlign, globalAlpha, globalCompositeOperation, lineDash, lineDashOffset) : $super.p5g.call(this, transform, clip, path, lineScaleMode, lineWidth, startLineCap, endLineCap, lineJoin, miterLimit, strokeStyle, fillStyle, fontRegistry, font, fontSize, new VerticalAlign(verticalAlign), new HorizontalAlign(horizontalAlign), globalAlpha, globalCompositeOperation, lineDash, lineDashOffset);
  }
  toString() {
    return 'State(transform=' + this.b47_1.toString() + ', clip=' + toString(this.c47_1) + ', path=' + this.d47_1.toString() + ', lineScaleMode=' + this.e47_1.toString() + ', lineWidth=' + this.f47_1 + ', startLineCap=' + this.g47_1.toString() + ', endLineCap=' + this.h47_1.toString() + ', lineJoin=' + this.i47_1.toString() + ', miterLimit=' + this.j47_1 + ', strokeStyle=' + toString_0(this.k47_1) + ', fillStyle=' + toString_0(this.l47_1) + ', fontRegistry=' + toString(this.m47_1) + ', font=' + toString(this.n47_1) + ', fontSize=' + this.o47_1 + ', verticalAlign=' + VerticalAlign__toString_impl_hcpnn2(this.p47_1) + ', horizontalAlign=' + HorizontalAlign__toString_impl_toflc0(this.q47_1) + ', globalAlpha=' + this.r47_1 + ', globalCompositeOperation=' + toString_0(this.s47_1) + ', lineDash=' + toString(this.t47_1) + ', lineDashOffset=' + this.u47_1 + ')';
  }
  hashCode() {
    var result = this.b47_1.hashCode();
    result = imul(result, 31) + (this.c47_1 == null ? 0 : this.c47_1.hashCode()) | 0;
    result = imul(result, 31) + this.d47_1.hashCode() | 0;
    result = imul(result, 31) + this.e47_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.f47_1) | 0;
    result = imul(result, 31) + this.g47_1.hashCode() | 0;
    result = imul(result, 31) + this.h47_1.hashCode() | 0;
    result = imul(result, 31) + this.i47_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.j47_1) | 0;
    result = imul(result, 31) + hashCode(this.k47_1) | 0;
    result = imul(result, 31) + hashCode(this.l47_1) | 0;
    result = imul(result, 31) + (this.m47_1 == null ? 0 : hashCode(this.m47_1)) | 0;
    result = imul(result, 31) + (this.n47_1 == null ? 0 : hashCode(this.n47_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.o47_1) | 0;
    result = imul(result, 31) + VerticalAlign__hashCode_impl_vx8hj7(this.p47_1) | 0;
    result = imul(result, 31) + HorizontalAlign__hashCode_impl_7x9oj5(this.q47_1) | 0;
    result = imul(result, 31) + getNumberHashCode(this.r47_1) | 0;
    result = imul(result, 31) + hashCode(this.s47_1) | 0;
    result = imul(result, 31) + (this.t47_1 == null ? 0 : hashCode(this.t47_1)) | 0;
    result = imul(result, 31) + getNumberHashCode(this.u47_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof State))
      return false;
    var tmp0_other_with_cast = other instanceof State ? other : THROW_CCE();
    if (!this.b47_1.equals(tmp0_other_with_cast.b47_1))
      return false;
    if (!equals(this.c47_1, tmp0_other_with_cast.c47_1))
      return false;
    if (!this.d47_1.equals(tmp0_other_with_cast.d47_1))
      return false;
    if (!this.e47_1.equals(tmp0_other_with_cast.e47_1))
      return false;
    if (!equals(this.f47_1, tmp0_other_with_cast.f47_1))
      return false;
    if (!this.g47_1.equals(tmp0_other_with_cast.g47_1))
      return false;
    if (!this.h47_1.equals(tmp0_other_with_cast.h47_1))
      return false;
    if (!this.i47_1.equals(tmp0_other_with_cast.i47_1))
      return false;
    if (!equals(this.j47_1, tmp0_other_with_cast.j47_1))
      return false;
    if (!equals(this.k47_1, tmp0_other_with_cast.k47_1))
      return false;
    if (!equals(this.l47_1, tmp0_other_with_cast.l47_1))
      return false;
    if (!equals(this.m47_1, tmp0_other_with_cast.m47_1))
      return false;
    if (!equals(this.n47_1, tmp0_other_with_cast.n47_1))
      return false;
    if (!equals(this.o47_1, tmp0_other_with_cast.o47_1))
      return false;
    if (!equals(this.p47_1, tmp0_other_with_cast.p47_1))
      return false;
    if (!equals(this.q47_1, tmp0_other_with_cast.q47_1))
      return false;
    if (!equals(this.r47_1, tmp0_other_with_cast.r47_1))
      return false;
    if (!equals(this.s47_1, tmp0_other_with_cast.s47_1))
      return false;
    if (!equals(this.t47_1, tmp0_other_with_cast.t47_1))
      return false;
    if (!equals(this.u47_1, tmp0_other_with_cast.u47_1))
      return false;
    return true;
  }
}
class Context2d {
  constructor(renderer, defaultFontRegistry, defaultFont) {
    defaultFontRegistry = defaultFontRegistry === VOID ? null : defaultFontRegistry;
    defaultFont = defaultFont === VOID ? null : defaultFont;
    this.e3u_1 = renderer;
    this.f3u_1 = defaultFontRegistry;
    this.g3u_1 = defaultFont;
    this.h3u_1 = new State(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, this.f3u_1, this.g3u_1);
    this.i3u_1 = _TGenStack___init__impl__yynjgt();
    this.j3u_1 = Vector2D.j24();
    this.k3u_1 = Vector2D.j24();
  }
  q5g() {
    return this.e3u_1.n2d();
  }
  r5g() {
    return this.e3u_1.o2d();
  }
  s5g(state, fill, winding) {
    return this.e3u_1.a5g(state, fill, winding);
  }
  t5g(state, fill, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.s5g(state, fill, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.s5g.call(this, state, fill, winding);
    }
    return tmp;
  }
  u5g(image, pos, size, transform) {
    return this.e3u_1.d5g(image, pos, size, transform);
  }
  v5g() {
    return this.e3u_1.p11();
  }
  w5g() {
    return this.e3u_1.y5f();
  }
  x5g() {
    return this.e3u_1.z5f();
  }
  n2d() {
    return this.q5g();
  }
  o2d() {
    return this.r5g();
  }
  p11() {
    this.v5g();
  }
  y5g() {
    return this.w5g();
  }
  z5g() {
    return this.x5g();
  }
  a5h(value) {
    this.h3u_1.e47_1 = value;
  }
  i4f(value) {
    this.h3u_1.f47_1 = value;
  }
  b4f() {
    return this.h3u_1.f47_1;
  }
  j4f(value) {
    this.h3u_1.j4f(value);
  }
  c4f() {
    return this.h3u_1.c4f();
  }
  l4f(value) {
    this.h3u_1.j47_1 = value;
  }
  e4f() {
    return this.h3u_1.j47_1;
  }
  b5h(value) {
    this.h3u_1.g47_1 = value;
  }
  c5h(value) {
    this.h3u_1.h47_1 = value;
  }
  k4f(value) {
    this.h3u_1.i47_1 = value;
  }
  d4f() {
    return this.h3u_1.i47_1;
  }
  d5h(value) {
    this.h3u_1.k47_1 = value;
  }
  e5h() {
    return this.h3u_1.k47_1;
  }
  y47(value) {
    this.h3u_1.l47_1 = value;
  }
  x47() {
    return this.h3u_1.l47_1;
  }
  c4h() {
    return this.h3u_1.n47_1;
  }
  u45() {
    return this.h3u_1.o47_1;
  }
  i5c() {
    return this.h3u_1.p47_1;
  }
  f5h() {
    return this.h3u_1.q47_1;
  }
  g5h() {
    return Companion_getInstance_48().a5b(this.f5h(), this.i5c());
  }
  m4f(value) {
    this.h3u_1.t47_1 = value;
  }
  f4f() {
    return this.h3u_1.t47_1;
  }
  n4f(value) {
    this.h3u_1.u47_1 = value;
  }
  g4f() {
    return this.h3u_1.u47_1;
  }
  h4f() {
    TGenStack__push_impl_9yh33t(this.i3u_1, this.h3u_1.qw());
  }
  p4f() {
    this.h3u_1 = TGenStack__pop_impl_qisxa0(this.i3u_1);
  }
  u4x(sx, sy) {
    this.h3u_1.b47_1 = this.h3u_1.b47_1.c26(sx, sy);
  }
  w47(sx, sy, $super) {
    sy = sy === VOID ? sx : sy;
    var tmp;
    if ($super === VOID) {
      this.u4x(sx, sy);
      tmp = Unit_instance;
    } else {
      tmp = $super.u4x.call(this, sx, sy);
    }
    return tmp;
  }
  z4g(tx, ty) {
    this.h3u_1.b47_1 = this.h3u_1.b47_1.k26(tx, ty);
  }
  b4h(m) {
    this.h3u_1.b47_1 = this.h3u_1.b47_1.l26(m);
  }
  h5h(_set____db54di) {
    this.j3u_1 = _set____db54di;
  }
  i5h() {
    return this.j3u_1;
  }
  j5h(_set____db54di) {
    this.k3u_1 = _set____db54di;
  }
  q3f() {
    return this.k3u_1;
  }
  p3f() {
    return this.h3u_1.d47_1.p3f();
  }
  z5() {
    this.h3u_1.d47_1.z5();
    this.j5h(this.i5h());
  }
  n36(p) {
    this.h3u_1.d47_1.n36(trans(this, p));
    this.j5h(p);
    this.h5h(p);
  }
  a37(p) {
    this.h3u_1.d47_1.a37(trans(this, p));
    this.j5h(p);
  }
  b37(c, a) {
    this.h3u_1.d47_1.b37(trans(this, c), trans(this, a));
    this.j5h(a);
  }
  o36(c1, c2, a) {
    this.h3u_1.d47_1.o36(trans(this, c1), trans(this, c2), trans(this, a));
    this.j5h(a);
  }
  t4x(path) {
    if (this.f1())
      this.h3u_1.d47_1.s36_1 = path.s36_1;
    write_0(this, path);
  }
  t4h(d) {
    d.s4h(this);
  }
  z47(x, y, width, height) {
    this.o4d();
    this.u3f(x, y, width, height);
    this.x4e();
  }
  o4d() {
    this.h3u_1.d47_1 = new VectorPath();
  }
  w4e() {
    if (!equals(this.h3u_1.k47_1, NonePaint_instance)) {
      this.t5g(this.h3u_1, false);
    }
  }
  k5h(winding) {
    if (!equals(this.h3u_1.l47_1, NonePaint_instance)) {
      this.s5g(this.h3u_1, true, winding);
    }
  }
  x4e(winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.k5h(winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.k5h.call(this, winding);
    }
    return tmp;
  }
  l5h(paint, winding) {
    if (paint == null)
      return Unit_instance;
    // Inline function 'korlibs.image.vector.Context2d.fillStyle' call
    var oldStyle = this.x47();
    this.y47(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.fill.<anonymous>' call
      this.k5h(winding);
    }finally {
      this.y47(oldStyle);
    }
  }
  a4f(paint, winding, $super) {
    winding = winding === VOID ? null : winding;
    var tmp;
    if ($super === VOID) {
      this.l5h(paint, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.l5h.call(this, paint, winding);
    }
    return tmp;
  }
  o4f(paint) {
    // Inline function 'korlibs.image.vector.Context2d.strokeStyle' call
    var oldStyle = this.e5h();
    this.d5h(paint);
    try {
      // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
      this.w4e();
    }finally {
      this.d5h(oldStyle);
    }
  }
  m5h(path, winding) {
    if (!(path == null)) {
      if (this.h3u_1.c47_1 == null) {
        this.h3u_1.c47_1 = new VectorPath();
      }
      ensureNotNull(this.h3u_1.c47_1).j3();
      ensureNotNull(this.h3u_1.c47_1).s36_1 = winding;
      ensureNotNull(this.h3u_1.c47_1).g3g(path);
      if (path === this.h3u_1.d47_1) {
        path.j3();
      }
    } else {
      this.h3u_1.c47_1 = null;
    }
  }
  n5h(path, winding, $super) {
    path = path === VOID ? this.h3u_1.d47_1 : path;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.m5h(path, winding);
      tmp = Unit_instance;
    } else {
      tmp = $super.m5h.call(this, path, winding);
    }
    return tmp;
  }
  o5h(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) {
    var paint_0 = paint == null ? fill ? this.x47() : this.e5h() : paint;
    return font == null ? null : drawText(font, this, size, text, paint_0, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  p5h(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, $super) {
    pos = pos === VOID ? Companion_getInstance_7().v21_1 : pos;
    fill = fill === VOID ? true : fill;
    paint = paint === VOID ? null : paint;
    font = font === VOID ? this.c4h() : font;
    size = size === VOID ? this.u45() : size;
    var tmp;
    if (renderer === VOID) {
      var tmp_0 = get_DefaultStringTextRenderer();
      tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
    } else {
      tmp = renderer;
    }
    renderer = tmp;
    align = align === VOID ? this.g5h() : align;
    outMetrics = outMetrics === VOID ? null : outMetrics;
    fillStyle = fillStyle === VOID ? null : fillStyle;
    stroke = stroke === VOID ? null : stroke;
    textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
    textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
    return $super === VOID ? this.o5h(text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd) : $super.o5h.call(this, text, pos, fill, paint, font, size, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd);
  }
  a48(image, pos, size) {
    return this.u5g(image, pos, size, this.h3u_1.b47_1);
  }
  h57(image, pos, size, $super) {
    size = size === VOID ? toFloat(image.d1()) : size;
    var tmp;
    if ($super === VOID) {
      this.a48(image, pos, size);
      tmp = Unit_instance;
    } else {
      tmp = $super.a48.call(this, image, pos, size);
    }
    return tmp;
  }
}
class Companion_37 {
  constructor() {
    Companion_instance_43 = this;
    this.q5h_1 = values_6();
  }
}
class CycleMethod extends Enum {
  i5a() {
    return !this.equals(CycleMethod_NO_CYCLE_getInstance()) && !this.equals(CycleMethod_NO_CYCLE_CLAMP_getInstance());
  }
  f5a(ratio) {
    var tmp;
    switch (this.m3_1) {
      case 0:
        tmp = ratio;
        break;
      case 1:
        tmp = clamp01_0(ratio);
        break;
      case 2:
        // Inline function 'korlibs.math.fract' call

        tmp = ratio - toIntFloor(ratio);
        break;
      case 3:
        var part = umod_0(ratio, 2.0);
        tmp = part > 1.0 ? 2.0 - part : part;
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  r5h(ratio) {
    return this.f5a(ratio);
  }
}
class ColorizedBeziers {
  constructor(beziers) {
    this.s5h_1 = beziers;
    var tmp = this;
    tmp.t5h_1 = lazy(ColorizedBeziers$red$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.u5h_1 = lazy(ColorizedBeziers$green$delegate$lambda(this));
    var tmp_1 = this;
    tmp_1.v5h_1 = lazy(ColorizedBeziers$blue$delegate$lambda(this));
    var tmp_2 = this;
    tmp_2.w5h_1 = lazy(ColorizedBeziers$allProjected$delegate$lambda(this));
    var tmp_3 = this;
    tmp_3.x5h_1 = lazy(ColorizedBeziers$redProjected$delegate$lambda(this));
    var tmp_4 = this;
    tmp_4.y5h_1 = lazy(ColorizedBeziers$greenProjected$delegate$lambda(this));
    var tmp_5 = this;
    tmp_5.z5h_1 = lazy(ColorizedBeziers$blueProjected$delegate$lambda(this));
  }
  k5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t5h_1;
    red$factory();
    return this_0.t1();
  }
  l5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5h_1;
    green$factory();
    return this_0.t1();
  }
  m5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5h_1;
    blue$factory();
    return this_0.t1();
  }
  a5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w5h_1;
    allProjected$factory();
    return this_0.t1();
  }
  f5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x5h_1;
    redProjected$factory();
    return this_0.t1();
  }
  g5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.y5h_1;
    greenProjected$factory();
    return this_0.t1();
  }
  h5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.z5h_1;
    blueProjected$factory();
    return this_0.t1();
  }
}
class ColoredBezier {
  constructor(bezier, color) {
    this.i5i_1 = bezier;
    this.j5i_1 = color;
  }
  toString() {
    return 'ColoredBezier(bezier=' + this.i5i_1.toString() + ', color=' + RGBA__toString_impl_4lw6dp(this.j5i_1) + ')';
  }
  hashCode() {
    var result = this.i5i_1.hashCode();
    result = imul(result, 31) + RGBA__hashCode_impl_h59qf6(this.j5i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof ColoredBezier))
      return false;
    var tmp0_other_with_cast = other instanceof ColoredBezier ? other : THROW_CCE();
    if (!this.i5i_1.equals(tmp0_other_with_cast.i5i_1))
      return false;
    if (!(this.j5i_1 === tmp0_other_with_cast.j5i_1))
      return false;
    return true;
  }
}
class ProjectCurvesLookup {
  constructor(beziers) {
    this.b5i_1 = beziers;
    this.c5i_1 = new ProjectedPoint();
    this.d5i_1 = Companion_getInstance_3().d25();
  }
  e5i(point) {
    return Companion_getInstance_7().f2c(point, this.t35(point));
  }
  t35(point) {
    if (this.b5i_1.f1())
      return Vector2D.l24(0, 0);
    var minDistSq = Infinity;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.b5i_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var dist = this_0.c1(_unary__edvuaz).e35().n23(point);
      if (dist < minDistSq) {
        minDistSq = dist;
      }
    }
    var bminDistSq = Infinity;
    var out = Vector2D.j24();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_1 = this.b5i_1;
    var n_0 = 0;
    while (n_0 < this_1.d1()) {
      $l$block: {
        // Inline function 'korlibs.image.vector.ProjectCurvesLookup.closest.<anonymous>' call
        var _unary__edvuaz_0 = n_0;
        n_0 = _unary__edvuaz_0 + 1 | 0;
        var it = this_1.c1(_unary__edvuaz_0);
        if (it.e35().m23(point) > minDistSq) {
          break $l$block;
        }
        it.r35(point, this.c5i_1);
        if (this.c5i_1.h34_1 < bminDistSq) {
          bminDistSq = this.c5i_1.h34_1;
          out = this.c5i_1.f34_1;
        }
      }
    }
    return out;
  }
}
class Shape {}
function getPath(path) {
  return path;
}
function getPath$default(path, $super) {
  path = path === VOID ? new VectorPath() : path;
  return $super === VOID ? this.n5i(path) : getPath(path);
}
function get_bounds() {
  return this.o5i(true);
}
class StyledShape {}
function get_path() {
  return null;
}
function getBounds(includeStrokes) {
  var tmp344_safe_receiver = this.l1q();
  var tmp;
  if (tmp344_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.StyledShape.getBounds.<anonymous>' call
    tmp = _BoundsBuilder___get_bounds__impl__s1l1gx(plus_1(Companion_getInstance_8().t22(), tmp344_safe_receiver));
  }
  var tmp0_elvis_lhs = tmp;
  return tmp0_elvis_lhs == null ? Companion_getInstance_5().s22() : tmp0_elvis_lhs;
}
function getPath_0(path) {
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.StyledShape.getPath.<anonymous>' call
  var tmp346_safe_receiver = this.l1q();
  if (tmp346_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    // Inline function 'kotlin.contracts.contract' call
    path.g3g(tmp346_safe_receiver);
  }
  return path;
}
function draw(c) {
  // Inline function 'korlibs.image.vector.Context2d.keepTransform' call
  var t = c.h3u_1.b47_1;
  try {
    // Inline function 'korlibs.image.vector.StyledShape.draw.<anonymous>' call
    c.o4d();
    var tmp347_safe_receiver = this.l1q();
    if (tmp347_safe_receiver == null)
      null;
    else {
      draw_0(tmp347_safe_receiver, c);
    }
    if (!(this.w5i() == null)) {
      draw_0(ensureNotNull(this.w5i()), c);
      c.n5h();
    }
    c.b4h(get_immutable(this.a4h()));
    this.a5j(c);
  }finally {
    c.h3u_1.b47_1 = t;
  }
}
function drawInternal(c) {
}
class FillShape {
  constructor(path, clip, paint, transform, globalAlpha) {
    transform = transform === VOID ? Companion_getInstance_6().a25_1 : transform;
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.p5i_1 = path;
    this.q5i_1 = clip;
    this.r5i_1 = paint;
    this.s5i_1 = transform;
    this.t5i_1 = globalAlpha;
    var tmp = this;
    tmp.u5i_1 = lazy(FillShape$pathCurvesList$delegate$lambda(this));
    var tmp_0 = this;
    tmp_0.v5i_1 = lazy(FillShape$clipCurvesList$delegate$lambda(this));
  }
  l1q() {
    return this.p5i_1;
  }
  w5i() {
    return this.q5i_1;
  }
  a4h() {
    return this.s5i_1;
  }
  x5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.u5i_1;
    pathCurvesList$factory();
    return this_0.t1();
  }
  y5i() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.v5i_1;
    clipCurvesList$factory();
    return this_0.t1();
  }
  z5i() {
    return this.x5i().d1() === 1 && get_isConvex(first_0(this.x5i())) && this.y5i() == null;
  }
  a5j(c) {
    c.l5h(this.r5i_1, this.p5i_1.s36_1);
  }
  toString() {
    return 'FillShape(path=' + this.p5i_1.toString() + ', clip=' + toString(this.q5i_1) + ', paint=' + toString_0(this.r5i_1) + ', transform=' + this.s5i_1.toString() + ', globalAlpha=' + this.t5i_1 + ')';
  }
  hashCode() {
    var result = this.p5i_1.hashCode();
    result = imul(result, 31) + (this.q5i_1 == null ? 0 : this.q5i_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.r5i_1) | 0;
    result = imul(result, 31) + this.s5i_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.t5i_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof FillShape))
      return false;
    var tmp0_other_with_cast = other instanceof FillShape ? other : THROW_CCE();
    if (!this.p5i_1.equals(tmp0_other_with_cast.p5i_1))
      return false;
    if (!equals(this.q5i_1, tmp0_other_with_cast.q5i_1))
      return false;
    if (!equals(this.r5i_1, tmp0_other_with_cast.r5i_1))
      return false;
    if (!this.s5i_1.equals(tmp0_other_with_cast.s5i_1))
      return false;
    if (!equals(this.t5i_1, tmp0_other_with_cast.t5i_1))
      return false;
    return true;
  }
}
class CompoundShape {
  constructor(components) {
    this.b5j_1 = components;
  }
  o5i(includeStrokes) {
    var bb = Companion_getInstance_8().t22();
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.b5j_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getBounds.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      var it = this_0.c1(_unary__edvuaz);
      bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, it.o5i(includeStrokes));
    }
    return _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  }
  s4h(c) {
    $l$block: {
      // Inline function 'korlibs.image.vector.Context2d.buffering' call
      c.y5g();
      try {
        // Inline function 'korlibs.datastructure.iterators.fastForEach' call
        var this_0 = this.b5j_1;
        var n = 0;
        while (n < this_0.d1()) {
          // Inline function 'korlibs.image.vector.CompoundShape.draw.<anonymous>.<anonymous>' call
          var _unary__edvuaz = n;
          n = _unary__edvuaz + 1 | 0;
          this_0.c1(_unary__edvuaz).s4h(c);
        }
        break $l$block;
      }finally {
        c.z5g();
      }
    }
    return Unit_instance;
  }
  n5i(path) {
    // Inline function 'kotlin.also' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>' call
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.b5j_1;
    var n = 0;
    while (n < this_0.d1()) {
      // Inline function 'korlibs.image.vector.CompoundShape.getPath.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n;
      n = _unary__edvuaz + 1 | 0;
      this_0.c1(_unary__edvuaz).n5i(path);
    }
    return path;
  }
  toString() {
    return 'CompoundShape(\n  ' + joinToString(this.b5j_1, ',\n  ') + '\n)';
  }
}
class PolylineShape {
  constructor(path, clip, paint, transform, strokeInfo, globalAlpha) {
    globalAlpha = globalAlpha === VOID ? 1.0 : globalAlpha;
    this.d5j_1 = path;
    this.e5j_1 = clip;
    this.f5j_1 = paint;
    this.g5j_1 = transform;
    this.h5j_1 = strokeInfo;
    this.i5j_1 = globalAlpha;
    this.j5j_1 = thickness$factory(this.h5j_1);
    this.k5j_1 = scaleMode$factory(this.h5j_1);
    this.l5j_1 = startCap$factory(this.h5j_1);
    this.m5j_1 = endCap$factory(this.h5j_1);
    this.n5j_1 = join$factory(this.h5j_1);
    this.o5j_1 = miterLimit$factory(this.h5j_1);
    this.p5j_1 = dash$factory(this.h5j_1);
    this.q5j_1 = dashOffset$factory(this.h5j_1);
    var tmp = this;
    tmp.r5j_1 = lazy(PolylineShape$fillShape$delegate$lambda(this));
  }
  l1q() {
    return this.d5j_1;
  }
  w5i() {
    return this.e5j_1;
  }
  a4h() {
    return this.g5j_1;
  }
  o5i(includeStrokes) {
    var tmp351_safe_receiver = BoundsBuilder__boundsOrNull_impl_se9lyg(plus_1(Companion_getInstance_8().t22(), this.d5j_1));
    var bounds = tmp351_safe_receiver == null ? null : get_mutable(tmp351_safe_receiver);
    if (includeStrokes) {
      // Inline function 'kotlin.math.max' call
      var a = this.h5j_1.w30_1 / 2.0;
      var halfThickness = Math.max(a, 0.0);
      if (bounds == null)
        null;
      else
        bounds.a3i(halfThickness, halfThickness);
    }
    var tmp0_elvis_lhs = bounds == null ? null : bounds.i3h();
    return tmp0_elvis_lhs == null ? Companion_getInstance_5().p22_1 : tmp0_elvis_lhs;
  }
  s5j(c) {
    c.a5h(this.h5j_1.y30_1);
    c.i4f(this.h5j_1.w30_1);
    c.b5h(this.h5j_1.z30_1);
    c.c5h(this.h5j_1.a31_1);
    c.k4f(this.h5j_1.b31_1);
    c.l4f(this.h5j_1.c31_1);
    c.m4f(this.h5j_1.d31_1);
    c.n4f(this.h5j_1.e31_1);
  }
  a5j(c) {
    this.s5j(c);
    c.o4f(this.f5j_1);
  }
  toString() {
    return 'PolylineShape(path=' + this.d5j_1.toString() + ', clip=' + toString(this.e5j_1) + ', paint=' + toString_0(this.f5j_1) + ', transform=' + this.g5j_1.toString() + ', strokeInfo=' + this.h5j_1.toString() + ', globalAlpha=' + this.i5j_1 + ')';
  }
  hashCode() {
    var result = this.d5j_1.hashCode();
    result = imul(result, 31) + (this.e5j_1 == null ? 0 : this.e5j_1.hashCode()) | 0;
    result = imul(result, 31) + hashCode(this.f5j_1) | 0;
    result = imul(result, 31) + this.g5j_1.hashCode() | 0;
    result = imul(result, 31) + this.h5j_1.hashCode() | 0;
    result = imul(result, 31) + getNumberHashCode(this.i5j_1) | 0;
    return result;
  }
  equals(other) {
    if (this === other)
      return true;
    if (!(other instanceof PolylineShape))
      return false;
    var tmp0_other_with_cast = other instanceof PolylineShape ? other : THROW_CCE();
    if (!this.d5j_1.equals(tmp0_other_with_cast.d5j_1))
      return false;
    if (!equals(this.e5j_1, tmp0_other_with_cast.e5j_1))
      return false;
    if (!equals(this.f5j_1, tmp0_other_with_cast.f5j_1))
      return false;
    if (!this.g5j_1.equals(tmp0_other_with_cast.g5j_1))
      return false;
    if (!this.h5j_1.equals(tmp0_other_with_cast.h5j_1))
      return false;
    if (!equals(this.i5j_1, tmp0_other_with_cast.i5j_1))
      return false;
    return true;
  }
}
class TextShape {
  u5j() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.t5j_1;
    primitiveShapes$factory();
    return this_0.t1();
  }
}
class EmptyShape {
  o5i(includeStrokes) {
    return Companion_getInstance_5().s22();
  }
  s4h(c) {
    return Unit_instance;
  }
}
class ShapeBuilder extends Context2d {
  constructor(width, height) {
    super(Companion_getInstance_55());
    var tmp = this;
    tmp.t4b_1 = width == null ? 256 : width;
    var tmp_0 = this;
    tmp_0.u4b_1 = height == null ? 256 : height;
    var tmp_1 = this;
    // Inline function 'kotlin.collections.arrayListOf' call
    tmp_1.v4b_1 = ArrayList.p1();
  }
  q5g() {
    return this.t4b_1;
  }
  r5g() {
    return this.u4b_1;
  }
  s5g(state, fill, winding) {
    if (state.d47_1.f1())
      return Unit_instance;
    // Inline function 'kotlin.also' call
    var this_0 = state.d47_1.qw();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
    var tmp = this_0;
    tmp.s36_1 = winding == null ? this_0.s36_1 : winding;
    var path = this_0;
    var tmp366_safe_receiver = state.c47_1;
    var tmp367_safe_receiver = tmp366_safe_receiver == null ? null : tmp366_safe_receiver.qw();
    var tmp_0;
    if (tmp367_safe_receiver == null) {
      tmp_0 = null;
    } else {
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.vector.ShapeBuilder.rendererRender.<anonymous>' call
      var tmp_1 = tmp367_safe_receiver;
      tmp_1.s36_1 = winding == null ? tmp367_safe_receiver.s36_1 : winding;
      tmp_0 = tmp367_safe_receiver;
    }
    var clip = tmp_0;
    var transform = state.b47_1;
    if (fill) {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_1 = this.v4b_1;
      var element = new FillShape(path, clip, state.l47_1.qw(), transform, state.r47_1);
      this_1.f(element);
    } else {
      // Inline function 'kotlin.collections.plusAssign' call
      var this_2 = this.v4b_1;
      var tmp_2 = state.k47_1.qw();
      var tmp368_thickness = state.f47_1;
      var tmp369_scaleMode = state.e47_1;
      var tmp370_startCap = state.g47_1;
      var tmp371_endCap = state.h47_1;
      var tmp372_join = state.i47_1;
      var tmp373_dash = state.t47_1;
      var tmp374_dashOffset = state.u47_1;
      var tmp375_miterLimit = state.j47_1;
      var element_0 = new PolylineShape(path, clip, tmp_2, transform, new StrokeInfo(tmp368_thickness, true, tmp369_scaleMode, tmp370_startCap, tmp371_endCap, tmp372_join, tmp375_miterLimit, tmp373_dash, tmp374_dashOffset), state.r47_1);
      this_2.f(element_0);
    }
  }
  u5g(image, pos, size, transform) {
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.ShapeBuilder.rendererDrawImage.<anonymous>' call
    this_0.t3f(pos, size);
    this.t5g(new State(transform, VOID, this_0, VOID, VOID, VOID, VOID, VOID, VOID, VOID, new BitmapPaint(image, scaled(Companion_getInstance_6().a25_1, size.k2b(toFloat(image.d1()))).e26(pos))), true);
  }
  v5g() {
  }
  w5g() {
    return 0;
  }
  x5g() {
  }
  w4b() {
    return this.v4b_1.d1() === 1 ? first_0(this.v4b_1) : new CompoundShape(toList(this.v4b_1));
  }
  s4h(c) {
    c.t4h(this.w4b());
  }
}
class SvgPath {
  c5j(path, separator, decimalPlaces) {
    // Inline function 'kotlin.collections.arrayListOf' call
    var parts = ArrayList.p1();
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.q36_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.ow(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.r36_1.c1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.j21(tmp, path.r36_1.c1(_unary__edvuaz_1));
          var x = destruct.rk();
          var y = destruct.sk();
          // Inline function 'kotlin.collections.plusAssign' call

          var element = 'M' + toSvgPathString$fixX(x, decimalPlaces) + ' ' + toSvgPathString$fixY(y, decimalPlaces);
          parts.f(element);
          break;
        case 1:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.r36_1.c1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.j21(tmp_0, path.r36_1.c1(_unary__edvuaz_3));
          var x_0 = destruct_0.rk();
          var y_0 = destruct_0.sk();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_0 = 'L' + toSvgPathString$fixX(x_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y_0, decimalPlaces);
          parts.f(element_0);
          break;
        case 2:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.r36_1.c1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.j21(tmp_1, path.r36_1.c1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.r36_1.c1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.j21(tmp_2, path.r36_1.c1(_unary__edvuaz_7));
          var x1 = destruct_1.rk();
          var y1 = destruct_1.sk();
          var x2 = destruct_2.rk();
          var y2 = destruct_2.sk();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_1 = 'Q' + toSvgPathString$fixX(x1, decimalPlaces) + ' ' + toSvgPathString$fixY(y1, decimalPlaces) + ', ' + toSvgPathString$fixX(x2, decimalPlaces) + ' ' + toSvgPathString$fixY(y2, decimalPlaces);
          parts.f(element_1);
          break;
        case 3:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.r36_1.c1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.j21(tmp_3, path.r36_1.c1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.r36_1.c1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.j21(tmp_4, path.r36_1.c1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.r36_1.c1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.j21(tmp_5, path.r36_1.c1(_unary__edvuaz_13));
          var x1_0 = destruct_3.rk();
          var y1_0 = destruct_3.sk();
          var x2_0 = destruct_4.rk();
          var y2_0 = destruct_4.sk();
          var x3 = destruct_5.rk();
          var y3 = destruct_5.sk();
          // Inline function 'kotlin.collections.plusAssign' call

          var element_2 = 'C' + toSvgPathString$fixX(x1_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y1_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x2_0, decimalPlaces) + ' ' + toSvgPathString$fixY(y2_0, decimalPlaces) + ', ' + toSvgPathString$fixX(x3, decimalPlaces) + ' ' + toSvgPathString$fixY(y3, decimalPlaces);
          parts.f(element_2);
          break;
        case 4:
          // Inline function 'korlibs.image.vector.format.SvgPath.toSvgPathString.<anonymous>' call

          // Inline function 'kotlin.collections.plusAssign' call

          parts.f('Z');
          break;
      }
    }
    return joinToString(parts, '');
  }
}
class Rasterizer extends RastScale {
  constructor() {
    super();
    this.k5f_1 = false;
    this.l5f_1 = 2;
    this.m5f_1 = 1;
    this.n5f_1 = new PolygonScanline();
    this.o5f_1 = new PolygonScanline();
    this.p5f_1 = new IntSegmentSet();
    this.q5f_1 = new IntSegmentSet();
    this.r5f_1 = new IntSegmentSet();
    this.s5f_1 = IntArrayList.w2e(1024);
  }
  e2h() {
    this.n5f_1.e2h();
    this.o5f_1.e2h();
  }
  v5j(bounds, quality, stats, winding, callback) {
    if (stats == null)
      null;
    else {
      stats.e2h();
    }
    var xmin = this.x3c(bounds.k22());
    var xmax = this.x3c(bounds.l22());
    var tempRect = this.n5f_1.e33();
    // Inline function 'kotlin.math.max' call
    var a = bounds.m22();
    var b = tempRect.m22();
    var tmp$ret$0 = Math.max(a, b);
    var startY = this.x3c(tmp$ret$0);
    // Inline function 'kotlin.math.min' call
    var a_0 = bounds.n22();
    var b_0 = tempRect.n22();
    var tmp$ret$1 = Math.min(a_0, b_0);
    var endY = this.x3c(tmp$ret$1);
    var func = Rasterizer$rasterizeFill$lambda(xmax, xmin, this, callback);
    this.s5f_1.j3();
    var q = quality;
    var yCount = imul(((endY - startY | 0) / this.p3d() | 0) + 1 | 0, q);
    var inductionVariable = 0;
    var last = (yCount + q | 0) - 1 | 0;
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var y = startY + ((imul(n, this.p3d()) / this.m5f_1 | 0) / q | 0) | 0;
        this.s5f_1.c2f(y);
      }
       while (inductionVariable < last);
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>' call
    var edgesEmitted = 0;
    var edgesChecked = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = this.s5f_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      var y_0 = this_0.ow(_unary__edvuaz);
      this.n5f_1.k3d(y_0, winding, this.p5f_1);
      edgesChecked = edgesChecked + this.n5f_1.v3c_1 | 0;
      if (this.o5f_1.z23()) {
        this.o5f_1.k3d(y_0, this.o5f_1.g3c_1, this.q5f_1);
        edgesChecked = edgesChecked + this.o5f_1.v3c_1 | 0;
        this.r5f_1.v30(this.p5f_1, this.q5f_1);
      }
      // Inline function 'korlibs.math.segment.IntSegmentSet.fastForEach' call
      var this_1 = this.o5f_1.z23() ? this.r5f_1 : this.p5f_1;
      var inductionVariable_0 = 0;
      var last_0 = this_1.d1();
      if (inductionVariable_0 < last_0)
        do {
          var n_1 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.vector.rasterizer.Rasterizer.rasterizeFill.<anonymous>.<anonymous>.<anonymous>' call
          func(this_1.n30_1.ow(n_1), this_1.o30_1.ow(n_1), y_0);
          edgesEmitted = edgesEmitted + 1 | 0;
        }
         while (inductionVariable_0 < last_0);
    }
    var tmp;
    if (stats == null) {
      tmp = null;
    } else {
      stats.z5j(edgesChecked, edgesEmitted, yCount);
      tmp = Unit_instance;
    }
  }
  t5f(bounds, quality, stats, winding, callback, $super) {
    quality = quality === VOID ? this.l5f_1 : quality;
    stats = stats === VOID ? null : stats;
    winding = winding === VOID ? Winding_NON_ZERO_getInstance() : winding;
    var tmp;
    if ($super === VOID) {
      this.v5j(bounds, quality, stats, winding, callback);
      tmp = Unit_instance;
    } else {
      tmp = $super.v5j.call(this, bounds, quality, stats, winding, callback);
    }
    return tmp;
  }
}
class DummyRenderer extends Renderer {
  constructor(width, height) {
    Companion_getInstance_55();
    super();
    this.c5k_1 = width;
    this.d5k_1 = height;
  }
  n2d() {
    return this.c5k_1;
  }
  o2d() {
    return this.d5k_1;
  }
}
class Companion_38 extends DummyRenderer {
  constructor() {
    Companion_instance_44 = null;
    super(128, 128);
    Companion_instance_44 = this;
  }
}
class HtmlCanvas {
  e5k(width, height) {
    if (Companion_getInstance_11().sq()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on Node.JS';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var out = document.createElement('canvas');
    out.width = width;
    out.height = height;
    return toLike(out);
  }
}
class HtmlImage {
  a5l(width, height) {
    return HtmlCanvas_instance.e5k(width, height);
  }
  b5l(bmpData, bmpWidth, bmpHeight, canvas) {
    var pixelCount = _RgbaArray___get_size__impl__imxef8(bmpData);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    var idata = ctx.createImageData(bmpWidth, bmpHeight);
    var idataData = idata.data;
    var m = 0;
    var inductionVariable = 0;
    if (inductionVariable < pixelCount)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var c = RgbaArray__get_impl_nzyo1o(bmpData, n);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz = m;
        m = _unary__edvuaz + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz] = _RGBA___get_r__impl__duz7mo(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_0 = m;
        m = _unary__edvuaz_0 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_0] = _RGBA___get_g__impl__o8pukr(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_1 = m;
        m = _unary__edvuaz_1 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_1] = _RGBA___get_b__impl__m6tl80(c);
        // Inline function 'org.khronos.webgl.set' call
        var _unary__edvuaz_2 = m;
        m = _unary__edvuaz_2 + 1 | 0;
        // Inline function 'kotlin.js.asDynamic' call
        // Inline function 'kotlin.js.asDynamic' call
        idataData[_unary__edvuaz_2] = _RGBA___get_a__impl__6msvu7(c);
      }
       while (inductionVariable < pixelCount);
    ctx.putImageData(idata, 0.0, 0.0);
    return canvas;
  }
  c5l(bmp, canvas) {
    return this.b5l(_RgbaArray___init__impl__oib4y4(bmp.n3x().w3l_1), bmp.n2d(), bmp.o2d(), canvas);
  }
  f5k(bmp) {
    return this.c5l(bmp, this.a5l(bmp.n2d(), bmp.o2d()));
  }
}
class NodeJsNativeImageFormatProvider extends BaseNativeImageFormatProvider {
  constructor() {
    NodeJsNativeImageFormatProvider_instance = null;
    super();
    NodeJsNativeImageFormatProvider_instance = this;
  }
  p55() {
    return get_RegisteredImageFormats();
  }
}
class HtmlNativeImageFormatProvider extends NativeImageFormatProvider {
  constructor() {
    HtmlNativeImageFormatProvider_instance = null;
    super();
    HtmlNativeImageFormatProvider_instance = this;
  }
  h56(data, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_0(this, data, props, $completion), $completion);
  }
  b57(vfs, path, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeInternal__jnwsgt_1(this, vfs, path, props, $completion), $completion);
  }
  m40(width, height, premultiplied) {
    return HtmlNativeImage.z5k(HtmlCanvas_instance.e5k(width, height));
  }
  l40(bmp) {
    return HtmlNativeImage.z5k(HtmlImage_instance.f5k(bmp.s3m()));
  }
}
class HtmlNativeImage extends NativeImage {
  static i5l(texSourceBase, width, height) {
    var $this = this.k40(width, height, texSourceBase, true);
    $this.u5k_1 = texSourceBase;
    $this.v5k_1 = $this.u5k_1;
    var tmp = $this;
    tmp.w5k_1 = lazy(HtmlNativeImage$lazyCanvasElement$delegate$lambda($this, width, height));
    var tmp_0 = $this;
    tmp_0.x5k_1 = lazy(HtmlNativeImage$ctx$delegate$lambda($this));
    $this.y5k_1 = Monotonic_instance.oi();
    return $this;
  }
  n3() {
    return 'HtmlNativeImage';
  }
  static f5l(img) {
    return this.i5l(img, img.width, img.height);
  }
  static z5k(canvas) {
    return this.i5l(canvas, canvas.width, canvas.height);
  }
  h5l() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.w5k_1;
    lazyCanvasElement$factory();
    return this_0.t1();
  }
  j5l() {
    // Inline function 'kotlin.getValue' call
    var this_0 = this.x5k_1;
    ctx$factory();
    return this_0.t1();
  }
  f3n(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var tmp = this.u5k_1;
    if (tmp instanceof HTMLVideoElement) {
      var now = Monotonic_instance.oi();
      var elapsedTime = ValueTimeMark__minus_impl_f87sko(now, this.y5k_1);
      // Inline function 'korlibs.time.milliseconds' call
      // Inline function 'kotlin.time.Companion.milliseconds' call
      Companion_getInstance();
      var tmp$ret$1 = toDuration(16, DurationUnit_MILLISECONDS_getInstance());
      if (Duration__compareTo_impl_pchp0f(elapsedTime, tmp$ret$1) >= 0) {
        this.y5k_1 = now;
        this.j5l().clearRect(0.0, 0.0, width, height);
        this.j5l().drawImage(this.u5k_1, 0.0, 0.0);
      }
    }
    var idata = this.j5l().getImageData(x, y, width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(data, 0, out, offset, size);
    if (get_isBigEndian()) {
      bswap32(out, offset, size);
    }
    if (!this.n3m_1) {
      premultiply(_RgbaArray___init__impl__oib4y4(out), offset, _RgbaPremultipliedArray___init__impl__lx83hy(out), offset, imul(width, height));
    }
  }
  h3n(x, y, width, height, out, offset) {
    if (width <= 0 || height <= 0)
      return Unit_instance;
    var size = imul(width, height);
    var idata = this.j5l().createImageData(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var data = asInt32Array(idata.data.buffer);
    arraycopy(out, offset, data, 0, size);
    if (!this.n3m_1) {
      depremultiply(_RgbaPremultipliedArray___init__impl__lx83hy(data), 0, _RgbaArray___init__impl__oib4y4(data), 0, imul(width, height));
    }
    if (get_isBigEndian()) {
      bswap32(data, 0, size);
    }
    this.j5l().putImageData(idata, x, y);
  }
  c3u(antialiasing) {
    return new Context2d(new CanvasContext2dRenderer(this.h5l()));
  }
  k5l(type, quality) {
    return this.h5l().toDataURL(type, quality);
  }
  l5l(type, quality, $super) {
    type = type === VOID ? 'image/png' : type;
    quality = quality === VOID ? null : quality;
    return $super === VOID ? this.k5l(type, quality) : $super.k5l.call(this, type, quality);
  }
}
class BrowserImage {
  d5l(bytes, props, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_decodeToCanvas__71sobd(this, bytes, props, $completion), $completion);
  }
  o5l(img) {
    return this.g5l(img, img.width, img.height);
  }
  g5l(img, width, height) {
    var canvas = HtmlCanvas_instance.e5k(width, height);
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var ctx = canvas.getContext('2d');
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    ctx.drawImage(img, 0.0, 0.0);
    return canvas;
  }
  e5l(jsUrl, props, $completion) {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine.<anonymous>' call
    var cancellable = new CancellableContinuationImpl(intercepted($completion), 1);
    cancellable.v12();
    // Inline function 'korlibs.image.format.BrowserImage.loadImage.<anonymous>' call
    if (Companion_getInstance_11().sq()) {
      // Inline function 'kotlin.error' call
      var message = 'Canvas not available on NodeJS';
      throw IllegalStateException.w4(toString_0(message));
    }
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    var img = document.createElement('img');
    img.onload = BrowserImage$loadImage$lambda(cancellable, img);
    img.onerror = BrowserImage$loadImage$lambda_0(cancellable, jsUrl);
    img.src = jsUrl;
    return cancellable.h10();
  }
  n5l(jsUrl, props, $completion, $super) {
    props = props === VOID ? Companion_getInstance_40().r48_1 : props;
    return $super === VOID ? this.e5l(jsUrl, props, $completion) : $super.e5l.call(this, jsUrl, props, $completion);
  }
  m5l(jsUrl, $completion) {
    return suspendOrReturn(/*#__NOINLINE__*/_generator_loadCanvas__xw76hi(this, jsUrl, $completion), $completion);
  }
}
class CanvasContext2dRenderer extends Renderer {
  constructor(canvas) {
    super();
    this.r5l_1 = canvas;
    var tmp = this;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    tmp.s5l_1 = this.r5l_1.getContext('2d');
    this.t5l_1 = NaN;
    this.u5l_1 = null;
  }
  n2d() {
    return this.r5l_1.width;
  }
  o2d() {
    return this.r5l_1.height;
  }
  y5l(_this__u8e3s4, paint) {
    var grad = _this__u8e3s4;
    var inductionVariable = 0;
    var last = paint.a4t_1.d1();
    if (inductionVariable < last)
      do {
        var n = inductionVariable;
        inductionVariable = inductionVariable + 1 | 0;
        var stop = paint.a4t_1.ow(n);
        var color = paint.b4t_1.ow(n);
        grad.addColorStop(stop, _RGBA___get_htmlStringSimple__impl__l4nu0u(_RGBA___init__impl__lqpay5(color)));
      }
       while (inductionVariable < last);
    return _this__u8e3s4;
  }
  w5l(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof NonePaint) {
      tmp = 'none';
    } else {
      if (_this__u8e3s4 instanceof RGBA) {
        tmp = _RGBA___get_htmlColor__impl__bzw5k6(_RGBA___get_color__impl__8x3sb3(_this__u8e3s4.l44_1));
      } else {
        if (_this__u8e3s4 instanceof GradientPaint) {
          var tmp_0;
          switch (_this__u8e3s4.t4s_1.m3_1) {
            case 0:
              tmp_0 = this.y5l(this.s5l_1.createLinearGradient(_this__u8e3s4.u4s_1, _this__u8e3s4.v4s_1, _this__u8e3s4.x4s_1, _this__u8e3s4.y4s_1), _this__u8e3s4);
              break;
            case 1:
              tmp_0 = this.y5l(this.s5l_1.createRadialGradient(_this__u8e3s4.u4s_1, _this__u8e3s4.v4s_1, _this__u8e3s4.w4s_1, _this__u8e3s4.x4s_1, _this__u8e3s4.y4s_1, _this__u8e3s4.z4s_1), _this__u8e3s4);
              break;
            case 2:
              var tmp_1;
              if (!equals(this.s5l_1.createConicGradient, undefined)) {
                // Inline function 'kotlin.js.unsafeCast' call
                // Inline function 'kotlin.js.asDynamic' call
                var tmp$ret$1 = this.s5l_1.createConicGradient(_Angle___get_radians__impl__n00yt5(_this__u8e3s4.g4t_1), _this__u8e3s4.u4s_1, _this__u8e3s4.v4s_1);
                tmp_1 = this.y5l(tmp$ret$1, _this__u8e3s4);
              } else {
                tmp_1 = 'fuchsia';
              }

              tmp_0 = tmp_1;
              break;
            default:
              noWhenBranchMatchedException();
              break;
          }
          tmp = tmp_0;
        } else {
          if (_this__u8e3s4 instanceof BitmapPaint) {
            // Inline function 'kotlin.js.unsafeCast' call
            // Inline function 'kotlin.js.asDynamic' call
            var tmp$ret$3 = toHtmlNative(_this__u8e3s4.s59_1).v5k_1;
            tmp = this.s5l_1.createPattern(tmp$ret$3, _this__u8e3s4.h5a() && _this__u8e3s4.j5a() ? 'repeat' : _this__u8e3s4.h5a() ? 'repeat-x' : _this__u8e3s4.j5a() ? 'repeat-y' : 'no-repeat');
          } else {
            tmp = 'black';
          }
        }
      }
    }
    return tmp;
  }
  z5l(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.m3_1) {
      case 0:
        tmp = 'clear';
        break;
      case 1:
        tmp = 'copy';
        break;
      case 2:
        tmp = 'source-over';
        break;
      case 3:
        tmp = 'destination-over';
        break;
      case 4:
        tmp = 'source-in';
        break;
      case 5:
        tmp = 'destination-in';
        break;
      case 6:
        tmp = 'source-out';
        break;
      case 7:
        tmp = 'destination-out';
        break;
      case 8:
        tmp = 'source-atop';
        break;
      case 9:
        tmp = 'destination-atop';
        break;
      case 10:
        tmp = 'xor';
        break;
      case 11:
        tmp = 'lighter';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
  a5m(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.m3_1) {
      case 0:
        tmp = 'normal';
        break;
      case 1:
        tmp = 'multiply';
        break;
      case 2:
        tmp = 'screen';
        break;
      case 3:
        tmp = 'overlay';
        break;
      case 4:
        tmp = 'darken';
        break;
      case 5:
        tmp = 'lighten';
        break;
      case 6:
        tmp = 'color-dodge';
        break;
      case 7:
        tmp = 'color-burn';
        break;
      case 8:
        tmp = 'hard-light';
        break;
      case 9:
        tmp = 'soft-light';
        break;
      case 10:
        tmp = 'difference';
        break;
      case 11:
        tmp = 'exclusion';
        break;
      case 12:
        tmp = 'hue';
        break;
      case 13:
        tmp = 'saturation';
        break;
      case 14:
        tmp = 'color';
        break;
      case 15:
        tmp = 'luminosity';
        break;
      default:
        // Inline function 'kotlin.text.lowercase' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = _this__u8e3s4.l3_1.toLowerCase();
        break;
    }
    return tmp;
  }
  v5l(_this__u8e3s4) {
    var tmp;
    if (_this__u8e3s4 instanceof CompositeMode) {
      tmp = this.z5l(_this__u8e3s4);
    } else {
      if (_this__u8e3s4 instanceof BlendMode) {
        tmp = this.a5m(_this__u8e3s4);
      } else {
        tmp = 'source-over';
      }
    }
    return tmp;
  }
  x5l(_this__u8e3s4, m) {
    _this__u8e3s4.transform(m.f25_1, m.g25_1, m.h25_1, m.i25_1, m.j25_1, m.k25_1);
  }
  d5g(image, pos, size, transform) {
    this.s5l_1.save();
    try {
      // Inline function 'kotlin.run' call
      // Inline function 'kotlin.contracts.contract' call
      this.s5l_1.setTransform(transform.f25_1, transform.g25_1, transform.h25_1, transform.i25_1, transform.j25_1, transform.k25_1);
      // Inline function 'kotlin.js.unsafeCast' call
      var tmp = ensureNative(image);
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = (tmp instanceof HtmlNativeImage ? tmp : THROW_CCE()).v5k_1;
      this.s5l_1.drawImage(tmp$ret$2, pos.h21_1, pos.i21_1, size.y22_1, size.z22_1);
    }finally {
      this.s5l_1.restore();
    }
  }
  b5m(path) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
    var n = 0;
    // Inline function 'korlibs.datastructure.iterators.fastForEach' call
    var this_0 = path.q36_1;
    var n_0 = 0;
    while (n_0 < this_0.d1()) {
      // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
      var _unary__edvuaz = n_0;
      n_0 = _unary__edvuaz + 1 | 0;
      switch (this_0.ow(_unary__edvuaz)) {
        case 0:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_0 = n;
          n = _unary__edvuaz_0 + 1 | 0;
          var tmp = path.r36_1.c1(_unary__edvuaz_0);
          var _unary__edvuaz_1 = n;
          n = _unary__edvuaz_1 + 1 | 0;
          var destruct = Vector2D.j21(tmp, path.r36_1.c1(_unary__edvuaz_1));
          var x = destruct.rk();
          var y = destruct.sk();
          this.s5l_1.moveTo(x, y);
          break;
        case 1:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_2 = n;
          n = _unary__edvuaz_2 + 1 | 0;
          var tmp_0 = path.r36_1.c1(_unary__edvuaz_2);
          var _unary__edvuaz_3 = n;
          n = _unary__edvuaz_3 + 1 | 0;
          var destruct_0 = Vector2D.j21(tmp_0, path.r36_1.c1(_unary__edvuaz_3));
          var x_0 = destruct_0.rk();
          var y_0 = destruct_0.sk();
          this.s5l_1.lineTo(x_0, y_0);
          break;
        case 2:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_4 = n;
          n = _unary__edvuaz_4 + 1 | 0;
          var tmp_1 = path.r36_1.c1(_unary__edvuaz_4);
          var _unary__edvuaz_5 = n;
          n = _unary__edvuaz_5 + 1 | 0;
          var destruct_1 = Vector2D.j21(tmp_1, path.r36_1.c1(_unary__edvuaz_5));
          var _unary__edvuaz_6 = n;
          n = _unary__edvuaz_6 + 1 | 0;
          var tmp_2 = path.r36_1.c1(_unary__edvuaz_6);
          var _unary__edvuaz_7 = n;
          n = _unary__edvuaz_7 + 1 | 0;
          var destruct_2 = Vector2D.j21(tmp_2, path.r36_1.c1(_unary__edvuaz_7));
          var cx = destruct_1.rk();
          var cy = destruct_1.sk();
          var ax = destruct_2.rk();
          var ay = destruct_2.sk();
          this.s5l_1.quadraticCurveTo(cx, cy, ax, ay);
          break;
        case 3:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          var _unary__edvuaz_8 = n;
          n = _unary__edvuaz_8 + 1 | 0;
          var tmp_3 = path.r36_1.c1(_unary__edvuaz_8);
          var _unary__edvuaz_9 = n;
          n = _unary__edvuaz_9 + 1 | 0;
          var destruct_3 = Vector2D.j21(tmp_3, path.r36_1.c1(_unary__edvuaz_9));
          var _unary__edvuaz_10 = n;
          n = _unary__edvuaz_10 + 1 | 0;
          var tmp_4 = path.r36_1.c1(_unary__edvuaz_10);
          var _unary__edvuaz_11 = n;
          n = _unary__edvuaz_11 + 1 | 0;
          var destruct_4 = Vector2D.j21(tmp_4, path.r36_1.c1(_unary__edvuaz_11));
          var _unary__edvuaz_12 = n;
          n = _unary__edvuaz_12 + 1 | 0;
          var tmp_5 = path.r36_1.c1(_unary__edvuaz_12);
          var _unary__edvuaz_13 = n;
          n = _unary__edvuaz_13 + 1 | 0;
          var destruct_5 = Vector2D.j21(tmp_5, path.r36_1.c1(_unary__edvuaz_13));
          var cx1 = destruct_3.rk();
          var cy1 = destruct_3.sk();
          var cx2 = destruct_4.rk();
          var cy2 = destruct_4.sk();
          var ax_0 = destruct_5.rk();
          var ay_0 = destruct_5.sk();
          this.s5l_1.bezierCurveTo(cx1, cy1, cx2, cy2, ax_0, ay_0);
          break;
        case 4:
          // Inline function 'korlibs.image.format.CanvasContext2dRenderer.doVisit.<anonymous>' call

          this.s5l_1.closePath();
          break;
      }
    }
  }
  u5f(state, fill, winding) {
    if (state.d47_1.f1())
      return Unit_instance;
    $l$block: {
      // Inline function 'korlibs.image.format.CanvasContext2dRenderer.keep' call
      this.s5l_1.save();
      try {
        setState(this, state, fill, false);
        var clip = state.c47_1;
        if (!(clip == null)) {
          this.s5l_1.beginPath();
          this.b5m(clip);
          this.s5l_1.clip(this.c5m(winding == null ? clip.s36_1 : winding));
        }
        this.s5l_1.beginPath();
        this.b5m(state.d47_1);
        this.x5l(this.s5l_1, state.b47_1);
        if (fill) {
          transformPaint(this, state.l47_1);
          this.s5l_1.fill(this.c5m(winding == null ? state.d47_1.s36_1 : winding));
        } else {
          transformPaint(this, state.k47_1);
          var lineDash = state.t47_1;
          if (!(lineDash == null)) {
            this.s5l_1.lineDashOffset = state.u47_1;
            // Inline function 'kotlin.collections.toTypedArray' call
            // Inline function 'korlibs.datastructure.mapDouble' call
            // Inline function 'kotlin.also' call
            var this_0 = DoubleArrayList.q2f();
            // Inline function 'kotlin.contracts.contract' call
            // Inline function 'korlibs.datastructure.mapDouble.<anonymous>' call
            var _iterator__ex2g4s = lineDash.z();
            while (_iterator__ex2g4s.a1()) {
              var v = _iterator__ex2g4s.b1();
              // Inline function 'korlibs.image.format.CanvasContext2dRenderer.renderFinal.<anonymous>.<anonymous>' call
              this_0.g1y(v);
            }
            var tmp$ret$3 = copyToArray(this_0);
            this.s5l_1.setLineDash(tmp$ret$3);
          }
          this.s5l_1.stroke();
        }
        break $l$block;
      }finally {
        this.s5l_1.restore();
      }
    }
  }
  c5m(_this__u8e3s4) {
    var tmp;
    switch (_this__u8e3s4.m3_1) {
      case 1:
        // Inline function 'org.w3c.dom.NONZERO' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'nonzero';
        break;
      case 0:
        // Inline function 'org.w3c.dom.EVENODD' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'evenodd';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    return tmp;
  }
}
//endregion
function get_isLow(_this__u8e3s4) {
  return _this__u8e3s4.k2q() <= 0.25;
}
var GrowMethod_GROW_IMAGE_instance;
var GrowMethod_NEW_IMAGES_instance;
var GrowMethod_entriesInitialized;
function GrowMethod_initEntries() {
  if (GrowMethod_entriesInitialized)
    return Unit_instance;
  GrowMethod_entriesInitialized = true;
  GrowMethod_GROW_IMAGE_instance = new GrowMethod('GROW_IMAGE', 0);
  GrowMethod_NEW_IMAGES_instance = new GrowMethod('NEW_IMAGES', 1);
}
function reconstructWithSize($this, width, height) {
  var slices = toList($this.g3l_1);
  $this.y3k_1 = Companion_instance_0.f37(width, height);
  $this.e3l_1 = Bitmap32.z3l(width, height, VOID, $this.a3l_1);
  $this.f3l_1.j3();
  $this.f3l_1.f($this.e3l_1);
  $this.h3l_1.j3();
  $this.g3l_1.j3();
  var _iterator__ex2g4s = slices.z();
  while (_iterator__ex2g4s.a1()) {
    var entry = _iterator__ex2g4s.b1();
    $this.a3m(entry.w3k_1, entry.x3k_1, entry.w3k_1.r38_1);
  }
}
function growAtlas($this, bmp) {
  switch ($this.c3l_1.m3_1) {
    case 0:
      reconstructWithSize($this, imul($this.n2d(), 2), imul($this.o2d(), 2));
      break;
    case 1:
      if (bmp.w38_1 > $this.n2d() || bmp.x38_1 > $this.o2d()) {
        // Inline function 'kotlin.error' call
        var message = 'Atlas is too small (' + $this.n2d() + 'x' + $this.o2d() + ') to hold a slice of (' + bmp.w38_1 + 'x' + bmp.x38_1 + ')';
        throw IllegalStateException.w4(toString_0(message));
      }

      $this.y3k_1 = Companion_instance_0.f37($this.n2d(), $this.o2d());
      $this.e3l_1 = Bitmap32.z3l($this.n2d(), $this.o2d(), VOID, $this.a3l_1);
      $this.f3l_1.f($this.e3l_1);
      break;
    default:
      noWhenBranchMatchedException();
      break;
  }
}
function GrowMethod_NEW_IMAGES_getInstance() {
  GrowMethod_initEntries();
  return GrowMethod_NEW_IMAGES_instance;
}
function set_baseMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = baseMipmapLevel$delegate;
  var property = baseMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.vw_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_baseMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = baseMipmapLevel$delegate;
    var property = baseMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.uw();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.vw_1;
      tmp_0 = tmp0_safe_receiver.b3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.ww_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.vw_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.vw_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var baseMipmapLevel$delegate;
function set_maxMipmapLevel(_this__u8e3s4, _set____db54di) {
  _init_properties_Bitmap_kt__y1ku1b();
  var this_0 = maxMipmapLevel$delegate;
  var property = maxMipmapLevel$factory();
  var tmp0_elvis_lhs = this_0.vw_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_maxMipmapLevel(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = maxMipmapLevel$delegate;
    var property = maxMipmapLevel$factory_0();
    var tmp = _this__u8e3s4.uw();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.vw_1;
      tmp_0 = tmp0_safe_receiver.b3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.ww_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.vw_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.vw_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var maxMipmapLevel$delegate;
function Bitmap$tempInts$delegate$lambda(this$0) {
  return function () {
    return new Int32Array(imul(this$0.n2d(), 2));
  };
}
function readPixelsUnsafe(_this__u8e3s4, x, y, width, height) {
  _init_properties_Bitmap_kt__y1ku1b();
  var out = new Int32Array(imul(width, height));
  _this__u8e3s4.f3n(x, y, width, height, out, 0);
  return out;
}
function mipmaps(_this__u8e3s4, enable) {
  enable = enable === VOID ? true : enable;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.mipmaps.<anonymous>' call
  _this__u8e3s4.r3m_1 = enable;
  return _this__u8e3s4;
}
function NativeImageContext2d(width, height, antialiased, block) {
  antialiased = antialiased === VOID ? true : antialiased;
  _init_properties_Bitmap_kt__y1ku1b();
  // Inline function 'korlibs.image.bitmap.context2d' call
  var this_0 = NativeImage_0(width, height, true);
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = this_0.k3m_1;
  if (false) {
    this_0.l1o();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = this_0.c3u(antialiased);
    try {
      // Inline function 'korlibs.image.bitmap.NativeImageContext2d.<anonymous>' call
      block(ctx);
    }finally {
      ctx.p11();
    }
  }finally {
    result = false ? this_0.u3m(rect) : 0;
  }
  return this_0;
}
function asumePremultiplied(_this__u8e3s4) {
  _init_properties_Bitmap_kt__y1ku1b();
  _this__u8e3s4.y3m(true);
  _this__u8e3s4.n3m_1 = true;
  return _this__u8e3s4;
}
function baseMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function maxMipmapLevel$delegate$lambda() {
  _init_properties_Bitmap_kt__y1ku1b();
  return null;
}
function baseMipmapLevel$factory() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function baseMipmapLevel$factory_0() {
  return getPropertyCallableRef('baseMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_baseMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_baseMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function maxMipmapLevel$factory_0() {
  return getPropertyCallableRef('maxMipmapLevel', 1, KMutableProperty1, function (receiver) {
    return get_maxMipmapLevel(receiver);
  }, function (receiver, value) {
    return set_maxMipmapLevel(receiver, value);
  });
}
function tempInts$factory() {
  return getPropertyCallableRef('tempInts', 1, KProperty1, function (receiver) {
    return receiver.a3n();
  }, null);
}
var properties_initialized_Bitmap_kt_sxrn69;
function _init_properties_Bitmap_kt__y1ku1b() {
  if (!properties_initialized_Bitmap_kt_sxrn69) {
    properties_initialized_Bitmap_kt_sxrn69 = true;
    baseMipmapLevel$delegate = new Property(VOID, baseMipmapLevel$delegate$lambda);
    maxMipmapLevel$delegate = new Property(VOID, maxMipmapLevel$delegate$lambda);
  }
}
function *_generator_invoke__zhh2q8($this, $this$iterator, $completion) {
  var inductionVariable = 0;
  var last = $this.l3u_1.b2b();
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = $this$iterator.tk(new RGBA($this.l3u_1.m3u(n)), $completion);
      if (tmp === get_COROUTINE_SUSPENDED())
        tmp = yield tmp;
    }
     while (inductionVariable < last);
  return Unit_instance;
}
var Companion_instance_5;
function Companion_getInstance_16() {
  if (Companion_instance_5 === VOID)
    new Companion();
  return Companion_instance_5;
}
function Bitmap32$iterator$slambda_0(this$0) {
  var i = new Bitmap32$iterator$slambda(this$0);
  var l = function ($this$iterator, $completion) {
    return i.v3v($this$iterator, $completion);
  };
  l.$arity = 1;
  return l;
}
function isFullyTransparent(_this__u8e3s4) {
  var bmp = get_bmp(_this__u8e3s4);
  var data = _RgbaArray___init__impl__oib4y4(get_bmp(_this__u8e3s4).w3l_1);
  var width = _this__u8e3s4.l22() - _this__u8e3s4.k22() | 0;
  var inductionVariable = _this__u8e3s4.m22();
  var last = _this__u8e3s4.n22();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var index = bmp.d3n(_this__u8e3s4.k22(), y);
      // Inline function 'kotlin.check' call
      // Inline function 'kotlin.contracts.contract' call
      if (!(index >= 0 && index <= (_RgbaArray___get_size__impl__imxef8(data) - width | 0))) {
        // Inline function 'korlibs.image.bitmap.isFullyTransparent.<anonymous>' call
        var message = 'left=' + _this__u8e3s4.k22() + ', top=' + _this__u8e3s4.m22() + ', right=' + _this__u8e3s4.l22() + ', bottom=' + _this__u8e3s4.n22();
        throw IllegalStateException.w4(toString_0(message));
      }
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < width)
        do {
          var n = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          if (!(_RGBA___get_a__impl__6msvu7(RgbaArray__get_impl_nzyo1o(data, index + n | 0)) === 0))
            return false;
        }
         while (inductionVariable_0 < width);
    }
     while (inductionVariable < last);
  return true;
}
function expandBorder(_this__u8e3s4, area, border) {
  return expandBorder_0(_this__u8e3s4, area.m22(), area.k22(), area.n22(), area.l22(), border);
}
function expandBorder_0(_this__u8e3s4, areaTop, areaLeft, areaBottom, areaRight, border) {
  var data = _this__u8e3s4.w3l_1;
  var x0Index = _this__u8e3s4.d3n(areaLeft, areaTop);
  var x1Index = _this__u8e3s4.d3n(areaRight - 1 | 0, areaTop);
  var areaWidth = areaRight - areaLeft | 0;
  var areaHeight = areaBottom - areaTop | 0;
  var inductionVariable = 0;
  if (inductionVariable < areaHeight)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var x0Color = data[x0Index];
      var x1Color = data[x1Index];
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < border)
        do {
          var m = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          data[(x0Index - m | 0) - 1 | 0] = x0Color;
          data[(x1Index + m | 0) + 1 | 0] = x1Color;
        }
         while (inductionVariable_0 < border);
      x0Index = x0Index + _this__u8e3s4.n2d() | 0;
      x1Index = x1Index + _this__u8e3s4.n2d() | 0;
    }
     while (inductionVariable < areaHeight);
  var inductionVariable_1 = 0;
  if (inductionVariable_1 < border)
    do {
      var m_0 = inductionVariable_1;
      inductionVariable_1 = inductionVariable_1 + 1 | 0;
      var x = areaLeft - border | 0;
      var npixels = areaWidth + imul(border, 2) | 0;
      arraycopy(data, _this__u8e3s4.d3n(x, areaTop), data, _this__u8e3s4.d3n(x, (areaTop - m_0 | 0) - 1 | 0), npixels);
      arraycopy(data, _this__u8e3s4.d3n(x, areaBottom - 1 | 0), data, _this__u8e3s4.d3n(x, areaBottom + m_0 | 0), npixels);
    }
     while (inductionVariable_1 < border);
}
var Companion_instance_6;
function Companion_getInstance_17() {
  return Companion_instance_6;
}
var BitmapChannel_RED_instance;
var BitmapChannel_GREEN_instance;
var BitmapChannel_BLUE_instance;
var BitmapChannel_ALPHA_instance;
var Companion_instance_7;
function Companion_getInstance_18() {
  BitmapChannel_initEntries();
  if (Companion_instance_7 === VOID)
    new Companion_1();
  return Companion_instance_7;
}
function values() {
  return [BitmapChannel_RED_getInstance(), BitmapChannel_GREEN_getInstance(), BitmapChannel_BLUE_getInstance(), BitmapChannel_ALPHA_getInstance()];
}
var BitmapChannel_entriesInitialized;
function BitmapChannel_initEntries() {
  if (BitmapChannel_entriesInitialized)
    return Unit_instance;
  BitmapChannel_entriesInitialized = true;
  BitmapChannel_RED_instance = new BitmapChannel('RED', 0, 0);
  BitmapChannel_GREEN_instance = new BitmapChannel('GREEN', 1, 1);
  BitmapChannel_BLUE_instance = new BitmapChannel('BLUE', 2, 2);
  BitmapChannel_ALPHA_instance = new BitmapChannel('ALPHA', 3, 3);
  Companion_getInstance_18();
}
function BitmapChannel_RED_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_RED_instance;
}
function BitmapChannel_GREEN_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_GREEN_instance;
}
function BitmapChannel_BLUE_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_BLUE_instance;
}
function BitmapChannel_ALPHA_getInstance() {
  BitmapChannel_initEntries();
  return BitmapChannel_ALPHA_instance;
}
function get_bounds_0(_this__u8e3s4) {
  return _this__u8e3s4.o38_1;
}
function get_bmp(_this__u8e3s4) {
  return get_container(_this__u8e3s4);
}
function get_container(_this__u8e3s4) {
  return _this__u8e3s4.t2g();
}
function slice_0(_this__u8e3s4, bounds, name, orientation, padding) {
  bounds = bounds === VOID ? RectangleInt.j2a(0, 0, _this__u8e3s4.n2d(), _this__u8e3s4.o2d()) : bounds;
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_1().d38_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_4().q24_1 : padding;
  var left = clamp(bounds.k22(), 0, _this__u8e3s4.n2d());
  var top = clamp(bounds.m22(), 0, _this__u8e3s4.o2d());
  return new RectSlice(_this__u8e3s4, Companion_instance_1.r29(left, top, clamp(bounds.l22(), left, _this__u8e3s4.n2d()), clamp(bounds.n22(), top, _this__u8e3s4.o2d())), orientation, padding, name);
}
function extract_0(_this__u8e3s4) {
  var w = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.p38_1) ? _this__u8e3s4.o38_1.h2a_1 : _this__u8e3s4.o38_1.i2a_1;
  var h = !_SliceOrientation___get_isRotatedDeg90CwOrCcw__impl__98v1vq(_this__u8e3s4.p38_1) ? _this__u8e3s4.o38_1.i2a_1 : _this__u8e3s4.o38_1.h2a_1;
  var tmp = get_container(_this__u8e3s4).b3u(w + _this__u8e3s4.q38_1.y24() | 0, h + _this__u8e3s4.q38_1.z24() | 0);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  var raw = extractUntransformed(_this__u8e3s4).a3u(_this__u8e3s4.p38_1);
  raw.o3t(0, 0, out, _this__u8e3s4.q38_1.u24_1, _this__u8e3s4.q38_1.r24_1, raw.n2d(), raw.o2d());
  return out;
}
function sliceWithSize(_this__u8e3s4, x, y, width, height, name, orientation, padding) {
  name = name === VOID ? null : name;
  orientation = orientation === VOID ? Companion_getInstance_1().d38_1 : orientation;
  padding = padding === VOID ? Companion_getInstance_4().q24_1 : padding;
  return slice_0(_this__u8e3s4, RectangleInt.j2a(x, y, width, height), name, orientation, padding);
}
function extractUntransformed(_this__u8e3s4) {
  var tmp = get_container(_this__u8e3s4).b3u(_this__u8e3s4.o38_1.h2a_1, _this__u8e3s4.o38_1.i2a_1);
  var out = tmp instanceof Bitmap ? tmp : THROW_CCE();
  get_container(_this__u8e3s4).l3t(_this__u8e3s4.o38_1.f2a_1, _this__u8e3s4.o38_1.g2a_1, out, 0, 0, _this__u8e3s4.o38_1.h2a_1, _this__u8e3s4.o38_1.i2a_1);
  return out;
}
function get_Bitmaps_transparent() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_transparent;
}
var Bitmaps_transparent;
function get_Bitmaps_white() {
  _init_properties_Bitmaps_kt__92w93i();
  return Bitmaps_white;
}
var Bitmaps_white;
var Bitmaps_instance;
function Bitmaps_getInstance() {
  return Bitmaps_instance;
}
var properties_initialized_Bitmaps_kt_qcuk18;
function _init_properties_Bitmaps_kt__92w93i() {
  if (!properties_initialized_Bitmaps_kt_qcuk18) {
    properties_initialized_Bitmaps_kt_qcuk18 = true;
    Bitmaps_transparent = slice_0(Companion_getInstance_16().o3u(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().p3n_1)), VOID, 'transparent');
    Bitmaps_white = slice_0(Companion_getInstance_16().o3u(1, 1, _RGBA___get_premultiplied__impl__3bulqc(Colors_getInstance().k3n_1)), VOID, 'white');
  }
}
var Companion_instance_8;
function Companion_getInstance_19() {
  return Companion_instance_8;
}
function setFromBitmap$getAlpha(_this__u8e3s4, x, y, min) {
  return _this__u8e3s4.r3t(x, y) ? _RGBA___get_a__impl__6msvu7(_this__u8e3s4.g3n(x, y)) >= min : false;
}
function setFromBitmap$pass(this$0, x, y, dx, dy, d) {
  if (this$0.p3y(x + dx | 0, y + dy | 0) + d < this$0.p3y(x, y)) {
    this$0.l3y(x, y, x + dx | 0, y + dy | 0);
    // Inline function 'kotlin.math.hypot' call
    var x_0 = x - this$0.m3y(x, y) | 0;
    var y_0 = y - this$0.n3y(x, y) | 0;
    var tmp$ret$0 = hypot(x_0, y_0);
    this$0.o3y(x, y, tmp$ret$0);
  }
}
function distanceMap(_this__u8e3s4, out, thresold) {
  out = out === VOID ? new DistanceBitmap(_this__u8e3s4.n2d(), _this__u8e3s4.o2d()) : out;
  thresold = thresold === VOID ? 0.5 : thresold;
  // Inline function 'kotlin.also' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.distanceMap.<anonymous>' call
  out.r3y(_this__u8e3s4, thresold);
  return out;
}
function index4($this, x, y) {
  return imul($this.d3n(x, y), 4);
}
function NativeImageOrBitmap32(width, height, native, premultiplied) {
  native = native === VOID ? true : native;
  premultiplied = premultiplied === VOID ? null : premultiplied;
  var tmp;
  if (native) {
    tmp = NativeImage_0(width, height, premultiplied);
  } else {
    tmp = Bitmap32.z3l(width, height, VOID, premultiplied == null ? true : premultiplied);
  }
  return tmp;
}
function ensureNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof NativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = get_nativeImageFormatProvider().l40(_this__u8e3s4);
  }
  return tmp;
}
function NativeImage_0(width, height, premultiplied) {
  premultiplied = premultiplied === VOID ? null : premultiplied;
  return get_nativeImageFormatProvider().m40(width, height, premultiplied);
}
var Companion_instance_9;
function Companion_getInstance_20() {
  return Companion_instance_9;
}
function NinePatchInfo$Segment$bmp$delegate$lambda(this$0) {
  return function () {
    var tmp21_safe_receiver = this$0.q41_1;
    return tmp21_safe_receiver == null ? null : extract_0(tmp21_safe_receiver);
  };
}
function get_length(_this__u8e3s4) {
  return (_this__u8e3s4.d2_1 - _this__u8e3s4.c2_1 | 0) + 1 | 0;
}
function asNinePatchSimple(_this__u8e3s4, left, top, right, bottom) {
  return Companion_instance_9.o40(_this__u8e3s4, left, top, right, bottom);
}
function applyEffect(_this__u8e3s4, effect) {
  var safeBorder = get_safeBorder(effect);
  var out = Companion_getInstance_16().p3u(_this__u8e3s4.n2d() + imul(safeBorder, 2) | 0, _this__u8e3s4.o2d() + imul(safeBorder, 2) | 0, _this__u8e3s4.z3m());
  out.k3w(_this__u8e3s4, safeBorder, safeBorder);
  applyEffectInline(out, effect);
  return out;
}
function get_safeBorder(_this__u8e3s4) {
  var tmp0_elvis_lhs = _this__u8e3s4 == null ? null : _this__u8e3s4.a43();
  return tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
}
function applyEffectInline(_this__u8e3s4, effect) {
  if (effect == null)
    return Unit_instance;
  if (!(effect.t42_1 === 0)) {
    blurInplace(_this__u8e3s4, effect.t42_1);
  }
  if (!(effect.w42_1 === 0) || !(effect.u42_1 === 0) || !(effect.v42_1 === 0)) {
    dropShadowInplace(_this__u8e3s4, effect.u42_1, effect.v42_1, effect.w42_1, effect.x42_1);
  }
  if (!(effect.y42_1 === 0)) {
    borderInline(_this__u8e3s4, effect.y42_1, effect.z42_1);
  }
}
function blurInplace(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.n2d() / 2 | 0) - 1 | 0), (_this__u8e3s4.o2d() / 2 | 0) - 1 | 0);
  var t1 = Bitmap8.l3x(_this__u8e3s4.n2d(), _this__u8e3s4.o2d());
  var t2 = Bitmap8.l3x(_this__u8e3s4.n2d(), _this__u8e3s4.o2d());
  var inductionVariable = 0;
  if (inductionVariable < 4)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var channel = Companion_getInstance_18().c1(n);
      _this__u8e3s4.p3w(channel, t1);
      arraycopy_0(t1.s3v(), 0, t2.s3v(), 0, t2.b2b());
      gaussBlur(t1.s3v(), t2.s3v(), _this__u8e3s4.n2d(), _this__u8e3s4.o2d(), r_0);
      _this__u8e3s4.o3w(channel, t2);
    }
     while (inductionVariable < 4);
}
function gaussBlur(scl, tcl, w, h, r) {
  var a = 0;
  var b = 0;
  var c = 0;
  // Inline function 'korlibs.image.bitmap.effect.boxesForGaussN3' call
  var n = 3;
  // Inline function 'kotlin.math.sqrt' call
  var x = 12.0 * r * r / n + 1;
  var wIdeal = Math.sqrt(x);
  var wl = toIntFloor_0(wIdeal);
  if ((wl % 2 | 0) === 0) {
    wl = wl - 1 | 0;
  }
  var wu = wl + 2 | 0;
  var mIdeal = (12.0 * r * r - imul(imul(n, wl), wl) - imul(imul(4, n), wl) - imul(3, n)) / (imul(-4, wl) - 4 | 0);
  var m = round(mIdeal);
  // Inline function 'korlibs.image.bitmap.effect.gaussBlur.<anonymous>' call
  a = 0 < m ? wl : wu;
  b = 1 < m ? wl : wu;
  c = 2 < m ? wl : wu;
  boxBlur(scl, tcl, w, h, (a - 1 | 0) / 2 | 0);
  boxBlur(tcl, scl, w, h, (b - 1 | 0) / 2 | 0);
  boxBlur(scl, tcl, w, h, (c - 1 | 0) / 2 | 0);
}
function boxBlur(scl, tcl, w, h, r) {
  arraycopy_0(scl, 0, tcl, 0, scl.length);
  boxBlurH(tcl, scl, w, h, r);
  boxBlurT(scl, tcl, w, h, r);
}
function boxBlurH(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < h)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = imul(i, w);
      var li = ti;
      var ri = ti + r | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, (ti + w | 0) - 1 | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + j | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var tmp = v;
          var _unary__edvuaz = ri;
          ri = _unary__edvuaz + 1 | 0;
          v = tmp + (getU8(scl, _unary__edvuaz) - fv | 0) | 0;
          var _unary__edvuaz_0 = ti;
          ti = _unary__edvuaz_0 + 1 | 0;
          tcl[_unary__edvuaz_0] = toByte(v / arr | 0);
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = w - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          var tmp_0 = v;
          var _unary__edvuaz_1 = ri;
          ri = _unary__edvuaz_1 + 1 | 0;
          var tmp_1 = getU8(scl, _unary__edvuaz_1);
          var _unary__edvuaz_2 = li;
          li = _unary__edvuaz_2 + 1 | 0;
          v = tmp_0 + (tmp_1 - getU8(scl, _unary__edvuaz_2) | 0) | 0;
          var _unary__edvuaz_3 = ti;
          ti = _unary__edvuaz_3 + 1 | 0;
          tcl[_unary__edvuaz_3] = toByte(v / arr | 0);
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = w - r | 0;
      if (inductionVariable_3 < w)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          var tmp_2 = v;
          var _unary__edvuaz_4 = li;
          li = _unary__edvuaz_4 + 1 | 0;
          v = tmp_2 + (lv - getU8(scl, _unary__edvuaz_4) | 0) | 0;
          var _unary__edvuaz_5 = ti;
          ti = _unary__edvuaz_5 + 1 | 0;
          tcl[_unary__edvuaz_5] = toByte(v / arr | 0);
        }
         while (inductionVariable_3 < w);
    }
     while (inductionVariable < h);
}
function boxBlurT(scl, tcl, w, h, r) {
  var arr = (r + r | 0) + 1 | 0;
  var inductionVariable = 0;
  if (inductionVariable < w)
    do {
      var i = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var ti = i;
      var li = ti;
      var ri = ti + imul(r, w) | 0;
      var fv = getU8(scl, ti);
      var lv = getU8(scl, ti + imul(w, h - 1 | 0) | 0);
      var v = imul(r + 1 | 0, fv);
      var inductionVariable_0 = 0;
      if (inductionVariable_0 < r)
        do {
          var j = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          v = v + getU8(scl, ti + imul(j, w) | 0) | 0;
        }
         while (inductionVariable_0 < r);
      var inductionVariable_1 = 0;
      if (inductionVariable_1 <= r)
        do {
          var j_0 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          v = v + (getU8(scl, ri) - fv | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (!(j_0 === r));
      var inductionVariable_2 = r + 1 | 0;
      var last = h - r | 0;
      if (inductionVariable_2 < last)
        do {
          var j_1 = inductionVariable_2;
          inductionVariable_2 = inductionVariable_2 + 1 | 0;
          v = v + (getU8(scl, ri) - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ri = ri + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_2 < last);
      var inductionVariable_3 = h - r | 0;
      if (inductionVariable_3 < h)
        do {
          var j_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          v = v + (lv - getU8(scl, li) | 0) | 0;
          tcl[ti] = toByte(v / arr | 0);
          li = li + w | 0;
          ti = ti + w | 0;
        }
         while (inductionVariable_3 < h);
    }
     while (inductionVariable < w);
}
function blur(_this__u8e3s4, r) {
  var out = Bitmap8.l3x(_this__u8e3s4.n2d() + imul(r, 2) | 0, _this__u8e3s4.o2d() + imul(r, 2) | 0);
  Companion_instance_6.s3x(_this__u8e3s4, 0, 0, out, r, r, _this__u8e3s4.n2d(), _this__u8e3s4.o2d());
  blurInplace_0(out, r);
  return out;
}
function blurInplace_0(_this__u8e3s4, r) {
  var r_0 = coerceAtMost(coerceAtMost(r, (_this__u8e3s4.n2d() / 2 | 0) - 1 | 0), (_this__u8e3s4.o2d() / 2 | 0) - 1 | 0);
  var t2 = Bitmap8.l3x(_this__u8e3s4.n2d(), _this__u8e3s4.o2d());
  arraycopy_0(_this__u8e3s4.s3v(), 0, t2.s3v(), 0, _this__u8e3s4.b2b());
  gaussBlur(t2.s3v(), _this__u8e3s4.s3v(), _this__u8e3s4.n2d(), _this__u8e3s4.o2d(), r_0);
}
function borderInline(_this__u8e3s4, r, color) {
  color = color === VOID ? Colors_getInstance().l3n_1 : color;
  var out = _this__u8e3s4;
  var distance = distanceMap(out);
  var inductionVariable = 0;
  var last = out.o2d();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = out.n2d();
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          var dist = distance.p3y(x, y);
          if (dist < (r + 1 | 0)) {
            var alpha = dist >= r ? 1.0 - dist % 1.0 : 1.0;
            var rcolor = alpha === 1.0 ? color : RGBA__withAf_impl_dpdu32(color, _RGBA___get_af__impl__vu36qv(color) * alpha);
            out.x3v(x, y, Companion_getInstance_23().b43(rcolor, out.z3v(x, y)));
          }
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
}
function dropShadowInplace(_this__u8e3s4, x, y, r, color) {
  color = color === VOID ? Colors_getInstance().l3n_1 : color;
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>' call
  var copy = _this__u8e3s4.qw();
  var pcolor = _RGBA___get_premultiplied__impl__3bulqc(color);
  // Inline function 'kotlin.also' call
  var this_0 = blur(_this__u8e3s4.q3w(BitmapChannel_ALPHA_getInstance()), r);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.bitmap.effect.dropShadowInplace.<anonymous>.<anonymous>' call
  this_0.y3m(true);
  var inductionVariable = 0;
  if (inductionVariable < 256)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaArray__set_impl_epw2wg(this_0.m3v_1, n, Companion_getInstance_23().c43(imul(_RGBAPremultiplied___get_r__impl__m8nz5i(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_g__impl__fv131x(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_b__impl__dt4tp6(pcolor), n) / 255 | 0, imul(_RGBAPremultiplied___get_a__impl__f0hnd1(pcolor), n) / 255 | 0));
    }
     while (inductionVariable < 256);
  var shadow = this_0.s3m();
  _this__u8e3s4.i3w(Colors_getInstance().p3n_1);
  _this__u8e3s4.l3w(shadow, x - r | 0, y - r | 0);
  _this__u8e3s4.l3w(copy, 0, 0);
  return _this__u8e3s4;
}
var NewSDF_instance;
function NewSDF_getInstance() {
  return NewSDF_instance;
}
function decode(_this__u8e3s4, data, dataOffset, out, outOffset, size, littleEndian) {
  littleEndian = littleEndian === VOID ? true : littleEndian;
  var tmp;
  switch (_this__u8e3s4.x3m()) {
    case 16:
      var tmp_0;
      if (littleEndian) {
        tmp_0 = getU16LE$ref();
      } else {
        tmp_0 = getU16BE$ref();
      }

      tmp = tmp_0;
      break;
    case 24:
      var tmp_1;
      if (littleEndian) {
        tmp_1 = getU24LE$ref();
      } else {
        tmp_1 = getU24BE$ref();
      }

      tmp = tmp_1;
      break;
    case 32:
      var tmp_2;
      if (littleEndian) {
        tmp_2 = getS32LE$ref();
      } else {
        tmp_2 = getS32BE$ref();
      }

      tmp = tmp_2;
      break;
    default:
      throw IllegalArgumentException.l('Unsupported bpp ' + _this__u8e3s4.x3m());
  }
  var readFunc = tmp;
  // Inline function 'korlibs.image.color.decodeInternal' call
  var io = dataOffset;
  var oo = outOffset;
  var bytesPerPixel = get_bytesPerPixel(_this__u8e3s4);
  var outdata = out;
  var Bpp = numberToInt(bytesPerPixel);
  var inductionVariable = 0;
  if (inductionVariable < size)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var c = readFunc(data, io);
      io = io + Bpp | 0;
      var _unary__edvuaz = oo;
      oo = _unary__edvuaz + 1 | 0;
      RgbaArray__set_impl_epw2wg(outdata, _unary__edvuaz, Companion_getInstance_23().c43(_this__u8e3s4.m43(c), _this__u8e3s4.n43(c), _this__u8e3s4.o43(c), _this__u8e3s4.p43(c)));
    }
     while (inductionVariable < size);
}
function get_bytesPerPixel(_this__u8e3s4) {
  return _this__u8e3s4.x3m() / 8;
}
function getU16LE$ref() {
  var l = function (p0, p1) {
    return getU16LE(p0, p1);
  };
  l.callableName = 'getU16LE';
  return l;
}
function getU16BE$ref() {
  var l = function (p0, p1) {
    return getU16BE(p0, p1);
  };
  l.callableName = 'getU16BE';
  return l;
}
function getU24LE$ref() {
  var l = function (p0, p1) {
    return getU24LE(p0, p1);
  };
  l.callableName = 'getU24LE';
  return l;
}
function getU24BE$ref() {
  var l = function (p0, p1) {
    return getU24BE(p0, p1);
  };
  l.callableName = 'getU24BE';
  return l;
}
function getS32LE$ref() {
  var l = function (p0, p1) {
    return getS32LE(p0, p1);
  };
  l.callableName = 'getS32LE';
  return l;
}
function getS32BE$ref() {
  var l = function (p0, p1) {
    return getS32BE(p0, p1);
  };
  l.callableName = 'getS32BE';
  return l;
}
var Colors_instance;
function Colors_getInstance() {
  if (Colors_instance === VOID)
    new Colors();
  return Colors_instance;
}
var Companion_instance_10;
function Companion_getInstance_21() {
  if (Companion_instance_10 === VOID)
    new Companion_4();
  return Companion_instance_10;
}
function _RgbaArray___init__impl__oib4y4(ints) {
  return ints;
}
function _RgbaArray___get_ints__impl__u2kps1($this) {
  return $this;
}
var Companion_instance_11;
function Companion_getInstance_22() {
  return Companion_instance_11;
}
function RgbaArray__subList_impl_rbyi98($this, fromIndex, toIndex) {
  return new GenericSubList(new RgbaArray($this), fromIndex, toIndex);
}
function RgbaArray__contains_impl_ofn00n($this, element) {
  return contains(_RgbaArray___get_ints__impl__u2kps1($this), _RGBA___get_value__impl__hhco8v(element));
}
function RgbaArray__containsAll_impl_l6gz5c($this, elements) {
  var tmp$ret$0;
  $l$block_0: {
    // Inline function 'kotlin.collections.all' call
    var tmp;
    if (isInterface(elements, Collection)) {
      tmp = elements.f1();
    } else {
      tmp = false;
    }
    if (tmp) {
      tmp$ret$0 = true;
      break $l$block_0;
    }
    var tmp0_iterator = elements.z();
    while (tmp0_iterator.a1()) {
      var element = tmp0_iterator.b1();
      // Inline function 'korlibs.image.color.RgbaArray.containsAll.<anonymous>' call
      var it = element.l44_1;
      if (!RgbaArray__contains_impl_ofn00n($this, it)) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
    }
    tmp$ret$0 = true;
  }
  return tmp$ret$0;
}
function RgbaArray__containsAll_impl_l6gz5c_0($this, elements) {
  return RgbaArray__containsAll_impl_l6gz5c($this.r44_1, elements);
}
function RgbaArray__isEmpty_impl_nch3ip($this) {
  // Inline function 'kotlin.collections.isEmpty' call
  return _RgbaArray___get_ints__impl__u2kps1($this).length === 0;
}
function RgbaArray__iterator_impl_5wfwsm($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0($this) {
  return RgbaArray__listIterator_impl_m4kjt0_0($this, 0);
}
function RgbaArray__listIterator_impl_m4kjt0_0($this, index) {
  return new GenericListIterator(new RgbaArray($this), index);
}
function _RgbaArray___get_size__impl__imxef8($this) {
  return _RgbaArray___get_ints__impl__u2kps1($this).length;
}
function RgbaArray__get_impl_nzyo1o($this, index) {
  return _RGBA___init__impl__lqpay5(_RgbaArray___get_ints__impl__u2kps1($this)[index]);
}
function RgbaArray__get_impl_nzyo1o_0($this, index) {
  return new RGBA(RgbaArray__get_impl_nzyo1o($this.r44_1, index));
}
function RgbaArray__set_impl_epw2wg($this, index, color) {
  _RgbaArray___get_ints__impl__u2kps1($this)[index] = _RGBA___get_value__impl__hhco8v(color);
}
function RgbaArray__toString_impl_vgvk04($this) {
  return 'RgbaArray(' + _RgbaArray___get_size__impl__imxef8($this) + ')';
}
function RgbaArray__hashCode_impl_ht2l65($this) {
  return hashCode($this);
}
function RgbaArray__equals_impl_6qvuf($this, other) {
  if (!(other instanceof RgbaArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaArray ? other.r44_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function blendComponent($this, c1, c2, factor) {
  return numberToInt(c1 * (1.0 - Ratio__toFloat_impl_1ftup5(factor)) + c2 * Ratio__toFloat_impl_1ftup5(factor)) & 255;
}
function _RGBA___init__impl__lqpay5(value) {
  return value;
}
function _RGBA___get_value__impl__hhco8v($this) {
  return $this;
}
function RGBA__clone_impl_w007z0($this) {
  return new RGBA($this);
}
function _RGBA___get_color__impl__8x3sb3($this) {
  return $this;
}
function _RGBA___get_r__impl__duz7mo($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 0 | 0) & 255;
}
function _RGBA___get_g__impl__o8pukr($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 8 | 0) & 255;
}
function _RGBA___get_b__impl__m6tl80($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 16 | 0) & 255;
}
function _RGBA___get_a__impl__6msvu7($this) {
  // Inline function 'korlibs.memory.extract8' call
  return (_RGBA___get_value__impl__hhco8v($this) >>> 24 | 0) & 255;
}
function _RGBA___get_rf__impl__kvz75k($this) {
  return _RGBA___get_r__impl__duz7mo($this) / 255.0;
}
function _RGBA___get_gf__impl__5gcu1f($this) {
  return _RGBA___get_g__impl__o8pukr($this) / 255.0;
}
function _RGBA___get_bf__impl__1xz5yg($this) {
  return _RGBA___get_b__impl__m6tl80($this) / 255.0;
}
function _RGBA___get_af__impl__vu36qv($this) {
  return _RGBA___get_a__impl__6msvu7($this) / 255.0;
}
function _RGBA___get_rgb__impl__tijaqt($this) {
  return _RGBA___get_value__impl__hhco8v($this) & 16777215;
}
function RGBA__withA_impl_vogscm($this, v) {
  return _RGBA___init__impl__lqpay5(_RGBA___get_value__impl__hhco8v($this) & 16777215 | clampUByte(v) << 24);
}
function RGBA__withAf_impl_dpdu32($this, v) {
  return RGBA__withA_impl_vogscm($this, f2i(v));
}
function RGBA__concatAd_impl_gwhfm($this, v) {
  return RGBA__withA_impl_vogscm($this, numberToInt(_RGBA___get_a__impl__6msvu7($this) * v));
}
function _RGBA___get_hexString__impl__kocngm($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.h();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexString>.<anonymous>' call
  this_0.ob(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  appendHexByte(this_0, _RGBA___get_a__impl__6msvu7($this));
  return this_0.toString();
}
function _RGBA___get_hexStringNoAlpha__impl__j315et($this) {
  // Inline function 'kotlin.text.buildString' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.apply' call
  var this_0 = StringBuilder.h();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.color.RGBA.<get-hexStringNoAlpha>.<anonymous>' call
  this_0.ob(_Char___init__impl__6a9atx(35));
  appendHexByte(this_0, _RGBA___get_r__impl__duz7mo($this));
  appendHexByte(this_0, _RGBA___get_g__impl__o8pukr($this));
  appendHexByte(this_0, _RGBA___get_b__impl__m6tl80($this));
  return this_0.toString();
}
function _RGBA___get_htmlColor__impl__bzw5k6($this) {
  return 'rgba(' + _RGBA___get_r__impl__duz7mo($this) + ', ' + _RGBA___get_g__impl__o8pukr($this) + ', ' + _RGBA___get_b__impl__m6tl80($this) + ', ' + get_niceStr(_RGBA___get_af__impl__vu36qv($this)) + ')';
}
function _RGBA___get_htmlStringSimple__impl__l4nu0u($this) {
  return _RGBA___get_hexStringNoAlpha__impl__j315et($this);
}
function RGBA__toString_impl_4lw6dp($this) {
  return _RGBA___get_hexString__impl__kocngm($this);
}
function RGBA__compareTo_impl_lrfjc1($this, other) {
  return compareTo(_RGBA___get_value__impl__hhco8v($this), _RGBA___get_value__impl__hhco8v(other));
}
function RGBA__compareTo_impl_lrfjc1_0($this, other) {
  return RGBA__compareTo_impl_lrfjc1($this.l44_1, other instanceof RGBA ? other.l44_1 : THROW_CCE());
}
function RGBA__premultipliedValue_impl_oja55q($this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc($this)) : _RGBA___get_value__impl__hhco8v($this);
}
function _RGBA___get_premultiplied__impl__3bulqc($this) {
  return _RGBA___get_premultipliedFast__impl__qiau4g($this);
}
function _RGBA___get_premultipliedFast__impl__qiau4g($this) {
  var A = _RGBA___get_a__impl__6msvu7($this) + 1 | 0;
  if (A >= 255)
    return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this));
  if (A <= 1)
    return _RGBAPremultiplied___init__impl__uos02x(0);
  var RB = (imul(_RGBA___get_value__impl__hhco8v($this) & 16711935, A) >>> 8 | 0) & 16711935;
  var G = (imul(_RGBA___get_value__impl__hhco8v($this) & 65280, A) >>> 8 | 0) & 65280;
  return _RGBAPremultiplied___init__impl__uos02x(_RGBA___get_value__impl__hhco8v($this) & -16777216 | RB | G);
}
var Companion_instance_12;
function Companion_getInstance_23() {
  if (Companion_instance_12 === VOID)
    new Companion_6();
  return Companion_instance_12;
}
function RGBA__hashCode_impl_h59qf6($this) {
  return $this;
}
function RGBA__equals_impl_4vjmca($this, other) {
  if (!(other instanceof RGBA))
    return false;
  if (!($this === (other instanceof RGBA ? other.l44_1 : THROW_CCE())))
    return false;
  return true;
}
function _RGBAPremultiplied___init__impl__uos02x(value) {
  return value;
}
function _RGBAPremultiplied___get_value__impl__bqfhud($this) {
  return $this;
}
function _RGBAPremultiplied___init__impl__uos02x_0(r, g, b, a) {
  return _RGBAPremultiplied___init__impl__uos02x(packIntClamped(r, g, b, a));
}
function _RGBAPremultiplied___get_r__impl__m8nz5i($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 0 | 0) & 255;
}
function _RGBAPremultiplied___get_g__impl__fv131x($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 8 | 0) & 255;
}
function _RGBAPremultiplied___get_b__impl__dt4tp6($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 16 | 0) & 255;
}
function _RGBAPremultiplied___get_a__impl__f0hnd1($this) {
  return (_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0) & 255;
}
function _RGBAPremultiplied___get_rf__impl__pt0c4y($this) {
  return _RGBAPremultiplied___get_r__impl__m8nz5i($this) / 255.0;
}
function _RGBAPremultiplied___get_gf__impl__ivron7($this) {
  return _RGBAPremultiplied___get_g__impl__fv131x($this) / 255.0;
}
function _RGBAPremultiplied___get_bf__impl__qa3on2($this) {
  return _RGBAPremultiplied___get_b__impl__dt4tp6($this) / 255.0;
}
function _RGBAPremultiplied___get_af__impl__euwcjn($this) {
  return _RGBAPremultiplied___get_a__impl__f0hnd1($this) / 255.0;
}
function _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv($this) {
  var alpha = _RGBAPremultiplied___get_a__impl__f0hnd1($this);
  var tmp;
  if (alpha === 0) {
    tmp = Colors_getInstance().p3n_1;
  } else {
    var ialpha = 255.0 / alpha;
    tmp = Companion_getInstance_23().c43(numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i($this) * ialpha), numberToInt(_RGBAPremultiplied___get_g__impl__fv131x($this) * ialpha), numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6($this) * ialpha), alpha);
  }
  return tmp;
}
function RGBAPremultiplied__scaled256_impl_hjm9ii($this, s) {
  var rb = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 16711935, s) >>> 8 | 0) & 16711935;
  var g = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) & 65280, s) >>> 8 | 0) & 65280;
  var a = (imul(_RGBAPremultiplied___get_value__impl__bqfhud($this) >>> 24 | 0, s) >>> 8 | 0) << 24;
  return _RGBAPremultiplied___init__impl__uos02x(rb | g | a);
}
function RGBAPremultiplied__scaled_impl_qz7lg1($this, alpha) {
  return RGBAPremultiplied__scaled256_impl_hjm9ii($this, numberToInt(clamp01_0(alpha) * 256));
}
var Companion_instance_13;
function Companion_getInstance_24() {
  return Companion_instance_13;
}
function mix(_this__u8e3s4, src) {
  var dst = _this__u8e3s4;
  var srcAf = _RGBAPremultiplied___get_af__impl__euwcjn(src);
  var oneMSrcAf = 1.0 - srcAf;
  var outA = numberToInt(_RGBAPremultiplied___get_a__impl__f0hnd1(src) + _RGBAPremultiplied___get_a__impl__f0hnd1(dst) * oneMSrcAf);
  var outR = numberToInt(_RGBAPremultiplied___get_r__impl__m8nz5i(src) + _RGBAPremultiplied___get_r__impl__m8nz5i(dst) * oneMSrcAf);
  var outG = numberToInt(_RGBAPremultiplied___get_g__impl__fv131x(src) + _RGBAPremultiplied___get_g__impl__fv131x(dst) * oneMSrcAf);
  var outB = numberToInt(_RGBAPremultiplied___get_b__impl__dt4tp6(src) + _RGBAPremultiplied___get_b__impl__dt4tp6(dst) * oneMSrcAf);
  return _RGBAPremultiplied___init__impl__uos02x_0(outR, outG, outB, outA);
}
function _RgbaPremultipliedArray___init__impl__lx83hy(ints) {
  return ints;
}
function _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this) {
  return $this;
}
var Companion_instance_14;
function Companion_getInstance_25() {
  return Companion_instance_14;
}
function _RgbaPremultipliedArray___get_size__impl__6lte0e($this) {
  return _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this).length;
}
function RgbaPremultipliedArray__get_impl_1u69ta($this, index) {
  return _RGBAPremultiplied___init__impl__uos02x(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index]);
}
function RgbaPremultipliedArray__set_impl_7fwbby($this, index, color) {
  _RgbaPremultipliedArray___get_ints__impl__i1gpd7($this)[index] = _RGBAPremultiplied___get_value__impl__bqfhud(color);
}
function RgbaPremultipliedArray__fill_impl_sem38t($this, value, start, end) {
  return fill(_RgbaPremultipliedArray___get_ints__impl__i1gpd7($this), _RGBAPremultiplied___get_value__impl__bqfhud(value), start, end);
}
function RgbaPremultipliedArray__toString_impl_seal6e($this) {
  return 'RgbaPremultipliedArray(' + _RgbaPremultipliedArray___get_size__impl__6lte0e($this) + ')';
}
function RgbaPremultipliedArray__hashCode_impl_kvnjzv($this) {
  return hashCode($this);
}
function RgbaPremultipliedArray__equals_impl_vav5d5($this, other) {
  if (!(other instanceof RgbaPremultipliedArray))
    return false;
  var tmp0_other_with_cast = other instanceof RgbaPremultipliedArray ? other.g45_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function scale(color, colorOffset, alpha, alphaOffset, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    $l$loop: do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var a = clamp01_0(alpha[alphaOffset + n | 0]);
      if (a === 1.0)
        continue $l$loop;
      RgbaPremultipliedArray__set_impl_7fwbby(color, colorOffset + n | 0, RGBAPremultiplied__scaled_impl_qz7lg1(RgbaPremultipliedArray__get_impl_1u69ta(color, colorOffset + n | 0), a));
    }
     while (inductionVariable < count);
}
function premultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      RgbaPremultipliedArray__set_impl_7fwbby(dst, dstN + n | 0, _RGBA___get_premultiplied__impl__3bulqc(RgbaArray__get_impl_nzyo1o(src, srcN + n | 0)));
    }
     while (inductionVariable < count);
}
function depremultiply(src, srcN, dst, dstN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var this_0 = RgbaPremultipliedArray__get_impl_1u69ta(src, srcN + n | 0);
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(this_0);
      RgbaArray__set_impl_epw2wg(dst, tmp, tmp$ret$0);
    }
     while (inductionVariable < count);
}
function mix_0(dst, dstX, src, srcX, count) {
  return mix_1(dst, dstX, dst, dstX, src, srcX, count);
}
function mix_1(tgt, tgtX, dst, dstX, src, srcX, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var srcC = RgbaPremultipliedArray__get_impl_1u69ta(src, srcX + n | 0);
      RgbaPremultipliedArray__set_impl_7fwbby(tgt, tgtX + n | 0, _RGBAPremultiplied___get_a__impl__f0hnd1(srcC) === 255 ? srcC : Companion_instance_13.e45(RgbaPremultipliedArray__get_impl_1u69ta(dst, dstX + n | 0), srcC));
    }
     while (inductionVariable < count);
}
function _RGBAf___init__impl__idjpgn(data) {
  return data;
}
function _RGBAf___get_data__impl__yt2t4($this) {
  return $this;
}
function _RGBAf___init__impl__idjpgn_0(r, g, b, a) {
  r = r === VOID ? 1.0 : r;
  g = g === VOID ? 1.0 : g;
  b = b === VOID ? 1.0 : b;
  a = a === VOID ? 1.0 : a;
  // Inline function 'kotlin.floatArrayOf' call
  var tmp$ret$0 = new Float32Array([r, g, b, a]);
  return _RGBAf___init__impl__idjpgn(tmp$ret$0);
}
function _RGBAf___set_r__impl__pz5j5e($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[0] = v;
}
function _RGBAf___get_r__impl__jfq8gq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[0];
}
function _RGBAf___set_g__impl__c4jj21($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[1] = v;
}
function _RGBAf___get_g__impl__dhoraz($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[1];
}
function _RGBAf___set_b__impl__a2n9pa($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[2] = v;
}
function _RGBAf___get_b__impl__fjl0nq($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[2];
}
function _RGBAf___set_a__impl__iqz7cx($this, v) {
  _RGBAf___get_data__impl__yt2t4($this)[3] = v;
}
function _RGBAf___get_a__impl__qnwk97($this) {
  return _RGBAf___get_data__impl__yt2t4($this)[3];
}
var Companion_instance_15;
function Companion_getInstance_26() {
  return Companion_instance_15;
}
function BitmapFont$Glyph$bmp$delegate$lambda(this$0) {
  return function () {
    return extract_0(this$0.k45_1).s3m();
  };
}
var Companion_instance_16;
function Companion_getInstance_27() {
  return Companion_instance_16;
}
function BitmapFontImpl$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var ascent = this$0.g48_1;
    var baseline = 0.0;
    var tmp = -this$0.l48_1;
    var tmp_0 = -this$0.l48_1;
    // Inline function 'kotlin.run' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.BitmapFontImpl.naturalFontMetrics$delegate.<anonymous>.<anonymous>' call
    var width = 0.0;
    var _iterator__ex2g4s = this$0.h48_1.k3().z();
    while (_iterator__ex2g4s.a1()) {
      var glyph = _iterator__ex2g4s.b1();
      if (!(glyph == null)) {
        // Inline function 'kotlin.math.max' call
        var a = width;
        var b = glyph.k45_1.w38_1;
        width = Math.max(a, b);
      }
    }
    var tmp$ret$2 = width;
    return new FontMetrics(this$0.e48_1, ascent, ascent, baseline, tmp, tmp_0, 0.0, tmp$ret$2);
  };
}
function BitmapFontImpl$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.h48_1.c1(this$0.h48_1.c3().z().b1());
    return tmp0_elvis_lhs == null ? this$0.q48() : tmp0_elvis_lhs;
  };
}
function BitmapFontImpl$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.e48_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function *_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  var fntFile = _this__u8e3s4;
  // Inline function 'kotlin.text.trim' call
  var tmp = fntFile.r1s(VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var this_0 = tmp;
  var content = toString_0(trim(isCharSequence(this_0) ? this_0 : THROW_CCE()));
  // Inline function 'kotlin.collections.hashMapOf' call
  var textures = HashMap.f8();
  var tmp_0;
  if (startsWith_0(content, _Char___init__impl__6a9atx(60))) {
    var tmp_1 = readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_1 === get_COROUTINE_SUSPENDED())
      tmp_1 = yield tmp_1;
    tmp_0 = tmp_1;
  } else if (startsWith_0(content, _Char___init__impl__6a9atx(123))) {
    var tmp_2 = readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_2 === get_COROUTINE_SUSPENDED())
      tmp_2 = yield tmp_2;
    tmp_0 = tmp_2;
  } else if (startsWith(content, 'info')) {
    var tmp_3 = readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion);
    if (tmp_3 === get_COROUTINE_SUSPENDED())
      tmp_3 = yield tmp_3;
    tmp_0 = tmp_3;
  } else {
    var reason = 'Unsupported font type starting with ' + substr_0(content, 0, 16);
    throw NotImplementedError.nd('An operation is not implemented: ' + reason);
  }
  return tmp_0;
}
function readBitmapFont(_this__u8e3s4, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFont__n2ejpo(_this__u8e3s4, props, mipmaps, atlas, $completion), $completion);
}
function *_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var xml = Xml(content);
  var tmp60_safe_receiver = firstOrNull(xml.lh('info'));
  var tmp0_elvis_lhs = tmp60_safe_receiver == null ? null : tmp60_safe_receiver.i20('size');
  var fontSize = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
  var tmp61_safe_receiver = firstOrNull(xml.lh('common'));
  var tmp1_elvis_lhs = tmp61_safe_receiver == null ? null : tmp61_safe_receiver.i20('lineHeight');
  var lineHeight = tmp1_elvis_lhs == null ? 16.0 : tmp1_elvis_lhs;
  var tmp62_safe_receiver = firstOrNull(xml.lh('common'));
  var tmp2_elvis_lhs = tmp62_safe_receiver == null ? null : tmp62_safe_receiver.i20('base');
  var base = tmp2_elvis_lhs == null ? 16.0 : tmp2_elvis_lhs;
  var tmp63_safe_receiver = firstOrNull(xml.lh('distanceField'));
  var distanceField = tmp63_safe_receiver == null ? null : tmp63_safe_receiver.j20('fieldType');
  var _iterator__ex2g4s = get(xml.lh('pages'), 'page').z();
  while (_iterator__ex2g4s.a1()) {
    var page = _iterator__ex2g4s.b1();
    var id = page.f20('id');
    var file = page.h20('file');
    var texFile = fntFile.m1s().lh(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice_0(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.g3(id, tex);
  }
  // Inline function 'kotlin.collections.map' call
  var this_0 = get(xml.lh('chars'), 'char');
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
  var tmp0_iterator = this_0.z();
  while (tmp0_iterator.a1()) {
    var item = tmp0_iterator.b1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var page_0 = item.f20('page');
    var tmp0_elvis_lhs_0 = textures.b3(page_0);
    var texture = tmp0_elvis_lhs_0 == null ? first(textures.k3()) : tmp0_elvis_lhs_0;
    var tmp_0 = item.f20('id');
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.d3a(item.f20('x'), item.f20('y'), item.f20('width'), item.f20('height'));
      tmp_1 = atlas.v3m(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp65_safe_receiver = tmp_1;
    var tmp1_elvis_lhs_0 = tmp65_safe_receiver == null ? null : tmp65_safe_receiver.w3k_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs_0 == null ? texture.d3a(item.f20('x'), item.f20('y'), item.f20('width'), item.f20('height')) : tmp1_elvis_lhs_0, item.f20('xoffset'), item.f20('yoffset'), item.f20('xadvance'));
    destination.f(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_1 = get(xml.lh('kernings'), 'kerning');
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator_0 = this_1.z();
  while (tmp0_iterator_0.a1()) {
    var item_0 = tmp0_iterator_0.b1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$3 = new Kerning(item_0.f20('first'), item_0.f20('second'), item_0.f20('amount'));
    destination_0.f(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.z();
  while (tmp0_iterator_1.a1()) {
    var item_1 = tmp0_iterator_1.b1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$6 = to(item_1.j45_1, item_1);
    destination_1.f(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.z();
  while (tmp0_iterator_2.a1()) {
    var item_2 = tmp0_iterator_2.b1();
    // Inline function 'korlibs.image.font.readBitmapFontXml.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_15.h45(item_2.q45_1, item_2.r45_1), item_2);
    destination_2.f(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontXml(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontXml__tgdamn(content, fntFile, textures, props, mipmaps, atlas, $completion), $completion);
}
function *_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  var json = get_dyn(Companion_getInstance_13().v1x(content));
  var fontSize = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'info'), 'size'), 16.0);
  var lineHeight = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'lineHeight'), 16.0);
  var base = Dyn__toDoubleDefault_impl_fspogf(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'common'), 'base'), 16.0);
  var distanceField = Dyn__toStringOrNull_impl_7e6cgy(Dyn__get_impl_6l2p80(Dyn__get_impl_6l2p80(json, 'distanceField'), 'fieldType'));
  // Inline function 'korlibs.datastructure.iterators.fastForEachWithIndex' call
  var this_0 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'pages'));
  var n = 0;
  while (n < this_0.d1()) {
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var id = n;
    var page = this_0.c1(n).u2q_1;
    var file = Dyn__toString_impl_9l0v3s(page);
    var texFile = fntFile.m1s().lh(file);
    var tmp = readBitmap(texFile, props, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
    var tex = slice_0(mipmaps(tmp, mipmaps_0));
    // Inline function 'kotlin.collections.set' call
    textures.g3(id, tex);
    n = n + 1 | 0;
  }
  // Inline function 'kotlin.collections.map' call
  var this_1 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'chars'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_1, 10));
  var tmp0_iterator = this_1.z();
  while (tmp0_iterator.a1()) {
    var item = tmp0_iterator.b1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it = item.u2q_1;
    var page_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'page'));
    var tmp0_elvis_lhs = textures.b3(page_0);
    var texture = tmp0_elvis_lhs == null ? first(textures.k3()) : tmp0_elvis_lhs;
    var tmp_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'id'));
    var tmp_1;
    if (atlas == null) {
      tmp_1 = null;
    } else {
      var tmp_2 = texture.d3a(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height')));
      tmp_1 = atlas.v3m(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
    }
    var tmp43_safe_receiver = tmp_1;
    var tmp1_elvis_lhs = tmp43_safe_receiver == null ? null : tmp43_safe_receiver.w3k_1;
    var tmp$ret$0 = new Glyph(fontSize, tmp_0, tmp1_elvis_lhs == null ? texture.d3a(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'height'))) : tmp1_elvis_lhs, _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'yoffset')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it, 'xadvance')));
    destination.f(tmp$ret$0);
  }
  var glyphs = destination;
  // Inline function 'kotlin.collections.map' call
  var this_2 = Dyn__toList_impl_pxssgr(Dyn__get_impl_6l2p80(json, 'kernings'));
  // Inline function 'kotlin.collections.mapTo' call
  var destination_0 = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator_0 = this_2.z();
  while (tmp0_iterator_0.a1()) {
    var item_0 = tmp0_iterator_0.b1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var it_0 = item_0.u2q_1;
    var tmp$ret$3 = new Kerning(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'first')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'second')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(it_0, 'amount')));
    destination_0.f(tmp$ret$3);
  }
  var kernings = destination_0;
  // Inline function 'korlibs.image.font.Companion.invoke' call
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_1 = ArrayList.w(collectionSizeOrDefault(glyphs, 10));
  var tmp0_iterator_1 = glyphs.z();
  while (tmp0_iterator_1.a1()) {
    var item_1 = tmp0_iterator_1.b1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$6 = to(item_1.j45_1, item_1);
    destination_1.f(tmp$ret$6);
  }
  var glyphs_0 = toIntMap(toMap(destination_1));
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination_2 = ArrayList.w(collectionSizeOrDefault(kernings, 10));
  var tmp0_iterator_2 = kernings.z();
  while (tmp0_iterator_2.a1()) {
    var item_2 = tmp0_iterator_2.b1();
    // Inline function 'korlibs.image.font.readBitmapFontJson.<anonymous>' call
    var tmp$ret$9 = to(Companion_instance_15.h45(item_2.q45_1, item_2.r45_1), item_2);
    destination_2.f(tmp$ret$9);
  }
  var kernings_0 = toIntMap(toMap(destination_2));
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize), numberToDouble(lineHeight), numberToDouble(base), glyphs_0, kernings_0, name, distanceField);
}
function readBitmapFontJson(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontJson__a3fd7w(content, fntFile, textures, props, mipmaps, atlas, $completion), $completion);
}
function *_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps_0, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps_0 = mipmaps_0 === VOID ? true : mipmaps_0;
  atlas = atlas === VOID ? null : atlas;
  // Inline function 'kotlin.collections.arrayListOf' call
  var kernings = ArrayList.p1();
  // Inline function 'kotlin.collections.arrayListOf' call
  var glyphs = ArrayList.p1();
  var lineHeight = 16.0;
  var fontSize = 16.0;
  var base = null;
  var _iterator__ex2g4s = lines(content).z();
  while (_iterator__ex2g4s.a1()) {
    var rline = _iterator__ex2g4s.b1();
    // Inline function 'kotlin.text.trim' call
    var line = toString_0(trim(isCharSequence(rline) ? rline : THROW_CCE()));
    var map = LinkedHashMap.ac();
    var _iterator__ex2g4s_0 = split_0(line, charArrayOf([_Char___init__impl__6a9atx(32)])).z();
    while (_iterator__ex2g4s_0.a1()) {
      var part = _iterator__ex2g4s_0.b1();
      var _destruct__k2r9zo = plus(split_0(part, charArrayOf([_Char___init__impl__6a9atx(61)])), listOf(['', '']));
      // Inline function 'kotlin.collections.component1' call
      var key = _destruct__k2r9zo.c1(0);
      // Inline function 'kotlin.collections.component2' call
      var value = _destruct__k2r9zo.c1(1);
      // Inline function 'kotlin.collections.set' call
      map.g3(key, value);
    }
    if (startsWith(line, 'info')) {
      // Inline function 'kotlin.math.absoluteValue' call
      var tmp44_safe_receiver = map.b3('size');
      var tmp0_elvis_lhs = tmp44_safe_receiver == null ? null : toDouble(tmp44_safe_receiver);
      var this_0 = tmp0_elvis_lhs == null ? 16.0 : tmp0_elvis_lhs;
      fontSize = Math.abs(this_0);
    } else if (startsWith(line, 'page')) {
      var tmp45_safe_receiver = map.b3('id');
      var tmp1_elvis_lhs = tmp45_safe_receiver == null ? null : toInt_0(tmp45_safe_receiver);
      var id = tmp1_elvis_lhs == null ? 0 : tmp1_elvis_lhs;
      var tmp46_safe_receiver = map.b3('file');
      var tmp2_elvis_lhs = tmp46_safe_receiver == null ? null : unquote(tmp46_safe_receiver);
      var tmp;
      if (tmp2_elvis_lhs == null) {
        var message = 'page without file';
        throw IllegalStateException.w4(toString_0(message));
      } else {
        tmp = tmp2_elvis_lhs;
      }
      var file = tmp;
      // Inline function 'kotlin.collections.set' call
      var tmp_0 = readBitmap(fntFile.m1s().lh(file), props, $completion);
      if (tmp_0 === get_COROUTINE_SUSPENDED())
        tmp_0 = yield tmp_0;
      var value_0 = slice_0(mipmaps(tmp_0, mipmaps_0));
      textures.g3(id, value_0);
    } else if (startsWith(line, 'common ')) {
      var tmp47_safe_receiver = map.b3('lineHeight');
      var tmp3_elvis_lhs = tmp47_safe_receiver == null ? null : toDoubleOrNull(tmp47_safe_receiver);
      lineHeight = tmp3_elvis_lhs == null ? 16.0 : tmp3_elvis_lhs;
      var tmp48_safe_receiver = map.b3('base');
      base = tmp48_safe_receiver == null ? null : toDoubleOrNull(tmp48_safe_receiver);
    } else if (startsWith(line, 'char ')) {
      var tmp49_safe_receiver = map.b3('page');
      var tmp4_elvis_lhs = tmp49_safe_receiver == null ? null : toIntOrNull(tmp49_safe_receiver);
      var page = tmp4_elvis_lhs == null ? 0 : tmp4_elvis_lhs;
      var tmp5_elvis_lhs = textures.b3(page);
      var texture = tmp5_elvis_lhs == null ? first(textures.k3()) : tmp5_elvis_lhs;
      var dmap = get_dyn(map);
      var id_0 = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'id'));
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp52_fontSize = fontSize;
      var tmp53_xoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xoffset'));
      var tmp54_yoffset = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'yoffset'));
      var tmp55_xadvance = _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'xadvance'));
      var tmp_1;
      if (atlas == null) {
        tmp_1 = null;
      } else {
        var tmp_2 = texture.d3a(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0)));
        tmp_1 = atlas.v3m(tmp_2 instanceof RectSlice ? tmp_2 : THROW_CCE(), Unit_instance);
      }
      var tmp51_safe_receiver = tmp_1;
      var tmp6_elvis_lhs = tmp51_safe_receiver == null ? null : tmp51_safe_receiver.w3k_1;
      var tmp56_texture = tmp6_elvis_lhs == null ? texture.d3a(_Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'x')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'y')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'width')), _Dyn___get_int__impl__sh8lhm(Dyn__get_impl_6l2p80(dmap, 'height')), 'glyph-' + toString_1(numberToChar(id_0))) : tmp6_elvis_lhs;
      var element = new Glyph(tmp52_fontSize, id_0, tmp56_texture, tmp53_xoffset, tmp54_yoffset, tmp55_xadvance);
      glyphs.f(element);
    } else if (startsWith(line, 'kerning ')) {
      // Inline function 'kotlin.collections.plusAssign' call
      var tmp57_safe_receiver = map.b3('first');
      var tmp7_elvis_lhs = tmp57_safe_receiver == null ? null : toIntOrNull(tmp57_safe_receiver);
      var tmp_3 = tmp7_elvis_lhs == null ? 0 : tmp7_elvis_lhs;
      var tmp58_safe_receiver = map.b3('second');
      var tmp8_elvis_lhs = tmp58_safe_receiver == null ? null : toIntOrNull(tmp58_safe_receiver);
      var tmp_4 = tmp8_elvis_lhs == null ? 0 : tmp8_elvis_lhs;
      var tmp59_safe_receiver = map.b3('amount');
      var tmp9_elvis_lhs = tmp59_safe_receiver == null ? null : toIntOrNull(tmp59_safe_receiver);
      var element_0 = new Kerning(tmp_3, tmp_4, tmp9_elvis_lhs == null ? 0 : tmp9_elvis_lhs);
      kernings.f(element_0);
    }
  }
  // Inline function 'korlibs.image.font.Companion.invoke' call
  var fontSize_0 = fontSize;
  var lineHeight_0 = lineHeight;
  var tmp10_elvis_lhs = base;
  var base_0 = tmp10_elvis_lhs == null ? lineHeight : tmp10_elvis_lhs;
  // Inline function 'kotlin.collections.associateBy' call
  var capacity = coerceAtLeast(mapCapacity(collectionSizeOrDefault(glyphs, 10)), 16);
  // Inline function 'kotlin.collections.associateByTo' call
  var destination = LinkedHashMap.bc(capacity);
  var tmp0_iterator = glyphs.z();
  while (tmp0_iterator.a1()) {
    var element_1 = tmp0_iterator.b1();
    // Inline function 'korlibs.image.font.readBitmapFontTxt.<anonymous>' call
    var tmp$ret$6 = element_1.j45_1;
    destination.g3(tmp$ret$6, element_1);
  }
  var glyphs_0 = toIntMap(destination);
  var kernings_0 = associateByInt(kernings, readBitmapFontTxt$lambda);
  var name = 'BitmapFont';
  return new BitmapFontImpl(numberToDouble(fontSize_0), numberToDouble(lineHeight_0), numberToDouble(base_0), glyphs_0, kernings_0, name, null);
}
function readBitmapFontTxt(content, fntFile, textures, props, mipmaps, atlas, $completion) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapFontTxt__tgfm88(content, fntFile, textures, props, mipmaps, atlas, $completion), $completion);
}
function readBitmapFontTxt$lambda(_unused_var__etf5q3, it) {
  return Companion_instance_15.h45(it.q45_1, it.r45_1);
}
function bmp$factory() {
  return getPropertyCallableRef('bmp', 1, KProperty1, function (receiver) {
    return receiver.t45();
  }, null);
}
function naturalFontMetrics$factory() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.b46();
  }, null);
}
function anyGlyph$factory() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.a46();
  }, null);
}
function invalidGlyph$factory() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.q48();
  }, null);
}
var DefaultTtfFontOrNull;
function get_DefaultTtfFont() {
  if (DefaultTtfFontOrNull == null) {
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'kotlin.time.measureTimedValue' call
    // Inline function 'kotlin.contracts.contract' call
    var mark = Monotonic_instance.oi();
    // Inline function 'korlibs.image.font.<get-DefaultTtfFont>.<anonymous>' call
    var result = TtfFont.f4b(DefaultTtfFontBytes(), 'Default Font');
    var res = new TimedValue(result, ValueTimeMark__elapsedNow_impl_eonqvs(mark));
    DefaultTtfFontOrNull = res.wn_1;
  }
  return ensureNotNull(DefaultTtfFontOrNull);
}
function DefaultTtfFontBytes() {
  return uncompress(fromBase64('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'), Companion_getInstance_14());
}
function get_DefaultTtfFontAsBitmap() {
  return get_lazyBitmapSDF(get_DefaultTtfFont());
}
function renderGlyphToBitmap(_this__u8e3s4, size, codePoint, paint, fill, effect, border, nativeRendering, reader) {
  paint = paint === VOID ? new RGBA(get_DefaultPaint()) : paint;
  fill = fill === VOID ? true : fill;
  effect = effect === VOID ? null : effect;
  border = border === VOID ? 1 : border;
  nativeRendering = nativeRendering === VOID ? true : nativeRendering;
  reader = reader === VOID ? null : reader;
  var font = _this__u8e3s4;
  var fmetrics = _this__u8e3s4.o46(size);
  var gmetrics = _this__u8e3s4.x46(size, codePoint, VOID, reader);
  var gx = -gmetrics.k22();
  var gy = gmetrics.o2d() + gmetrics.m22();
  var border2 = imul(border, 2);
  var iwidth = toIntCeil_0(gmetrics.n2d()) + border2 | 0;
  var iheight = toIntCeil_0(gmetrics.o2d()) + border2 | 0;
  var image = nativeRendering ? NativeImage_0(iwidth, iheight) : Bitmap32.z3l(iwidth, iheight, VOID, true);
  // Inline function 'korlibs.image.bitmap.context2d' call
  // Inline function 'korlibs.image.bitmap.Bitmap.lock' call
  var rect = image.k3m_1;
  if (true) {
    image.l1o();
  }
  var result;
  try {
    // Inline function 'korlibs.image.bitmap.context2d.<anonymous>' call
    var ctx = image.c3u(true);
    try {
      // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
      renderGlyphToBitmap$renderGlyph(ctx, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
    }finally {
      ctx.p11();
    }
  }finally {
    result = true ? image.u3m(rect) : 0;
  }
  var imageOut = applyEffect(image.d3u(), effect);
  var glyph = new PlacedGlyphMetrics(codePoint, Vector2D.j21(gx + border, gy + border), gmetrics, fmetrics, Companion_getInstance_6().a25_1, 0, 0);
  var tmp = new TextMetrics();
  var tmp_0 = listOf_0(glyph);
  var tmp_1 = listOf_0(listOf_0(glyph));
  // Inline function 'korlibs.image.vector.buildShape' call
  // Inline function 'kotlin.apply' call
  var this_0 = new ShapeBuilder(iwidth, iheight);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.font.renderGlyphToBitmap.<anonymous>' call
  renderGlyphToBitmap$renderGlyph(this_0, paint, font, size, codePoint, gx, border, gy, gmetrics, fill);
  var tmp$ret$3 = this_0.w4b();
  return new TextToBitmapResult(imageOut, fmetrics, tmp, tmp_0, tmp_1, tmp$ret$3);
}
function PlacedGlyphMetrics$boundsPath$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.shape.buildVectorPath' call
    // Inline function 'kotlin.apply' call
    var this_0 = new VectorPath();
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.font.PlacedGlyphMetrics.boundsPath$delegate.<anonymous>.<anonymous>' call
    this_0.t36_1 = false;
    this_0.u3f(this$0.z4b_1.k22(), -this$0.a4c_1.g46_1, this$0.z4b_1.v46_1, this$0.a4c_1.v45());
    return applyTransform(this_0, Companion_getInstance_6().d25().e26(this$0.y4b_1).l26(this$0.b4c_1));
  };
}
function PlacedGlyphMetrics$boundsPathCurves$delegate$lambda(this$0) {
  return function () {
    var curves = getCurves(this$0.i4c());
    var tmp;
    if (!(curves.h32_1.d1() === 4)) {
      println('curves=' + curves.h32_1.d1());
      tmp = Unit_instance;
    }
    return curves;
  };
}
function PlacedGlyphMetrics$caretStart$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.math.geom.Line2D.flipped' call
    var this_0 = this$0.j4c().h32_1.c1(3).d36();
    var tmp$ret$0 = Line2D.h24(this_0.g24_1, this_0.f24_1);
    return toBezier(tmp$ret$0);
  };
}
function PlacedGlyphMetrics$caretEnd$delegate$lambda(this$0) {
  return function () {
    return this$0.j4c().h32_1.c1(1);
  };
}
function drawText(_this__u8e3s4, ctx, size, text, paint, pos, fill, renderer, align, outMetrics, fillStyle, stroke, textRangeStart, textRangeEnd, placed) {
  pos = pos === VOID ? Companion_getInstance_7().v21_1 : pos;
  fill = fill === VOID ? true : fill;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_48().y4c_1 : align;
  outMetrics = outMetrics === VOID ? null : outMetrics;
  fillStyle = fillStyle === VOID ? null : fillStyle;
  stroke = stroke === VOID ? null : stroke;
  textRangeStart = textRangeStart === VOID ? 0 : textRangeStart;
  textRangeEnd = textRangeEnd === VOID ? 2147483647 : textRangeEnd;
  placed = placed === VOID ? null : placed;
  var glyphs = !(outMetrics == null) ? new MultiplePlacedGlyphMetrics() : null;
  var fnt = _this__u8e3s4;
  var doRender = drawText$lambda(fillStyle, stroke, ctx, fill);
  var actions = new drawText$actions$1(renderer, text, size, fnt, align, pos, ctx, paint, textRangeStart, textRangeEnd, doRender, glyphs, placed);
  if (ctx == null)
    null;
  else {
    ctx.o4d();
  }
  invoke(renderer, actions, text, size, _this__u8e3s4);
  doRender();
  if (!(outMetrics == null)) {
    ensureNotNull(glyphs);
    outMetrics.m4c_1 = glyphs.p4d_1;
    outMetrics.n4c_1 = glyphs.q4d_1;
    var fmetrics = _this__u8e3s4.o46(size);
    outMetrics.k4c_1 = fmetrics;
    var metrics = outMetrics.l4c_1;
    metrics.t4d_1.v4d(fmetrics);
    metrics.u4d_1 = glyphs.q4d_1.d1();
    var tmp_1 = metrics;
    // Inline function 'kotlin.collections.map' call
    var this_0 = glyphs.q4d_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.font.drawText.<anonymous>' call
      var bb = Companion_getInstance_8().t22();
      var _iterator__ex2g4s = item.z();
      while (_iterator__ex2g4s.a1()) {
        var g = _iterator__ex2g4s.b1();
        bb = plus_1(bb, g.i4c());
      }
      var tmp$ret$0 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
      destination.f(tmp$ret$0);
    }
    tmp_1.s4d_1 = destination;
    metrics.r4d_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(BoundsBuilder__plus_impl_cz7f7x(Companion_getInstance_8().t22(), metrics.s4d_1));
  }
  return outMetrics;
}
function getTextBounds(_this__u8e3s4, size, text, out, renderer, align) {
  out = out === VOID ? new TextMetrics() : out;
  var tmp;
  if (renderer === VOID) {
    var tmp_0 = get_DefaultStringTextRenderer();
    tmp = isInterface(tmp_0, TextRenderer) ? tmp_0 : THROW_CCE();
  } else {
    tmp = renderer;
  }
  renderer = tmp;
  align = align === VOID ? Companion_getInstance_48().u4c_1 : align;
  var actions = new BoundBuilderTextRendererActions();
  invoke(renderer, actions, text, size, _this__u8e3s4);
  _this__u8e3s4.d46(size, out.t4d_1);
  out.u4d_1 = actions.l4e();
  var bb = Companion_getInstance_8().t22();
  var dy = 0.0;
  var lineBounds = FastArrayList.lx();
  var offsetY = actions.p4e(align.n4e_1, out.t4d_1);
  var _iterator__ex2g4s = actions.j4e_1.z();
  while (_iterator__ex2g4s.a1()) {
    var line = _iterator__ex2g4s.b1();
    var offsetX = line.t4e(align.m4e_1);
    var rect = new Rectangle(-offsetX, +offsetY + dy - out.u4e(), line.r4e_1, line.q4e_1);
    bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, rect);
    lineBounds.f(rect);
    dy = dy + line.q4e_1;
  }
  out.s4d_1 = lineBounds;
  out.r4d_1 = _BoundsBuilder___get_bounds__impl__s1l1gx(bb);
  return out;
}
function renderGlyphToBitmap$renderGlyph(_this__u8e3s4, $paint, font, $size, $codePoint, gx, $border, gy, gmetrics, $fill) {
  _this__u8e3s4.y47($paint);
  font.b48(_this__u8e3s4, $size, $codePoint, Vector2D.j21(gx + $border, gy + $border), true, gmetrics);
  if ($fill) {
    _this__u8e3s4.x4e();
  } else {
    _this__u8e3s4.w4e();
  }
}
function drawText$lambda($fillStyle, $stroke, $ctx, $fill) {
  return function () {
    if (!($fillStyle == null) || !($stroke == null)) {
      var tmp67_safe_receiver = $ctx;
      if (tmp67_safe_receiver == null)
        null;
      else {
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var fill = $fillStyle;
        var stroke = $stroke;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke' call
        var stroke_0 = stroke == null ? null : stroke.y4e_1;
        var strokeInfo = stroke == null ? null : stroke.z4e_1;
        // Inline function 'korlibs.image.vector.Context2d.fillStroke.<anonymous>' call
        if (!(fill == null)) {
          tmp67_safe_receiver.a4f(fill);
        }
        if (!(stroke_0 == null)) {
          if (!(strokeInfo == null)) {
            $l$block: {
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              if (stroke_0 == null || strokeInfo == null) {
                break $l$block;
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke' call
              var lineWidth = strokeInfo.w30_1;
              var lineCap = strokeInfo.z30_1;
              var lineJoin = strokeInfo.b31_1;
              var miterLimit = strokeInfo.c31_1;
              var lineDash = strokeInfo.d31_1;
              var lineDashOffset = strokeInfo.e31_1;
              if (false) {
                tmp67_safe_receiver.o4d();
              }
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              // Inline function 'korlibs.image.vector.Context2d.keep' call
              tmp67_safe_receiver.h4f();
              try {
                // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
                tmp67_safe_receiver.i4f(numberToDouble(lineWidth));
                tmp67_safe_receiver.j4f(lineCap);
                tmp67_safe_receiver.k4f(lineJoin);
                tmp67_safe_receiver.l4f(numberToDouble(miterLimit));
                tmp67_safe_receiver.m4f(lineDash);
                tmp67_safe_receiver.n4f(numberToDouble(lineDashOffset));
                tmp67_safe_receiver.o4f(stroke_0);
              }finally {
                tmp67_safe_receiver.p4f();
              }
            }
          } else {
            // Inline function 'korlibs.image.vector.Context2d.stroke' call
            var lineWidth_0 = tmp67_safe_receiver.b4f();
            var lineCap_0 = tmp67_safe_receiver.c4f();
            var lineJoin_0 = tmp67_safe_receiver.d4f();
            var miterLimit_0 = tmp67_safe_receiver.e4f();
            var lineDash_0 = tmp67_safe_receiver.f4f();
            var lineDashOffset_0 = tmp67_safe_receiver.g4f();
            if (false) {
              tmp67_safe_receiver.o4d();
            }
            // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
            // Inline function 'korlibs.image.vector.Context2d.keep' call
            tmp67_safe_receiver.h4f();
            try {
              // Inline function 'korlibs.image.vector.Context2d.stroke.<anonymous>' call
              tmp67_safe_receiver.i4f(numberToDouble(lineWidth_0));
              tmp67_safe_receiver.j4f(lineCap_0);
              tmp67_safe_receiver.k4f(lineJoin_0);
              tmp67_safe_receiver.l4f(numberToDouble(miterLimit_0));
              tmp67_safe_receiver.m4f(lineDash_0);
              tmp67_safe_receiver.n4f(numberToDouble(lineDashOffset_0));
              tmp67_safe_receiver.o4f(stroke_0);
            }finally {
              tmp67_safe_receiver.p4f();
            }
          }
        }
      }
    } else {
      if ($fill) {
        var tmp68_safe_receiver = $ctx;
        if (tmp68_safe_receiver == null)
          null;
        else {
          tmp68_safe_receiver.x4e();
        }
      } else {
        var tmp69_safe_receiver = $ctx;
        if (tmp69_safe_receiver == null)
          null;
        else {
          tmp69_safe_receiver.w4e();
        }
      }
    }
    var tmp70_safe_receiver = $ctx;
    if (tmp70_safe_receiver == null)
      null;
    else {
      tmp70_safe_receiver.o4d();
    }
    return Unit_instance;
  };
}
function boundsPath$factory() {
  return getPropertyCallableRef('boundsPath', 1, KProperty1, function (receiver) {
    return receiver.i4c();
  }, null);
}
function boundsPathCurves$factory() {
  return getPropertyCallableRef('boundsPathCurves', 1, KProperty1, function (receiver) {
    return receiver.j4c();
  }, null);
}
function *_generator_readFont__gkiy77(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  var tmp = _this__u8e3s4.n1s(until(0, 16), $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var header = tmp;
  var tmp_0;
  switch (getS32BE(header, 0)) {
    case 1953784678:
    case 1330926671:
    case 65536:
      var tmp_1 = readTtfFont(_this__u8e3s4, VOID, VOID, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp_0 = tmp_1;
      break;
    default:
      var tmp_2 = readBitmapFont(_this__u8e3s4, props, mipmaps, VOID, $completion);
      if (tmp_2 === get_COROUTINE_SUSPENDED())
        tmp_2 = yield tmp_2;
      tmp_0 = tmp_2;
      break;
  }
  return tmp_0;
}
function readFont(_this__u8e3s4, preload, props, mipmaps, $completion) {
  preload = preload === VOID ? false : preload;
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  mipmaps = mipmaps === VOID ? true : mipmaps;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readFont__gkiy77(_this__u8e3s4, preload, props, mipmaps, $completion), $completion);
}
var SystemFontRegistryOrNull;
var lazyBitmap$delegate;
function get_lazyBitmapSDF(_this__u8e3s4) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.PropertyThis.getValue' call
    var this_0 = lazyBitmapSDF$delegate;
    var property = lazyBitmapSDF$factory();
    var tmp0_elvis_lhs = this_0.xw_1;
    var res = getExtraTyped(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    if (res == null) {
      var r = this_0.yw_1(_this__u8e3s4);
      // Inline function 'korlibs.datastructure.PropertyThis.setValueUntransformed' call
      var tmp0_elvis_lhs_0 = this_0.xw_1;
      setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var lazyBitmapSDF$delegate;
var Companion_instance_17;
function Companion_getInstance_28() {
  if (Companion_instance_17 === VOID)
    new Companion_11();
  return Companion_instance_17;
}
function LazyBitmapFont$anyGlyph$delegate$lambda(this$0) {
  return function () {
    var tmp0_elvis_lhs = this$0.d4i_1.c1(this$0.d4i_1.c3().z().b1());
    return tmp0_elvis_lhs == null ? this$0.q48() : tmp0_elvis_lhs;
  };
}
function LazyBitmapFont$invalidGlyph$delegate$lambda(this$0) {
  return function () {
    // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
    var tmp$ret$0 = get_Bitmaps_transparent();
    return new Glyph(this$0.x4h_1, -1, tmp$ret$0, 0, 0, 0);
  };
}
function LazyBitmapFont$naturalFontMetrics$delegate$lambda(this$0) {
  return function () {
    var descent = this$0.a4i_1.i46_1 - this$0.a4i_1.k46_1;
    var tmp78_size = this$0.a4i_1.e46_1;
    var tmp79_top = this$0.a4i_1.f46_1;
    var tmp80_ascent = this$0.a4i_1.g46_1;
    var tmp81_baseline = this$0.a4i_1.h46_1;
    var tmp82_maxWidth = this$0.a4i_1.l46_1;
    return new FontMetrics(tmp78_size, tmp79_top, tmp80_ascent, tmp81_baseline, descent, descent, 0.0, tmp82_maxWidth, 0.0);
  };
}
function toLazyBitmapFont(_this__u8e3s4, fontSize, distanceField) {
  distanceField = distanceField === VOID ? null : distanceField;
  _init_properties_LazyBitmapFont_kt__76ptri();
  return new LazyBitmapFont(_this__u8e3s4, fontSize, distanceField);
}
function lazyBitmap$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, null);
}
function lazyBitmapSDF$delegate$lambda($this$PropertyThis) {
  _init_properties_LazyBitmapFont_kt__76ptri();
  return toLazyBitmapFont($this$PropertyThis, 32.0, 'sdf');
}
function lazyBitmapSDF$factory() {
  return getPropertyCallableRef('lazyBitmapSDF', 1, KProperty1, function (receiver) {
    return get_lazyBitmapSDF(receiver);
  }, null);
}
function anyGlyph$factory_0() {
  return getPropertyCallableRef('anyGlyph', 1, KProperty1, function (receiver) {
    return receiver.a46();
  }, null);
}
function invalidGlyph$factory_0() {
  return getPropertyCallableRef('invalidGlyph', 1, KProperty1, function (receiver) {
    return receiver.q48();
  }, null);
}
function naturalFontMetrics$factory_0() {
  return getPropertyCallableRef('naturalFontMetrics', 1, KProperty1, function (receiver) {
    return receiver.b46();
  }, null);
}
var properties_initialized_LazyBitmapFont_kt_c74u44;
function _init_properties_LazyBitmapFont_kt__76ptri() {
  if (!properties_initialized_LazyBitmapFont_kt_c74u44) {
    properties_initialized_LazyBitmapFont_kt_c74u44 = true;
    lazyBitmap$delegate = new PropertyThis(VOID, lazyBitmap$delegate$lambda);
    lazyBitmapSDF$delegate = new PropertyThis(VOID, lazyBitmapSDF$delegate$lambda);
  }
}
var Op_version_instance;
var Op_Copyright_instance;
var Op_Notice_instance;
var Op_isFixedPitch_instance;
var Op_FullName_instance;
var Op_ItalicAngle_instance;
var Op_FamilyName_instance;
var Op_UnderlinePosition_instance;
var Op_Weight_instance;
var Op_UnderlineThickness_instance;
var Op_FontBBox_instance;
var Op_PaintType_instance;
var Op_BlueValues_instance;
var Op_CharstringType_instance;
var Op_OtherBlues_instance;
var Op_FontMatrix_instance;
var Op_FamilyBlues_instance;
var Op_StrokeWidth_instance;
var Op_FamilyOtherBlues_instance;
var Op_BlueScale_instance;
var Op_StdHW_instance;
var Op_BlueShift_instance;
var Op_StdVW_instance;
var Op_BlueFuzz_instance;
var Op_StemSnapH_instance;
var Op_UniqueID_instance;
var Op_StemSnapV_instance;
var Op_XUID_instance;
var Op_ForceBold_instance;
var Op_charset_instance;
var Op_Encoding_instance;
var Op_CharStrings_instance;
var Op_LanguageGroup_instance;
var Op_Private_instance;
var Op_ExpansionFactor_instance;
var Op_Subrs_instance;
var Op_initialRandomSeed_instance;
var Op_defaultWidthX_instance;
var Op_SyntheicBase_instance;
var Op_nominalWidthX_instance;
var Op_PostScript_instance;
var Op_vsindex_instance;
var Op_BaseFontName_instance;
var Op_blend_instance;
var Op_BaseFontBlend_instance;
var Op_vstore_instance;
var Op_maxstack_instance;
var Op_ROS_instance;
var Op_CIDFontVersion_instance;
var Op_CIDFontRevision_instance;
var Op_CIDFontType_instance;
var Op_CIDCount_instance;
var Op_UIDBase_instance;
var Op_FDArray_instance;
var Op_FDSelect_instance;
var Op_FontName_instance;
var Companion_instance_18;
function Companion_getInstance_29() {
  Op_initEntries();
  if (Companion_instance_18 === VOID)
    new Companion_12();
  return Companion_instance_18;
}
function values_0() {
  return [Op_version_getInstance(), Op_Copyright_getInstance(), Op_Notice_getInstance(), Op_isFixedPitch_getInstance(), Op_FullName_getInstance(), Op_ItalicAngle_getInstance(), Op_FamilyName_getInstance(), Op_UnderlinePosition_getInstance(), Op_Weight_getInstance(), Op_UnderlineThickness_getInstance(), Op_FontBBox_getInstance(), Op_PaintType_getInstance(), Op_BlueValues_getInstance(), Op_CharstringType_getInstance(), Op_OtherBlues_getInstance(), Op_FontMatrix_getInstance(), Op_FamilyBlues_getInstance(), Op_StrokeWidth_getInstance(), Op_FamilyOtherBlues_getInstance(), Op_BlueScale_getInstance(), Op_StdHW_getInstance(), Op_BlueShift_getInstance(), Op_StdVW_getInstance(), Op_BlueFuzz_getInstance(), Op_StemSnapH_getInstance(), Op_UniqueID_getInstance(), Op_StemSnapV_getInstance(), Op_XUID_getInstance(), Op_ForceBold_getInstance(), Op_charset_getInstance(), Op_Encoding_getInstance(), Op_CharStrings_getInstance(), Op_LanguageGroup_getInstance(), Op_Private_getInstance(), Op_ExpansionFactor_getInstance(), Op_Subrs_getInstance(), Op_initialRandomSeed_getInstance(), Op_defaultWidthX_getInstance(), Op_SyntheicBase_getInstance(), Op_nominalWidthX_getInstance(), Op_PostScript_getInstance(), Op_vsindex_getInstance(), Op_BaseFontName_getInstance(), Op_blend_getInstance(), Op_BaseFontBlend_getInstance(), Op_vstore_getInstance(), Op_maxstack_getInstance(), Op_ROS_getInstance(), Op_CIDFontVersion_getInstance(), Op_CIDFontRevision_getInstance(), Op_CIDFontType_getInstance(), Op_CIDCount_getInstance(), Op_UIDBase_getInstance(), Op_FDArray_getInstance(), Op_FDSelect_getInstance(), Op_FontName_getInstance()];
}
var Op_entriesInitialized;
function Op_initEntries() {
  if (Op_entriesInitialized)
    return Unit_instance;
  Op_entriesInitialized = true;
  Op_version_instance = new Op('version', 0, 0);
  Op_Copyright_instance = new Op('Copyright', 1, 3072);
  Op_Notice_instance = new Op('Notice', 2, 1);
  Op_isFixedPitch_instance = new Op('isFixedPitch', 3, 3073);
  Op_FullName_instance = new Op('FullName', 4, 2);
  Op_ItalicAngle_instance = new Op('ItalicAngle', 5, 3074);
  Op_FamilyName_instance = new Op('FamilyName', 6, 3);
  Op_UnderlinePosition_instance = new Op('UnderlinePosition', 7, 3075);
  Op_Weight_instance = new Op('Weight', 8, 4);
  Op_UnderlineThickness_instance = new Op('UnderlineThickness', 9, 3076);
  Op_FontBBox_instance = new Op('FontBBox', 10, 5);
  Op_PaintType_instance = new Op('PaintType', 11, 3077);
  Op_BlueValues_instance = new Op('BlueValues', 12, 6);
  Op_CharstringType_instance = new Op('CharstringType', 13, 3078);
  Op_OtherBlues_instance = new Op('OtherBlues', 14, 7);
  Op_FontMatrix_instance = new Op('FontMatrix', 15, 3079);
  Op_FamilyBlues_instance = new Op('FamilyBlues', 16, 8);
  Op_StrokeWidth_instance = new Op('StrokeWidth', 17, 3080);
  Op_FamilyOtherBlues_instance = new Op('FamilyOtherBlues', 18, 9);
  Op_BlueScale_instance = new Op('BlueScale', 19, 3081);
  Op_StdHW_instance = new Op('StdHW', 20, 10);
  Op_BlueShift_instance = new Op('BlueShift', 21, 3082);
  Op_StdVW_instance = new Op('StdVW', 22, 11);
  Op_BlueFuzz_instance = new Op('BlueFuzz', 23, 3083);
  Op_StemSnapH_instance = new Op('StemSnapH', 24, 3084);
  Op_UniqueID_instance = new Op('UniqueID', 25, 13);
  Op_StemSnapV_instance = new Op('StemSnapV', 26, 3085);
  Op_XUID_instance = new Op('XUID', 27, 14);
  Op_ForceBold_instance = new Op('ForceBold', 28, 3086);
  Op_charset_instance = new Op('charset', 29, 15);
  Op_Encoding_instance = new Op('Encoding', 30, 16);
  Op_CharStrings_instance = new Op('CharStrings', 31, 17);
  Op_LanguageGroup_instance = new Op('LanguageGroup', 32, 3089);
  Op_Private_instance = new Op('Private', 33, 18);
  Op_ExpansionFactor_instance = new Op('ExpansionFactor', 34, 3090);
  Op_Subrs_instance = new Op('Subrs', 35, 19);
  Op_initialRandomSeed_instance = new Op('initialRandomSeed', 36, 3091);
  Op_defaultWidthX_instance = new Op('defaultWidthX', 37, 20);
  Op_SyntheicBase_instance = new Op('SyntheicBase', 38, 3092);
  Op_nominalWidthX_instance = new Op('nominalWidthX', 39, 21);
  Op_PostScript_instance = new Op('PostScript', 40, 3093);
  Op_vsindex_instance = new Op('vsindex', 41, 22);
  Op_BaseFontName_instance = new Op('BaseFontName', 42, 3094);
  Op_blend_instance = new Op('blend', 43, 23);
  Op_BaseFontBlend_instance = new Op('BaseFontBlend', 44, 3095);
  Op_vstore_instance = new Op('vstore', 45, 24);
  Op_maxstack_instance = new Op('maxstack', 46, 25);
  Op_ROS_instance = new Op('ROS', 47, 3102);
  Op_CIDFontVersion_instance = new Op('CIDFontVersion', 48, 3103);
  Op_CIDFontRevision_instance = new Op('CIDFontRevision', 49, 3104);
  Op_CIDFontType_instance = new Op('CIDFontType', 50, 3105);
  Op_CIDCount_instance = new Op('CIDCount', 51, 3106);
  Op_UIDBase_instance = new Op('UIDBase', 52, 3107);
  Op_FDArray_instance = new Op('FDArray', 53, 3108);
  Op_FDSelect_instance = new Op('FDSelect', 54, 3109);
  Op_FontName_instance = new Op('FontName', 55, 3110);
  Companion_getInstance_29();
}
function Op_version_getInstance() {
  Op_initEntries();
  return Op_version_instance;
}
function Op_Copyright_getInstance() {
  Op_initEntries();
  return Op_Copyright_instance;
}
function Op_Notice_getInstance() {
  Op_initEntries();
  return Op_Notice_instance;
}
function Op_isFixedPitch_getInstance() {
  Op_initEntries();
  return Op_isFixedPitch_instance;
}
function Op_FullName_getInstance() {
  Op_initEntries();
  return Op_FullName_instance;
}
function Op_ItalicAngle_getInstance() {
  Op_initEntries();
  return Op_ItalicAngle_instance;
}
function Op_FamilyName_getInstance() {
  Op_initEntries();
  return Op_FamilyName_instance;
}
function Op_UnderlinePosition_getInstance() {
  Op_initEntries();
  return Op_UnderlinePosition_instance;
}
function Op_Weight_getInstance() {
  Op_initEntries();
  return Op_Weight_instance;
}
function Op_UnderlineThickness_getInstance() {
  Op_initEntries();
  return Op_UnderlineThickness_instance;
}
function Op_FontBBox_getInstance() {
  Op_initEntries();
  return Op_FontBBox_instance;
}
function Op_PaintType_getInstance() {
  Op_initEntries();
  return Op_PaintType_instance;
}
function Op_BlueValues_getInstance() {
  Op_initEntries();
  return Op_BlueValues_instance;
}
function Op_CharstringType_getInstance() {
  Op_initEntries();
  return Op_CharstringType_instance;
}
function Op_OtherBlues_getInstance() {
  Op_initEntries();
  return Op_OtherBlues_instance;
}
function Op_FontMatrix_getInstance() {
  Op_initEntries();
  return Op_FontMatrix_instance;
}
function Op_FamilyBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyBlues_instance;
}
function Op_StrokeWidth_getInstance() {
  Op_initEntries();
  return Op_StrokeWidth_instance;
}
function Op_FamilyOtherBlues_getInstance() {
  Op_initEntries();
  return Op_FamilyOtherBlues_instance;
}
function Op_BlueScale_getInstance() {
  Op_initEntries();
  return Op_BlueScale_instance;
}
function Op_StdHW_getInstance() {
  Op_initEntries();
  return Op_StdHW_instance;
}
function Op_BlueShift_getInstance() {
  Op_initEntries();
  return Op_BlueShift_instance;
}
function Op_StdVW_getInstance() {
  Op_initEntries();
  return Op_StdVW_instance;
}
function Op_BlueFuzz_getInstance() {
  Op_initEntries();
  return Op_BlueFuzz_instance;
}
function Op_StemSnapH_getInstance() {
  Op_initEntries();
  return Op_StemSnapH_instance;
}
function Op_UniqueID_getInstance() {
  Op_initEntries();
  return Op_UniqueID_instance;
}
function Op_StemSnapV_getInstance() {
  Op_initEntries();
  return Op_StemSnapV_instance;
}
function Op_XUID_getInstance() {
  Op_initEntries();
  return Op_XUID_instance;
}
function Op_ForceBold_getInstance() {
  Op_initEntries();
  return Op_ForceBold_instance;
}
function Op_charset_getInstance() {
  Op_initEntries();
  return Op_charset_instance;
}
function Op_Encoding_getInstance() {
  Op_initEntries();
  return Op_Encoding_instance;
}
function Op_CharStrings_getInstance() {
  Op_initEntries();
  return Op_CharStrings_instance;
}
function Op_LanguageGroup_getInstance() {
  Op_initEntries();
  return Op_LanguageGroup_instance;
}
function Op_Private_getInstance() {
  Op_initEntries();
  return Op_Private_instance;
}
function Op_ExpansionFactor_getInstance() {
  Op_initEntries();
  return Op_ExpansionFactor_instance;
}
function Op_Subrs_getInstance() {
  Op_initEntries();
  return Op_Subrs_instance;
}
function Op_initialRandomSeed_getInstance() {
  Op_initEntries();
  return Op_initialRandomSeed_instance;
}
function Op_defaultWidthX_getInstance() {
  Op_initEntries();
  return Op_defaultWidthX_instance;
}
function Op_SyntheicBase_getInstance() {
  Op_initEntries();
  return Op_SyntheicBase_instance;
}
function Op_nominalWidthX_getInstance() {
  Op_initEntries();
  return Op_nominalWidthX_instance;
}
function Op_PostScript_getInstance() {
  Op_initEntries();
  return Op_PostScript_instance;
}
function Op_vsindex_getInstance() {
  Op_initEntries();
  return Op_vsindex_instance;
}
function Op_BaseFontName_getInstance() {
  Op_initEntries();
  return Op_BaseFontName_instance;
}
function Op_blend_getInstance() {
  Op_initEntries();
  return Op_blend_instance;
}
function Op_BaseFontBlend_getInstance() {
  Op_initEntries();
  return Op_BaseFontBlend_instance;
}
function Op_vstore_getInstance() {
  Op_initEntries();
  return Op_vstore_instance;
}
function Op_maxstack_getInstance() {
  Op_initEntries();
  return Op_maxstack_instance;
}
function Op_ROS_getInstance() {
  Op_initEntries();
  return Op_ROS_instance;
}
function Op_CIDFontVersion_getInstance() {
  Op_initEntries();
  return Op_CIDFontVersion_instance;
}
function Op_CIDFontRevision_getInstance() {
  Op_initEntries();
  return Op_CIDFontRevision_instance;
}
function Op_CIDFontType_getInstance() {
  Op_initEntries();
  return Op_CIDFontType_instance;
}
function Op_CIDCount_getInstance() {
  Op_initEntries();
  return Op_CIDCount_instance;
}
function Op_UIDBase_getInstance() {
  Op_initEntries();
  return Op_UIDBase_instance;
}
function Op_FDArray_getInstance() {
  Op_initEntries();
  return Op_FDArray_instance;
}
function Op_FDSelect_getInstance() {
  Op_initEntries();
  return Op_FDSelect_instance;
}
function Op_FontName_getInstance() {
  Op_initEntries();
  return Op_FontName_instance;
}
var Op_hstem_instance;
var Op_vstem_instance;
var Op_and_instance;
var Op_vmoveto_instance;
var Op_or_instance;
var Op_rlineto_instance;
var Op_not_instance;
var Op_hlineto_instance;
var Op_vlineto_instance;
var Op_rrcurveto_instance;
var Op_abs_instance;
var Op_callsubr_instance;
var Op_add_instance;
var Op_return_instance;
var Op_sub_instance;
var Op_div_instance;
var Op_endchar_instance;
var Op_neg_instance;
var Op_cff2vsidx_instance;
var Op_eq_instance;
var Op_cff2blend_instance;
var Op_hstemhm_instance;
var Op_drop_instance;
var Op_hintmask_instance;
var Op_cntrmask_instance;
var Op_put_instance;
var Op_rmoveto_instance;
var Op_get_instance;
var Op_hmoveto_instance;
var Op_ifelse_instance;
var Op_vstemhm_instance;
var Op_random_instance;
var Op_rcurveline_instance;
var Op_mul_instance;
var Op_rlinecurve_instance;
var Op_vvcurveto_instance;
var Op_sqrt_instance;
var Op_hhcurveto_instance;
var Op_dup_instance;
var Op_exch_instance;
var Op_callgsubr_instance;
var Op_index_instance;
var Op_vhcurveto_instance;
var Op_roll_instance;
var Op_hvcurveto_instance;
var Op_hflex_instance;
var Op_flex_instance;
var Op_hflex1_instance;
var Op_flex1_instance;
var Companion_instance_19;
function Companion_getInstance_30() {
  Op_initEntries_0();
  if (Companion_instance_19 === VOID)
    new Companion_13();
  return Companion_instance_19;
}
function values_1() {
  return [Op_hstem_getInstance(), Op_vstem_getInstance(), Op_and_getInstance(), Op_vmoveto_getInstance(), Op_or_getInstance(), Op_rlineto_getInstance(), Op_not_getInstance(), Op_hlineto_getInstance(), Op_vlineto_getInstance(), Op_rrcurveto_getInstance(), Op_abs_getInstance(), Op_callsubr_getInstance(), Op_add_getInstance(), Op_return_getInstance(), Op_sub_getInstance(), Op_div_getInstance(), Op_endchar_getInstance(), Op_neg_getInstance(), Op_cff2vsidx_getInstance(), Op_eq_getInstance(), Op_cff2blend_getInstance(), Op_hstemhm_getInstance(), Op_drop_getInstance(), Op_hintmask_getInstance(), Op_cntrmask_getInstance(), Op_put_getInstance(), Op_rmoveto_getInstance(), Op_get_getInstance(), Op_hmoveto_getInstance(), Op_ifelse_getInstance(), Op_vstemhm_getInstance(), Op_random_getInstance(), Op_rcurveline_getInstance(), Op_mul_getInstance(), Op_rlinecurve_getInstance(), Op_vvcurveto_getInstance(), Op_sqrt_getInstance(), Op_hhcurveto_getInstance(), Op_dup_getInstance(), Op_exch_getInstance(), Op_callgsubr_getInstance(), Op_index_getInstance(), Op_vhcurveto_getInstance(), Op_roll_getInstance(), Op_hvcurveto_getInstance(), Op_hflex_getInstance(), Op_flex_getInstance(), Op_hflex1_getInstance(), Op_flex1_getInstance()];
}
var Op_entriesInitialized_0;
function Op_initEntries_0() {
  if (Op_entriesInitialized_0)
    return Unit_instance;
  Op_entriesInitialized_0 = true;
  Op_hstem_instance = new Op_0('hstem', 0, 1);
  Op_vstem_instance = new Op_0('vstem', 1, 3);
  Op_and_instance = new Op_0('and', 2, 3075);
  Op_vmoveto_instance = new Op_0('vmoveto', 3, 4);
  Op_or_instance = new Op_0('or', 4, 3076);
  Op_rlineto_instance = new Op_0('rlineto', 5, 5);
  Op_not_instance = new Op_0('not', 6, 3077);
  Op_hlineto_instance = new Op_0('hlineto', 7, 6);
  Op_vlineto_instance = new Op_0('vlineto', 8, 7);
  Op_rrcurveto_instance = new Op_0('rrcurveto', 9, 8);
  Op_abs_instance = new Op_0('abs', 10, 3081);
  Op_callsubr_instance = new Op_0('callsubr', 11, 10);
  Op_add_instance = new Op_0('add', 12, 3082);
  Op_return_instance = new Op_0('return', 13, 11);
  Op_sub_instance = new Op_0('sub', 14, 3083);
  Op_div_instance = new Op_0('div', 15, 3084);
  Op_endchar_instance = new Op_0('endchar', 16, 14);
  Op_neg_instance = new Op_0('neg', 17, 3086);
  Op_cff2vsidx_instance = new Op_0('cff2vsidx', 18, 15);
  Op_eq_instance = new Op_0('eq', 19, 3087);
  Op_cff2blend_instance = new Op_0('cff2blend', 20, 16);
  Op_hstemhm_instance = new Op_0('hstemhm', 21, 18);
  Op_drop_instance = new Op_0('drop', 22, 3090);
  Op_hintmask_instance = new Op_0('hintmask', 23, 19);
  Op_cntrmask_instance = new Op_0('cntrmask', 24, 20);
  Op_put_instance = new Op_0('put', 25, 3092);
  Op_rmoveto_instance = new Op_0('rmoveto', 26, 21);
  Op_get_instance = new Op_0('get', 27, 3093);
  Op_hmoveto_instance = new Op_0('hmoveto', 28, 22);
  Op_ifelse_instance = new Op_0('ifelse', 29, 3094);
  Op_vstemhm_instance = new Op_0('vstemhm', 30, 23);
  Op_random_instance = new Op_0('random', 31, 3095);
  Op_rcurveline_instance = new Op_0('rcurveline', 32, 24);
  Op_mul_instance = new Op_0('mul', 33, 3096);
  Op_rlinecurve_instance = new Op_0('rlinecurve', 34, 25);
  Op_vvcurveto_instance = new Op_0('vvcurveto', 35, 26);
  Op_sqrt_instance = new Op_0('sqrt', 36, 3098);
  Op_hhcurveto_instance = new Op_0('hhcurveto', 37, 27);
  Op_dup_instance = new Op_0('dup', 38, 3099);
  Op_exch_instance = new Op_0('exch', 39, 3100);
  Op_callgsubr_instance = new Op_0('callgsubr', 40, 29);
  Op_index_instance = new Op_0('index', 41, 3101);
  Op_vhcurveto_instance = new Op_0('vhcurveto', 42, 30);
  Op_roll_instance = new Op_0('roll', 43, 3102);
  Op_hvcurveto_instance = new Op_0('hvcurveto', 44, 31);
  Op_hflex_instance = new Op_0('hflex', 45, 3106);
  Op_flex_instance = new Op_0('flex', 46, 3107);
  Op_hflex1_instance = new Op_0('hflex1', 47, 3108);
  Op_flex1_instance = new Op_0('flex1', 48, 3109);
  Companion_getInstance_30();
}
function computeSubrBias($this, count) {
  return count < 1240 ? 107 : count < 33900 ? 1131 : 32768;
}
function Op_hstem_getInstance() {
  Op_initEntries_0();
  return Op_hstem_instance;
}
function Op_vstem_getInstance() {
  Op_initEntries_0();
  return Op_vstem_instance;
}
function Op_and_getInstance() {
  Op_initEntries_0();
  return Op_and_instance;
}
function Op_vmoveto_getInstance() {
  Op_initEntries_0();
  return Op_vmoveto_instance;
}
function Op_or_getInstance() {
  Op_initEntries_0();
  return Op_or_instance;
}
function Op_rlineto_getInstance() {
  Op_initEntries_0();
  return Op_rlineto_instance;
}
function Op_not_getInstance() {
  Op_initEntries_0();
  return Op_not_instance;
}
function Op_hlineto_getInstance() {
  Op_initEntries_0();
  return Op_hlineto_instance;
}
function Op_vlineto_getInstance() {
  Op_initEntries_0();
  return Op_vlineto_instance;
}
function Op_rrcurveto_getInstance() {
  Op_initEntries_0();
  return Op_rrcurveto_instance;
}
function Op_abs_getInstance() {
  Op_initEntries_0();
  return Op_abs_instance;
}
function Op_callsubr_getInstance() {
  Op_initEntries_0();
  return Op_callsubr_instance;
}
function Op_add_getInstance() {
  Op_initEntries_0();
  return Op_add_instance;
}
function Op_return_getInstance() {
  Op_initEntries_0();
  return Op_return_instance;
}
function Op_sub_getInstance() {
  Op_initEntries_0();
  return Op_sub_instance;
}
function Op_div_getInstance() {
  Op_initEntries_0();
  return Op_div_instance;
}
function Op_endchar_getInstance() {
  Op_initEntries_0();
  return Op_endchar_instance;
}
function Op_neg_getInstance() {
  Op_initEntries_0();
  return Op_neg_instance;
}
function Op_cff2vsidx_getInstance() {
  Op_initEntries_0();
  return Op_cff2vsidx_instance;
}
function Op_eq_getInstance() {
  Op_initEntries_0();
  return Op_eq_instance;
}
function Op_cff2blend_getInstance() {
  Op_initEntries_0();
  return Op_cff2blend_instance;
}
function Op_hstemhm_getInstance() {
  Op_initEntries_0();
  return Op_hstemhm_instance;
}
function Op_drop_getInstance() {
  Op_initEntries_0();
  return Op_drop_instance;
}
function Op_hintmask_getInstance() {
  Op_initEntries_0();
  return Op_hintmask_instance;
}
function Op_cntrmask_getInstance() {
  Op_initEntries_0();
  return Op_cntrmask_instance;
}
function Op_put_getInstance() {
  Op_initEntries_0();
  return Op_put_instance;
}
function Op_rmoveto_getInstance() {
  Op_initEntries_0();
  return Op_rmoveto_instance;
}
function Op_get_getInstance() {
  Op_initEntries_0();
  return Op_get_instance;
}
function Op_hmoveto_getInstance() {
  Op_initEntries_0();
  return Op_hmoveto_instance;
}
function Op_ifelse_getInstance() {
  Op_initEntries_0();
  return Op_ifelse_instance;
}
function Op_vstemhm_getInstance() {
  Op_initEntries_0();
  return Op_vstemhm_instance;
}
function Op_random_getInstance() {
  Op_initEntries_0();
  return Op_random_instance;
}
function Op_rcurveline_getInstance() {
  Op_initEntries_0();
  return Op_rcurveline_instance;
}
function Op_mul_getInstance() {
  Op_initEntries_0();
  return Op_mul_instance;
}
function Op_rlinecurve_getInstance() {
  Op_initEntries_0();
  return Op_rlinecurve_instance;
}
function Op_vvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vvcurveto_instance;
}
function Op_sqrt_getInstance() {
  Op_initEntries_0();
  return Op_sqrt_instance;
}
function Op_hhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hhcurveto_instance;
}
function Op_dup_getInstance() {
  Op_initEntries_0();
  return Op_dup_instance;
}
function Op_exch_getInstance() {
  Op_initEntries_0();
  return Op_exch_instance;
}
function Op_callgsubr_getInstance() {
  Op_initEntries_0();
  return Op_callgsubr_instance;
}
function Op_index_getInstance() {
  Op_initEntries_0();
  return Op_index_instance;
}
function Op_vhcurveto_getInstance() {
  Op_initEntries_0();
  return Op_vhcurveto_instance;
}
function Op_roll_getInstance() {
  Op_initEntries_0();
  return Op_roll_instance;
}
function Op_hvcurveto_getInstance() {
  Op_initEntries_0();
  return Op_hvcurveto_instance;
}
function Op_hflex_getInstance() {
  Op_initEntries_0();
  return Op_hflex_instance;
}
function Op_flex_getInstance() {
  Op_initEntries_0();
  return Op_flex_instance;
}
function Op_hflex1_getInstance() {
  Op_initEntries_0();
  return Op_hflex1_instance;
}
function Op_flex1_getInstance() {
  Op_initEntries_0();
  return Op_flex1_instance;
}
var CFF_instance;
function CFF_getInstance() {
  return CFF_instance;
}
var CharStringType2_instance;
function CharStringType2_getInstance() {
  return CharStringType2_instance;
}
var TtfCIDFont_instance;
function TtfCIDFont_getInstance() {
  if (TtfCIDFont_instance === VOID)
    new TtfCIDFont();
  return TtfCIDFont_instance;
}
var Companion_instance_20;
function Companion_getInstance_31() {
  if (Companion_instance_20 === VOID)
    new Companion_14();
  return Companion_instance_20;
}
function _get_ss__ndcawb($this) {
  // Inline function 'kotlin.getValue' call
  var this_0 = $this.a4q_1;
  ss$factory();
  return this_0.t1();
}
function BaseTtfFont$Table$ss$delegate$lambda(this$0) {
  return function () {
    return ensureNotNull(this$0.z4p_1)();
  };
}
function BaseTtfFont$Companion$readHeaderTables$lambda($$this$run, $table) {
  return function () {
    return $$this$run.e1j($table.x4p_1, $table.y4p_1);
  };
}
var NameId_COPYRIGHT_instance;
var NameId_NAME_instance;
var NameId_STYLE_instance;
var NameId_UNAME_instance;
var NameId_COMPLETE_NAME_instance;
var NameId_RELEASE_VERSION_instance;
var NameId_POSTSCRIPT_NAME_instance;
var NameId_TRADEMARK_instance;
var NameId_MANUFACTURER_instance;
var NameId_DESIGNER_instance;
var NameId_DESCRIPTION_instance;
var NameId_URL_VENDOR_instance;
var NameId_URL_DESIGNER_instance;
var NameId_LICENSE_DESCRIPTION_instance;
var NameId_LICENSE_URL_instance;
var NameId_RESERVED_15_instance;
var NameId_PREFERRED_FAMILY_instance;
var NameId_PREFERRED_SUBFAMILY_instance;
var NameId_COMPATIBLE_FULL_instance;
var NameId_SAMPLE_TEXT_instance;
var NameId_POSTSCRIPT_CID_instance;
var NameId_WWS_FAMILY_NAME_instance;
var NameId_WWS_SUBFAMILY_NAME_instance;
var NameId_LIGHT_BACKGROUND_instance;
var NameId_DARK_BACKGROUND_instance;
var NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
var Companion_instance_21;
function Companion_getInstance_32() {
  return Companion_instance_21;
}
function values_2() {
  return [NameId_COPYRIGHT_getInstance(), NameId_NAME_getInstance(), NameId_STYLE_getInstance(), NameId_UNAME_getInstance(), NameId_COMPLETE_NAME_getInstance(), NameId_RELEASE_VERSION_getInstance(), NameId_POSTSCRIPT_NAME_getInstance(), NameId_TRADEMARK_getInstance(), NameId_MANUFACTURER_getInstance(), NameId_DESIGNER_getInstance(), NameId_DESCRIPTION_getInstance(), NameId_URL_VENDOR_getInstance(), NameId_URL_DESIGNER_getInstance(), NameId_LICENSE_DESCRIPTION_getInstance(), NameId_LICENSE_URL_getInstance(), NameId_RESERVED_15_getInstance(), NameId_PREFERRED_FAMILY_getInstance(), NameId_PREFERRED_SUBFAMILY_getInstance(), NameId_COMPATIBLE_FULL_getInstance(), NameId_SAMPLE_TEXT_getInstance(), NameId_POSTSCRIPT_CID_getInstance(), NameId_WWS_FAMILY_NAME_getInstance(), NameId_WWS_SUBFAMILY_NAME_getInstance(), NameId_LIGHT_BACKGROUND_getInstance(), NameId_DARK_BACKGROUND_getInstance(), NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance()];
}
var NameId_entriesInitialized;
function NameId_initEntries() {
  if (NameId_entriesInitialized)
    return Unit_instance;
  NameId_entriesInitialized = true;
  NameId_COPYRIGHT_instance = new NameId('COPYRIGHT', 0, 0);
  NameId_NAME_instance = new NameId('NAME', 1, 1);
  NameId_STYLE_instance = new NameId('STYLE', 2, 2);
  NameId_UNAME_instance = new NameId('UNAME', 3, 3);
  NameId_COMPLETE_NAME_instance = new NameId('COMPLETE_NAME', 4, 4);
  NameId_RELEASE_VERSION_instance = new NameId('RELEASE_VERSION', 5, 5);
  NameId_POSTSCRIPT_NAME_instance = new NameId('POSTSCRIPT_NAME', 6, 6);
  NameId_TRADEMARK_instance = new NameId('TRADEMARK', 7, 7);
  NameId_MANUFACTURER_instance = new NameId('MANUFACTURER', 8, 8);
  NameId_DESIGNER_instance = new NameId('DESIGNER', 9, 9);
  NameId_DESCRIPTION_instance = new NameId('DESCRIPTION', 10, 10);
  NameId_URL_VENDOR_instance = new NameId('URL_VENDOR', 11, 11);
  NameId_URL_DESIGNER_instance = new NameId('URL_DESIGNER', 12, 12);
  NameId_LICENSE_DESCRIPTION_instance = new NameId('LICENSE_DESCRIPTION', 13, 13);
  NameId_LICENSE_URL_instance = new NameId('LICENSE_URL', 14, 14);
  NameId_RESERVED_15_instance = new NameId('RESERVED_15', 15, 15);
  NameId_PREFERRED_FAMILY_instance = new NameId('PREFERRED_FAMILY', 16, 16);
  NameId_PREFERRED_SUBFAMILY_instance = new NameId('PREFERRED_SUBFAMILY', 17, 17);
  NameId_COMPATIBLE_FULL_instance = new NameId('COMPATIBLE_FULL', 18, 18);
  NameId_SAMPLE_TEXT_instance = new NameId('SAMPLE_TEXT', 19, 19);
  NameId_POSTSCRIPT_CID_instance = new NameId('POSTSCRIPT_CID', 20, 20);
  NameId_WWS_FAMILY_NAME_instance = new NameId('WWS_FAMILY_NAME', 21, 21);
  NameId_WWS_SUBFAMILY_NAME_instance = new NameId('WWS_SUBFAMILY_NAME', 22, 22);
  NameId_LIGHT_BACKGROUND_instance = new NameId('LIGHT_BACKGROUND', 23, 23);
  NameId_DARK_BACKGROUND_instance = new NameId('DARK_BACKGROUND', 24, 23);
  NameId_VARIATION_POSTSCRIPT_PREFIX_instance = new NameId('VARIATION_POSTSCRIPT_PREFIX', 25, 25);
}
var Colrv1Paint_PaintColrLayers_instance;
var Colrv1Paint_PaintSolid_instance;
var Colrv1Paint_PaintVarSolid_instance;
var Colrv1Paint_PaintLinearGradient_instance;
var Colrv1Paint_PaintVarLinearGradient_instance;
var Colrv1Paint_PaintRadialGradient_instance;
var Colrv1Paint_PaintVarRadialGradient_instance;
var Colrv1Paint_PaintSweepGradient_instance;
var Colrv1Paint_PaintVarSweepGradient_instance;
var Colrv1Paint_PaintGlyph_instance;
var Colrv1Paint_PaintColrGlyph_instance;
var Colrv1Paint_PaintTransform_instance;
var Colrv1Paint_PaintVarTransform_instance;
var Colrv1Paint_PaintTranslate_instance;
var Colrv1Paint_PaintVarTranslate_instance;
var Colrv1Paint_PaintScale_instance;
var Colrv1Paint_PaintVarScale_instance;
var Colrv1Paint_PaintScaleAroundCenter_instance;
var Colrv1Paint_PaintVarScaleAroundCenter_instance;
var Colrv1Paint_PaintScaleUniform_instance;
var Colrv1Paint_PaintVarScaleUniform_instance;
var Colrv1Paint_PaintScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
var Colrv1Paint_PaintRotate_instance;
var Colrv1Paint_PaintVarRotate_instance;
var Colrv1Paint_PaintRotateAroundCenter_instance;
var Colrv1Paint_PaintVarRotateAroundCenter_instance;
var Colrv1Paint_PaintSkew_instance;
var Colrv1Paint_PaintVarSkew_instance;
var Colrv1Paint_PaintSkewAroundCenter_instance;
var Colrv1Paint_PaintVarSkewAroundCenter_instance;
var Colrv1Paint_PaintComposite_instance;
var Companion_instance_22;
function Companion_getInstance_33() {
  Colrv1Paint_initEntries();
  if (Companion_instance_22 === VOID)
    new Companion_16();
  return Companion_instance_22;
}
function values_3() {
  return [Colrv1Paint_PaintColrLayers_getInstance(), Colrv1Paint_PaintSolid_getInstance(), Colrv1Paint_PaintVarSolid_getInstance(), Colrv1Paint_PaintLinearGradient_getInstance(), Colrv1Paint_PaintVarLinearGradient_getInstance(), Colrv1Paint_PaintRadialGradient_getInstance(), Colrv1Paint_PaintVarRadialGradient_getInstance(), Colrv1Paint_PaintSweepGradient_getInstance(), Colrv1Paint_PaintVarSweepGradient_getInstance(), Colrv1Paint_PaintGlyph_getInstance(), Colrv1Paint_PaintColrGlyph_getInstance(), Colrv1Paint_PaintTransform_getInstance(), Colrv1Paint_PaintVarTransform_getInstance(), Colrv1Paint_PaintTranslate_getInstance(), Colrv1Paint_PaintVarTranslate_getInstance(), Colrv1Paint_PaintScale_getInstance(), Colrv1Paint_PaintVarScale_getInstance(), Colrv1Paint_PaintScaleAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleAroundCenter_getInstance(), Colrv1Paint_PaintScaleUniform_getInstance(), Colrv1Paint_PaintVarScaleUniform_getInstance(), Colrv1Paint_PaintScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance(), Colrv1Paint_PaintRotate_getInstance(), Colrv1Paint_PaintVarRotate_getInstance(), Colrv1Paint_PaintRotateAroundCenter_getInstance(), Colrv1Paint_PaintVarRotateAroundCenter_getInstance(), Colrv1Paint_PaintSkew_getInstance(), Colrv1Paint_PaintVarSkew_getInstance(), Colrv1Paint_PaintSkewAroundCenter_getInstance(), Colrv1Paint_PaintVarSkewAroundCenter_getInstance(), Colrv1Paint_PaintComposite_getInstance()];
}
var Colrv1Paint_entriesInitialized;
function Colrv1Paint_initEntries() {
  if (Colrv1Paint_entriesInitialized)
    return Unit_instance;
  Colrv1Paint_entriesInitialized = true;
  Colrv1Paint_PaintColrLayers_instance = new Colrv1Paint('PaintColrLayers', 0);
  Colrv1Paint_PaintSolid_instance = new Colrv1Paint('PaintSolid', 1);
  Colrv1Paint_PaintVarSolid_instance = new Colrv1Paint('PaintVarSolid', 2);
  Colrv1Paint_PaintLinearGradient_instance = new Colrv1Paint('PaintLinearGradient', 3);
  Colrv1Paint_PaintVarLinearGradient_instance = new Colrv1Paint('PaintVarLinearGradient', 4);
  Colrv1Paint_PaintRadialGradient_instance = new Colrv1Paint('PaintRadialGradient', 5);
  Colrv1Paint_PaintVarRadialGradient_instance = new Colrv1Paint('PaintVarRadialGradient', 6);
  Colrv1Paint_PaintSweepGradient_instance = new Colrv1Paint('PaintSweepGradient', 7);
  Colrv1Paint_PaintVarSweepGradient_instance = new Colrv1Paint('PaintVarSweepGradient', 8);
  Colrv1Paint_PaintGlyph_instance = new Colrv1Paint('PaintGlyph', 9);
  Colrv1Paint_PaintColrGlyph_instance = new Colrv1Paint('PaintColrGlyph', 10);
  Colrv1Paint_PaintTransform_instance = new Colrv1Paint('PaintTransform', 11);
  Colrv1Paint_PaintVarTransform_instance = new Colrv1Paint('PaintVarTransform', 12);
  Colrv1Paint_PaintTranslate_instance = new Colrv1Paint('PaintTranslate', 13);
  Colrv1Paint_PaintVarTranslate_instance = new Colrv1Paint('PaintVarTranslate', 14);
  Colrv1Paint_PaintScale_instance = new Colrv1Paint('PaintScale', 15);
  Colrv1Paint_PaintVarScale_instance = new Colrv1Paint('PaintVarScale', 16);
  Colrv1Paint_PaintScaleAroundCenter_instance = new Colrv1Paint('PaintScaleAroundCenter', 17);
  Colrv1Paint_PaintVarScaleAroundCenter_instance = new Colrv1Paint('PaintVarScaleAroundCenter', 18);
  Colrv1Paint_PaintScaleUniform_instance = new Colrv1Paint('PaintScaleUniform', 19);
  Colrv1Paint_PaintVarScaleUniform_instance = new Colrv1Paint('PaintVarScaleUniform', 20);
  Colrv1Paint_PaintScaleUniformAroundCenter_instance = new Colrv1Paint('PaintScaleUniformAroundCenter', 21);
  Colrv1Paint_PaintVarScaleUniformAroundCenter_instance = new Colrv1Paint('PaintVarScaleUniformAroundCenter', 22);
  Colrv1Paint_PaintRotate_instance = new Colrv1Paint('PaintRotate', 23);
  Colrv1Paint_PaintVarRotate_instance = new Colrv1Paint('PaintVarRotate', 24);
  Colrv1Paint_PaintRotateAroundCenter_instance = new Colrv1Paint('PaintRotateAroundCenter', 25);
  Colrv1Paint_PaintVarRotateAroundCenter_instance = new Colrv1Paint('PaintVarRotateAroundCenter', 26);
  Colrv1Paint_PaintSkew_instance = new Colrv1Paint('PaintSkew', 27);
  Colrv1Paint_PaintVarSkew_instance = new Colrv1Paint('PaintVarSkew', 28);
  Colrv1Paint_PaintSkewAroundCenter_instance = new Colrv1Paint('PaintSkewAroundCenter', 29);
  Colrv1Paint_PaintVarSkewAroundCenter_instance = new Colrv1Paint('PaintVarSkewAroundCenter', 30);
  Colrv1Paint_PaintComposite_instance = new Colrv1Paint('PaintComposite', 31);
  Companion_getInstance_33();
}
var Companion_instance_23;
function Companion_getInstance_34() {
  return Companion_instance_23;
}
function NameId_COPYRIGHT_getInstance() {
  NameId_initEntries();
  return NameId_COPYRIGHT_instance;
}
function NameId_NAME_getInstance() {
  NameId_initEntries();
  return NameId_NAME_instance;
}
function NameId_STYLE_getInstance() {
  NameId_initEntries();
  return NameId_STYLE_instance;
}
function NameId_UNAME_getInstance() {
  NameId_initEntries();
  return NameId_UNAME_instance;
}
function NameId_COMPLETE_NAME_getInstance() {
  NameId_initEntries();
  return NameId_COMPLETE_NAME_instance;
}
function NameId_RELEASE_VERSION_getInstance() {
  NameId_initEntries();
  return NameId_RELEASE_VERSION_instance;
}
function NameId_POSTSCRIPT_NAME_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_NAME_instance;
}
function NameId_TRADEMARK_getInstance() {
  NameId_initEntries();
  return NameId_TRADEMARK_instance;
}
function NameId_MANUFACTURER_getInstance() {
  NameId_initEntries();
  return NameId_MANUFACTURER_instance;
}
function NameId_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_DESIGNER_instance;
}
function NameId_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_DESCRIPTION_instance;
}
function NameId_URL_VENDOR_getInstance() {
  NameId_initEntries();
  return NameId_URL_VENDOR_instance;
}
function NameId_URL_DESIGNER_getInstance() {
  NameId_initEntries();
  return NameId_URL_DESIGNER_instance;
}
function NameId_LICENSE_DESCRIPTION_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_DESCRIPTION_instance;
}
function NameId_LICENSE_URL_getInstance() {
  NameId_initEntries();
  return NameId_LICENSE_URL_instance;
}
function NameId_RESERVED_15_getInstance() {
  NameId_initEntries();
  return NameId_RESERVED_15_instance;
}
function NameId_PREFERRED_FAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_FAMILY_instance;
}
function NameId_PREFERRED_SUBFAMILY_getInstance() {
  NameId_initEntries();
  return NameId_PREFERRED_SUBFAMILY_instance;
}
function NameId_COMPATIBLE_FULL_getInstance() {
  NameId_initEntries();
  return NameId_COMPATIBLE_FULL_instance;
}
function NameId_SAMPLE_TEXT_getInstance() {
  NameId_initEntries();
  return NameId_SAMPLE_TEXT_instance;
}
function NameId_POSTSCRIPT_CID_getInstance() {
  NameId_initEntries();
  return NameId_POSTSCRIPT_CID_instance;
}
function NameId_WWS_FAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_FAMILY_NAME_instance;
}
function NameId_WWS_SUBFAMILY_NAME_getInstance() {
  NameId_initEntries();
  return NameId_WWS_SUBFAMILY_NAME_instance;
}
function NameId_LIGHT_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_LIGHT_BACKGROUND_instance;
}
function NameId_DARK_BACKGROUND_getInstance() {
  NameId_initEntries();
  return NameId_DARK_BACKGROUND_instance;
}
function NameId_VARIATION_POSTSCRIPT_PREFIX_getInstance() {
  NameId_initEntries();
  return NameId_VARIATION_POSTSCRIPT_PREFIX_instance;
}
function Colrv1Paint_PaintColrLayers_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrLayers_instance;
}
function Colrv1Paint_PaintSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSolid_instance;
}
function Colrv1Paint_PaintVarSolid_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSolid_instance;
}
function Colrv1Paint_PaintLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintLinearGradient_instance;
}
function Colrv1Paint_PaintVarLinearGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarLinearGradient_instance;
}
function Colrv1Paint_PaintRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRadialGradient_instance;
}
function Colrv1Paint_PaintVarRadialGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRadialGradient_instance;
}
function Colrv1Paint_PaintSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSweepGradient_instance;
}
function Colrv1Paint_PaintVarSweepGradient_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSweepGradient_instance;
}
function Colrv1Paint_PaintGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintGlyph_instance;
}
function Colrv1Paint_PaintColrGlyph_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintColrGlyph_instance;
}
function Colrv1Paint_PaintTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTransform_instance;
}
function Colrv1Paint_PaintVarTransform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTransform_instance;
}
function Colrv1Paint_PaintTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintTranslate_instance;
}
function Colrv1Paint_PaintVarTranslate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarTranslate_instance;
}
function Colrv1Paint_PaintScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScale_instance;
}
function Colrv1Paint_PaintVarScale_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScale_instance;
}
function Colrv1Paint_PaintScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleAroundCenter_instance;
}
function Colrv1Paint_PaintScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniform_instance;
}
function Colrv1Paint_PaintVarScaleUniform_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniform_instance;
}
function Colrv1Paint_PaintScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintVarScaleUniformAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarScaleUniformAroundCenter_instance;
}
function Colrv1Paint_PaintRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotate_instance;
}
function Colrv1Paint_PaintVarRotate_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotate_instance;
}
function Colrv1Paint_PaintRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintRotateAroundCenter_instance;
}
function Colrv1Paint_PaintVarRotateAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarRotateAroundCenter_instance;
}
function Colrv1Paint_PaintSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkew_instance;
}
function Colrv1Paint_PaintVarSkew_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkew_instance;
}
function Colrv1Paint_PaintSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintSkewAroundCenter_instance;
}
function Colrv1Paint_PaintVarSkewAroundCenter_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintVarSkewAroundCenter_instance;
}
function Colrv1Paint_PaintComposite_getInstance() {
  Colrv1Paint_initEntries();
  return Colrv1Paint_PaintComposite_instance;
}
var Companion_instance_24;
function Companion_getInstance_35() {
  return Companion_instance_24;
}
function _FWord___init__impl__2rjyqf(data) {
  return data;
}
function _FWord___get_data__impl__9ys4ze($this) {
  return $this;
}
function FWord__toDouble_impl_53j5qp($this) {
  return _FWord___get_data__impl__9ys4ze($this);
}
function *_generator_readTtfFont__nm5tmd(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  var tmp = _this__u8e3s4.o1s($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return TtfFont.f4b(tmp, get_baseName(_this__u8e3s4), onlyReadMetadata, enableLigatures);
}
function readTtfFont(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion) {
  onlyReadMetadata = onlyReadMetadata === VOID ? false : onlyReadMetadata;
  enableLigatures = enableLigatures === VOID ? true : enableLigatures;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readTtfFont__nm5tmd(_this__u8e3s4, onlyReadMetadata, enableLigatures, $completion), $completion);
}
function ss$factory() {
  return getPropertyCallableRef('ss', 1, KProperty1, function (receiver) {
    return _get_ss__ndcawb(receiver);
  }, null);
}
function set_onlyReadVisibleLayers(_this__u8e3s4, _set____db54di) {
  _init_properties_ASE_kt__16anup();
  var this_0 = onlyReadVisibleLayers$delegate;
  var property = onlyReadVisibleLayers$factory();
  var tmp0_elvis_lhs = this_0.vw_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, _set____db54di);
  return Unit_instance;
}
function get_onlyReadVisibleLayers(_this__u8e3s4) {
  _init_properties_ASE_kt__16anup();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = onlyReadVisibleLayers$delegate;
    var property = onlyReadVisibleLayers$factory_0();
    var tmp = _this__u8e3s4.uw();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.vw_1;
      tmp_0 = tmp0_safe_receiver.b3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.ww_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.vw_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.vw_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      tmp$ret$0 = r;
      break $l$block;
    }
    tmp$ret$0 = res;
  }
  return tmp$ret$0;
}
var onlyReadVisibleLayers$delegate;
var Companion_instance_25;
function Companion_getInstance_36() {
  return Companion_instance_25;
}
function ASE$AseSlice$sortKeys$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.AseSlice.sortKeys.<anonymous>' call
  var tmp = a.a4y_1;
  // Inline function 'korlibs.image.format.AseSlice.sortKeys.<anonymous>' call
  var tmp$ret$1 = b.a4y_1;
  return compareValues(tmp, tmp$ret$1);
}
function takeLayersByName(_this__u8e3s4, $this, name) {
  var tmp;
  if (getExtra(_this__u8e3s4, 'layers') == null) {
    tmp = true;
  } else {
    var tmp_0 = getExtra(_this__u8e3s4, 'layers');
    tmp = contains_0((!(tmp_0 == null) ? typeof tmp_0 === 'string' : false) ? tmp_0 : THROW_CCE(), name);
  }
  return tmp;
}
function slicingEnabled(_this__u8e3s4, $this) {
  return getExtraTyped(_this__u8e3s4, 'disableSlicing') == null || !ensureNotNull(getExtraTyped(_this__u8e3s4, 'disableSlicing'));
}
function useSlicePosition(_this__u8e3s4, $this) {
  return !(getExtraTyped(_this__u8e3s4, 'useSlicePosition') == null) && ensureNotNull(getExtraTyped(_this__u8e3s4, 'useSlicePosition'));
}
function readImageContainer$createImageFrameLayer(imageLayers, image, key, value) {
  var resolved = value.o4y();
  var layer = imageLayers.c1(key);
  var tilemap = null;
  if (resolved instanceof AseTilemapCell) {
    var tileset = image.n51_1.c1(layer.s4z_1);
    var tmp = Companion_instance_39;
    tilemap = tmp.o51(resolved.a4z_1, tileset == null ? null : tileset.r50_1, resolved.b4z_1, resolved.c4z_1, resolved.d4z_1, resolved.e4z_1);
  }
  return new ImageFrameLayer(layer, slice_0(resolved.t45()), resolved.m4y(), resolved.n4y(), false, true, tilemap);
}
var ASE_instance;
function ASE_getInstance() {
  if (ASE_instance === VOID)
    ASE.r51();
  return ASE_instance;
}
function _Fixed32___init__impl__8jizkq(raw) {
  return raw;
}
function _Fixed32___get_raw__impl__5vhc8t($this) {
  return $this;
}
function _Fixed32___get_double__impl__wjoyf6($this) {
  return _Fixed32___get_raw__impl__5vhc8t($this) / 65536.0;
}
var Companion_instance_26;
function Companion_getInstance_37() {
  return Companion_instance_26;
}
function onlyReadVisibleLayers$delegate$lambda() {
  _init_properties_ASE_kt__16anup();
  return true;
}
function onlyReadVisibleLayers$factory() {
  return getPropertyCallableRef('onlyReadVisibleLayers', 1, KMutableProperty1, function (receiver) {
    return get_onlyReadVisibleLayers(receiver);
  }, function (receiver, value) {
    return set_onlyReadVisibleLayers(receiver, value);
  });
}
function onlyReadVisibleLayers$factory_0() {
  return getPropertyCallableRef('onlyReadVisibleLayers', 1, KMutableProperty1, function (receiver) {
    return get_onlyReadVisibleLayers(receiver);
  }, function (receiver, value) {
    return set_onlyReadVisibleLayers(receiver, value);
  });
}
var properties_initialized_ASE_kt_jtvwzh;
function _init_properties_ASE_kt__16anup() {
  if (!properties_initialized_ASE_kt_jtvwzh) {
    properties_initialized_ASE_kt_jtvwzh = true;
    // Inline function 'korlibs.datastructure.extraProperty' call
    var default_0 = onlyReadVisibleLayers$delegate$lambda;
    onlyReadVisibleLayers$delegate = new Property(null, default_0);
  }
}
var DataFormat_UBYTE_instance;
var DataFormat_STRING_instance;
var DataFormat_USHORT_instance;
var DataFormat_ULONG_instance;
var DataFormat_URATIO_instance;
var DataFormat_SBYTE_instance;
var DataFormat_UNDEFINED_instance;
var DataFormat_SSHORT_instance;
var DataFormat_SLONG_instance;
var DataFormat_SRATIO_instance;
var DataFormat_SFLOAT_instance;
var DataFormat_DFLOAT_instance;
var DataFormat_UNKNOWN_instance;
var Companion_instance_27;
function Companion_getInstance_38() {
  DataFormat_initEntries();
  if (Companion_instance_27 === VOID)
    new Companion_21();
  return Companion_instance_27;
}
function values_4() {
  return [DataFormat_UBYTE_getInstance(), DataFormat_STRING_getInstance(), DataFormat_USHORT_getInstance(), DataFormat_ULONG_getInstance(), DataFormat_URATIO_getInstance(), DataFormat_SBYTE_getInstance(), DataFormat_UNDEFINED_getInstance(), DataFormat_SSHORT_getInstance(), DataFormat_SLONG_getInstance(), DataFormat_SRATIO_getInstance(), DataFormat_SFLOAT_getInstance(), DataFormat_DFLOAT_getInstance(), DataFormat_UNKNOWN_getInstance()];
}
function EXIF$DataFormat$lambda(it) {
  return it;
}
function EXIF$DataFormat$lambda_0(it) {
  return 4;
}
function EXIF$DataFormat$lambda_1(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_2(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_3(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_4(it) {
  return it;
}
function EXIF$DataFormat$lambda_5(it) {
  return it;
}
function EXIF$DataFormat$lambda_6(it) {
  return imul(it, 2);
}
function EXIF$DataFormat$lambda_7(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_8(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_9(it) {
  return imul(it, 4);
}
function EXIF$DataFormat$lambda_10(it) {
  return imul(it, 8);
}
function EXIF$DataFormat$lambda_11(it) {
  return 0;
}
var DataFormat_entriesInitialized;
function DataFormat_initEntries() {
  if (DataFormat_entriesInitialized)
    return Unit_instance;
  DataFormat_entriesInitialized = true;
  DataFormat_UBYTE_instance = new DataFormat('UBYTE', 0, 1, EXIF$DataFormat$lambda);
  DataFormat_STRING_instance = new DataFormat('STRING', 1, 2, EXIF$DataFormat$lambda_0);
  DataFormat_USHORT_instance = new DataFormat('USHORT', 2, 3, EXIF$DataFormat$lambda_1);
  DataFormat_ULONG_instance = new DataFormat('ULONG', 3, 4, EXIF$DataFormat$lambda_2);
  DataFormat_URATIO_instance = new DataFormat('URATIO', 4, 5, EXIF$DataFormat$lambda_3);
  DataFormat_SBYTE_instance = new DataFormat('SBYTE', 5, 6, EXIF$DataFormat$lambda_4);
  DataFormat_UNDEFINED_instance = new DataFormat('UNDEFINED', 6, 7, EXIF$DataFormat$lambda_5);
  DataFormat_SSHORT_instance = new DataFormat('SSHORT', 7, 8, EXIF$DataFormat$lambda_6);
  DataFormat_SLONG_instance = new DataFormat('SLONG', 8, 9, EXIF$DataFormat$lambda_7);
  DataFormat_SRATIO_instance = new DataFormat('SRATIO', 9, 10, EXIF$DataFormat$lambda_8);
  DataFormat_SFLOAT_instance = new DataFormat('SFLOAT', 10, 11, EXIF$DataFormat$lambda_9);
  DataFormat_DFLOAT_instance = new DataFormat('DFLOAT', 11, 12, EXIF$DataFormat$lambda_10);
  DataFormat_UNKNOWN_instance = new DataFormat('UNKNOWN', 12, -1, EXIF$DataFormat$lambda_11);
  Companion_getInstance_38();
}
function *_generator_readExifBase__4npesx($this, ss, info, debug, $completion) {
  var tmp = sliceHere(ss, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var s = tmp;
  var tmp_0 = readString_0(s, 2, Charsets_instance.bs(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  var start = tmp_0;
  var tmp_1;
  switch (start) {
    case 'MM':
      tmp_1 = Endian_BIG_ENDIAN_getInstance();
      break;
    case 'II':
      tmp_1 = Endian_LITTLE_ENDIAN_getInstance();
      break;
    default:
      var message = "Not Exif data (not starting with MM or II but '" + start + "')";
      throw IllegalStateException.w4(toString_0(message));
  }
  var endian = tmp_1;
  var tmp_2 = readU16(s, endian, $completion);
  if (tmp_2 === get_COROUTINE_SUSPENDED())
    tmp_2 = yield tmp_2;
  var tagMark = tmp_2;
  var tmp_3 = readS32(s, endian, $completion);
  if (tmp_3 === get_COROUTINE_SUSPENDED())
    tmp_3 = yield tmp_3;
  var offsetFirstIFD = tmp_3;
  var tmp_4 = readU16(s, endian, $completion);
  if (tmp_4 === get_COROUTINE_SUSPENDED())
    tmp_4 = yield tmp_4;
  var nDirEntry = tmp_4;
  if (debug) {
    // Inline function 'korlibs.logger.Logger.error' call
    var this_0 = $this.d54_1;
    var level = Level_ERROR_getInstance();
    var tmp_5;
    if (this_0.m2q(level)) {
      // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
      var tmp$ret$0 = 'nDirEntry=' + nDirEntry + ', tagMark=' + tagMark + ', offsetFirstFID=' + offsetFirstIFD;
      this_0.n2q(level, tmp$ret$0);
      tmp_5 = Unit_instance;
    }
  }
  var inductionVariable = 0;
  if (inductionVariable < nDirEntry)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var tagPos = s.u1k_1.i2();
      var tmp_6 = readU16(s, endian, $completion);
      if (tmp_6 === get_COROUTINE_SUSPENDED())
        tmp_6 = yield tmp_6;
      var tagNumber = tmp_6;
      var tmp_7 = Companion_getInstance_38();
      var tmp_8 = readU16(s, endian, $completion);
      if (tmp_8 === get_COROUTINE_SUSPENDED())
        tmp_8 = yield tmp_8;
      var dataFormat = tmp_7.c1(tmp_8);
      var tmp_9 = readS32(s, endian, $completion);
      if (tmp_9 === get_COROUTINE_SUSPENDED())
        tmp_9 = yield tmp_9;
      var nComponent = tmp_9;
      if (debug) {
        // Inline function 'korlibs.logger.Logger.error' call
        var this_1 = $this.d54_1;
        var level_0 = Level_ERROR_getInstance();
        var tmp_10;
        if (this_1.m2q(level_0)) {
          // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
          var tmp$ret$2 = 'tagPos=' + get_hex(tagPos) + ', tagNumber=' + get_hex(tagNumber) + ', dataFormat=' + dataFormat.toString() + ', nComponent=' + nComponent + ', size=' + dataFormat.b54_1(nComponent);
          this_1.n2q(level_0, tmp$ret$2);
          tmp_10 = Unit_instance;
        }
      }
      var tmp_11 = readBytesExact_0(s, dataFormat.b54_1(nComponent), $completion);
      if (tmp_11 === get_COROUTINE_SUSPENDED())
        tmp_11 = yield tmp_11;
      var data = tmp_11;
      if (debug) {
        if (dataFormat.equals(DataFormat_STRING_getInstance())) {
          // Inline function 'korlibs.logger.Logger.error' call
          var this_2 = $this.d54_1;
          var level_1 = Level_ERROR_getInstance();
          var tmp_12;
          if (this_2.m2q(level_1)) {
            // Inline function 'korlibs.image.format.EXIF.readExifBase.<anonymous>' call
            var tmp_13 = sliceStart(s, toLong(readExifBase$readInt(data, endian, 0)), VOID, $completion);
            if (tmp_13 === get_COROUTINE_SUSPENDED())
              tmp_13 = yield tmp_13;
            var tmp_14 = readStringz(tmp_13, nComponent, VOID, $completion);
            if (tmp_14 === get_COROUTINE_SUSPENDED())
              tmp_14 = yield tmp_14;
            var tmp$ret$4 = "  - '" + tmp_14 + "'";
            this_2.n2q(level_1, tmp$ret$4);
            tmp_12 = Unit_instance;
          }
        }
      }
      if (tagNumber === 274) {
        var tmp_15;
        switch (readExifBase$readUShort(data, endian, 0)) {
          case 1:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_1().d38_1;
            break;
          case 2:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_HORIZONTAL' call

            tmp_15 = Companion_getInstance_1().h38_1;
            break;
          case 3:
            tmp_15 = Companion_getInstance_1().f38_1;
            break;
          case 4:
            // Inline function 'korlibs.math.geom.slice.Companion.MIRROR_VERTICAL' call

            tmp_15 = Companion_getInstance_1().j38_1;
            break;
          case 5:
            tmp_15 = Companion_getInstance_1().k38_1;
            break;
          case 6:
            tmp_15 = Companion_getInstance_1().e38_1;
            break;
          case 7:
            tmp_15 = Companion_getInstance_1().i38_1;
            break;
          case 8:
            tmp_15 = Companion_getInstance_1().g38_1;
            break;
          default:
            // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call

            tmp_15 = Companion_getInstance_1().d38_1;
            break;
        }
        set_orientation(info, tmp_15);
      }
      skipToAlign(s, 4, 2);
    }
     while (inductionVariable < nDirEntry);
  return info;
}
function readExifBase$readUShort(data, endian, index) {
  return getU16(data, imul(index, 2), endian.fq());
}
function readExifBase$readInt(data, endian, index) {
  return getS32(data, imul(index, 4), endian.fq());
}
function DataFormat_UBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UBYTE_instance;
}
function DataFormat_STRING_getInstance() {
  DataFormat_initEntries();
  return DataFormat_STRING_instance;
}
function DataFormat_USHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_USHORT_instance;
}
function DataFormat_ULONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_ULONG_instance;
}
function DataFormat_URATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_URATIO_instance;
}
function DataFormat_SBYTE_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SBYTE_instance;
}
function DataFormat_UNDEFINED_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNDEFINED_instance;
}
function DataFormat_SSHORT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SSHORT_instance;
}
function DataFormat_SLONG_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SLONG_instance;
}
function DataFormat_SRATIO_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SRATIO_instance;
}
function DataFormat_SFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_SFLOAT_instance;
}
function DataFormat_DFLOAT_getInstance() {
  DataFormat_initEntries();
  return DataFormat_DFLOAT_instance;
}
function DataFormat_UNKNOWN_getInstance() {
  DataFormat_initEntries();
  return DataFormat_UNKNOWN_instance;
}
var EXIF_instance;
function EXIF_getInstance() {
  if (EXIF_instance === VOID)
    new EXIF();
  return EXIF_instance;
}
var Direction_ONCE_FORWARD_instance;
var Direction_ONCE_REVERSE_instance;
var Direction_FORWARD_instance;
var Direction_REVERSE_instance;
var Direction_PING_PONG_instance;
var Direction_entriesInitialized;
function Direction_initEntries() {
  if (Direction_entriesInitialized)
    return Unit_instance;
  Direction_entriesInitialized = true;
  Direction_ONCE_FORWARD_instance = new Direction('ONCE_FORWARD', 0);
  Direction_ONCE_REVERSE_instance = new Direction('ONCE_REVERSE', 1);
  Direction_FORWARD_instance = new Direction('FORWARD', 2);
  Direction_REVERSE_instance = new Direction('REVERSE', 3);
  Direction_PING_PONG_instance = new Direction('PING_PONG', 4);
}
function ImageAnimation$_init_$lambda_bxp50i(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp = a.v52_1;
  // Inline function 'korlibs.image.format.ImageAnimation.<init>.<anonymous>' call
  var tmp$ret$1 = b.v52_1;
  return compareValues(tmp, tmp$ret$1);
}
function Direction_FORWARD_getInstance() {
  Direction_initEntries();
  return Direction_FORWARD_instance;
}
function Direction_REVERSE_getInstance() {
  Direction_initEntries();
  return Direction_REVERSE_instance;
}
function Direction_PING_PONG_getInstance() {
  Direction_initEntries();
  return Direction_PING_PONG_instance;
}
var Companion_instance_28;
function Companion_getInstance_39() {
  return Companion_instance_28;
}
function ImageData$framesSortedByPriority$lambda(a, b) {
  // Inline function 'kotlin.comparisons.compareValuesBy' call
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp;
  if (b.q54()) {
    tmp = 2147483647;
  } else {
    tmp = imul(imul(b.p54().n2d(), b.p54().o2d()), imul(b.p54().x3m(), b.p54().x3m()));
  }
  var tmp_0 = tmp;
  // Inline function 'korlibs.image.format.ImageData.framesSortedByPriority.<anonymous>' call
  var tmp_1;
  if (a.q54()) {
    tmp_1 = 2147483647;
  } else {
    tmp_1 = imul(imul(a.p54().n2d(), a.p54().o2d()), imul(a.p54().x3m(), a.p54().x3m()));
  }
  var tmp$ret$1 = tmp_1;
  return compareValues(tmp_0, tmp$ret$1);
}
var Companion_instance_29;
function Companion_getInstance_40() {
  if (Companion_instance_29 === VOID)
    new Companion_23();
  return Companion_instance_29;
}
function *_generator_decode__skqvkq($this, file, props, $completion) {
  var tmp = readAsSyncStream(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.s53(tmp, props.j55(file));
}
function ImageFormat$decodingProps$delegate$lambda(this$0) {
  return function () {
    return toProps(this$0);
  };
}
function toProps(_this__u8e3s4, props) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  return props.i55(VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, VOID, _this__u8e3s4);
}
function decodingProps$factory() {
  return getPropertyCallableRef('decodingProps', 1, KProperty1, function (receiver) {
    return receiver.r53();
  }, null);
}
function *_generator_decodeSuspend__fioeme($this, data, props, $completion) {
  var tmp$ret$1;
  $l$block: {
    // Inline function 'korlibs.image.format.ImageFormats.readImageTyped' call
    var s = openSync(data);
    var _iterator__ex2g4s = $this.p55().z();
    while (_iterator__ex2g4s.a1()) {
      var format = _iterator__ex2g4s.b1();
      if (format.t53(sliceStart_0(s), props)) {
        // Inline function 'korlibs.image.format.ImageFormats.decodeSuspend.<anonymous>' call
        sliceStart_0(s);
        var tmp = format.x53(data, props, $completion);
        if (tmp === get_COROUTINE_SUSPENDED())
          tmp = yield tmp;
        tmp$ret$1 = tmp;
        break $l$block;
      }
    }
    throw UnsupportedOperationException.x9('No suitable image format : MAGIC:' + readString_1(sliceStart_0(s), 4, ASCII_getInstance()) + '(' + get_hex_0(readBytes(sliceStart_0(s), 4)) + ') (' + toString_2(readBytes(sliceStart_0(s), 4), ASCII_getInstance()) + ')');
  }
  return tmp$ret$1;
}
function listFormats(_this__u8e3s4) {
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination = ArrayList.p1();
  var tmp0_iterator = _this__u8e3s4.z();
  while (tmp0_iterator.a1()) {
    var element = tmp0_iterator.b1();
    // Inline function 'korlibs.image.format.listFormats.<anonymous>' call
    var list = listFormats_0(element);
    addAll(destination, list);
  }
  return toMutableSet(destination);
}
function listFormats_0(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof ImageFormats) {
    tmp = _this__u8e3s4.p55();
  } else {
    tmp = setOf_0(_this__u8e3s4);
  }
  return tmp;
}
function _formats$factory() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.t55();
  }, function (receiver, value) {
    return receiver.s55(value);
  });
}
function _formats$factory_0() {
  return getPropertyCallableRef('_formats', 1, KMutableProperty1, function (receiver) {
    return receiver.t55();
  }, function (receiver, value) {
    return receiver.s55(value);
  });
}
var Companion_instance_30;
function Companion_getInstance_41() {
  return Companion_instance_30;
}
var Type_NORMAL_instance;
var Type_GROUP_instance;
var Type_TILEMAP_instance;
var Companion_instance_31;
function Companion_getInstance_42() {
  Type_initEntries();
  if (Companion_instance_31 === VOID)
    new Companion_25();
  return Companion_instance_31;
}
var Type_entriesInitialized;
function Type_initEntries() {
  if (Type_entriesInitialized)
    return Unit_instance;
  Type_entriesInitialized = true;
  Type_NORMAL_instance = new Type('NORMAL', 0);
  Type_GROUP_instance = new Type('GROUP', 1);
  Type_TILEMAP_instance = new Type('TILEMAP', 2);
  Companion_getInstance_42();
}
function Type_NORMAL_getInstance() {
  Type_initEntries();
  return Type_NORMAL_instance;
}
function Type_GROUP_getInstance() {
  Type_initEntries();
  return Type_GROUP_instance;
}
function Type_TILEMAP_getInstance() {
  Type_initEntries();
  return Type_TILEMAP_instance;
}
function set_orientation(_this__u8e3s4, _set____db54di) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var this_0 = orientation$delegate;
  var property = orientation$factory();
  var tmp = _set____db54di;
  var value = tmp == null ? null : new SliceOrientation(tmp);
  var tmp0_elvis_lhs = this_0.vw_1;
  setExtra(_this__u8e3s4, tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs, value);
  return Unit_instance;
}
function get_orientation(_this__u8e3s4) {
  _init_properties_ImageOrientation_kt__rodtsl();
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.datastructure.Property.getValue' call
    var this_0 = orientation$delegate;
    var property = orientation$factory_0();
    var tmp = _this__u8e3s4.uw();
    var tmp0_safe_receiver = (!(tmp == null) ? isInterface(tmp, KtMutableMap) : false) ? tmp : null;
    var tmp_0;
    if (tmp0_safe_receiver == null) {
      tmp_0 = null;
    } else {
      var tmp0_elvis_lhs = this_0.vw_1;
      tmp_0 = tmp0_safe_receiver.b3(tmp0_elvis_lhs == null ? property.callableName : tmp0_elvis_lhs);
    }
    var res = tmp_0;
    if (res == null) {
      var r = this_0.ww_1();
      var tmp_1;
      if (!(r == null)) {
        tmp_1 = true;
      } else {
        var tmp1_elvis_lhs = this_0.vw_1;
        tmp_1 = hasExtra(_this__u8e3s4, tmp1_elvis_lhs == null ? property.callableName : tmp1_elvis_lhs);
      }
      if (tmp_1) {
        // Inline function 'korlibs.datastructure.Property.setValue' call
        var tmp0_elvis_lhs_0 = this_0.vw_1;
        setExtra(_this__u8e3s4, tmp0_elvis_lhs_0 == null ? property.callableName : tmp0_elvis_lhs_0, r);
      }
      var tmp_2 = r;
      tmp$ret$0 = tmp_2 == null ? null : tmp_2.m38_1;
      break $l$block;
    }
    var tmp_3 = res;
    tmp$ret$0 = tmp_3 == null ? null : tmp_3.m38_1;
  }
  return tmp$ret$0;
}
var orientation$delegate;
function orientation$delegate$lambda() {
  _init_properties_ImageOrientation_kt__rodtsl();
  return null;
}
function orientation$factory() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.m38_1);
  });
}
function orientation$factory_0() {
  return getPropertyCallableRef('orientation', 1, KMutableProperty1, function (receiver) {
    var tmp = get_orientation(receiver);
    return tmp == null ? null : new SliceOrientation(tmp);
  }, function (receiver, value) {
    var tmp = value;
    return set_orientation(receiver, tmp == null ? null : tmp.m38_1);
  });
}
var properties_initialized_ImageOrientation_kt_37wzbr;
function _init_properties_ImageOrientation_kt__rodtsl() {
  if (!properties_initialized_ImageOrientation_kt_37wzbr) {
    properties_initialized_ImageOrientation_kt_37wzbr = true;
    orientation$delegate = new Property(VOID, orientation$delegate$lambda);
  }
}
function get_imageLoadingLogger() {
  _init_properties_KorioExt_kt__tiega5();
  return imageLoadingLogger;
}
var imageLoadingLogger;
function readBitmapSlice(_this__u8e3s4, name, atlas, props, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  return readBitmapSlice_0(_this__u8e3s4, props, name, atlas, $completion);
}
function readBitmap(_this__u8e3s4, props, $completion) {
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  return _readBitmap(_this__u8e3s4, VOID, props.r53(), $completion);
}
function *_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  var tmp = readBitmap(_this__u8e3s4, bprops, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var result = tmp;
  return !(atlas == null) ? atlas.d3m(result.d3u(), Unit_instance, name).w3k_1 : slice_0(result, VOID, name);
}
function readBitmapSlice_0(_this__u8e3s4, bprops, name, atlas, $completion) {
  name = name === VOID ? null : name;
  atlas = atlas === VOID ? null : atlas;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmapSlice__1cfrfr(_this__u8e3s4, bprops, name, atlas, $completion), $completion);
}
function *_generator__readBitmap__syf68g(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  var prop = !(file == null) ? props.j55(file) : props;
  var rformats = !prop.o52_1 ? listOf_0(prop.p52_1) : prop.p52_1 == null ? listOf_0(null) : prop.n52_1 ? listOf([prop.p52_1, null]) : listOf([null, prop.p52_1]);
  var lastError = null;
  var _iterator__ex2g4s = rformats.z();
  while (_iterator__ex2g4s.a1()) {
    var format = _iterator__ex2g4s.b1();
    try {
      var rformat = format == null ? get_nativeImageFormatProvider() : format;
      var tmp;
      if (!(bytes == null)) {
        var tmp_0 = rformat.x53(bytes, prop, $completion);
        if (tmp_0 === get_COROUTINE_SUSPENDED())
          tmp_0 = yield tmp_0;
        tmp = tmp_0;
      } else if (!(file == null)) {
        var tmp_1 = rformat.w53(file, prop, $completion);
        if (tmp_1 === get_COROUTINE_SUSPENDED())
          tmp_1 = yield tmp_1;
        tmp = tmp_1;
      } else {
        throw NotImplementedError.nd();
      }
      var bmp = tmp;
      // Inline function 'kotlin.also' call
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
      if (prop.k52_1) {
        asumePremultiplied(bmp);
      }
      return bmp;
    } catch ($p) {
      if ($p instanceof Error) {
        var e = $p;
        lastError = e;
        if (e instanceof CancellationException)
          throw e;
        else {
          var tmp_2;
          if (e instanceof FileNotFoundException) {
            tmp_2 = true;
          } else {
            tmp_2 = e instanceof ImageDecoderNotFoundException;
          }
          if (!tmp_2) {
            // Inline function 'korlibs.logger.Logger.info' call
            var this_0 = get_imageLoadingLogger();
            var level = Level_INFO_getInstance();
            var tmp_3;
            if (this_0.m2q(level)) {
              // Inline function 'korlibs.image.format._readBitmap.<anonymous>' call
              this_0.n2q(level, e);
              tmp_3 = Unit_instance;
            }
          }
        }
      } else {
        throw $p;
      }
    }
  }
  throw ensureNotNull(lastError);
}
function _readBitmap(file, bytes, props, $completion) {
  file = file === VOID ? null : file;
  bytes = bytes === VOID ? null : bytes;
  props = props === VOID ? Companion_getInstance_40().r48_1 : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator__readBitmap__syf68g(file, bytes, props, $completion), $completion);
}
function *_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  var tmp = readAll(_this__u8e3s4, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = _readBitmap(VOID, tmp, props.r53(), $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function readBitmap_0(_this__u8e3s4, props, $completion) {
  props = props === VOID ? new ImageDecodingProps('file.bin') : props;
  return suspendOrReturn(/*#__NOINLINE__*/_generator_readBitmap__ml2xmr(_this__u8e3s4, props, $completion), $completion);
}
var properties_initialized_KorioExt_kt_kjvlu9;
function _init_properties_KorioExt_kt__tiega5() {
  if (!properties_initialized_KorioExt_kt_kjvlu9) {
    properties_initialized_KorioExt_kt_kjvlu9 = true;
    imageLoadingLogger = Companion_getInstance_15().us('ImageLoading');
  }
}
function *_generator_decodeInternal__jnwsgt($this, vfs, path, props, $completion) {
  var tmp = vfs.b1s(path).p1s($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.h56(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
function *_generator_decodeSuspend__fioeme_0($this, data, props, $completion) {
  var tmp = $this.h56(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.d57_1;
}
function *_generator_decode__skqvkq_0($this, file, props, $completion) {
  var tmp = $this.b57(file.f1q(), file.l1q(), props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return tmp.d57_1;
}
function *_generator_decode__skqvkq_1($this, file, props, $completion) {
  var tmp = getUnderlyingUnscapedFile(file, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  var tmp_0 = $this.c57(tmp, props, $completion);
  if (tmp_0 === get_COROUTINE_SUSPENDED())
    tmp_0 = yield tmp_0;
  return tmp_0;
}
var Colorspace_GRAYSCALE_instance;
var Colorspace_RGB_instance;
var Colorspace_INDEXED_instance;
var Colorspace_GRAYSCALE_ALPHA_instance;
var Colorspace_RGBA_instance;
var Companion_instance_32;
function Companion_getInstance_43() {
  Colorspace_initEntries();
  if (Companion_instance_32 === VOID)
    new Companion_26();
  return Companion_instance_32;
}
function values_5() {
  return [Colorspace_GRAYSCALE_getInstance(), Colorspace_RGB_getInstance(), Colorspace_INDEXED_getInstance(), Colorspace_GRAYSCALE_ALPHA_getInstance(), Colorspace_RGBA_getInstance()];
}
var Colorspace_entriesInitialized;
function Colorspace_initEntries() {
  if (Colorspace_entriesInitialized)
    return Unit_instance;
  Colorspace_entriesInitialized = true;
  Colorspace_GRAYSCALE_instance = new Colorspace('GRAYSCALE', 0, 0, 1);
  Colorspace_RGB_instance = new Colorspace('RGB', 1, 2, 3);
  Colorspace_INDEXED_instance = new Colorspace('INDEXED', 2, 3, 1);
  Colorspace_GRAYSCALE_ALPHA_instance = new Colorspace('GRAYSCALE_ALPHA', 3, 4, 2);
  Colorspace_RGBA_instance = new Colorspace('RGBA', 4, 6, 4);
  Companion_getInstance_43();
}
function readCommon($this, s, readHeader, info) {
  var magic = readS32BE(s);
  if (!(magic === -1991225785))
    throw IllegalArgumentException.l('Invalid PNG file magic: ' + get_hex(magic) + '!=' + get_hex(-1991225785));
  readS32BE(s);
  var pheader = {_v: null};
  var pngdata = ByteArrayBuilder.mp();
  var rgbPalette = _UByteArrayInt___init__impl__xif7bu_0(768);
  var tmp = 0;
  var tmp_0 = new Int8Array(256);
  while (tmp < 256) {
    tmp_0[tmp] = -1;
    tmp = tmp + 1 | 0;
  }
  var aPalette = _UByteArrayInt___init__impl__xif7bu(tmp_0);
  var paletteCount = {_v: 0};
  while (!get_eof(s) && readCommon$readChunk(s, pheader, info, paletteCount, rgbPalette, aPalette, readHeader, pngdata)) {
  }
  if (readHeader)
    return pheader._v;
  var tmp0_elvis_lhs = pheader._v;
  var tmp_1;
  if (tmp0_elvis_lhs == null) {
    throw IllegalArgumentException.l('PNG without header!');
  } else {
    tmp_1 = tmp0_elvis_lhs;
  }
  var header = tmp_1;
  var width = header.u57_1;
  var height = header.v57_1;
  var outputSizeHint = imul(imul(1 + width | 0, height), header.b58_1);
  var databb = uncompress(pngdata.rp(), Companion_getInstance_14());
  var databbp = 0;
  var context = new DecodingContext(header);
  var bpp = context.d58_1.b58_1;
  var row32 = context.g58_1;
  var tmp_2;
  if (header.b58_1 === 1) {
    // Inline function 'kotlin.collections.map' call
    var this_0 = until(0, paletteCount._v);
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.format.PNG.readCommon.<anonymous>' call
      var tmp$ret$1 = _RGBA___get_value__impl__hhco8v(Companion_getInstance_23().c43(UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 0 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 1 | 0), UByteArrayInt__get_impl_px6q8a(rgbPalette, imul(item, 3) + 2 | 0), UByteArrayInt__get_impl_px6q8a(aPalette, item)));
      destination.f(tmp$ret$1);
    }
    tmp_2 = Bitmap8.l3x(width, height, VOID, _RgbaArray___init__impl__oib4y4(toIntArray_0(destination)));
  } else {
    tmp_2 = Bitmap32.z3l(width, height, VOID, false);
  }
  var bmp = tmp_2;
  var bmp8 = bmp instanceof Bitmap8 ? bmp : null;
  var bmp32 = bmp instanceof Bitmap32 ? bmp : null;
  var passes = header.a58_1 === 1 ? $this.l58_1 : $this.m58_1;
  var _iterator__ex2g4s = passes.z();
  while (_iterator__ex2g4s.a1()) {
    var pass = _iterator__ex2g4s.b1();
    var progression = step(until(pass.n57_1, height), pass.p57_1);
    var inductionVariable = progression.c2_1;
    var last = progression.d2_1;
    var step_0 = progression.e2_1;
    if (step_0 > 0 && inductionVariable <= last || (step_0 < 0 && last <= inductionVariable))
      do {
        var row = inductionVariable;
        inductionVariable = inductionVariable + step_0 | 0;
        var col = pass.o57_1;
        var colIncrement = pass.q57_1;
        var pixelsInThisRow = width >>> pass.t57_1 | 0;
        var bytesInThisRow = imul(imul(pixelsInThisRow, header.b58_1), header.w57_1) / 8 | 0;
        var _unary__edvuaz = databbp;
        databbp = _unary__edvuaz + 1 | 0;
        var filter = databb[_unary__edvuaz] & 255;
        var currentRow = context.f58_1;
        var lastRow = context.e58_1;
        arraycopy_0(databb, databbp, asByteArray(currentRow), 0, bytesInThisRow);
        databbp = databbp + bytesInThisRow | 0;
        if (!(bmp8 == null)) {
          $this.o58(filter, lastRow, currentRow, header.b58_1);
          switch (header.w57_1) {
            case 1:
              var inductionVariable_0 = 0;
              if (inductionVariable_0 < width)
                do {
                  var n = inductionVariable_0;
                  inductionVariable_0 = inductionVariable_0 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x = col + n | 0;
                  var y = row;
                  var color = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n / 8 | 0), 7 - imul(n % 8 | 0, 1) | 0, 1);
                  bmp.c3t(x, y, color);
                }
                 while (inductionVariable_0 < width);
              break;
            case 2:
              var inductionVariable_1 = 0;
              if (inductionVariable_1 < width)
                do {
                  var n_0 = inductionVariable_1;
                  inductionVariable_1 = inductionVariable_1 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_0 = col + n_0 | 0;
                  var y_0 = row;
                  var color_0 = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n_0 / 4 | 0), 6 - imul(n_0 % 4 | 0, 2) | 0, 2);
                  bmp.c3t(x_0, y_0, color_0);
                }
                 while (inductionVariable_1 < width);
              break;
            case 4:
              var inductionVariable_2 = 0;
              if (inductionVariable_2 < width)
                do {
                  var n_1 = inductionVariable_2;
                  inductionVariable_2 = inductionVariable_2 + 1 | 0;
                  // Inline function 'korlibs.image.bitmap.BitmapIndexed.set' call
                  var x_1 = col + n_1 | 0;
                  var y_1 = row;
                  var color_1 = extract(UByteArrayInt__get_impl_px6q8a(currentRow, n_1 / 2 | 0), 4 - imul(n_1 % 2 | 0, 4) | 0, 4);
                  bmp.c3t(x_1, y_1, color_1);
                }
                 while (inductionVariable_2 < width);
              break;
            case 8:
              bmp8.b3y(col, row, asByteArray(currentRow), width, colIncrement);
              break;
            default:
              // Inline function 'kotlin.error' call

              var message = 'Unsupported header.bitsPerChannel=' + header.w57_1;
              throw IllegalStateException.w4(toString_0(message));
          }
        } else if (!(bmp32 == null)) {
          if (header.w57_1 === 8) {
            $this.n58(filter, lastRow, currentRow, bpp, bytesInThisRow);
            switch (bpp) {
              case 3:
                decode(Companion_getInstance_21(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              case 4:
                decode(Companion_getInstance_23(), asByteArray(currentRow), 0, row32, 0, pixelsInThisRow);
                break;
              default:
                // Inline function 'kotlin.TODO' call

                var reason = 'Bytes: ' + bpp;
                throw NotImplementedError.nd('An operation is not implemented: ' + reason);
            }
            bmp32.r3x(col, row, row32, width, colIncrement);
          } else {
            // Inline function 'kotlin.error' call
            var message_0 = 'Unsupported header.bitsPerChannel=' + header.w57_1;
            throw IllegalStateException.w4(toString_0(message_0));
          }
        }
        context.p58();
      }
       while (!(row === last));
  }
  return bmp;
}
function readCommon$default($this, s, readHeader, info, $super) {
  info = info === VOID ? new ImageInfo() : info;
  return readCommon($this, s, readHeader, info);
}
function readCommon$readChunk(_this__u8e3s4, pheader, $info, paletteCount, rgbPalette, aPalette, $readHeader, pngdata) {
  if (get_eof(_this__u8e3s4))
    return false;
  var length = readS32BE(_this__u8e3s4);
  var type = readStringz_0(_this__u8e3s4, 4);
  var data = readStream_0(_this__u8e3s4, toLong(length));
  var crc = readS32BE(_this__u8e3s4);
  switch (type) {
    case 'IHDR':
      // Inline function 'kotlin.run' call

      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>' call

      // Inline function 'kotlin.also' call

      var tmp = readS32BE(data);
      var tmp_0 = readS32BE(data);
      var tmp_1 = readU8(data);
      var tmp0_elvis_lhs = Companion_getInstance_43().m57_1.b3(readU8(data));
      var this_0 = new Header(tmp, tmp_0, tmp_1, tmp0_elvis_lhs == null ? Colorspace_RGBA_getInstance() : tmp0_elvis_lhs, readU8(data), readU8(data), readU8(data));
      // Inline function 'kotlin.contracts.contract' call

      // Inline function 'korlibs.image.format.PNG.readCommon.readChunk.<anonymous>.<anonymous>' call

      $info.x51_1 = this_0.u57_1;
      $info.y51_1 = this_0.v57_1;
      $info.z51_1 = imul(this_0.w57_1, this_0.x57_1.l57_1);
      pheader._v = this_0;
      break;
    case 'PLTE':
      // Inline function 'kotlin.math.max' call

      var a = paletteCount._v;
      var b = data.a().i2() / 3 | 0;
      paletteCount._v = Math.max(a, b);
      data.rv(asByteArray(rgbPalette), 0, data.a().i2());
      break;
    case 'tRNS':
      // Inline function 'kotlin.math.max' call

      var a_0 = paletteCount._v;
      var b_0 = data.a().i2();
      paletteCount._v = Math.max(a_0, b_0);
      data.rv(asByteArray(aPalette), 0, data.a().i2());
      break;
    case 'IDAT':
      if ($readHeader) {
        return false;
      }

      pngdata.pp(readAll_0(data));
      break;
    case 'eXIf':
      runBlockingNoSuspensions(PNG$readCommon$readChunk$slambda_0(data, $info));
      break;
    case 'IEND':
      return false;
  }
  return true;
}
function PNG$readCommon$readChunk$slambda_0($data, $info) {
  var i = new PNG$readCommon$readChunk$slambda($data, $info);
  var l = function ($completion) {
    return i.od($completion);
  };
  l.$arity = 0;
  return l;
}
function Colorspace_GRAYSCALE_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_instance;
}
function Colorspace_RGB_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGB_instance;
}
function Colorspace_INDEXED_getInstance() {
  Colorspace_initEntries();
  return Colorspace_INDEXED_instance;
}
function Colorspace_GRAYSCALE_ALPHA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_GRAYSCALE_ALPHA_instance;
}
function Colorspace_RGBA_getInstance() {
  Colorspace_initEntries();
  return Colorspace_RGBA_instance;
}
var PNG_instance;
function PNG_getInstance() {
  if (PNG_instance === VOID)
    PNG.s58();
  return PNG_instance;
}
function get_RegisteredImageFormats() {
  _init_properties_RegisteredImageFormats_kt__dq34zn();
  return RegisteredImageFormats;
}
var RegisteredImageFormats;
var properties_initialized_RegisteredImageFormats_kt_ribwxx;
function _init_properties_RegisteredImageFormats_kt__dq34zn() {
  if (!properties_initialized_RegisteredImageFormats_kt_ribwxx) {
    properties_initialized_RegisteredImageFormats_kt_ribwxx = true;
    RegisteredImageFormats = ImageFormatsMutable.a56();
  }
}
function sumPacked4MulR(a, b, mul) {
  var dstRB = imul(b & 16711935, mul) >>> 8 | 0;
  var dstGA = imul((b >>> 8 | 0) & 16711935, mul) >>> 8 | 0;
  var r = ((a >>> 0 | 0) & 255) + ((dstRB >>> 0 | 0) & 255) | 0;
  var g = ((a >>> 8 | 0) & 255) + ((dstGA >>> 0 | 0) & 255) | 0;
  var b_0 = ((a >>> 16 | 0) & 255) + ((dstRB >>> 16 | 0) & 255) | 0;
  var a_0 = ((a >>> 24 | 0) & 255) + ((dstGA >>> 16 | 0) & 255) | 0;
  return packIntClamped(r, g, b_0, a_0);
}
function f2i(v) {
  return toIntRound_0(clamp01_0(v) * 255);
}
function packIntUnchecked(r, g, b, a) {
  return (r & 255) << 0 | (g & 255) << 8 | (b & 255) << 16 | (a & 255) << 24;
}
function packIntClamped(r, g, b, a) {
  return clampUByte(r) | clampUByte(g) << 8 | clampUByte(b) << 16 | clampUByte(a) << 24;
}
var Companion_instance_33;
function Companion_getInstance_44() {
  return Companion_instance_33;
}
function _get_fill__d6ivc8($this) {
  var tmp = $this.c59_1;
  if (!(tmp == null))
    return tmp;
  else {
    throwUninitializedPropertyAccessException('fill');
  }
}
function color($this, ratio) {
  return RgbaPremultipliedArray__get_impl_1u69ta($this.b59_1, numberToInt(clamp01_0(ratio) * 255));
}
function _set_texture__qu271y($this, value) {
  $this.n59_1 = value;
  $this.j59_1 = $this.n59_1.n2d();
  $this.k59_1 = $this.n59_1.o2d();
  $this.l59_1 = 1.0 / $this.j59_1;
  $this.m59_1 = 1.0 / $this.k59_1;
}
var NoneFiller_instance;
function NoneFiller_getInstance() {
  if (NoneFiller_instance === VOID)
    new NoneFiller();
  return NoneFiller_instance;
}
function toFiller(_this__u8e3s4, state) {
  var tmp;
  if (_this__u8e3s4 instanceof NonePaint) {
    tmp = NoneFiller_getInstance();
  } else {
    if (_this__u8e3s4 instanceof RGBA) {
      // Inline function 'kotlin.also' call
      var this_0 = new ColorFiller();
      // Inline function 'kotlin.contracts.contract' call
      // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
      this_0.v58(_this__u8e3s4.l44_1, state);
      tmp = this_0;
    } else {
      if (_this__u8e3s4 instanceof GradientPaint) {
        // Inline function 'kotlin.also' call
        var this_1 = new GradientFiller();
        // Inline function 'kotlin.contracts.contract' call
        // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
        this_1.d59(_this__u8e3s4, state);
        tmp = this_1;
      } else {
        if (_this__u8e3s4 instanceof BitmapPaint) {
          // Inline function 'kotlin.also' call
          var this_2 = new BitmapFiller();
          // Inline function 'kotlin.contracts.contract' call
          // Inline function 'korlibs.image.paint.toFiller.<anonymous>' call
          this_2.r59(_this__u8e3s4, state);
          tmp = this_2;
        } else {
          throw NotImplementedError.nd();
        }
      }
    }
  }
  return tmp;
}
function colorInt(_this__u8e3s4, $this, premultiplied) {
  return premultiplied ? _RGBAPremultiplied___get_value__impl__bqfhud(_RGBA___get_premultiplied__impl__3bulqc(_this__u8e3s4)) : _RGBA___get_value__impl__hhco8v(_this__u8e3s4);
}
function _fillColors($this, out, stops, colors, premultiplied) {
  var numberOfStops = stops.d1();
  var NCOLORS = out.length;
  switch (numberOfStops) {
    case 0:
    case 1:
      var color = numberOfStops === 0 ? Colors_getInstance().m3p_1 : _RGBA___init__impl__lqpay5(colors.uj());
      var pcolor = colorInt(color, $this, premultiplied);
      var inductionVariable = 0;
      if (inductionVariable < NCOLORS)
        do {
          var n = inductionVariable;
          inductionVariable = inductionVariable + 1 | 0;
          out[n] = pcolor;
        }
         while (inductionVariable < NCOLORS);
      break;
    default:
      var inductionVariable_0 = 0;
      var last = _fillColors$stopN(stops, NCOLORS, 0);
      if (inductionVariable_0 < last)
        do {
          var n_0 = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          out[n_0] = colorInt(_RGBA___init__impl__lqpay5(colors.uj()), $this, premultiplied);
        }
         while (inductionVariable_0 < last);
      var inductionVariable_1 = 0;
      var last_0 = numberOfStops - 1 | 0;
      if (inductionVariable_1 < last_0)
        do {
          var n_1 = inductionVariable_1;
          inductionVariable_1 = inductionVariable_1 + 1 | 0;
          var stop0 = _fillColors$stopN(stops, NCOLORS, n_1 + 0 | 0);
          var stop1 = _fillColors$stopN(stops, NCOLORS, n_1 + 1 | 0);
          var color0 = _RGBA___init__impl__lqpay5(colors.ow(n_1 + 0 | 0));
          var color1 = _RGBA___init__impl__lqpay5(colors.ow(n_1 + 1 | 0));
          var inductionVariable_2 = stop0;
          if (inductionVariable_2 < stop1)
            do {
              var s = inductionVariable_2;
              inductionVariable_2 = inductionVariable_2 + 1 | 0;
              var ratio = _Ratio___init__impl__9mwvn2(s - stop0 | 0, stop1 - stop0 | 0);
              out[s] = colorInt(Companion_getInstance_23().a45(color0, color1, ratio), $this, premultiplied);
            }
             while (inductionVariable_2 < stop1);
        }
         while (inductionVariable_1 < last_0);
      var inductionVariable_3 = _fillColors$stopN(stops, NCOLORS, numberOfStops - 1 | 0);
      if (inductionVariable_3 < NCOLORS)
        do {
          var n_2 = inductionVariable_3;
          inductionVariable_3 = inductionVariable_3 + 1 | 0;
          out[n_2] = colorInt(_RGBA___init__impl__lqpay5(colors.j2f()), $this, premultiplied);
        }
         while (inductionVariable_3 < NCOLORS);
      break;
  }
}
function _fillColors$stopN($stops, NCOLORS, n) {
  return numberToInt($stops.c1(n) * NCOLORS);
}
var Companion_instance_34;
function Companion_getInstance_45() {
  return Companion_instance_34;
}
function colorsToString($this, colors) {
  return '[' + joinToString(new RgbaArray(colors), ', ', VOID, VOID, VOID, VOID, GradientPaint$colorsToString$lambda) + ']';
}
function colorsToString_0($this, colors) {
  return colorsToString($this, _RgbaArray___init__impl__oib4y4(colors.n2f()));
}
function GradientPaint$colorsToString$lambda(it) {
  return _RGBA___get_hexString__impl__kocngm(it.l44_1);
}
var GradientKind_LINEAR_instance;
var GradientKind_RADIAL_instance;
var GradientKind_SWEEP_instance;
var GradientKind_entriesInitialized;
function GradientKind_initEntries() {
  if (GradientKind_entriesInitialized)
    return Unit_instance;
  GradientKind_entriesInitialized = true;
  GradientKind_LINEAR_instance = new GradientKind('LINEAR', 0);
  GradientKind_RADIAL_instance = new GradientKind('RADIAL', 1);
  GradientKind_SWEEP_instance = new GradientKind('SWEEP', 2);
}
var GradientInterpolationMethod_LINEAR_instance;
var GradientInterpolationMethod_NORMAL_instance;
var GradientInterpolationMethod_entriesInitialized;
function GradientInterpolationMethod_initEntries() {
  if (GradientInterpolationMethod_entriesInitialized)
    return Unit_instance;
  GradientInterpolationMethod_entriesInitialized = true;
  GradientInterpolationMethod_LINEAR_instance = new GradientInterpolationMethod('LINEAR', 0);
  GradientInterpolationMethod_NORMAL_instance = new GradientInterpolationMethod('NORMAL', 1);
}
var GradientUnits_USER_SPACE_ON_USE_instance;
var GradientUnits_OBJECT_BOUNDING_BOX_instance;
var GradientUnits_entriesInitialized;
function GradientUnits_initEntries() {
  if (GradientUnits_entriesInitialized)
    return Unit_instance;
  GradientUnits_entriesInitialized = true;
  GradientUnits_USER_SPACE_ON_USE_instance = new GradientUnits('USER_SPACE_ON_USE', 0);
  GradientUnits_OBJECT_BOUNDING_BOX_instance = new GradientUnits('OBJECT_BOUNDING_BOX', 1);
}
var NonePaint_instance;
function NonePaint_getInstance() {
  return NonePaint_instance;
}
function get_DefaultPaint() {
  return Colors_getInstance().l3n_1;
}
function GradientKind_LINEAR_getInstance() {
  GradientKind_initEntries();
  return GradientKind_LINEAR_instance;
}
function GradientKind_RADIAL_getInstance() {
  GradientKind_initEntries();
  return GradientKind_RADIAL_instance;
}
function GradientInterpolationMethod_NORMAL_getInstance() {
  GradientInterpolationMethod_initEntries();
  return GradientInterpolationMethod_NORMAL_instance;
}
function GradientUnits_OBJECT_BOUNDING_BOX_getInstance() {
  GradientUnits_initEntries();
  return GradientUnits_OBJECT_BOUNDING_BOX_instance;
}
function _VerticalAlign___init__impl__f42kfq(ratio) {
  return ratio;
}
function _VerticalAlign___get_ratio__impl__b3ilr8($this) {
  return $this;
}
function _VerticalAlign___get_ratioFake__impl__1h2fwv($this) {
  return equals($this, Companion_getInstance_46().p5a_1) ? 1.0 : _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
var Companion_instance_35;
function Companion_getInstance_46() {
  if (Companion_instance_35 === VOID)
    new Companion_29();
  return Companion_instance_35;
}
function VerticalAlign__getOffsetY_impl_iso0y6($this, height, baseline) {
  return equals($this, Companion_getInstance_46().p5a_1) ? baseline : -height * _VerticalAlign___get_ratio__impl__b3ilr8($this);
}
function VerticalAlign__getOffsetYRespectBaseline_impl_62po5b($this, font, totalHeight) {
  return equals($this, Companion_getInstance_46().p5a_1) ? 0.0 : interpolate_0(toRatio_0(_VerticalAlign___get_ratio__impl__b3ilr8($this)), font.f46_1, font.f46_1 - totalHeight);
}
function VerticalAlign__toString_impl_hcpnn2($this) {
  return equals($this, Companion_getInstance_46().m5a_1) ? 'TOP' : equals($this, Companion_getInstance_46().n5a_1) ? 'MIDDLE' : equals($this, Companion_getInstance_46().o5a_1) ? 'BOTTOM' : equals($this, Companion_getInstance_46().p5a_1) ? 'BASELINE' : 'VerticalAlign(' + _VerticalAlign___get_ratio__impl__b3ilr8($this) + ')';
}
function VerticalAlign__hashCode_impl_vx8hj7($this) {
  return getNumberHashCode($this);
}
function VerticalAlign__equals_impl_xp13z($this, other) {
  if (!(other instanceof VerticalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof VerticalAlign ? other.s5a_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
function _HorizontalAlign___init__impl__ad654o(ratio) {
  return ratio;
}
function _HorizontalAlign___get_ratio__impl__x9wlea($this) {
  return $this;
}
function _HorizontalAlign___get_ratioFake__impl__h46z0d($this) {
  return equals($this, Companion_getInstance_47().t5a_1) ? 0.0 : _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
var Companion_instance_36;
function Companion_getInstance_47() {
  if (Companion_instance_36 === VOID)
    new Companion_30();
  return Companion_instance_36;
}
function HorizontalAlign__getOffsetX_impl_urzzxf($this, width) {
  return equals($this, Companion_getInstance_47().t5a_1) ? 0.0 : width * _HorizontalAlign___get_ratio__impl__x9wlea($this);
}
function HorizontalAlign__toString_impl_toflc0($this) {
  return equals($this, Companion_getInstance_47().u5a_1) ? 'LEFT' : equals($this, Companion_getInstance_47().v5a_1) ? 'CENTER' : equals($this, Companion_getInstance_47().w5a_1) ? 'RIGHT' : equals($this, Companion_getInstance_47().t5a_1) ? 'JUSTIFY' : 'HorizontalAlign(' + _HorizontalAlign___get_ratio__impl__x9wlea($this) + ')';
}
function HorizontalAlign__hashCode_impl_7x9oj5($this) {
  return getNumberHashCode($this);
}
function HorizontalAlign__equals_impl_hkfbhv($this, other) {
  if (!(other instanceof HorizontalAlign))
    return false;
  var tmp0_other_with_cast = other instanceof HorizontalAlign ? other.z5a_1 : THROW_CCE();
  if (!equals($this, tmp0_other_with_cast))
    return false;
  return true;
}
var Companion_instance_37;
function Companion_getInstance_48() {
  if (Companion_instance_37 === VOID)
    new Companion_31();
  return Companion_instance_37;
}
var DefaultWStringTextRenderer;
function get_DefaultStringTextRenderer() {
  _init_properties_TextRenderer_kt__4uayeo();
  return DefaultStringTextRenderer;
}
var DefaultStringTextRenderer;
function CreateWStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateWStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateWStringTextRenderer$2(getVersion, handler);
}
function CreateStringTextRenderer(getVersion, handler) {
  var tmp;
  if (getVersion === VOID) {
    tmp = CreateStringTextRenderer$lambda;
  } else {
    tmp = getVersion;
  }
  getVersion = tmp;
  _init_properties_TextRenderer_kt__4uayeo();
  return new CreateStringTextRenderer$2(getVersion, handler);
}
function add($this, x, y) {
  var rx = $this.bt().h21_1 + $this.a4h().s25(x, y);
  var ry = $this.bt().i21_1 + $this.a4h().v25(x, y);
  $this.h4e_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.h4e_1, Vector2D.j21(rx, ry));
  if ($this.i4e_1 === 0) {
    $this.g4e_1 = BoundsBuilder__plus_impl_cz7f7x_1($this.g4e_1, Vector2D.j21(rx, ry));
  }
  var _receiver__tnumb7 = $this.k4e_1;
  _receiver__tnumb7.s4e_1 = BoundsBuilder__plus_impl_cz7f7x_1(_receiver__tnumb7.s4e_1, Vector2D.j21(rx, ry));
}
function add_0($this, rect) {
  var fx = rect.k22();
  var fy = rect.m22();
  var w = rect.f22_1;
  var h = rect.g22_1;
  add($this, fx, fy);
  add($this, fx + w, fy);
  add($this, fx + w, fy + h);
  add($this, fx, fy + h);
}
function measure(_this__u8e3s4, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  var actions = new BoundBuilderTextRendererActions();
  invoke(_this__u8e3s4, actions, text, size, defaultFont);
  return actions;
}
function invoke(_this__u8e3s4, actions, text, size, defaultFont) {
  _init_properties_TextRenderer_kt__4uayeo();
  // Inline function 'kotlin.apply' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.text.invoke.<anonymous>' call
  _this__u8e3s4.c5b(actions, text, size, defaultFont);
}
function DefaultWStringTextRenderer$lambda($this$CreateWStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateWStringTextRenderer.m4g(text, c);
  $this$CreateWStringTextRenderer.i4h(advance);
  return Unit_instance;
}
function DefaultStringTextRenderer$lambda($this$CreateStringTextRenderer, text, c, g, advance) {
  _init_properties_TextRenderer_kt__4uayeo();
  $this$CreateStringTextRenderer.m4g(text, c);
  $this$CreateStringTextRenderer.i4h(advance);
  return Unit_instance;
}
function CreateWStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$lambda() {
  _init_properties_TextRenderer_kt__4uayeo();
  return 0;
}
function CreateStringTextRenderer$o$wstring$lambda($handler) {
  return function ($this$CreateWStringTextRenderer, text, c, g, advance) {
    $handler($this$CreateWStringTextRenderer, text, c, g, advance);
    return Unit_instance;
  };
}
var properties_initialized_TextRenderer_kt_lfmsb6;
function _init_properties_TextRenderer_kt__4uayeo() {
  if (!properties_initialized_TextRenderer_kt_lfmsb6) {
    properties_initialized_TextRenderer_kt_lfmsb6 = true;
    DefaultWStringTextRenderer = CreateWStringTextRenderer(VOID, DefaultWStringTextRenderer$lambda);
    DefaultStringTextRenderer = CreateStringTextRenderer(VOID, DefaultStringTextRenderer$lambda);
  }
}
function _Tile___init__impl__tdix77(raw) {
  return raw;
}
function _Tile___get_raw__impl__kp6cq8($this) {
  return $this;
}
function _Tile___get_rawLow__impl__rdabpi($this) {
  return get_low(_Tile___get_raw__impl__kp6cq8($this));
}
function _Tile___get_rawHigh__impl__7pktiq($this) {
  return get_high(_Tile___get_raw__impl__kp6cq8($this));
}
function _Tile___get_isValid__impl__nlo03e($this) {
  return !_Tile___get_raw__impl__kp6cq8($this).equals(new Long(-1, -1));
}
function _Tile___get_isInvalid__impl__yfg9ed($this) {
  return _Tile___get_raw__impl__kp6cq8($this).equals(new Long(-1, -1));
}
function _Tile___get_tile__impl__nfq1aw($this) {
  return extract(_Tile___get_rawLow__impl__rdabpi($this), 0, 26);
}
function _Tile___get_rotate__impl__5kjdv9($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_Tile___get_rawLow__impl__rdabpi($this) >>> 29 | 0) & 1) === 0);
}
function _Tile___get_flipY__impl__95aqcs($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_Tile___get_rawLow__impl__rdabpi($this) >>> 30 | 0) & 1) === 0);
}
function _Tile___get_flipX__impl__jobqpf($this) {
  // Inline function 'korlibs.memory.extract' call
  // Inline function 'korlibs.memory.extract1' call
  return !(((_Tile___get_rawLow__impl__rdabpi($this) >>> 31 | 0) & 1) === 0);
}
function _Tile___get_offsetX__impl__qwhdsd($this) {
  return extract16Signed(_Tile___get_rawHigh__impl__7pktiq($this), 0);
}
function _Tile___get_offsetY__impl__1x539u($this) {
  return extract16Signed(_Tile___get_rawHigh__impl__7pktiq($this), 16);
}
var Companion_instance_38;
function Companion_getInstance_49() {
  if (Companion_instance_38 === VOID)
    new Companion_32();
  return Companion_instance_38;
}
function Tile__toString_impl_iy9thp($this) {
  return 'Tile(raw=' + $this.toString() + ')';
}
function Tile__hashCode_impl_ubobok($this) {
  return $this.hashCode();
}
var Companion_instance_39;
function Companion_getInstance_50() {
  return Companion_instance_39;
}
var TileMapRepeat_NONE_instance;
var TileMapRepeat_REPEAT_instance;
var TileMapRepeat_MIRROR_instance;
function TileMapRepeat$lambda(v, max) {
  return v;
}
function TileMapRepeat$lambda_0(v, max) {
  return umod(v, max);
}
function TileMapRepeat$lambda_1(v, max) {
  var r = umod(v, max);
  return ((v / max | 0) % 2 | 0) === 0 ? r : (max - 1 | 0) - r | 0;
}
var TileMapRepeat_entriesInitialized;
function TileMapRepeat_initEntries() {
  if (TileMapRepeat_entriesInitialized)
    return Unit_instance;
  TileMapRepeat_entriesInitialized = true;
  TileMapRepeat_NONE_instance = new TileMapRepeat('NONE', 0, TileMapRepeat$lambda);
  TileMapRepeat_REPEAT_instance = new TileMapRepeat('REPEAT', 1, TileMapRepeat$lambda_0);
  TileMapRepeat_MIRROR_instance = new TileMapRepeat('MIRROR', 2, TileMapRepeat$lambda_1);
}
function TileMapRepeat_NONE_getInstance() {
  TileMapRepeat_initEntries();
  return TileMapRepeat_NONE_instance;
}
var Companion_instance_40;
function Companion_getInstance_51() {
  if (Companion_instance_40 === VOID)
    new Companion_34();
  return Companion_instance_40;
}
function TileSet$base$delegate$lambda(this$0) {
  return function () {
    var tmp;
    if (this$0.x5d_1.v2j_1 === 0) {
      // Inline function 'korlibs.image.bitmap.Bitmaps.transparent' call
      var tmp$ret$0 = get_Bitmaps_transparent();
      tmp = get_bmp(tmp$ret$0);
    } else {
      tmp = get_bmp(this$0.x5d_1.k2k().u5d_1);
    }
    return tmp;
  };
}
function TileSet$hasMultipleBaseBitmaps$delegate$lambda(this$0) {
  return function () {
    var tmp$ret$0;
    $l$block_0: {
      // Inline function 'kotlin.collections.any' call
      var this_0 = this$0.x5d_1.k3();
      var tmp;
      if (isInterface(this_0, Collection)) {
        tmp = this_0.f1();
      } else {
        tmp = false;
      }
      if (tmp) {
        tmp$ret$0 = false;
        break $l$block_0;
      }
      var tmp0_iterator = this_0.z();
      while (tmp0_iterator.a1()) {
        var element = tmp0_iterator.b1();
        // Inline function 'korlibs.image.tiles.TileSet.hasMultipleBaseBitmaps$delegate.<anonymous>.<anonymous>' call
        if (!(element === null) && !(get_bmp(element.u5d_1) === this$0.t2g())) {
          tmp$ret$0 = true;
          break $l$block_0;
        }
      }
      tmp$ret$0 = false;
    }
    return tmp$ret$0;
  };
}
function TileSet$infos$delegate$lambda(this$0) {
  return function () {
    var tmp = 0;
    var tmp300_safe_receiver = maxOrNull(this$0.x5d_1.c3());
    var tmp0_elvis_lhs = tmp300_safe_receiver == null ? null : tmp300_safe_receiver + 1 | 0;
    var tmp_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      tmp_1[tmp_2] = this$0.x5d_1.c1(tmp_2);
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function TileSet$textures$delegate$lambda(this$0) {
  return function () {
    var tmp = 0;
    var tmp301_safe_receiver = maxOrNull(this$0.x5d_1.c3());
    var tmp0_elvis_lhs = tmp301_safe_receiver == null ? null : tmp301_safe_receiver + 1 | 0;
    var tmp_0 = tmp0_elvis_lhs == null ? 0 : tmp0_elvis_lhs;
    // Inline function 'kotlin.arrayOfNulls' call
    var tmp_1 = fillArrayVal(Array(tmp_0), null);
    while (tmp < tmp_0) {
      var tmp_2 = tmp;
      var tmp302_safe_receiver = this$0.x5d_1.c1(tmp_2);
      tmp_1[tmp_2] = tmp302_safe_receiver == null ? null : tmp302_safe_receiver.u5d_1;
      tmp = tmp + 1 | 0;
    }
    return tmp_1;
  };
}
function base$factory() {
  return getPropertyCallableRef('base', 1, KProperty1, function (receiver) {
    return receiver.t2g();
  }, null);
}
function infos$factory() {
  return getPropertyCallableRef('infos', 1, KProperty1, function (receiver) {
    return receiver.f33();
  }, null);
}
function textures$factory() {
  return getPropertyCallableRef('textures', 1, KProperty1, function (receiver) {
    return receiver.f5e();
  }, null);
}
function Tile(tile, orientation, offsetX, offsetY) {
  var tmp;
  if (orientation === VOID) {
    // Inline function 'korlibs.math.geom.slice.Companion.NORMAL' call
    tmp = Companion_getInstance_1().d38_1;
  } else {
    tmp = orientation;
  }
  orientation = tmp;
  offsetX = offsetX === VOID ? 0 : offsetX;
  offsetY = offsetY === VOID ? 0 : offsetY;
  return Companion_getInstance_49().x5c(tile, offsetX, offsetY, get_tileFlipX(orientation), get_tileFlipY(orientation), get_tileRot(orientation));
}
function get_tileFlipX(_this__u8e3s4) {
  return _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 1 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 2 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 4 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 5;
}
function get_tileFlipY(_this__u8e3s4) {
  return _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 2 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 3 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 5 || _SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) === 6;
}
function get_tileRot(_this__u8e3s4) {
  return (_SliceOrientation___get_raw__impl__tj3u8w(_this__u8e3s4) % 2 | 0) === 1;
}
function flippedX(_this__u8e3s4) {
  return withOrientation(_this__u8e3s4, SliceOrientation__flippedX_impl_m25zo9(get_orientation_0(_this__u8e3s4)));
}
function flippedY(_this__u8e3s4) {
  return withOrientation(_this__u8e3s4, SliceOrientation__flippedY_impl_mj7m2g(get_orientation_0(_this__u8e3s4)));
}
function rotatedRight(_this__u8e3s4, offset) {
  offset = offset === VOID ? 1 : offset;
  return withOrientation(_this__u8e3s4, SliceOrientation__rotatedRight_impl_m8di3g(get_orientation_0(_this__u8e3s4), offset));
}
function withOrientation(_this__u8e3s4, orientation) {
  return Tile(_Tile___get_tile__impl__nfq1aw(_this__u8e3s4), orientation, _Tile___get_offsetX__impl__qwhdsd(_this__u8e3s4), _Tile___get_offsetY__impl__1x539u(_this__u8e3s4));
}
function get_orientation_0(_this__u8e3s4) {
  return _Tile___get_flipY__impl__95aqcs(_this__u8e3s4) ? _Tile___get_flipX__impl__jobqpf(_this__u8e3s4) ? _Tile___get_rotate__impl__5kjdv9(_this__u8e3s4) ? Companion_getInstance_1().i38_1 : Companion_getInstance_1().f38_1 : _Tile___get_rotate__impl__5kjdv9(_this__u8e3s4) ? Companion_getInstance_1().g38_1 : Companion_getInstance_1().j38_1 : _Tile___get_flipX__impl__jobqpf(_this__u8e3s4) ? _Tile___get_rotate__impl__5kjdv9(_this__u8e3s4) ? Companion_getInstance_1().e38_1 : Companion_getInstance_1().h38_1 : _Tile___get_rotate__impl__5kjdv9(_this__u8e3s4) ? Companion_getInstance_1().k38_1 : Companion_getInstance_1().d38_1;
}
function overlaps($this, a0, a1, b0, b1) {
  // Inline function 'kotlin.math.min' call
  var min = Math.min(a0, a0);
  // Inline function 'kotlin.math.max' call
  var max = Math.max(a1, a1);
  // Inline function 'kotlin.math.max' call
  var maxMinor = Math.max(a0, b0);
  // Inline function 'kotlin.math.min' call
  var minMajor = Math.min(a1, b1);
  return (min <= maxMinor ? maxMinor <= max : false) || (min <= minMajor ? minMajor <= max : false);
}
function renderFinal$flush(this$0, filler, $state, $winding, fillPath) {
  if (this$0.z5e_1.n5f_1.z23()) {
    this$0.z5e_1.l5f_1 = this$0.x5e_1 ? 4 : 1;
    this$0.d5f_1.j5e_1 = filler;
    this$0.d5f_1.s5e_1 = $state.r47_1;
    this$0.d5f_1.e2h();
    var tmp = $winding == null ? fillPath.s36_1 : $winding;
    this$0.z5e_1.t5f(this$0.y5e_1, VOID, VOID, tmp, Bitmap32Context2d$renderFinal$flush$lambda(this$0));
    this$0.d5f_1.kc();
    this$0.z5e_1.n5f_1.e2h();
  }
}
function Bitmap32Context2d$renderFinal$flush$lambda(this$0) {
  return function (x0, x1, y) {
    this$0.d5f_1.h5f(x0, x1, y);
    return Unit_instance;
  };
}
function CompositeOperation$Companion$UNIMPLEMENTED$lambda(dst, dstN, src, srcN, count) {
  mix_0(dst.g45_1, dstN, src.g45_1, srcN, count);
  return Unit_instance;
}
var Companion_instance_41;
function Companion_getInstance_52() {
  if (Companion_instance_41 === VOID)
    new Companion_35();
  return Companion_instance_41;
}
var CompositeMode_CLEAR_instance;
var CompositeMode_COPY_instance;
var CompositeMode_SOURCE_OVER_instance;
var CompositeMode_DESTINATION_OVER_instance;
var CompositeMode_SOURCE_IN_instance;
var CompositeMode_DESTINATION_IN_instance;
var CompositeMode_SOURCE_OUT_instance;
var CompositeMode_DESTINATION_OUT_instance;
var CompositeMode_SOURCE_ATOP_instance;
var CompositeMode_DESTINATION_ATOP_instance;
var CompositeMode_XOR_instance;
var CompositeMode_LIGHTER_instance;
var Companion_instance_42;
function Companion_getInstance_53() {
  return Companion_instance_42;
}
function CompositeMode$lambda(dst, dstN, src, srcN, count) {
  var inductionVariable = 0;
  if (inductionVariable < count)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var d = RgbaPremultipliedArray__get_impl_1u69ta(dst.g45_1, dstN + n | 0);
      var s = RgbaPremultipliedArray__get_impl_1u69ta(src.g45_1, srcN + n | 0);
      var tmp = dstN + n | 0;
      // Inline function 'korlibs.image.color.RGBAPremultiplied.depremultiplied' call
      var tmp$ret$0 = _RGBAPremultiplied___get_depremultipliedAccurate__impl__i51glv(d);
      RgbaPremultipliedArray__set_impl_7fwbby(dst.g45_1, tmp, _RGBA___get_premultiplied__impl__3bulqc(RGBA__withA_impl_vogscm(tmp$ret$0, clampUByte(_RGBAPremultiplied___get_a__impl__f0hnd1(d) - _RGBAPremultiplied___get_a__impl__f0hnd1(s) | 0))));
    }
     while (inductionVariable < count);
  return Unit_instance;
}
function CompositeMode$lambda_0(dst, dstN, src, srcN, count) {
  mix_1(dst.g45_1, dstN, dst.g45_1, dstN, src.g45_1, srcN, count);
  return Unit_instance;
}
function CompositeMode$lambda_1(dst, dstN, src, srcN, count) {
  mix_1(dst.g45_1, dstN, src.g45_1, srcN, dst.g45_1, dstN, count);
  return Unit_instance;
}
var CompositeMode_entriesInitialized;
function CompositeMode_initEntries() {
  if (CompositeMode_entriesInitialized)
    return Unit_instance;
  CompositeMode_entriesInitialized = true;
  var tmp = Companion_getInstance_52();
  CompositeMode_CLEAR_instance = new CompositeMode('CLEAR', 0, tmp.g5g(CompositeMode$lambda));
  CompositeMode_COPY_instance = new CompositeMode('COPY', 1, Companion_getInstance_52().f5g_1);
  var tmp_0 = Companion_getInstance_52();
  CompositeMode_SOURCE_OVER_instance = new CompositeMode('SOURCE_OVER', 2, tmp_0.g5g(CompositeMode$lambda_0));
  var tmp_1 = Companion_getInstance_52();
  CompositeMode_DESTINATION_OVER_instance = new CompositeMode('DESTINATION_OVER', 3, tmp_1.g5g(CompositeMode$lambda_1));
  CompositeMode_SOURCE_IN_instance = new CompositeMode('SOURCE_IN', 4, Companion_getInstance_52().f5g_1);
  CompositeMode_DESTINATION_IN_instance = new CompositeMode('DESTINATION_IN', 5, Companion_getInstance_52().f5g_1);
  CompositeMode_SOURCE_OUT_instance = new CompositeMode('SOURCE_OUT', 6, Companion_getInstance_52().f5g_1);
  CompositeMode_DESTINATION_OUT_instance = new CompositeMode('DESTINATION_OUT', 7, Companion_getInstance_52().f5g_1);
  CompositeMode_SOURCE_ATOP_instance = new CompositeMode('SOURCE_ATOP', 8, Companion_getInstance_52().f5g_1);
  CompositeMode_DESTINATION_ATOP_instance = new CompositeMode('DESTINATION_ATOP', 9, Companion_getInstance_52().f5g_1);
  CompositeMode_XOR_instance = new CompositeMode('XOR', 10, Companion_getInstance_52().f5g_1);
  CompositeMode_LIGHTER_instance = new CompositeMode('LIGHTER', 11, Companion_getInstance_52().f5g_1);
}
function get_DEFAULT(_this__u8e3s4) {
  return Companion_instance_42.b3g();
}
var BlendMode_NORMAL_instance;
var BlendMode_MULTIPLY_instance;
var BlendMode_SCREEN_instance;
var BlendMode_OVERLAY_instance;
var BlendMode_DARKEN_instance;
var BlendMode_LIGHTEN_instance;
var BlendMode_COLOR_DODGE_instance;
var BlendMode_COLOR_BURN_instance;
var BlendMode_HARD_LIGHT_instance;
var BlendMode_SOFT_LIGHT_instance;
var BlendMode_DIFFERENCE_instance;
var BlendMode_EXCLUSION_instance;
var BlendMode_HUE_instance;
var BlendMode_SATURATION_instance;
var BlendMode_COLOR_instance;
var BlendMode_LUMINOSITY_instance;
var BlendMode_ADDITION_instance;
var BlendMode_SUBTRACT_instance;
var BlendMode_DIVIDE_instance;
var BlendMode_entriesInitialized;
function BlendMode_initEntries() {
  if (BlendMode_entriesInitialized)
    return Unit_instance;
  BlendMode_entriesInitialized = true;
  BlendMode_NORMAL_instance = new BlendMode('NORMAL', 0, Companion_getInstance_52().f5g_1);
  BlendMode_MULTIPLY_instance = new BlendMode('MULTIPLY', 1, Companion_getInstance_52().f5g_1);
  BlendMode_SCREEN_instance = new BlendMode('SCREEN', 2, Companion_getInstance_52().f5g_1);
  BlendMode_OVERLAY_instance = new BlendMode('OVERLAY', 3, Companion_getInstance_52().f5g_1);
  BlendMode_DARKEN_instance = new BlendMode('DARKEN', 4, Companion_getInstance_52().f5g_1);
  BlendMode_LIGHTEN_instance = new BlendMode('LIGHTEN', 5, Companion_getInstance_52().f5g_1);
  BlendMode_COLOR_DODGE_instance = new BlendMode('COLOR_DODGE', 6, Companion_getInstance_52().f5g_1);
  BlendMode_COLOR_BURN_instance = new BlendMode('COLOR_BURN', 7, Companion_getInstance_52().f5g_1);
  BlendMode_HARD_LIGHT_instance = new BlendMode('HARD_LIGHT', 8, Companion_getInstance_52().f5g_1);
  BlendMode_SOFT_LIGHT_instance = new BlendMode('SOFT_LIGHT', 9, Companion_getInstance_52().f5g_1);
  BlendMode_DIFFERENCE_instance = new BlendMode('DIFFERENCE', 10, Companion_getInstance_52().f5g_1);
  BlendMode_EXCLUSION_instance = new BlendMode('EXCLUSION', 11, Companion_getInstance_52().f5g_1);
  BlendMode_HUE_instance = new BlendMode('HUE', 12, Companion_getInstance_52().f5g_1);
  BlendMode_SATURATION_instance = new BlendMode('SATURATION', 13, Companion_getInstance_52().f5g_1);
  BlendMode_COLOR_instance = new BlendMode('COLOR', 14, Companion_getInstance_52().f5g_1);
  BlendMode_LUMINOSITY_instance = new BlendMode('LUMINOSITY', 15, Companion_getInstance_52().f5g_1);
  BlendMode_ADDITION_instance = new BlendMode('ADDITION', 16, Companion_getInstance_52().f5g_1);
  BlendMode_SUBTRACT_instance = new BlendMode('SUBTRACT', 17, Companion_getInstance_52().f5g_1);
  BlendMode_DIVIDE_instance = new BlendMode('DIVIDE', 18, Companion_getInstance_52().f5g_1);
}
function CompositeMode_SOURCE_OVER_getInstance() {
  CompositeMode_initEntries();
  return CompositeMode_SOURCE_OVER_instance;
}
function BlendMode_NORMAL_getInstance() {
  BlendMode_initEntries();
  return BlendMode_NORMAL_instance;
}
function BlendMode_MULTIPLY_getInstance() {
  BlendMode_initEntries();
  return BlendMode_MULTIPLY_instance;
}
function BlendMode_SCREEN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SCREEN_instance;
}
function BlendMode_OVERLAY_getInstance() {
  BlendMode_initEntries();
  return BlendMode_OVERLAY_instance;
}
function BlendMode_DARKEN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_DARKEN_instance;
}
function BlendMode_LIGHTEN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_LIGHTEN_instance;
}
function BlendMode_COLOR_DODGE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_COLOR_DODGE_instance;
}
function BlendMode_COLOR_BURN_getInstance() {
  BlendMode_initEntries();
  return BlendMode_COLOR_BURN_instance;
}
function BlendMode_HARD_LIGHT_getInstance() {
  BlendMode_initEntries();
  return BlendMode_HARD_LIGHT_instance;
}
function BlendMode_SOFT_LIGHT_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SOFT_LIGHT_instance;
}
function BlendMode_DIFFERENCE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_DIFFERENCE_instance;
}
function BlendMode_EXCLUSION_getInstance() {
  BlendMode_initEntries();
  return BlendMode_EXCLUSION_instance;
}
function BlendMode_HUE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_HUE_instance;
}
function BlendMode_SATURATION_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SATURATION_instance;
}
function BlendMode_COLOR_getInstance() {
  BlendMode_initEntries();
  return BlendMode_COLOR_instance;
}
function BlendMode_LUMINOSITY_getInstance() {
  BlendMode_initEntries();
  return BlendMode_LUMINOSITY_instance;
}
function BlendMode_ADDITION_getInstance() {
  BlendMode_initEntries();
  return BlendMode_ADDITION_instance;
}
function BlendMode_SUBTRACT_getInstance() {
  BlendMode_initEntries();
  return BlendMode_SUBTRACT_instance;
}
function BlendMode_DIVIDE_getInstance() {
  BlendMode_initEntries();
  return BlendMode_DIVIDE_instance;
}
function Context2d$State$transformTransform$delegate$lambda(this$0) {
  return function () {
    return this$0.b47_1.n26();
  };
}
function trans($this, p) {
  var tmp$ret$0;
  $l$block: {
    // Inline function 'korlibs.math.geom.Matrix.transform' call
    var this_0 = $this.h3u_1.b47_1;
    if (this_0.i22()) {
      tmp$ret$0 = p;
      break $l$block;
    }
    tmp$ret$0 = Vector2D.j21(this_0.s25(p.h21_1, p.i21_1), this_0.v25(p.h21_1, p.i21_1));
  }
  return tmp$ret$0;
}
function write_0(_this__u8e3s4, path) {
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_0 = path.q36_1;
  var n_0 = 0;
  while (n_0 < this_0.d1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_0.ow(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = path.r36_1.c1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var it = Vector2D.j21(tmp, path.r36_1.c1(_unary__edvuaz_1));
        _this__u8e3s4.n36(it);
        break;
      case 1:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = path.r36_1.c1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var it_0 = Vector2D.j21(tmp_0, path.r36_1.c1(_unary__edvuaz_3));
        _this__u8e3s4.a37(it_0);
        break;
      case 2:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = path.r36_1.c1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var c = Vector2D.j21(tmp_1, path.r36_1.c1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = path.r36_1.c1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var a = Vector2D.j21(tmp_2, path.r36_1.c1(_unary__edvuaz_7));
        _this__u8e3s4.b37(c, a);
        break;
      case 3:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = path.r36_1.c1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var c1 = Vector2D.j21(tmp_3, path.r36_1.c1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = path.r36_1.c1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var c2 = Vector2D.j21(tmp_4, path.r36_1.c1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = path.r36_1.c1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var a_0 = Vector2D.j21(tmp_5, path.r36_1.c1(_unary__edvuaz_13));
        _this__u8e3s4.o36(c1, c2, a_0);
        break;
      case 4:
        // Inline function 'korlibs.image.vector.write.<anonymous>' call

        _this__u8e3s4.z5();
        break;
    }
  }
}
function toBitmapPaint(_this__u8e3s4, state) {
  var filler = toFiller(_this__u8e3s4, state);
  var bb = Companion_getInstance_8().t22();
  bb = BoundsBuilder__plus_impl_cz7f7x_0(bb, state.d47_1.e33());
  var tmp = bb;
  var tmp332_safe_receiver = state.c47_1;
  bb = BoundsBuilder__plus_impl_cz7f7x_0(tmp, tmp332_safe_receiver == null ? null : tmp332_safe_receiver.e33());
  var bounds = _BoundsBuilder___get_bounds__impl__s1l1gx(bb).m2a(state.b47_1);
  // Inline function 'kotlin.also' call
  var this_0 = Bitmap32.z3l(toIntCeil_0(bounds.f22_1), toIntCeil_0(bounds.g22_1), VOID, true);
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toBitmapPaint.<anonymous>' call
  filler.z58(this_0);
  var bmp = this_0;
  return new BitmapPaint(bmp, Companion_getInstance_6().d25().g26(-bounds.k22(), -bounds.m22()));
}
function transformTransform$factory() {
  return getPropertyCallableRef('transformTransform', 1, KProperty1, function (receiver) {
    return receiver.n5g();
  }, null);
}
var CycleMethod_NO_CYCLE_instance;
var CycleMethod_NO_CYCLE_CLAMP_instance;
var CycleMethod_REPEAT_instance;
var CycleMethod_REFLECT_instance;
var Companion_instance_43;
function Companion_getInstance_54() {
  CycleMethod_initEntries();
  if (Companion_instance_43 === VOID)
    new Companion_37();
  return Companion_instance_43;
}
function values_6() {
  return [CycleMethod_NO_CYCLE_getInstance(), CycleMethod_NO_CYCLE_CLAMP_getInstance(), CycleMethod_REPEAT_getInstance(), CycleMethod_REFLECT_getInstance()];
}
var CycleMethod_entriesInitialized;
function CycleMethod_initEntries() {
  if (CycleMethod_entriesInitialized)
    return Unit_instance;
  CycleMethod_entriesInitialized = true;
  CycleMethod_NO_CYCLE_instance = new CycleMethod('NO_CYCLE', 0);
  CycleMethod_NO_CYCLE_CLAMP_instance = new CycleMethod('NO_CYCLE_CLAMP', 1);
  CycleMethod_REPEAT_instance = new CycleMethod('REPEAT', 2);
  CycleMethod_REFLECT_instance = new CycleMethod('REFLECT', 3);
  Companion_getInstance_54();
}
function _CycleMethodPair___init__impl__y6jlco(data) {
  return data;
}
function _CycleMethodPair___get_data__impl__r5ik0n($this) {
  return $this;
}
function _CycleMethodPair___init__impl__y6jlco_0(x, y) {
  return _CycleMethodPair___init__impl__y6jlco(insert8(insert8(0, x.m3_1, 0), y.m3_1, 8));
}
function _CycleMethodPair___get_x__impl__dgz5uj($this) {
  var tmp = Companion_getInstance_54().q5h_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 0 | 0) & 255];
}
function _CycleMethodPair___get_y__impl__fcnb7o($this) {
  var tmp = Companion_getInstance_54().q5h_1;
  // Inline function 'korlibs.memory.extract8' call
  return tmp[(_CycleMethodPair___get_data__impl__r5ik0n($this) >>> 8 | 0) & 255];
}
function CycleMethodPair__apply_impl_g3sekg($this, ratio) {
  return Vector2D.j21(_CycleMethodPair___get_x__impl__dgz5uj($this).r5h(ratio.h21_1), _CycleMethodPair___get_y__impl__fcnb7o($this).r5h(ratio.i21_1));
}
function CycleMethod_NO_CYCLE_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_instance;
}
function CycleMethod_NO_CYCLE_CLAMP_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_NO_CYCLE_CLAMP_instance;
}
function CycleMethod_REPEAT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REPEAT_instance;
}
function CycleMethod_REFLECT_getInstance() {
  CycleMethod_initEntries();
  return CycleMethod_REFLECT_instance;
}
function draw_0(_this__u8e3s4, c) {
  c.t4x(_this__u8e3s4);
}
function draw_1(_this__u8e3s4, path) {
  _this__u8e3s4.t4x(path);
}
function msdfBmp(_this__u8e3s4, width, height) {
  var msdf_0 = msdf(_this__u8e3s4, width, height);
  // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent' call
  // Inline function 'korlibs.image.bitmap.Bitmap.forEach' call
  var width_0 = msdf_0.n2d() - 0 | 0;
  var inductionVariable = 0;
  var last = 0 + (msdf_0.o2d() - 0 | 0) | 0;
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var n = msdf_0.d3n(0, 0 + y | 0);
      var inductionVariable_0 = 0;
      var last_0 = 0 + width_0 | 0;
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          // Inline function 'korlibs.image.bitmap.FloatBitmap32.updateComponent.<anonymous>' call
          n = n + 1 | 0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value = msdf_0.i3z(x, y);
          var tmp = 0 === 3 ? -100.0 : value;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_0 = msdf_0.j3z(x, y);
          var tmp_0 = 1 === 3 ? -100.0 : value_0;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_1 = msdf_0.k3z(x, y);
          var tmp_1 = 2 === 3 ? -100.0 : value_1;
          // Inline function 'korlibs.image.vector.msdfBmp.<anonymous>' call
          var value_2 = msdf_0.l3z(x, y);
          var tmp$ret$3 = 3 === 3 ? -100.0 : value_2;
          msdf_0.m3z(x, y, tmp, tmp_0, tmp_1, tmp$ret$3);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  msdf_0.t3z(-1.0);
  msdf_0.v3z(-1.0, +1.0);
  msdf_0.s3z();
  var msdfBitmap = msdf_0.s3m();
  return msdfBitmap;
}
function sdfBmp(_this__u8e3s4, width, height) {
  var tmp = NewSDF_instance;
  var newImage = tmp.k43(NativeImageContext2d(width, height, VOID, sdfBmp$lambda(_this__u8e3s4)).s3m(), VOID, 0);
  return newImage.d43_1.d3u();
}
function msdf(_this__u8e3s4, width, height) {
  return msdf_0(_this__u8e3s4, FloatBitmap32.g3z(width, height));
}
function msdf_0(_this__u8e3s4, data) {
  var path = _this__u8e3s4;
  var curvesList = toCurvesList(path);
  var p = Vector2D.j24();
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(curvesList, 10));
  var tmp0_iterator = curvesList.z();
  while (tmp0_iterator.a1()) {
    var item = tmp0_iterator.b1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var tmp$ret$0 = colorize(item.h32_1, item.i32_1);
    destination.f(tmp$ret$0);
  }
  var colorizedCurves = destination;
  // Inline function 'kotlin.collections.flatMap' call
  // Inline function 'kotlin.collections.flatMapTo' call
  var destination_0 = ArrayList.p1();
  var tmp0_iterator_0 = colorizedCurves.z();
  while (tmp0_iterator_0.a1()) {
    var element = tmp0_iterator_0.b1();
    // Inline function 'korlibs.image.vector.msdf.<anonymous>' call
    var list = element.s5h_1;
    addAll(destination_0, list);
  }
  var allColorizedCurves = new ColorizedBeziers(destination_0);
  var inductionVariable = 0;
  var last = data.o2d();
  if (inductionVariable < last)
    do {
      var y = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      var inductionVariable_0 = 0;
      var last_0 = data.n2d();
      if (inductionVariable_0 < last_0)
        do {
          var x = inductionVariable_0;
          inductionVariable_0 = inductionVariable_0 + 1 | 0;
          p = Vector2D.j21(x + 0.5, y + 0.5);
          var inside = path.e3g(p);
          var allDist = allColorizedCurves.a5i().e5i(p);
          var redDist = allColorizedCurves.f5i().e5i(p);
          var greenDist = allColorizedCurves.g5i().e5i(p);
          var blueDist = allColorizedCurves.h5i().e5i(p);
          var minR = redDist;
          var minG = greenDist;
          var minB = blueDist;
          var minA = allDist;
          if (inside) {
            minR = -minR;
            minG = -minG;
            minB = -minB;
            minA = -minA;
          }
          data.m3z(x, y, minR, minG, minB, minA);
        }
         while (inductionVariable_0 < last_0);
    }
     while (inductionVariable < last);
  return data;
}
function ColorizedBeziers$red$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.s5h_1;
    var destination = ArrayList.p1();
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var element = tmp0_iterator.b1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.red$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_r__impl__duz7mo(element.j5i_1) === 0)) {
        destination.f(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$green$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.s5h_1;
    var destination = ArrayList.p1();
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var element = tmp0_iterator.b1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.green$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_g__impl__o8pukr(element.j5i_1) === 0)) {
        destination.f(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$blue$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.filter' call
    // Inline function 'kotlin.collections.filterTo' call
    var this_0 = this$0.s5h_1;
    var destination = ArrayList.p1();
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var element = tmp0_iterator.b1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blue$delegate.<anonymous>.<anonymous>' call
      if (!(_RGBA___get_b__impl__m6tl80(element.j5i_1) === 0)) {
        destination.f(element);
      }
    }
    return destination;
  };
}
function ColorizedBeziers$allProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.s5h_1;
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.allProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.i5i_1;
      destination.f(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$redProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.k5i();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.redProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.i5i_1;
      destination.f(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$greenProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.l5i();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.greenProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.i5i_1;
      destination.f(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function ColorizedBeziers$blueProjected$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.collections.map' call
    var this_0 = this$0.m5i();
    // Inline function 'kotlin.collections.mapTo' call
    var destination = ArrayList.w(collectionSizeOrDefault(this_0, 10));
    var tmp0_iterator = this_0.z();
    while (tmp0_iterator.a1()) {
      var item = tmp0_iterator.b1();
      // Inline function 'korlibs.image.vector.ColorizedBeziers.blueProjected$delegate.<anonymous>.<anonymous>' call
      var tmp$ret$0 = item.i5i_1;
      destination.f(tmp$ret$0);
    }
    return new ProjectCurvesLookup(destination);
  };
}
function colorize(_this__u8e3s4, closed) {
  closed = closed === VOID ? true : closed;
  // Inline function 'kotlin.collections.mapIndexed' call
  // Inline function 'kotlin.collections.mapIndexedTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(_this__u8e3s4, 10));
  var index = 0;
  var tmp0_iterator = _this__u8e3s4.z();
  while (tmp0_iterator.a1()) {
    var item = tmp0_iterator.b1();
    // Inline function 'korlibs.image.vector.colorize.<anonymous>' call
    var tmp1 = index;
    index = tmp1 + 1 | 0;
    var index_0 = checkIndexOverflow(tmp1);
    var color = msdfColor(index_0, _this__u8e3s4.d1(), closed);
    var tmp$ret$0 = new ColoredBezier(item, color);
    destination.f(tmp$ret$0);
  }
  return new ColorizedBeziers(destination);
}
function msdfColor(index, size, closed) {
  if (size === 1)
    return Colors_getInstance().k3n_1;
  if (index === 0)
    return Colors_getInstance().m3p_1;
  return ((index - 1 | 0) % 2 | 0) === 0 ? Colors_getInstance().a3t_1 : Colors_getInstance().k3o_1;
}
function sdfBmp$lambda($this_sdfBmp) {
  return function ($this$NativeImageContext2d) {
    var paint = new RGBA(Colors_getInstance().k3n_1);
    if (true) {
      $this$NativeImageContext2d.o4d();
    }
    // Inline function 'korlibs.image.vector.sdfBmp.<anonymous>.<anonymous>' call
    write($this$NativeImageContext2d, $this_sdfBmp);
    $this$NativeImageContext2d.l5h(paint, null);
    return Unit_instance;
  };
}
function red$factory() {
  return getPropertyCallableRef('red', 1, KProperty1, function (receiver) {
    return receiver.k5i();
  }, null);
}
function green$factory() {
  return getPropertyCallableRef('green', 1, KProperty1, function (receiver) {
    return receiver.l5i();
  }, null);
}
function blue$factory() {
  return getPropertyCallableRef('blue', 1, KProperty1, function (receiver) {
    return receiver.m5i();
  }, null);
}
function allProjected$factory() {
  return getPropertyCallableRef('allProjected', 1, KProperty1, function (receiver) {
    return receiver.a5i();
  }, null);
}
function redProjected$factory() {
  return getPropertyCallableRef('redProjected', 1, KProperty1, function (receiver) {
    return receiver.f5i();
  }, null);
}
function greenProjected$factory() {
  return getPropertyCallableRef('greenProjected', 1, KProperty1, function (receiver) {
    return receiver.g5i();
  }, null);
}
function blueProjected$factory() {
  return getPropertyCallableRef('blueProjected', 1, KProperty1, function (receiver) {
    return receiver.h5i();
  }, null);
}
function toContext2dCommands(_this__u8e3s4, prefix, suffix, decimalPlaces) {
  prefix = prefix === VOID ? 'ctx.' : prefix;
  suffix = suffix === VOID ? ';' : suffix;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  // Inline function 'kotlin.collections.map' call
  // Inline function 'kotlin.collections.buildList' call
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'kotlin.collections.buildListInternal' call
  // Inline function 'kotlin.apply' call
  var this_0 = ArrayList.p1();
  // Inline function 'kotlin.contracts.contract' call
  // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
  // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds' call
  var n = 0;
  // Inline function 'korlibs.datastructure.iterators.fastForEach' call
  var this_1 = _this__u8e3s4.q36_1;
  var n_0 = 0;
  while (n_0 < this_1.d1()) {
    // Inline function 'korlibs.math.geom.vector.VectorPath.visitCmds.<anonymous>' call
    var _unary__edvuaz = n_0;
    n_0 = _unary__edvuaz + 1 | 0;
    switch (this_1.ow(_unary__edvuaz)) {
      case 0:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_0 = n;
        n = _unary__edvuaz_0 + 1 | 0;
        var tmp = _this__u8e3s4.r36_1.c1(_unary__edvuaz_0);
        var _unary__edvuaz_1 = n;
        n = _unary__edvuaz_1 + 1 | 0;
        var destruct = Vector2D.j21(tmp, _this__u8e3s4.r36_1.c1(_unary__edvuaz_1));
        var x = destruct.rk();
        var y = destruct.sk();
        this_0.f('moveTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y, decimalPlaces) + ')');
        break;
      case 1:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_2 = n;
        n = _unary__edvuaz_2 + 1 | 0;
        var tmp_0 = _this__u8e3s4.r36_1.c1(_unary__edvuaz_2);
        var _unary__edvuaz_3 = n;
        n = _unary__edvuaz_3 + 1 | 0;
        var destruct_0 = Vector2D.j21(tmp_0, _this__u8e3s4.r36_1.c1(_unary__edvuaz_3));
        var x_0 = destruct_0.rk();
        var y_0 = destruct_0.sk();
        this_0.f('lineTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(x_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(y_0, decimalPlaces) + ')');
        break;
      case 2:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_4 = n;
        n = _unary__edvuaz_4 + 1 | 0;
        var tmp_1 = _this__u8e3s4.r36_1.c1(_unary__edvuaz_4);
        var _unary__edvuaz_5 = n;
        n = _unary__edvuaz_5 + 1 | 0;
        var destruct_1 = Vector2D.j21(tmp_1, _this__u8e3s4.r36_1.c1(_unary__edvuaz_5));
        var _unary__edvuaz_6 = n;
        n = _unary__edvuaz_6 + 1 | 0;
        var tmp_2 = _this__u8e3s4.r36_1.c1(_unary__edvuaz_6);
        var _unary__edvuaz_7 = n;
        n = _unary__edvuaz_7 + 1 | 0;
        var destruct_2 = Vector2D.j21(tmp_2, _this__u8e3s4.r36_1.c1(_unary__edvuaz_7));
        var cx = destruct_1.rk();
        var cy = destruct_1.sk();
        var ax = destruct_2.rk();
        var ay = destruct_2.sk();
        this_0.f('quadTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay, decimalPlaces) + ')');
        break;
      case 3:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        var _unary__edvuaz_8 = n;
        n = _unary__edvuaz_8 + 1 | 0;
        var tmp_3 = _this__u8e3s4.r36_1.c1(_unary__edvuaz_8);
        var _unary__edvuaz_9 = n;
        n = _unary__edvuaz_9 + 1 | 0;
        var destruct_3 = Vector2D.j21(tmp_3, _this__u8e3s4.r36_1.c1(_unary__edvuaz_9));
        var _unary__edvuaz_10 = n;
        n = _unary__edvuaz_10 + 1 | 0;
        var tmp_4 = _this__u8e3s4.r36_1.c1(_unary__edvuaz_10);
        var _unary__edvuaz_11 = n;
        n = _unary__edvuaz_11 + 1 | 0;
        var destruct_4 = Vector2D.j21(tmp_4, _this__u8e3s4.r36_1.c1(_unary__edvuaz_11));
        var _unary__edvuaz_12 = n;
        n = _unary__edvuaz_12 + 1 | 0;
        var tmp_5 = _this__u8e3s4.r36_1.c1(_unary__edvuaz_12);
        var _unary__edvuaz_13 = n;
        n = _unary__edvuaz_13 + 1 | 0;
        var destruct_5 = Vector2D.j21(tmp_5, _this__u8e3s4.r36_1.c1(_unary__edvuaz_13));
        var cx1 = destruct_3.rk();
        var cy1 = destruct_3.sk();
        var cx2 = destruct_4.rk();
        var cy2 = destruct_4.sk();
        var ax_0 = destruct_5.rk();
        var ay_0 = destruct_5.sk();
        this_0.f('cubicTo(' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy1, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cx2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(cy2, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ax_0, decimalPlaces) + ', ' + toContext2dCommands$_anonymous_$round$0_5f3kr1(ay_0, decimalPlaces) + ')');
        break;
      case 4:
        // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>.<anonymous>' call

        this_0.f('close()');
        break;
    }
  }
  var this_2 = this_0.s7();
  // Inline function 'kotlin.collections.mapTo' call
  var destination = ArrayList.w(collectionSizeOrDefault(this_2, 10));
  var tmp0_iterator = this_2.z();
  while (tmp0_iterator.a1()) {
    var item = tmp0_iterator.b1();
    // Inline function 'korlibs.image.vector.toContext2dCommands.<anonymous>' call
    var tmp$ret$3 = prefix + item + suffix;
    destination.f(tmp$ret$3);
  }
  return destination;
}
function FillShape$pathCurvesList$delegate$lambda(this$0) {
  return function () {
    return toCurvesList(this$0.p5i_1);
  };
}
function FillShape$clipCurvesList$delegate$lambda(this$0) {
  return function () {
    var tmp350_safe_receiver = this$0.q5i_1;
    return tmp350_safe_receiver == null ? null : toCurvesList(tmp350_safe_receiver);
  };
}
function toSvgPathString(_this__u8e3s4, separator, decimalPlaces) {
  separator = separator === VOID ? ' ' : separator;
  decimalPlaces = decimalPlaces === VOID ? 1 : decimalPlaces;
  return SvgPath_instance.c5j(_this__u8e3s4, separator, decimalPlaces);
}
function PolylineShape$fillShape$delegate$lambda(this$0) {
  return function () {
    return new FillShape(strokeToFill_0(this$0.d5j_1, this$0.h5j_1), this$0.e5j_1, this$0.f5j_1, this$0.g5j_1, this$0.i5j_1);
  };
}
var EmptyShape_instance;
function EmptyShape_getInstance() {
  return EmptyShape_instance;
}
function toContext2dCommands$_anonymous_$round$0_5f3kr1(_this__u8e3s4, $decimalPlaces) {
  return niceStr(_this__u8e3s4, $decimalPlaces);
}
function pathCurvesList$factory() {
  return getPropertyCallableRef('pathCurvesList', 1, KProperty1, function (receiver) {
    return receiver.x5i();
  }, null);
}
function clipCurvesList$factory() {
  return getPropertyCallableRef('clipCurvesList', 1, KProperty1, function (receiver) {
    return receiver.y5i();
  }, null);
}
function thickness$factory($b0) {
  return getPropertyCallableRef('thickness', 0, KProperty0, function () {
    return $b0.w30_1;
  }, null);
}
function scaleMode$factory($b0) {
  return getPropertyCallableRef('scaleMode', 0, KProperty0, function () {
    return $b0.y30_1;
  }, null);
}
function startCap$factory($b0) {
  return getPropertyCallableRef('startCap', 0, KProperty0, function () {
    return $b0.z30_1;
  }, null);
}
function endCap$factory($b0) {
  return getPropertyCallableRef('endCap', 0, KProperty0, function () {
    return $b0.a31_1;
  }, null);
}
function join$factory($b0) {
  return getPropertyCallableRef('join', 0, KProperty0, function () {
    return $b0.b31_1;
  }, null);
}
function miterLimit$factory($b0) {
  return getPropertyCallableRef('miterLimit', 0, KProperty0, function () {
    return $b0.c31_1;
  }, null);
}
function dash$factory($b0) {
  return getPropertyCallableRef('dash', 0, KProperty0, function () {
    return $b0.d31_1;
  }, null);
}
function dashOffset$factory($b0) {
  return getPropertyCallableRef('dashOffset', 0, KProperty0, function () {
    return $b0.e31_1;
  }, null);
}
function primitiveShapes$factory() {
  return getPropertyCallableRef('primitiveShapes', 1, KProperty1, function (receiver) {
    return receiver.u5j();
  }, null);
}
function toSvgPathString$fixX(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
function toSvgPathString$fixY(_this__u8e3s4, $decimalPlaces) {
  return toStringDecimal(_this__u8e3s4, $decimalPlaces, true);
}
var SvgPath_instance;
function SvgPath_getInstance() {
  return SvgPath_instance;
}
function Rasterizer$rasterizeFill$lambda($xmax, $xmin, this$0, $callback) {
  return function (a, b, y) {
    var tmp;
    if (a <= $xmax && b >= $xmin) {
      var a0 = coerceIn(a, $xmin, $xmax);
      var b0 = coerceIn(b, $xmin, $xmax);
      if (this$0.k5f_1) {
        println('RASTER(' + a0 + ', ' + b0 + ', ' + y + ')');
      }
      tmp = $callback(a0, b0, y);
    } else {
      tmp = Unit_instance;
    }
    return Unit_instance;
  };
}
function Renderer$drawImage$lambda($pos, $size) {
  return function ($this$transformed) {
    $this$transformed.t3f($pos, $size);
    return Unit_instance;
  };
}
var Companion_instance_44;
function Companion_getInstance_55() {
  if (Companion_instance_44 === VOID)
    new Companion_38();
  return Companion_instance_44;
}
var HtmlCanvas_instance;
function HtmlCanvas_getInstance() {
  return HtmlCanvas_instance;
}
function toLike(_this__u8e3s4) {
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  return _this__u8e3s4;
}
function toHtmlNative(_this__u8e3s4) {
  var tmp;
  if (_this__u8e3s4 instanceof HtmlNativeImage) {
    tmp = _this__u8e3s4;
  } else {
    tmp = HtmlNativeImage.z5k(HtmlImage_instance.f5k(_this__u8e3s4.s3m()));
  }
  return tmp;
}
var HtmlImage_instance;
function HtmlImage_getInstance() {
  return HtmlImage_instance;
}
function get_nativeImageFormatProvider() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return nativeImageFormatProvider;
}
var nativeImageFormatProvider;
function get_tempB() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return tempB;
}
var tempB;
function get_tempI() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return tempI;
}
var tempI;
function get_temp8() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return temp8;
}
var temp8;
function get_isLittleEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  // Inline function 'kotlin.getValue' call
  var this_0 = isLittleEndian$delegate;
  isLittleEndian$factory();
  return this_0.t1();
}
var isLittleEndian$delegate;
var NodeJsNativeImageFormatProvider_instance;
function NodeJsNativeImageFormatProvider_getInstance() {
  if (NodeJsNativeImageFormatProvider_instance === VOID)
    new NodeJsNativeImageFormatProvider();
  return NodeJsNativeImageFormatProvider_instance;
}
function *_generator_decodeInternal__jnwsgt_0($this, data, props, $completion) {
  var tmp = BrowserImage_instance.d5l(data, props, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return new NativeImageResult(HtmlNativeImage.z5k(tmp));
}
function *_generator_decodeInternal__jnwsgt_1($this, vfs, path, props, $completion) {
  var tmp;
  if (vfs instanceof LocalVfs) {
    var tmp_0 = BrowserImage_instance.e5l(path, props, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    tmp = HtmlNativeImage.f5l(tmp_0);
  } else {
    if (vfs instanceof UrlVfs) {
      var jsUrl = vfs.a1t(path);
      var tmp_1 = BrowserImage_instance.e5l(jsUrl, props, $completion);
      if (tmp_1 === get_COROUTINE_SUSPENDED())
        tmp_1 = yield tmp_1;
      tmp = HtmlNativeImage.f5l(tmp_1);
    } else {
      var tmp_2 = BrowserImage_instance;
      var tmp_3 = vfs.lh(path).o1s($completion);
      if (tmp_3 === get_COROUTINE_SUSPENDED())
        tmp_3 = yield tmp_3;
      var tmp_4 = tmp_2.d5l(tmp_3, props, $completion);
      if (tmp_4 === get_COROUTINE_SUSPENDED())
        tmp_4 = yield tmp_4;
      tmp = HtmlNativeImage.z5k(tmp_4);
    }
  }
  return new NativeImageResult(tmp);
}
var HtmlNativeImageFormatProvider_instance;
function HtmlNativeImageFormatProvider_getInstance() {
  if (HtmlNativeImageFormatProvider_instance === VOID)
    new HtmlNativeImageFormatProvider();
  return HtmlNativeImageFormatProvider_instance;
}
function HtmlNativeImage$lazyCanvasElement$delegate$lambda(this$0, $width, $height) {
  return function () {
    // Inline function 'kotlin.also' call
    var tmp;
    // Inline function 'kotlin.js.asDynamic' call
    if (this$0.v5k_1.src !== undefined) {
      var tmp_0 = BrowserImage_instance;
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      var tmp$ret$2 = this$0.v5k_1;
      tmp = tmp_0.g5l(tmp$ret$2, $width, $height);
    } else {
      // Inline function 'kotlin.js.unsafeCast' call
      // Inline function 'kotlin.js.asDynamic' call
      tmp = this$0.v5k_1;
    }
    var this_0 = tmp;
    // Inline function 'kotlin.contracts.contract' call
    // Inline function 'korlibs.image.format.HtmlNativeImage.lazyCanvasElement$delegate.<anonymous>.<anonymous>' call
    this$0.v5k_1 = this_0;
    return this_0;
  };
}
function HtmlNativeImage$ctx$delegate$lambda(this$0) {
  return function () {
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    return this$0.h5l().getContext('2d');
  };
}
function *_generator_decodeToCanvas__71sobd($this, bytes, props, $completion) {
  if (Companion_getInstance_11().sq()) {
    // Inline function 'kotlin.error' call
    var message = 'Canvas not available on NodeJS';
    throw IllegalStateException.w4(toString_0(message));
  }
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var tmp = [bytes];
  // Inline function 'org.w3c.files.BlobPropertyBag' call
  var type = 'image/png';
  var o = {};
  o['type'] = type;
  var blob = new Blob(tmp, o);
  var blobURL = URL.createObjectURL(blob);
  try {
    var tmp_0 = $this.m5l(blobURL, $completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
    return tmp_0;
  }finally {
    URL.revokeObjectURL(blobURL);
  }
}
function *_generator_loadCanvas__xw76hi($this, jsUrl, $completion) {
  var tmp = $this.n5l(jsUrl, VOID, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return $this.o5l(tmp);
}
function BrowserImage$loadImage$lambda($c, $img) {
  return function (it) {
    // Inline function 'kotlin.coroutines.resume' call
    var this_0 = $c;
    // Inline function 'kotlin.js.unsafeCast' call
    // Inline function 'kotlin.js.asDynamic' call
    // Inline function 'kotlin.Companion.success' call
    var value = $img;
    var tmp$ret$2 = _Result___init__impl__xyqfz8(value);
    this_0.nc(tmp$ret$2);
    return Unit_instance;
  };
}
function BrowserImage$loadImage$lambda_0($c, $jsUrl) {
  return function (_unused_var__etf5q3, _unused_var__etf5q3_0, _unused_var__etf5q3_1, _unused_var__etf5q3_2, _unused_var__etf5q3_3) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    var this_0 = $c;
    // Inline function 'kotlin.Companion.failure' call
    var exception = RuntimeException.ia('error loading image ' + $jsUrl);
    var tmp$ret$0 = _Result___init__impl__xyqfz8(createFailure(exception));
    this_0.nc(tmp$ret$0);
    return Unit_instance;
  };
}
var BrowserImage_instance;
function BrowserImage_getInstance() {
  return BrowserImage_instance;
}
function get_isBigEndian() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return !get_isLittleEndian();
}
function bswap32(v, offset, size) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  var inductionVariable = offset;
  var last = offset + size | 0;
  if (inductionVariable < last)
    do {
      var n = inductionVariable;
      inductionVariable = inductionVariable + 1 | 0;
      v[n] = bswap32_0(v[n]);
    }
     while (inductionVariable < last);
}
function setFont($this, font, fontSize) {
  var tmp;
  if ((font == null ? null : font.n3()) == $this.u5l_1) {
    tmp = fontSize === $this.t5l_1;
  } else {
    tmp = false;
  }
  if (tmp)
    return Unit_instance;
  var tmp_0 = $this;
  tmp_0.u5l_1 = font == null ? null : font.n3();
  $this.t5l_1 = fontSize;
  var tmp0_elvis_lhs = font == null ? null : font.n3();
  $this.s5l_1.font = '' + fontSize + "px '" + (tmp0_elvis_lhs == null ? 'default' : tmp0_elvis_lhs) + "'";
}
function setState($this, state, fill, doSetFont) {
  $this.s5l_1.globalAlpha = state.r47_1;
  $this.s5l_1.globalCompositeOperation = $this.v5l(state.s47_1);
  if (doSetFont) {
    setFont($this, state.n47_1, state.o47_1);
  }
  if (fill) {
    $this.s5l_1.fillStyle = $this.w5l(state.l47_1);
  } else {
    $this.s5l_1.lineWidth = state.f47_1;
    var tmp;
    switch (state.i47_1.m3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BEVEL' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'bevel';
        break;
      case 2:
        // Inline function 'org.w3c.dom.MITER' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'miter';
        break;
      case 1:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp = 'round';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.s5l_1.lineJoin = tmp;
    var tmp_0;
    switch (state.c4f().m3_1) {
      case 0:
        // Inline function 'org.w3c.dom.BUTT' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'butt';
        break;
      case 2:
        // Inline function 'org.w3c.dom.ROUND' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'round';
        break;
      case 1:
        // Inline function 'org.w3c.dom.SQUARE' call

        // Inline function 'kotlin.js.unsafeCast' call

        // Inline function 'kotlin.js.asDynamic' call

        tmp_0 = 'square';
        break;
      default:
        noWhenBranchMatchedException();
        break;
    }
    $this.s5l_1.lineCap = tmp_0;
    $this.s5l_1.strokeStyle = $this.w5l(state.k47_1);
  }
}
function transformPaint($this, paint) {
  if (isInterface(paint, TransformedPaint)) {
    $this.x5l($this.s5l_1, paint.a4h());
  }
}
function bswap32_0(v) {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  return (v >>> 24 | 0 | v << 24 | (v & 65280) << 8 | (v >>> 8 | 0)) & 65280;
}
function isLittleEndian$delegate$lambda() {
  _init_properties_NativeImageFormatProviderJs_kt__3qg4wz();
  // Inline function 'org.khronos.webgl.set' call
  // Inline function 'kotlin.js.asDynamic' call
  get_tempI()[0] = 1;
  // Inline function 'org.khronos.webgl.get' call
  // Inline function 'kotlin.js.asDynamic' call
  return get_temp8()[0] === 1;
}
function isLittleEndian$factory() {
  return getPropertyCallableRef('isLittleEndian', 0, KProperty0, function () {
    return get_isLittleEndian();
  }, null);
}
function lazyCanvasElement$factory() {
  return getPropertyCallableRef('lazyCanvasElement', 1, KProperty1, function (receiver) {
    return receiver.h5l();
  }, null);
}
function ctx$factory() {
  return getPropertyCallableRef('ctx', 1, KProperty1, function (receiver) {
    return receiver.j5l();
  }, null);
}
var properties_initialized_NativeImageFormatProviderJs_kt_7b9n17;
function _init_properties_NativeImageFormatProviderJs_kt__3qg4wz() {
  if (!properties_initialized_NativeImageFormatProviderJs_kt_7b9n17) {
    properties_initialized_NativeImageFormatProviderJs_kt_7b9n17 = true;
    nativeImageFormatProvider = Companion_getInstance_11().sq() ? NodeJsNativeImageFormatProvider_getInstance() : HtmlNativeImageFormatProvider_getInstance();
    tempB = new ArrayBuffer(4);
    tempI = new Int32Array(get_tempB());
    temp8 = new Uint8Array(get_tempB());
    isLittleEndian$delegate = lazy(isLittleEndian$delegate$lambda);
  }
}
//region block: post-declaration
initMetadataForClass(GrowMethod, 'GrowMethod');
initMetadataForClass(Entry, 'Entry');
initMetadataForClass(MutableAtlas, 'MutableAtlas', MutableAtlas.c3m);
initMetadataForClass(Bitmap, 'Bitmap');
initMetadataForCompanion(Companion, VOID, VOID, [2, 3]);
initMetadataForLambda(Bitmap32$iterator$slambda, VOID, VOID, [1]);
initMetadataForClass(Bitmap32, 'Bitmap32', VOID, VOID, [Bitmap, Iterable]);
initMetadataForCompanion(Companion_0);
initMetadataForClass(BitmapIndexed, 'BitmapIndexed');
initMetadataForClass(Bitmap8, 'Bitmap8');
initMetadataForCompanion(Companion_1);
initMetadataForClass(BitmapChannel, 'BitmapChannel');
initMetadataForObject(Bitmaps, 'Bitmaps');
initMetadataForCompanion(Companion_2);
initMetadataForClass(DistanceBitmap, 'DistanceBitmap');
initMetadataForClass(FloatBitmap32, 'FloatBitmap32');
initMetadataForClass(MultiBitmap, 'MultiBitmap');
initMetadataForClass(NativeImage, 'NativeImage');
initMetadataForInterface(ForcedTexId, 'ForcedTexId');
initMetadataForCompanion(Companion_3);
initMetadataForClass(NinePatchBmpSlice, 'NinePatchBmpSlice');
initMetadataForClass(AxisSegment, 'AxisSegment');
initMetadataForClass(AxisInfo, 'AxisInfo');
initMetadataForClass(Segment, 'Segment');
initMetadataForClass(NinePatchInfo, 'NinePatchInfo');
initMetadataForClass(NullBitmap, 'NullBitmap');
initMetadataForClass(Palette, 'Palette');
initMetadataForClass(Result, 'Result');
initMetadataForObject(NewSDF, 'NewSDF');
initMetadataForClass(ColorFormat32, 'ColorFormat32');
initMetadataForClass(ColorFormat24, 'ColorFormat24');
initMetadataForClass(ColorTransformMul, 'ColorTransformMul', ColorTransformMul);
initMetadataForObject(Colors, 'Colors');
initMetadataForClass(RGB, 'RGB');
initMetadataForCompanion(Companion_4);
initMetadataForCompanion(Companion_5);
initMetadataForClass(RgbaArray, 'RgbaArray', VOID, VOID, [KtList]);
initMetadataForCompanion(Companion_6);
initMetadataForClass(RGBA, 'RGBA', VOID, VOID, [Comparable]);
initMetadataForCompanion(Companion_7);
initMetadataForCompanion(Companion_8);
initMetadataForClass(RgbaPremultipliedArray, 'RgbaPremultipliedArray');
initMetadataForCompanion(Companion_9);
initMetadataForCompanion(Companion_10);
initMetadataForClass(Kerning, 'Kerning');
initMetadataForClass(Glyph, 'Glyph');
initMetadataForInterface(Font, 'Font', VOID, VOID, VOID, [0]);
initMetadataForInterface(BitmapFont, 'BitmapFont', VOID, VOID, [Font], [0]);
protoOf(BitmapFontImpl).z45 = get_baseBmp;
protoOf(BitmapFontImpl).d46 = getFontMetrics;
protoOf(BitmapFontImpl).o46 = getFontMetrics$default;
protoOf(BitmapFontImpl).p46 = getGlyphMetrics;
protoOf(BitmapFontImpl).x46 = getGlyphMetrics$default;
protoOf(BitmapFontImpl).c48 = getKerning;
protoOf(BitmapFontImpl).z46 = getTextScale;
protoOf(BitmapFontImpl).c1 = get_0;
protoOf(BitmapFontImpl).a47 = renderGlyph;
protoOf(BitmapFontImpl).b48 = renderGlyph$default;
initMetadataForClass(BitmapFontImpl, 'BitmapFontImpl', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(TextToBitmapResult, 'TextToBitmapResult');
initMetadataForClass(PlacedGlyphMetrics, 'PlacedGlyphMetrics');
initMetadataForClass(TextMetricsResult, 'TextMetricsResult', TextMetricsResult);
initMetadataForClass(MultiplePlacedGlyphMetrics, 'MultiplePlacedGlyphMetrics', MultiplePlacedGlyphMetrics);
initMetadataForInterface(ITextRendererActions, 'ITextRendererActions');
protoOf(TextRendererActions).e2h = reset;
protoOf(TextRendererActions).i4h = advance;
protoOf(TextRendererActions).j4h = newLine;
initMetadataForClass(TextRendererActions, 'TextRendererActions', VOID, VOID, [ITextRendererActions]);
initMetadataForClass(drawText$actions$1);
initMetadataForClass(GlyphPath, 'GlyphPath', GlyphPath);
initMetadataForCompanion(Companion_11);
protoOf(LazyBitmapFont).z45 = get_baseBmp;
protoOf(LazyBitmapFont).d46 = getFontMetrics;
protoOf(LazyBitmapFont).o46 = getFontMetrics$default;
protoOf(LazyBitmapFont).p46 = getGlyphMetrics;
protoOf(LazyBitmapFont).x46 = getGlyphMetrics$default;
protoOf(LazyBitmapFont).c48 = getKerning;
protoOf(LazyBitmapFont).z46 = getTextScale;
protoOf(LazyBitmapFont).xx = getOrNull_2;
protoOf(LazyBitmapFont).c1 = get_0;
protoOf(LazyBitmapFont).a47 = renderGlyph;
protoOf(LazyBitmapFont).b48 = renderGlyph$default;
initMetadataForClass(LazyBitmapFont, 'LazyBitmapFont', VOID, VOID, [BitmapFont], [0]);
initMetadataForClass(FontMetrics, 'FontMetrics', FontMetrics);
initMetadataForClass(GlyphMetrics, 'GlyphMetrics', GlyphMetrics);
initMetadataForClass(TextMetrics, 'TextMetrics', TextMetrics);
initMetadataForCompanion(Companion_12);
initMetadataForClass(GlyphPath_0, 'GlyphPath');
initMetadataForClass(CFFResult, 'CFFResult');
initMetadataForClass(DataIndex, 'DataIndex', DataIndex.b4k, VOID, [Iterable]);
initMetadataForClass(Op, 'Op');
initMetadataForCompanion(Companion_13);
initMetadataForClass(EvalContext, 'EvalContext', EvalContext);
initMetadataForClass(Op_0, 'Op');
initMetadataForObject(CFF, 'CFF');
initMetadataForObject(CharStringType2, 'CharStringType2');
initMetadataForObject(TtfCIDFont, 'TtfCIDFont');
initMetadataForCompanion(Companion_14, VOID, VOID, [1]);
initMetadataForInterface(VectorFont, 'VectorFont', VOID, VOID, [Font], [0]);
protoOf(BaseTtfFont).o46 = getFontMetrics$default;
protoOf(BaseTtfFont).x46 = getGlyphMetrics$default;
protoOf(BaseTtfFont).x4n = getGlyphPath$default;
protoOf(BaseTtfFont).a47 = renderGlyph_0;
protoOf(BaseTtfFont).b48 = renderGlyph$default;
protoOf(BaseTtfFont).xx = getOrNull_2;
initMetadataForClass(BaseTtfFont, 'BaseTtfFont', VOID, VOID, [VectorFont], [0]);
initMetadataForClass(TtfFont, 'TtfFont', VOID, VOID, VOID, [0]);
initMetadataForCompanion(Companion_15);
initMetadataForCompanion(Companion_16);
initMetadataForClass(NamesInfo, 'NamesInfo', NamesInfo);
initMetadataForClass(SubstitutionInfo, 'SubstitutionInfo');
initMetadataForClass(Table, 'Table');
initMetadataForClass(HorMetric, 'HorMetric');
initMetadataForCompanion(Companion_17);
initMetadataForClass(NameId, 'NameId');
initMetadataForClass(ColorBitmapInfo, 'ColorBitmapInfo', ColorBitmapInfo);
initMetadataForClass(SbitLineMetrics, 'SbitLineMetrics', SbitLineMetrics);
initMetadataForClass(BitmapGlyphInfo, 'BitmapGlyphInfo');
initMetadataForClass(ColorLine, 'ColorLine');
initMetadataForClass(ColorStop, 'ColorStop');
initMetadataForClass(Colrv1Paint, 'Colrv1Paint');
initMetadataForClass(COLRv1, 'COLRv1', COLRv1);
initMetadataForClass(Contour, 'Contour', Contour);
initMetadataForClass(GlyphReference, 'GlyphReference');
initMetadataForClass(ColrLayerInfo, 'ColrLayerInfo');
initMetadataForInterface(ColrGlyphInfo, 'ColrGlyphInfo');
protoOf(ColrGlyphInfoV1).c4v = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV1, 'ColrGlyphInfoV1', VOID, VOID, [ColrGlyphInfo]);
protoOf(ColrGlyphInfoV0).c4v = getColorShape$default;
initMetadataForClass(ColrGlyphInfoV0, 'ColrGlyphInfoV0', VOID, VOID, [ColrGlyphInfo]);
protoOf(GlyphGraphicsPath).w3f = arc$default;
initMetadataForClass(GlyphGraphicsPath, 'GlyphGraphicsPath', VOID, VOID, [VectorBuilder]);
initMetadataForClass(Glyph_0, 'Glyph');
initMetadataForClass(CompositeGlyph, 'CompositeGlyph');
initMetadataForClass(CFFGlyph, 'CFFGlyph');
initMetadataForClass(SimpleGlyph, 'SimpleGlyph');
initMetadataForClass(BaseTtfFont$readCblc$1$Subtable, 'Subtable');
initMetadataForClass(BaseTtfFont$readSbix$1$StrikeInfo, 'StrikeInfo');
initMetadataForClass(BaseTtfFont$readCoverage$RangeInfo, 'RangeInfo');
initMetadataForClass(BaseTtfFont$readCmap$1$EncodingRecord, 'EncodingRecord');
initMetadataForCompanion(Companion_18);
initMetadataForCompanion(Companion_19);
initMetadataForClass(Mixin_0, 'Mixin', Mixin_0);
initMetadataForClass(sam$kotlin_Comparator$0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForInterface(AseCell, 'AseCell');
protoOf(AseBitmapCell).o4y = resolve;
initMetadataForClass(AseBitmapCell, 'AseBitmapCell', VOID, VOID, [AseCell]);
initMetadataForClass(AseLinkedCell, 'AseLinkedCell', VOID, VOID, [AseCell]);
protoOf(AseTilemapCell).o4y = resolve;
initMetadataForClass(AseTilemapCell, 'AseTilemapCell', VOID, VOID, [AseCell]);
initMetadataForClass(ImageLayer, 'ImageLayer');
initMetadataForClass(AseLayer, 'AseLayer');
initMetadataForClass(AseFrame, 'AseFrame');
initMetadataForClass(AsePalette, 'AsePalette');
initMetadataForClass(AseTileset, 'AseTileset');
initMetadataForClass(AseSliceKey, 'AseSliceKey');
initMetadataForClass(AseSlice, 'AseSlice');
initMetadataForClass(AseTag, 'AseTag');
initMetadataForClass(AseImage, 'AseImage', AseImage);
initMetadataForClass(ImageFormat, 'ImageFormat', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatWithContainer, 'ImageFormatWithContainer', VOID, VOID, VOID, [2, 1]);
initMetadataForObject(ASE, 'ASE', VOID, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_20);
initMetadataForCompanion(Companion_21);
initMetadataForClass(DataFormat, 'DataFormat');
initMetadataForObject(EXIF, 'EXIF', VOID, VOID, VOID, [3]);
initMetadataForClass(Direction, 'Direction');
initMetadataForClass(sam$kotlin_Comparator$0_0, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(ImageAnimation, 'ImageAnimation');
initMetadataForCompanion(Companion_22);
initMetadataForClass(sam$kotlin_Comparator$0_1, 'sam$kotlin_Comparator$0', VOID, VOID, [Comparator]);
initMetadataForClass(ImageData, 'ImageData');
initMetadataForClass(ImageDataContainer, 'ImageDataContainer');
initMetadataForCompanion(Companion_23);
initMetadataForClass(ImageDecodingProps, 'ImageDecodingProps', ImageDecodingProps);
initMetadataForClass(ImageDecoderNotFoundException, 'ImageDecoderNotFoundException');
initMetadataForClass(ImageFormats, 'ImageFormats', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(ImageFormatsMutable, 'ImageFormatsMutable', ImageFormatsMutable.a56, VOID, VOID, [2, 1]);
initMetadataForCompanion(Companion_24);
initMetadataForClass(ImageFrame, 'ImageFrame');
initMetadataForClass(ImageFrameLayer, 'ImageFrameLayer');
initMetadataForClass(ImageInfo, 'ImageInfo', ImageInfo);
initMetadataForCompanion(Companion_25);
initMetadataForClass(Type, 'Type');
initMetadataForClass(NativeImageFormatProvider, 'NativeImageFormatProvider', VOID, VOID, VOID, [1, 2, 3]);
initMetadataForClass(BaseNativeImageFormatProvider, 'BaseNativeImageFormatProvider', BaseNativeImageFormatProvider, VOID, VOID, [2, 1, 3]);
initMetadataForClass(NativeImageResult, 'NativeImageResult');
initMetadataForClass(BitmapNativeImage, 'BitmapNativeImage');
initMetadataForCompanion(Companion_26);
initMetadataForClass(InterlacedPass, 'InterlacedPass');
initMetadataForClass(Colorspace, 'Colorspace');
initMetadataForClass(Header, 'Header');
initMetadataForClass(DecodingContext, 'DecodingContext');
initMetadataForLambda(PNG$readCommon$readChunk$slambda, VOID, VOID, [0]);
initMetadataForObject(PNG, 'PNG', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(BaseFiller, 'BaseFiller');
initMetadataForClass(ColorFiller, 'ColorFiller', ColorFiller);
initMetadataForCompanion(Companion_27);
initMetadataForClass(GradientFiller, 'GradientFiller', GradientFiller);
initMetadataForClass(BitmapFiller, 'BitmapFiller', BitmapFiller);
initMetadataForObject(NoneFiller, 'NoneFiller');
initMetadataForCompanion(Companion_28);
initMetadataForInterface(TransformedPaint, 'TransformedPaint');
initMetadataForClass(GradientPaint, 'GradientPaint', VOID, VOID, [TransformedPaint]);
initMetadataForClass(GradientKind, 'GradientKind');
initMetadataForClass(GradientInterpolationMethod, 'GradientInterpolationMethod');
initMetadataForClass(GradientUnits, 'GradientUnits');
initMetadataForObject(NonePaint, 'NonePaint');
initMetadataForClass(BitmapPaint, 'BitmapPaint', VOID, VOID, [TransformedPaint]);
initMetadataForCompanion(Companion_29);
initMetadataForClass(VerticalAlign, 'VerticalAlign');
initMetadataForCompanion(Companion_30);
initMetadataForClass(HorizontalAlign, 'HorizontalAlign');
initMetadataForCompanion(Companion_31);
initMetadataForClass(TextAlignment, 'TextAlignment');
initMetadataForInterface(TextRenderer, 'TextRenderer');
initMetadataForClass(LineStats, 'LineStats', LineStats);
initMetadataForClass(BoundBuilderTextRendererActions, 'BoundBuilderTextRendererActions', BoundBuilderTextRendererActions);
initMetadataForClass(LineInfo, 'LineInfo', LineInfo);
initMetadataForClass(Entry_0, 'Entry', Entry_0);
initMetadataForClass(Text2TextRendererActions, 'Text2TextRendererActions', Text2TextRendererActions);
initMetadataForClass(CreateWStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForClass(CreateStringTextRenderer$2, VOID, VOID, VOID, [TextRenderer]);
initMetadataForCompanion(Companion_32);
initMetadataForCompanion(Companion_33);
initMetadataForClass(TileMapData, 'TileMapData', VOID, VOID, [BaseDelegatedStackedArray2, IStackedArray2Base]);
initMetadataForClass(TileMapRepeat, 'TileMapRepeat');
initMetadataForCompanion(Companion_34);
initMetadataForClass(TileSet, 'TileSet');
initMetadataForClass(TileSetTileInfo, 'TileSetTileInfo');
initMetadataForClass(SegmentHandler, 'SegmentHandler', SegmentHandler);
initMetadataForClass(ScanlineWriter, 'ScanlineWriter');
initMetadataForClass(Renderer, 'Renderer');
initMetadataForClass(Bitmap32Context2d, 'Bitmap32Context2d');
initMetadataForClass(CompositeOperation$Companion$invoke$1);
initMetadataForCompanion(Companion_35);
initMetadataForCompanion(Companion_36);
initMetadataForClass(CompositeMode, 'CompositeMode');
initMetadataForClass(BlendMode, 'BlendMode');
initMetadataForClass(State, 'State', State);
protoOf(Context2d).r3f = line;
protoOf(Context2d).f1 = isEmpty;
protoOf(Context2d).s3f = rect;
protoOf(Context2d).t3f = rect_0;
protoOf(Context2d).u3f = rect_1;
protoOf(Context2d).v3f = arc;
protoOf(Context2d).w3f = arc$default;
protoOf(Context2d).x3f = circle;
protoOf(Context2d).y3f = rMoveTo;
protoOf(Context2d).z3f = rLineTo;
protoOf(Context2d).m2a = transformed;
initMetadataForClass(Context2d, 'Context2d', VOID, VOID, [VectorBuilder]);
initMetadataForCompanion(Companion_37);
initMetadataForClass(CycleMethod, 'CycleMethod');
initMetadataForClass(ColorizedBeziers, 'ColorizedBeziers');
initMetadataForClass(ColoredBezier, 'ColoredBezier');
initMetadataForClass(ProjectCurvesLookup, 'ProjectCurvesLookup');
initMetadataForInterface(Shape, 'Shape');
initMetadataForInterface(StyledShape, 'StyledShape', VOID, VOID, [Shape]);
protoOf(FillShape).o5i = getBounds;
protoOf(FillShape).n5i = getPath_0;
protoOf(FillShape).l4i = getPath$default;
protoOf(FillShape).s4h = draw;
protoOf(FillShape).l4v = get_bounds;
initMetadataForClass(FillShape, 'FillShape', VOID, VOID, [StyledShape]);
protoOf(CompoundShape).l4i = getPath$default;
protoOf(CompoundShape).l4v = get_bounds;
initMetadataForClass(CompoundShape, 'CompoundShape', VOID, VOID, [Shape]);
protoOf(PolylineShape).n5i = getPath_0;
protoOf(PolylineShape).l4i = getPath$default;
protoOf(PolylineShape).s4h = draw;
protoOf(PolylineShape).l4v = get_bounds;
initMetadataForClass(PolylineShape, 'PolylineShape', VOID, VOID, [StyledShape]);
initMetadataForClass(TextShape, 'TextShape', VOID, VOID, [StyledShape]);
protoOf(EmptyShape).n5i = getPath;
protoOf(EmptyShape).l4i = getPath$default;
protoOf(EmptyShape).l4v = get_bounds;
initMetadataForObject(EmptyShape, 'EmptyShape', VOID, VOID, [Shape]);
initMetadataForClass(ShapeBuilder, 'ShapeBuilder');
initMetadataForObject(SvgPath, 'SvgPath');
initMetadataForClass(Rasterizer, 'Rasterizer', Rasterizer);
initMetadataForClass(DummyRenderer, 'DummyRenderer');
initMetadataForCompanion(Companion_38);
initMetadataForObject(HtmlCanvas, 'HtmlCanvas');
initMetadataForObject(HtmlImage, 'HtmlImage');
initMetadataForObject(NodeJsNativeImageFormatProvider, 'NodeJsNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForObject(HtmlNativeImageFormatProvider, 'HtmlNativeImageFormatProvider', VOID, VOID, VOID, [2, 3, 1]);
initMetadataForClass(HtmlNativeImage, 'HtmlNativeImage');
initMetadataForObject(BrowserImage, 'BrowserImage', VOID, VOID, VOID, [2, 1]);
initMetadataForClass(CanvasContext2dRenderer, 'CanvasContext2dRenderer');
//endregion
//region block: init
Companion_instance_6 = new Companion_0();
Bitmaps_instance = new Bitmaps();
Companion_instance_8 = new Companion_2();
Companion_instance_9 = new Companion_3();
NewSDF_instance = new NewSDF();
Companion_instance_11 = new Companion_5();
Companion_instance_13 = new Companion_7();
Companion_instance_14 = new Companion_8();
Companion_instance_15 = new Companion_9();
Companion_instance_16 = new Companion_10();
DefaultTtfFontOrNull = null;
SystemFontRegistryOrNull = null;
CFF_instance = new CFF();
CharStringType2_instance = new CharStringType2();
Companion_instance_21 = new Companion_15();
Companion_instance_23 = new Companion_17();
Companion_instance_24 = new Companion_18();
Companion_instance_25 = new Companion_19();
Companion_instance_26 = new Companion_20();
Companion_instance_28 = new Companion_22();
Companion_instance_30 = new Companion_24();
Companion_instance_33 = new Companion_27();
Companion_instance_34 = new Companion_28();
NonePaint_instance = new NonePaint();
Companion_instance_39 = new Companion_33();
Companion_instance_42 = new Companion_36();
EmptyShape_instance = new EmptyShape();
SvgPath_instance = new SvgPath();
HtmlCanvas_instance = new HtmlCanvas();
HtmlImage_instance = new HtmlImage();
BrowserImage_instance = new BrowserImage();
//endregion
//region block: exports
export {
  TileMapRepeat_NONE_getInstance as TileMapRepeat_NONE_getInstance1rwcpdxdrcp50,
  readFont as readFont45tmpsdawgck,
  readBitmapSlice as readBitmapSlice1mxfjm5uys58e,
  readBitmap_0 as readBitmap1xlsnvr8f9icc,
  readBitmap as readBitmap1dn2o52mvbpv4,
  _RGBA___get_af__impl__vu36qv as _RGBA___get_af__impl__vu36qv3iv1uv3wd82oh,
  _RGBA___get_bf__impl__1xz5yg as _RGBA___get_bf__impl__1xz5yg3ni93gubw9yz3,
  _RGBA___get_gf__impl__5gcu1f as _RGBA___get_gf__impl__5gcu1f1u2gy3h5k9nkx,
  RGBA__hashCode_impl_h59qf6 as RGBA__hashCode_impl_h59qf63jsbsnnrny7w3,
  _RGBA___get_hexString__impl__kocngm as _RGBA___get_hexString__impl__kocngmzp2nzhttcejz,
  _RGBA___get_premultiplied__impl__3bulqc as _RGBA___get_premultiplied__impl__3bulqcbb8bnh8j0y24,
  _RGBA___get_rf__impl__kvz75k as _RGBA___get_rf__impl__kvz75k3pk03bu2ddet,
  _RGBA___get_rgb__impl__tijaqt as _RGBA___get_rgb__impl__tijaqt1opkd4mw5vm2z,
  RGBA__toString_impl_4lw6dp as RGBA__toString_impl_4lw6dp2cnrrhh9rakoc,
  _RGBA___get_value__impl__hhco8v as _RGBA___get_value__impl__hhco8v1fb2bqjo5n70o,
  _RGBAPremultiplied___get_af__impl__euwcjn as _RGBAPremultiplied___get_af__impl__euwcjn1b7069ioje2c2,
  _RGBAPremultiplied___get_bf__impl__qa3on2 as _RGBAPremultiplied___get_bf__impl__qa3on213rxeu9ptyi9h,
  _RGBAPremultiplied___get_gf__impl__ivron7 as _RGBAPremultiplied___get_gf__impl__ivron74okc5xdveso1,
  _RGBAPremultiplied___get_rf__impl__pt0c4y as _RGBAPremultiplied___get_rf__impl__pt0c4y18zok6tr9apch,
  _RgbaPremultipliedArray___init__impl__lx83hy as _RgbaPremultipliedArray___init__impl__lx83hyhrkrjwkiqj0l,
  HorizontalAlign__getOffsetX_impl_urzzxf as HorizontalAlign__getOffsetX_impl_urzzxfwwtut2j2hfgv,
  VerticalAlign__getOffsetY_impl_iso0y6 as VerticalAlign__getOffsetY_impl_iso0y61hxbkot1sg4z0,
  _VerticalAlign___get_ratioFake__impl__1h2fwv as _VerticalAlign___get_ratioFake__impl__1h2fwv3b9t7y5yljykc,
  _Tile___get_flipX__impl__jobqpf as _Tile___get_flipX__impl__jobqpfe9cgmzzfemed,
  _Tile___get_flipY__impl__95aqcs as _Tile___get_flipY__impl__95aqcseyyd2ly5g92f,
  Tile__hashCode_impl_ubobok as Tile__hashCode_impl_ubobok3tqsleujf9ax8,
  _Tile___get_isInvalid__impl__yfg9ed as _Tile___get_isInvalid__impl__yfg9ed173l8j2a3h38e,
  _Tile___get_isValid__impl__nlo03e as _Tile___get_isValid__impl__nlo03e2mhmmy4urkdxd,
  _Tile___get_offsetX__impl__qwhdsd as _Tile___get_offsetX__impl__qwhdsd2u0qshojurkrv,
  _Tile___get_offsetY__impl__1x539u as _Tile___get_offsetY__impl__1x539um3hkx58tbqvt,
  _Tile___get_rotate__impl__5kjdv9 as _Tile___get_rotate__impl__5kjdv91g1hqxlteoxnf,
  _Tile___get_tile__impl__nfq1aw as _Tile___get_tile__impl__nfq1aw343zt1qckjepn,
  Tile__toString_impl_iy9thp as Tile__toString_impl_iy9thpd5dj258mzgi6,
  Bitmaps_instance as Bitmaps_instancebct336c8d0m7,
  Colors_getInstance as Colors_getInstance1qvds1isfbag2,
  Companion_instance_16 as Companion_instancevwyx2uq9kvqe,
  Companion_instance_15 as Companion_instance307r99gfwddav,
  ASE_getInstance as ASE_getInstance1eqtiryc16lrg,
  Companion_getInstance_48 as Companion_getInstance2fl1toxz5lf8a,
  Companion_getInstance_46 as Companion_getInstance1rfeljt05xntw,
  Companion_getInstance_49 as Companion_getInstance1y19lmoptxnwi,
  Companion_getInstance_51 as Companion_getInstancenwobv30yoie,
  EmptyShape_instance as EmptyShape_instance7pcf1jiur1zr,
  Bitmap32 as Bitmap321klycakvwgb5w,
  Bitmap8 as Bitmap82ekc5d8xpcfp2,
  get_Bitmaps_transparent as get_Bitmaps_transparent3nm2857y3u3hn,
  get_Bitmaps_white as get_Bitmaps_white37u58wbn8ngk2,
  FloatBitmap32 as FloatBitmap321fufbxi3ys0iu,
  ForcedTexId as ForcedTexId3ivekmtdm8t3u,
  MultiBitmap as MultiBitmapk0zsv2zy1mpk,
  NativeImageOrBitmap32 as NativeImageOrBitmap3211fg7set8uiki,
  NativeImage as NativeImagebqxh3nwkmck,
  NullBitmap as NullBitmap15b22oyta4usb,
  get_baseMipmapLevel as get_baseMipmapLevel1ty2cgb5p9xw4,
  get_bmp as get_bmpevghw2zw2fa7,
  get_maxMipmapLevel as get_maxMipmapLevel13juf70j6ney9,
  slice_0 as slice2pfxfvku0ybgy,
  ColorTransformMul as ColorTransformMul2rawiv5hyxh9p,
  RGBA as RGBA34obx2i62wcl3,
  Glyph as Glyphdz1l7rusab9h,
  BitmapFontImpl as BitmapFontImpljoxrxbqjo5ee,
  BitmapFont as BitmapFont35unsvaxq1brd,
  get_DefaultTtfFontAsBitmap as get_DefaultTtfFontAsBitmap1hzwi8e4truhb,
  FontMetrics as FontMetrics1b1o1zbrk6cew,
  Font as Font2bg7nte760csr,
  TextMetricsResult as TextMetricsResult1qr6b0fc6i56z,
  TextMetrics as TextMetrics1vfyzci74zdhy,
  getTextBounds as getTextBoundsio1pfpt2q8ze,
  HtmlNativeImage as HtmlNativeImagenz79853f60h,
  ImageDecodingProps as ImageDecodingProps12g4gdsvb3zm5,
  get_RegisteredImageFormats as get_RegisteredImageFormats243xf60qkmjxj,
  toHtmlNative as toHtmlNative1zcg9na83p2te,
  BitmapPaint as BitmapPaintgyia0tdij0bl,
  GradientPaint as GradientPaint1uc4xuo0s2w8w,
  NonePaint as NonePaint2h93brzruznft,
  get_DefaultStringTextRenderer as get_DefaultStringTextRendererdyzggul2pyry,
  Entry_0 as Entry3jfmfe0iy8gwc,
  LineInfo as LineInfo27uw564y6w2d2,
  Text2TextRendererActions as Text2TextRendererActions1307nbc4pqqhs,
  invoke as invoke2ot88cm6qcfmr,
  TileMapData as TileMapData285v3okd3krdh,
  Tile as Tilejvhqhoacncec,
  flippedX as flippedX1d8oy0yl9d737,
  flippedY as flippedY21xqtg7yj14hj,
  rotatedRight as rotatedRight1d92miv84rwna,
  CompoundShape as CompoundShape2jsp34o6wp7wp,
  FillShape as FillShape13c5zk3dmjgcf,
  PolylineShape as PolylineShape2w5p5crr94b97,
  ShapeBuilder as ShapeBuilderk05da5wk16e9,
  TextShape as TextShape3u9vrw15swk1x,
  get_isLow as get_isLow1k7uocm2ojjr8,
};
//endregion
